var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a, prop, b2[prop]);
    }
  return a;
};
var __spreadProps = (a, b2) => __defProps(a, __getOwnPropDescs(b2));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import * as React from "react";
import React__default, { forwardRef, useContext, createContext, createElement, Fragment as Fragment$1, useState, useEffect, useRef, useCallback } from "react";
import { CircularProgress, styled as styled$5, Chip, Box, Link, Typography, List, ListItem, Button, Dialog, DialogTitle, DialogContent, DialogActions, FormLabel, Tooltip, FormControl, FormHelperText, InputLabel, Select, MenuItem, Grid, TextField, Alert, useMediaQuery, useTheme as useTheme$3, Container, Divider, Stack, Tab, Tabs, FormGroup, FormControlLabel, Checkbox, RadioGroup, Radio, Card, CardContent, CardMedia, Fade, Collapse } from "@mui/material";
import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
import PhoneInput from "react-phone-input-2";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var f2 = n2.default;
  if (typeof f2 == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        var args = [null];
        args.push.apply(args, arguments);
        var Ctor = Function.bind.apply(f2, args);
        return new Ctor();
      }
      return f2.apply(this, arguments);
    };
    a.prototype = f2.prototype;
  } else
    a = {};
  Object.defineProperty(a, "__esModule", {
    value: true
  });
  Object.keys(n2).forEach(function(k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a, k2, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a;
}
var jsxRuntime$1 = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$1 = React__default, k$1 = Symbol.for("react.element"), l$1 = Symbol.for("react.fragment"), m$1 = Object.prototype.hasOwnProperty, n$1 = f$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p$1 = { key: true, ref: true, __self: true, __source: true };
function q$1(c2, a, g2) {
  var b2, d2 = {}, e2 = null, h2 = null;
  void 0 !== g2 && (e2 = "" + g2);
  void 0 !== a.key && (e2 = "" + a.key);
  void 0 !== a.ref && (h2 = a.ref);
  for (b2 in a)
    m$1.call(a, b2) && !p$1.hasOwnProperty(b2) && (d2[b2] = a[b2]);
  if (c2 && c2.defaultProps)
    for (b2 in a = c2.defaultProps, a)
      void 0 === d2[b2] && (d2[b2] = a[b2]);
  return { $$typeof: k$1, type: c2, key: e2, ref: h2, props: d2, _owner: n$1.current };
}
reactJsxRuntime_production_min.Fragment = l$1;
reactJsxRuntime_production_min.jsx = q$1;
reactJsxRuntime_production_min.jsxs = q$1;
{
  jsxRuntime$1.exports = reactJsxRuntime_production_min;
}
var jsxRuntimeExports = jsxRuntime$1.exports;
const Fragment = jsxRuntimeExports.Fragment;
const jsx = jsxRuntimeExports.jsx;
const jsxs = jsxRuntimeExports.jsxs;
const jsxRuntime = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Fragment,
  jsx,
  jsxs
}, Symbol.toStringTag, { value: "Module" }));
const tagRe = /<([a-zA-Z0-9]+)>(.*?)<\/\1>|<([a-zA-Z0-9]+)\/>/;
const nlRe = /(?:\r\n|\r|\n)/g;
const voidElementTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
  menuitem: true
};
function formatElements(value, elements = {}) {
  const uniqueId = makeCounter(0, "$lingui$");
  const parts = value.replace(nlRe, "").split(tagRe);
  if (parts.length === 1)
    return value;
  const tree = [];
  const before = parts.shift();
  if (before)
    tree.push(before);
  for (const [index2, children, after] of getElements(parts)) {
    let element2 = typeof index2 !== "undefined" ? elements[index2] : void 0;
    if (!element2 || voidElementTags[element2.type] && children) {
      if (!element2) {
        console.error(
          `Can't use element at index '${index2}' as it is not declared in the original translation`
        );
      } else {
        console.error(
          `${element2.type} is a void element tag therefore it must have no children`
        );
      }
      element2 = React__default.createElement(React__default.Fragment);
    }
    if (Array.isArray(element2)) {
      element2 = React__default.createElement(React__default.Fragment, {}, element2);
    }
    tree.push(
      React__default.cloneElement(
        element2,
        { key: uniqueId() },
        // format children for pair tags
        // unpaired tags might have children if it's a component passed as a variable
        children ? formatElements(children, elements) : element2.props.children
      )
    );
    if (after)
      tree.push(after);
  }
  return tree;
}
function getElements(parts) {
  if (!parts.length)
    return [];
  const [paired, children, unpaired, after] = parts.slice(0, 4);
  const triple = [paired || unpaired, children || "", after];
  return [triple].concat(getElements(parts.slice(4, parts.length)));
}
const makeCounter = (count = 0, prefix2 = "") => () => `${prefix2}_${count++}`;
function TransNoContext(props) {
  const {
    render,
    component,
    id,
    message,
    formats,
    lingui: { i18n: i18n2, defaultComponent }
  } = props;
  const values2 = __spreadValues({}, props.values);
  const components2 = __spreadValues({}, props.components);
  if (values2) {
    Object.keys(values2).forEach((key) => {
      const value = values2[key];
      const valueIsReactEl = React__default.isValidElement(value) || Array.isArray(value) && value.every(React__default.isValidElement);
      if (!valueIsReactEl)
        return;
      const index2 = Object.keys(components2).length;
      components2[index2] = value;
      values2[key] = `<${index2}/>`;
    });
  }
  const _translation = i18n2 && typeof i18n2._ === "function" ? i18n2._(id, values2, { message, formats }) : id;
  const translation = _translation ? formatElements(_translation, components2) : null;
  if (render === null || component === null) {
    return translation;
  }
  const FallbackComponent = defaultComponent || RenderFragment;
  const i18nProps = {
    id,
    message,
    translation,
    // TODO vonovak - remove isTranslated prop in v5 release
    isTranslated: id !== translation && message !== translation,
    children: translation
    // for type-compatibility with `component` prop
  };
  if (render && component) {
    console.error(
      "You can't use both `component` and `render` prop at the same time. `component` is ignored."
    );
  } else if (render && typeof render !== "function") {
    console.error(
      `Invalid value supplied to prop \`render\`. It must be a function, provided ${render}`
    );
  } else if (component && typeof component !== "function") {
    console.error(
      `Invalid value supplied to prop \`component\`. It must be a React component, provided ${component}`
    );
    return React__default.createElement(FallbackComponent, i18nProps, translation);
  }
  if (typeof render === "function") {
    return render(i18nProps);
  }
  const Component = component || FallbackComponent;
  return React__default.createElement(Component, i18nProps, translation);
}
const RenderFragment = ({ children }) => {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children);
};
const LinguiContext = React__default.createContext(null);
const useLinguiInternal = (devErrorMessage) => {
  const context = React__default.useContext(LinguiContext);
  return context;
};
const I18nProvider = ({
  i18n: i18n2,
  defaultComponent,
  children
}) => {
  const latestKnownLocale = React__default.useRef(i18n2.locale);
  const makeContext = React__default.useCallback(
    () => ({
      i18n: i18n2,
      defaultComponent,
      _: i18n2.t.bind(i18n2)
    }),
    [i18n2, defaultComponent]
  );
  const [context, setContext] = React__default.useState(makeContext());
  React__default.useEffect(() => {
    const updateContext = () => {
      latestKnownLocale.current = i18n2.locale;
      setContext(makeContext());
    };
    const unsubscribe = i18n2.on("change", updateContext);
    if (latestKnownLocale.current !== i18n2.locale) {
      updateContext();
    }
    return unsubscribe;
  }, [i18n2, makeContext]);
  if (!latestKnownLocale.current) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(LinguiContext.Provider, { value: context }, children);
};
function Trans(props) {
  const lingui = useLinguiInternal();
  return React__default.createElement(TransNoContext, __spreadProps(__spreadValues({}, props), { lingui }));
}
var dist$1 = {};
var errors = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.errorMessages = exports.ErrorType = void 0;
  var ErrorType;
  (function(ErrorType2) {
    ErrorType2["MalformedUnicode"] = "MALFORMED_UNICODE";
    ErrorType2["MalformedHexadecimal"] = "MALFORMED_HEXADECIMAL";
    ErrorType2["CodePointLimit"] = "CODE_POINT_LIMIT";
    ErrorType2["OctalDeprecation"] = "OCTAL_DEPRECATION";
    ErrorType2["EndOfString"] = "END_OF_STRING";
  })(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
  exports.errorMessages = /* @__PURE__ */ new Map([
    [ErrorType.MalformedUnicode, "malformed Unicode character escape sequence"],
    [
      ErrorType.MalformedHexadecimal,
      "malformed hexadecimal character escape sequence"
    ],
    [
      ErrorType.CodePointLimit,
      "Unicode codepoint must not be greater than 0x10FFFF in escape sequence"
    ],
    [
      ErrorType.OctalDeprecation,
      '"0"-prefixed octal literals and octal escape sequences are deprecated; for octal literals use the "0o" prefix instead'
    ],
    [ErrorType.EndOfString, "malformed escape sequence at end of string"]
  ]);
})(errors);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.unraw = exports.errorMessages = exports.ErrorType = void 0;
  const errors_1 = errors;
  Object.defineProperty(exports, "ErrorType", { enumerable: true, get: function() {
    return errors_1.ErrorType;
  } });
  Object.defineProperty(exports, "errorMessages", { enumerable: true, get: function() {
    return errors_1.errorMessages;
  } });
  function parseHexToInt(hex) {
    const isOnlyHexChars = !hex.match(/[^a-f0-9]/i);
    return isOnlyHexChars ? parseInt(hex, 16) : NaN;
  }
  function validateAndParseHex(hex, errorName, enforcedLength) {
    const parsedHex = parseHexToInt(hex);
    if (Number.isNaN(parsedHex) || enforcedLength !== void 0 && enforcedLength !== hex.length) {
      throw new SyntaxError(errors_1.errorMessages.get(errorName));
    }
    return parsedHex;
  }
  function parseHexadecimalCode(code2) {
    const parsedCode = validateAndParseHex(code2, errors_1.ErrorType.MalformedHexadecimal, 2);
    return String.fromCharCode(parsedCode);
  }
  function parseUnicodeCode(code2, surrogateCode) {
    const parsedCode = validateAndParseHex(code2, errors_1.ErrorType.MalformedUnicode, 4);
    if (surrogateCode !== void 0) {
      const parsedSurrogateCode = validateAndParseHex(surrogateCode, errors_1.ErrorType.MalformedUnicode, 4);
      return String.fromCharCode(parsedCode, parsedSurrogateCode);
    }
    return String.fromCharCode(parsedCode);
  }
  function isCurlyBraced(text2) {
    return text2.charAt(0) === "{" && text2.charAt(text2.length - 1) === "}";
  }
  function parseUnicodeCodePointCode(codePoint) {
    if (!isCurlyBraced(codePoint)) {
      throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.MalformedUnicode));
    }
    const withoutBraces = codePoint.slice(1, -1);
    const parsedCode = validateAndParseHex(withoutBraces, errors_1.ErrorType.MalformedUnicode);
    try {
      return String.fromCodePoint(parsedCode);
    } catch (err) {
      throw err instanceof RangeError ? new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.CodePointLimit)) : err;
    }
  }
  function parseOctalCode(code2, error = false) {
    if (error) {
      throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.OctalDeprecation));
    }
    const parsedCode = parseInt(code2, 8);
    return String.fromCharCode(parsedCode);
  }
  const singleCharacterEscapes = /* @__PURE__ */ new Map([
    ["b", "\b"],
    ["f", "\f"],
    ["n", "\n"],
    ["r", "\r"],
    ["t", "	"],
    ["v", "\v"],
    ["0", "\0"]
  ]);
  function parseSingleCharacterCode(code2) {
    return singleCharacterEscapes.get(code2) || code2;
  }
  const escapeMatch = /\\(?:(\\)|x([\s\S]{0,2})|u(\{[^}]*\}?)|u([\s\S]{4})\\u([^{][\s\S]{0,3})|u([\s\S]{0,4})|([0-3]?[0-7]{1,2})|([\s\S])|$)/g;
  function unraw(raw, allowOctals = false) {
    return raw.replace(escapeMatch, function(_, backslash, hex, codePoint, unicodeWithSurrogate, surrogate, unicode, octal, singleCharacter) {
      if (backslash !== void 0) {
        return "\\";
      }
      if (hex !== void 0) {
        return parseHexadecimalCode(hex);
      }
      if (codePoint !== void 0) {
        return parseUnicodeCodePointCode(codePoint);
      }
      if (unicodeWithSurrogate !== void 0) {
        return parseUnicodeCode(unicodeWithSurrogate, surrogate);
      }
      if (unicode !== void 0) {
        return parseUnicodeCode(unicode);
      }
      if (octal === "0") {
        return "\0";
      }
      if (octal !== void 0) {
        return parseOctalCode(octal, !allowOctals);
      }
      if (singleCharacter !== void 0) {
        return parseSingleCharacterCode(singleCharacter);
      }
      throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.EndOfString));
    });
  }
  exports.unraw = unraw;
  exports.default = unraw;
})(dist$1);
const isString$2 = (s) => typeof s === "string";
const isFunction$2 = (f2) => typeof f2 === "function";
const cache = /* @__PURE__ */ new Map();
const defaultLocale = "en";
function normalizeLocales(locales2) {
  const out = Array.isArray(locales2) ? locales2 : [locales2];
  return [...out, defaultLocale];
}
function date(locales2, value, format2) {
  const _locales = normalizeLocales(locales2);
  const formatter = getMemoized(
    () => cacheKey("date", _locales, format2),
    () => new Intl.DateTimeFormat(_locales, format2)
  );
  return formatter.format(isString$2(value) ? new Date(value) : value);
}
function number$1(locales2, value, format2) {
  const _locales = normalizeLocales(locales2);
  const formatter = getMemoized(
    () => cacheKey("number", _locales, format2),
    () => new Intl.NumberFormat(_locales, format2)
  );
  return formatter.format(value);
}
function plural(locales2, ordinal2, value, _a) {
  var _b = _a, { offset: offset2 = 0 } = _b, rules = __objRest(_b, ["offset"]);
  var _a2, _b2;
  const _locales = normalizeLocales(locales2);
  const plurals = ordinal2 ? getMemoized(
    () => cacheKey("plural-ordinal", _locales),
    () => new Intl.PluralRules(_locales, { type: "ordinal" })
  ) : getMemoized(
    () => cacheKey("plural-cardinal", _locales),
    () => new Intl.PluralRules(_locales, { type: "cardinal" })
  );
  return (_b2 = (_a2 = rules[value]) != null ? _a2 : rules[plurals.select(value - offset2)]) != null ? _b2 : rules.other;
}
function getMemoized(getKey, construct) {
  const key = getKey();
  let formatter = cache.get(key);
  if (!formatter) {
    formatter = construct();
    cache.set(key, formatter);
  }
  return formatter;
}
function cacheKey(type, locales2, options) {
  const localeKey = locales2.join("-");
  return `${type}-${localeKey}-${JSON.stringify(options)}`;
}
const UNICODE_REGEX = /\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/g;
const OCTOTHORPE_PH = "%__lingui_octothorpe__%";
const getDefaultFormats = (locale2, passedLocales, formats = {}) => {
  const locales2 = passedLocales || locale2;
  const style2 = (format2) => {
    return typeof format2 === "object" ? format2 : formats[format2] || { style: format2 };
  };
  const replaceOctothorpe = (value, message) => {
    const numberFormat = Object.keys(formats).length ? style2("number") : void 0;
    const valueStr = number$1(locales2, value, numberFormat);
    return message.replace(new RegExp(OCTOTHORPE_PH, "g"), valueStr);
  };
  return {
    plural: (value, cases) => {
      const { offset: offset2 = 0 } = cases;
      const message = plural(locales2, false, value, cases);
      return replaceOctothorpe(value - offset2, message);
    },
    selectordinal: (value, cases) => {
      const { offset: offset2 = 0 } = cases;
      const message = plural(locales2, true, value, cases);
      return replaceOctothorpe(value - offset2, message);
    },
    select: selectFormatter,
    number: (value, format2) => number$1(locales2, value, style2(format2)),
    date: (value, format2) => date(locales2, value, style2(format2))
  };
};
const selectFormatter = (value, rules) => {
  var _a;
  return (_a = rules[value]) != null ? _a : rules.other;
};
function interpolate(translation, locale2, locales2) {
  return (values2 = {}, formats) => {
    const formatters = getDefaultFormats(locale2, locales2, formats);
    const formatMessage = (tokens2, replaceOctothorpe = false) => {
      if (!Array.isArray(tokens2))
        return tokens2;
      return tokens2.reduce((message, token2) => {
        if (token2 === "#" && replaceOctothorpe) {
          return message + OCTOTHORPE_PH;
        }
        if (isString$2(token2)) {
          return message + token2;
        }
        const [name, type, format2] = token2;
        let interpolatedFormat = {};
        if (type === "plural" || type === "selectordinal" || type === "select") {
          Object.entries(format2).forEach(
            ([key, value2]) => {
              interpolatedFormat[key] = formatMessage(
                value2,
                type === "plural" || type === "selectordinal"
              );
            }
          );
        } else {
          interpolatedFormat = format2;
        }
        let value;
        if (type) {
          const formatter = formatters[type];
          value = formatter(values2[name], interpolatedFormat);
        } else {
          value = values2[name];
        }
        if (value == null) {
          return message;
        }
        return message + value;
      }, "");
    };
    const result = formatMessage(translation);
    if (isString$2(result) && UNICODE_REGEX.test(result)) {
      return dist$1.unraw(result.trim());
    }
    if (isString$2(result))
      return result.trim();
    return result ? String(result) : "";
  };
}
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class EventEmitter {
  constructor() {
    __publicField$1(this, "_events", {});
  }
  on(event, listener) {
    var _a2;
    var _a;
    (_a2 = (_a = this._events)[event]) != null ? _a2 : _a[event] = [];
    this._events[event].push(listener);
    return () => this.removeListener(event, listener);
  }
  removeListener(event, listener) {
    const maybeListeners = this._getListeners(event);
    if (!maybeListeners)
      return;
    const index2 = maybeListeners.indexOf(listener);
    if (~index2)
      maybeListeners.splice(index2, 1);
  }
  emit(event, ...args) {
    const maybeListeners = this._getListeners(event);
    if (!maybeListeners)
      return;
    maybeListeners.map((listener) => listener.apply(this, args));
  }
  _getListeners(event) {
    const maybeListeners = this._events[event];
    return Array.isArray(maybeListeners) ? maybeListeners : false;
  }
}
var __defProp2 = Object.defineProperty;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class I18n extends EventEmitter {
  constructor(params) {
    var _a;
    super();
    __publicField(this, "_locale", "");
    __publicField(this, "_locales");
    __publicField(this, "_localeData", {});
    __publicField(this, "_messages", {});
    __publicField(this, "_missing");
    __publicField(this, "t", this._.bind(this));
    if (params.missing != null)
      this._missing = params.missing;
    if (params.messages != null)
      this.load(params.messages);
    if (params.localeData != null)
      this.loadLocaleData(params.localeData);
    if (typeof params.locale === "string" || params.locales) {
      this.activate((_a = params.locale) != null ? _a : defaultLocale, params.locales);
    }
  }
  get locale() {
    return this._locale;
  }
  get locales() {
    return this._locales;
  }
  get messages() {
    var _a;
    return (_a = this._messages[this._locale]) != null ? _a : {};
  }
  /**
   * @deprecated this has no effect. Please remove this from the code. Deprecated in v4
   */
  get localeData() {
    var _a;
    return (_a = this._localeData[this._locale]) != null ? _a : {};
  }
  _loadLocaleData(locale2, localeData2) {
    const maybeLocaleData = this._localeData[locale2];
    if (!maybeLocaleData) {
      this._localeData[locale2] = localeData2;
    } else {
      Object.assign(maybeLocaleData, localeData2);
    }
  }
  /**
   * @deprecated Plurals automatically used from Intl.PluralRules you can safely remove this call. Deprecated in v4
   */
  // @ts-ignore deprecated, so ignore the reported error
  loadLocaleData(localeOrAllData, localeData2) {
    if (localeData2 != null) {
      this._loadLocaleData(localeOrAllData, localeData2);
    } else {
      Object.keys(localeOrAllData).forEach(
        (locale2) => this._loadLocaleData(locale2, localeOrAllData[locale2])
      );
    }
    this.emit("change");
  }
  _load(locale2, messages2) {
    const maybeMessages = this._messages[locale2];
    if (!maybeMessages) {
      this._messages[locale2] = messages2;
    } else {
      Object.assign(maybeMessages, messages2);
    }
  }
  load(localeOrMessages, messages2) {
    if (typeof localeOrMessages == "string" && typeof messages2 === "object") {
      this._load(localeOrMessages, messages2);
    } else {
      Object.entries(localeOrMessages).forEach(
        ([locale2, messages22]) => this._load(locale2, messages22)
      );
    }
    this.emit("change");
  }
  /**
   * @param options {@link LoadAndActivateOptions}
   */
  loadAndActivate({ locale: locale2, locales: locales2, messages: messages2 }) {
    this._locale = locale2;
    this._locales = locales2 || void 0;
    this._messages[this._locale] = messages2;
    this.emit("change");
  }
  activate(locale2, locales2) {
    this._locale = locale2;
    this._locales = locales2;
    this.emit("change");
  }
  _(id, values2, options) {
    let message = options == null ? void 0 : options.message;
    if (!id) {
      id = "";
    }
    if (!isString$2(id)) {
      values2 = id.values || values2;
      message = id.message;
      id = id.id;
    }
    const messageForId = this.messages[id];
    const messageMissing = messageForId === void 0;
    const missing = this._missing;
    if (missing && messageMissing) {
      return isFunction$2(missing) ? missing(this._locale, id) : missing;
    }
    if (messageMissing) {
      this.emit("missing", { id, locale: this._locale });
    }
    let translation = messageForId || message || id;
    if (isString$2(translation) && UNICODE_REGEX.test(translation))
      return JSON.parse(`"${translation}"`);
    if (isString$2(translation))
      return translation;
    return interpolate(
      translation,
      this._locale,
      this._locales
    )(values2, options == null ? void 0 : options.formats);
  }
  date(value, format2) {
    return date(this._locales || this._locale, value, format2);
  }
  number(value, format2) {
    return number$1(this._locales || this._locale, value, format2);
  }
}
function setupI18n(params = {}) {
  return new I18n(params);
}
const i18n = setupI18n();
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var hookCallback;
function hooks() {
  return hookCallback.apply(null, arguments);
}
function setHookCallback(callback) {
  hookCallback = callback;
}
function isArray$1(input) {
  return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
}
function isObject$2(input) {
  return input != null && Object.prototype.toString.call(input) === "[object Object]";
}
function hasOwnProp(a, b2) {
  return Object.prototype.hasOwnProperty.call(a, b2);
}
function isObjectEmpty$1(obj) {
  if (Object.getOwnPropertyNames) {
    return Object.getOwnPropertyNames(obj).length === 0;
  } else {
    var k2;
    for (k2 in obj) {
      if (hasOwnProp(obj, k2)) {
        return false;
      }
    }
    return true;
  }
}
function isUndefined$1(input) {
  return input === void 0;
}
function isNumber(input) {
  return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
}
function isDate(input) {
  return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
}
function map(arr, fn) {
  var res = [], i, arrLen = arr.length;
  for (i = 0; i < arrLen; ++i) {
    res.push(fn(arr[i], i));
  }
  return res;
}
function extend$2(a, b2) {
  for (var i in b2) {
    if (hasOwnProp(b2, i)) {
      a[i] = b2[i];
    }
  }
  if (hasOwnProp(b2, "toString")) {
    a.toString = b2.toString;
  }
  if (hasOwnProp(b2, "valueOf")) {
    a.valueOf = b2.valueOf;
  }
  return a;
}
function createUTC(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, true).utc();
}
function defaultParsingFlags() {
  return {
    empty: false,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: false,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: false,
    userInvalidated: false,
    iso: false,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: false,
    weekdayMismatch: false
  };
}
function getParsingFlags(m2) {
  if (m2._pf == null) {
    m2._pf = defaultParsingFlags();
  }
  return m2._pf;
}
var some;
if (Array.prototype.some) {
  some = Array.prototype.some;
} else {
  some = function(fun) {
    var t2 = Object(this), len = t2.length >>> 0, i;
    for (i = 0; i < len; i++) {
      if (i in t2 && fun.call(this, t2[i], i, t2)) {
        return true;
      }
    }
    return false;
  };
}
function isValid(m2) {
  if (m2._isValid == null) {
    var flags = getParsingFlags(m2), parsedParts = some.call(flags.parsedDateParts, function(i) {
      return i != null;
    }), isNowValid = !isNaN(m2._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
    if (m2._strict) {
      isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === void 0;
    }
    if (Object.isFrozen == null || !Object.isFrozen(m2)) {
      m2._isValid = isNowValid;
    } else {
      return isNowValid;
    }
  }
  return m2._isValid;
}
function createInvalid(flags) {
  var m2 = createUTC(NaN);
  if (flags != null) {
    extend$2(getParsingFlags(m2), flags);
  } else {
    getParsingFlags(m2).userInvalidated = true;
  }
  return m2;
}
var momentProperties = hooks.momentProperties = [], updateInProgress = false;
function copyConfig(to2, from2) {
  var i, prop, val, momentPropertiesLen = momentProperties.length;
  if (!isUndefined$1(from2._isAMomentObject)) {
    to2._isAMomentObject = from2._isAMomentObject;
  }
  if (!isUndefined$1(from2._i)) {
    to2._i = from2._i;
  }
  if (!isUndefined$1(from2._f)) {
    to2._f = from2._f;
  }
  if (!isUndefined$1(from2._l)) {
    to2._l = from2._l;
  }
  if (!isUndefined$1(from2._strict)) {
    to2._strict = from2._strict;
  }
  if (!isUndefined$1(from2._tzm)) {
    to2._tzm = from2._tzm;
  }
  if (!isUndefined$1(from2._isUTC)) {
    to2._isUTC = from2._isUTC;
  }
  if (!isUndefined$1(from2._offset)) {
    to2._offset = from2._offset;
  }
  if (!isUndefined$1(from2._pf)) {
    to2._pf = getParsingFlags(from2);
  }
  if (!isUndefined$1(from2._locale)) {
    to2._locale = from2._locale;
  }
  if (momentPropertiesLen > 0) {
    for (i = 0; i < momentPropertiesLen; i++) {
      prop = momentProperties[i];
      val = from2[prop];
      if (!isUndefined$1(val)) {
        to2[prop] = val;
      }
    }
  }
  return to2;
}
function Moment(config) {
  copyConfig(this, config);
  this._d = new Date(config._d != null ? config._d.getTime() : NaN);
  if (!this.isValid()) {
    this._d = /* @__PURE__ */ new Date(NaN);
  }
  if (updateInProgress === false) {
    updateInProgress = true;
    hooks.updateOffset(this);
    updateInProgress = false;
  }
}
function isMoment(obj) {
  return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
}
function warn(msg) {
  if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
    console.warn("Deprecation warning: " + msg);
  }
}
function deprecate(msg, fn) {
  var firstTime = true;
  return extend$2(function() {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(null, msg);
    }
    if (firstTime) {
      var args = [], arg, i, key, argLen = arguments.length;
      for (i = 0; i < argLen; i++) {
        arg = "";
        if (typeof arguments[i] === "object") {
          arg += "\n[" + i + "] ";
          for (key in arguments[0]) {
            if (hasOwnProp(arguments[0], key)) {
              arg += key + ": " + arguments[0][key] + ", ";
            }
          }
          arg = arg.slice(0, -2);
        } else {
          arg = arguments[i];
        }
        args.push(arg);
      }
      warn(
        msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack
      );
      firstTime = false;
    }
    return fn.apply(this, arguments);
  }, fn);
}
var deprecations = {};
function deprecateSimple(name, msg) {
  if (hooks.deprecationHandler != null) {
    hooks.deprecationHandler(name, msg);
  }
  if (!deprecations[name]) {
    warn(msg);
    deprecations[name] = true;
  }
}
hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;
function isFunction$1(input) {
  return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
}
function set$1(config) {
  var prop, i;
  for (i in config) {
    if (hasOwnProp(config, i)) {
      prop = config[i];
      if (isFunction$1(prop)) {
        this[i] = prop;
      } else {
        this["_" + i] = prop;
      }
    }
  }
  this._config = config;
  this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function mergeConfigs(parentConfig, childConfig) {
  var res = extend$2({}, parentConfig), prop;
  for (prop in childConfig) {
    if (hasOwnProp(childConfig, prop)) {
      if (isObject$2(parentConfig[prop]) && isObject$2(childConfig[prop])) {
        res[prop] = {};
        extend$2(res[prop], parentConfig[prop]);
        extend$2(res[prop], childConfig[prop]);
      } else if (childConfig[prop] != null) {
        res[prop] = childConfig[prop];
      } else {
        delete res[prop];
      }
    }
  }
  for (prop in parentConfig) {
    if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject$2(parentConfig[prop])) {
      res[prop] = extend$2({}, res[prop]);
    }
  }
  return res;
}
function Locale(config) {
  if (config != null) {
    this.set(config);
  }
}
var keys$1;
if (Object.keys) {
  keys$1 = Object.keys;
} else {
  keys$1 = function(obj) {
    var i, res = [];
    for (i in obj) {
      if (hasOwnProp(obj, i)) {
        res.push(i);
      }
    }
    return res;
  };
}
var defaultCalendar = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function calendar(key, mom, now2) {
  var output = this._calendar[key] || this._calendar["sameElse"];
  return isFunction$1(output) ? output.call(mom, now2) : output;
}
function zeroFill(number2, targetLength, forceSign) {
  var absNumber = "" + Math.abs(number2), zerosToFill = targetLength - absNumber.length, sign2 = number2 >= 0;
  return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
function addFormatToken(token2, padded, ordinal2, callback) {
  var func = callback;
  if (typeof callback === "string") {
    func = function() {
      return this[callback]();
    };
  }
  if (token2) {
    formatTokenFunctions[token2] = func;
  }
  if (padded) {
    formatTokenFunctions[padded[0]] = function() {
      return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
    };
  }
  if (ordinal2) {
    formatTokenFunctions[ordinal2] = function() {
      return this.localeData().ordinal(
        func.apply(this, arguments),
        token2
      );
    };
  }
}
function removeFormattingTokens(input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|\]$/g, "");
  }
  return input.replace(/\\/g, "");
}
function makeFormatFunction(format2) {
  var array = format2.match(formattingTokens), i, length2;
  for (i = 0, length2 = array.length; i < length2; i++) {
    if (formatTokenFunctions[array[i]]) {
      array[i] = formatTokenFunctions[array[i]];
    } else {
      array[i] = removeFormattingTokens(array[i]);
    }
  }
  return function(mom) {
    var output = "", i2;
    for (i2 = 0; i2 < length2; i2++) {
      output += isFunction$1(array[i2]) ? array[i2].call(mom, format2) : array[i2];
    }
    return output;
  };
}
function formatMoment(m2, format2) {
  if (!m2.isValid()) {
    return m2.localeData().invalidDate();
  }
  format2 = expandFormat(format2, m2.localeData());
  formatFunctions[format2] = formatFunctions[format2] || makeFormatFunction(format2);
  return formatFunctions[format2](m2);
}
function expandFormat(format2, locale2) {
  var i = 5;
  function replaceLongDateFormatTokens(input) {
    return locale2.longDateFormat(input) || input;
  }
  localFormattingTokens.lastIndex = 0;
  while (i >= 0 && localFormattingTokens.test(format2)) {
    format2 = format2.replace(
      localFormattingTokens,
      replaceLongDateFormatTokens
    );
    localFormattingTokens.lastIndex = 0;
    i -= 1;
  }
  return format2;
}
var defaultLongDateFormat = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function longDateFormat(key) {
  var format2 = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
  if (format2 || !formatUpper) {
    return format2;
  }
  this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
    if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
      return tok.slice(1);
    }
    return tok;
  }).join("");
  return this._longDateFormat[key];
}
var defaultInvalidDate = "Invalid date";
function invalidDate() {
  return this._invalidDate;
}
var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal(number2) {
  return this._ordinal.replace("%d", number2);
}
var defaultRelativeTime = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function relativeTime(number2, withoutSuffix, string2, isFuture) {
  var output = this._relativeTime[string2];
  return isFunction$1(output) ? output(number2, withoutSuffix, string2, isFuture) : output.replace(/%d/i, number2);
}
function pastFuture(diff2, output) {
  var format2 = this._relativeTime[diff2 > 0 ? "future" : "past"];
  return isFunction$1(format2) ? format2(output) : format2.replace(/%s/i, output);
}
var aliases$1 = {};
function addUnitAlias(unit, shorthand) {
  var lowerCase = unit.toLowerCase();
  aliases$1[lowerCase] = aliases$1[lowerCase + "s"] = aliases$1[shorthand] = unit;
}
function normalizeUnits(units) {
  return typeof units === "string" ? aliases$1[units] || aliases$1[units.toLowerCase()] : void 0;
}
function normalizeObjectUnits(inputObject) {
  var normalizedInput = {}, normalizedProp, prop;
  for (prop in inputObject) {
    if (hasOwnProp(inputObject, prop)) {
      normalizedProp = normalizeUnits(prop);
      if (normalizedProp) {
        normalizedInput[normalizedProp] = inputObject[prop];
      }
    }
  }
  return normalizedInput;
}
var priorities = {};
function addUnitPriority(unit, priority) {
  priorities[unit] = priority;
}
function getPrioritizedUnits(unitsObj) {
  var units = [], u2;
  for (u2 in unitsObj) {
    if (hasOwnProp(unitsObj, u2)) {
      units.push({ unit: u2, priority: priorities[u2] });
    }
  }
  units.sort(function(a, b2) {
    return a.priority - b2.priority;
  });
  return units;
}
function isLeapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function absFloor(number2) {
  if (number2 < 0) {
    return Math.ceil(number2) || 0;
  } else {
    return Math.floor(number2);
  }
}
function toInt(argumentForCoercion) {
  var coercedNumber = +argumentForCoercion, value = 0;
  if (coercedNumber !== 0 && isFinite(coercedNumber)) {
    value = absFloor(coercedNumber);
  }
  return value;
}
function makeGetSet(unit, keepTime) {
  return function(value) {
    if (value != null) {
      set$1$1(this, unit, value);
      hooks.updateOffset(this, keepTime);
      return this;
    } else {
      return get$1(this, unit);
    }
  };
}
function get$1(mom, unit) {
  return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
}
function set$1$1(mom, unit, value) {
  if (mom.isValid() && !isNaN(value)) {
    if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
      value = toInt(value);
      mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](
        value,
        mom.month(),
        daysInMonth(value, mom.month())
      );
    } else {
      mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
    }
  }
}
function stringGet(units) {
  units = normalizeUnits(units);
  if (isFunction$1(this[units])) {
    return this[units]();
  }
  return this;
}
function stringSet(units, value) {
  if (typeof units === "object") {
    units = normalizeObjectUnits(units);
    var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
    for (i = 0; i < prioritizedLen; i++) {
      this[prioritized[i].unit](units[prioritized[i].unit]);
    }
  } else {
    units = normalizeUnits(units);
    if (isFunction$1(this[units])) {
      return this[units](value);
    }
  }
  return this;
}
var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
regexes = {};
function addRegexToken(token2, regex, strictRegex) {
  regexes[token2] = isFunction$1(regex) ? regex : function(isStrict, localeData2) {
    return isStrict && strictRegex ? strictRegex : regex;
  };
}
function getParseRegexForToken(token2, config) {
  if (!hasOwnProp(regexes, token2)) {
    return new RegExp(unescapeFormat(token2));
  }
  return regexes[token2](config._strict, config._locale);
}
function unescapeFormat(s) {
  return regexEscape(
    s.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }
    )
  );
}
function regexEscape(s) {
  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var tokens = {};
function addParseToken(token2, callback) {
  var i, func = callback, tokenLen;
  if (typeof token2 === "string") {
    token2 = [token2];
  }
  if (isNumber(callback)) {
    func = function(input, array) {
      array[callback] = toInt(input);
    };
  }
  tokenLen = token2.length;
  for (i = 0; i < tokenLen; i++) {
    tokens[token2[i]] = func;
  }
}
function addWeekParseToken(token2, callback) {
  addParseToken(token2, function(input, array, config, token3) {
    config._w = config._w || {};
    callback(input, config._w, config, token3);
  });
}
function addTimeToArrayFromToken(token2, input, config) {
  if (input != null && hasOwnProp(tokens, token2)) {
    tokens[token2](input, config._a, config, token2);
  }
}
var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
function mod(n2, x) {
  return (n2 % x + x) % x;
}
var indexOf;
if (Array.prototype.indexOf) {
  indexOf = Array.prototype.indexOf;
} else {
  indexOf = function(o) {
    var i;
    for (i = 0; i < this.length; ++i) {
      if (this[i] === o) {
        return i;
      }
    }
    return -1;
  };
}
function daysInMonth(year, month) {
  if (isNaN(year) || isNaN(month)) {
    return NaN;
  }
  var modMonth = mod(month, 12);
  year += (month - modMonth) / 12;
  return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
}
addFormatToken("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
addFormatToken("MMM", 0, 0, function(format2) {
  return this.localeData().monthsShort(this, format2);
});
addFormatToken("MMMM", 0, 0, function(format2) {
  return this.localeData().months(this, format2);
});
addUnitAlias("month", "M");
addUnitPriority("month", 8);
addRegexToken("M", match1to2);
addRegexToken("MM", match1to2, match2);
addRegexToken("MMM", function(isStrict, locale2) {
  return locale2.monthsShortRegex(isStrict);
});
addRegexToken("MMMM", function(isStrict, locale2) {
  return locale2.monthsRegex(isStrict);
});
addParseToken(["M", "MM"], function(input, array) {
  array[MONTH] = toInt(input) - 1;
});
addParseToken(["MMM", "MMMM"], function(input, array, config, token2) {
  var month = config._locale.monthsParse(input, token2, config._strict);
  if (month != null) {
    array[MONTH] = month;
  } else {
    getParsingFlags(config).invalidMonth = input;
  }
});
var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
function localeMonths(m2, format2) {
  if (!m2) {
    return isArray$1(this._months) ? this._months : this._months["standalone"];
  }
  return isArray$1(this._months) ? this._months[m2.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format2) ? "format" : "standalone"][m2.month()];
}
function localeMonthsShort(m2, format2) {
  if (!m2) {
    return isArray$1(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
  }
  return isArray$1(this._monthsShort) ? this._monthsShort[m2.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format2) ? "format" : "standalone"][m2.month()];
}
function handleStrictParse(monthName, format2, strict) {
  var i, ii, mom, llc = monthName.toLocaleLowerCase();
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
    for (i = 0; i < 12; ++i) {
      mom = createUTC([2e3, i]);
      this._shortMonthsParse[i] = this.monthsShort(
        mom,
        ""
      ).toLocaleLowerCase();
      this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format2 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeMonthsParse(monthName, format2, strict) {
  var i, mom, regex;
  if (this._monthsParseExact) {
    return handleStrictParse.call(this, monthName, format2, strict);
  }
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
  }
  for (i = 0; i < 12; i++) {
    mom = createUTC([2e3, i]);
    if (strict && !this._longMonthsParse[i]) {
      this._longMonthsParse[i] = new RegExp(
        "^" + this.months(mom, "").replace(".", "") + "$",
        "i"
      );
      this._shortMonthsParse[i] = new RegExp(
        "^" + this.monthsShort(mom, "").replace(".", "") + "$",
        "i"
      );
    }
    if (!strict && !this._monthsParse[i]) {
      regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
      this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
    }
    if (strict && format2 === "MMMM" && this._longMonthsParse[i].test(monthName)) {
      return i;
    } else if (strict && format2 === "MMM" && this._shortMonthsParse[i].test(monthName)) {
      return i;
    } else if (!strict && this._monthsParse[i].test(monthName)) {
      return i;
    }
  }
}
function setMonth(mom, value) {
  var dayOfMonth;
  if (!mom.isValid()) {
    return mom;
  }
  if (typeof value === "string") {
    if (/^\d+$/.test(value)) {
      value = toInt(value);
    } else {
      value = mom.localeData().monthsParse(value);
      if (!isNumber(value)) {
        return mom;
      }
    }
  }
  dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
  mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
  return mom;
}
function getSetMonth(value) {
  if (value != null) {
    setMonth(this, value);
    hooks.updateOffset(this, true);
    return this;
  } else {
    return get$1(this, "Month");
  }
}
function getDaysInMonth() {
  return daysInMonth(this.year(), this.month());
}
function monthsShortRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsShortStrictRegex;
    } else {
      return this._monthsShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsShortRegex")) {
      this._monthsShortRegex = defaultMonthsShortRegex;
    }
    return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
  }
}
function monthsRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsStrictRegex;
    } else {
      return this._monthsRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsRegex")) {
      this._monthsRegex = defaultMonthsRegex;
    }
    return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
  }
}
function computeMonthsParse() {
  function cmpLenRev(a, b2) {
    return b2.length - a.length;
  }
  var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
  for (i = 0; i < 12; i++) {
    mom = createUTC([2e3, i]);
    shortPieces.push(this.monthsShort(mom, ""));
    longPieces.push(this.months(mom, ""));
    mixedPieces.push(this.months(mom, ""));
    mixedPieces.push(this.monthsShort(mom, ""));
  }
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  for (i = 0; i < 12; i++) {
    shortPieces[i] = regexEscape(shortPieces[i]);
    longPieces[i] = regexEscape(longPieces[i]);
  }
  for (i = 0; i < 24; i++) {
    mixedPieces[i] = regexEscape(mixedPieces[i]);
  }
  this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._monthsShortRegex = this._monthsRegex;
  this._monthsStrictRegex = new RegExp(
    "^(" + longPieces.join("|") + ")",
    "i"
  );
  this._monthsShortStrictRegex = new RegExp(
    "^(" + shortPieces.join("|") + ")",
    "i"
  );
}
addFormatToken("Y", 0, 0, function() {
  var y = this.year();
  return y <= 9999 ? zeroFill(y, 4) : "+" + y;
});
addFormatToken(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
addFormatToken(0, ["YYYY", 4], 0, "year");
addFormatToken(0, ["YYYYY", 5], 0, "year");
addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
addUnitAlias("year", "y");
addUnitPriority("year", 1);
addRegexToken("Y", matchSigned);
addRegexToken("YY", match1to2, match2);
addRegexToken("YYYY", match1to4, match4);
addRegexToken("YYYYY", match1to6, match6);
addRegexToken("YYYYYY", match1to6, match6);
addParseToken(["YYYYY", "YYYYYY"], YEAR);
addParseToken("YYYY", function(input, array) {
  array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken("YY", function(input, array) {
  array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken("Y", function(input, array) {
  array[YEAR] = parseInt(input, 10);
});
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
hooks.parseTwoDigitYear = function(input) {
  return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
};
var getSetYear = makeGetSet("FullYear", true);
function getIsLeapYear() {
  return isLeapYear(this.year());
}
function createDate(y, m2, d2, h2, M, s, ms) {
  var date2;
  if (y < 100 && y >= 0) {
    date2 = new Date(y + 400, m2, d2, h2, M, s, ms);
    if (isFinite(date2.getFullYear())) {
      date2.setFullYear(y);
    }
  } else {
    date2 = new Date(y, m2, d2, h2, M, s, ms);
  }
  return date2;
}
function createUTCDate(y) {
  var date2, args;
  if (y < 100 && y >= 0) {
    args = Array.prototype.slice.call(arguments);
    args[0] = y + 400;
    date2 = new Date(Date.UTC.apply(null, args));
    if (isFinite(date2.getUTCFullYear())) {
      date2.setUTCFullYear(y);
    }
  } else {
    date2 = new Date(Date.UTC.apply(null, arguments));
  }
  return date2;
}
function firstWeekOffset(year, dow, doy) {
  var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
  return -fwdlw + fwd - 1;
}
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
  var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
  if (dayOfYear <= 0) {
    resYear = year - 1;
    resDayOfYear = daysInYear(resYear) + dayOfYear;
  } else if (dayOfYear > daysInYear(year)) {
    resYear = year + 1;
    resDayOfYear = dayOfYear - daysInYear(year);
  } else {
    resYear = year;
    resDayOfYear = dayOfYear;
  }
  return {
    year: resYear,
    dayOfYear: resDayOfYear
  };
}
function weekOfYear(mom, dow, doy) {
  var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
  if (week < 1) {
    resYear = mom.year() - 1;
    resWeek = week + weeksInYear(resYear, dow, doy);
  } else if (week > weeksInYear(mom.year(), dow, doy)) {
    resWeek = week - weeksInYear(mom.year(), dow, doy);
    resYear = mom.year() + 1;
  } else {
    resYear = mom.year();
    resWeek = week;
  }
  return {
    week: resWeek,
    year: resYear
  };
}
function weeksInYear(year, dow, doy) {
  var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
  return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}
addFormatToken("w", ["ww", 2], "wo", "week");
addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
addUnitAlias("week", "w");
addUnitAlias("isoWeek", "W");
addUnitPriority("week", 5);
addUnitPriority("isoWeek", 5);
addRegexToken("w", match1to2);
addRegexToken("ww", match1to2, match2);
addRegexToken("W", match1to2);
addRegexToken("WW", match1to2, match2);
addWeekParseToken(
  ["w", "ww", "W", "WW"],
  function(input, week, config, token2) {
    week[token2.substr(0, 1)] = toInt(input);
  }
);
function localeWeek(mom) {
  return weekOfYear(mom, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function localeFirstDayOfWeek() {
  return this._week.dow;
}
function localeFirstDayOfYear() {
  return this._week.doy;
}
function getSetWeek(input) {
  var week = this.localeData().week(this);
  return input == null ? week : this.add((input - week) * 7, "d");
}
function getSetISOWeek(input) {
  var week = weekOfYear(this, 1, 4).week;
  return input == null ? week : this.add((input - week) * 7, "d");
}
addFormatToken("d", 0, "do", "day");
addFormatToken("dd", 0, 0, function(format2) {
  return this.localeData().weekdaysMin(this, format2);
});
addFormatToken("ddd", 0, 0, function(format2) {
  return this.localeData().weekdaysShort(this, format2);
});
addFormatToken("dddd", 0, 0, function(format2) {
  return this.localeData().weekdays(this, format2);
});
addFormatToken("e", 0, 0, "weekday");
addFormatToken("E", 0, 0, "isoWeekday");
addUnitAlias("day", "d");
addUnitAlias("weekday", "e");
addUnitAlias("isoWeekday", "E");
addUnitPriority("day", 11);
addUnitPriority("weekday", 11);
addUnitPriority("isoWeekday", 11);
addRegexToken("d", match1to2);
addRegexToken("e", match1to2);
addRegexToken("E", match1to2);
addRegexToken("dd", function(isStrict, locale2) {
  return locale2.weekdaysMinRegex(isStrict);
});
addRegexToken("ddd", function(isStrict, locale2) {
  return locale2.weekdaysShortRegex(isStrict);
});
addRegexToken("dddd", function(isStrict, locale2) {
  return locale2.weekdaysRegex(isStrict);
});
addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config, token2) {
  var weekday = config._locale.weekdaysParse(input, token2, config._strict);
  if (weekday != null) {
    week.d = weekday;
  } else {
    getParsingFlags(config).invalidWeekday = input;
  }
});
addWeekParseToken(["d", "e", "E"], function(input, week, config, token2) {
  week[token2] = toInt(input);
});
function parseWeekday(input, locale2) {
  if (typeof input !== "string") {
    return input;
  }
  if (!isNaN(input)) {
    return parseInt(input, 10);
  }
  input = locale2.weekdaysParse(input);
  if (typeof input === "number") {
    return input;
  }
  return null;
}
function parseIsoWeekday(input, locale2) {
  if (typeof input === "string") {
    return locale2.weekdaysParse(input) % 7 || 7;
  }
  return isNaN(input) ? null : input;
}
function shiftWeekdays(ws, n2) {
  return ws.slice(n2, 7).concat(ws.slice(0, n2));
}
var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
function localeWeekdays(m2, format2) {
  var weekdays = isArray$1(this._weekdays) ? this._weekdays : this._weekdays[m2 && m2 !== true && this._weekdays.isFormat.test(format2) ? "format" : "standalone"];
  return m2 === true ? shiftWeekdays(weekdays, this._week.dow) : m2 ? weekdays[m2.day()] : weekdays;
}
function localeWeekdaysShort(m2) {
  return m2 === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m2 ? this._weekdaysShort[m2.day()] : this._weekdaysShort;
}
function localeWeekdaysMin(m2) {
  return m2 === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m2 ? this._weekdaysMin[m2.day()] : this._weekdaysMin;
}
function handleStrictParse$1(weekdayName, format2, strict) {
  var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._minWeekdaysParse = [];
    for (i = 0; i < 7; ++i) {
      mom = createUTC([2e3, 1]).day(i);
      this._minWeekdaysParse[i] = this.weekdaysMin(
        mom,
        ""
      ).toLocaleLowerCase();
      this._shortWeekdaysParse[i] = this.weekdaysShort(
        mom,
        ""
      ).toLocaleLowerCase();
      this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format2 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format2 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format2 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeWeekdaysParse(weekdayName, format2, strict) {
  var i, mom, regex;
  if (this._weekdaysParseExact) {
    return handleStrictParse$1.call(this, weekdayName, format2, strict);
  }
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._minWeekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._fullWeekdaysParse = [];
  }
  for (i = 0; i < 7; i++) {
    mom = createUTC([2e3, 1]).day(i);
    if (strict && !this._fullWeekdaysParse[i]) {
      this._fullWeekdaysParse[i] = new RegExp(
        "^" + this.weekdays(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
      this._shortWeekdaysParse[i] = new RegExp(
        "^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
      this._minWeekdaysParse[i] = new RegExp(
        "^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
    }
    if (!this._weekdaysParse[i]) {
      regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
      this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
    }
    if (strict && format2 === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (strict && format2 === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (strict && format2 === "dd" && this._minWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
      return i;
    }
  }
}
function getSetDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  if (input != null) {
    input = parseWeekday(input, this.localeData());
    return this.add(input - day, "d");
  } else {
    return day;
  }
}
function getSetLocaleDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return input == null ? weekday : this.add(input - weekday, "d");
}
function getSetISODayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    var weekday = parseIsoWeekday(input, this.localeData());
    return this.day(this.day() % 7 ? weekday : weekday - 7);
  } else {
    return this.day() || 7;
  }
}
function weekdaysRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysStrictRegex;
    } else {
      return this._weekdaysRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      this._weekdaysRegex = defaultWeekdaysRegex;
    }
    return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
  }
}
function weekdaysShortRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysShortStrictRegex;
    } else {
      return this._weekdaysShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysShortRegex")) {
      this._weekdaysShortRegex = defaultWeekdaysShortRegex;
    }
    return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
  }
}
function weekdaysMinRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysMinStrictRegex;
    } else {
      return this._weekdaysMinRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysMinRegex")) {
      this._weekdaysMinRegex = defaultWeekdaysMinRegex;
    }
    return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
  }
}
function computeWeekdaysParse() {
  function cmpLenRev(a, b2) {
    return b2.length - a.length;
  }
  var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
  for (i = 0; i < 7; i++) {
    mom = createUTC([2e3, 1]).day(i);
    minp = regexEscape(this.weekdaysMin(mom, ""));
    shortp = regexEscape(this.weekdaysShort(mom, ""));
    longp = regexEscape(this.weekdays(mom, ""));
    minPieces.push(minp);
    shortPieces.push(shortp);
    longPieces.push(longp);
    mixedPieces.push(minp);
    mixedPieces.push(shortp);
    mixedPieces.push(longp);
  }
  minPieces.sort(cmpLenRev);
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._weekdaysShortRegex = this._weekdaysRegex;
  this._weekdaysMinRegex = this._weekdaysRegex;
  this._weekdaysStrictRegex = new RegExp(
    "^(" + longPieces.join("|") + ")",
    "i"
  );
  this._weekdaysShortStrictRegex = new RegExp(
    "^(" + shortPieces.join("|") + ")",
    "i"
  );
  this._weekdaysMinStrictRegex = new RegExp(
    "^(" + minPieces.join("|") + ")",
    "i"
  );
}
function hFormat() {
  return this.hours() % 12 || 12;
}
function kFormat() {
  return this.hours() || 24;
}
addFormatToken("H", ["HH", 2], 0, "hour");
addFormatToken("h", ["hh", 2], 0, hFormat);
addFormatToken("k", ["kk", 2], 0, kFormat);
addFormatToken("hmm", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken("hmmss", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
addFormatToken("Hmm", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken("Hmmss", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
function meridiem(token2, lowercase) {
  addFormatToken(token2, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      lowercase
    );
  });
}
meridiem("a", true);
meridiem("A", false);
addUnitAlias("hour", "h");
addUnitPriority("hour", 13);
function matchMeridiem(isStrict, locale2) {
  return locale2._meridiemParse;
}
addRegexToken("a", matchMeridiem);
addRegexToken("A", matchMeridiem);
addRegexToken("H", match1to2);
addRegexToken("h", match1to2);
addRegexToken("k", match1to2);
addRegexToken("HH", match1to2, match2);
addRegexToken("hh", match1to2, match2);
addRegexToken("kk", match1to2, match2);
addRegexToken("hmm", match3to4);
addRegexToken("hmmss", match5to6);
addRegexToken("Hmm", match3to4);
addRegexToken("Hmmss", match5to6);
addParseToken(["H", "HH"], HOUR);
addParseToken(["k", "kk"], function(input, array, config) {
  var kInput = toInt(input);
  array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(["a", "A"], function(input, array, config) {
  config._isPm = config._locale.isPM(input);
  config._meridiem = input;
});
addParseToken(["h", "hh"], function(input, array, config) {
  array[HOUR] = toInt(input);
  getParsingFlags(config).bigHour = true;
});
addParseToken("hmm", function(input, array, config) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
  getParsingFlags(config).bigHour = true;
});
addParseToken("hmmss", function(input, array, config) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
  getParsingFlags(config).bigHour = true;
});
addParseToken("Hmm", function(input, array, config) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
});
addParseToken("Hmmss", function(input, array, config) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
});
function localeIsPM(input) {
  return (input + "").toLowerCase().charAt(0) === "p";
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
function localeMeridiem(hours2, minutes2, isLower) {
  if (hours2 > 11) {
    return isLower ? "pm" : "PM";
  } else {
    return isLower ? "am" : "AM";
  }
}
var baseConfig = {
  calendar: defaultCalendar,
  longDateFormat: defaultLongDateFormat,
  invalidDate: defaultInvalidDate,
  ordinal: defaultOrdinal,
  dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
  relativeTime: defaultRelativeTime,
  months: defaultLocaleMonths,
  monthsShort: defaultLocaleMonthsShort,
  week: defaultLocaleWeek,
  weekdays: defaultLocaleWeekdays,
  weekdaysMin: defaultLocaleWeekdaysMin,
  weekdaysShort: defaultLocaleWeekdaysShort,
  meridiemParse: defaultLocaleMeridiemParse
};
var locales = {}, localeFamilies = {}, globalLocale;
function commonPrefix(arr1, arr2) {
  var i, minl = Math.min(arr1.length, arr2.length);
  for (i = 0; i < minl; i += 1) {
    if (arr1[i] !== arr2[i]) {
      return i;
    }
  }
  return minl;
}
function normalizeLocale(key) {
  return key ? key.toLowerCase().replace("_", "-") : key;
}
function chooseLocale(names) {
  var i = 0, j, next2, locale2, split;
  while (i < names.length) {
    split = normalizeLocale(names[i]).split("-");
    j = split.length;
    next2 = normalizeLocale(names[i + 1]);
    next2 = next2 ? next2.split("-") : null;
    while (j > 0) {
      locale2 = loadLocale(split.slice(0, j).join("-"));
      if (locale2) {
        return locale2;
      }
      if (next2 && next2.length >= j && commonPrefix(split, next2) >= j - 1) {
        break;
      }
      j--;
    }
    i++;
  }
  return globalLocale;
}
function isLocaleNameSane(name) {
  return name.match("^[^/\\\\]*$") != null;
}
function loadLocale(name) {
  var oldLocale = null, aliasedRequire;
  if (locales[name] === void 0 && typeof module !== "undefined" && module && module.exports && isLocaleNameSane(name)) {
    try {
      oldLocale = globalLocale._abbr;
      aliasedRequire = require;
      aliasedRequire("./locale/" + name);
      getSetGlobalLocale(oldLocale);
    } catch (e2) {
      locales[name] = null;
    }
  }
  return locales[name];
}
function getSetGlobalLocale(key, values2) {
  var data;
  if (key) {
    if (isUndefined$1(values2)) {
      data = getLocale(key);
    } else {
      data = defineLocale(key, values2);
    }
    if (data) {
      globalLocale = data;
    } else {
      if (typeof console !== "undefined" && console.warn) {
        console.warn(
          "Locale " + key + " not found. Did you forget to load it?"
        );
      }
    }
  }
  return globalLocale._abbr;
}
function defineLocale(name, config) {
  if (config !== null) {
    var locale2, parentConfig = baseConfig;
    config.abbr = name;
    if (locales[name] != null) {
      deprecateSimple(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      );
      parentConfig = locales[name]._config;
    } else if (config.parentLocale != null) {
      if (locales[config.parentLocale] != null) {
        parentConfig = locales[config.parentLocale]._config;
      } else {
        locale2 = loadLocale(config.parentLocale);
        if (locale2 != null) {
          parentConfig = locale2._config;
        } else {
          if (!localeFamilies[config.parentLocale]) {
            localeFamilies[config.parentLocale] = [];
          }
          localeFamilies[config.parentLocale].push({
            name,
            config
          });
          return null;
        }
      }
    }
    locales[name] = new Locale(mergeConfigs(parentConfig, config));
    if (localeFamilies[name]) {
      localeFamilies[name].forEach(function(x) {
        defineLocale(x.name, x.config);
      });
    }
    getSetGlobalLocale(name);
    return locales[name];
  } else {
    delete locales[name];
    return null;
  }
}
function updateLocale(name, config) {
  if (config != null) {
    var locale2, tmpLocale, parentConfig = baseConfig;
    if (locales[name] != null && locales[name].parentLocale != null) {
      locales[name].set(mergeConfigs(locales[name]._config, config));
    } else {
      tmpLocale = loadLocale(name);
      if (tmpLocale != null) {
        parentConfig = tmpLocale._config;
      }
      config = mergeConfigs(parentConfig, config);
      if (tmpLocale == null) {
        config.abbr = name;
      }
      locale2 = new Locale(config);
      locale2.parentLocale = locales[name];
      locales[name] = locale2;
    }
    getSetGlobalLocale(name);
  } else {
    if (locales[name] != null) {
      if (locales[name].parentLocale != null) {
        locales[name] = locales[name].parentLocale;
        if (name === getSetGlobalLocale()) {
          getSetGlobalLocale(name);
        }
      } else if (locales[name] != null) {
        delete locales[name];
      }
    }
  }
  return locales[name];
}
function getLocale(key) {
  var locale2;
  if (key && key._locale && key._locale._abbr) {
    key = key._locale._abbr;
  }
  if (!key) {
    return globalLocale;
  }
  if (!isArray$1(key)) {
    locale2 = loadLocale(key);
    if (locale2) {
      return locale2;
    }
    key = [key];
  }
  return chooseLocale(key);
}
function listLocales() {
  return keys$1(locales);
}
function checkOverflow(m2) {
  var overflow, a = m2._a;
  if (a && getParsingFlags(m2).overflow === -2) {
    overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
    if (getParsingFlags(m2)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
      overflow = DATE;
    }
    if (getParsingFlags(m2)._overflowWeeks && overflow === -1) {
      overflow = WEEK;
    }
    if (getParsingFlags(m2)._overflowWeekday && overflow === -1) {
      overflow = WEEKDAY;
    }
    getParsingFlags(m2).overflow = overflow;
  }
  return m2;
}
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, false],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, false],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, false],
  ["YYYY", /\d{4}/, false]
], isoTimes = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function configFromISO(config) {
  var i, l2, string2 = config._i, match5 = extendedIsoRegex.exec(string2) || basicIsoRegex.exec(string2), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
  if (match5) {
    getParsingFlags(config).iso = true;
    for (i = 0, l2 = isoDatesLen; i < l2; i++) {
      if (isoDates[i][1].exec(match5[1])) {
        dateFormat = isoDates[i][0];
        allowTime = isoDates[i][2] !== false;
        break;
      }
    }
    if (dateFormat == null) {
      config._isValid = false;
      return;
    }
    if (match5[3]) {
      for (i = 0, l2 = isoTimesLen; i < l2; i++) {
        if (isoTimes[i][1].exec(match5[3])) {
          timeFormat = (match5[2] || " ") + isoTimes[i][0];
          break;
        }
      }
      if (timeFormat == null) {
        config._isValid = false;
        return;
      }
    }
    if (!allowTime && timeFormat != null) {
      config._isValid = false;
      return;
    }
    if (match5[4]) {
      if (tzRegex.exec(match5[4])) {
        tzFormat = "Z";
      } else {
        config._isValid = false;
        return;
      }
    }
    config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
    configFromStringAndFormat(config);
  } else {
    config._isValid = false;
  }
}
function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result = [
    untruncateYear(yearStr),
    defaultLocaleMonthsShort.indexOf(monthStr),
    parseInt(dayStr, 10),
    parseInt(hourStr, 10),
    parseInt(minuteStr, 10)
  ];
  if (secondStr) {
    result.push(parseInt(secondStr, 10));
  }
  return result;
}
function untruncateYear(yearStr) {
  var year = parseInt(yearStr, 10);
  if (year <= 49) {
    return 2e3 + year;
  } else if (year <= 999) {
    return 1900 + year;
  }
  return year;
}
function preprocessRFC2822(s) {
  return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function checkWeekday(weekdayStr, parsedInput, config) {
  if (weekdayStr) {
    var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(
      parsedInput[0],
      parsedInput[1],
      parsedInput[2]
    ).getDay();
    if (weekdayProvided !== weekdayActual) {
      getParsingFlags(config).weekdayMismatch = true;
      config._isValid = false;
      return false;
    }
  }
  return true;
}
function calculateOffset(obsOffset, militaryOffset, numOffset) {
  if (obsOffset) {
    return obsOffsets[obsOffset];
  } else if (militaryOffset) {
    return 0;
  } else {
    var hm = parseInt(numOffset, 10), m2 = hm % 100, h2 = (hm - m2) / 100;
    return h2 * 60 + m2;
  }
}
function configFromRFC2822(config) {
  var match5 = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
  if (match5) {
    parsedArray = extractFromRFC2822Strings(
      match5[4],
      match5[3],
      match5[2],
      match5[5],
      match5[6],
      match5[7]
    );
    if (!checkWeekday(match5[1], parsedArray, config)) {
      return;
    }
    config._a = parsedArray;
    config._tzm = calculateOffset(match5[8], match5[9], match5[10]);
    config._d = createUTCDate.apply(null, config._a);
    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    getParsingFlags(config).rfc2822 = true;
  } else {
    config._isValid = false;
  }
}
function configFromString(config) {
  var matched = aspNetJsonRegex.exec(config._i);
  if (matched !== null) {
    config._d = /* @__PURE__ */ new Date(+matched[1]);
    return;
  }
  configFromISO(config);
  if (config._isValid === false) {
    delete config._isValid;
  } else {
    return;
  }
  configFromRFC2822(config);
  if (config._isValid === false) {
    delete config._isValid;
  } else {
    return;
  }
  if (config._strict) {
    config._isValid = false;
  } else {
    hooks.createFromInputFallback(config);
  }
}
hooks.createFromInputFallback = deprecate(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(config) {
    config._d = /* @__PURE__ */ new Date(config._i + (config._useUTC ? " UTC" : ""));
  }
);
function defaults(a, b2, c2) {
  if (a != null) {
    return a;
  }
  if (b2 != null) {
    return b2;
  }
  return c2;
}
function currentDateArray(config) {
  var nowValue = new Date(hooks.now());
  if (config._useUTC) {
    return [
      nowValue.getUTCFullYear(),
      nowValue.getUTCMonth(),
      nowValue.getUTCDate()
    ];
  }
  return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}
function configFromArray(config) {
  var i, date2, input = [], currentDate, expectedWeekday, yearToUse;
  if (config._d) {
    return;
  }
  currentDate = currentDateArray(config);
  if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
    dayOfYearFromWeekInfo(config);
  }
  if (config._dayOfYear != null) {
    yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
    if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
      getParsingFlags(config)._overflowDayOfYear = true;
    }
    date2 = createUTCDate(yearToUse, 0, config._dayOfYear);
    config._a[MONTH] = date2.getUTCMonth();
    config._a[DATE] = date2.getUTCDate();
  }
  for (i = 0; i < 3 && config._a[i] == null; ++i) {
    config._a[i] = input[i] = currentDate[i];
  }
  for (; i < 7; i++) {
    config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
  }
  if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
    config._nextDay = true;
    config._a[HOUR] = 0;
  }
  config._d = (config._useUTC ? createUTCDate : createDate).apply(
    null,
    input
  );
  expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
  if (config._tzm != null) {
    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
  }
  if (config._nextDay) {
    config._a[HOUR] = 24;
  }
  if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) {
    getParsingFlags(config).weekdayMismatch = true;
  }
}
function dayOfYearFromWeekInfo(config) {
  var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
  w = config._w;
  if (w.GG != null || w.W != null || w.E != null) {
    dow = 1;
    doy = 4;
    weekYear = defaults(
      w.GG,
      config._a[YEAR],
      weekOfYear(createLocal(), 1, 4).year
    );
    week = defaults(w.W, 1);
    weekday = defaults(w.E, 1);
    if (weekday < 1 || weekday > 7) {
      weekdayOverflow = true;
    }
  } else {
    dow = config._locale._week.dow;
    doy = config._locale._week.doy;
    curWeek = weekOfYear(createLocal(), dow, doy);
    weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
    week = defaults(w.w, curWeek.week);
    if (w.d != null) {
      weekday = w.d;
      if (weekday < 0 || weekday > 6) {
        weekdayOverflow = true;
      }
    } else if (w.e != null) {
      weekday = w.e + dow;
      if (w.e < 0 || w.e > 6) {
        weekdayOverflow = true;
      }
    } else {
      weekday = dow;
    }
  }
  if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
    getParsingFlags(config)._overflowWeeks = true;
  } else if (weekdayOverflow != null) {
    getParsingFlags(config)._overflowWeekday = true;
  } else {
    temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
    config._a[YEAR] = temp.year;
    config._dayOfYear = temp.dayOfYear;
  }
}
hooks.ISO_8601 = function() {
};
hooks.RFC_2822 = function() {
};
function configFromStringAndFormat(config) {
  if (config._f === hooks.ISO_8601) {
    configFromISO(config);
    return;
  }
  if (config._f === hooks.RFC_2822) {
    configFromRFC2822(config);
    return;
  }
  config._a = [];
  getParsingFlags(config).empty = true;
  var string2 = "" + config._i, i, parsedInput, tokens2, token2, skipped, stringLength = string2.length, totalParsedInputLength = 0, era, tokenLen;
  tokens2 = expandFormat(config._f, config._locale).match(formattingTokens) || [];
  tokenLen = tokens2.length;
  for (i = 0; i < tokenLen; i++) {
    token2 = tokens2[i];
    parsedInput = (string2.match(getParseRegexForToken(token2, config)) || [])[0];
    if (parsedInput) {
      skipped = string2.substr(0, string2.indexOf(parsedInput));
      if (skipped.length > 0) {
        getParsingFlags(config).unusedInput.push(skipped);
      }
      string2 = string2.slice(
        string2.indexOf(parsedInput) + parsedInput.length
      );
      totalParsedInputLength += parsedInput.length;
    }
    if (formatTokenFunctions[token2]) {
      if (parsedInput) {
        getParsingFlags(config).empty = false;
      } else {
        getParsingFlags(config).unusedTokens.push(token2);
      }
      addTimeToArrayFromToken(token2, parsedInput, config);
    } else if (config._strict && !parsedInput) {
      getParsingFlags(config).unusedTokens.push(token2);
    }
  }
  getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
  if (string2.length > 0) {
    getParsingFlags(config).unusedInput.push(string2);
  }
  if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
    getParsingFlags(config).bigHour = void 0;
  }
  getParsingFlags(config).parsedDateParts = config._a.slice(0);
  getParsingFlags(config).meridiem = config._meridiem;
  config._a[HOUR] = meridiemFixWrap(
    config._locale,
    config._a[HOUR],
    config._meridiem
  );
  era = getParsingFlags(config).era;
  if (era !== null) {
    config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
  }
  configFromArray(config);
  checkOverflow(config);
}
function meridiemFixWrap(locale2, hour, meridiem2) {
  var isPm;
  if (meridiem2 == null) {
    return hour;
  }
  if (locale2.meridiemHour != null) {
    return locale2.meridiemHour(hour, meridiem2);
  } else if (locale2.isPM != null) {
    isPm = locale2.isPM(meridiem2);
    if (isPm && hour < 12) {
      hour += 12;
    }
    if (!isPm && hour === 12) {
      hour = 0;
    }
    return hour;
  } else {
    return hour;
  }
}
function configFromStringAndArray(config) {
  var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
  if (configfLen === 0) {
    getParsingFlags(config).invalidFormat = true;
    config._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (i = 0; i < configfLen; i++) {
    currentScore = 0;
    validFormatFound = false;
    tempConfig = copyConfig({}, config);
    if (config._useUTC != null) {
      tempConfig._useUTC = config._useUTC;
    }
    tempConfig._f = config._f[i];
    configFromStringAndFormat(tempConfig);
    if (isValid(tempConfig)) {
      validFormatFound = true;
    }
    currentScore += getParsingFlags(tempConfig).charsLeftOver;
    currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
    getParsingFlags(tempConfig).score = currentScore;
    if (!bestFormatIsValid) {
      if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
        if (validFormatFound) {
          bestFormatIsValid = true;
        }
      }
    } else {
      if (currentScore < scoreToBeat) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
      }
    }
  }
  extend$2(config, bestMoment || tempConfig);
}
function configFromObject(config) {
  if (config._d) {
    return;
  }
  var i = normalizeObjectUnits(config._i), dayOrDate = i.day === void 0 ? i.date : i.day;
  config._a = map(
    [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
    function(obj) {
      return obj && parseInt(obj, 10);
    }
  );
  configFromArray(config);
}
function createFromConfig(config) {
  var res = new Moment(checkOverflow(prepareConfig(config)));
  if (res._nextDay) {
    res.add(1, "d");
    res._nextDay = void 0;
  }
  return res;
}
function prepareConfig(config) {
  var input = config._i, format2 = config._f;
  config._locale = config._locale || getLocale(config._l);
  if (input === null || format2 === void 0 && input === "") {
    return createInvalid({ nullInput: true });
  }
  if (typeof input === "string") {
    config._i = input = config._locale.preparse(input);
  }
  if (isMoment(input)) {
    return new Moment(checkOverflow(input));
  } else if (isDate(input)) {
    config._d = input;
  } else if (isArray$1(format2)) {
    configFromStringAndArray(config);
  } else if (format2) {
    configFromStringAndFormat(config);
  } else {
    configFromInput(config);
  }
  if (!isValid(config)) {
    config._d = null;
  }
  return config;
}
function configFromInput(config) {
  var input = config._i;
  if (isUndefined$1(input)) {
    config._d = new Date(hooks.now());
  } else if (isDate(input)) {
    config._d = new Date(input.valueOf());
  } else if (typeof input === "string") {
    configFromString(config);
  } else if (isArray$1(input)) {
    config._a = map(input.slice(0), function(obj) {
      return parseInt(obj, 10);
    });
    configFromArray(config);
  } else if (isObject$2(input)) {
    configFromObject(config);
  } else if (isNumber(input)) {
    config._d = new Date(input);
  } else {
    hooks.createFromInputFallback(config);
  }
}
function createLocalOrUTC(input, format2, locale2, strict, isUTC) {
  var c2 = {};
  if (format2 === true || format2 === false) {
    strict = format2;
    format2 = void 0;
  }
  if (locale2 === true || locale2 === false) {
    strict = locale2;
    locale2 = void 0;
  }
  if (isObject$2(input) && isObjectEmpty$1(input) || isArray$1(input) && input.length === 0) {
    input = void 0;
  }
  c2._isAMomentObject = true;
  c2._useUTC = c2._isUTC = isUTC;
  c2._l = locale2;
  c2._i = input;
  c2._f = format2;
  c2._strict = strict;
  return createFromConfig(c2);
}
function createLocal(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, false);
}
var prototypeMin = deprecate(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
      return other < this ? this : other;
    } else {
      return createInvalid();
    }
  }
), prototypeMax = deprecate(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
      return other > this ? this : other;
    } else {
      return createInvalid();
    }
  }
);
function pickBy(fn, moments) {
  var res, i;
  if (moments.length === 1 && isArray$1(moments[0])) {
    moments = moments[0];
  }
  if (!moments.length) {
    return createLocal();
  }
  res = moments[0];
  for (i = 1; i < moments.length; ++i) {
    if (!moments[i].isValid() || moments[i][fn](res)) {
      res = moments[i];
    }
  }
  return res;
}
function min() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isBefore", args);
}
function max() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isAfter", args);
}
var now$1 = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
};
var ordering = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function isDurationValid(m2) {
  var key, unitHasDecimal = false, i, orderLen = ordering.length;
  for (key in m2) {
    if (hasOwnProp(m2, key) && !(indexOf.call(ordering, key) !== -1 && (m2[key] == null || !isNaN(m2[key])))) {
      return false;
    }
  }
  for (i = 0; i < orderLen; ++i) {
    if (m2[ordering[i]]) {
      if (unitHasDecimal) {
        return false;
      }
      if (parseFloat(m2[ordering[i]]) !== toInt(m2[ordering[i]])) {
        unitHasDecimal = true;
      }
    }
  }
  return true;
}
function isValid$1() {
  return this._isValid;
}
function createInvalid$1() {
  return createDuration(NaN);
}
function Duration(duration2) {
  var normalizedInput = normalizeObjectUnits(duration2), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
  this._isValid = isDurationValid(normalizedInput);
  this._milliseconds = +milliseconds2 + seconds2 * 1e3 + // 1000
  minutes2 * 6e4 + // 1000 * 60
  hours2 * 1e3 * 60 * 60;
  this._days = +days2 + weeks2 * 7;
  this._months = +months2 + quarters * 3 + years2 * 12;
  this._data = {};
  this._locale = getLocale();
  this._bubble();
}
function isDuration(obj) {
  return obj instanceof Duration;
}
function absRound(number2) {
  if (number2 < 0) {
    return Math.round(-1 * number2) * -1;
  } else {
    return Math.round(number2);
  }
}
function compareArrays(array1, array2, dontConvert) {
  var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
  for (i = 0; i < len; i++) {
    if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
      diffs++;
    }
  }
  return diffs + lengthDiff;
}
function offset(token2, separator) {
  addFormatToken(token2, 0, 0, function() {
    var offset2 = this.utcOffset(), sign2 = "+";
    if (offset2 < 0) {
      offset2 = -offset2;
      sign2 = "-";
    }
    return sign2 + zeroFill(~~(offset2 / 60), 2) + separator + zeroFill(~~offset2 % 60, 2);
  });
}
offset("Z", ":");
offset("ZZ", "");
addRegexToken("Z", matchShortOffset);
addRegexToken("ZZ", matchShortOffset);
addParseToken(["Z", "ZZ"], function(input, array, config) {
  config._useUTC = true;
  config._tzm = offsetFromString(matchShortOffset, input);
});
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(matcher, string2) {
  var matches = (string2 || "").match(matcher), chunk, parts, minutes2;
  if (matches === null) {
    return null;
  }
  chunk = matches[matches.length - 1] || [];
  parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
  minutes2 = +(parts[1] * 60) + toInt(parts[2]);
  return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
}
function cloneWithOffset(input, model) {
  var res, diff2;
  if (model._isUTC) {
    res = model.clone();
    diff2 = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
    res._d.setTime(res._d.valueOf() + diff2);
    hooks.updateOffset(res, false);
    return res;
  } else {
    return createLocal(input).local();
  }
}
function getDateOffset(m2) {
  return -Math.round(m2._d.getTimezoneOffset());
}
hooks.updateOffset = function() {
};
function getSetOffset(input, keepLocalTime, keepMinutes) {
  var offset2 = this._offset || 0, localAdjust;
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    if (typeof input === "string") {
      input = offsetFromString(matchShortOffset, input);
      if (input === null) {
        return this;
      }
    } else if (Math.abs(input) < 16 && !keepMinutes) {
      input = input * 60;
    }
    if (!this._isUTC && keepLocalTime) {
      localAdjust = getDateOffset(this);
    }
    this._offset = input;
    this._isUTC = true;
    if (localAdjust != null) {
      this.add(localAdjust, "m");
    }
    if (offset2 !== input) {
      if (!keepLocalTime || this._changeInProgress) {
        addSubtract(
          this,
          createDuration(input - offset2, "m"),
          1,
          false
        );
      } else if (!this._changeInProgress) {
        this._changeInProgress = true;
        hooks.updateOffset(this, true);
        this._changeInProgress = null;
      }
    }
    return this;
  } else {
    return this._isUTC ? offset2 : getDateOffset(this);
  }
}
function getSetZone(input, keepLocalTime) {
  if (input != null) {
    if (typeof input !== "string") {
      input = -input;
    }
    this.utcOffset(input, keepLocalTime);
    return this;
  } else {
    return -this.utcOffset();
  }
}
function setOffsetToUTC(keepLocalTime) {
  return this.utcOffset(0, keepLocalTime);
}
function setOffsetToLocal(keepLocalTime) {
  if (this._isUTC) {
    this.utcOffset(0, keepLocalTime);
    this._isUTC = false;
    if (keepLocalTime) {
      this.subtract(getDateOffset(this), "m");
    }
  }
  return this;
}
function setOffsetToParsedOffset() {
  if (this._tzm != null) {
    this.utcOffset(this._tzm, false, true);
  } else if (typeof this._i === "string") {
    var tZone = offsetFromString(matchOffset, this._i);
    if (tZone != null) {
      this.utcOffset(tZone);
    } else {
      this.utcOffset(0, true);
    }
  }
  return this;
}
function hasAlignedHourOffset(input) {
  if (!this.isValid()) {
    return false;
  }
  input = input ? createLocal(input).utcOffset() : 0;
  return (this.utcOffset() - input) % 60 === 0;
}
function isDaylightSavingTime() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function isDaylightSavingTimeShifted() {
  if (!isUndefined$1(this._isDSTShifted)) {
    return this._isDSTShifted;
  }
  var c2 = {}, other;
  copyConfig(c2, this);
  c2 = prepareConfig(c2);
  if (c2._a) {
    other = c2._isUTC ? createUTC(c2._a) : createLocal(c2._a);
    this._isDSTShifted = this.isValid() && compareArrays(c2._a, other.toArray()) > 0;
  } else {
    this._isDSTShifted = false;
  }
  return this._isDSTShifted;
}
function isLocal() {
  return this.isValid() ? !this._isUTC : false;
}
function isUtcOffset() {
  return this.isValid() ? this._isUTC : false;
}
function isUtc() {
  return this.isValid() ? this._isUTC && this._offset === 0 : false;
}
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(input, key) {
  var duration2 = input, match5 = null, sign2, ret, diffRes;
  if (isDuration(input)) {
    duration2 = {
      ms: input._milliseconds,
      d: input._days,
      M: input._months
    };
  } else if (isNumber(input) || !isNaN(+input)) {
    duration2 = {};
    if (key) {
      duration2[key] = +input;
    } else {
      duration2.milliseconds = +input;
    }
  } else if (match5 = aspNetRegex.exec(input)) {
    sign2 = match5[1] === "-" ? -1 : 1;
    duration2 = {
      y: 0,
      d: toInt(match5[DATE]) * sign2,
      h: toInt(match5[HOUR]) * sign2,
      m: toInt(match5[MINUTE]) * sign2,
      s: toInt(match5[SECOND]) * sign2,
      ms: toInt(absRound(match5[MILLISECOND] * 1e3)) * sign2
      // the millisecond decimal point is included in the match
    };
  } else if (match5 = isoRegex.exec(input)) {
    sign2 = match5[1] === "-" ? -1 : 1;
    duration2 = {
      y: parseIso(match5[2], sign2),
      M: parseIso(match5[3], sign2),
      w: parseIso(match5[4], sign2),
      d: parseIso(match5[5], sign2),
      h: parseIso(match5[6], sign2),
      m: parseIso(match5[7], sign2),
      s: parseIso(match5[8], sign2)
    };
  } else if (duration2 == null) {
    duration2 = {};
  } else if (typeof duration2 === "object" && ("from" in duration2 || "to" in duration2)) {
    diffRes = momentsDifference(
      createLocal(duration2.from),
      createLocal(duration2.to)
    );
    duration2 = {};
    duration2.ms = diffRes.milliseconds;
    duration2.M = diffRes.months;
  }
  ret = new Duration(duration2);
  if (isDuration(input) && hasOwnProp(input, "_locale")) {
    ret._locale = input._locale;
  }
  if (isDuration(input) && hasOwnProp(input, "_isValid")) {
    ret._isValid = input._isValid;
  }
  return ret;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(inp, sign2) {
  var res = inp && parseFloat(inp.replace(",", "."));
  return (isNaN(res) ? 0 : res) * sign2;
}
function positiveMomentsDifference(base2, other) {
  var res = {};
  res.months = other.month() - base2.month() + (other.year() - base2.year()) * 12;
  if (base2.clone().add(res.months, "M").isAfter(other)) {
    --res.months;
  }
  res.milliseconds = +other - +base2.clone().add(res.months, "M");
  return res;
}
function momentsDifference(base2, other) {
  var res;
  if (!(base2.isValid() && other.isValid())) {
    return { milliseconds: 0, months: 0 };
  }
  other = cloneWithOffset(other, base2);
  if (base2.isBefore(other)) {
    res = positiveMomentsDifference(base2, other);
  } else {
    res = positiveMomentsDifference(other, base2);
    res.milliseconds = -res.milliseconds;
    res.months = -res.months;
  }
  return res;
}
function createAdder(direction, name) {
  return function(val, period) {
    var dur, tmp;
    if (period !== null && !isNaN(+period)) {
      deprecateSimple(
        name,
        "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
      );
      tmp = val;
      val = period;
      period = tmp;
    }
    dur = createDuration(val, period);
    addSubtract(this, dur, direction);
    return this;
  };
}
function addSubtract(mom, duration2, isAdding, updateOffset) {
  var milliseconds2 = duration2._milliseconds, days2 = absRound(duration2._days), months2 = absRound(duration2._months);
  if (!mom.isValid()) {
    return;
  }
  updateOffset = updateOffset == null ? true : updateOffset;
  if (months2) {
    setMonth(mom, get$1(mom, "Month") + months2 * isAdding);
  }
  if (days2) {
    set$1$1(mom, "Date", get$1(mom, "Date") + days2 * isAdding);
  }
  if (milliseconds2) {
    mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
  }
  if (updateOffset) {
    hooks.updateOffset(mom, days2 || months2);
  }
}
var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
function isString$1(input) {
  return typeof input === "string" || input instanceof String;
}
function isMomentInput(input) {
  return isMoment(input) || isDate(input) || isString$1(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === void 0;
}
function isMomentInputObject(input) {
  var objectTest = isObject$2(input) && !isObjectEmpty$1(input), propertyTest = false, properties2 = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i, property, propertyLen = properties2.length;
  for (i = 0; i < propertyLen; i += 1) {
    property = properties2[i];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function isNumberOrStringArray(input) {
  var arrayTest = isArray$1(input), dataTypeTest = false;
  if (arrayTest) {
    dataTypeTest = input.filter(function(item) {
      return !isNumber(item) && isString$1(input);
    }).length === 0;
  }
  return arrayTest && dataTypeTest;
}
function isCalendarSpec(input) {
  var objectTest = isObject$2(input) && !isObjectEmpty$1(input), propertyTest = false, properties2 = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i, property;
  for (i = 0; i < properties2.length; i += 1) {
    property = properties2[i];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function getCalendarFormat(myMoment, now2) {
  var diff2 = myMoment.diff(now2, "days", true);
  return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
}
function calendar$1(time, formats) {
  if (arguments.length === 1) {
    if (!arguments[0]) {
      time = void 0;
      formats = void 0;
    } else if (isMomentInput(arguments[0])) {
      time = arguments[0];
      formats = void 0;
    } else if (isCalendarSpec(arguments[0])) {
      formats = arguments[0];
      time = void 0;
    }
  }
  var now2 = time || createLocal(), sod = cloneWithOffset(now2, this).startOf("day"), format2 = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction$1(formats[format2]) ? formats[format2].call(this, now2) : formats[format2]);
  return this.format(
    output || this.localeData().calendar(format2, this, createLocal(now2))
  );
}
function clone() {
  return new Moment(this);
}
function isAfter(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() > localInput.valueOf();
  } else {
    return localInput.valueOf() < this.clone().startOf(units).valueOf();
  }
}
function isBefore(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() < localInput.valueOf();
  } else {
    return this.clone().endOf(units).valueOf() < localInput.valueOf();
  }
}
function isBetween(from2, to2, units, inclusivity) {
  var localFrom = isMoment(from2) ? from2 : createLocal(from2), localTo = isMoment(to2) ? to2 : createLocal(to2);
  if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
    return false;
  }
  inclusivity = inclusivity || "()";
  return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
}
function isSame(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input), inputMs;
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() === localInput.valueOf();
  } else {
    inputMs = localInput.valueOf();
    return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
  }
}
function isSameOrAfter(input, units) {
  return this.isSame(input, units) || this.isAfter(input, units);
}
function isSameOrBefore(input, units) {
  return this.isSame(input, units) || this.isBefore(input, units);
}
function diff(input, units, asFloat) {
  var that, zoneDelta, output;
  if (!this.isValid()) {
    return NaN;
  }
  that = cloneWithOffset(input, this);
  if (!that.isValid()) {
    return NaN;
  }
  zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
  units = normalizeUnits(units);
  switch (units) {
    case "year":
      output = monthDiff(this, that) / 12;
      break;
    case "month":
      output = monthDiff(this, that);
      break;
    case "quarter":
      output = monthDiff(this, that) / 3;
      break;
    case "second":
      output = (this - that) / 1e3;
      break;
    case "minute":
      output = (this - that) / 6e4;
      break;
    case "hour":
      output = (this - that) / 36e5;
      break;
    case "day":
      output = (this - that - zoneDelta) / 864e5;
      break;
    case "week":
      output = (this - that - zoneDelta) / 6048e5;
      break;
    default:
      output = this - that;
  }
  return asFloat ? output : absFloor(output);
}
function monthDiff(a, b2) {
  if (a.date() < b2.date()) {
    return -monthDiff(b2, a);
  }
  var wholeMonthDiff = (b2.year() - a.year()) * 12 + (b2.month() - a.month()), anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
  if (b2 - anchor < 0) {
    anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
    adjust = (b2 - anchor) / (anchor - anchor2);
  } else {
    anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
    adjust = (b2 - anchor) / (anchor2 - anchor);
  }
  return -(wholeMonthDiff + adjust) || 0;
}
hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function toString$1() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function toISOString(keepOffset) {
  if (!this.isValid()) {
    return null;
  }
  var utc = keepOffset !== true, m2 = utc ? this.clone().utc() : this;
  if (m2.year() < 0 || m2.year() > 9999) {
    return formatMoment(
      m2,
      utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
    );
  }
  if (isFunction$1(Date.prototype.toISOString)) {
    if (utc) {
      return this.toDate().toISOString();
    } else {
      return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m2, "Z"));
    }
  }
  return formatMoment(
    m2,
    utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function inspect() {
  if (!this.isValid()) {
    return "moment.invalid(/* " + this._i + " */)";
  }
  var func = "moment", zone = "", prefix2, year, datetime, suffix;
  if (!this.isLocal()) {
    func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
    zone = "Z";
  }
  prefix2 = "[" + func + '("]';
  year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
  datetime = "-MM-DD[T]HH:mm:ss.SSS";
  suffix = zone + '[")]';
  return this.format(prefix2 + year + datetime + suffix);
}
function format(inputString) {
  if (!inputString) {
    inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
  }
  var output = formatMoment(this, inputString);
  return this.localeData().postformat(output);
}
function from$1(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function fromNow(withoutSuffix) {
  return this.from(createLocal(), withoutSuffix);
}
function to(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function toNow(withoutSuffix) {
  return this.to(createLocal(), withoutSuffix);
}
function locale(key) {
  var newLocaleData;
  if (key === void 0) {
    return this._locale._abbr;
  } else {
    newLocaleData = getLocale(key);
    if (newLocaleData != null) {
      this._locale = newLocaleData;
    }
    return this;
  }
}
var lang = deprecate(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(key) {
    if (key === void 0) {
      return this.localeData();
    } else {
      return this.locale(key);
    }
  }
);
function localeData() {
  return this._locale;
}
var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
function mod$1(dividend, divisor) {
  return (dividend % divisor + divisor) % divisor;
}
function localStartOfDate(y, m2, d2) {
  if (y < 100 && y >= 0) {
    return new Date(y + 400, m2, d2) - MS_PER_400_YEARS;
  } else {
    return new Date(y, m2, d2).valueOf();
  }
}
function utcStartOfDate(y, m2, d2) {
  if (y < 100 && y >= 0) {
    return Date.UTC(y + 400, m2, d2) - MS_PER_400_YEARS;
  } else {
    return Date.UTC(y, m2, d2);
  }
}
function startOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year(), 0, 1);
      break;
    case "quarter":
      time = startOfDate(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      time = startOfDate(this.year(), this.month(), 1);
      break;
    case "week":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date());
      break;
    case "hour":
      time = this._d.valueOf();
      time -= mod$1(
        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      );
      break;
    case "minute":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_MINUTE);
      break;
    case "second":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_SECOND);
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function endOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      time = startOfDate(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      time = startOfDate(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      time = this._d.valueOf();
      time += MS_PER_HOUR - mod$1(
        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      ) - 1;
      break;
    case "minute":
      time = this._d.valueOf();
      time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
      break;
    case "second":
      time = this._d.valueOf();
      time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function valueOf() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function unix() {
  return Math.floor(this.valueOf() / 1e3);
}
function toDate() {
  return new Date(this.valueOf());
}
function toArray() {
  var m2 = this;
  return [
    m2.year(),
    m2.month(),
    m2.date(),
    m2.hour(),
    m2.minute(),
    m2.second(),
    m2.millisecond()
  ];
}
function toObject() {
  var m2 = this;
  return {
    years: m2.year(),
    months: m2.month(),
    date: m2.date(),
    hours: m2.hours(),
    minutes: m2.minutes(),
    seconds: m2.seconds(),
    milliseconds: m2.milliseconds()
  };
}
function toJSON() {
  return this.isValid() ? this.toISOString() : null;
}
function isValid$2() {
  return isValid(this);
}
function parsingFlags() {
  return extend$2({}, getParsingFlags(this));
}
function invalidAt() {
  return getParsingFlags(this).overflow;
}
function creationData() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
addFormatToken("N", 0, 0, "eraAbbr");
addFormatToken("NN", 0, 0, "eraAbbr");
addFormatToken("NNN", 0, 0, "eraAbbr");
addFormatToken("NNNN", 0, 0, "eraName");
addFormatToken("NNNNN", 0, 0, "eraNarrow");
addFormatToken("y", ["y", 1], "yo", "eraYear");
addFormatToken("y", ["yy", 2], 0, "eraYear");
addFormatToken("y", ["yyy", 3], 0, "eraYear");
addFormatToken("y", ["yyyy", 4], 0, "eraYear");
addRegexToken("N", matchEraAbbr);
addRegexToken("NN", matchEraAbbr);
addRegexToken("NNN", matchEraAbbr);
addRegexToken("NNNN", matchEraName);
addRegexToken("NNNNN", matchEraNarrow);
addParseToken(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(input, array, config, token2) {
    var era = config._locale.erasParse(input, token2, config._strict);
    if (era) {
      getParsingFlags(config).era = era;
    } else {
      getParsingFlags(config).invalidEra = input;
    }
  }
);
addRegexToken("y", matchUnsigned);
addRegexToken("yy", matchUnsigned);
addRegexToken("yyy", matchUnsigned);
addRegexToken("yyyy", matchUnsigned);
addRegexToken("yo", matchEraYearOrdinal);
addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
addParseToken(["yo"], function(input, array, config, token2) {
  var match5;
  if (config._locale._eraYearOrdinalRegex) {
    match5 = input.match(config._locale._eraYearOrdinalRegex);
  }
  if (config._locale.eraYearOrdinalParse) {
    array[YEAR] = config._locale.eraYearOrdinalParse(input, match5);
  } else {
    array[YEAR] = parseInt(input, 10);
  }
});
function localeEras(m2, format2) {
  var i, l2, date2, eras = this._eras || getLocale("en")._eras;
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    switch (typeof eras[i].since) {
      case "string":
        date2 = hooks(eras[i].since).startOf("day");
        eras[i].since = date2.valueOf();
        break;
    }
    switch (typeof eras[i].until) {
      case "undefined":
        eras[i].until = Infinity;
        break;
      case "string":
        date2 = hooks(eras[i].until).startOf("day").valueOf();
        eras[i].until = date2.valueOf();
        break;
    }
  }
  return eras;
}
function localeErasParse(eraName, format2, strict) {
  var i, l2, eras = this.eras(), name, abbr, narrow;
  eraName = eraName.toUpperCase();
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    name = eras[i].name.toUpperCase();
    abbr = eras[i].abbr.toUpperCase();
    narrow = eras[i].narrow.toUpperCase();
    if (strict) {
      switch (format2) {
        case "N":
        case "NN":
        case "NNN":
          if (abbr === eraName) {
            return eras[i];
          }
          break;
        case "NNNN":
          if (name === eraName) {
            return eras[i];
          }
          break;
        case "NNNNN":
          if (narrow === eraName) {
            return eras[i];
          }
          break;
      }
    } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
      return eras[i];
    }
  }
}
function localeErasConvertYear(era, year) {
  var dir = era.since <= era.until ? 1 : -1;
  if (year === void 0) {
    return hooks(era.since).year();
  } else {
    return hooks(era.since).year() + (year - era.offset) * dir;
  }
}
function getEraName() {
  var i, l2, val, eras = this.localeData().eras();
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].name;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].name;
    }
  }
  return "";
}
function getEraNarrow() {
  var i, l2, val, eras = this.localeData().eras();
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].narrow;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].narrow;
    }
  }
  return "";
}
function getEraAbbr() {
  var i, l2, val, eras = this.localeData().eras();
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].abbr;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].abbr;
    }
  }
  return "";
}
function getEraYear() {
  var i, l2, dir, val, eras = this.localeData().eras();
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    dir = eras[i].since <= eras[i].until ? 1 : -1;
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
      return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
    }
  }
  return this.year();
}
function erasNameRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNameRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNameRegex : this._erasRegex;
}
function erasAbbrRegex(isStrict) {
  if (!hasOwnProp(this, "_erasAbbrRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasAbbrRegex : this._erasRegex;
}
function erasNarrowRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNarrowRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNarrowRegex : this._erasRegex;
}
function matchEraAbbr(isStrict, locale2) {
  return locale2.erasAbbrRegex(isStrict);
}
function matchEraName(isStrict, locale2) {
  return locale2.erasNameRegex(isStrict);
}
function matchEraNarrow(isStrict, locale2) {
  return locale2.erasNarrowRegex(isStrict);
}
function matchEraYearOrdinal(isStrict, locale2) {
  return locale2._eraYearOrdinalRegex || matchUnsigned;
}
function computeErasParse() {
  var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l2, eras = this.eras();
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    namePieces.push(regexEscape(eras[i].name));
    abbrPieces.push(regexEscape(eras[i].abbr));
    narrowPieces.push(regexEscape(eras[i].narrow));
    mixedPieces.push(regexEscape(eras[i].name));
    mixedPieces.push(regexEscape(eras[i].abbr));
    mixedPieces.push(regexEscape(eras[i].narrow));
  }
  this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
  this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
  this._erasNarrowRegex = new RegExp(
    "^(" + narrowPieces.join("|") + ")",
    "i"
  );
}
addFormatToken(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
addFormatToken(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(token2, getter) {
  addFormatToken(0, [token2, token2.length], 0, getter);
}
addWeekYearFormatToken("gggg", "weekYear");
addWeekYearFormatToken("ggggg", "weekYear");
addWeekYearFormatToken("GGGG", "isoWeekYear");
addWeekYearFormatToken("GGGGG", "isoWeekYear");
addUnitAlias("weekYear", "gg");
addUnitAlias("isoWeekYear", "GG");
addUnitPriority("weekYear", 1);
addUnitPriority("isoWeekYear", 1);
addRegexToken("G", matchSigned);
addRegexToken("g", matchSigned);
addRegexToken("GG", match1to2, match2);
addRegexToken("gg", match1to2, match2);
addRegexToken("GGGG", match1to4, match4);
addRegexToken("gggg", match1to4, match4);
addRegexToken("GGGGG", match1to6, match6);
addRegexToken("ggggg", match1to6, match6);
addWeekParseToken(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(input, week, config, token2) {
    week[token2.substr(0, 2)] = toInt(input);
  }
);
addWeekParseToken(["gg", "GG"], function(input, week, config, token2) {
  week[token2] = hooks.parseTwoDigitYear(input);
});
function getSetWeekYear(input) {
  return getSetWeekYearHelper.call(
    this,
    input,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function getSetISOWeekYear(input) {
  return getSetWeekYearHelper.call(
    this,
    input,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function getISOWeeksInYear() {
  return weeksInYear(this.year(), 1, 4);
}
function getISOWeeksInISOWeekYear() {
  return weeksInYear(this.isoWeekYear(), 1, 4);
}
function getWeeksInYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}
function getWeeksInWeekYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
}
function getSetWeekYearHelper(input, week, weekday, dow, doy) {
  var weeksTarget;
  if (input == null) {
    return weekOfYear(this, dow, doy).year;
  } else {
    weeksTarget = weeksInYear(input, dow, doy);
    if (week > weeksTarget) {
      week = weeksTarget;
    }
    return setWeekAll.call(this, input, week, weekday, dow, doy);
  }
}
function setWeekAll(weekYear, week, weekday, dow, doy) {
  var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date2 = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
  this.year(date2.getUTCFullYear());
  this.month(date2.getUTCMonth());
  this.date(date2.getUTCDate());
  return this;
}
addFormatToken("Q", 0, "Qo", "quarter");
addUnitAlias("quarter", "Q");
addUnitPriority("quarter", 7);
addRegexToken("Q", match1);
addParseToken("Q", function(input, array) {
  array[MONTH] = (toInt(input) - 1) * 3;
});
function getSetQuarter(input) {
  return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}
addFormatToken("D", ["DD", 2], "Do", "date");
addUnitAlias("date", "D");
addUnitPriority("date", 9);
addRegexToken("D", match1to2);
addRegexToken("DD", match1to2, match2);
addRegexToken("Do", function(isStrict, locale2) {
  return isStrict ? locale2._dayOfMonthOrdinalParse || locale2._ordinalParse : locale2._dayOfMonthOrdinalParseLenient;
});
addParseToken(["D", "DD"], DATE);
addParseToken("Do", function(input, array) {
  array[DATE] = toInt(input.match(match1to2)[0]);
});
var getSetDayOfMonth = makeGetSet("Date", true);
addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
addUnitAlias("dayOfYear", "DDD");
addUnitPriority("dayOfYear", 4);
addRegexToken("DDD", match1to3);
addRegexToken("DDDD", match3);
addParseToken(["DDD", "DDDD"], function(input, array, config) {
  config._dayOfYear = toInt(input);
});
function getSetDayOfYear(input) {
  var dayOfYear = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
}
addFormatToken("m", ["mm", 2], 0, "minute");
addUnitAlias("minute", "m");
addUnitPriority("minute", 14);
addRegexToken("m", match1to2);
addRegexToken("mm", match1to2, match2);
addParseToken(["m", "mm"], MINUTE);
var getSetMinute = makeGetSet("Minutes", false);
addFormatToken("s", ["ss", 2], 0, "second");
addUnitAlias("second", "s");
addUnitPriority("second", 15);
addRegexToken("s", match1to2);
addRegexToken("ss", match1to2, match2);
addParseToken(["s", "ss"], SECOND);
var getSetSecond = makeGetSet("Seconds", false);
addFormatToken("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
addFormatToken(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
addFormatToken(0, ["SSS", 3], 0, "millisecond");
addFormatToken(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
addFormatToken(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
addFormatToken(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
addFormatToken(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
addUnitAlias("millisecond", "ms");
addUnitPriority("millisecond", 16);
addRegexToken("S", match1to3, match1);
addRegexToken("SS", match1to3, match2);
addRegexToken("SSS", match1to3, match3);
var token$1, getSetMillisecond;
for (token$1 = "SSSS"; token$1.length <= 9; token$1 += "S") {
  addRegexToken(token$1, matchUnsigned);
}
function parseMs(input, array) {
  array[MILLISECOND] = toInt(("0." + input) * 1e3);
}
for (token$1 = "S"; token$1.length <= 9; token$1 += "S") {
  addParseToken(token$1, parseMs);
}
getSetMillisecond = makeGetSet("Milliseconds", false);
addFormatToken("z", 0, 0, "zoneAbbr");
addFormatToken("zz", 0, 0, "zoneName");
function getZoneAbbr() {
  return this._isUTC ? "UTC" : "";
}
function getZoneName() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var proto = Moment.prototype;
proto.add = add;
proto.calendar = calendar$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format;
proto.from = from$1;
proto.fromNow = fromNow;
proto.to = to;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2;
proto.lang = lang;
proto.locale = locale;
proto.localeData = localeData;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract;
proto.toArray = toArray;
proto.toObject = toObject;
proto.toDate = toDate;
proto.toISOString = toISOString;
proto.inspect = inspect;
if (typeof Symbol !== "undefined" && Symbol.for != null) {
  proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
    return "Moment<" + this.format() + ">";
  };
}
proto.toJSON = toJSON;
proto.toString = toString$1;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.eraName = getEraName;
proto.eraNarrow = getEraNarrow;
proto.eraAbbr = getEraAbbr;
proto.eraYear = getEraYear;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.weeksInWeekYear = getWeeksInWeekYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate(
  "dates accessor is deprecated. Use date instead.",
  getSetDayOfMonth
);
proto.months = deprecate(
  "months accessor is deprecated. Use month instead",
  getSetMonth
);
proto.years = deprecate(
  "years accessor is deprecated. Use year instead",
  getSetYear
);
proto.zone = deprecate(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  getSetZone
);
proto.isDSTShifted = deprecate(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  isDaylightSavingTimeShifted
);
function createUnix(input) {
  return createLocal(input * 1e3);
}
function createInZone() {
  return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(string2) {
  return string2;
}
var proto$1 = Locale.prototype;
proto$1.calendar = calendar;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set$1;
proto$1.eras = localeEras;
proto$1.erasParse = localeErasParse;
proto$1.erasConvertYear = localeErasConvertYear;
proto$1.erasAbbrRegex = erasAbbrRegex;
proto$1.erasNameRegex = erasNameRegex;
proto$1.erasNarrowRegex = erasNarrowRegex;
proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;
proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;
function get$1$1(format2, index2, field, setter) {
  var locale2 = getLocale(), utc = createUTC().set(setter, index2);
  return locale2[field](utc, format2);
}
function listMonthsImpl(format2, index2, field) {
  if (isNumber(format2)) {
    index2 = format2;
    format2 = void 0;
  }
  format2 = format2 || "";
  if (index2 != null) {
    return get$1$1(format2, index2, field, "month");
  }
  var i, out = [];
  for (i = 0; i < 12; i++) {
    out[i] = get$1$1(format2, i, field, "month");
  }
  return out;
}
function listWeekdaysImpl(localeSorted, format2, index2, field) {
  if (typeof localeSorted === "boolean") {
    if (isNumber(format2)) {
      index2 = format2;
      format2 = void 0;
    }
    format2 = format2 || "";
  } else {
    format2 = localeSorted;
    index2 = format2;
    localeSorted = false;
    if (isNumber(format2)) {
      index2 = format2;
      format2 = void 0;
    }
    format2 = format2 || "";
  }
  var locale2 = getLocale(), shift = localeSorted ? locale2._week.dow : 0, i, out = [];
  if (index2 != null) {
    return get$1$1(format2, (index2 + shift) % 7, field, "day");
  }
  for (i = 0; i < 7; i++) {
    out[i] = get$1$1(format2, (i + shift) % 7, field, "day");
  }
  return out;
}
function listMonths(format2, index2) {
  return listMonthsImpl(format2, index2, "months");
}
function listMonthsShort(format2, index2) {
  return listMonthsImpl(format2, index2, "monthsShort");
}
function listWeekdays(localeSorted, format2, index2) {
  return listWeekdaysImpl(localeSorted, format2, index2, "weekdays");
}
function listWeekdaysShort(localeSorted, format2, index2) {
  return listWeekdaysImpl(localeSorted, format2, index2, "weekdaysShort");
}
function listWeekdaysMin(localeSorted, format2, index2) {
  return listWeekdaysImpl(localeSorted, format2, index2, "weekdaysMin");
}
getSetGlobalLocale("en", {
  eras: [
    {
      since: "0001-01-01",
      until: Infinity,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -Infinity,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(number2) {
    var b2 = number2 % 10, output = toInt(number2 % 100 / 10) === 1 ? "th" : b2 === 1 ? "st" : b2 === 2 ? "nd" : b2 === 3 ? "rd" : "th";
    return number2 + output;
  }
});
hooks.lang = deprecate(
  "moment.lang is deprecated. Use moment.locale instead.",
  getSetGlobalLocale
);
hooks.langData = deprecate(
  "moment.langData is deprecated. Use moment.localeData instead.",
  getLocale
);
var mathAbs = Math.abs;
function abs$1() {
  var data = this._data;
  this._milliseconds = mathAbs(this._milliseconds);
  this._days = mathAbs(this._days);
  this._months = mathAbs(this._months);
  data.milliseconds = mathAbs(data.milliseconds);
  data.seconds = mathAbs(data.seconds);
  data.minutes = mathAbs(data.minutes);
  data.hours = mathAbs(data.hours);
  data.months = mathAbs(data.months);
  data.years = mathAbs(data.years);
  return this;
}
function addSubtract$1(duration2, input, value, direction) {
  var other = createDuration(input, value);
  duration2._milliseconds += direction * other._milliseconds;
  duration2._days += direction * other._days;
  duration2._months += direction * other._months;
  return duration2._bubble();
}
function add$1(input, value) {
  return addSubtract$1(this, input, value, 1);
}
function subtract$1(input, value) {
  return addSubtract$1(this, input, value, -1);
}
function absCeil(number2) {
  if (number2 < 0) {
    return Math.floor(number2);
  } else {
    return Math.ceil(number2);
  }
}
function bubble() {
  var milliseconds2 = this._milliseconds, days2 = this._days, months2 = this._months, data = this._data, seconds2, minutes2, hours2, years2, monthsFromDays;
  if (!(milliseconds2 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months2 <= 0)) {
    milliseconds2 += absCeil(monthsToDays(months2) + days2) * 864e5;
    days2 = 0;
    months2 = 0;
  }
  data.milliseconds = milliseconds2 % 1e3;
  seconds2 = absFloor(milliseconds2 / 1e3);
  data.seconds = seconds2 % 60;
  minutes2 = absFloor(seconds2 / 60);
  data.minutes = minutes2 % 60;
  hours2 = absFloor(minutes2 / 60);
  data.hours = hours2 % 24;
  days2 += absFloor(hours2 / 24);
  monthsFromDays = absFloor(daysToMonths(days2));
  months2 += monthsFromDays;
  days2 -= absCeil(monthsToDays(monthsFromDays));
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  data.days = days2;
  data.months = months2;
  data.years = years2;
  return this;
}
function daysToMonths(days2) {
  return days2 * 4800 / 146097;
}
function monthsToDays(months2) {
  return months2 * 146097 / 4800;
}
function as(units) {
  if (!this.isValid()) {
    return NaN;
  }
  var days2, months2, milliseconds2 = this._milliseconds;
  units = normalizeUnits(units);
  if (units === "month" || units === "quarter" || units === "year") {
    days2 = this._days + milliseconds2 / 864e5;
    months2 = this._months + daysToMonths(days2);
    switch (units) {
      case "month":
        return months2;
      case "quarter":
        return months2 / 3;
      case "year":
        return months2 / 12;
    }
  } else {
    days2 = this._days + Math.round(monthsToDays(this._months));
    switch (units) {
      case "week":
        return days2 / 7 + milliseconds2 / 6048e5;
      case "day":
        return days2 + milliseconds2 / 864e5;
      case "hour":
        return days2 * 24 + milliseconds2 / 36e5;
      case "minute":
        return days2 * 1440 + milliseconds2 / 6e4;
      case "second":
        return days2 * 86400 + milliseconds2 / 1e3;
      case "millisecond":
        return Math.floor(days2 * 864e5) + milliseconds2;
      default:
        throw new Error("Unknown unit " + units);
    }
  }
}
function valueOf$1() {
  if (!this.isValid()) {
    return NaN;
  }
  return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
}
function makeAs(alias) {
  return function() {
    return this.as(alias);
  };
}
var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
function clone$1() {
  return createDuration(this);
}
function get$2(units) {
  units = normalizeUnits(units);
  return this.isValid() ? this[units + "s"]() : NaN;
}
function makeGetter(name) {
  return function() {
    return this.isValid() ? this._data[name] : NaN;
  };
}
var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
function weeks() {
  return absFloor(this.days() / 7);
}
var round$1 = Math.round, thresholds = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function substituteTimeAgo(string2, number2, withoutSuffix, isFuture, locale2) {
  return locale2.relativeTime(number2 || 1, !!withoutSuffix, string2, isFuture);
}
function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale2) {
  var duration2 = createDuration(posNegDuration).abs(), seconds2 = round$1(duration2.as("s")), minutes2 = round$1(duration2.as("m")), hours2 = round$1(duration2.as("h")), days2 = round$1(duration2.as("d")), months2 = round$1(duration2.as("M")), weeks2 = round$1(duration2.as("w")), years2 = round$1(duration2.as("y")), a = seconds2 <= thresholds2.ss && ["s", seconds2] || seconds2 < thresholds2.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
  if (thresholds2.w != null) {
    a = a || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
  }
  a = a || months2 <= 1 && ["M"] || months2 < thresholds2.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
  a[2] = withoutSuffix;
  a[3] = +posNegDuration > 0;
  a[4] = locale2;
  return substituteTimeAgo.apply(null, a);
}
function getSetRelativeTimeRounding(roundingFunction) {
  if (roundingFunction === void 0) {
    return round$1;
  }
  if (typeof roundingFunction === "function") {
    round$1 = roundingFunction;
    return true;
  }
  return false;
}
function getSetRelativeTimeThreshold(threshold, limit) {
  if (thresholds[threshold] === void 0) {
    return false;
  }
  if (limit === void 0) {
    return thresholds[threshold];
  }
  thresholds[threshold] = limit;
  if (threshold === "s") {
    thresholds.ss = limit - 1;
  }
  return true;
}
function humanize(argWithSuffix, argThresholds) {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var withSuffix = false, th = thresholds, locale2, output;
  if (typeof argWithSuffix === "object") {
    argThresholds = argWithSuffix;
    argWithSuffix = false;
  }
  if (typeof argWithSuffix === "boolean") {
    withSuffix = argWithSuffix;
  }
  if (typeof argThresholds === "object") {
    th = Object.assign({}, thresholds, argThresholds);
    if (argThresholds.s != null && argThresholds.ss == null) {
      th.ss = argThresholds.s - 1;
    }
  }
  locale2 = this.localeData();
  output = relativeTime$1(this, !withSuffix, th, locale2);
  if (withSuffix) {
    output = locale2.pastFuture(+this, output);
  }
  return locale2.postformat(output);
}
var abs$1$1 = Math.abs;
function sign(x) {
  return (x > 0) - (x < 0) || +x;
}
function toISOString$1() {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var seconds2 = abs$1$1(this._milliseconds) / 1e3, days2 = abs$1$1(this._days), months2 = abs$1$1(this._months), minutes2, hours2, years2, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
  if (!total) {
    return "P0D";
  }
  minutes2 = absFloor(seconds2 / 60);
  hours2 = absFloor(minutes2 / 60);
  seconds2 %= 60;
  minutes2 %= 60;
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  s = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
  totalSign = total < 0 ? "-" : "";
  ymSign = sign(this._months) !== sign(total) ? "-" : "";
  daysSign = sign(this._days) !== sign(total) ? "-" : "";
  hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
  return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months2 ? ymSign + months2 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds2 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds2 ? hmsSign + s + "S" : "");
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1;
proto$2.abs = abs$1;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  toISOString$1
);
proto$2.lang = lang;
addFormatToken("X", 0, 0, "unix");
addFormatToken("x", 0, 0, "valueOf");
addRegexToken("x", matchSigned);
addRegexToken("X", matchTimestamp);
addParseToken("X", function(input, array, config) {
  config._d = new Date(parseFloat(input) * 1e3);
});
addParseToken("x", function(input, array, config) {
  config._d = new Date(toInt(input));
});
//! moment.js
hooks.version = "2.29.4";
setHookCallback(createLocal);
hooks.fn = proto;
hooks.min = min;
hooks.max = max;
hooks.now = now$1;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;
hooks.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const PageLoadingSpinner = () => {
  return /* @__PURE__ */ jsx("div", { style: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, children: /* @__PURE__ */ jsx(CircularProgress, { size: 60 }) });
};
const defaultOptions$1 = {};
var DocumentPurpose = /* @__PURE__ */ ((DocumentPurpose2) => {
  DocumentPurpose2["AllOwnersAccredited"] = "all_owners_accredited";
  DocumentPurpose2["AngellistEncryptedFile"] = "angellist_encrypted_file";
  DocumentPurpose2["Assets"] = "assets";
  DocumentPurpose2["CompaniesEvidenceToAct"] = "companies_evidence_to_act";
  DocumentPurpose2["CompaniesGoodStandingVerification"] = "companies_good_standing_verification";
  DocumentPurpose2["CompaniesMajorShareholderIdVerification"] = "companies_major_shareholder_id_verification";
  DocumentPurpose2["CompaniesMajorShareholderOwnershipVerification"] = "companies_major_shareholder_ownership_verification";
  DocumentPurpose2["CompaniesProofOfAddress"] = "companies_proof_of_address";
  DocumentPurpose2["CompaniesRegistrationVerification"] = "companies_registration_verification";
  DocumentPurpose2["CreditReport"] = "credit_report";
  DocumentPurpose2["Income_1YearAgo"] = "income_1_year_ago";
  DocumentPurpose2["Income_2YearsAgo"] = "income_2_years_ago";
  DocumentPurpose2["InternationalDocuments"] = "international_documents";
  DocumentPurpose2["ProofOfResidence"] = "proof_of_residence";
  DocumentPurpose2["SecureUpload"] = "secure_upload";
  DocumentPurpose2["SignatoryProofOfResidence"] = "signatory_proof_of_residence";
  DocumentPurpose2["ThirdPartyLetter"] = "third_party_letter";
  DocumentPurpose2["TrustRevocability"] = "trust_revocability";
  DocumentPurpose2["TrustsAgreementVerification"] = "trusts_agreement_verification";
  return DocumentPurpose2;
})(DocumentPurpose || {});
var EntityOrganizationKind = /* @__PURE__ */ ((EntityOrganizationKind2) => {
  EntityOrganizationKind2["Company"] = "COMPANY";
  EntityOrganizationKind2["Trust"] = "TRUST";
  return EntityOrganizationKind2;
})(EntityOrganizationKind || {});
var KycIncorporationTypes = /* @__PURE__ */ ((KycIncorporationTypes2) => {
  KycIncorporationTypes2["Corporation"] = "CORPORATION";
  KycIncorporationTypes2["Estate"] = "ESTATE";
  KycIncorporationTypes2["ExemptOrg"] = "EXEMPT_ORG";
  KycIncorporationTypes2["Limited"] = "LIMITED";
  KycIncorporationTypes2["Llc"] = "LLC";
  KycIncorporationTypes2["Llp"] = "LLP";
  KycIncorporationTypes2["Lp"] = "LP";
  KycIncorporationTypes2["Nonprofit"] = "NONPROFIT";
  KycIncorporationTypes2["Other"] = "OTHER";
  KycIncorporationTypes2["Partnership"] = "PARTNERSHIP";
  KycIncorporationTypes2["SoleProprietorship"] = "SOLE_PROPRIETORSHIP";
  KycIncorporationTypes2["SCorporation"] = "S_CORPORATION";
  KycIncorporationTypes2["Unincorporated"] = "UNINCORPORATED";
  return KycIncorporationTypes2;
})(KycIncorporationTypes || {});
var KycOnboardingStep = /* @__PURE__ */ ((KycOnboardingStep2) => {
  KycOnboardingStep2["Idv"] = "IDV";
  KycOnboardingStep2["PreIdv"] = "PRE_IDV";
  KycOnboardingStep2["Status"] = "STATUS";
  return KycOnboardingStep2;
})(KycOnboardingStep || {});
var ProductEligibilityProductName = /* @__PURE__ */ ((ProductEligibilityProductName2) => {
  ProductEligibilityProductName2["Wallet"] = "WALLET";
  return ProductEligibilityProductName2;
})(ProductEligibilityProductName || {});
var ProductEligibilityProductStatus = /* @__PURE__ */ ((ProductEligibilityProductStatus2) => {
  ProductEligibilityProductStatus2["Approved"] = "APPROVED";
  ProductEligibilityProductStatus2["Incomplete"] = "INCOMPLETE";
  ProductEligibilityProductStatus2["NotStarted"] = "NOT_STARTED";
  ProductEligibilityProductStatus2["Offboarded"] = "OFFBOARDED";
  ProductEligibilityProductStatus2["Pending"] = "PENDING";
  ProductEligibilityProductStatus2["PendingReverificationReview"] = "PENDING_REVERIFICATION_REVIEW";
  ProductEligibilityProductStatus2["Rejected"] = "REJECTED";
  ProductEligibilityProductStatus2["Reverifying"] = "REVERIFYING";
  ProductEligibilityProductStatus2["UnapprovedAfterZero"] = "UNAPPROVED_AFTER_ZERO";
  return ProductEligibilityProductStatus2;
})(ProductEligibilityProductStatus || {});
var ProductEligibilityQualificationName = /* @__PURE__ */ ((ProductEligibilityQualificationName2) => {
  ProductEligibilityQualificationName2["IdentityVerified"] = "identity_verified";
  ProductEligibilityQualificationName2["MfaQualification"] = "mfa_qualification";
  ProductEligibilityQualificationName2["ProofOfResidenceQualification"] = "proof_of_residence_qualification";
  ProductEligibilityQualificationName2["SupportedJurisdiction"] = "supported_jurisdiction";
  ProductEligibilityQualificationName2["WalletApplicationSubmissionQualification"] = "wallet_application_submission_qualification";
  return ProductEligibilityQualificationName2;
})(ProductEligibilityQualificationName || {});
var ProductEligibilityQualificationStatus = /* @__PURE__ */ ((ProductEligibilityQualificationStatus2) => {
  ProductEligibilityQualificationStatus2["ActionRequired"] = "ACTION_REQUIRED";
  ProductEligibilityQualificationStatus2["Failed"] = "FAILED";
  ProductEligibilityQualificationStatus2["Pending"] = "PENDING";
  ProductEligibilityQualificationStatus2["Success"] = "SUCCESS";
  return ProductEligibilityQualificationStatus2;
})(ProductEligibilityQualificationStatus || {});
const CreateQuoteFragmentDoc = gql`
  fragment CreateQuote on Quote {
    coinlistFeeAmount
    expiresAtIso
    id
    price
  }
`;
const StakingVaultDepositFragmentDoc = gql`
  fragment StakingVaultDeposit on StakingVaultDeposit {
    createdAt
    depositAmount
    id
    state
    errors
  }
`;
const WithdrawRequestFragmentDoc = gql`
  fragment WithdrawRequest on WithdrawRequest {
    address
    amount
    assetFee
    createdAt
    fiatFee
    id
    state
  }
`;
const CounterAssetFragmentDoc = gql`
  fragment CounterAsset on Asset {
    name
    symbol
    id
    logoUrl
    price
  }
`;
const LockedStakingVaultFragmentDoc = gql`
  fragment LockedStakingVault on LockedStakingVault {
    __typename
    id
    apy
    endDateIso
    lockupDays
    minDeposit
    startDateIso
  }
`;
const AutoStakingVaultFragmentDoc = gql`
  fragment AutoStakingVault on AutoStakingVault {
    __typename
    apy
  }
`;
const AssetDetailsAssetFragmentDoc = gql`
  fragment AssetDetailsAsset on Asset {
    name
    symbol
    logoUrl
    price
    dailyChange
    counterAssets(entity: $entityId) {
      ...CounterAsset
    }
    priceHistory(
      startTime: $priceHistoryStartTime
      endTime: $priceHistoryEndTime
      interval: $priceHistoryInterval
    ) {
      date
      dateIso
      value
    }
    stakingVaults(entityId: $entityId) {
      ...LockedStakingVault
      ...AutoStakingVault
    }
  }
  ${CounterAssetFragmentDoc}
  ${LockedStakingVaultFragmentDoc}
  ${AutoStakingVaultFragmentDoc}
`;
const AssetFragmentDoc = gql`
  fragment Asset on Asset {
    name
    symbol
    logoUrl
    price
    dailyChange
    stakingVaults(entityId: $entityId) {
      ... on AutoStakingVault {
        apy
      }
    }
  }
`;
const AssetSaleInfoFragmentDoc = gql`
  fragment AssetSaleInfo on Asset {
    name
    symbol
    price
    logoUrl
    saleInfo {
      investmentReturnPercentage
      closedAt
    }
  }
`;
const EntityInfoFragmentDoc = gql`
  fragment EntityInfo on Entity {
    id
    name
  }
`;
const AccountHoldingInfoFragmentDoc = gql`
  fragment AccountHoldingInfo on AccountsHolding {
    balance
    fiatBalance
    asset {
      symbol
      name
    }
  }
`;
const UserStakingInfoFragmentDoc = gql`
  fragment UserStakingInfo on AccountsStaking {
    id
    apy
    asset {
      symbol
      name
    }
    balance
    fiatBalance
  }
`;
const QuestionFieldsFragmentDoc = gql`
  fragment questionFields on Questionnaire {
    slug
    questions {
      slug
      name
      order
      answerType
      displayAs
      isOptional
      shouldAllowMultipleAnswers
      text
      tooltipText
      choices {
        id
        text
        order
      }
    }
  }
`;
gql`
  mutation acceptQuote($entityId: ID!, $rfqId: ID!) {
    quoteAccept(input: { entityId: $entityId, rfqId: $rfqId }) {
      success
      errors {
        message
      }
    }
  }
`;
const CreateAuthorizedSignatoryDocument = gql`
  mutation createAuthorizedSignatory(
    $title: String!
    $ownerId: String!
    $firstName: String!
    $middleName: String!
    $lastName: String!
    $phoneNumber: String!
    $dateOfBirth: String!
    $stateIdentifier: String!
    $city: String!
    $region: String!
    $country: String!
    $postalCode: String!
    $streetAddress: String!
  ) {
    createAuthorizedSignatory(
      input: {
        ownerId: $ownerId
        firstName: $firstName
        middleName: $middleName
        lastName: $lastName
        phoneNumber: $phoneNumber
        dob: $dateOfBirth
        stateIdentifier: $stateIdentifier
        city: $city
        region: $region
        country: $country
        postalCode: $postalCode
        streetAddress: $streetAddress
        title: $title
      }
    ) {
      success
      errors {
        message
      }
    }
  }
`;
function useCreateAuthorizedSignatoryMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(CreateAuthorizedSignatoryDocument, options);
}
const CreateBeneficiaryDocument = gql`
  mutation createBeneficiary(
    $ownerId: String!
    $firstName: String!
    $middleName: String!
    $lastName: String!
    $phoneNumber: String!
    $dateOfBirth: String!
    $stateIdentifier: String!
    $city: String!
    $region: String!
    $country: String!
    $postalCode: String!
    $streetAddress: String!
  ) {
    createBeneficiary(
      input: {
        ownerId: $ownerId
        firstName: $firstName
        middleName: $middleName
        lastName: $lastName
        phoneNumber: $phoneNumber
        dob: $dateOfBirth
        stateIdentifier: $stateIdentifier
        city: $city
        region: $region
        country: $country
        postalCode: $postalCode
        streetAddress: $streetAddress
      }
    ) {
      success
      errors {
        message
      }
      result {
        relatedPersonId
      }
    }
  }
`;
function useCreateBeneficiaryMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(CreateBeneficiaryDocument, options);
}
const EntityCreateOrganizationDocument = gql`
  mutation entityCreateOrganization(
    $name: String!
    $kind: EntityOrganizationKind!
    $offeringSlug: String!
  ) {
    entityCreateOrganization(
      input: { name: $name, kind: $kind, offeringSlug: $offeringSlug }
    ) {
      success
      errors {
        message
      }
      result {
        id
      }
    }
  }
`;
function useEntityCreateOrganizationMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(EntityCreateOrganizationDocument, options);
}
const CreatePersonEntityDocument = gql`
  mutation createPersonEntity(
    $firstName: String!
    $lastName: String!
    $offeringSlug: String!
  ) {
    createPersonEntity(
      input: {
        firstName: $firstName
        lastName: $lastName
        offeringSlug: $offeringSlug
      }
    ) {
      success
      errors {
        message
      }
      result {
        id
      }
    }
  }
`;
function useCreatePersonEntityMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(CreatePersonEntityDocument, options);
}
gql`
  mutation createQuote(
    $entityId: String!
    $baseAssetSymbol: String!
    $counterAssetSymbol: String!
    $primaryAssetAmount: Float!
    $primaryAssetSymbol: String!
    $side: QuoteSide!
  ) {
    quoteCreate(
      input: {
        entityId: $entityId
        baseAssetSymbol: $baseAssetSymbol
        counterAssetSymbol: $counterAssetSymbol
        primaryAssetAmount: $primaryAssetAmount
        primaryAssetSymbol: $primaryAssetSymbol
        side: $side
      }
    ) {
      success
      result {
        ...CreateQuote
      }
      errors {
        message
      }
    }
  }
  ${CreateQuoteFragmentDoc}
`;
gql`
  mutation createStakingDeposit($entity: ID!, $vault: ID!, $amount: Money!) {
    stakingVaultDepositCreate(
      input: { entity: $entity, vault: $vault, amount: $amount }
    ) {
      success
      result {
        ...StakingVaultDeposit
      }
      errors {
        message
      }
    }
  }
  ${StakingVaultDepositFragmentDoc}
`;
const DeleteBeneficiaryDocument = gql`
  mutation deleteBeneficiary($beneficiaryId: String!) {
    deleteBeneficiary(input: { beneficiaryId: $beneficiaryId }) {
      success
      errors {
        message
      }
    }
  }
`;
function useDeleteBeneficiaryMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(DeleteBeneficiaryDocument, options);
}
const EditAuthorizedSignatoryDocument = gql`
  mutation editAuthorizedSignatory(
    $title: String!
    $ownerId: String!
    $firstName: String!
    $middleName: String!
    $lastName: String!
    $phoneNumber: String!
    $dateOfBirth: String!
    $stateIdentifier: String!
    $city: String!
    $region: String!
    $country: String!
    $postalCode: String!
    $streetAddress: String!
  ) {
    editAuthorizedSignatory(
      input: {
        entity: $ownerId
        firstName: $firstName
        middleName: $middleName
        lastName: $lastName
        phoneNumber: $phoneNumber
        dob: $dateOfBirth
        stateIdentifier: $stateIdentifier
        city: $city
        region: $region
        country: $country
        postalCode: $postalCode
        streetAddress: $streetAddress
        title: $title
      }
    ) {
      success
      errors {
        message
      }
    }
  }
`;
function useEditAuthorizedSignatoryMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(EditAuthorizedSignatoryDocument, options);
}
const EditBeneficiaryDocument = gql`
  mutation editBeneficiary(
    $beneficiaryId: String!
    $firstName: String!
    $middleName: String!
    $lastName: String!
    $phoneNumber: String!
    $dateOfBirth: String!
    $stateIdentifier: String!
    $city: String!
    $region: String!
    $country: String!
    $postalCode: String!
    $streetAddress: String!
  ) {
    editBeneficiary(
      input: {
        beneficiaryId: $beneficiaryId
        firstName: $firstName
        middleName: $middleName
        lastName: $lastName
        phoneNumber: $phoneNumber
        dob: $dateOfBirth
        stateIdentifier: $stateIdentifier
        city: $city
        region: $region
        country: $country
        postalCode: $postalCode
        streetAddress: $streetAddress
      }
    ) {
      success
      errors {
        message
      }
      result {
        relatedPersonId
      }
    }
  }
`;
function useEditBeneficiaryMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(EditBeneficiaryDocument, options);
}
const FinalizeKybDocument = gql`
  mutation finalizeKyb($entityId: ID!) {
    finalizeKyb(input: { entity: $entityId }) {
      success
      errors {
        message
      }
    }
  }
`;
function useFinalizeKybMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(
    FinalizeKybDocument,
    options
  );
}
const FinalizeKycBasicDetailsDocument = gql`
  mutation finalizeKycBasicDetails($entityId: ID!) {
    finalizeBasicDetails(input: { entity: $entityId }) {
      success
      errors {
        message
      }
    }
  }
`;
function useFinalizeKycBasicDetailsMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(FinalizeKycBasicDetailsDocument, options);
}
gql`
  mutation finalizeWithdraw($entityId: ID!, $withdrawRequestId: ID!) {
    withdrawRequestAccept(
      input: { entityId: $entityId, withdrawRequestId: $withdrawRequestId }
    ) {
      success
      errors {
        message
      }
    }
  }
`;
gql`
  mutation previewWithdraw(
    $entityId: String!
    $destinationAddress: String!
    $amount: Money!
  ) {
    withdrawRequestCreate(
      input: {
        entityId: $entityId
        destinationAddress: $destinationAddress
        amount: $amount
      }
    ) {
      success
      result {
        ...WithdrawRequest
      }
      errors {
        message
      }
    }
  }
  ${WithdrawRequestFragmentDoc}
`;
const SubmitKybDocumentationCompanyDocument = gql`
  mutation submitKybDocumentationCompany(
    $entity: String!
    $legalName: String!
    $dbaName: String!
    $incorporationInfo: KycUpsertBusinessInfoIncorporationInfoInput!
    $businessOpsAddress: KycUpsertBusinessInfoBusinessOperationsAddressInput!
    $companyProfileSurvey: [KycUpsertBusinessInfoQuestionnaireAnswerInput!]!
  ) {
    upsertBusinessInfo(
      input: {
        entity: $entity
        legalName: $legalName
        dbaName: $dbaName
        incorporationInfo: $incorporationInfo
        businessOpsAddress: $businessOpsAddress
        companyProfileSurvey: $companyProfileSurvey
      }
    ) {
      success
      errors {
        message
      }
    }
  }
`;
function useSubmitKybDocumentationCompanyMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(SubmitKybDocumentationCompanyDocument, options);
}
const SubmitKybDocumentationTrustDocument = gql`
  mutation submitKybDocumentationTrust(
    $entity: String!
    $legalName: String!
    $incorporationInfo: KycUpsertBusinessInfoIncorporationInfoInput!
    $businessOpsAddress: KycUpsertBusinessInfoBusinessOperationsAddressInput!
  ) {
    upsertBusinessInfo(
      input: {
        entity: $entity
        legalName: $legalName
        incorporationInfo: $incorporationInfo
        businessOpsAddress: $businessOpsAddress
      }
    ) {
      success
      errors {
        message
      }
    }
  }
`;
function useSubmitKybDocumentationTrustMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(SubmitKybDocumentationTrustDocument, options);
}
const UploadDocumentDocument = gql`
  mutation uploadDocument(
    $fileContent: String!
    $fileName: String!
    $docCategory: String!
    $ownerEntityId: String!
    $country: String
    $state: String
  ) {
    uploadDocument(
      input: {
        fileContent: $fileContent
        fileName: $fileName
        docCategory: $docCategory
        ownerEntityId: $ownerEntityId
        country: $country
        state: $state
      }
    ) {
      success
      errors {
        message
      }
    }
  }
`;
function useUploadDocumentMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(UploadDocumentDocument, options);
}
const UpsertAccountUsageSurveyDocument = gql`
  mutation upsertAccountUsageSurvey(
    $entity: String!
    $submission: [KycUpsertAccountUsageSurveyQuestionnaireAnswerInput!]!
  ) {
    upsertAccountUsageSurvey(
      input: { entity: $entity, submission: $submission }
    ) {
      success
      errors {
        message
      }
    }
  }
`;
function useUpsertAccountUsageSurveyMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(UpsertAccountUsageSurveyDocument, options);
}
const UpsertKycBasicDetailsDocument = gql`
  mutation upsertKycBasicDetails(
    $entityId: String!
    $firstName: String
    $lastName: String
    $occupation: String
    $phoneNumber: String
    $stateIdentifier: String
    $streetAddress: String
    $city: String
    $region: String
    $country: String
    $zipcode: String
    $dateOfBirth: String
  ) {
    upsertBasicDetails(
      input: {
        entity: $entityId
        firstName: $firstName
        lastName: $lastName
        occupation: $occupation
        phoneNumber: $phoneNumber
        stateIdentifier: $stateIdentifier
        streetAddress: $streetAddress
        dob: $dateOfBirth
        city: $city
        state: $region
        country: $country
        zipcode: $zipcode
      }
    ) {
      success
      errors {
        message
      }
    }
  }
`;
function useUpsertKycBasicDetailsMutation(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useMutation(UpsertKycBasicDetailsDocument, options);
}
const AccountUsageSubmissionDocument = gql`
  query accountUsageSubmission($entityId: String!) {
    me {
      entity(id: $entityId) {
        id
        kyc {
          ... on KycOrganization {
            accountUsageSurvey {
              questionSlug
              answers
            }
          }
        }
      }
    }
  }
`;
function useAccountUsageSubmissionQuery(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useQuery(AccountUsageSubmissionDocument, options);
}
gql`
  query asset($symbol: String!) {
    asset(symbol: $symbol) {
      name
      symbol
      price
      logoUrl
    }
  }
`;
gql`
  query assetDetails(
    $symbol: String!
    $entityId: ID!
    $priceHistoryStartTime: Time!
    $priceHistoryEndTime: Time
    $priceHistoryInterval: ChartDataInterval!
  ) {
    asset(symbol: $symbol) {
      ...AssetDetailsAsset
    }
    me {
      entities(ids: [$entityId]) {
        id
        accounts {
          holding(assets: [$symbol]) {
            balance
            fiatBalance
            asset {
              symbol
              name
            }
            transactions {
              edges {
                node {
                  description
                  amount
                  status
                  category
                  createdAt
                }
                cursor
              }
            }
          }
          staking(assets: [$symbol]) {
            id
            apy
            asset {
              symbol
              name
            }
            balance
            fiatBalance
          }
        }
      }
    }
  }
  ${AssetDetailsAssetFragmentDoc}
`;
gql`
  query assets($entityId: ID!) {
    assets {
      ...Asset
    }
  }
  ${AssetFragmentDoc}
`;
gql`
  query assetsForStaking($entityId: ID!) {
    assets {
      name
      symbol
      price
      stakingVaults(entityId: $entityId) {
        ... on LockedStakingVault {
          apy
          endDate
          lockupDays
          minDeposit
          startDate
        }
      }
    }
  }
`;
gql`
  query assetsSaleInfo {
    assets {
      ...AssetSaleInfo
    }
  }
  ${AssetSaleInfoFragmentDoc}
`;
const AuthorizedSignatoryDocument = gql`
  query authorizedSignatory($entityId: String!) {
    me {
      entity(id: $entityId) {
        id
        kyc {
          ... on KycOrganization {
            authorizedSignatory {
              title
              firstName
              middleName
              lastName
              phoneNumber
              dob
              streetAddress
              city
              region
              country
              zipcode
              stateIdentifier
              idv {
                isSubmitted
                url
              }
            }
          }
        }
      }
    }
  }
`;
function useAuthorizedSignatoryQuery(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useQuery(AuthorizedSignatoryDocument, options);
}
gql`
  query balanceHistory(
    $startTime: Time!
    $endTime: Time
    $interval: ChartDataInterval!
  ) {
    me {
      entities {
        id
        balanceHistory(
          startTime: $startTime
          endTime: $endTime
          interval: $interval
        ) {
          date
          value
        }
      }
    }
  }
`;
const BeneficiariesDocument = gql`
  query beneficiaries($entityId: String!) {
    me {
      entity(id: $entityId) {
        id
        kyc {
          ... on KycOrganization {
            beneficiaries {
              firstName
              middleName
              lastName
              relatedPersonId
            }
          }
        }
      }
    }
  }
`;
function useBeneficiariesQuery(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useQuery(
    BeneficiariesDocument,
    options
  );
}
const BeneficiaryDetailsDocument = gql`
  query beneficiaryDetails($entityId: String!, $beneficiaryId: ID!) {
    me {
      entity(id: $entityId) {
        id
        kyc {
          ... on KycOrganization {
            beneficiary(id: $beneficiaryId) {
              firstName
              middleName
              lastName
              phoneNumber
              dob
              streetAddress
              city
              region
              country
              zipcode
              stateIdentifier
              relatedPersonId
            }
          }
        }
      }
    }
  }
`;
function useBeneficiaryDetailsQuery(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useQuery(BeneficiaryDetailsDocument, options);
}
const CurrentOnboardingStepDocument = gql`
  query currentOnboardingStep($entityId: String!) {
    me {
      entity(id: $entityId) {
        id
        kyc {
          ... on KycIndividual {
            currentStep
          }
          ... on KycOrganization {
            currentStep
          }
        }
      }
    }
  }
`;
function useCurrentOnboardingStepQuery(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useQuery(CurrentOnboardingStepDocument, options);
}
gql`
  query entitiesInfo {
    me {
      id
      name
      entities {
        ...EntityInfo
      }
    }
  }
  ${EntityInfoFragmentDoc}
`;
gql`
  query entityAccountHoldings($entityId: ID!) {
    me {
      entities(ids: [$entityId]) {
        id
        name
        accounts {
          holding {
            ...AccountHoldingInfo
          }
        }
      }
    }
  }
  ${AccountHoldingInfoFragmentDoc}
`;
gql`
  query entityBalanceHistory(
    $entityId: ID!
    $balanceHistoryStartTime: Time!
    $balanceHistoryEndTime: Time
    $balanceHistoryInterval: ChartDataInterval!
  ) {
    me {
      entities(ids: [$entityId]) {
        id
        balanceHistory(
          startTime: $balanceHistoryStartTime
          endTime: $balanceHistoryEndTime
          interval: $balanceHistoryInterval
        ) {
          date
          value
        }
      }
    }
  }
`;
gql`
  query entityHoldingsAndBalances(
    $entityId: ID!
    $balanceHistoryStartTime: Time!
    $balanceHistoryEndTime: Time
    $balanceHistoryInterval: ChartDataInterval!
  ) {
    me {
      entities(ids: [$entityId]) {
        id
        name
        accounts {
          holding {
            balance
            fiatBalance
            asset {
              symbol
              name
            }
          }
        }
        balanceHistory(
          startTime: $balanceHistoryStartTime
          endTime: $balanceHistoryEndTime
          interval: $balanceHistoryInterval
        ) {
          dateIso
          value
        }
      }
    }
  }
`;
const EntityKycDocumentsDocument = gql`
  query entityKycDocuments($entityId: String!) {
    me {
      entity(id: $entityId) {
        id
        kyc {
          ... on KycOrganization {
            documents {
              id
              filename
              category
              ownerEntityId
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
`;
function useEntityKycDocumentsQuery(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useQuery(EntityKycDocumentsDocument, options);
}
const ProductEligibilityDocument = gql`
  query productEligibility($entityId: String!) {
    me {
      entity(id: $entityId) {
        id
        latestRegisteredOffering {
          url
          name
        }
        kyc {
          ... on KycOrganization {
            currentStep
            applicationSubmitted
            idvStepSubmitted
            reverification {
              isReverifying
              isAccountRestricted
              readyToRestrictAccountAt
              softDeadlineAt
              isFinalized
              finalizationStatus
            }
          }
          ... on KycIndividual {
            currentStep
            applicationSubmitted
            idvStepSubmitted
            reverification {
              isReverifying
              isAccountRestricted
              readyToRestrictAccountAt
              softDeadlineAt
              isFinalized
              finalizationStatus
            }
          }
        }
        productEligibility {
          productStatuses {
            productName
            status
            neededQualifications
          }
          qualifications {
            name
            nameForDisplay
            isApplicable
            qualificationStatus
            shouldDisplayInStatusPage
            notesForStatusPage
            callToActionUrl
            callToActionLabel
          }
        }
      }
    }
  }
`;
function useProductEligibilityQuery(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useQuery(ProductEligibilityDocument, options);
}
gql`
  query entityStakingVault($entityId: ID!) {
    me {
      entities(ids: [$entityId]) {
        id
        accounts {
          staking {
            ...UserStakingInfo
          }
        }
      }
    }
  }
  ${UserStakingInfoFragmentDoc}
`;
gql`
  query offering($offeringSlug: String!, $entityId: ID!) {
    offering(slug: $offeringSlug, entity: $entityId) {
      id
      slug
      issuerName
      name
      createdAt
    }
  }
`;
const OrganizationKycInfoDocument = gql`
  query organizationKycInfo($entityId: String!) {
    me {
      entity(id: $entityId) {
        id
        latestRegisteredOffering {
          name
          url
        }
        kyc {
          ... on KycOrganization {
            kind
            legalName
            dbaName
            companyProfileSurvey {
              questionSlug
              answers
            }
            incorporationInfo {
              incorporationType
              incorporatedOn
              countryOfIncorporation
              regionOfIncorporation
              taxIdNumber
            }
            businessOpsAddress {
              streetAddress
              postalCode
              country
              city
              region
            }
          }
        }
      }
    }
  }
`;
function useOrganizationKycInfoQuery(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useQuery(OrganizationKycInfoDocument, options);
}
const OrganizationKycQuestionnairesDocument = gql`
  query organizationKycQuestionnaires {
    accountUsageCompany: questionnaire(slug: "account_usage_company") {
      ...questionFields
    }
    profileCompany: questionnaire(slug: "profile_company") {
      ...questionFields
    }
  }
  ${QuestionFieldsFragmentDoc}
`;
function useOrganizationKycQuestionnairesQuery(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useQuery(OrganizationKycQuestionnairesDocument, options);
}
const PersonKycBasicDetailsDocument = gql`
  query personKycBasicDetails($entityId: String!) {
    me {
      entity(id: $entityId) {
        id
        latestRegisteredOffering {
          url
          name
        }
        kyc {
          ... on KycIndividual {
            basicDetails {
              firstName
              lastName
              dob
              stateIdentifier
              phoneNumber
              occupation
              streetAddress
              city
              state
              country
              zipcode
            }
            documents {
              id
              filename
              category
              ownerEntityId
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
`;
function usePersonKycBasicDetailsQuery(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useQuery(PersonKycBasicDetailsDocument, options);
}
gql`
  query personKycStatus($entityId: String!) {
    me {
      entity(id: $entityId) {
        id
        kyc {
          ... on KycIndividual {
            status
          }
        }
      }
    }
  }
`;
gql`
  query priceHistory(
    $symbol: String!
    $startTime: Time!
    $endTime: Time
    $interval: ChartDataInterval!
  ) {
    asset(symbol: $symbol) {
      symbol
      priceHistory(
        startTime: $startTime
        endTime: $endTime
        interval: $interval
      ) {
        date
        dateIso
        value
      }
    }
  }
`;
gql`
  query saleInfoAndHoldings(
    $entityId: ID!
    $balanceHistoryStartTime: Time!
    $balanceHistoryEndTime: Time
    $balanceHistoryInterval: ChartDataInterval!
  ) {
    me {
      entities(ids: [$entityId]) {
        id
        name
        accounts {
          holding {
            balance
            fiatBalance
            asset {
              symbol
              name
            }
          }
        }
        balanceHistory(
          startTime: $balanceHistoryStartTime
          endTime: $balanceHistoryEndTime
          interval: $balanceHistoryInterval
        ) {
          dateIso
          value
        }
      }
    }
    assets {
      name
      symbol
      price
      logoUrl
      saleInfo {
        investmentReturnPercentage
        closedAt
      }
    }
  }
`;
gql`
  query simpleUser {
    me {
      email
      name
    }
  }
`;
gql`
  query userInfo(
    $entityId: ID!
    $balanceHistoryStartTime: Time!
    $balanceHistoryEndTime: Time
    $balanceHistoryInterval: ChartDataInterval!
  ) {
    me {
      email
      name
      entities(ids: [$entityId]) {
        id
        name
        accounts {
          holding {
            balance
            fiatBalance
            asset {
              symbol
              name
            }
            depositAddress
            transactions {
              edges {
                node {
                  description
                  amount
                  status
                  category
                  createdAt
                }
                cursor
              }
            }
          }
          staking {
            ...UserStakingInfo
          }
        }
        balanceHistory(
          startTime: $balanceHistoryStartTime
          endTime: $balanceHistoryEndTime
          interval: $balanceHistoryInterval
        ) {
          date
          value
        }
      }
    }
  }
  ${UserStakingInfoFragmentDoc}
`;
const UserNameAndEntityCountDocument = gql`
  query userNameAndEntityCount {
    me {
      firstName
      lastName
      entityCount
    }
  }
`;
function useUserNameAndEntityCountQuery(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useQuery(UserNameAndEntityCountDocument, options);
}
gql`
  query userTransactionAndAssetInfo($entityId: ID!, $assetSymbol: String!) {
    me {
      id
      entities(ids: [$entityId]) {
        id
        accounts {
          holding(assets: [$assetSymbol]) {
            transactions {
              edges {
                node {
                  description
                  amount
                  status
                  category
                  createdAt
                }
                cursor
              }
            }
          }
        }
      }
    }
    asset(symbol: $assetSymbol) {
      name
      symbol
      logoUrl
    }
  }
`;
gql`
  query userTransactionForSymbol($entityId: ID!, $assetSymbol: String!) {
    me {
      id
      entities(ids: [$entityId]) {
        id
        accounts {
          holding(assets: [$assetSymbol]) {
            fiatBalance
            balance
            transactions {
              edges {
                node {
                  description
                  amount
                  status
                  category
                  createdAt
                }
                cursor
              }
            }
          }
        }
      }
    }
  }
`;
const VeriffIdvSessionDocument = gql`
  query veriffIdvSession($entityId: String!) {
    me {
      entity(id: $entityId) {
        id
        kyc {
          ... on KycIndividual {
            idv {
              isSubmitted
              url
            }
          }
        }
      }
    }
  }
`;
function useVeriffIdvSessionQuery(baseOptions) {
  const options = __spreadValues(__spreadValues({}, defaultOptions$1), baseOptions);
  return Apollo.useQuery(
    VeriffIdvSessionDocument,
    options
  );
}
const KycIncorporationTypesDescriptions = {
  CORPORATION: "Corporation",
  ESTATE: "Estate",
  EXEMPT_ORG: "Exempt organization",
  LIMITED: "Limited Company (Pte., or Ltd.)",
  LLC: "Limited Liability company (LLC)",
  LLP: "Limited Liability partnership (LLP)",
  LP: "Limited partnership",
  NONPROFIT: "Nonprofit corporation",
  OTHER: "Other",
  PARTNERSHIP: "Partnership",
  SOLE_PROPRIETORSHIP: "Sole proprietorship",
  S_CORPORATION: "S-Corporation",
  UNINCORPORATED: "Unincorporated Entity or Association"
};
const SvgReverifyClock = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: 22, height: 22, fill: "none", viewBox: "0 0 18 17" }, props), /* @__PURE__ */ React.createElement("path", { fill: "#000", d: "M5.047 9.336a.605.605 0 0 1-.445-.18.605.605 0 0 1-.18-.445.58.58 0 0 1 .18-.438c.12-.12.268-.18.445-.18h3.32v-4.5c0-.171.06-.317.18-.437s.265-.18.437-.18c.177 0 .326.06.446.18s.18.266.18.438V8.71c0 .177-.06.325-.18.445a.605.605 0 0 1-.446.18H5.047Zm3.945 7.094a7.757 7.757 0 0 1-3.117-.633 8.14 8.14 0 0 1-2.578-1.742 8.316 8.316 0 0 1-1.742-2.578 7.758 7.758 0 0 1-.633-3.118c0-1.104.21-2.143.633-3.117A8.275 8.275 0 0 1 5.868.922 7.758 7.758 0 0 1 8.983.289c1.11 0 2.151.211 3.125.633a8.25 8.25 0 0 1 2.579 1.75 8.156 8.156 0 0 1 1.75 2.57c.421.974.632 2.013.632 3.117 0 1.105-.21 2.144-.633 3.118a8.25 8.25 0 0 1-4.328 4.32 7.757 7.757 0 0 1-3.117.633Zm0-1.594a6.36 6.36 0 0 0 2.524-.5 6.488 6.488 0 0 0 2.062-1.39 6.49 6.49 0 0 0 1.39-2.063c.334-.781.5-1.623.5-2.524 0-.895-.166-1.734-.5-2.515a6.468 6.468 0 0 0-3.46-3.461 6.362 6.362 0 0 0-2.524-.5c-.895 0-1.737.166-2.523.5a6.4 6.4 0 0 0-2.055 1.39 6.531 6.531 0 0 0-1.383 2.07c-.333.782-.5 1.62-.5 2.516 0 .901.167 1.743.5 2.524a6.554 6.554 0 0 0 1.383 2.062 6.398 6.398 0 0 0 4.586 1.89Z" }));
const SvgReverifyInstitution = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: 22, height: 22, fill: "none", viewBox: "0 0 18 17" }, props), /* @__PURE__ */ React.createElement("path", { fill: "#000", d: "M.477 15.945c0-.192.07-.36.21-.5.141-.14.308-.21.5-.21h15.61c.198 0 .367.07.508.21.14.14.21.308.21.5 0 .198-.07.367-.21.508a.68.68 0 0 1-.508.219H1.187a.671.671 0 0 1-.5-.219.692.692 0 0 1-.21-.508Zm1.351-8.89v-.196c0-.177.05-.317.149-.421a.58.58 0 0 1 .43-.157h1.937c.187 0 .333.052.437.157a.57.57 0 0 1 .157.421v.196a.57.57 0 0 1-.157.422c-.104.104-.25.156-.437.156H2.406a.58.58 0 0 1-.43-.156.587.587 0 0 1-.148-.422Zm.875 6.484V7.07h1.352v6.47H2.703Zm-.875.406v-.195c0-.177.05-.318.149-.422a.58.58 0 0 1 .43-.156h1.937c.187 0 .333.052.437.156a.57.57 0 0 1 .157.422v.195a.58.58 0 0 1-.157.43c-.104.104-.25.156-.437.156H2.406a.58.58 0 0 1-.43-.156c-.098-.104-.148-.247-.148-.43Zm3.758-6.89v-.196a.57.57 0 0 1 .156-.421.58.58 0 0 1 .43-.157h1.937a.58.58 0 0 1 .43.157.57.57 0 0 1 .156.421v.196a.57.57 0 0 1-.156.422.58.58 0 0 1-.43.156H6.172a.58.58 0 0 1-.43-.156.57.57 0 0 1-.156-.422Zm.89 6.484V7.07h1.352v6.47H6.477Zm-.89.406v-.195a.57.57 0 0 1 .156-.422.58.58 0 0 1 .43-.156h1.937a.58.58 0 0 1 .43.156.57.57 0 0 1 .156.422v.195a.58.58 0 0 1-.156.43.58.58 0 0 1-.43.156H6.172a.58.58 0 0 1-.43-.156.58.58 0 0 1-.156-.43Zm3.773-6.89v-.196a.57.57 0 0 1 .157-.421.58.58 0 0 1 .43-.157h1.937a.58.58 0 0 1 .43.157.57.57 0 0 1 .156.421v.196a.57.57 0 0 1-.156.422.58.58 0 0 1-.43.156H9.945a.58.58 0 0 1-.43-.156.57.57 0 0 1-.156-.422Zm.883 6.484V7.07h1.352v6.47h-1.352Zm-.883.406v-.195a.57.57 0 0 1 .157-.422.58.58 0 0 1 .43-.156h1.937c.182 0 .325.052.43.156a.57.57 0 0 1 .156.422v.195a.58.58 0 0 1-.156.43.58.58 0 0 1-.43.156H9.945a.58.58 0 0 1-.43-.156.58.58 0 0 1-.156-.43Zm3.766-6.89v-.196a.57.57 0 0 1 .156-.421.58.58 0 0 1 .43-.157h1.937a.58.58 0 0 1 .43.157.57.57 0 0 1 .156.421v.196a.57.57 0 0 1-.156.422.58.58 0 0 1-.43.156h-1.937a.58.58 0 0 1-.43-.156.57.57 0 0 1-.156-.422Zm.883 6.484V7.07h1.351v6.47h-1.351Zm-.883.406v-.195a.57.57 0 0 1 .156-.422.581.581 0 0 1 .43-.156h1.937a.58.58 0 0 1 .43.156.57.57 0 0 1 .156.422v.195a.58.58 0 0 1-.156.43c-.104.104-.247.156-.43.156h-1.937a.58.58 0 0 1-.43-.156.581.581 0 0 1-.156-.43Zm-11.5-8.36c-.24 0-.427-.07-.563-.21a.714.714 0 0 1-.203-.5c0-.146.037-.276.11-.39.078-.115.195-.217.351-.305L7.992.336a1.995 1.995 0 0 1 1-.281c.339 0 .675.093 1.008.28l6.672 3.845c.15.088.263.19.336.304a.714.714 0 0 1-.086.89c-.13.142-.318.212-.563.212H1.625Z" }));
const SvgReverifyLock = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: 22, height: 22, fill: "none", viewBox: "0 0 12 16" }, props), /* @__PURE__ */ React.createElement("path", { fill: "#000", d: "M2.344 15.945c-.594 0-1.045-.161-1.352-.484-.307-.318-.46-.797-.46-1.438V8.484c0-.635.153-1.112.46-1.43.307-.317.758-.476 1.352-.476h7.312c.594 0 1.044.159 1.352.477.307.317.46.794.46 1.43v5.538c0 .641-.153 1.12-.46 1.438-.307.323-.758.484-1.352.484H2.344Zm-.383-8.71V4.75c0-.964.187-1.768.562-2.414.38-.651.878-1.14 1.493-1.469A4.15 4.15 0 0 1 6 .375c.708 0 1.37.164 1.984.492.615.328 1.11.818 1.485 1.469.38.646.57 1.45.57 2.414v2.484H8.58V4.602c0-.61-.12-1.123-.36-1.54a2.415 2.415 0 0 0-.938-.96A2.578 2.578 0 0 0 6 1.773c-.464 0-.89.11-1.281.329-.39.218-.703.539-.938.96-.234.417-.351.93-.351 1.54v2.632H1.96Z" }));
const SvgStatusApproved = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 100 65" }, props), /* @__PURE__ */ React.createElement("path", { fill: "#1E9738", fillRule: "evenodd", d: "M8.966 6.164h67.24a2.802 2.802 0 0 1 2.803 2.802V27.21a21.186 21.186 0 0 1 6.163.027V8.966A8.966 8.966 0 0 0 76.207 0H8.966A8.966 8.966 0 0 0 0 8.966v47.069A8.966 8.966 0 0 0 8.966 65h60.703a21.11 21.11 0 0 1-5.66-6.164H8.965a2.802 2.802 0 0 1-2.802-2.801V8.965a2.802 2.802 0 0 1 2.802-2.801Zm61.637 22.974c.495 0 .952.16 1.323.431a21.086 21.086 0 0 0-5.23 4.052H50.43a2.241 2.241 0 0 1 0-4.483h20.172ZM50.431 43.707h11.008a21.09 21.09 0 0 0-.438 4.483H50.43a2.241 2.241 0 0 1 0-4.483Zm-35.498 5.227c-1.014 0-1.813-.228-2.396-.684-.57-.444-.855-1.059-.855-1.845 0-1.229.367-2.515 1.102-3.859.735-1.356 1.8-2.623 3.194-3.802 1.394-1.191 3.074-2.154 5.038-2.89 1.977-.747 4.195-1.121 6.654-1.121 2.471 0 4.69.374 6.654 1.121 1.977.736 3.656 1.699 5.038 2.89 1.394 1.179 2.458 2.446 3.193 3.802.748 1.344 1.122 2.63 1.122 3.86 0 .785-.292 1.4-.875 1.843-.57.457-1.362.685-2.376.685H14.932ZM27.688 31.33a6.869 6.869 0 0 1-3.764-1.103c-1.154-.748-2.085-1.749-2.795-3.003-.697-1.268-1.046-2.687-1.046-4.259 0-1.546.349-2.94 1.046-4.182.71-1.242 1.641-2.225 2.795-2.947a6.957 6.957 0 0 1 3.764-1.084c1.356 0 2.61.355 3.764 1.065 1.153.71 2.078 1.686 2.775 2.928.71 1.229 1.065 2.623 1.065 4.182 0 1.584-.355 3.01-1.065 4.277-.697 1.268-1.622 2.275-2.775 3.023a6.869 6.869 0 0 1-3.764 1.103ZM50.43 20.172a2.241 2.241 0 0 1 0-4.482h20.172a2.241 2.241 0 1 1 0 4.482H50.431Zm28.026 11.584a5.534 5.534 0 0 1 8.087 0 5.535 5.535 0 0 0 4.23 1.752 5.535 5.535 0 0 1 5.718 5.718 5.534 5.534 0 0 0 1.753 4.23 5.535 5.535 0 0 1 0 8.087 5.534 5.534 0 0 0-1.753 4.23 5.535 5.535 0 0 1-5.718 5.72 5.534 5.534 0 0 0-4.23 1.752 5.535 5.535 0 0 1-8.087 0 5.534 5.534 0 0 0-4.23-1.753 5.535 5.535 0 0 1-5.72-5.718 5.535 5.535 0 0 0-1.752-4.23 5.534 5.534 0 0 1 0-8.087 5.535 5.535 0 0 0 1.753-4.23 5.534 5.534 0 0 1 5.718-5.72 5.535 5.535 0 0 0 4.23-1.751Zm11.954 7.472a1.778 1.778 0 0 0-2.463.512l-7.561 11.527-3.432-4.173a1.779 1.779 0 1 0-2.747 2.26l4.88 5.934a1.779 1.779 0 0 0 2.636.123c.214-.133.403-.313.55-.537l8.648-13.183a1.779 1.779 0 0 0-.511-2.463Z", clipRule: "evenodd" }));
const SvgStatusIncomplete = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 86 65" }, props), /* @__PURE__ */ React.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M3.082 50.15H0v5.885A8.966 8.966 0 0 0 8.966 65h8.405v-6.164H8.966a2.802 2.802 0 0 1-2.802-2.801V50.15H3.082Zm0-11.766H0V26.616h6.164v11.768H3.082Zm0-23.535H0V8.966A8.966 8.966 0 0 1 8.966 0h8.405v6.164H8.966a2.802 2.802 0 0 0-2.802 2.802v5.883H3.082ZM34.18 3.082V0h16.81v6.164h-16.81V3.082Zm33.62 0V0h8.406a8.966 8.966 0 0 1 8.965 8.966v5.883H79.01V8.966a2.802 2.802 0 0 0-2.802-2.802h-8.405V3.082Zm14.29 23.534h3.081v11.768H79.01V26.616h3.082Zm0 23.535h3.081v5.883A8.966 8.966 0 0 1 76.207 65h-8.405v-6.164h8.405a2.802 2.802 0 0 0 2.802-2.801V50.15h3.082Zm-31.1 11.767V65h-16.81v-6.164h16.81v3.082ZM14.932 48.934c-1.014 0-1.812-.228-2.395-.685-.57-.443-.855-1.058-.855-1.844 0-1.229.367-2.515 1.102-3.859.735-1.356 1.8-2.623 3.194-3.802 1.394-1.191 3.074-2.155 5.038-2.89 1.977-.748 4.195-1.121 6.654-1.121 2.471 0 4.69.373 6.654 1.121 1.977.735 3.656 1.699 5.037 2.89 1.395 1.179 2.46 2.446 3.194 3.802.748 1.344 1.122 2.63 1.122 3.86 0 .785-.292 1.4-.875 1.843-.57.457-1.362.685-2.376.685H14.932ZM27.69 31.33a6.87 6.87 0 0 1-3.764-1.103c-1.154-.748-2.085-1.749-2.795-3.004-.697-1.267-1.046-2.686-1.046-4.258 0-1.546.349-2.94 1.046-4.183.71-1.241 1.641-2.224 2.795-2.946a6.957 6.957 0 0 1 3.764-1.084c1.356 0 2.61.355 3.764 1.065 1.153.71 2.078 1.685 2.775 2.927.71 1.23 1.065 2.624 1.065 4.183 0 1.584-.355 3.01-1.065 4.277-.697 1.268-1.622 2.275-2.775 3.023a6.87 6.87 0 0 1-3.764 1.103ZM50.43 20.172a2.241 2.241 0 1 1 0-4.482h20.172a2.241 2.241 0 1 1 0 4.482H50.431Zm0 13.449a2.241 2.241 0 1 1 0-4.483h20.172a2.241 2.241 0 1 1 0 4.483H50.431ZM48.19 45.948a2.241 2.241 0 0 0 2.241 2.242h20.172a2.241 2.241 0 1 0 0-4.483H50.431a2.241 2.241 0 0 0-2.241 2.241Z", clipRule: "evenodd" }));
const SvgStatusPending = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 99 65" }, props), /* @__PURE__ */ React.createElement("path", { fill: "#777", fillRule: "evenodd", d: "M8.966 6.164h67.24a2.802 2.802 0 0 1 2.803 2.802V27.21a21.186 21.186 0 0 1 6.163.027V8.966A8.966 8.966 0 0 0 76.207 0H8.966A8.966 8.966 0 0 0 0 8.966v47.069A8.966 8.966 0 0 0 8.966 65h60.703a21.11 21.11 0 0 1-5.66-6.164H8.965a2.802 2.802 0 0 1-2.802-2.801V8.965a2.802 2.802 0 0 1 2.802-2.801Zm61.637 22.974c.495 0 .952.16 1.323.431a21.086 21.086 0 0 0-5.23 4.052H50.43a2.241 2.241 0 0 1 0-4.483h20.172ZM50.431 43.707h11.008a21.09 21.09 0 0 0-.438 4.483H50.43a2.241 2.241 0 0 1 0-4.483Zm-35.498 5.227c-1.014 0-1.813-.228-2.396-.684-.57-.444-.855-1.059-.855-1.845 0-1.229.367-2.515 1.102-3.859.735-1.356 1.8-2.623 3.194-3.802 1.394-1.191 3.074-2.154 5.038-2.89 1.977-.747 4.195-1.121 6.654-1.121 2.471 0 4.69.374 6.654 1.121 1.977.736 3.656 1.699 5.038 2.89 1.394 1.179 2.458 2.446 3.193 3.802.748 1.344 1.122 2.63 1.122 3.86 0 .785-.292 1.4-.875 1.843-.57.457-1.362.685-2.376.685H14.932ZM27.688 31.33a6.869 6.869 0 0 1-3.764-1.103c-1.154-.748-2.085-1.749-2.795-3.003-.697-1.268-1.046-2.687-1.046-4.259 0-1.546.349-2.94 1.046-4.182.71-1.242 1.641-2.225 2.795-2.947a6.957 6.957 0 0 1 3.764-1.084c1.356 0 2.61.355 3.764 1.065 1.153.71 2.078 1.686 2.775 2.928.71 1.229 1.065 2.623 1.065 4.182 0 1.584-.355 3.01-1.065 4.277-.697 1.268-1.622 2.275-2.775 3.023a6.869 6.869 0 0 1-3.764 1.103ZM50.43 20.172a2.241 2.241 0 0 1 0-4.482h20.172a2.241 2.241 0 1 1 0 4.482H50.431Zm48.492 27.29c0 9.09-7.37 16.46-16.462 16.46-9.091 0-16.461-7.37-16.461-16.46C66 38.37 73.37 31 82.461 31c9.092 0 16.462 7.37 16.462 16.461ZM82.96 35.987c1.102 0 1.995.894 1.995 1.996v9.558l6.428 3.614a2.023 2.023 0 0 1-1.934 3.554l-7.289-3.837a2.198 2.198 0 0 1-.883-.843 1.985 1.985 0 0 1-.312-1.072V37.984c0-1.102.893-1.996 1.995-1.996Z", clipRule: "evenodd" }));
const SvgStatusRejected = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 102 66" }, props), /* @__PURE__ */ React.createElement("path", { fill: "#CD3237", fillRule: "evenodd", d: "M9.053 6.224H76.12a2.829 2.829 0 0 1 2.829 2.829v15.899a5.891 5.891 0 0 1 6.223-.184V9.053c0-5-4.053-9.053-9.052-9.053H9.053C4.053 0 0 4.053 0 9.053v46.894C0 60.947 4.053 65 9.053 65h48.822c-1.084-1.754-1.256-4.067-.036-6.09l.08-.134H9.054a2.829 2.829 0 0 1-2.83-2.829V9.053a2.829 2.829 0 0 1 2.83-2.83ZM50.43 44.017H66.82L64.117 48.5H50.43a2.241 2.241 0 1 1 0-4.483Zm-35.622 5.38c-1.024 0-1.83-.23-2.42-.69-.575-.448-.863-1.069-.863-1.862 0-1.242.371-2.54 1.114-3.897.742-1.37 1.817-2.65 3.224-3.84 1.408-1.202 3.104-2.175 5.087-2.917 1.997-.755 4.236-1.133 6.719-1.133 2.495 0 4.735.378 6.718 1.133 1.997.742 3.692 1.715 5.087 2.918 1.408 1.19 2.483 2.47 3.225 3.839.755 1.356 1.132 2.655 1.132 3.897 0 .793-.294 1.414-.883 1.862-.575.46-1.375.69-2.4.69H14.81Zm12.88-17.774a6.936 6.936 0 0 1-3.8-1.114c-1.165-.755-2.106-1.766-2.823-3.033-.703-1.28-1.055-2.713-1.055-4.3 0-1.56.352-2.968 1.055-4.223.717-1.254 1.658-2.245 2.822-2.975a7.025 7.025 0 0 1 3.8-1.094c1.37 0 2.637.358 3.802 1.075 1.164.716 2.098 1.702 2.802 2.956.717 1.241 1.075 2.649 1.075 4.223 0 1.6-.358 3.04-1.075 4.32-.704 1.279-1.638 2.296-2.802 3.051a6.936 6.936 0 0 1-3.801 1.113Zm22.742-11.14a2.241 2.241 0 1 1 0-4.483h20.172a2.241 2.241 0 1 1 0 4.483H50.431Zm0 13.448a2.241 2.241 0 1 1 0-4.483h20.172a2.241 2.241 0 1 1 0 4.483H50.431Zm35.526-.239c-1.762-2.923-6-2.923-7.763 0L63.158 58.627c-1.822 3.02.354 6.873 3.882 6.873H97.11c3.528 0 5.704-3.852 3.882-6.873L85.957 33.692Zm-3.881 7.161a1.983 1.983 0 0 0-1.983 1.983v9.066a1.983 1.983 0 1 0 3.966 0v-9.066a1.983 1.983 0 0 0-1.983-1.983Zm2.266 16.998a2.266 2.266 0 1 1-4.533 0 2.266 2.266 0 0 1 4.533 0Z", clipRule: "evenodd" }));
const SvgStatusRejectedButIdVerified = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 102 66" }, props), /* @__PURE__ */ React.createElement("path", { fill: "#FFC124", fillRule: "evenodd", d: "M9.053 6.224H76.12a2.829 2.829 0 0 1 2.829 2.829v15.899a5.891 5.891 0 0 1 6.223-.184V9.053c0-5-4.053-9.053-9.052-9.053H9.053C4.053 0 0 4.053 0 9.053v46.894C0 60.947 4.053 65 9.053 65h48.822c-1.084-1.754-1.256-4.067-.036-6.09l.08-.134H9.054a2.829 2.829 0 0 1-2.83-2.829V9.053a2.829 2.829 0 0 1 2.83-2.83ZM50.43 44.017H66.82L64.117 48.5H50.43a2.241 2.241 0 1 1 0-4.483Zm-35.622 5.38c-1.024 0-1.83-.23-2.42-.69-.575-.448-.863-1.069-.863-1.862 0-1.242.371-2.54 1.114-3.897.742-1.37 1.817-2.65 3.224-3.84 1.408-1.202 3.104-2.175 5.087-2.917 1.997-.755 4.236-1.133 6.719-1.133 2.495 0 4.735.378 6.718 1.133 1.997.742 3.692 1.715 5.087 2.918 1.408 1.19 2.483 2.47 3.225 3.839.755 1.356 1.132 2.655 1.132 3.897 0 .793-.294 1.414-.883 1.862-.575.46-1.375.69-2.4.69H14.81Zm12.88-17.774a6.936 6.936 0 0 1-3.8-1.114c-1.165-.755-2.106-1.766-2.823-3.033-.703-1.28-1.055-2.713-1.055-4.3 0-1.56.352-2.968 1.055-4.223.717-1.254 1.658-2.245 2.822-2.975a7.025 7.025 0 0 1 3.8-1.094c1.37 0 2.637.358 3.802 1.075 1.164.716 2.098 1.702 2.802 2.956.717 1.241 1.075 2.649 1.075 4.223 0 1.6-.358 3.04-1.075 4.32-.704 1.279-1.638 2.296-2.802 3.051a6.936 6.936 0 0 1-3.801 1.113Zm22.742-11.14a2.241 2.241 0 1 1 0-4.483h20.172a2.241 2.241 0 1 1 0 4.483H50.431Zm0 13.448a2.241 2.241 0 1 1 0-4.483h20.172a2.241 2.241 0 1 1 0 4.483H50.431Zm35.526-.239c-1.762-2.923-6-2.923-7.763 0L63.158 58.627c-1.822 3.02.354 6.873 3.882 6.873H97.11c3.528 0 5.704-3.852 3.882-6.873L85.957 33.692Zm-3.881 7.161a1.983 1.983 0 0 0-1.983 1.983v9.066a1.983 1.983 0 1 0 3.966 0v-9.066a1.983 1.983 0 0 0-1.983-1.983Zm2.266 16.998a2.266 2.266 0 1 1-4.533 0 2.266 2.266 0 0 1 4.533 0Z", clipRule: "evenodd" }));
const SvgStatusReverifying = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 101 66" }, props), /* @__PURE__ */ React.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M8.966 6.164h67.24a2.802 2.802 0 0 1 2.803 2.802V27.21a21.186 21.186 0 0 1 6.163.027V8.966A8.966 8.966 0 0 0 76.207 0H8.966A8.966 8.966 0 0 0 0 8.966v47.069A8.966 8.966 0 0 0 8.966 65h60.703a21.11 21.11 0 0 1-5.66-6.164H8.965a2.802 2.802 0 0 1-2.802-2.801V8.965a2.802 2.802 0 0 1 2.802-2.801Zm61.637 22.974c.495 0 .952.16 1.323.431a21.086 21.086 0 0 0-5.23 4.052H50.43a2.241 2.241 0 0 1 0-4.483h20.172ZM50.431 43.707h11.008a21.09 21.09 0 0 0-.438 4.483H50.43a2.241 2.241 0 0 1 0-4.483Zm-35.498 5.227c-1.014 0-1.813-.228-2.396-.684-.57-.444-.855-1.059-.855-1.845 0-1.229.367-2.515 1.102-3.859.735-1.356 1.8-2.623 3.194-3.802 1.394-1.191 3.074-2.154 5.038-2.89 1.977-.747 4.195-1.121 6.654-1.121 2.471 0 4.69.374 6.654 1.121 1.977.736 3.656 1.699 5.038 2.89 1.394 1.179 2.458 2.446 3.193 3.802.748 1.344 1.122 2.63 1.122 3.86 0 .785-.292 1.4-.875 1.843-.57.457-1.362.685-2.376.685H14.932ZM27.688 31.33a6.869 6.869 0 0 1-3.764-1.103c-1.154-.748-2.085-1.749-2.795-3.003-.697-1.268-1.046-2.687-1.046-4.259 0-1.546.349-2.94 1.046-4.182.71-1.242 1.641-2.225 2.795-2.947a6.957 6.957 0 0 1 3.764-1.084c1.356 0 2.61.355 3.764 1.065 1.153.71 2.078 1.686 2.775 2.928.71 1.229 1.065 2.623 1.065 4.182 0 1.584-.355 3.01-1.065 4.277-.697 1.268-1.622 2.275-2.775 3.023a6.869 6.869 0 0 1-3.764 1.103ZM50.43 20.172a2.241 2.241 0 0 1 0-4.482h20.172a2.241 2.241 0 1 1 0 4.482H50.431Zm27.625 11.344a6.386 6.386 0 0 1 8.26 0l1.298 1.1c.436.37.977.594 1.546.64l1.697.14a6.386 6.386 0 0 1 5.84 5.842l.14 1.696c.047.57.271 1.11.64 1.546l1.101 1.298a6.387 6.387 0 0 1 0 8.26l-1.1 1.298c-.37.436-.594.977-.64 1.546l-.14 1.696a6.386 6.386 0 0 1-5.841 5.842l-1.697.14c-.57.046-1.11.27-1.546.64l-1.297 1.1a6.386 6.386 0 0 1-8.261 0l-1.298-1.1a2.738 2.738 0 0 0-1.546-.64l-1.696-.14a6.386 6.386 0 0 1-5.842-5.842l-.14-1.696a2.737 2.737 0 0 0-.64-1.546l-1.1-1.297a6.386 6.386 0 0 1 0-8.261l1.1-1.298c.37-.436.594-.977.64-1.546l.14-1.696a6.386 6.386 0 0 1 5.842-5.842l1.696-.14c.57-.046 1.11-.27 1.546-.64l1.298-1.1Zm5.9 2.783a2.737 2.737 0 0 0-3.54 0l-1.298 1.1a6.386 6.386 0 0 1-3.607 1.495l-1.696.14a2.737 2.737 0 0 0-2.504 2.502l-.14 1.697a6.386 6.386 0 0 1-1.494 3.607l-1.1 1.298a2.737 2.737 0 0 0 0 3.54l1.1 1.298a6.385 6.385 0 0 1 1.495 3.608l.14 1.695a2.737 2.737 0 0 0 2.503 2.504l1.696.14c1.329.109 2.59.631 3.607 1.494l1.298 1.1a2.737 2.737 0 0 0 3.54 0l1.298-1.1a6.386 6.386 0 0 1 3.608-1.495l1.696-.139a2.737 2.737 0 0 0 2.503-2.504l.14-1.696a6.385 6.385 0 0 1 1.494-3.607l1.1-1.298a2.737 2.737 0 0 0 0-3.54l-1.1-1.298a6.386 6.386 0 0 1-1.494-3.608l-.14-1.696a2.737 2.737 0 0 0-2.503-2.503l-1.696-.14a6.386 6.386 0 0 1-3.608-1.494l-1.298-1.1Zm5.632 6.402a1.592 1.592 0 0 0-2.205.458l-6.77 10.32-3.073-3.736a1.592 1.592 0 1 0-2.46 2.023l4.37 5.314a1.592 1.592 0 0 0 2.36.11c.192-.118.361-.28.493-.48l7.743-11.804a1.592 1.592 0 0 0-.458-2.205Z", clipRule: "evenodd" }));
const SvgBulletGlobe = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 15 15" }, props), /* @__PURE__ */ React.createElement("path", { fill: "#000", d: "M7.787 12.533c-.164 0-.33-.048-.499-.143-.164-.091-.3-.21-.41-.356a.735.735 0 0 1-.157-.444c0-.237.043-.449.13-.636.09-.187.134-.385.13-.595 0-.086-.124-.216-.37-.39a70.31 70.31 0 0 1-.97-.717c-.388-.287-.581-.629-.581-1.025 0-.21.031-.392.095-.547.064-.155.096-.27.096-.342 0-.05-.032-.103-.096-.157a21.57 21.57 0 0 0-.287-.26l-1.087-.957c-.551-.488-.93-.939-1.135-1.354-.2-.414-.28-.797-.239-1.148.046-.356.164-.686.356-.991l.67.136a2.41 2.41 0 0 0-.335.875c-.041.278.025.572.198.882.173.31.488.67.943 1.08l1.094.978c.023.014.043.03.062.048a.747.747 0 0 0 .061.054c.164.142.285.272.362.39a.672.672 0 0 1 .123.403c0 .105-.034.276-.102.513-.06.182-.089.315-.089.397 0 .16.103.316.308.471l.218.164.226.158c.401.282.695.52.882.71.187.187.282.392.287.616.004.164-.014.319-.055.464a5.257 5.257 0 0 1-.11.383 7.31 7.31 0 0 0-.081.247.633.633 0 0 0-.014.123c0 .063.039.127.116.19a.41.41 0 0 0 .24.09c.118 0 .289-.105.512-.315.224-.21.465-.476.725-.8.26-.328.508-.67.745-1.025.237-.355.43-.686.581-.991.15-.31.226-.545.226-.704 0-.091-.069-.214-.205-.37a3.83 3.83 0 0 0-.493-.485 3.735 3.735 0 0 0-.574-.41c-.191-.114-.344-.17-.458-.17-.073 0-.187.04-.342.122-.155.082-.319.164-.492.246a1.137 1.137 0 0 1-.451.117c-.16 0-.349-.055-.567-.164a3.592 3.592 0 0 1-.63-.431c-.2-.178-.368-.362-.505-.554-.137-.191-.205-.364-.205-.52 0-.145.05-.289.15-.43.1-.141.226-.257.376-.349a.845.845 0 0 1 .458-.143c.128 0 .283.054.465.164.187.105.362.21.526.314.169.105.292.158.37.158.059 0 .107-.019.143-.055a.185.185 0 0 0 .055-.137.514.514 0 0 0-.096-.266 6.584 6.584 0 0 0-.308-.445c-.068-.096-.088-.182-.061-.26a.316.316 0 0 1 .157-.177c.196-.105.426-.226.69-.363a12.2 12.2 0 0 0 .807-.464c.27-.17.508-.351.718-.547.214-.196.367-.401.458-.616l.615.322a2.31 2.31 0 0 1-.465.663 5 5 0 0 1-.683.58c-.25.179-.5.338-.745.48-.246.136-.465.252-.657.348.174.25.26.47.26.656 0 .296-.086.533-.26.711-.173.173-.403.26-.69.26-.132 0-.287-.052-.465-.157-.178-.105-.346-.21-.506-.315-.155-.11-.264-.164-.328-.164a.321.321 0 0 0-.198.082c-.064.05-.096.1-.096.15 0 .064.048.151.144.26.095.11.212.22.348.329.137.109.272.202.404.28.136.073.244.11.321.11a.89.89 0 0 0 .396-.117c.15-.082.304-.162.459-.24a.93.93 0 0 1 .43-.122c.214 0 .458.073.732.218.273.146.537.33.793.554.26.223.473.456.642.697.169.242.253.458.253.65 0 .25-.087.565-.26.943a8.528 8.528 0 0 1-.676 1.19c-.274.41-.568.797-.882 1.162-.315.364-.618.66-.91.888-.291.228-.535.342-.73.342ZM7.5 14.037c-.952 0-1.85-.182-2.693-.547a7.137 7.137 0 0 1-2.222-1.51 7.139 7.139 0 0 1-1.51-2.222 6.713 6.713 0 0 1-.548-2.694c0-.952.183-1.848.547-2.686a7.174 7.174 0 0 1 1.504-2.229A7.14 7.14 0 0 1 4.8.64 6.713 6.713 0 0 1 7.493.092c.953 0 1.85.182 2.694.547a7.116 7.116 0 0 1 2.228 1.51 7.116 7.116 0 0 1 1.51 2.229c.365.838.548 1.734.548 2.686 0 .953-.183 1.85-.547 2.694a7.139 7.139 0 0 1-1.511 2.222 7.113 7.113 0 0 1-2.228 1.51 6.664 6.664 0 0 1-2.687.547Zm0-.93c.825 0 1.602-.16 2.331-.478a6.137 6.137 0 0 0 1.928-1.306 6.137 6.137 0 0 0 1.306-1.927c.319-.73.478-1.507.478-2.332 0-.824-.16-1.601-.478-2.33a6.083 6.083 0 0 0-1.313-1.928A6.138 6.138 0 0 0 9.824 1.5a5.752 5.752 0 0 0-2.33-.479c-.826 0-1.603.16-2.332.479-.73.314-1.372.75-1.928 1.306A6.295 6.295 0 0 0 1.93 4.733a5.823 5.823 0 0 0-.472 2.331c0 .825.157 1.602.472 2.332.319.729.756 1.371 1.312 1.927A6.137 6.137 0 0 0 5.17 12.63c.73.319 1.506.478 2.331.478Z" }));
const SvgBulletPerson = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 14" }, props), /* @__PURE__ */ React.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M12.794 7A5.794 5.794 0 1 1 1.206 7a5.794 5.794 0 0 1 11.588 0ZM14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0ZM3.846 10.445c.125.099.297.148.516.148h5.49c.219 0 .39-.05.512-.148a.47.47 0 0 0 .189-.397c0-.265-.08-.542-.242-.831a2.882 2.882 0 0 0-.688-.819 3.522 3.522 0 0 0-1.085-.622 4.005 4.005 0 0 0-1.433-.242c-.53 0-1.007.08-1.433.242a3.587 3.587 0 0 0-1.085.622c-.3.254-.53.527-.688.819-.158.29-.237.566-.237.831 0 .17.061.302.184.397Zm2.452-3.881c.249.158.52.237.811.237.292 0 .563-.079.811-.237a1.853 1.853 0 0 0 .827-1.572c0-.336-.076-.637-.23-.901a1.703 1.703 0 0 0-.597-.631 1.518 1.518 0 0 0-.81-.23c-.293 0-.563.078-.812.234A1.77 1.77 0 0 0 5.471 5c0 .338.075.644.226.917.152.27.353.486.601.647Z", clipRule: "evenodd" }));
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function isPlainObject$3(item) {
  return item !== null && typeof item === "object" && item.constructor === Object;
}
function deepClone(source) {
  if (!isPlainObject$3(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach((key) => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? _extends$2({}, target) : target;
  if (isPlainObject$3(target) && isPlainObject$3(source)) {
    Object.keys(source).forEach((key) => {
      if (key === "__proto__") {
        return;
      }
      if (isPlainObject$3(source[key]) && key in target && isPlainObject$3(target[key])) {
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject$3(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}
function formatMuiErrorMessage(code2) {
  let url = "https://mui.com/production-error/?code=" + code2;
  for (let i = 1; i < arguments.length; i += 1) {
    url += "&args[]=" + encodeURIComponent(arguments[i]);
  }
  return "Minified MUI error #" + code2 + "; visit " + url + " for the full message.";
}
function capitalize(string2) {
  if (typeof string2 !== "string") {
    throw new Error(formatMuiErrorMessage(7));
  }
  return string2.charAt(0).toUpperCase() + string2.slice(1);
}
function createChainedFunction(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }
    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {
  });
}
function debounce$1(func, wait = 166) {
  let timeout;
  function debounced(...args) {
    const later = () => {
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = () => {
    clearTimeout(timeout);
  };
  return debounced;
}
function deprecatedPropType(validator, reason) {
  {
    return () => null;
  }
}
function isMuiElement(element2, muiNames) {
  return /* @__PURE__ */ React.isValidElement(element2) && muiNames.indexOf(element2.type.muiName) !== -1;
}
function ownerDocument(node2) {
  return node2 && node2.ownerDocument || document;
}
function ownerWindow(node2) {
  const doc = ownerDocument(node2);
  return doc.defaultView || window;
}
function requirePropFactory(componentNameInError, Component) {
  {
    return () => null;
  }
}
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
const useEnhancedEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
const useEnhancedEffect$1 = useEnhancedEffect;
let globalId = 0;
function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = React.useState(idOverride);
  const id = idOverride || defaultId;
  React.useEffect(() => {
    if (defaultId == null) {
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id;
}
const maybeReactUseId = React["useId"];
function useId(idOverride) {
  if (maybeReactUseId !== void 0) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  return useGlobalId(idOverride);
}
function unsupportedProp(props, propName, componentName, location, propFullName) {
  {
    return null;
  }
}
function useControlled({
  controlled,
  default: defaultProp,
  name,
  state = "value"
}) {
  const {
    current: isControlled
  } = React.useRef(controlled !== void 0);
  const [valueState, setValue] = React.useState(defaultProp);
  const value = isControlled ? controlled : valueState;
  const setValueIfUncontrolled = React.useCallback((newValue) => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}
function useEventCallback(fn) {
  const ref = React.useRef(fn);
  useEnhancedEffect$1(() => {
    ref.current = fn;
  });
  return React.useCallback((...args) => (
    // @ts-expect-error hide `this`
    // tslint:disable-next-line:ban-comma-operator
    (0, ref.current)(...args)
  ), []);
}
function useForkRef(...refs) {
  return React.useMemo(() => {
    if (refs.every((ref) => ref == null)) {
      return null;
    }
    return (instance) => {
      refs.forEach((ref) => {
        setRef(ref, instance);
      });
    };
  }, refs);
}
let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
let hadFocusVisibleRecentlyTimeout;
const inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  "datetime-local": true
};
function focusTriggersKeyboardModality(node2) {
  const {
    type,
    tagName
  } = node2;
  if (tagName === "INPUT" && inputTypesWhitelist[type] && !node2.readOnly) {
    return true;
  }
  if (tagName === "TEXTAREA" && !node2.readOnly) {
    return true;
  }
  if (node2.isContentEditable) {
    return true;
  }
  return false;
}
function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}
function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === "hidden") {
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener("keydown", handleKeyDown, true);
  doc.addEventListener("mousedown", handlePointerDown, true);
  doc.addEventListener("pointerdown", handlePointerDown, true);
  doc.addEventListener("touchstart", handlePointerDown, true);
  doc.addEventListener("visibilitychange", handleVisibilityChange, true);
}
function isFocusVisible(event) {
  const {
    target
  } = event;
  try {
    return target.matches(":focus-visible");
  } catch (error) {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
  const ref = React.useCallback((node2) => {
    if (node2 != null) {
      prepare(node2.ownerDocument);
    }
  }, []);
  const isFocusVisibleRef = React.useRef(false);
  function handleBlurVisible() {
    if (isFocusVisibleRef.current) {
      hadFocusVisibleRecently = true;
      window.clearTimeout(hadFocusVisibleRecentlyTimeout);
      hadFocusVisibleRecentlyTimeout = window.setTimeout(() => {
        hadFocusVisibleRecently = false;
      }, 100);
      isFocusVisibleRef.current = false;
      return true;
    }
    return false;
  }
  function handleFocusVisible(event) {
    if (isFocusVisible(event)) {
      isFocusVisibleRef.current = true;
      return true;
    }
    return false;
  }
  return {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref
  };
}
function resolveProps(defaultProps, props) {
  const output = _extends$2({}, props);
  Object.keys(defaultProps).forEach((propName) => {
    if (propName.toString().match(/^(components|slots)$/)) {
      output[propName] = _extends$2({}, defaultProps[propName], output[propName]);
    } else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      const defaultSlotProps = defaultProps[propName] || {};
      const slotProps = props[propName];
      output[propName] = {};
      if (!slotProps || !Object.keys(slotProps)) {
        output[propName] = defaultSlotProps;
      } else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) {
        output[propName] = slotProps;
      } else {
        output[propName] = _extends$2({}, slotProps);
        Object.keys(defaultSlotProps).forEach((slotPropName) => {
          output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
        });
      }
    } else if (output[propName] === void 0) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
}
function composeClasses(slots, getUtilityClass, classes = void 0) {
  const output = {};
  Object.keys(slots).forEach(
    // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot) => {
      output[slot] = slots[slot].reduce((acc, key) => {
        if (key) {
          const utilityClass = getUtilityClass(key);
          if (utilityClass !== "") {
            acc.push(utilityClass);
          }
          if (classes && classes[key]) {
            acc.push(classes[key]);
          }
        }
        return acc;
      }, []).join(" ");
    }
  );
  return output;
}
const defaultGenerator = (componentName) => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
const ClassNameGenerator$1 = ClassNameGenerator;
const globalStateClassesMapping = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  readOnly: "readOnly",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  required: "required",
  selected: "selected"
};
function generateUtilityClass(componentName, slot, globalStatePrefix = "Mui") {
  const globalStateClass = globalStateClassesMapping[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator$1.generate(componentName)}-${slot}`;
}
function generateUtilityClasses(componentName, slots, globalStatePrefix = "Mui") {
  const result = {};
  slots.forEach((slot) => {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function memoize$1(fn) {
  var cache2 = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache2[arg] === void 0)
      cache2[arg] = fn(arg);
    return cache2[arg];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid = /* @__PURE__ */ memoize$1(
  function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e2) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim$1(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search2) {
  return value.indexOf(search2);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end) {
  return value.slice(begin, end);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array) {
  return array.push(value), value;
}
function combine(array, callback) {
  return array.map(callback).join("");
}
var line = 1;
var column = 1;
var length = 0;
var position$2 = 0;
var character = 0;
var characters = "";
function node$1(value, root2, parent, type, props, children, length2) {
  return { value, root: root2, parent, type, props, children, line, column, length: length2, return: "" };
}
function copy(root2, props) {
  return assign(node$1("", null, null, "", null, null, 0), root2, { length: -root2.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position$2 > 0 ? charat(characters, --position$2) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position$2 < length ? charat(characters, position$2++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position$2);
}
function caret() {
  return position$2;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token(type) {
  switch (type) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position$2 = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type) {
  return trim$1(slice(position$2 - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace$1(type) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index2, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
  while (next())
    switch (character) {
      case type:
        return position$2;
      case 34:
      case 39:
        if (type !== 34 && type !== 39)
          delimiter(character);
        break;
      case 40:
        if (type === 41)
          delimiter(type);
        break;
      case 92:
        next();
        break;
    }
  return position$2;
}
function commenter(type, index2) {
  while (next())
    if (type + character === 47 + 10)
      break;
    else if (type + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index2, position$2 - 1) + "*" + from(type === 47 ? type : next());
}
function identifier(index2) {
  while (!token(peek()))
    next();
  return slice(index2, position$2);
}
function compile(value) {
  return dealloc(parse$2("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse$2(value, root2, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset2 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous2 = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type = "";
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters2 = type;
  while (scanning)
    switch (previous2 = character2, character2 = next()) {
      case 40:
        if (previous2 != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace$1(previous2);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root2, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset2:
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append(reference = ruleset(characters2, root2, parent, index2, offset2, rules, points, type, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset2 === 0)
                parse$2(characters2, root2, reference, reference, props, rulesets, length2, points, children);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  case 100:
                  case 109:
                  case 115:
                    parse$2(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse$2(characters2, reference, reference, reference, [""], children, 0, points, children);
                }
        }
        index2 = offset2 = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property = previous2;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset2 > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset2 = length2 = strlen(type = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous2 === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root2, parent, index2, offset2, rules, points, type, props, children, length2) {
  var post = offset2 - 1;
  var rule = offset2 === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k2 = 0; i < index2; ++i)
    for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
      if (z = trim$1(j > 0 ? rule[x] + " " + y : replace(y, /&\f/g, rule[x])))
        props[k2++] = z;
  return node$1(value, root2, parent, offset2 === 0 ? RULESET : type, props, children, length2);
}
function comment(value, root2, parent) {
  return node$1(value, root2, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root2, parent, length2) {
  return node$1(value, root2, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i = 0; i < length2; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify$2(element2, index2, children, callback) {
  switch (element2.type) {
    case IMPORT:
    case DECLARATION:
      return element2.return = element2.return || element2.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element2.return = element2.value + "{" + serialize(element2.children, callback) + "}";
    case RULESET:
      element2.value = element2.props.join(",");
  }
  return strlen(children = serialize(element2.children, callback)) ? element2.return = element2.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element2, index2, children, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element2, index2, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element2) {
    if (!element2.root) {
      if (element2 = element2.return)
        callback(element2);
    }
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous2 = 0;
  var character2 = 0;
  while (true) {
    previous2 = character2;
    character2 = peek();
    if (previous2 === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position$2);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position$2 - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      default:
        parsed[index2] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element2) {
  if (element2.type !== "rule" || !element2.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element2.length < 1) {
    return;
  }
  var value = element2.value, parent = element2.parent;
  var isImplicitRule = element2.column === parent.column && element2.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent)
      return;
  }
  if (element2.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element2, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k2 = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k2++) {
      element2.props[k2] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element2) {
  if (element2.type === "decl") {
    var value = element2.value;
    if (
      // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98
    ) {
      element2["return"] = "";
      element2.value = "";
    }
  }
};
function prefix(value, length2) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6)
        switch (charat(value, length2 + 1)) {
          case 109:
            if (charat(value, length2 + 4) !== 45)
              break;
          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
          case 115:
            return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
        }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115)
        break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element2, index2, children, callback) {
  if (element2.length > -1) {
    if (!element2["return"])
      switch (element2.type) {
        case DECLARATION:
          element2["return"] = prefix(element2.value, element2.length);
          break;
        case KEYFRAMES:
          return serialize([copy(element2, {
            value: replace(element2.value, "@", "@" + WEBKIT)
          })], callback);
        case RULESET:
          if (element2.length)
            return combine(element2.props, function(value) {
              switch (match(value, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return serialize([copy(element2, {
                    props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
                  })], callback);
                case "::placeholder":
                  return serialize([copy(element2, {
                    props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
                  }), copy(element2, {
                    props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
                  }), copy(element2, {
                    props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
                  })], callback);
              }
              return "";
            });
      }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options) {
  var key = options.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options.container || document.head;
    Array.prototype.forEach.call(
      // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll('style[data-emotion^="' + key + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify$2, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles) {
      return serialize(compile(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache2.inserted[serialized.name] = true;
      }
    };
  }
  var cache2 = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache2.sheet.hydrate(nodesToHydrate);
  return cache2;
};
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = "";
  classNames.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache2, serialized, isStringTag2) {
  var className = cache2.key + "-" + serialized.name;
  if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag2 === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache2.registered[className] === void 0
  ) {
    cache2.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache2, serialized, isStringTag2) {
  registerStyles(cache2, serialized, isStringTag2);
  var className = cache2.key + "-" + serialized.name;
  if (cache2.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache2.insert(serialized === current ? "." + className : "", current, cache2.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h2 = 0;
  var k2, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k2 = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k2 = /* Math.imul(k, m): */
    (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= /* k >>> r: */
    k2 >>> 24;
    h2 = /* Math.imul(k, m): */
    (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h2 ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h2 ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h2 ^= str.charCodeAt(i) & 255;
      h2 = /* Math.imul(h, m): */
      (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  h2 ^= h2 >>> 13;
  h2 = /* Math.imul(h, m): */
  (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize$1(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match5, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next2 = interpolation.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles = interpolation.styles + ";";
        return styles;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string2 = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string2 += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string2 += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string2 += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && false) {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string2 += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case "animation":
            case "animationName": {
              string2 += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string2 += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string2;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    styles += strings[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      styles += strings[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match5;
  while ((match5 = labelPattern.exec(styles)) !== null) {
    identifierName += "-" + // $FlowFixMe we know it's not null
    match5[1];
  }
  var name = murmur2(styles) + identifierName;
  return {
    name,
    styles,
    next: cursor
  };
};
var syncFallback = function syncFallback2(create2) {
  return create2();
};
var useInsertionEffect = React["useInsertionEffect"] ? React["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var EmotionCacheContext = /* @__PURE__ */ createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref) {
    var cache2 = useContext(EmotionCacheContext);
    return func(props, cache2, ref);
  });
};
var ThemeContext$2 = /* @__PURE__ */ createContext({});
var testOmitPropsOnStringTag = isPropValid;
var testOmitPropsOnComponent = function testOmitPropsOnComponent2(key) {
  return key !== "theme";
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp2(tag) {
  return typeof tag === "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps2(tag, options, isReal) {
  var shouldForwardProp2;
  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp2 = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }
  if (typeof shouldForwardProp2 !== "function" && isReal) {
    shouldForwardProp2 = tag.__emotion_forwardProp;
  }
  return shouldForwardProp2;
};
var Insertion = function Insertion2(_ref) {
  var cache2 = _ref.cache, serialized = _ref.serialized, isStringTag2 = _ref.isStringTag;
  registerStyles(cache2, serialized, isStringTag2);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache2, serialized, isStringTag2);
  });
  return null;
};
var createStyled$1 = function createStyled(tag, options) {
  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;
  if (options !== void 0) {
    identifierName = options.label;
    targetClassName = options.target;
  }
  var shouldForwardProp2 = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp2 || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp("as");
  return function() {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== void 0 ? tag.__emotion_styles.slice(0) : [];
    if (identifierName !== void 0) {
      styles.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === void 0) {
      styles.push.apply(styles, args);
    } else {
      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;
      for (; i < len; i++) {
        styles.push(args[i], args[0][i]);
      }
    }
    var Styled = withEmotionCache(function(props, cache2, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = "";
      var classInterpolations = [];
      var mergedProps = props;
      if (props.theme == null) {
        mergedProps = {};
        for (var key in props) {
          mergedProps[key] = props[key];
        }
        mergedProps.theme = useContext(ThemeContext$2);
      }
      if (typeof props.className === "string") {
        className = getRegisteredStyles(cache2.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }
      var serialized = serializeStyles(styles.concat(classInterpolations), cache2.registered, mergedProps);
      className += cache2.key + "-" + serialized.name;
      if (targetClassName !== void 0) {
        className += " " + targetClassName;
      }
      var finalShouldForwardProp = shouldUseAs && shouldForwardProp2 === void 0 ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};
      for (var _key in props) {
        if (shouldUseAs && _key === "as")
          continue;
        if (
          // $FlowFixMe
          finalShouldForwardProp(_key)
        ) {
          newProps[_key] = props[_key];
        }
      }
      newProps.className = className;
      newProps.ref = ref;
      return /* @__PURE__ */ createElement(Fragment$1, null, /* @__PURE__ */ createElement(Insertion, {
        cache: cache2,
        serialized,
        isStringTag: typeof FinalTag === "string"
      }), /* @__PURE__ */ createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== void 0 ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp2;
    Object.defineProperty(Styled, "toString", {
      value: function value() {
        if (targetClassName === void 0 && false) {
          return "NO_COMPONENT_SELECTOR";
        }
        return "." + targetClassName;
      }
    });
    Styled.withComponent = function(nextTag, nextOptions) {
      return createStyled(nextTag, _extends$2({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };
    return Styled;
  };
};
const createStyled$2 = createStyled$1;
var tags = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
var newStyled = createStyled$2.bind();
tags.forEach(function(tagName) {
  newStyled[tagName] = newStyled(tagName);
});
const emStyled = newStyled;
/**
 * @mui/styled-engine v5.11.16
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$4(tag, options) {
  const stylesFactory = emStyled(tag, options);
  return stylesFactory;
}
const internal_processStyles = (tag, processor) => {
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};
function merge$1(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge(acc, item, {
    clone: false
    // No need to clone deep, it's way faster.
  });
}
const values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (key) => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index2) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index2])] = styleFromPropValue(propValue[index2]);
      return acc;
    }, {});
  }
  if (typeof propValue === "object") {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style2) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style2);
}
function getPath(obj, path2, checkVars = true) {
  if (!path2 || typeof path2 !== "string") {
    return null;
  }
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path2}`.split(".").reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path2.split(".").reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === "function") {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style$1(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;
  const fn = (props) => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = (propValueFinal) => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === "string") {
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn.propTypes = {};
  fn.filterProps = [prop];
  return fn;
}
function compose(...styles) {
  const handlers2 = styles.reduce((acc, style2) => {
    style2.filterProps.forEach((prop) => {
      acc[prop] = style2;
    });
    return acc;
  }, {});
  const fn = (props) => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers2[prop]) {
        return merge$1(acc, handlers2[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes = {};
  fn.filterProps = styles.reduce((acc, style2) => acc.concat(style2.filterProps), []);
  return fn;
}
function memoize(fn) {
  const cache2 = {};
  return (arg) => {
    if (cache2[arg] === void 0) {
      cache2[arg] = fn(arg);
    }
    return cache2[arg];
  };
}
const properties = {
  m: "margin",
  p: "padding"
};
const directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
};
const aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
};
const getCssProperties = memoize((prop) => {
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b2] = prop.split("");
  const property = properties[a];
  const direction = directions[b2] || "";
  return Array.isArray(direction) ? direction.map((dir) => property + dir) : [property + direction];
});
const marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"];
const paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
[...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === "number") {
    return (abs2) => {
      if (typeof abs2 === "string") {
        return abs2;
      }
      return themeSpacing * abs2;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return (abs2) => {
      if (typeof abs2 === "string") {
        return abs2;
      }
      return themeSpacing[abs2];
    };
  }
  if (typeof themeSpacing === "function") {
    return themeSpacing;
  }
  return () => void 0;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, "spacing", 8);
}
function getValue(transformer, propValue) {
  if (typeof propValue === "string" || propValue == null) {
    return propValue;
  }
  const abs2 = Math.abs(propValue);
  const transformed = transformer(abs2);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === "number") {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return (propValue) => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys2, prop, transformer) {
  if (keys2.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style(props, keys2) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map((prop) => resolveCssProperty(props, keys2, prop, transformer)).reduce(merge$1, {});
}
function margin(props) {
  return style(props, marginKeys);
}
margin.propTypes = {};
margin.filterProps = marginKeys;
function padding(props) {
  return style(props, paddingKeys);
}
padding.propTypes = {};
padding.filterProps = paddingKeys;
function borderTransform(value) {
  if (typeof value !== "number") {
    return value;
  }
  return `${value}px solid`;
}
const border = style$1({
  prop: "border",
  themeKey: "borders",
  transform: borderTransform
});
const borderTop = style$1({
  prop: "borderTop",
  themeKey: "borders",
  transform: borderTransform
});
const borderRight = style$1({
  prop: "borderRight",
  themeKey: "borders",
  transform: borderTransform
});
const borderBottom = style$1({
  prop: "borderBottom",
  themeKey: "borders",
  transform: borderTransform
});
const borderLeft = style$1({
  prop: "borderLeft",
  themeKey: "borders",
  transform: borderTransform
});
const borderColor = style$1({
  prop: "borderColor",
  themeKey: "palette"
});
const borderTopColor = style$1({
  prop: "borderTopColor",
  themeKey: "palette"
});
const borderRightColor = style$1({
  prop: "borderRightColor",
  themeKey: "palette"
});
const borderBottomColor = style$1({
  prop: "borderBottomColor",
  themeKey: "palette"
});
const borderLeftColor = style$1({
  prop: "borderLeftColor",
  themeKey: "palette"
});
const borderRadius = (props) => {
  if (props.borderRadius !== void 0 && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, "shape.borderRadius", 4);
    const styleFromPropValue = (propValue) => ({
      borderRadius: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = {};
borderRadius.filterProps = ["borderRadius"];
compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius);
const gap = (props) => {
  if (props.gap !== void 0 && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8);
    const styleFromPropValue = (propValue) => ({
      gap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = {};
gap.filterProps = ["gap"];
const columnGap = (props) => {
  if (props.columnGap !== void 0 && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8);
    const styleFromPropValue = (propValue) => ({
      columnGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = {};
columnGap.filterProps = ["columnGap"];
const rowGap = (props) => {
  if (props.rowGap !== void 0 && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8);
    const styleFromPropValue = (propValue) => ({
      rowGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$1({
  prop: "gridColumn"
});
const gridRow = style$1({
  prop: "gridRow"
});
const gridAutoFlow = style$1({
  prop: "gridAutoFlow"
});
const gridAutoColumns = style$1({
  prop: "gridAutoColumns"
});
const gridAutoRows = style$1({
  prop: "gridAutoRows"
});
const gridTemplateColumns = style$1({
  prop: "gridTemplateColumns"
});
const gridTemplateRows = style$1({
  prop: "gridTemplateRows"
});
const gridTemplateAreas = style$1({
  prop: "gridTemplateAreas"
});
const gridArea = style$1({
  prop: "gridArea"
});
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(value, userValue) {
  if (userValue === "grey") {
    return userValue;
  }
  return value;
}
const color$1 = style$1({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
});
const bgcolor = style$1({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
const backgroundColor = style$1({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose(color$1, bgcolor, backgroundColor);
function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = style$1({
  prop: "width",
  transform: sizingTransform
});
const maxWidth = (props) => {
  if (props.maxWidth !== void 0 && props.maxWidth !== null) {
    const styleFromPropValue = (propValue) => {
      var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
      const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || values[propValue];
      return {
        maxWidth: breakpoint || sizingTransform(propValue)
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$1({
  prop: "minWidth",
  transform: sizingTransform
});
const height = style$1({
  prop: "height",
  transform: sizingTransform
});
const maxHeight = style$1({
  prop: "maxHeight",
  transform: sizingTransform
});
const minHeight = style$1({
  prop: "minHeight",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
const boxSizing = style$1({
  prop: "boxSizing"
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: (value) => ({
      "@media print": {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: "typography"
  }
};
const defaultSxConfig$1 = defaultSxConfig;
function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys2, object) => keys2.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every((object) => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style: style2
    } = options;
    if (val == null) {
      return null;
    }
    if (themeKey === "typography" && val === "inherit") {
      return {
        [prop]: val
      };
    }
    const themeMapping = getPath(theme, themeKey) || {};
    if (style2) {
      return style2(props);
    }
    const styleFromPropValue = (propValueFinal) => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === "string") {
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, val, styleFromPropValue);
  }
  function styleFunctionSx2(props) {
    var _theme$unstable_sxCon;
    const {
      sx,
      theme = {}
    } = props || {};
    if (!sx) {
      return null;
    }
    const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : defaultSxConfig$1;
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === "function") {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== "object") {
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach((styleKey) => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== void 0) {
          if (typeof value === "object") {
            if (config[styleKey]) {
              css = merge$1(css, getThemeValue(styleKey, value, theme, config));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value, (x) => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx2({
                  sx: value,
                  theme
                });
              } else {
                css = merge$1(css, breakpointsValues);
              }
            }
          } else {
            css = merge$1(css, getThemeValue(styleKey, value, theme, config));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx2;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ["sx"];
const styleFunctionSx$1 = styleFunctionSx;
function r(e2) {
  var t2, f2, n2 = "";
  if ("string" == typeof e2 || "number" == typeof e2)
    n2 += e2;
  else if ("object" == typeof e2)
    if (Array.isArray(e2))
      for (t2 = 0; t2 < e2.length; t2++)
        e2[t2] && (f2 = r(e2[t2])) && (n2 && (n2 += " "), n2 += f2);
    else
      for (t2 in e2)
        e2[t2] && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
function clsx() {
  for (var e2, t2, f2 = 0, n2 = ""; f2 < arguments.length; )
    (e2 = arguments[f2++]) && (t2 = r(e2)) && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
const _excluded$9 = ["values", "unit", "step"];
const sortBreakpointsValues = (values2) => {
  const breakpointsAsArray = Object.keys(values2).map((key) => ({
    key,
    val: values2[key]
  })) || [];
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return _extends$2({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};
function createBreakpoints(breakpoints) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: values2 = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit = "px",
    step = 5
  } = breakpoints, other = _objectWithoutPropertiesLoose$1(breakpoints, _excluded$9);
  const sortedValues = sortBreakpointsValues(values2);
  const keys2 = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys2.indexOf(end);
    return `@media (min-width:${typeof values2[start] === "number" ? values2[start] : start}${unit}) and (max-width:${(endIndex !== -1 && typeof values2[keys2[endIndex]] === "number" ? values2[keys2[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys2.indexOf(key) + 1 < keys2.length) {
      return between(key, keys2[keys2.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    const keyIndex = keys2.indexOf(key);
    if (keyIndex === 0) {
      return up(keys2[1]);
    }
    if (keyIndex === keys2.length - 1) {
      return down(keys2[keyIndex]);
    }
    return between(key, keys2[keys2.indexOf(key) + 1]).replace("@media", "@media not all and");
  }
  return _extends$2({
    keys: keys2,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}
const shape = {
  borderRadius: 4
};
const shape$1 = shape;
function createSpacing(spacingInput = 8) {
  if (spacingInput.mui) {
    return spacingInput;
  }
  const transform = createUnarySpacing({
    spacing: spacingInput
  });
  const spacing = (...argsInput) => {
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map((argument) => {
      const output = transform(argument);
      return typeof output === "number" ? `${output}px` : output;
    }).join(" ");
  };
  spacing.mui = true;
  return spacing;
}
const _excluded$8 = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$1(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {}
  } = options, other = _objectWithoutPropertiesLoose$1(options, _excluded$8);
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge({
    breakpoints,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: _extends$2({
      mode: "light"
    }, paletteInput),
    spacing,
    shape: _extends$2({}, shape$1, shapeInput)
  }, other);
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = _extends$2({}, defaultSxConfig$1, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$1({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
const ThemeContext = /* @__PURE__ */ React.createContext(null);
const ThemeContext$1 = ThemeContext;
function useTheme$2() {
  const theme = React.useContext(ThemeContext$1);
  return theme;
}
function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme$1(defaultTheme2 = null) {
  const contextTheme = useTheme$2();
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme2 : contextTheme;
}
const systemDefaultTheme$1 = createTheme$1();
function useTheme(defaultTheme2 = systemDefaultTheme$1) {
  return useTheme$1(defaultTheme2);
}
const _excluded$7 = ["variant"];
function isEmpty$1(string2) {
  return string2.length === 0;
}
function propsToClassKey(props) {
  const {
    variant
  } = props, other = _objectWithoutPropertiesLoose$1(props, _excluded$7);
  let classKey = variant || "";
  Object.keys(other).sort().forEach((key) => {
    if (key === "color") {
      classKey += isEmpty$1(classKey) ? props[key] : capitalize(props[key]);
    } else {
      classKey += `${isEmpty$1(classKey) ? key : capitalize(key)}${capitalize(props[key].toString())}`;
    }
  });
  return classKey;
}
const _excluded$6 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"], _excluded2 = ["theme"], _excluded3 = ["theme"];
function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function isStringTag(tag) {
  return typeof tag === "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}
const getStyleOverrides = (name, theme) => {
  if (theme.components && theme.components[name] && theme.components[name].styleOverrides) {
    return theme.components[name].styleOverrides;
  }
  return null;
};
const getVariantStyles = (name, theme) => {
  let variants = [];
  if (theme && theme.components && theme.components[name] && theme.components[name].variants) {
    variants = theme.components[name].variants;
  }
  const variantsStyles = {};
  variants.forEach((definition2) => {
    const key = propsToClassKey(definition2.props);
    variantsStyles[key] = definition2.style;
  });
  return variantsStyles;
};
const variantsResolver = (props, styles, theme, name) => {
  var _theme$components, _theme$components$nam;
  const {
    ownerState = {}
  } = props;
  const variantsStyles = [];
  const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
  if (themeVariants) {
    themeVariants.forEach((themeVariant) => {
      let isMatch = true;
      Object.keys(themeVariant.props).forEach((key) => {
        if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) {
          isMatch = false;
        }
      });
      if (isMatch) {
        variantsStyles.push(styles[propsToClassKey(themeVariant.props)]);
      }
    });
  }
  return variantsStyles;
};
function shouldForwardProp(prop) {
  return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const systemDefaultTheme = createTheme$1();
function createStyled2(input = {}) {
  const {
    defaultTheme: defaultTheme2 = systemDefaultTheme,
    rootShouldForwardProp: rootShouldForwardProp2 = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp
  } = input;
  const systemSx = (props) => {
    const theme = isEmpty(props.theme) ? defaultTheme2 : props.theme;
    return styleFunctionSx$1(_extends$2({}, props, {
      theme
    }));
  };
  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    internal_processStyles(tag, (styles) => styles.filter((style2) => !(style2 != null && style2.__mui_systemSx)));
    const {
      name: componentName,
      slot: componentSlot,
      skipVariantsResolver: inputSkipVariantsResolver,
      skipSx: inputSkipSx,
      overridesResolver
    } = inputOptions, options = _objectWithoutPropertiesLoose$1(inputOptions, _excluded$6);
    const skipVariantsResolver = inputSkipVariantsResolver !== void 0 ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" || false;
    const skipSx = inputSkipSx || false;
    let label;
    let shouldForwardPropOption = shouldForwardProp;
    if (componentSlot === "Root") {
      shouldForwardPropOption = rootShouldForwardProp2;
    } else if (componentSlot) {
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      shouldForwardPropOption = void 0;
    }
    const defaultStyledResolver = styled$4(tag, _extends$2({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const muiStyledResolver = (styleArg, ...expressions) => {
      const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg) => {
        return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (_ref) => {
          let {
            theme: themeInput
          } = _ref, other = _objectWithoutPropertiesLoose$1(_ref, _excluded2);
          return stylesArg(_extends$2({
            theme: isEmpty(themeInput) ? defaultTheme2 : themeInput
          }, other));
        } : stylesArg;
      }) : [];
      let transformedStyleArg = styleArg;
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push((props) => {
          const theme = isEmpty(props.theme) ? defaultTheme2 : props.theme;
          const styleOverrides = getStyleOverrides(componentName, theme);
          if (styleOverrides) {
            const resolvedStyleOverrides = {};
            Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
              resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle(_extends$2({}, props, {
                theme
              })) : slotStyle;
            });
            return overridesResolver(props, resolvedStyleOverrides);
          }
          return null;
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push((props) => {
          const theme = isEmpty(props.theme) ? defaultTheme2 : props.theme;
          return variantsResolver(props, getVariantStyles(componentName, theme), theme, componentName);
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill("");
        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      styleArg.__emotion_real !== styleArg) {
        transformedStyleArg = (_ref2) => {
          let {
            theme: themeInput
          } = _ref2, other = _objectWithoutPropertiesLoose$1(_ref2, _excluded3);
          return styleArg(_extends$2({
            theme: isEmpty(themeInput) ? defaultTheme2 : themeInput
          }, other));
        };
      }
      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}
const styled$2 = createStyled2();
const styled$3 = styled$2;
function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return resolveProps(theme.components[name].defaultProps, props);
}
function useThemeProps$1({
  props,
  name,
  defaultTheme: defaultTheme2
}) {
  const theme = useTheme(defaultTheme2);
  const mergedProps = getThemeProps({
    theme,
    name,
    props
  });
  return mergedProps;
}
function clamp(value, min2 = 0, max2 = 1) {
  return Math.min(Math.max(min2, value), max2);
}
function hexToRgb(color2) {
  color2 = color2.slice(1);
  const re = new RegExp(`.{1,${color2.length >= 6 ? 2 : 1}}`, "g");
  let colors = color2.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map((n2) => n2 + n2);
  }
  return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n2, index2) => {
    return index2 < 3 ? parseInt(n2, 16) : Math.round(parseInt(n2, 16) / 255 * 1e3) / 1e3;
  }).join(", ")})` : "";
}
function decomposeColor(color2) {
  if (color2.type) {
    return color2;
  }
  if (color2.charAt(0) === "#") {
    return decomposeColor(hexToRgb(color2));
  }
  const marker = color2.indexOf("(");
  const type = color2.substring(0, marker);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(type) === -1) {
    throw new Error(formatMuiErrorMessage(9, color2));
  }
  let values2 = color2.substring(marker + 1, color2.length - 1);
  let colorSpace;
  if (type === "color") {
    values2 = values2.split(" ");
    colorSpace = values2.shift();
    if (values2.length === 4 && values2[3].charAt(0) === "/") {
      values2[3] = values2[3].slice(1);
    }
    if (["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(colorSpace) === -1) {
      throw new Error(formatMuiErrorMessage(10, colorSpace));
    }
  } else {
    values2 = values2.split(",");
  }
  values2 = values2.map((value) => parseFloat(value));
  return {
    type,
    values: values2,
    colorSpace
  };
}
function recomposeColor(color2) {
  const {
    type,
    colorSpace
  } = color2;
  let {
    values: values2
  } = color2;
  if (type.indexOf("rgb") !== -1) {
    values2 = values2.map((n2, i) => i < 3 ? parseInt(n2, 10) : n2);
  } else if (type.indexOf("hsl") !== -1) {
    values2[1] = `${values2[1]}%`;
    values2[2] = `${values2[2]}%`;
  }
  if (type.indexOf("color") !== -1) {
    values2 = `${colorSpace} ${values2.join(" ")}`;
  } else {
    values2 = `${values2.join(", ")}`;
  }
  return `${type}(${values2})`;
}
function hslToRgb(color2) {
  color2 = decomposeColor(color2);
  const {
    values: values2
  } = color2;
  const h2 = values2[0];
  const s = values2[1] / 100;
  const l2 = values2[2] / 100;
  const a = s * Math.min(l2, 1 - l2);
  const f2 = (n2, k2 = (n2 + h2 / 30) % 12) => l2 - a * Math.max(Math.min(k2 - 3, 9 - k2, 1), -1);
  let type = "rgb";
  const rgb = [Math.round(f2(0) * 255), Math.round(f2(8) * 255), Math.round(f2(4) * 255)];
  if (color2.type === "hsla") {
    type += "a";
    rgb.push(values2[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
function getLuminance(color2) {
  color2 = decomposeColor(color2);
  let rgb = color2.type === "hsl" || color2.type === "hsla" ? decomposeColor(hslToRgb(color2)).values : color2.values;
  rgb = rgb.map((val) => {
    if (color2.type !== "color") {
      val /= 255;
    }
    return val <= 0.03928 ? val / 12.92 : __pow((val + 0.055) / 1.055, 2.4);
  });
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function darken(color2, coefficient) {
  color2 = decomposeColor(color2);
  coefficient = clamp(coefficient);
  if (color2.type.indexOf("hsl") !== -1) {
    color2.values[2] *= 1 - coefficient;
  } else if (color2.type.indexOf("rgb") !== -1 || color2.type.indexOf("color") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color2);
}
function lighten(color2, coefficient) {
  color2 = decomposeColor(color2);
  coefficient = clamp(coefficient);
  if (color2.type.indexOf("hsl") !== -1) {
    color2.values[2] += (100 - color2.values[2]) * coefficient;
  } else if (color2.type.indexOf("rgb") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] += (255 - color2.values[i]) * coefficient;
    }
  } else if (color2.type.indexOf("color") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] += (1 - color2.values[i]) * coefficient;
    }
  }
  return recomposeColor(color2);
}
function createMixins(breakpoints, mixins) {
  return _extends$2({
    toolbar: {
      minHeight: 56,
      [breakpoints.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [breakpoints.up("sm")]: {
        minHeight: 64
      }
    }
  }, mixins);
}
const common = {
  black: "#000",
  white: "#fff"
};
const common$1 = common;
const grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
const grey$1 = grey;
const purple = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
};
const purple$1 = purple;
const red = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
};
const red$1 = red;
const orange = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
};
const orange$1 = orange;
const blue = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
};
const blue$1 = blue;
const lightBlue = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
};
const lightBlue$1 = lightBlue;
const green = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
const green$1 = green;
const _excluded$5 = ["mode", "contrastThreshold", "tonalOffset"];
const light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$1.white,
    default: common$1.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = {
  text: {
    primary: common$1.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: common$1.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === "light") {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === "dark") {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}
function getDefaultPrimary(mode = "light") {
  if (mode === "dark") {
    return {
      main: blue$1[200],
      light: blue$1[50],
      dark: blue$1[400]
    };
  }
  return {
    main: blue$1[700],
    light: blue$1[400],
    dark: blue$1[800]
  };
}
function getDefaultSecondary(mode = "light") {
  if (mode === "dark") {
    return {
      main: purple$1[200],
      light: purple$1[50],
      dark: purple$1[400]
    };
  }
  return {
    main: purple$1[500],
    light: purple$1[300],
    dark: purple$1[700]
  };
}
function getDefaultError(mode = "light") {
  if (mode === "dark") {
    return {
      main: red$1[500],
      light: red$1[300],
      dark: red$1[700]
    };
  }
  return {
    main: red$1[700],
    light: red$1[400],
    dark: red$1[800]
  };
}
function getDefaultInfo(mode = "light") {
  if (mode === "dark") {
    return {
      main: lightBlue$1[400],
      light: lightBlue$1[300],
      dark: lightBlue$1[700]
    };
  }
  return {
    main: lightBlue$1[700],
    light: lightBlue$1[500],
    dark: lightBlue$1[900]
  };
}
function getDefaultSuccess(mode = "light") {
  if (mode === "dark") {
    return {
      main: green$1[400],
      light: green$1[300],
      dark: green$1[700]
    };
  }
  return {
    main: green$1[800],
    light: green$1[500],
    dark: green$1[900]
  };
}
function getDefaultWarning(mode = "light") {
  if (mode === "dark") {
    return {
      main: orange$1[400],
      light: orange$1[300],
      dark: orange$1[700]
    };
  }
  return {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange$1[500],
    dark: orange$1[900]
  };
}
function createPalette(palette2) {
  const {
    mode = "light",
    contrastThreshold = 3,
    tonalOffset = 0.2
  } = palette2, other = _objectWithoutPropertiesLoose$1(palette2, _excluded$5);
  const primary = palette2.primary || getDefaultPrimary(mode);
  const secondary = palette2.secondary || getDefaultSecondary(mode);
  const error = palette2.error || getDefaultError(mode);
  const info = palette2.info || getDefaultInfo(mode);
  const success = palette2.success || getDefaultSuccess(mode);
  const warning = palette2.warning || getDefaultWarning(mode);
  function getContrastText(background) {
    const contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    return contrastText;
  }
  const augmentColor = ({
    color: color2,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color2 = _extends$2({}, color2);
    if (!color2.main && color2[mainShade]) {
      color2.main = color2[mainShade];
    }
    if (!color2.hasOwnProperty("main")) {
      throw new Error(formatMuiErrorMessage(11, name ? ` (${name})` : "", mainShade));
    }
    if (typeof color2.main !== "string") {
      throw new Error(formatMuiErrorMessage(12, name ? ` (${name})` : "", JSON.stringify(color2.main)));
    }
    addLightOrDark(color2, "light", lightShade, tonalOffset);
    addLightOrDark(color2, "dark", darkShade, tonalOffset);
    if (!color2.contrastText) {
      color2.contrastText = getContrastText(color2.main);
    }
    return color2;
  };
  const modes = {
    dark,
    light
  };
  const paletteOutput = deepmerge(_extends$2({
    // A collection of common colors.
    common: _extends$2({}, common$1),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: "success"
    }),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}
const _excluded$4 = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette2, typography2) {
  const _ref = typeof typography2 === "function" ? typography2(palette2) : typography2, {
    fontFamily = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize = 14,
    // px
    fontWeightLight = 300,
    fontWeightRegular = 400,
    fontWeightMedium = 500,
    fontWeightBold = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16,
    // Apply the CSS properties to all the variants.
    allVariants,
    pxToRem: pxToRem2
  } = _ref, other = _objectWithoutPropertiesLoose$1(_ref, _excluded$4);
  const coef = fontSize / 14;
  const pxToRem = pxToRem2 || ((size) => `${size / htmlFontSize * coef}rem`);
  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => _extends$2({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight
  }, fontFamily === defaultFontFamily ? {
    letterSpacing: `${round(letterSpacing / size)}em`
  } : {}, casing, allVariants);
  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge(_extends$2({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
const shadows$1 = shadows;
const _excluded$3 = ["duration", "easing", "delay"];
const easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds2) {
  return `${Math.round(milliseconds2)}ms`;
}
function getAutoHeightDuration(height2) {
  if (!height2) {
    return 0;
  }
  const constant = height2 / 36;
  return Math.round((4 + 15 * __pow(constant, 0.25) + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
  const mergedEasing = _extends$2({}, easing, inputTransitions.easing);
  const mergedDuration = _extends$2({}, duration, inputTransitions.duration);
  const create2 = (props = ["all"], options = {}) => {
    const {
      duration: durationOption = mergedDuration.standard,
      easing: easingOption = mergedEasing.easeInOut,
      delay = 0
    } = options;
    _objectWithoutPropertiesLoose$1(options, _excluded$3);
    return (Array.isArray(props) ? props : [props]).map((animatedProp) => `${animatedProp} ${typeof durationOption === "string" ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : formatMs(delay)}`).join(",");
  };
  return _extends$2({
    getAutoHeightDuration,
    create: create2
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
const zIndex$1 = zIndex;
const _excluded$2 = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function createTheme(options = {}, ...args) {
  const {
    mixins: mixinsInput = {},
    palette: paletteInput = {},
    transitions: transitionsInput = {},
    typography: typographyInput = {}
  } = options, other = _objectWithoutPropertiesLoose$1(options, _excluded$2);
  if (options.vars) {
    throw new Error(formatMuiErrorMessage(18));
  }
  const palette2 = createPalette(paletteInput);
  const systemTheme = createTheme$1(options);
  let muiTheme = deepmerge(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette: palette2,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows$1.slice(),
    typography: createTypography(palette2, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: _extends$2({}, zIndex$1)
  });
  muiTheme = deepmerge(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = _extends$2({}, defaultSxConfig$1, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$1({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
const defaultTheme = createTheme();
const defaultTheme$1 = defaultTheme;
function useThemeProps({
  props,
  name
}) {
  return useThemeProps$1({
    props,
    name,
    defaultTheme: defaultTheme$1
  });
}
const rootShouldForwardProp = (prop) => shouldForwardProp(prop) && prop !== "classes";
const styled = createStyled2({
  defaultTheme: defaultTheme$1,
  rootShouldForwardProp
});
const styled$1 = styled;
const palette = {
  primary: {
    main: "#000"
  },
  secondary: {
    main: "rgb(51, 51, 51, 0.05)"
    // gray-light
  },
  tertiary: {
    main: "#F2F3F4"
    // gray
  },
  brand: {
    "gray-dark": "rgb(51, 51, 51)",
    "gray-light": "rgb(51, 51, 51, 0.05)",
    gray: "#F2F3F4",
    white: "#FFFFFF",
    green: "#1E9738",
    errorRed: "#CB0000",
    orange: "#FFA500",
    cyan: "#00D1FF",
    blue: "#2C7DF7",
    bgColor: "#F5F5F5",
    bgAlertYellow: "#FFFBE1",
    50: "rgba(51, 51, 51, 0.04)",
    // lightest
    100: "rgba(51, 51, 51, 0.06)",
    200: "rgba(51, 51, 51, 0.08)",
    300: "rgba(51, 51, 51, 0.16)",
    400: "rgba(51, 51, 51, 0.24)",
    500: "rgba(51, 51, 51, 0.36)",
    600: "rgba(51, 51, 51, 0.48)",
    700: "rgba(51, 51, 51, 0.64)",
    800: "rgba(51, 51, 51, 0.80)",
    900: "rgba(51, 51, 51, 0.92)"
    // darkest
  }
};
const components = {
  MuiLink: {
    styleOverrides: {
      root: {
        "&.Mui-focusVisible": {
          boxShadow: "none"
        }
      }
    }
  },
  MuiTypography: {
    defaultProps: {
      fontWeight: 400
    }
  },
  MuiAlert: {
    styleOverrides: {
      root: {
        fontSize: "0.9rem",
        fontWeight: 700
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: "unset",
        marginBottom: "0px",
        "&:hover": {
          opacity: 0.75
        }
      },
      containedPrimary: {
        backgroundColor: "primary",
        color: "white",
        "&:hover, &:focus, &:active": {
          color: "white !important"
          // Needed to override @coinlist/css-framework's hover color
        }
      },
      outlinedPrimary: {
        backgroundColor: "secondary",
        color: "black",
        "&:hover, &:focus, &:active": {
          color: "#696969 !important",
          // Needed to override @coinlist/css-framework's hover color
          border: "1px solid #696969"
        }
      },
      sizeSmall: {
        height: "49px"
      },
      sizeMedium: {
        height: "48px"
      },
      sizeLarge: {
        height: "56px"
      }
    }
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
      // The @coinlist/css-framework package unfortunately globally targets all <button /> elements.
      //   It is hard to override these styles in the css-framework library using a pattern such as
      //   <div className="c-cssReset">
      //     <button>...</button>
      //   </div>
      //   because by changing the selector in the css-framework library from button {...} to
      //   button:not(.c-cssReset) {...} , there are other unintended consequences elsewhere in the
      //   application. The best solution is to override the styles in the css-framework library
      //   using the following css reset.
      sx: {
        // Select items that are MuiMenuItem-root but not MuiButtonBase-root
        "&.MuiButtonBase-root:not(.MuiMenuItem-root)": {
          borderRadius: "9999px",
          fontWeight: 800
        },
        // Only apply to elements that also have class MuiButtonBase-root
        "&.MuiButtonBase-root": {
          fontSize: "14px",
          backgroundImage: "unset",
          boxShadow: "none",
          "&:hover, &:focus, &:active": {
            boxShadow: "none",
            backgroundImage: "unset"
          }
        },
        "&.MuiButtonBase-root.Mui-disabled": {
          backgroundImage: "unset"
        }
      }
    }
  },
  MuiInputBase: {
    defaultProps: {
      sx: {
        borderWidth: "0px",
        borderRadius: "12px",
        borderColor: palette.brand["300"],
        "& input": {
          height: "inherit"
          // override input height set by @coinlist/css-framework
        }
      }
    }
  },
  // Modify for FormLabel
  MuiFormLabel: {
    defaultProps: {
      // We have to unset default styles set to <label /> @coinilst/css-framework
      sx: {
        letterSpacing: "unset",
        textTransform: "unset",
        fontWeight: "400",
        fontFamily: "ES-Build, -apple-system, sans-serif"
      }
    },
    styleOverrides: {
      root: {
        "&.kyc_form": {
          color: palette.primary.main,
          fontWeight: 700,
          display: "inline-flex"
        }
      }
    }
  },
  MuiFormControlLabel: {
    defaultProps: {
      // We have to unset default styles applied to all <label /> elements by @coinilst/css-framework
      sx: {
        letterSpacing: "unset",
        textTransform: "unset",
        fontWeight: "400",
        fontFamily: "ES-Build, -apple-system, sans-serif",
        color: palette.primary.main
      }
    }
  },
  MuiFormHelperText: {
    defaultProps: {
      sx: {
        color: palette.brand.errorRed
      }
    }
  },
  MuiContainer: {
    defaultProps: {
      disableGutters: true
    },
    styleOverrides: {
      root: {
        // Applies to the `xs` variant of the `Container` component
        [`& .MuiContainer-maxWidth-xs`]: {
          maxWidth: "470px"
        },
        // Applies to the `sm` variant of the `Container` component
        [`& .MuiContainer-maxWidth-sm`]: {
          maxWidth: "640px"
        },
        // Applies to the `md` variant of the `Container` component
        [`& .MuiContainer-maxWidth-md`]: {
          maxWidth: "768px"
        },
        // Applies to the `lg` variant of the `Container` component
        [`& .MuiContainer-maxWidth-lg`]: {
          maxWidth: "1024px"
        },
        // Applies to the `xl` variant of the `Container` component
        [`& .MuiContainer-maxWidth-xl`]: {
          maxWidth: "1280px"
        }
      }
    }
  }
};
const typography = {
  htmlFontSize: 16,
  fontFamily: "ABCDiatype, -apple-system, sans-serif",
  fontSmoothing: "antialiased",
  button: {
    textTransform: "none"
  },
  h1: {
    fontSize: "4rem",
    fontWeight: "bold",
    lineHeight: 1.2
  },
  body1: {
    fontSize: "1rem",
    lineHeight: 1.5
  },
  body2: {
    fontSize: "2em",
    lineHeight: 1.5,
    fontFamily: "ES-Build, -apple-system, sans-serif",
    fontWeight: 600
  },
  subtitle1: {
    fontSize: "0.9rem",
    lineHeight: 1.5,
    color: palette.brand[900]
  },
  subtitle2: {
    fontSize: "0.75rem",
    lineHeight: 1.5,
    color: palette.brand[800]
  }
};
const MuiTheme = createTheme({
  components,
  typography,
  palette
});
const MuiTheme$1 = MuiTheme;
const protocols = ["http", "https", "mailto", "tel"];
function uriTransformer(uri) {
  const url = (uri || "").trim();
  const first = url.charAt(0);
  if (first === "#" || first === "/") {
    return url;
  }
  const colon = url.indexOf(":");
  if (colon === -1) {
    return url;
  }
  let index2 = -1;
  while (++index2 < protocols.length) {
    const protocol = protocols[index2];
    if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) {
      return url;
    }
  }
  index2 = url.indexOf("?");
  if (index2 !== -1 && colon > index2) {
    return url;
  }
  index2 = url.indexOf("#");
  if (index2 !== -1 && colon > index2) {
    return url;
  }
  return "javascript:void(0)";
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var isBuffer = function isBuffer2(obj) {
  return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};
const isBuffer$1 = /* @__PURE__ */ getDefaultExportFromCjs(isBuffer);
function stringifyPosition(value) {
  if (!value || typeof value !== "object") {
    return "";
  }
  if ("position" in value || "type" in value) {
    return position$1(value.position);
  }
  if ("start" in value || "end" in value) {
    return position$1(value);
  }
  if ("line" in value || "column" in value) {
    return point$2(value);
  }
  return "";
}
function point$2(point2) {
  return index(point2 && point2.line) + ":" + index(point2 && point2.column);
}
function position$1(pos) {
  return point$2(pos && pos.start) + "-" + point$2(pos && pos.end);
}
function index(value) {
  return value && typeof value === "number" ? value : 1;
}
class VFileMessage extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // To do: next major: expose `undefined` everywhere instead of `null`.
  constructor(reason, place, origin) {
    const parts = [null, null];
    let position2 = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: { line: null, column: null },
      // @ts-expect-error: "
      end: { line: null, column: null }
    };
    super();
    if (typeof place === "string") {
      origin = place;
      place = void 0;
    }
    if (typeof origin === "string") {
      const index2 = origin.indexOf(":");
      if (index2 === -1) {
        parts[1] = origin;
      } else {
        parts[0] = origin.slice(0, index2);
        parts[1] = origin.slice(index2 + 1);
      }
    }
    if (place) {
      if ("type" in place || "position" in place) {
        if (place.position) {
          position2 = place.position;
        }
      } else if ("start" in place || "end" in place) {
        position2 = place;
      } else if ("line" in place || "column" in place) {
        position2.start = place;
      }
    }
    this.name = stringifyPosition(place) || "1:1";
    this.message = typeof reason === "object" ? reason.message : reason;
    this.stack = "";
    if (typeof reason === "object" && reason.stack) {
      this.stack = reason.stack;
    }
    this.reason = this.message;
    this.fatal;
    this.line = position2.start.line;
    this.column = position2.start.column;
    this.position = position2;
    this.source = parts[0];
    this.ruleId = parts[1];
    this.file;
    this.actual;
    this.expected;
    this.url;
    this.note;
  }
}
VFileMessage.prototype.file = "";
VFileMessage.prototype.name = "";
VFileMessage.prototype.reason = "";
VFileMessage.prototype.message = "";
VFileMessage.prototype.stack = "";
VFileMessage.prototype.fatal = null;
VFileMessage.prototype.column = null;
VFileMessage.prototype.line = null;
VFileMessage.prototype.source = null;
VFileMessage.prototype.ruleId = null;
VFileMessage.prototype.position = null;
const path = { basename, dirname, extname, join, sep: "/" };
function basename(path2, ext) {
  if (ext !== void 0 && typeof ext !== "string") {
    throw new TypeError('"ext" argument must be a string');
  }
  assertPath$1(path2);
  let start = 0;
  let end = -1;
  let index2 = path2.length;
  let seenNonSlash;
  if (ext === void 0 || ext.length === 0 || ext.length > path2.length) {
    while (index2--) {
      if (path2.charCodeAt(index2) === 47) {
        if (seenNonSlash) {
          start = index2 + 1;
          break;
        }
      } else if (end < 0) {
        seenNonSlash = true;
        end = index2 + 1;
      }
    }
    return end < 0 ? "" : path2.slice(start, end);
  }
  if (ext === path2) {
    return "";
  }
  let firstNonSlashEnd = -1;
  let extIndex = ext.length - 1;
  while (index2--) {
    if (path2.charCodeAt(index2) === 47) {
      if (seenNonSlash) {
        start = index2 + 1;
        break;
      }
    } else {
      if (firstNonSlashEnd < 0) {
        seenNonSlash = true;
        firstNonSlashEnd = index2 + 1;
      }
      if (extIndex > -1) {
        if (path2.charCodeAt(index2) === ext.charCodeAt(extIndex--)) {
          if (extIndex < 0) {
            end = index2;
          }
        } else {
          extIndex = -1;
          end = firstNonSlashEnd;
        }
      }
    }
  }
  if (start === end) {
    end = firstNonSlashEnd;
  } else if (end < 0) {
    end = path2.length;
  }
  return path2.slice(start, end);
}
function dirname(path2) {
  assertPath$1(path2);
  if (path2.length === 0) {
    return ".";
  }
  let end = -1;
  let index2 = path2.length;
  let unmatchedSlash;
  while (--index2) {
    if (path2.charCodeAt(index2) === 47) {
      if (unmatchedSlash) {
        end = index2;
        break;
      }
    } else if (!unmatchedSlash) {
      unmatchedSlash = true;
    }
  }
  return end < 0 ? path2.charCodeAt(0) === 47 ? "/" : "." : end === 1 && path2.charCodeAt(0) === 47 ? "//" : path2.slice(0, end);
}
function extname(path2) {
  assertPath$1(path2);
  let index2 = path2.length;
  let end = -1;
  let startPart = 0;
  let startDot = -1;
  let preDotState = 0;
  let unmatchedSlash;
  while (index2--) {
    const code2 = path2.charCodeAt(index2);
    if (code2 === 47) {
      if (unmatchedSlash) {
        startPart = index2 + 1;
        break;
      }
      continue;
    }
    if (end < 0) {
      unmatchedSlash = true;
      end = index2 + 1;
    }
    if (code2 === 46) {
      if (startDot < 0) {
        startDot = index2;
      } else if (preDotState !== 1) {
        preDotState = 1;
      }
    } else if (startDot > -1) {
      preDotState = -1;
    }
  }
  if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
  preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
  preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return "";
  }
  return path2.slice(startDot, end);
}
function join(...segments) {
  let index2 = -1;
  let joined;
  while (++index2 < segments.length) {
    assertPath$1(segments[index2]);
    if (segments[index2]) {
      joined = joined === void 0 ? segments[index2] : joined + "/" + segments[index2];
    }
  }
  return joined === void 0 ? "." : normalize$1(joined);
}
function normalize$1(path2) {
  assertPath$1(path2);
  const absolute = path2.charCodeAt(0) === 47;
  let value = normalizeString(path2, !absolute);
  if (value.length === 0 && !absolute) {
    value = ".";
  }
  if (value.length > 0 && path2.charCodeAt(path2.length - 1) === 47) {
    value += "/";
  }
  return absolute ? "/" + value : value;
}
function normalizeString(path2, allowAboveRoot) {
  let result = "";
  let lastSegmentLength = 0;
  let lastSlash = -1;
  let dots = 0;
  let index2 = -1;
  let code2;
  let lastSlashIndex;
  while (++index2 <= path2.length) {
    if (index2 < path2.length) {
      code2 = path2.charCodeAt(index2);
    } else if (code2 === 47) {
      break;
    } else {
      code2 = 47;
    }
    if (code2 === 47) {
      if (lastSlash === index2 - 1 || dots === 1)
        ;
      else if (lastSlash !== index2 - 1 && dots === 2) {
        if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 || result.charCodeAt(result.length - 2) !== 46) {
          if (result.length > 2) {
            lastSlashIndex = result.lastIndexOf("/");
            if (lastSlashIndex !== result.length - 1) {
              if (lastSlashIndex < 0) {
                result = "";
                lastSegmentLength = 0;
              } else {
                result = result.slice(0, lastSlashIndex);
                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
              }
              lastSlash = index2;
              dots = 0;
              continue;
            }
          } else if (result.length > 0) {
            result = "";
            lastSegmentLength = 0;
            lastSlash = index2;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          result = result.length > 0 ? result + "/.." : "..";
          lastSegmentLength = 2;
        }
      } else {
        if (result.length > 0) {
          result += "/" + path2.slice(lastSlash + 1, index2);
        } else {
          result = path2.slice(lastSlash + 1, index2);
        }
        lastSegmentLength = index2 - lastSlash - 1;
      }
      lastSlash = index2;
      dots = 0;
    } else if (code2 === 46 && dots > -1) {
      dots++;
    } else {
      dots = -1;
    }
  }
  return result;
}
function assertPath$1(path2) {
  if (typeof path2 !== "string") {
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(path2)
    );
  }
}
const proc = { cwd };
function cwd() {
  return "/";
}
function isUrl(fileUrlOrPath) {
  return fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && // @ts-expect-error: indexable.
  fileUrlOrPath.href && // @ts-expect-error: indexable.
  fileUrlOrPath.origin;
}
function urlToPath(path2) {
  if (typeof path2 === "string") {
    path2 = new URL(path2);
  } else if (!isUrl(path2)) {
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + path2 + "`"
    );
    error.code = "ERR_INVALID_ARG_TYPE";
    throw error;
  }
  if (path2.protocol !== "file:") {
    const error = new TypeError("The URL must be of scheme file");
    error.code = "ERR_INVALID_URL_SCHEME";
    throw error;
  }
  return getPathFromURLPosix(path2);
}
function getPathFromURLPosix(url) {
  if (url.hostname !== "") {
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    error.code = "ERR_INVALID_FILE_URL_HOST";
    throw error;
  }
  const pathname = url.pathname;
  let index2 = -1;
  while (++index2 < pathname.length) {
    if (pathname.charCodeAt(index2) === 37 && pathname.charCodeAt(index2 + 1) === 50) {
      const third = pathname.charCodeAt(index2 + 2);
      if (third === 70 || third === 102) {
        const error = new TypeError(
          "File URL path must not include encoded / characters"
        );
        error.code = "ERR_INVALID_FILE_URL_PATH";
        throw error;
      }
    }
  }
  return decodeURIComponent(pathname);
}
const order = ["history", "path", "basename", "stem", "extname", "dirname"];
class VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(value) {
    let options;
    if (!value) {
      options = {};
    } else if (typeof value === "string" || buffer(value)) {
      options = { value };
    } else if (isUrl(value)) {
      options = { path: value };
    } else {
      options = value;
    }
    this.data = {};
    this.messages = [];
    this.history = [];
    this.cwd = proc.cwd();
    this.value;
    this.stored;
    this.result;
    this.map;
    let index2 = -1;
    while (++index2 < order.length) {
      const prop2 = order[index2];
      if (prop2 in options && options[prop2] !== void 0 && options[prop2] !== null) {
        this[prop2] = prop2 === "history" ? [...options[prop2]] : options[prop2];
      }
    }
    let prop;
    for (prop in options) {
      if (!order.includes(prop)) {
        this[prop] = options[prop];
      }
    }
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */
  set path(path2) {
    if (isUrl(path2)) {
      path2 = urlToPath(path2);
    }
    assertNonEmpty(path2, "path");
    if (this.path !== path2) {
      this.history.push(path2);
    }
  }
  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path === "string" ? path.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(dirname2) {
    assertPath(this.basename, "dirname");
    this.path = path.join(dirname2 || "", this.basename);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path === "string" ? path.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(basename2) {
    assertNonEmpty(basename2, "basename");
    assertPart(basename2, "basename");
    this.path = path.join(this.dirname || "", basename2);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path === "string" ? path.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(extname2) {
    assertPart(extname2, "extname");
    assertPath(this.dirname, "extname");
    if (extname2) {
      if (extname2.charCodeAt(0) !== 46) {
        throw new Error("`extname` must start with `.`");
      }
      if (extname2.includes(".", 1)) {
        throw new Error("`extname` cannot contain multiple dots");
      }
    }
    this.path = path.join(this.dirname, this.stem + (extname2 || ""));
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path === "string" ? path.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(stem) {
    assertNonEmpty(stem, "stem");
    assertPart(stem, "stem");
    this.path = path.join(this.dirname || "", stem + (this.extname || ""));
  }
  /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    return (this.value || "").toString(encoding || void 0);
  }
  /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(reason, place, origin) {
    const message = new VFileMessage(reason, place, origin);
    if (this.path) {
      message.name = this.path + ":" + message.name;
      message.file = this.path;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
  }
  /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(reason, place, origin) {
    const message = this.message(reason, place, origin);
    message.fatal = null;
    return message;
  }
  /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(reason, place, origin) {
    const message = this.message(reason, place, origin);
    message.fatal = true;
    throw message;
  }
}
function assertPart(part, name) {
  if (part && part.includes(path.sep)) {
    throw new Error(
      "`" + name + "` cannot be a path: did not expect `" + path.sep + "`"
    );
  }
}
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error("`" + name + "` cannot be empty");
  }
}
function assertPath(path2, name) {
  if (!path2) {
    throw new Error("Setting `" + name + "` requires `path` to be set too");
  }
}
function buffer(value) {
  return isBuffer$1(value);
}
function bail(error) {
  if (error) {
    throw error;
  }
}
var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;
var isArray = function isArray2(arr) {
  if (typeof Array.isArray === "function") {
    return Array.isArray(arr);
  }
  return toStr.call(arr) === "[object Array]";
};
var isPlainObject$2 = function isPlainObject(obj) {
  if (!obj || toStr.call(obj) !== "[object Object]") {
    return false;
  }
  var hasOwnConstructor = hasOwn.call(obj, "constructor");
  var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
  if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
    return false;
  }
  var key;
  for (key in obj) {
  }
  return typeof key === "undefined" || hasOwn.call(obj, key);
};
var setProperty = function setProperty2(target, options) {
  if (defineProperty && options.name === "__proto__") {
    defineProperty(target, options.name, {
      enumerable: true,
      configurable: true,
      value: options.newValue,
      writable: true
    });
  } else {
    target[options.name] = options.newValue;
  }
};
var getProperty = function getProperty2(obj, name) {
  if (name === "__proto__") {
    if (!hasOwn.call(obj, name)) {
      return void 0;
    } else if (gOPD) {
      return gOPD(obj, name).value;
    }
  }
  return obj[name];
};
var extend = function extend2() {
  var options, name, src, copy2, copyIsArray, clone2;
  var target = arguments[0];
  var i = 1;
  var length2 = arguments.length;
  var deep = false;
  if (typeof target === "boolean") {
    deep = target;
    target = arguments[1] || {};
    i = 2;
  }
  if (target == null || typeof target !== "object" && typeof target !== "function") {
    target = {};
  }
  for (; i < length2; ++i) {
    options = arguments[i];
    if (options != null) {
      for (name in options) {
        src = getProperty(target, name);
        copy2 = getProperty(options, name);
        if (target !== copy2) {
          if (deep && copy2 && (isPlainObject$2(copy2) || (copyIsArray = isArray(copy2)))) {
            if (copyIsArray) {
              copyIsArray = false;
              clone2 = src && isArray(src) ? src : [];
            } else {
              clone2 = src && isPlainObject$2(src) ? src : {};
            }
            setProperty(target, { name, newValue: extend2(deep, clone2, copy2) });
          } else if (typeof copy2 !== "undefined") {
            setProperty(target, { name, newValue: copy2 });
          }
        }
      }
    }
  }
  return target;
};
const extend$1 = /* @__PURE__ */ getDefaultExportFromCjs(extend);
function isPlainObject$1(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}
function trough() {
  const fns = [];
  const pipeline = { run, use };
  return pipeline;
  function run(...values2) {
    let middlewareIndex = -1;
    const callback = values2.pop();
    if (typeof callback !== "function") {
      throw new TypeError("Expected function as last argument, not " + callback);
    }
    next2(null, ...values2);
    function next2(error, ...output) {
      const fn = fns[++middlewareIndex];
      let index2 = -1;
      if (error) {
        callback(error);
        return;
      }
      while (++index2 < values2.length) {
        if (output[index2] === null || output[index2] === void 0) {
          output[index2] = values2[index2];
        }
      }
      values2 = output;
      if (fn) {
        wrap$1(fn, next2)(...output);
      } else {
        callback(null, ...output);
      }
    }
  }
  function use(middelware) {
    if (typeof middelware !== "function") {
      throw new TypeError(
        "Expected `middelware` to be a function, not " + middelware
      );
    }
    fns.push(middelware);
    return pipeline;
  }
}
function wrap$1(middleware2, callback) {
  let called;
  return wrapped;
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware2.length > parameters.length;
    let result;
    if (fnExpectsCallback) {
      parameters.push(done);
    }
    try {
      result = middleware2.apply(this, parameters);
    } catch (error) {
      const exception = (
        /** @type {Error} */
        error
      );
      if (fnExpectsCallback && called) {
        throw exception;
      }
      return done(exception);
    }
    if (!fnExpectsCallback) {
      if (result instanceof Promise) {
        result.then(then, done);
      } else if (result instanceof Error) {
        done(result);
      } else {
        then(result);
      }
    }
  }
  function done(error, ...output) {
    if (!called) {
      called = true;
      callback(error, ...output);
    }
  }
  function then(value) {
    done(null, value);
  }
}
const unified = base().freeze();
const own$6 = {}.hasOwnProperty;
function base() {
  const transformers = trough();
  const attachers = [];
  let namespace = {};
  let frozen;
  let freezeIndex = -1;
  processor.data = data;
  processor.Parser = void 0;
  processor.Compiler = void 0;
  processor.freeze = freeze;
  processor.attachers = attachers;
  processor.use = use;
  processor.parse = parse2;
  processor.stringify = stringify2;
  processor.run = run;
  processor.runSync = runSync;
  processor.process = process;
  processor.processSync = processSync;
  return processor;
  function processor() {
    const destination = base();
    let index2 = -1;
    while (++index2 < attachers.length) {
      destination.use(...attachers[index2]);
    }
    destination.data(extend$1(true, {}, namespace));
    return destination;
  }
  function data(key, value) {
    if (typeof key === "string") {
      if (arguments.length === 2) {
        assertUnfrozen("data", frozen);
        namespace[key] = value;
        return processor;
      }
      return own$6.call(namespace, key) && namespace[key] || null;
    }
    if (key) {
      assertUnfrozen("data", frozen);
      namespace = key;
      return processor;
    }
    return namespace;
  }
  function freeze() {
    if (frozen) {
      return processor;
    }
    while (++freezeIndex < attachers.length) {
      const [attacher, ...options] = attachers[freezeIndex];
      if (options[0] === false) {
        continue;
      }
      if (options[0] === true) {
        options[0] = void 0;
      }
      const transformer = attacher.call(processor, ...options);
      if (typeof transformer === "function") {
        transformers.use(transformer);
      }
    }
    frozen = true;
    freezeIndex = Number.POSITIVE_INFINITY;
    return processor;
  }
  function use(value, ...options) {
    let settings;
    assertUnfrozen("use", frozen);
    if (value === null || value === void 0)
      ;
    else if (typeof value === "function") {
      addPlugin(value, ...options);
    } else if (typeof value === "object") {
      if (Array.isArray(value)) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new TypeError("Expected usable value, not `" + value + "`");
    }
    if (settings) {
      namespace.settings = Object.assign(namespace.settings || {}, settings);
    }
    return processor;
    function add2(value2) {
      if (typeof value2 === "function") {
        addPlugin(value2);
      } else if (typeof value2 === "object") {
        if (Array.isArray(value2)) {
          const [plugin, ...options2] = value2;
          addPlugin(plugin, ...options2);
        } else {
          addPreset(value2);
        }
      } else {
        throw new TypeError("Expected usable value, not `" + value2 + "`");
      }
    }
    function addPreset(result) {
      addList(result.plugins);
      if (result.settings) {
        settings = Object.assign(settings || {}, result.settings);
      }
    }
    function addList(plugins) {
      let index2 = -1;
      if (plugins === null || plugins === void 0)
        ;
      else if (Array.isArray(plugins)) {
        while (++index2 < plugins.length) {
          const thing = plugins[index2];
          add2(thing);
        }
      } else {
        throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
      }
    }
    function addPlugin(plugin, value2) {
      let index2 = -1;
      let entry;
      while (++index2 < attachers.length) {
        if (attachers[index2][0] === plugin) {
          entry = attachers[index2];
          break;
        }
      }
      if (entry) {
        if (isPlainObject$1(entry[1]) && isPlainObject$1(value2)) {
          value2 = extend$1(true, entry[1], value2);
        }
        entry[1] = value2;
      } else {
        attachers.push([...arguments]);
      }
    }
  }
  function parse2(doc) {
    processor.freeze();
    const file = vfile(doc);
    const Parser = processor.Parser;
    assertParser("parse", Parser);
    if (newable(Parser, "parse")) {
      return new Parser(String(file), file).parse();
    }
    return Parser(String(file), file);
  }
  function stringify2(node2, doc) {
    processor.freeze();
    const file = vfile(doc);
    const Compiler = processor.Compiler;
    assertCompiler("stringify", Compiler);
    assertNode(node2);
    if (newable(Compiler, "compile")) {
      return new Compiler(node2, file).compile();
    }
    return Compiler(node2, file);
  }
  function run(node2, doc, callback) {
    assertNode(node2);
    processor.freeze();
    if (!callback && typeof doc === "function") {
      callback = doc;
      doc = void 0;
    }
    if (!callback) {
      return new Promise(executor);
    }
    executor(null, callback);
    function executor(resolve, reject) {
      transformers.run(node2, vfile(doc), done);
      function done(error, tree, file) {
        tree = tree || node2;
        if (error) {
          reject(error);
        } else if (resolve) {
          resolve(tree);
        } else {
          callback(null, tree, file);
        }
      }
    }
  }
  function runSync(node2, file) {
    let result;
    let complete;
    processor.run(node2, file, done);
    assertDone("runSync", "run", complete);
    return result;
    function done(error, tree) {
      bail(error);
      result = tree;
      complete = true;
    }
  }
  function process(doc, callback) {
    processor.freeze();
    assertParser("process", processor.Parser);
    assertCompiler("process", processor.Compiler);
    if (!callback) {
      return new Promise(executor);
    }
    executor(null, callback);
    function executor(resolve, reject) {
      const file = vfile(doc);
      processor.run(processor.parse(file), file, (error, tree, file2) => {
        if (error || !tree || !file2) {
          done(error);
        } else {
          const result = processor.stringify(tree, file2);
          if (result === void 0 || result === null)
            ;
          else if (looksLikeAVFileValue(result)) {
            file2.value = result;
          } else {
            file2.result = result;
          }
          done(error, file2);
        }
      });
      function done(error, file2) {
        if (error || !file2) {
          reject(error);
        } else if (resolve) {
          resolve(file2);
        } else {
          callback(null, file2);
        }
      }
    }
  }
  function processSync(doc) {
    let complete;
    processor.freeze();
    assertParser("processSync", processor.Parser);
    assertCompiler("processSync", processor.Compiler);
    const file = vfile(doc);
    processor.process(file, done);
    assertDone("processSync", "process", complete);
    return file;
    function done(error) {
      complete = true;
      bail(error);
    }
  }
}
function newable(value, name) {
  return typeof value === "function" && // Prototypes do exist.
  // type-coverage:ignore-next-line
  value.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  // type-coverage:ignore-next-line
  (keys(value.prototype) || name in value.prototype);
}
function keys(value) {
  let key;
  for (key in value) {
    if (own$6.call(value, key)) {
      return true;
    }
  }
  return false;
}
function assertParser(name, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name + "` without `Parser`");
  }
}
function assertCompiler(name, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name + "` without `Compiler`");
  }
}
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(
      "Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
  }
}
function assertNode(node2) {
  if (!isPlainObject$1(node2) || typeof node2.type !== "string") {
    throw new TypeError("Expected node, got `" + node2 + "`");
  }
}
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error(
      "`" + name + "` finished async. Use `" + asyncName + "` instead"
    );
  }
}
function vfile(value) {
  return looksLikeAVFile(value) ? value : new VFile(value);
}
function looksLikeAVFile(value) {
  return Boolean(
    value && typeof value === "object" && "message" in value && "messages" in value
  );
}
function looksLikeAVFileValue(value) {
  return typeof value === "string" || isBuffer$1(value);
}
const emptyOptions = {};
function toString(value, options) {
  const settings = options || emptyOptions;
  const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
  const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
  return one$1(value, includeImageAlt, includeHtml);
}
function one$1(value, includeImageAlt, includeHtml) {
  if (node(value)) {
    if ("value" in value) {
      return value.type === "html" && !includeHtml ? "" : value.value;
    }
    if (includeImageAlt && "alt" in value && value.alt) {
      return value.alt;
    }
    if ("children" in value) {
      return all$1(value.children, includeImageAlt, includeHtml);
    }
  }
  if (Array.isArray(value)) {
    return all$1(value, includeImageAlt, includeHtml);
  }
  return "";
}
function all$1(values2, includeImageAlt, includeHtml) {
  const result = [];
  let index2 = -1;
  while (++index2 < values2.length) {
    result[index2] = one$1(values2[index2], includeImageAlt, includeHtml);
  }
  return result.join("");
}
function node(value) {
  return Boolean(value && typeof value === "object");
}
function splice(list2, start, remove, items) {
  const end = list2.length;
  let chunkStart = 0;
  let parameters;
  if (start < 0) {
    start = -start > end ? 0 : end + start;
  } else {
    start = start > end ? end : start;
  }
  remove = remove > 0 ? remove : 0;
  if (items.length < 1e4) {
    parameters = Array.from(items);
    parameters.unshift(start, remove);
    list2.splice(...parameters);
  } else {
    if (remove)
      list2.splice(start, remove);
    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 1e4);
      parameters.unshift(start, 0);
      list2.splice(...parameters);
      chunkStart += 1e4;
      start += 1e4;
    }
  }
}
function push(list2, items) {
  if (list2.length > 0) {
    splice(list2, list2.length, 0, items);
    return list2;
  }
  return items;
}
const hasOwnProperty = {}.hasOwnProperty;
function combineExtensions(extensions) {
  const all2 = {};
  let index2 = -1;
  while (++index2 < extensions.length) {
    syntaxExtension(all2, extensions[index2]);
  }
  return all2;
}
function syntaxExtension(all2, extension2) {
  let hook;
  for (hook in extension2) {
    const maybe = hasOwnProperty.call(all2, hook) ? all2[hook] : void 0;
    const left = maybe || (all2[hook] = {});
    const right = extension2[hook];
    let code2;
    if (right) {
      for (code2 in right) {
        if (!hasOwnProperty.call(left, code2))
          left[code2] = [];
        const value = right[code2];
        constructs(
          // @ts-expect-error Looks like a list.
          left[code2],
          Array.isArray(value) ? value : value ? [value] : []
        );
      }
    }
  }
}
function constructs(existing, list2) {
  let index2 = -1;
  const before = [];
  while (++index2 < list2.length) {
    (list2[index2].add === "after" ? existing : before).push(list2[index2]);
  }
  splice(existing, 0, 0, before);
}
const unicodePunctuationRegex = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
const asciiAlpha = regexCheck(/[A-Za-z]/);
const asciiAlphanumeric = regexCheck(/[\dA-Za-z]/);
const asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function asciiControl(code2) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code2 !== null && (code2 < 32 || code2 === 127)
  );
}
const asciiDigit = regexCheck(/\d/);
const asciiHexDigit = regexCheck(/[\dA-Fa-f]/);
const asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
function markdownLineEnding(code2) {
  return code2 !== null && code2 < -2;
}
function markdownLineEndingOrSpace(code2) {
  return code2 !== null && (code2 < 0 || code2 === 32);
}
function markdownSpace(code2) {
  return code2 === -2 || code2 === -1 || code2 === 32;
}
const unicodePunctuation = regexCheck(unicodePunctuationRegex);
const unicodeWhitespace = regexCheck(/\s/);
function regexCheck(regex) {
  return check;
  function check(code2) {
    return code2 !== null && regex.test(String.fromCharCode(code2));
  }
}
function factorySpace(effects, ok2, type, max2) {
  const limit = max2 ? max2 - 1 : Number.POSITIVE_INFINITY;
  let size = 0;
  return start;
  function start(code2) {
    if (markdownSpace(code2)) {
      effects.enter(type);
      return prefix2(code2);
    }
    return ok2(code2);
  }
  function prefix2(code2) {
    if (markdownSpace(code2) && size++ < limit) {
      effects.consume(code2);
      return prefix2;
    }
    effects.exit(type);
    return ok2(code2);
  }
}
const content$1 = {
  tokenize: initializeContent
};
function initializeContent(effects) {
  const contentStart = effects.attempt(
    this.parser.constructs.contentInitial,
    afterContentStartConstruct,
    paragraphInitial
  );
  let previous2;
  return contentStart;
  function afterContentStartConstruct(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace(effects, contentStart, "linePrefix");
  }
  function paragraphInitial(code2) {
    effects.enter("paragraph");
    return lineStart(code2);
  }
  function lineStart(code2) {
    const token2 = effects.enter("chunkText", {
      contentType: "text",
      previous: previous2
    });
    if (previous2) {
      previous2.next = token2;
    }
    previous2 = token2;
    return data(code2);
  }
  function data(code2) {
    if (code2 === null) {
      effects.exit("chunkText");
      effects.exit("paragraph");
      effects.consume(code2);
      return;
    }
    if (markdownLineEnding(code2)) {
      effects.consume(code2);
      effects.exit("chunkText");
      return lineStart;
    }
    effects.consume(code2);
    return data;
  }
}
const document$2 = {
  tokenize: initializeDocument
};
const containerConstruct = {
  tokenize: tokenizeContainer
};
function initializeDocument(effects) {
  const self2 = this;
  const stack = [];
  let continued = 0;
  let childFlow;
  let childToken;
  let lineStartOffset;
  return start;
  function start(code2) {
    if (continued < stack.length) {
      const item = stack[continued];
      self2.containerState = item[1];
      return effects.attempt(
        item[0].continuation,
        documentContinue,
        checkNewContainers
      )(code2);
    }
    return checkNewContainers(code2);
  }
  function documentContinue(code2) {
    continued++;
    if (self2.containerState._closeFlow) {
      self2.containerState._closeFlow = void 0;
      if (childFlow) {
        closeFlow();
      }
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits;
      let point2;
      while (indexBeforeFlow--) {
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          point2 = self2.events[indexBeforeFlow][1].end;
          break;
        }
      }
      exitContainers(continued);
      let index2 = indexBeforeExits;
      while (index2 < self2.events.length) {
        self2.events[index2][1].end = Object.assign({}, point2);
        index2++;
      }
      splice(
        self2.events,
        indexBeforeFlow + 1,
        0,
        self2.events.slice(indexBeforeExits)
      );
      self2.events.length = index2;
      return checkNewContainers(code2);
    }
    return start(code2);
  }
  function checkNewContainers(code2) {
    if (continued === stack.length) {
      if (!childFlow) {
        return documentContinued(code2);
      }
      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code2);
      }
      self2.interrupt = Boolean(
        childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack
      );
    }
    self2.containerState = {};
    return effects.check(
      containerConstruct,
      thereIsANewContainer,
      thereIsNoNewContainer
    )(code2);
  }
  function thereIsANewContainer(code2) {
    if (childFlow)
      closeFlow();
    exitContainers(continued);
    return documentContinued(code2);
  }
  function thereIsNoNewContainer(code2) {
    self2.parser.lazy[self2.now().line] = continued !== stack.length;
    lineStartOffset = self2.now().offset;
    return flowStart(code2);
  }
  function documentContinued(code2) {
    self2.containerState = {};
    return effects.attempt(
      containerConstruct,
      containerContinue,
      flowStart
    )(code2);
  }
  function containerContinue(code2) {
    continued++;
    stack.push([self2.currentConstruct, self2.containerState]);
    return documentContinued(code2);
  }
  function flowStart(code2) {
    if (code2 === null) {
      if (childFlow)
        closeFlow();
      exitContainers(0);
      effects.consume(code2);
      return;
    }
    childFlow = childFlow || self2.parser.flow(self2.now());
    effects.enter("chunkFlow", {
      contentType: "flow",
      previous: childToken,
      _tokenizer: childFlow
    });
    return flowContinue(code2);
  }
  function flowContinue(code2) {
    if (code2 === null) {
      writeToChild(effects.exit("chunkFlow"), true);
      exitContainers(0);
      effects.consume(code2);
      return;
    }
    if (markdownLineEnding(code2)) {
      effects.consume(code2);
      writeToChild(effects.exit("chunkFlow"));
      continued = 0;
      self2.interrupt = void 0;
      return start;
    }
    effects.consume(code2);
    return flowContinue;
  }
  function writeToChild(token2, eof) {
    const stream = self2.sliceStream(token2);
    if (eof)
      stream.push(null);
    token2.previous = childToken;
    if (childToken)
      childToken.next = token2;
    childToken = token2;
    childFlow.defineSkip(token2.start);
    childFlow.write(stream);
    if (self2.parser.lazy[token2.start.line]) {
      let index2 = childFlow.events.length;
      while (index2--) {
        if (
          // The token starts before the line ending…
          childFlow.events[index2][1].start.offset < lineStartOffset && // …and either is not ended yet…
          (!childFlow.events[index2][1].end || // …or ends after it.
          childFlow.events[index2][1].end.offset > lineStartOffset)
        ) {
          return;
        }
      }
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits;
      let seen;
      let point2;
      while (indexBeforeFlow--) {
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          if (seen) {
            point2 = self2.events[indexBeforeFlow][1].end;
            break;
          }
          seen = true;
        }
      }
      exitContainers(continued);
      index2 = indexBeforeExits;
      while (index2 < self2.events.length) {
        self2.events[index2][1].end = Object.assign({}, point2);
        index2++;
      }
      splice(
        self2.events,
        indexBeforeFlow + 1,
        0,
        self2.events.slice(indexBeforeExits)
      );
      self2.events.length = index2;
    }
  }
  function exitContainers(size) {
    let index2 = stack.length;
    while (index2-- > size) {
      const entry = stack[index2];
      self2.containerState = entry[1];
      entry[0].exit.call(self2, effects);
    }
    stack.length = size;
  }
  function closeFlow() {
    childFlow.write([null]);
    childToken = void 0;
    childFlow = void 0;
    self2.containerState._closeFlow = void 0;
  }
}
function tokenizeContainer(effects, ok2, nok) {
  return factorySpace(
    effects,
    effects.attempt(this.parser.constructs.document, ok2, nok),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function classifyCharacter(code2) {
  if (code2 === null || markdownLineEndingOrSpace(code2) || unicodeWhitespace(code2)) {
    return 1;
  }
  if (unicodePunctuation(code2)) {
    return 2;
  }
}
function resolveAll(constructs2, events, context) {
  const called = [];
  let index2 = -1;
  while (++index2 < constructs2.length) {
    const resolve = constructs2[index2].resolveAll;
    if (resolve && !called.includes(resolve)) {
      events = resolve(events, context);
      called.push(resolve);
    }
  }
  return events;
}
const attention = {
  name: "attention",
  tokenize: tokenizeAttention,
  resolveAll: resolveAllAttention
};
function resolveAllAttention(events, context) {
  let index2 = -1;
  let open;
  let group;
  let text2;
  let openingSequence;
  let closingSequence;
  let use;
  let nextEvents;
  let offset2;
  while (++index2 < events.length) {
    if (events[index2][0] === "enter" && events[index2][1].type === "attentionSequence" && events[index2][1]._close) {
      open = index2;
      while (open--) {
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index2][1]).charCodeAt(0)) {
          if ((events[open][1]._close || events[index2][1]._open) && (events[index2][1].end.offset - events[index2][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index2][1].end.offset - events[index2][1].start.offset) % 3)) {
            continue;
          }
          use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index2][1].end.offset - events[index2][1].start.offset > 1 ? 2 : 1;
          const start = Object.assign({}, events[open][1].end);
          const end = Object.assign({}, events[index2][1].start);
          movePoint(start, -use);
          movePoint(end, use);
          openingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start,
            end: Object.assign({}, events[open][1].end)
          };
          closingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, events[index2][1].start),
            end
          };
          text2 = {
            type: use > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, events[open][1].end),
            end: Object.assign({}, events[index2][1].start)
          };
          group = {
            type: use > 1 ? "strong" : "emphasis",
            start: Object.assign({}, openingSequence.start),
            end: Object.assign({}, closingSequence.end)
          };
          events[open][1].end = Object.assign({}, openingSequence.start);
          events[index2][1].start = Object.assign({}, closingSequence.end);
          nextEvents = [];
          if (events[open][1].end.offset - events[open][1].start.offset) {
            nextEvents = push(nextEvents, [
              ["enter", events[open][1], context],
              ["exit", events[open][1], context]
            ]);
          }
          nextEvents = push(nextEvents, [
            ["enter", group, context],
            ["enter", openingSequence, context],
            ["exit", openingSequence, context],
            ["enter", text2, context]
          ]);
          nextEvents = push(
            nextEvents,
            resolveAll(
              context.parser.constructs.insideSpan.null,
              events.slice(open + 1, index2),
              context
            )
          );
          nextEvents = push(nextEvents, [
            ["exit", text2, context],
            ["enter", closingSequence, context],
            ["exit", closingSequence, context],
            ["exit", group, context]
          ]);
          if (events[index2][1].end.offset - events[index2][1].start.offset) {
            offset2 = 2;
            nextEvents = push(nextEvents, [
              ["enter", events[index2][1], context],
              ["exit", events[index2][1], context]
            ]);
          } else {
            offset2 = 0;
          }
          splice(events, open - 1, index2 - open + 3, nextEvents);
          index2 = open + nextEvents.length - offset2 - 2;
          break;
        }
      }
    }
  }
  index2 = -1;
  while (++index2 < events.length) {
    if (events[index2][1].type === "attentionSequence") {
      events[index2][1].type = "data";
    }
  }
  return events;
}
function tokenizeAttention(effects, ok2) {
  const attentionMarkers2 = this.parser.constructs.attentionMarkers.null;
  const previous2 = this.previous;
  const before = classifyCharacter(previous2);
  let marker;
  return start;
  function start(code2) {
    marker = code2;
    effects.enter("attentionSequence");
    return inside(code2);
  }
  function inside(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      return inside;
    }
    const token2 = effects.exit("attentionSequence");
    const after = classifyCharacter(code2);
    const open = !after || after === 2 && before || attentionMarkers2.includes(code2);
    const close = !before || before === 2 && after || attentionMarkers2.includes(previous2);
    token2._open = Boolean(marker === 42 ? open : open && (before || !close));
    token2._close = Boolean(marker === 42 ? close : close && (after || !open));
    return ok2(code2);
  }
}
function movePoint(point2, offset2) {
  point2.column += offset2;
  point2.offset += offset2;
  point2._bufferIndex += offset2;
}
const autolink = {
  name: "autolink",
  tokenize: tokenizeAutolink
};
function tokenizeAutolink(effects, ok2, nok) {
  let size = 0;
  return start;
  function start(code2) {
    effects.enter("autolink");
    effects.enter("autolinkMarker");
    effects.consume(code2);
    effects.exit("autolinkMarker");
    effects.enter("autolinkProtocol");
    return open;
  }
  function open(code2) {
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return schemeOrEmailAtext;
    }
    return emailAtext(code2);
  }
  function schemeOrEmailAtext(code2) {
    if (code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric(code2)) {
      size = 1;
      return schemeInsideOrEmailAtext(code2);
    }
    return emailAtext(code2);
  }
  function schemeInsideOrEmailAtext(code2) {
    if (code2 === 58) {
      effects.consume(code2);
      size = 0;
      return urlInside;
    }
    if ((code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric(code2)) && size++ < 32) {
      effects.consume(code2);
      return schemeInsideOrEmailAtext;
    }
    size = 0;
    return emailAtext(code2);
  }
  function urlInside(code2) {
    if (code2 === 62) {
      effects.exit("autolinkProtocol");
      effects.enter("autolinkMarker");
      effects.consume(code2);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok2;
    }
    if (code2 === null || code2 === 32 || code2 === 60 || asciiControl(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return urlInside;
  }
  function emailAtext(code2) {
    if (code2 === 64) {
      effects.consume(code2);
      return emailAtSignOrDot;
    }
    if (asciiAtext(code2)) {
      effects.consume(code2);
      return emailAtext;
    }
    return nok(code2);
  }
  function emailAtSignOrDot(code2) {
    return asciiAlphanumeric(code2) ? emailLabel(code2) : nok(code2);
  }
  function emailLabel(code2) {
    if (code2 === 46) {
      effects.consume(code2);
      size = 0;
      return emailAtSignOrDot;
    }
    if (code2 === 62) {
      effects.exit("autolinkProtocol").type = "autolinkEmail";
      effects.enter("autolinkMarker");
      effects.consume(code2);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok2;
    }
    return emailValue(code2);
  }
  function emailValue(code2) {
    if ((code2 === 45 || asciiAlphanumeric(code2)) && size++ < 63) {
      const next2 = code2 === 45 ? emailValue : emailLabel;
      effects.consume(code2);
      return next2;
    }
    return nok(code2);
  }
}
const blankLine = {
  tokenize: tokenizeBlankLine,
  partial: true
};
function tokenizeBlankLine(effects, ok2, nok) {
  return start;
  function start(code2) {
    return markdownSpace(code2) ? factorySpace(effects, after, "linePrefix")(code2) : after(code2);
  }
  function after(code2) {
    return code2 === null || markdownLineEnding(code2) ? ok2(code2) : nok(code2);
  }
}
const blockQuote = {
  name: "blockQuote",
  tokenize: tokenizeBlockQuoteStart,
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit
};
function tokenizeBlockQuoteStart(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (code2 === 62) {
      const state = self2.containerState;
      if (!state.open) {
        effects.enter("blockQuote", {
          _container: true
        });
        state.open = true;
      }
      effects.enter("blockQuotePrefix");
      effects.enter("blockQuoteMarker");
      effects.consume(code2);
      effects.exit("blockQuoteMarker");
      return after;
    }
    return nok(code2);
  }
  function after(code2) {
    if (markdownSpace(code2)) {
      effects.enter("blockQuotePrefixWhitespace");
      effects.consume(code2);
      effects.exit("blockQuotePrefixWhitespace");
      effects.exit("blockQuotePrefix");
      return ok2;
    }
    effects.exit("blockQuotePrefix");
    return ok2(code2);
  }
}
function tokenizeBlockQuoteContinuation(effects, ok2, nok) {
  const self2 = this;
  return contStart;
  function contStart(code2) {
    if (markdownSpace(code2)) {
      return factorySpace(
        effects,
        contBefore,
        "linePrefix",
        self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(code2);
    }
    return contBefore(code2);
  }
  function contBefore(code2) {
    return effects.attempt(blockQuote, ok2, nok)(code2);
  }
}
function exit(effects) {
  effects.exit("blockQuote");
}
const characterEscape = {
  name: "characterEscape",
  tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.enter("characterEscape");
    effects.enter("escapeMarker");
    effects.consume(code2);
    effects.exit("escapeMarker");
    return inside;
  }
  function inside(code2) {
    if (asciiPunctuation(code2)) {
      effects.enter("characterEscapeValue");
      effects.consume(code2);
      effects.exit("characterEscapeValue");
      effects.exit("characterEscape");
      return ok2;
    }
    return nok(code2);
  }
}
const element = document.createElement("i");
function decodeNamedCharacterReference(value) {
  const characterReference2 = "&" + value + ";";
  element.innerHTML = characterReference2;
  const char2 = element.textContent;
  if (char2.charCodeAt(char2.length - 1) === 59 && value !== "semi") {
    return false;
  }
  return char2 === characterReference2 ? false : char2;
}
const characterReference = {
  name: "characterReference",
  tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(effects, ok2, nok) {
  const self2 = this;
  let size = 0;
  let max2;
  let test;
  return start;
  function start(code2) {
    effects.enter("characterReference");
    effects.enter("characterReferenceMarker");
    effects.consume(code2);
    effects.exit("characterReferenceMarker");
    return open;
  }
  function open(code2) {
    if (code2 === 35) {
      effects.enter("characterReferenceMarkerNumeric");
      effects.consume(code2);
      effects.exit("characterReferenceMarkerNumeric");
      return numeric;
    }
    effects.enter("characterReferenceValue");
    max2 = 31;
    test = asciiAlphanumeric;
    return value(code2);
  }
  function numeric(code2) {
    if (code2 === 88 || code2 === 120) {
      effects.enter("characterReferenceMarkerHexadecimal");
      effects.consume(code2);
      effects.exit("characterReferenceMarkerHexadecimal");
      effects.enter("characterReferenceValue");
      max2 = 6;
      test = asciiHexDigit;
      return value;
    }
    effects.enter("characterReferenceValue");
    max2 = 7;
    test = asciiDigit;
    return value(code2);
  }
  function value(code2) {
    if (code2 === 59 && size) {
      const token2 = effects.exit("characterReferenceValue");
      if (test === asciiAlphanumeric && !decodeNamedCharacterReference(self2.sliceSerialize(token2))) {
        return nok(code2);
      }
      effects.enter("characterReferenceMarker");
      effects.consume(code2);
      effects.exit("characterReferenceMarker");
      effects.exit("characterReference");
      return ok2;
    }
    if (test(code2) && size++ < max2) {
      effects.consume(code2);
      return value;
    }
    return nok(code2);
  }
}
const nonLazyContinuation = {
  tokenize: tokenizeNonLazyContinuation,
  partial: true
};
const codeFenced = {
  name: "codeFenced",
  tokenize: tokenizeCodeFenced,
  concrete: true
};
function tokenizeCodeFenced(effects, ok2, nok) {
  const self2 = this;
  const closeStart = {
    tokenize: tokenizeCloseStart,
    partial: true
  };
  let initialPrefix = 0;
  let sizeOpen = 0;
  let marker;
  return start;
  function start(code2) {
    return beforeSequenceOpen(code2);
  }
  function beforeSequenceOpen(code2) {
    const tail = self2.events[self2.events.length - 1];
    initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    marker = code2;
    effects.enter("codeFenced");
    effects.enter("codeFencedFence");
    effects.enter("codeFencedFenceSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === marker) {
      sizeOpen++;
      effects.consume(code2);
      return sequenceOpen;
    }
    if (sizeOpen < 3) {
      return nok(code2);
    }
    effects.exit("codeFencedFenceSequence");
    return markdownSpace(code2) ? factorySpace(effects, infoBefore, "whitespace")(code2) : infoBefore(code2);
  }
  function infoBefore(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("codeFencedFence");
      return self2.interrupt ? ok2(code2) : effects.check(nonLazyContinuation, atNonLazyBreak, after)(code2);
    }
    effects.enter("codeFencedFenceInfo");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return info(code2);
  }
  function info(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return infoBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return factorySpace(effects, metaBefore, "whitespace")(code2);
    }
    if (code2 === 96 && code2 === marker) {
      return nok(code2);
    }
    effects.consume(code2);
    return info;
  }
  function metaBefore(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return infoBefore(code2);
    }
    effects.enter("codeFencedFenceMeta");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return meta(code2);
  }
  function meta(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceMeta");
      return infoBefore(code2);
    }
    if (code2 === 96 && code2 === marker) {
      return nok(code2);
    }
    effects.consume(code2);
    return meta;
  }
  function atNonLazyBreak(code2) {
    return effects.attempt(closeStart, after, contentBefore)(code2);
  }
  function contentBefore(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return contentStart;
  }
  function contentStart(code2) {
    return initialPrefix > 0 && markdownSpace(code2) ? factorySpace(
      effects,
      beforeContentChunk,
      "linePrefix",
      initialPrefix + 1
    )(code2) : beforeContentChunk(code2);
  }
  function beforeContentChunk(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return effects.check(nonLazyContinuation, atNonLazyBreak, after)(code2);
    }
    effects.enter("codeFlowValue");
    return contentChunk(code2);
  }
  function contentChunk(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("codeFlowValue");
      return beforeContentChunk(code2);
    }
    effects.consume(code2);
    return contentChunk;
  }
  function after(code2) {
    effects.exit("codeFenced");
    return ok2(code2);
  }
  function tokenizeCloseStart(effects2, ok3, nok2) {
    let size = 0;
    return startBefore;
    function startBefore(code2) {
      effects2.enter("lineEnding");
      effects2.consume(code2);
      effects2.exit("lineEnding");
      return start2;
    }
    function start2(code2) {
      effects2.enter("codeFencedFence");
      return markdownSpace(code2) ? factorySpace(
        effects2,
        beforeSequenceClose,
        "linePrefix",
        self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(code2) : beforeSequenceClose(code2);
    }
    function beforeSequenceClose(code2) {
      if (code2 === marker) {
        effects2.enter("codeFencedFenceSequence");
        return sequenceClose(code2);
      }
      return nok2(code2);
    }
    function sequenceClose(code2) {
      if (code2 === marker) {
        size++;
        effects2.consume(code2);
        return sequenceClose;
      }
      if (size >= sizeOpen) {
        effects2.exit("codeFencedFenceSequence");
        return markdownSpace(code2) ? factorySpace(effects2, sequenceCloseAfter, "whitespace")(code2) : sequenceCloseAfter(code2);
      }
      return nok2(code2);
    }
    function sequenceCloseAfter(code2) {
      if (code2 === null || markdownLineEnding(code2)) {
        effects2.exit("codeFencedFence");
        return ok3(code2);
      }
      return nok2(code2);
    }
  }
}
function tokenizeNonLazyContinuation(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return lineStart;
  }
  function lineStart(code2) {
    return self2.parser.lazy[self2.now().line] ? nok(code2) : ok2(code2);
  }
}
const codeIndented = {
  name: "codeIndented",
  tokenize: tokenizeCodeIndented
};
const furtherStart = {
  tokenize: tokenizeFurtherStart,
  partial: true
};
function tokenizeCodeIndented(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("codeIndented");
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code2);
  }
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code2) : nok(code2);
  }
  function atBreak(code2) {
    if (code2 === null) {
      return after(code2);
    }
    if (markdownLineEnding(code2)) {
      return effects.attempt(furtherStart, atBreak, after)(code2);
    }
    effects.enter("codeFlowValue");
    return inside(code2);
  }
  function inside(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("codeFlowValue");
      return atBreak(code2);
    }
    effects.consume(code2);
    return inside;
  }
  function after(code2) {
    effects.exit("codeIndented");
    return ok2(code2);
  }
}
function tokenizeFurtherStart(effects, ok2, nok) {
  const self2 = this;
  return furtherStart2;
  function furtherStart2(code2) {
    if (self2.parser.lazy[self2.now().line]) {
      return nok(code2);
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return furtherStart2;
    }
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code2);
  }
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok2(code2) : markdownLineEnding(code2) ? furtherStart2(code2) : nok(code2);
  }
}
const codeText = {
  name: "codeText",
  tokenize: tokenizeCodeText,
  resolve: resolveCodeText,
  previous
};
function resolveCodeText(events) {
  let tailExitIndex = events.length - 4;
  let headEnterIndex = 3;
  let index2;
  let enter;
  if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
    index2 = headEnterIndex;
    while (++index2 < tailExitIndex) {
      if (events[index2][1].type === "codeTextData") {
        events[headEnterIndex][1].type = "codeTextPadding";
        events[tailExitIndex][1].type = "codeTextPadding";
        headEnterIndex += 2;
        tailExitIndex -= 2;
        break;
      }
    }
  }
  index2 = headEnterIndex - 1;
  tailExitIndex++;
  while (++index2 <= tailExitIndex) {
    if (enter === void 0) {
      if (index2 !== tailExitIndex && events[index2][1].type !== "lineEnding") {
        enter = index2;
      }
    } else if (index2 === tailExitIndex || events[index2][1].type === "lineEnding") {
      events[enter][1].type = "codeTextData";
      if (index2 !== enter + 2) {
        events[enter][1].end = events[index2 - 1][1].end;
        events.splice(enter + 2, index2 - enter - 2);
        tailExitIndex -= index2 - enter - 2;
        index2 = enter + 2;
      }
      enter = void 0;
    }
  }
  return events;
}
function previous(code2) {
  return code2 !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeCodeText(effects, ok2, nok) {
  let sizeOpen = 0;
  let size;
  let token2;
  return start;
  function start(code2) {
    effects.enter("codeText");
    effects.enter("codeTextSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === 96) {
      effects.consume(code2);
      sizeOpen++;
      return sequenceOpen;
    }
    effects.exit("codeTextSequence");
    return between(code2);
  }
  function between(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 32) {
      effects.enter("space");
      effects.consume(code2);
      effects.exit("space");
      return between;
    }
    if (code2 === 96) {
      token2 = effects.enter("codeTextSequence");
      size = 0;
      return sequenceClose(code2);
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return between;
    }
    effects.enter("codeTextData");
    return data(code2);
  }
  function data(code2) {
    if (code2 === null || code2 === 32 || code2 === 96 || markdownLineEnding(code2)) {
      effects.exit("codeTextData");
      return between(code2);
    }
    effects.consume(code2);
    return data;
  }
  function sequenceClose(code2) {
    if (code2 === 96) {
      effects.consume(code2);
      size++;
      return sequenceClose;
    }
    if (size === sizeOpen) {
      effects.exit("codeTextSequence");
      effects.exit("codeText");
      return ok2(code2);
    }
    token2.type = "codeTextData";
    return data(code2);
  }
}
function subtokenize(events) {
  const jumps = {};
  let index2 = -1;
  let event;
  let lineIndex;
  let otherIndex;
  let otherEvent;
  let parameters;
  let subevents;
  let more;
  while (++index2 < events.length) {
    while (index2 in jumps) {
      index2 = jumps[index2];
    }
    event = events[index2];
    if (index2 && event[1].type === "chunkFlow" && events[index2 - 1][1].type === "listItemPrefix") {
      subevents = event[1]._tokenizer.events;
      otherIndex = 0;
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") {
        otherIndex += 2;
      }
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === "content") {
            break;
          }
          if (subevents[otherIndex][1].type === "chunkText") {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true;
            otherIndex++;
          }
        }
      }
    }
    if (event[0] === "enter") {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent(events, index2));
        index2 = jumps[index2];
        more = true;
      }
    } else if (event[1]._container) {
      otherIndex = index2;
      lineIndex = void 0;
      while (otherIndex--) {
        otherEvent = events[otherIndex];
        if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
          if (otherEvent[0] === "enter") {
            if (lineIndex) {
              events[lineIndex][1].type = "lineEndingBlank";
            }
            otherEvent[1].type = "lineEnding";
            lineIndex = otherIndex;
          }
        } else {
          break;
        }
      }
      if (lineIndex) {
        event[1].end = Object.assign({}, events[lineIndex][1].start);
        parameters = events.slice(lineIndex, index2);
        parameters.unshift(event);
        splice(events, lineIndex, index2 - lineIndex + 1, parameters);
      }
    }
  }
  return !more;
}
function subcontent(events, eventIndex) {
  const token2 = events[eventIndex][1];
  const context = events[eventIndex][2];
  let startPosition = eventIndex - 1;
  const startPositions = [];
  const tokenizer = token2._tokenizer || context.parser[token2.contentType](token2.start);
  const childEvents = tokenizer.events;
  const jumps = [];
  const gaps = {};
  let stream;
  let previous2;
  let index2 = -1;
  let current = token2;
  let adjust = 0;
  let start = 0;
  const breaks = [start];
  while (current) {
    while (events[++startPosition][1] !== current) {
    }
    startPositions.push(startPosition);
    if (!current._tokenizer) {
      stream = context.sliceStream(current);
      if (!current.next) {
        stream.push(null);
      }
      if (previous2) {
        tokenizer.defineSkip(current.start);
      }
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true;
      }
      tokenizer.write(stream);
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = void 0;
      }
    }
    previous2 = current;
    current = current.next;
  }
  current = token2;
  while (++index2 < childEvents.length) {
    if (
      // Find a void token that includes a break.
      childEvents[index2][0] === "exit" && childEvents[index2 - 1][0] === "enter" && childEvents[index2][1].type === childEvents[index2 - 1][1].type && childEvents[index2][1].start.line !== childEvents[index2][1].end.line
    ) {
      start = index2 + 1;
      breaks.push(start);
      current._tokenizer = void 0;
      current.previous = void 0;
      current = current.next;
    }
  }
  tokenizer.events = [];
  if (current) {
    current._tokenizer = void 0;
    current.previous = void 0;
  } else {
    breaks.pop();
  }
  index2 = breaks.length;
  while (index2--) {
    const slice2 = childEvents.slice(breaks[index2], breaks[index2 + 1]);
    const start2 = startPositions.pop();
    jumps.unshift([start2, start2 + slice2.length - 1]);
    splice(events, start2, 2, slice2);
  }
  index2 = -1;
  while (++index2 < jumps.length) {
    gaps[adjust + jumps[index2][0]] = adjust + jumps[index2][1];
    adjust += jumps[index2][1] - jumps[index2][0] - 1;
  }
  return gaps;
}
const content = {
  tokenize: tokenizeContent,
  resolve: resolveContent
};
const continuationConstruct = {
  tokenize: tokenizeContinuation,
  partial: true
};
function resolveContent(events) {
  subtokenize(events);
  return events;
}
function tokenizeContent(effects, ok2) {
  let previous2;
  return chunkStart;
  function chunkStart(code2) {
    effects.enter("content");
    previous2 = effects.enter("chunkContent", {
      contentType: "content"
    });
    return chunkInside(code2);
  }
  function chunkInside(code2) {
    if (code2 === null) {
      return contentEnd(code2);
    }
    if (markdownLineEnding(code2)) {
      return effects.check(
        continuationConstruct,
        contentContinue,
        contentEnd
      )(code2);
    }
    effects.consume(code2);
    return chunkInside;
  }
  function contentEnd(code2) {
    effects.exit("chunkContent");
    effects.exit("content");
    return ok2(code2);
  }
  function contentContinue(code2) {
    effects.consume(code2);
    effects.exit("chunkContent");
    previous2.next = effects.enter("chunkContent", {
      contentType: "content",
      previous: previous2
    });
    previous2 = previous2.next;
    return chunkInside;
  }
}
function tokenizeContinuation(effects, ok2, nok) {
  const self2 = this;
  return startLookahead;
  function startLookahead(code2) {
    effects.exit("chunkContent");
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace(effects, prefixed, "linePrefix");
  }
  function prefixed(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return nok(code2);
    }
    const tail = self2.events[self2.events.length - 1];
    if (!self2.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) {
      return ok2(code2);
    }
    return effects.interrupt(self2.parser.constructs.flow, nok, ok2)(code2);
  }
}
function factoryDestination(effects, ok2, nok, type, literalType, literalMarkerType, rawType, stringType, max2) {
  const limit = max2 || Number.POSITIVE_INFINITY;
  let balance = 0;
  return start;
  function start(code2) {
    if (code2 === 60) {
      effects.enter(type);
      effects.enter(literalType);
      effects.enter(literalMarkerType);
      effects.consume(code2);
      effects.exit(literalMarkerType);
      return enclosedBefore;
    }
    if (code2 === null || code2 === 32 || code2 === 41 || asciiControl(code2)) {
      return nok(code2);
    }
    effects.enter(type);
    effects.enter(rawType);
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return raw(code2);
  }
  function enclosedBefore(code2) {
    if (code2 === 62) {
      effects.enter(literalMarkerType);
      effects.consume(code2);
      effects.exit(literalMarkerType);
      effects.exit(literalType);
      effects.exit(type);
      return ok2;
    }
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return enclosed(code2);
  }
  function enclosed(code2) {
    if (code2 === 62) {
      effects.exit("chunkString");
      effects.exit(stringType);
      return enclosedBefore(code2);
    }
    if (code2 === null || code2 === 60 || markdownLineEnding(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? enclosedEscape : enclosed;
  }
  function enclosedEscape(code2) {
    if (code2 === 60 || code2 === 62 || code2 === 92) {
      effects.consume(code2);
      return enclosed;
    }
    return enclosed(code2);
  }
  function raw(code2) {
    if (!balance && (code2 === null || code2 === 41 || markdownLineEndingOrSpace(code2))) {
      effects.exit("chunkString");
      effects.exit(stringType);
      effects.exit(rawType);
      effects.exit(type);
      return ok2(code2);
    }
    if (balance < limit && code2 === 40) {
      effects.consume(code2);
      balance++;
      return raw;
    }
    if (code2 === 41) {
      effects.consume(code2);
      balance--;
      return raw;
    }
    if (code2 === null || code2 === 32 || code2 === 40 || asciiControl(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? rawEscape : raw;
  }
  function rawEscape(code2) {
    if (code2 === 40 || code2 === 41 || code2 === 92) {
      effects.consume(code2);
      return raw;
    }
    return raw(code2);
  }
}
function factoryLabel(effects, ok2, nok, type, markerType, stringType) {
  const self2 = this;
  let size = 0;
  let seen;
  return start;
  function start(code2) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code2);
    effects.exit(markerType);
    effects.enter(stringType);
    return atBreak;
  }
  function atBreak(code2) {
    if (size > 999 || code2 === null || code2 === 91 || code2 === 93 && !seen || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    code2 === 94 && !size && "_hiddenFootnoteSupport" in self2.parser.constructs) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.exit(stringType);
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      effects.exit(type);
      return ok2;
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return atBreak;
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return labelInside(code2);
  }
  function labelInside(code2) {
    if (code2 === null || code2 === 91 || code2 === 93 || markdownLineEnding(code2) || size++ > 999) {
      effects.exit("chunkString");
      return atBreak(code2);
    }
    effects.consume(code2);
    if (!seen)
      seen = !markdownSpace(code2);
    return code2 === 92 ? labelEscape : labelInside;
  }
  function labelEscape(code2) {
    if (code2 === 91 || code2 === 92 || code2 === 93) {
      effects.consume(code2);
      size++;
      return labelInside;
    }
    return labelInside(code2);
  }
}
function factoryTitle(effects, ok2, nok, type, markerType, stringType) {
  let marker;
  return start;
  function start(code2) {
    if (code2 === 34 || code2 === 39 || code2 === 40) {
      effects.enter(type);
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      marker = code2 === 40 ? 41 : code2;
      return begin;
    }
    return nok(code2);
  }
  function begin(code2) {
    if (code2 === marker) {
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      effects.exit(type);
      return ok2;
    }
    effects.enter(stringType);
    return atBreak(code2);
  }
  function atBreak(code2) {
    if (code2 === marker) {
      effects.exit(stringType);
      return begin(marker);
    }
    if (code2 === null) {
      return nok(code2);
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return factorySpace(effects, atBreak, "linePrefix");
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return inside(code2);
  }
  function inside(code2) {
    if (code2 === marker || code2 === null || markdownLineEnding(code2)) {
      effects.exit("chunkString");
      return atBreak(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? escape : inside;
  }
  function escape(code2) {
    if (code2 === marker || code2 === 92) {
      effects.consume(code2);
      return inside;
    }
    return inside(code2);
  }
}
function factoryWhitespace(effects, ok2) {
  let seen;
  return start;
  function start(code2) {
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      seen = true;
      return start;
    }
    if (markdownSpace(code2)) {
      return factorySpace(
        effects,
        start,
        seen ? "linePrefix" : "lineSuffix"
      )(code2);
    }
    return ok2(code2);
  }
}
function normalizeIdentifier(value) {
  return value.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const definition = {
  name: "definition",
  tokenize: tokenizeDefinition
};
const titleBefore = {
  tokenize: tokenizeTitleBefore,
  partial: true
};
function tokenizeDefinition(effects, ok2, nok) {
  const self2 = this;
  let identifier2;
  return start;
  function start(code2) {
    effects.enter("definition");
    return before(code2);
  }
  function before(code2) {
    return factoryLabel.call(
      self2,
      effects,
      labelAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(code2);
  }
  function labelAfter(code2) {
    identifier2 = normalizeIdentifier(
      self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1)
    );
    if (code2 === 58) {
      effects.enter("definitionMarker");
      effects.consume(code2);
      effects.exit("definitionMarker");
      return markerAfter;
    }
    return nok(code2);
  }
  function markerAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, destinationBefore)(code2) : destinationBefore(code2);
  }
  function destinationBefore(code2) {
    return factoryDestination(
      effects,
      destinationAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(code2);
  }
  function destinationAfter(code2) {
    return effects.attempt(titleBefore, after, after)(code2);
  }
  function after(code2) {
    return markdownSpace(code2) ? factorySpace(effects, afterWhitespace, "whitespace")(code2) : afterWhitespace(code2);
  }
  function afterWhitespace(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("definition");
      self2.parser.defined.push(identifier2);
      return ok2(code2);
    }
    return nok(code2);
  }
}
function tokenizeTitleBefore(effects, ok2, nok) {
  return titleBefore2;
  function titleBefore2(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, beforeMarker)(code2) : nok(code2);
  }
  function beforeMarker(code2) {
    return factoryTitle(
      effects,
      titleAfter,
      nok,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(code2);
  }
  function titleAfter(code2) {
    return markdownSpace(code2) ? factorySpace(effects, titleAfterOptionalWhitespace, "whitespace")(code2) : titleAfterOptionalWhitespace(code2);
  }
  function titleAfterOptionalWhitespace(code2) {
    return code2 === null || markdownLineEnding(code2) ? ok2(code2) : nok(code2);
  }
}
const hardBreakEscape = {
  name: "hardBreakEscape",
  tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.enter("hardBreakEscape");
    effects.consume(code2);
    return after;
  }
  function after(code2) {
    if (markdownLineEnding(code2)) {
      effects.exit("hardBreakEscape");
      return ok2(code2);
    }
    return nok(code2);
  }
}
const headingAtx = {
  name: "headingAtx",
  tokenize: tokenizeHeadingAtx,
  resolve: resolveHeadingAtx
};
function resolveHeadingAtx(events, context) {
  let contentEnd = events.length - 2;
  let contentStart = 3;
  let content2;
  let text2;
  if (events[contentStart][1].type === "whitespace") {
    contentStart += 2;
  }
  if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") {
    contentEnd -= 2;
  }
  if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
  }
  if (contentEnd > contentStart) {
    content2 = {
      type: "atxHeadingText",
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end
    };
    text2 = {
      type: "chunkText",
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end,
      contentType: "text"
    };
    splice(events, contentStart, contentEnd - contentStart + 1, [
      ["enter", content2, context],
      ["enter", text2, context],
      ["exit", text2, context],
      ["exit", content2, context]
    ]);
  }
  return events;
}
function tokenizeHeadingAtx(effects, ok2, nok) {
  let size = 0;
  return start;
  function start(code2) {
    effects.enter("atxHeading");
    return before(code2);
  }
  function before(code2) {
    effects.enter("atxHeadingSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === 35 && size++ < 6) {
      effects.consume(code2);
      return sequenceOpen;
    }
    if (code2 === null || markdownLineEndingOrSpace(code2)) {
      effects.exit("atxHeadingSequence");
      return atBreak(code2);
    }
    return nok(code2);
  }
  function atBreak(code2) {
    if (code2 === 35) {
      effects.enter("atxHeadingSequence");
      return sequenceFurther(code2);
    }
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("atxHeading");
      return ok2(code2);
    }
    if (markdownSpace(code2)) {
      return factorySpace(effects, atBreak, "whitespace")(code2);
    }
    effects.enter("atxHeadingText");
    return data(code2);
  }
  function sequenceFurther(code2) {
    if (code2 === 35) {
      effects.consume(code2);
      return sequenceFurther;
    }
    effects.exit("atxHeadingSequence");
    return atBreak(code2);
  }
  function data(code2) {
    if (code2 === null || code2 === 35 || markdownLineEndingOrSpace(code2)) {
      effects.exit("atxHeadingText");
      return atBreak(code2);
    }
    effects.consume(code2);
    return data;
  }
}
const htmlBlockNames = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
];
const htmlRawNames = ["pre", "script", "style", "textarea"];
const htmlFlow = {
  name: "htmlFlow",
  tokenize: tokenizeHtmlFlow,
  resolveTo: resolveToHtmlFlow,
  concrete: true
};
const blankLineBefore = {
  tokenize: tokenizeBlankLineBefore,
  partial: true
};
const nonLazyContinuationStart = {
  tokenize: tokenizeNonLazyContinuationStart,
  partial: true
};
function resolveToHtmlFlow(events) {
  let index2 = events.length;
  while (index2--) {
    if (events[index2][0] === "enter" && events[index2][1].type === "htmlFlow") {
      break;
    }
  }
  if (index2 > 1 && events[index2 - 2][1].type === "linePrefix") {
    events[index2][1].start = events[index2 - 2][1].start;
    events[index2 + 1][1].start = events[index2 - 2][1].start;
    events.splice(index2 - 2, 2);
  }
  return events;
}
function tokenizeHtmlFlow(effects, ok2, nok) {
  const self2 = this;
  let marker;
  let closingTag;
  let buffer2;
  let index2;
  let markerB;
  return start;
  function start(code2) {
    return before(code2);
  }
  function before(code2) {
    effects.enter("htmlFlow");
    effects.enter("htmlFlowData");
    effects.consume(code2);
    return open;
  }
  function open(code2) {
    if (code2 === 33) {
      effects.consume(code2);
      return declarationOpen;
    }
    if (code2 === 47) {
      effects.consume(code2);
      closingTag = true;
      return tagCloseStart;
    }
    if (code2 === 63) {
      effects.consume(code2);
      marker = 3;
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      buffer2 = String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function declarationOpen(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      marker = 2;
      return commentOpenInside;
    }
    if (code2 === 91) {
      effects.consume(code2);
      marker = 5;
      index2 = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      marker = 4;
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    return nok(code2);
  }
  function commentOpenInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    return nok(code2);
  }
  function cdataOpenInside(code2) {
    const value = "CDATA[";
    if (code2 === value.charCodeAt(index2++)) {
      effects.consume(code2);
      if (index2 === value.length) {
        return self2.interrupt ? ok2 : continuation;
      }
      return cdataOpenInside;
    }
    return nok(code2);
  }
  function tagCloseStart(code2) {
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      buffer2 = String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function tagName(code2) {
    if (code2 === null || code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      const slash = code2 === 47;
      const name = buffer2.toLowerCase();
      if (!slash && !closingTag && htmlRawNames.includes(name)) {
        marker = 1;
        return self2.interrupt ? ok2(code2) : continuation(code2);
      }
      if (htmlBlockNames.includes(buffer2.toLowerCase())) {
        marker = 6;
        if (slash) {
          effects.consume(code2);
          return basicSelfClosing;
        }
        return self2.interrupt ? ok2(code2) : continuation(code2);
      }
      marker = 7;
      return self2.interrupt && !self2.parser.lazy[self2.now().line] ? nok(code2) : closingTag ? completeClosingTagAfter(code2) : completeAttributeNameBefore(code2);
    }
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      buffer2 += String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function basicSelfClosing(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return self2.interrupt ? ok2 : continuation;
    }
    return nok(code2);
  }
  function completeClosingTagAfter(code2) {
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeClosingTagAfter;
    }
    return completeEnd(code2);
  }
  function completeAttributeNameBefore(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return completeEnd;
    }
    if (code2 === 58 || code2 === 95 || asciiAlpha(code2)) {
      effects.consume(code2);
      return completeAttributeName;
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAttributeNameBefore;
    }
    return completeEnd(code2);
  }
  function completeAttributeName(code2) {
    if (code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return completeAttributeName;
    }
    return completeAttributeNameAfter(code2);
  }
  function completeAttributeNameAfter(code2) {
    if (code2 === 61) {
      effects.consume(code2);
      return completeAttributeValueBefore;
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAttributeNameAfter;
    }
    return completeAttributeNameBefore(code2);
  }
  function completeAttributeValueBefore(code2) {
    if (code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 34 || code2 === 39) {
      effects.consume(code2);
      markerB = code2;
      return completeAttributeValueQuoted;
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAttributeValueBefore;
    }
    return completeAttributeValueUnquoted(code2);
  }
  function completeAttributeValueQuoted(code2) {
    if (code2 === markerB) {
      effects.consume(code2);
      markerB = null;
      return completeAttributeValueQuotedAfter;
    }
    if (code2 === null || markdownLineEnding(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return completeAttributeValueQuoted;
  }
  function completeAttributeValueUnquoted(code2) {
    if (code2 === null || code2 === 34 || code2 === 39 || code2 === 47 || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96 || markdownLineEndingOrSpace(code2)) {
      return completeAttributeNameAfter(code2);
    }
    effects.consume(code2);
    return completeAttributeValueUnquoted;
  }
  function completeAttributeValueQuotedAfter(code2) {
    if (code2 === 47 || code2 === 62 || markdownSpace(code2)) {
      return completeAttributeNameBefore(code2);
    }
    return nok(code2);
  }
  function completeEnd(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return completeAfter;
    }
    return nok(code2);
  }
  function completeAfter(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return continuation(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAfter;
    }
    return nok(code2);
  }
  function continuation(code2) {
    if (code2 === 45 && marker === 2) {
      effects.consume(code2);
      return continuationCommentInside;
    }
    if (code2 === 60 && marker === 1) {
      effects.consume(code2);
      return continuationRawTagOpen;
    }
    if (code2 === 62 && marker === 4) {
      effects.consume(code2);
      return continuationClose;
    }
    if (code2 === 63 && marker === 3) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    if (code2 === 93 && marker === 5) {
      effects.consume(code2);
      return continuationCdataInside;
    }
    if (markdownLineEnding(code2) && (marker === 6 || marker === 7)) {
      effects.exit("htmlFlowData");
      return effects.check(
        blankLineBefore,
        continuationAfter,
        continuationStart
      )(code2);
    }
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("htmlFlowData");
      return continuationStart(code2);
    }
    effects.consume(code2);
    return continuation;
  }
  function continuationStart(code2) {
    return effects.check(
      nonLazyContinuationStart,
      continuationStartNonLazy,
      continuationAfter
    )(code2);
  }
  function continuationStartNonLazy(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return continuationBefore;
  }
  function continuationBefore(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return continuationStart(code2);
    }
    effects.enter("htmlFlowData");
    return continuation(code2);
  }
  function continuationCommentInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationRawTagOpen(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      buffer2 = "";
      return continuationRawEndTag;
    }
    return continuation(code2);
  }
  function continuationRawEndTag(code2) {
    if (code2 === 62) {
      const name = buffer2.toLowerCase();
      if (htmlRawNames.includes(name)) {
        effects.consume(code2);
        return continuationClose;
      }
      return continuation(code2);
    }
    if (asciiAlpha(code2) && buffer2.length < 8) {
      effects.consume(code2);
      buffer2 += String.fromCharCode(code2);
      return continuationRawEndTag;
    }
    return continuation(code2);
  }
  function continuationCdataInside(code2) {
    if (code2 === 93) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationDeclarationInside(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return continuationClose;
    }
    if (code2 === 45 && marker === 2) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationClose(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("htmlFlowData");
      return continuationAfter(code2);
    }
    effects.consume(code2);
    return continuationClose;
  }
  function continuationAfter(code2) {
    effects.exit("htmlFlow");
    return ok2(code2);
  }
}
function tokenizeNonLazyContinuationStart(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return after;
    }
    return nok(code2);
  }
  function after(code2) {
    return self2.parser.lazy[self2.now().line] ? nok(code2) : ok2(code2);
  }
}
function tokenizeBlankLineBefore(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return effects.attempt(blankLine, ok2, nok);
  }
}
const htmlText = {
  name: "htmlText",
  tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(effects, ok2, nok) {
  const self2 = this;
  let marker;
  let index2;
  let returnState;
  return start;
  function start(code2) {
    effects.enter("htmlText");
    effects.enter("htmlTextData");
    effects.consume(code2);
    return open;
  }
  function open(code2) {
    if (code2 === 33) {
      effects.consume(code2);
      return declarationOpen;
    }
    if (code2 === 47) {
      effects.consume(code2);
      return tagCloseStart;
    }
    if (code2 === 63) {
      effects.consume(code2);
      return instruction;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return tagOpen;
    }
    return nok(code2);
  }
  function declarationOpen(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentOpenInside;
    }
    if (code2 === 91) {
      effects.consume(code2);
      index2 = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return declaration2;
    }
    return nok(code2);
  }
  function commentOpenInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentEnd;
    }
    return nok(code2);
  }
  function comment2(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 45) {
      effects.consume(code2);
      return commentClose;
    }
    if (markdownLineEnding(code2)) {
      returnState = comment2;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return comment2;
  }
  function commentClose(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentEnd;
    }
    return comment2(code2);
  }
  function commentEnd(code2) {
    return code2 === 62 ? end(code2) : code2 === 45 ? commentClose(code2) : comment2(code2);
  }
  function cdataOpenInside(code2) {
    const value = "CDATA[";
    if (code2 === value.charCodeAt(index2++)) {
      effects.consume(code2);
      return index2 === value.length ? cdata : cdataOpenInside;
    }
    return nok(code2);
  }
  function cdata(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.consume(code2);
      return cdataClose;
    }
    if (markdownLineEnding(code2)) {
      returnState = cdata;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return cdata;
  }
  function cdataClose(code2) {
    if (code2 === 93) {
      effects.consume(code2);
      return cdataEnd;
    }
    return cdata(code2);
  }
  function cdataEnd(code2) {
    if (code2 === 62) {
      return end(code2);
    }
    if (code2 === 93) {
      effects.consume(code2);
      return cdataEnd;
    }
    return cdata(code2);
  }
  function declaration2(code2) {
    if (code2 === null || code2 === 62) {
      return end(code2);
    }
    if (markdownLineEnding(code2)) {
      returnState = declaration2;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return declaration2;
  }
  function instruction(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 63) {
      effects.consume(code2);
      return instructionClose;
    }
    if (markdownLineEnding(code2)) {
      returnState = instruction;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return instruction;
  }
  function instructionClose(code2) {
    return code2 === 62 ? end(code2) : instruction(code2);
  }
  function tagCloseStart(code2) {
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return tagClose;
    }
    return nok(code2);
  }
  function tagClose(code2) {
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagClose;
    }
    return tagCloseBetween(code2);
  }
  function tagCloseBetween(code2) {
    if (markdownLineEnding(code2)) {
      returnState = tagCloseBetween;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagCloseBetween;
    }
    return end(code2);
  }
  function tagOpen(code2) {
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagOpen;
    }
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      return tagOpenBetween(code2);
    }
    return nok(code2);
  }
  function tagOpenBetween(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return end;
    }
    if (code2 === 58 || code2 === 95 || asciiAlpha(code2)) {
      effects.consume(code2);
      return tagOpenAttributeName;
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenBetween;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagOpenBetween;
    }
    return end(code2);
  }
  function tagOpenAttributeName(code2) {
    if (code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagOpenAttributeName;
    }
    return tagOpenAttributeNameAfter(code2);
  }
  function tagOpenAttributeNameAfter(code2) {
    if (code2 === 61) {
      effects.consume(code2);
      return tagOpenAttributeValueBefore;
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenAttributeNameAfter;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagOpenAttributeNameAfter;
    }
    return tagOpenBetween(code2);
  }
  function tagOpenAttributeValueBefore(code2) {
    if (code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 34 || code2 === 39) {
      effects.consume(code2);
      marker = code2;
      return tagOpenAttributeValueQuoted;
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenAttributeValueBefore;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagOpenAttributeValueBefore;
    }
    effects.consume(code2);
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuoted(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      marker = void 0;
      return tagOpenAttributeValueQuotedAfter;
    }
    if (code2 === null) {
      return nok(code2);
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenAttributeValueQuoted;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return tagOpenAttributeValueQuoted;
  }
  function tagOpenAttributeValueUnquoted(code2) {
    if (code2 === null || code2 === 34 || code2 === 39 || code2 === 60 || code2 === 61 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      return tagOpenBetween(code2);
    }
    effects.consume(code2);
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuotedAfter(code2) {
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      return tagOpenBetween(code2);
    }
    return nok(code2);
  }
  function end(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      effects.exit("htmlTextData");
      effects.exit("htmlText");
      return ok2;
    }
    return nok(code2);
  }
  function lineEndingBefore(code2) {
    effects.exit("htmlTextData");
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return lineEndingAfter;
  }
  function lineEndingAfter(code2) {
    return markdownSpace(code2) ? factorySpace(
      effects,
      lineEndingAfterPrefix,
      "linePrefix",
      self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(code2) : lineEndingAfterPrefix(code2);
  }
  function lineEndingAfterPrefix(code2) {
    effects.enter("htmlTextData");
    return returnState(code2);
  }
}
const labelEnd = {
  name: "labelEnd",
  tokenize: tokenizeLabelEnd,
  resolveTo: resolveToLabelEnd,
  resolveAll: resolveAllLabelEnd
};
const resourceConstruct = {
  tokenize: tokenizeResource
};
const referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
};
const referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
};
function resolveAllLabelEnd(events) {
  let index2 = -1;
  while (++index2 < events.length) {
    const token2 = events[index2][1];
    if (token2.type === "labelImage" || token2.type === "labelLink" || token2.type === "labelEnd") {
      events.splice(index2 + 1, token2.type === "labelImage" ? 4 : 2);
      token2.type = "data";
      index2++;
    }
  }
  return events;
}
function resolveToLabelEnd(events, context) {
  let index2 = events.length;
  let offset2 = 0;
  let token2;
  let open;
  let close;
  let media;
  while (index2--) {
    token2 = events[index2][1];
    if (open) {
      if (token2.type === "link" || token2.type === "labelLink" && token2._inactive) {
        break;
      }
      if (events[index2][0] === "enter" && token2.type === "labelLink") {
        token2._inactive = true;
      }
    } else if (close) {
      if (events[index2][0] === "enter" && (token2.type === "labelImage" || token2.type === "labelLink") && !token2._balanced) {
        open = index2;
        if (token2.type !== "labelLink") {
          offset2 = 2;
          break;
        }
      }
    } else if (token2.type === "labelEnd") {
      close = index2;
    }
  }
  const group = {
    type: events[open][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  };
  const label = {
    type: "label",
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[close][1].end)
  };
  const text2 = {
    type: "labelText",
    start: Object.assign({}, events[open + offset2 + 2][1].end),
    end: Object.assign({}, events[close - 2][1].start)
  };
  media = [
    ["enter", group, context],
    ["enter", label, context]
  ];
  media = push(media, events.slice(open + 1, open + offset2 + 3));
  media = push(media, [["enter", text2, context]]);
  media = push(
    media,
    resolveAll(
      context.parser.constructs.insideSpan.null,
      events.slice(open + offset2 + 4, close - 3),
      context
    )
  );
  media = push(media, [
    ["exit", text2, context],
    events[close - 2],
    events[close - 1],
    ["exit", label, context]
  ]);
  media = push(media, events.slice(close + 1));
  media = push(media, [["exit", group, context]]);
  splice(events, open, events.length, media);
  return events;
}
function tokenizeLabelEnd(effects, ok2, nok) {
  const self2 = this;
  let index2 = self2.events.length;
  let labelStart;
  let defined;
  while (index2--) {
    if ((self2.events[index2][1].type === "labelImage" || self2.events[index2][1].type === "labelLink") && !self2.events[index2][1]._balanced) {
      labelStart = self2.events[index2][1];
      break;
    }
  }
  return start;
  function start(code2) {
    if (!labelStart) {
      return nok(code2);
    }
    if (labelStart._inactive) {
      return labelEndNok(code2);
    }
    defined = self2.parser.defined.includes(
      normalizeIdentifier(
        self2.sliceSerialize({
          start: labelStart.end,
          end: self2.now()
        })
      )
    );
    effects.enter("labelEnd");
    effects.enter("labelMarker");
    effects.consume(code2);
    effects.exit("labelMarker");
    effects.exit("labelEnd");
    return after;
  }
  function after(code2) {
    if (code2 === 40) {
      return effects.attempt(
        resourceConstruct,
        labelEndOk,
        defined ? labelEndOk : labelEndNok
      )(code2);
    }
    if (code2 === 91) {
      return effects.attempt(
        referenceFullConstruct,
        labelEndOk,
        defined ? referenceNotFull : labelEndNok
      )(code2);
    }
    return defined ? labelEndOk(code2) : labelEndNok(code2);
  }
  function referenceNotFull(code2) {
    return effects.attempt(
      referenceCollapsedConstruct,
      labelEndOk,
      labelEndNok
    )(code2);
  }
  function labelEndOk(code2) {
    return ok2(code2);
  }
  function labelEndNok(code2) {
    labelStart._balanced = true;
    return nok(code2);
  }
}
function tokenizeResource(effects, ok2, nok) {
  return resourceStart;
  function resourceStart(code2) {
    effects.enter("resource");
    effects.enter("resourceMarker");
    effects.consume(code2);
    effects.exit("resourceMarker");
    return resourceBefore;
  }
  function resourceBefore(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, resourceOpen)(code2) : resourceOpen(code2);
  }
  function resourceOpen(code2) {
    if (code2 === 41) {
      return resourceEnd(code2);
    }
    return factoryDestination(
      effects,
      resourceDestinationAfter,
      resourceDestinationMissing,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(code2);
  }
  function resourceDestinationAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, resourceBetween)(code2) : resourceEnd(code2);
  }
  function resourceDestinationMissing(code2) {
    return nok(code2);
  }
  function resourceBetween(code2) {
    if (code2 === 34 || code2 === 39 || code2 === 40) {
      return factoryTitle(
        effects,
        resourceTitleAfter,
        nok,
        "resourceTitle",
        "resourceTitleMarker",
        "resourceTitleString"
      )(code2);
    }
    return resourceEnd(code2);
  }
  function resourceTitleAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, resourceEnd)(code2) : resourceEnd(code2);
  }
  function resourceEnd(code2) {
    if (code2 === 41) {
      effects.enter("resourceMarker");
      effects.consume(code2);
      effects.exit("resourceMarker");
      effects.exit("resource");
      return ok2;
    }
    return nok(code2);
  }
}
function tokenizeReferenceFull(effects, ok2, nok) {
  const self2 = this;
  return referenceFull;
  function referenceFull(code2) {
    return factoryLabel.call(
      self2,
      effects,
      referenceFullAfter,
      referenceFullMissing,
      "reference",
      "referenceMarker",
      "referenceString"
    )(code2);
  }
  function referenceFullAfter(code2) {
    return self2.parser.defined.includes(
      normalizeIdentifier(
        self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1)
      )
    ) ? ok2(code2) : nok(code2);
  }
  function referenceFullMissing(code2) {
    return nok(code2);
  }
}
function tokenizeReferenceCollapsed(effects, ok2, nok) {
  return referenceCollapsedStart;
  function referenceCollapsedStart(code2) {
    effects.enter("reference");
    effects.enter("referenceMarker");
    effects.consume(code2);
    effects.exit("referenceMarker");
    return referenceCollapsedOpen;
  }
  function referenceCollapsedOpen(code2) {
    if (code2 === 93) {
      effects.enter("referenceMarker");
      effects.consume(code2);
      effects.exit("referenceMarker");
      effects.exit("reference");
      return ok2;
    }
    return nok(code2);
  }
}
const labelStartImage = {
  name: "labelStartImage",
  tokenize: tokenizeLabelStartImage,
  resolveAll: labelEnd.resolveAll
};
function tokenizeLabelStartImage(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("labelImage");
    effects.enter("labelImageMarker");
    effects.consume(code2);
    effects.exit("labelImageMarker");
    return open;
  }
  function open(code2) {
    if (code2 === 91) {
      effects.enter("labelMarker");
      effects.consume(code2);
      effects.exit("labelMarker");
      effects.exit("labelImage");
      return after;
    }
    return nok(code2);
  }
  function after(code2) {
    return code2 === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code2) : ok2(code2);
  }
}
const labelStartLink = {
  name: "labelStartLink",
  tokenize: tokenizeLabelStartLink,
  resolveAll: labelEnd.resolveAll
};
function tokenizeLabelStartLink(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("labelLink");
    effects.enter("labelMarker");
    effects.consume(code2);
    effects.exit("labelMarker");
    effects.exit("labelLink");
    return after;
  }
  function after(code2) {
    return code2 === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code2) : ok2(code2);
  }
}
const lineEnding = {
  name: "lineEnding",
  tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(effects, ok2) {
  return start;
  function start(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace(effects, ok2, "linePrefix");
  }
}
const thematicBreak$1 = {
  name: "thematicBreak",
  tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(effects, ok2, nok) {
  let size = 0;
  let marker;
  return start;
  function start(code2) {
    effects.enter("thematicBreak");
    return before(code2);
  }
  function before(code2) {
    marker = code2;
    return atBreak(code2);
  }
  function atBreak(code2) {
    if (code2 === marker) {
      effects.enter("thematicBreakSequence");
      return sequence(code2);
    }
    if (size >= 3 && (code2 === null || markdownLineEnding(code2))) {
      effects.exit("thematicBreak");
      return ok2(code2);
    }
    return nok(code2);
  }
  function sequence(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      size++;
      return sequence;
    }
    effects.exit("thematicBreakSequence");
    return markdownSpace(code2) ? factorySpace(effects, atBreak, "whitespace")(code2) : atBreak(code2);
  }
}
const list$1 = {
  name: "list",
  tokenize: tokenizeListStart,
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd
};
const listItemPrefixWhitespaceConstruct = {
  tokenize: tokenizeListItemPrefixWhitespace,
  partial: true
};
const indentConstruct = {
  tokenize: tokenizeIndent,
  partial: true
};
function tokenizeListStart(effects, ok2, nok) {
  const self2 = this;
  const tail = self2.events[self2.events.length - 1];
  let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
  let size = 0;
  return start;
  function start(code2) {
    const kind = self2.containerState.type || (code2 === 42 || code2 === 43 || code2 === 45 ? "listUnordered" : "listOrdered");
    if (kind === "listUnordered" ? !self2.containerState.marker || code2 === self2.containerState.marker : asciiDigit(code2)) {
      if (!self2.containerState.type) {
        self2.containerState.type = kind;
        effects.enter(kind, {
          _container: true
        });
      }
      if (kind === "listUnordered") {
        effects.enter("listItemPrefix");
        return code2 === 42 || code2 === 45 ? effects.check(thematicBreak$1, nok, atMarker)(code2) : atMarker(code2);
      }
      if (!self2.interrupt || code2 === 49) {
        effects.enter("listItemPrefix");
        effects.enter("listItemValue");
        return inside(code2);
      }
    }
    return nok(code2);
  }
  function inside(code2) {
    if (asciiDigit(code2) && ++size < 10) {
      effects.consume(code2);
      return inside;
    }
    if ((!self2.interrupt || size < 2) && (self2.containerState.marker ? code2 === self2.containerState.marker : code2 === 41 || code2 === 46)) {
      effects.exit("listItemValue");
      return atMarker(code2);
    }
    return nok(code2);
  }
  function atMarker(code2) {
    effects.enter("listItemMarker");
    effects.consume(code2);
    effects.exit("listItemMarker");
    self2.containerState.marker = self2.containerState.marker || code2;
    return effects.check(
      blankLine,
      // Can’t be empty when interrupting.
      self2.interrupt ? nok : onBlank,
      effects.attempt(
        listItemPrefixWhitespaceConstruct,
        endOfPrefix,
        otherPrefix
      )
    );
  }
  function onBlank(code2) {
    self2.containerState.initialBlankLine = true;
    initialSize++;
    return endOfPrefix(code2);
  }
  function otherPrefix(code2) {
    if (markdownSpace(code2)) {
      effects.enter("listItemPrefixWhitespace");
      effects.consume(code2);
      effects.exit("listItemPrefixWhitespace");
      return endOfPrefix;
    }
    return nok(code2);
  }
  function endOfPrefix(code2) {
    self2.containerState.size = initialSize + self2.sliceSerialize(effects.exit("listItemPrefix"), true).length;
    return ok2(code2);
  }
}
function tokenizeListContinuation(effects, ok2, nok) {
  const self2 = this;
  self2.containerState._closeFlow = void 0;
  return effects.check(blankLine, onBlank, notBlank);
  function onBlank(code2) {
    self2.containerState.furtherBlankLines = self2.containerState.furtherBlankLines || self2.containerState.initialBlankLine;
    return factorySpace(
      effects,
      ok2,
      "listItemIndent",
      self2.containerState.size + 1
    )(code2);
  }
  function notBlank(code2) {
    if (self2.containerState.furtherBlankLines || !markdownSpace(code2)) {
      self2.containerState.furtherBlankLines = void 0;
      self2.containerState.initialBlankLine = void 0;
      return notInCurrentItem(code2);
    }
    self2.containerState.furtherBlankLines = void 0;
    self2.containerState.initialBlankLine = void 0;
    return effects.attempt(indentConstruct, ok2, notInCurrentItem)(code2);
  }
  function notInCurrentItem(code2) {
    self2.containerState._closeFlow = true;
    self2.interrupt = void 0;
    return factorySpace(
      effects,
      effects.attempt(list$1, ok2, nok),
      "linePrefix",
      self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(code2);
  }
}
function tokenizeIndent(effects, ok2, nok) {
  const self2 = this;
  return factorySpace(
    effects,
    afterPrefix,
    "listItemIndent",
    self2.containerState.size + 1
  );
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self2.containerState.size ? ok2(code2) : nok(code2);
  }
}
function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(effects, ok2, nok) {
  const self2 = this;
  return factorySpace(
    effects,
    afterPrefix,
    "listItemPrefixWhitespace",
    self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1
  );
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return !markdownSpace(code2) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok2(code2) : nok(code2);
  }
}
const setextUnderline = {
  name: "setextUnderline",
  tokenize: tokenizeSetextUnderline,
  resolveTo: resolveToSetextUnderline
};
function resolveToSetextUnderline(events, context) {
  let index2 = events.length;
  let content2;
  let text2;
  let definition2;
  while (index2--) {
    if (events[index2][0] === "enter") {
      if (events[index2][1].type === "content") {
        content2 = index2;
        break;
      }
      if (events[index2][1].type === "paragraph") {
        text2 = index2;
      }
    } else {
      if (events[index2][1].type === "content") {
        events.splice(index2, 1);
      }
      if (!definition2 && events[index2][1].type === "definition") {
        definition2 = index2;
      }
    }
  }
  const heading2 = {
    type: "setextHeading",
    start: Object.assign({}, events[text2][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  };
  events[text2][1].type = "setextHeadingText";
  if (definition2) {
    events.splice(text2, 0, ["enter", heading2, context]);
    events.splice(definition2 + 1, 0, ["exit", events[content2][1], context]);
    events[content2][1].end = Object.assign({}, events[definition2][1].end);
  } else {
    events[content2][1] = heading2;
  }
  events.push(["exit", heading2, context]);
  return events;
}
function tokenizeSetextUnderline(effects, ok2, nok) {
  const self2 = this;
  let marker;
  return start;
  function start(code2) {
    let index2 = self2.events.length;
    let paragraph2;
    while (index2--) {
      if (self2.events[index2][1].type !== "lineEnding" && self2.events[index2][1].type !== "linePrefix" && self2.events[index2][1].type !== "content") {
        paragraph2 = self2.events[index2][1].type === "paragraph";
        break;
      }
    }
    if (!self2.parser.lazy[self2.now().line] && (self2.interrupt || paragraph2)) {
      effects.enter("setextHeadingLine");
      marker = code2;
      return before(code2);
    }
    return nok(code2);
  }
  function before(code2) {
    effects.enter("setextHeadingLineSequence");
    return inside(code2);
  }
  function inside(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      return inside;
    }
    effects.exit("setextHeadingLineSequence");
    return markdownSpace(code2) ? factorySpace(effects, after, "lineSuffix")(code2) : after(code2);
  }
  function after(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("setextHeadingLine");
      return ok2(code2);
    }
    return nok(code2);
  }
}
const flow$1 = {
  tokenize: initializeFlow
};
function initializeFlow(effects) {
  const self2 = this;
  const initial = effects.attempt(
    // Try to parse a blank line.
    blankLine,
    atBlankEnding,
    // Try to parse initial flow (essentially, only code).
    effects.attempt(
      this.parser.constructs.flowInitial,
      afterConstruct,
      factorySpace(
        effects,
        effects.attempt(
          this.parser.constructs.flow,
          afterConstruct,
          effects.attempt(content, afterConstruct)
        ),
        "linePrefix"
      )
    )
  );
  return initial;
  function atBlankEnding(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEndingBlank");
    effects.consume(code2);
    effects.exit("lineEndingBlank");
    self2.currentConstruct = void 0;
    return initial;
  }
  function afterConstruct(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    self2.currentConstruct = void 0;
    return initial;
  }
}
const resolver = {
  resolveAll: createResolver()
};
const string$1 = initializeFactory("string");
const text$2 = initializeFactory("text");
function initializeFactory(field) {
  return {
    tokenize: initializeText,
    resolveAll: createResolver(
      field === "text" ? resolveAllLineSuffixes : void 0
    )
  };
  function initializeText(effects) {
    const self2 = this;
    const constructs2 = this.parser.constructs[field];
    const text2 = effects.attempt(constructs2, start, notText);
    return start;
    function start(code2) {
      return atBreak(code2) ? text2(code2) : notText(code2);
    }
    function notText(code2) {
      if (code2 === null) {
        effects.consume(code2);
        return;
      }
      effects.enter("data");
      effects.consume(code2);
      return data;
    }
    function data(code2) {
      if (atBreak(code2)) {
        effects.exit("data");
        return text2(code2);
      }
      effects.consume(code2);
      return data;
    }
    function atBreak(code2) {
      if (code2 === null) {
        return true;
      }
      const list2 = constructs2[code2];
      let index2 = -1;
      if (list2) {
        while (++index2 < list2.length) {
          const item = list2[index2];
          if (!item.previous || item.previous.call(self2, self2.previous)) {
            return true;
          }
        }
      }
      return false;
    }
  }
}
function createResolver(extraResolver) {
  return resolveAllText;
  function resolveAllText(events, context) {
    let index2 = -1;
    let enter;
    while (++index2 <= events.length) {
      if (enter === void 0) {
        if (events[index2] && events[index2][1].type === "data") {
          enter = index2;
          index2++;
        }
      } else if (!events[index2] || events[index2][1].type !== "data") {
        if (index2 !== enter + 2) {
          events[enter][1].end = events[index2 - 1][1].end;
          events.splice(enter + 2, index2 - enter - 2);
          index2 = enter + 2;
        }
        enter = void 0;
      }
    }
    return extraResolver ? extraResolver(events, context) : events;
  }
}
function resolveAllLineSuffixes(events, context) {
  let eventIndex = 0;
  while (++eventIndex <= events.length) {
    if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
      const data = events[eventIndex - 1][1];
      const chunks = context.sliceStream(data);
      let index2 = chunks.length;
      let bufferIndex = -1;
      let size = 0;
      let tabs;
      while (index2--) {
        const chunk = chunks[index2];
        if (typeof chunk === "string") {
          bufferIndex = chunk.length;
          while (chunk.charCodeAt(bufferIndex - 1) === 32) {
            size++;
            bufferIndex--;
          }
          if (bufferIndex)
            break;
          bufferIndex = -1;
        } else if (chunk === -2) {
          tabs = true;
          size++;
        } else if (chunk === -1)
          ;
        else {
          index2++;
          break;
        }
      }
      if (size) {
        const token2 = {
          type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: data.end.line,
            column: data.end.column - size,
            offset: data.end.offset - size,
            _index: data.start._index + index2,
            _bufferIndex: index2 ? bufferIndex : data.start._bufferIndex + bufferIndex
          },
          end: Object.assign({}, data.end)
        };
        data.end = Object.assign({}, token2.start);
        if (data.start.offset === data.end.offset) {
          Object.assign(data, token2);
        } else {
          events.splice(
            eventIndex,
            0,
            ["enter", token2, context],
            ["exit", token2, context]
          );
          eventIndex += 2;
        }
      }
      eventIndex++;
    }
  }
  return events;
}
function createTokenizer(parser, initialize, from2) {
  let point2 = Object.assign(
    from2 ? Object.assign({}, from2) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const columnStart = {};
  const resolveAllConstructs = [];
  let chunks = [];
  let stack = [];
  const effects = {
    consume,
    enter,
    exit: exit2,
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  };
  const context = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser,
    sliceStream,
    sliceSerialize,
    now: now2,
    defineSkip,
    write
  };
  let state = initialize.tokenize.call(context, effects);
  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize);
  }
  return context;
  function write(slice2) {
    chunks = push(chunks, slice2);
    main();
    if (chunks[chunks.length - 1] !== null) {
      return [];
    }
    addResult(initialize, 0);
    context.events = resolveAll(resolveAllConstructs, context.events, context);
    return context.events;
  }
  function sliceSerialize(token2, expandTabs) {
    return serializeChunks(sliceStream(token2), expandTabs);
  }
  function sliceStream(token2) {
    return sliceChunks(chunks, token2);
  }
  function now2() {
    const { line: line2, column: column2, offset: offset2, _index, _bufferIndex } = point2;
    return {
      line: line2,
      column: column2,
      offset: offset2,
      _index,
      _bufferIndex
    };
  }
  function defineSkip(value) {
    columnStart[value.line] = value.column;
    accountForPotentialSkip();
  }
  function main() {
    let chunkIndex;
    while (point2._index < chunks.length) {
      const chunk = chunks[point2._index];
      if (typeof chunk === "string") {
        chunkIndex = point2._index;
        if (point2._bufferIndex < 0) {
          point2._bufferIndex = 0;
        }
        while (point2._index === chunkIndex && point2._bufferIndex < chunk.length) {
          go(chunk.charCodeAt(point2._bufferIndex));
        }
      } else {
        go(chunk);
      }
    }
  }
  function go(code2) {
    state = state(code2);
  }
  function consume(code2) {
    if (markdownLineEnding(code2)) {
      point2.line++;
      point2.column = 1;
      point2.offset += code2 === -3 ? 2 : 1;
      accountForPotentialSkip();
    } else if (code2 !== -1) {
      point2.column++;
      point2.offset++;
    }
    if (point2._bufferIndex < 0) {
      point2._index++;
    } else {
      point2._bufferIndex++;
      if (point2._bufferIndex === chunks[point2._index].length) {
        point2._bufferIndex = -1;
        point2._index++;
      }
    }
    context.previous = code2;
  }
  function enter(type, fields) {
    const token2 = fields || {};
    token2.type = type;
    token2.start = now2();
    context.events.push(["enter", token2, context]);
    stack.push(token2);
    return token2;
  }
  function exit2(type) {
    const token2 = stack.pop();
    token2.end = now2();
    context.events.push(["exit", token2, context]);
    return token2;
  }
  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from);
  }
  function onsuccessfulcheck(_, info) {
    info.restore();
  }
  function constructFactory(onreturn, fields) {
    return hook;
    function hook(constructs2, returnState, bogusState) {
      let listOfConstructs;
      let constructIndex;
      let currentConstruct;
      let info;
      return Array.isArray(constructs2) ? handleListOfConstructs(constructs2) : "tokenize" in constructs2 ? (
        // @ts-expect-error Looks like a construct.
        handleListOfConstructs([constructs2])
      ) : handleMapOfConstructs(constructs2);
      function handleMapOfConstructs(map2) {
        return start;
        function start(code2) {
          const def = code2 !== null && map2[code2];
          const all2 = code2 !== null && map2.null;
          const list2 = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(def) ? def : def ? [def] : [],
            ...Array.isArray(all2) ? all2 : all2 ? [all2] : []
          ];
          return handleListOfConstructs(list2)(code2);
        }
      }
      function handleListOfConstructs(list2) {
        listOfConstructs = list2;
        constructIndex = 0;
        if (list2.length === 0) {
          return bogusState;
        }
        return handleConstruct(list2[constructIndex]);
      }
      function handleConstruct(construct) {
        return start;
        function start(code2) {
          info = store();
          currentConstruct = construct;
          if (!construct.partial) {
            context.currentConstruct = construct;
          }
          if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) {
            return nok();
          }
          return construct.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            fields ? Object.assign(Object.create(context), fields) : context,
            effects,
            ok2,
            nok
          )(code2);
        }
      }
      function ok2(code2) {
        onreturn(currentConstruct, info);
        return returnState;
      }
      function nok(code2) {
        info.restore();
        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex]);
        }
        return bogusState;
      }
    }
  }
  function addResult(construct, from3) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct);
    }
    if (construct.resolve) {
      splice(
        context.events,
        from3,
        context.events.length - from3,
        construct.resolve(context.events.slice(from3), context)
      );
    }
    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context);
    }
  }
  function store() {
    const startPoint = now2();
    const startPrevious = context.previous;
    const startCurrentConstruct = context.currentConstruct;
    const startEventsIndex = context.events.length;
    const startStack = Array.from(stack);
    return {
      restore,
      from: startEventsIndex
    };
    function restore() {
      point2 = startPoint;
      context.previous = startPrevious;
      context.currentConstruct = startCurrentConstruct;
      context.events.length = startEventsIndex;
      stack = startStack;
      accountForPotentialSkip();
    }
  }
  function accountForPotentialSkip() {
    if (point2.line in columnStart && point2.column < 2) {
      point2.column = columnStart[point2.line];
      point2.offset += columnStart[point2.line] - 1;
    }
  }
}
function sliceChunks(chunks, token2) {
  const startIndex = token2.start._index;
  const startBufferIndex = token2.start._bufferIndex;
  const endIndex = token2.end._index;
  const endBufferIndex = token2.end._bufferIndex;
  let view;
  if (startIndex === endIndex) {
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)];
  } else {
    view = chunks.slice(startIndex, endIndex);
    if (startBufferIndex > -1) {
      const head = view[0];
      if (typeof head === "string") {
        view[0] = head.slice(startBufferIndex);
      } else {
        view.shift();
      }
    }
    if (endBufferIndex > 0) {
      view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
  }
  return view;
}
function serializeChunks(chunks, expandTabs) {
  let index2 = -1;
  const result = [];
  let atTab;
  while (++index2 < chunks.length) {
    const chunk = chunks[index2];
    let value;
    if (typeof chunk === "string") {
      value = chunk;
    } else
      switch (chunk) {
        case -5: {
          value = "\r";
          break;
        }
        case -4: {
          value = "\n";
          break;
        }
        case -3: {
          value = "\r\n";
          break;
        }
        case -2: {
          value = expandTabs ? " " : "	";
          break;
        }
        case -1: {
          if (!expandTabs && atTab)
            continue;
          value = " ";
          break;
        }
        default: {
          value = String.fromCharCode(chunk);
        }
      }
    atTab = chunk === -2;
    result.push(value);
  }
  return result.join("");
}
const document$1 = {
  [42]: list$1,
  [43]: list$1,
  [45]: list$1,
  [48]: list$1,
  [49]: list$1,
  [50]: list$1,
  [51]: list$1,
  [52]: list$1,
  [53]: list$1,
  [54]: list$1,
  [55]: list$1,
  [56]: list$1,
  [57]: list$1,
  [62]: blockQuote
};
const contentInitial = {
  [91]: definition
};
const flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  [32]: codeIndented
};
const flow = {
  [35]: headingAtx,
  [42]: thematicBreak$1,
  [45]: [setextUnderline, thematicBreak$1],
  [60]: htmlFlow,
  [61]: setextUnderline,
  [95]: thematicBreak$1,
  [96]: codeFenced,
  [126]: codeFenced
};
const string = {
  [38]: characterReference,
  [92]: characterEscape
};
const text$1 = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  [33]: labelStartImage,
  [38]: characterReference,
  [42]: attention,
  [60]: [autolink, htmlText],
  [91]: labelStartLink,
  [92]: [hardBreakEscape, characterEscape],
  [93]: labelEnd,
  [95]: attention,
  [96]: codeText
};
const insideSpan = {
  null: [attention, resolver]
};
const attentionMarkers = {
  null: [42, 95]
};
const disable = {
  null: []
};
const defaultConstructs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers,
  contentInitial,
  disable,
  document: document$1,
  flow,
  flowInitial,
  insideSpan,
  string,
  text: text$1
}, Symbol.toStringTag, { value: "Module" }));
function parse$1(options) {
  const settings = options || {};
  const constructs2 = (
    /** @type {FullNormalizedExtension} */
    combineExtensions([defaultConstructs, ...settings.extensions || []])
  );
  const parser = {
    defined: [],
    lazy: {},
    constructs: constructs2,
    content: create2(content$1),
    document: create2(document$2),
    flow: create2(flow$1),
    string: create2(string$1),
    text: create2(text$2)
  };
  return parser;
  function create2(initial) {
    return creator;
    function creator(from2) {
      return createTokenizer(parser, initial, from2);
    }
  }
}
const search = /[\0\t\n\r]/g;
function preprocess() {
  let column2 = 1;
  let buffer2 = "";
  let start = true;
  let atCarriageReturn;
  return preprocessor;
  function preprocessor(value, encoding, end) {
    const chunks = [];
    let match5;
    let next2;
    let startPosition;
    let endPosition;
    let code2;
    value = buffer2 + value.toString(encoding);
    startPosition = 0;
    buffer2 = "";
    if (start) {
      if (value.charCodeAt(0) === 65279) {
        startPosition++;
      }
      start = void 0;
    }
    while (startPosition < value.length) {
      search.lastIndex = startPosition;
      match5 = search.exec(value);
      endPosition = match5 && match5.index !== void 0 ? match5.index : value.length;
      code2 = value.charCodeAt(endPosition);
      if (!match5) {
        buffer2 = value.slice(startPosition);
        break;
      }
      if (code2 === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3);
        atCarriageReturn = void 0;
      } else {
        if (atCarriageReturn) {
          chunks.push(-5);
          atCarriageReturn = void 0;
        }
        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition));
          column2 += endPosition - startPosition;
        }
        switch (code2) {
          case 0: {
            chunks.push(65533);
            column2++;
            break;
          }
          case 9: {
            next2 = Math.ceil(column2 / 4) * 4;
            chunks.push(-2);
            while (column2++ < next2)
              chunks.push(-1);
            break;
          }
          case 10: {
            chunks.push(-4);
            column2 = 1;
            break;
          }
          default: {
            atCarriageReturn = true;
            column2 = 1;
          }
        }
      }
      startPosition = endPosition + 1;
    }
    if (end) {
      if (atCarriageReturn)
        chunks.push(-5);
      if (buffer2)
        chunks.push(buffer2);
      chunks.push(null);
    }
    return chunks;
  }
}
function postprocess(events) {
  while (!subtokenize(events)) {
  }
  return events;
}
function decodeNumericCharacterReference(value, base2) {
  const code2 = Number.parseInt(value, base2);
  if (
    // C0 except for HT, LF, FF, CR, space.
    code2 < 9 || code2 === 11 || code2 > 13 && code2 < 32 || // Control character (DEL) of C0, and C1 controls.
    code2 > 126 && code2 < 160 || // Lone high surrogates and low surrogates.
    code2 > 55295 && code2 < 57344 || // Noncharacters.
    code2 > 64975 && code2 < 65008 || (code2 & 65535) === 65535 || (code2 & 65535) === 65534 || // Out of range
    code2 > 1114111
  ) {
    return "�";
  }
  return String.fromCharCode(code2);
}
const characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function decodeString(value) {
  return value.replace(characterEscapeOrReference, decode);
}
function decode($0, $1, $2) {
  if ($1) {
    return $1;
  }
  const head = $2.charCodeAt(0);
  if (head === 35) {
    const head2 = $2.charCodeAt(1);
    const hex = head2 === 120 || head2 === 88;
    return decodeNumericCharacterReference($2.slice(hex ? 2 : 1), hex ? 16 : 10);
  }
  return decodeNamedCharacterReference($2) || $0;
}
const own$5 = {}.hasOwnProperty;
const fromMarkdown = (
  /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */
  /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */
  function(value, encoding, options) {
    if (typeof encoding !== "string") {
      options = encoding;
      encoding = void 0;
    }
    return compiler(options)(
      postprocess(
        parse$1(options).document().write(preprocess()(value, encoding, true))
      )
    );
  }
);
function compiler(options) {
  const config = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: opener(link2),
      autolinkProtocol: onenterdata,
      autolinkEmail: onenterdata,
      atxHeading: opener(heading2),
      blockQuote: opener(blockQuote2),
      characterEscape: onenterdata,
      characterReference: onenterdata,
      codeFenced: opener(codeFlow),
      codeFencedFenceInfo: buffer2,
      codeFencedFenceMeta: buffer2,
      codeIndented: opener(codeFlow, buffer2),
      codeText: opener(codeText2, buffer2),
      codeTextData: onenterdata,
      data: onenterdata,
      codeFlowValue: onenterdata,
      definition: opener(definition2),
      definitionDestinationString: buffer2,
      definitionLabelString: buffer2,
      definitionTitleString: buffer2,
      emphasis: opener(emphasis2),
      hardBreakEscape: opener(hardBreak2),
      hardBreakTrailing: opener(hardBreak2),
      htmlFlow: opener(html2, buffer2),
      htmlFlowData: onenterdata,
      htmlText: opener(html2, buffer2),
      htmlTextData: onenterdata,
      image: opener(image2),
      label: buffer2,
      link: opener(link2),
      listItem: opener(listItem2),
      listItemValue: onenterlistitemvalue,
      listOrdered: opener(list2, onenterlistordered),
      listUnordered: opener(list2),
      paragraph: opener(paragraph2),
      reference: onenterreference,
      referenceString: buffer2,
      resourceDestinationString: buffer2,
      resourceTitleString: buffer2,
      setextHeading: opener(heading2),
      strong: opener(strong2),
      thematicBreak: opener(thematicBreak2)
    },
    exit: {
      atxHeading: closer(),
      atxHeadingSequence: onexitatxheadingsequence,
      autolink: closer(),
      autolinkEmail: onexitautolinkemail,
      autolinkProtocol: onexitautolinkprotocol,
      blockQuote: closer(),
      characterEscapeValue: onexitdata,
      characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
      characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
      characterReferenceValue: onexitcharacterreferencevalue,
      codeFenced: closer(onexitcodefenced),
      codeFencedFence: onexitcodefencedfence,
      codeFencedFenceInfo: onexitcodefencedfenceinfo,
      codeFencedFenceMeta: onexitcodefencedfencemeta,
      codeFlowValue: onexitdata,
      codeIndented: closer(onexitcodeindented),
      codeText: closer(onexitcodetext),
      codeTextData: onexitdata,
      data: onexitdata,
      definition: closer(),
      definitionDestinationString: onexitdefinitiondestinationstring,
      definitionLabelString: onexitdefinitionlabelstring,
      definitionTitleString: onexitdefinitiontitlestring,
      emphasis: closer(),
      hardBreakEscape: closer(onexithardbreak),
      hardBreakTrailing: closer(onexithardbreak),
      htmlFlow: closer(onexithtmlflow),
      htmlFlowData: onexitdata,
      htmlText: closer(onexithtmltext),
      htmlTextData: onexitdata,
      image: closer(onexitimage),
      label: onexitlabel,
      labelText: onexitlabeltext,
      lineEnding: onexitlineending,
      link: closer(onexitlink),
      listItem: closer(),
      listOrdered: closer(),
      listUnordered: closer(),
      paragraph: closer(),
      referenceString: onexitreferencestring,
      resourceDestinationString: onexitresourcedestinationstring,
      resourceTitleString: onexitresourcetitlestring,
      resource: onexitresource,
      setextHeading: closer(onexitsetextheading),
      setextHeadingLineSequence: onexitsetextheadinglinesequence,
      setextHeadingText: onexitsetextheadingtext,
      strong: closer(),
      thematicBreak: closer()
    }
  };
  configure(config, (options || {}).mdastExtensions || []);
  const data = {};
  return compile2;
  function compile2(events) {
    let tree = {
      type: "root",
      children: []
    };
    const context = {
      stack: [tree],
      tokenStack: [],
      config,
      enter,
      exit: exit2,
      buffer: buffer2,
      resume,
      setData,
      getData
    };
    const listStack = [];
    let index2 = -1;
    while (++index2 < events.length) {
      if (events[index2][1].type === "listOrdered" || events[index2][1].type === "listUnordered") {
        if (events[index2][0] === "enter") {
          listStack.push(index2);
        } else {
          const tail = listStack.pop();
          index2 = prepareList(events, tail, index2);
        }
      }
    }
    index2 = -1;
    while (++index2 < events.length) {
      const handler = config[events[index2][0]];
      if (own$5.call(handler, events[index2][1].type)) {
        handler[events[index2][1].type].call(
          Object.assign(
            {
              sliceSerialize: events[index2][2].sliceSerialize
            },
            context
          ),
          events[index2][1]
        );
      }
    }
    if (context.tokenStack.length > 0) {
      const tail = context.tokenStack[context.tokenStack.length - 1];
      const handler = tail[1] || defaultOnError;
      handler.call(context, void 0, tail[0]);
    }
    tree.position = {
      start: point$1(
        events.length > 0 ? events[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: point$1(
        events.length > 0 ? events[events.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    };
    index2 = -1;
    while (++index2 < config.transforms.length) {
      tree = config.transforms[index2](tree) || tree;
    }
    return tree;
  }
  function prepareList(events, start, length2) {
    let index2 = start - 1;
    let containerBalance = -1;
    let listSpread = false;
    let listItem3;
    let lineIndex;
    let firstBlankLineIndex;
    let atMarker;
    while (++index2 <= length2) {
      const event = events[index2];
      if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
        if (event[0] === "enter") {
          containerBalance++;
        } else {
          containerBalance--;
        }
        atMarker = void 0;
      } else if (event[1].type === "lineEndingBlank") {
        if (event[0] === "enter") {
          if (listItem3 && !atMarker && !containerBalance && !firstBlankLineIndex) {
            firstBlankLineIndex = index2;
          }
          atMarker = void 0;
        }
      } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace")
        ;
      else {
        atMarker = void 0;
      }
      if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
        if (listItem3) {
          let tailIndex = index2;
          lineIndex = void 0;
          while (tailIndex--) {
            const tailEvent = events[tailIndex];
            if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
              if (tailEvent[0] === "exit")
                continue;
              if (lineIndex) {
                events[lineIndex][1].type = "lineEndingBlank";
                listSpread = true;
              }
              tailEvent[1].type = "lineEnding";
              lineIndex = tailIndex;
            } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent")
              ;
            else {
              break;
            }
          }
          if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) {
            listItem3._spread = true;
          }
          listItem3.end = Object.assign(
            {},
            lineIndex ? events[lineIndex][1].start : event[1].end
          );
          events.splice(lineIndex || index2, 0, ["exit", listItem3, event[2]]);
          index2++;
          length2++;
        }
        if (event[1].type === "listItemPrefix") {
          listItem3 = {
            type: "listItem",
            _spread: false,
            start: Object.assign({}, event[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          events.splice(index2, 0, ["enter", listItem3, event[2]]);
          index2++;
          length2++;
          firstBlankLineIndex = void 0;
          atMarker = true;
        }
      }
    }
    events[start][1]._spread = listSpread;
    return length2;
  }
  function setData(key, value) {
    data[key] = value;
  }
  function getData(key) {
    return data[key];
  }
  function opener(create2, and) {
    return open;
    function open(token2) {
      enter.call(this, create2(token2), token2);
      if (and)
        and.call(this, token2);
    }
  }
  function buffer2() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function enter(node2, token2, errorHandler) {
    const parent = this.stack[this.stack.length - 1];
    parent.children.push(node2);
    this.stack.push(node2);
    this.tokenStack.push([token2, errorHandler]);
    node2.position = {
      start: point$1(token2.start)
    };
    return node2;
  }
  function closer(and) {
    return close;
    function close(token2) {
      if (and)
        and.call(this, token2);
      exit2.call(this, token2);
    }
  }
  function exit2(token2, onExitError) {
    const node2 = this.stack.pop();
    const open = this.tokenStack.pop();
    if (!open) {
      throw new Error(
        "Cannot close `" + token2.type + "` (" + stringifyPosition({
          start: token2.start,
          end: token2.end
        }) + "): it’s not open"
      );
    } else if (open[0].type !== token2.type) {
      if (onExitError) {
        onExitError.call(this, token2, open[0]);
      } else {
        const handler = open[1] || defaultOnError;
        handler.call(this, token2, open[0]);
      }
    }
    node2.position.end = point$1(token2.end);
    return node2;
  }
  function resume() {
    return toString(this.stack.pop());
  }
  function onenterlistordered() {
    setData("expectingFirstListItemValue", true);
  }
  function onenterlistitemvalue(token2) {
    if (getData("expectingFirstListItemValue")) {
      const ancestor = this.stack[this.stack.length - 2];
      ancestor.start = Number.parseInt(this.sliceSerialize(token2), 10);
      setData("expectingFirstListItemValue");
    }
  }
  function onexitcodefencedfenceinfo() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.lang = data2;
  }
  function onexitcodefencedfencemeta() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.meta = data2;
  }
  function onexitcodefencedfence() {
    if (getData("flowCodeInside"))
      return;
    this.buffer();
    setData("flowCodeInside", true);
  }
  function onexitcodefenced() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.value = data2.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
    setData("flowCodeInside");
  }
  function onexitcodeindented() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.value = data2.replace(/(\r?\n|\r)$/g, "");
  }
  function onexitdefinitionlabelstring(token2) {
    const label = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.label = label;
    node2.identifier = normalizeIdentifier(
      this.sliceSerialize(token2)
    ).toLowerCase();
  }
  function onexitdefinitiontitlestring() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.title = data2;
  }
  function onexitdefinitiondestinationstring() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.url = data2;
  }
  function onexitatxheadingsequence(token2) {
    const node2 = this.stack[this.stack.length - 1];
    if (!node2.depth) {
      const depth = this.sliceSerialize(token2).length;
      node2.depth = depth;
    }
  }
  function onexitsetextheadingtext() {
    setData("setextHeadingSlurpLineEnding", true);
  }
  function onexitsetextheadinglinesequence(token2) {
    const node2 = this.stack[this.stack.length - 1];
    node2.depth = this.sliceSerialize(token2).charCodeAt(0) === 61 ? 1 : 2;
  }
  function onexitsetextheading() {
    setData("setextHeadingSlurpLineEnding");
  }
  function onenterdata(token2) {
    const node2 = this.stack[this.stack.length - 1];
    let tail = node2.children[node2.children.length - 1];
    if (!tail || tail.type !== "text") {
      tail = text2();
      tail.position = {
        start: point$1(token2.start)
      };
      node2.children.push(tail);
    }
    this.stack.push(tail);
  }
  function onexitdata(token2) {
    const tail = this.stack.pop();
    tail.value += this.sliceSerialize(token2);
    tail.position.end = point$1(token2.end);
  }
  function onexitlineending(token2) {
    const context = this.stack[this.stack.length - 1];
    if (getData("atHardBreak")) {
      const tail = context.children[context.children.length - 1];
      tail.position.end = point$1(token2.end);
      setData("atHardBreak");
      return;
    }
    if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.includes(context.type)) {
      onenterdata.call(this, token2);
      onexitdata.call(this, token2);
    }
  }
  function onexithardbreak() {
    setData("atHardBreak", true);
  }
  function onexithtmlflow() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.value = data2;
  }
  function onexithtmltext() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.value = data2;
  }
  function onexitcodetext() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.value = data2;
  }
  function onexitlink() {
    const node2 = this.stack[this.stack.length - 1];
    if (getData("inReference")) {
      const referenceType = getData("referenceType") || "shortcut";
      node2.type += "Reference";
      node2.referenceType = referenceType;
      delete node2.url;
      delete node2.title;
    } else {
      delete node2.identifier;
      delete node2.label;
    }
    setData("referenceType");
  }
  function onexitimage() {
    const node2 = this.stack[this.stack.length - 1];
    if (getData("inReference")) {
      const referenceType = getData("referenceType") || "shortcut";
      node2.type += "Reference";
      node2.referenceType = referenceType;
      delete node2.url;
      delete node2.title;
    } else {
      delete node2.identifier;
      delete node2.label;
    }
    setData("referenceType");
  }
  function onexitlabeltext(token2) {
    const string2 = this.sliceSerialize(token2);
    const ancestor = this.stack[this.stack.length - 2];
    ancestor.label = decodeString(string2);
    ancestor.identifier = normalizeIdentifier(string2).toLowerCase();
  }
  function onexitlabel() {
    const fragment = this.stack[this.stack.length - 1];
    const value = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    setData("inReference", true);
    if (node2.type === "link") {
      const children = fragment.children;
      node2.children = children;
    } else {
      node2.alt = value;
    }
  }
  function onexitresourcedestinationstring() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.url = data2;
  }
  function onexitresourcetitlestring() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.title = data2;
  }
  function onexitresource() {
    setData("inReference");
  }
  function onenterreference() {
    setData("referenceType", "collapsed");
  }
  function onexitreferencestring(token2) {
    const label = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.label = label;
    node2.identifier = normalizeIdentifier(
      this.sliceSerialize(token2)
    ).toLowerCase();
    setData("referenceType", "full");
  }
  function onexitcharacterreferencemarker(token2) {
    setData("characterReferenceType", token2.type);
  }
  function onexitcharacterreferencevalue(token2) {
    const data2 = this.sliceSerialize(token2);
    const type = getData("characterReferenceType");
    let value;
    if (type) {
      value = decodeNumericCharacterReference(
        data2,
        type === "characterReferenceMarkerNumeric" ? 10 : 16
      );
      setData("characterReferenceType");
    } else {
      const result = decodeNamedCharacterReference(data2);
      value = result;
    }
    const tail = this.stack.pop();
    tail.value += value;
    tail.position.end = point$1(token2.end);
  }
  function onexitautolinkprotocol(token2) {
    onexitdata.call(this, token2);
    const node2 = this.stack[this.stack.length - 1];
    node2.url = this.sliceSerialize(token2);
  }
  function onexitautolinkemail(token2) {
    onexitdata.call(this, token2);
    const node2 = this.stack[this.stack.length - 1];
    node2.url = "mailto:" + this.sliceSerialize(token2);
  }
  function blockQuote2() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function codeFlow() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function codeText2() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function definition2() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function emphasis2() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function heading2() {
    return {
      type: "heading",
      depth: void 0,
      children: []
    };
  }
  function hardBreak2() {
    return {
      type: "break"
    };
  }
  function html2() {
    return {
      type: "html",
      value: ""
    };
  }
  function image2() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function link2() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function list2(token2) {
    return {
      type: "list",
      ordered: token2.type === "listOrdered",
      start: null,
      spread: token2._spread,
      children: []
    };
  }
  function listItem2(token2) {
    return {
      type: "listItem",
      spread: token2._spread,
      checked: null,
      children: []
    };
  }
  function paragraph2() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function strong2() {
    return {
      type: "strong",
      children: []
    };
  }
  function text2() {
    return {
      type: "text",
      value: ""
    };
  }
  function thematicBreak2() {
    return {
      type: "thematicBreak"
    };
  }
}
function point$1(d2) {
  return {
    line: d2.line,
    column: d2.column,
    offset: d2.offset
  };
}
function configure(combined, extensions) {
  let index2 = -1;
  while (++index2 < extensions.length) {
    const value = extensions[index2];
    if (Array.isArray(value)) {
      configure(combined, value);
    } else {
      extension(combined, value);
    }
  }
}
function extension(combined, extension2) {
  let key;
  for (key in extension2) {
    if (own$5.call(extension2, key)) {
      if (key === "canContainEols") {
        const right = extension2[key];
        if (right) {
          combined[key].push(...right);
        }
      } else if (key === "transforms") {
        const right = extension2[key];
        if (right) {
          combined[key].push(...right);
        }
      } else if (key === "enter" || key === "exit") {
        const right = extension2[key];
        if (right) {
          Object.assign(combined[key], right);
        }
      }
    }
  }
}
function defaultOnError(left, right) {
  if (left) {
    throw new Error(
      "Cannot close `" + left.type + "` (" + stringifyPosition({
        start: left.start,
        end: left.end
      }) + "): a different token (`" + right.type + "`, " + stringifyPosition({
        start: right.start,
        end: right.end
      }) + ") is open"
    );
  } else {
    throw new Error(
      "Cannot close document, a token (`" + right.type + "`, " + stringifyPosition({
        start: right.start,
        end: right.end
      }) + ") is still open"
    );
  }
}
function remarkParse(options) {
  const parser = (doc) => {
    const settings = (
      /** @type {Options} */
      this.data("settings")
    );
    return fromMarkdown(
      doc,
      Object.assign({}, settings, options, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data("micromarkExtensions") || [],
        mdastExtensions: this.data("fromMarkdownExtensions") || []
      })
    );
  };
  Object.assign(this, { Parser: parser });
}
function blockquote(state, node2) {
  const result = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: state.wrap(state.all(node2), true)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function hardBreak(state, node2) {
  const result = { type: "element", tagName: "br", properties: {}, children: [] };
  state.patch(node2, result);
  return [state.applyData(node2, result), { type: "text", value: "\n" }];
}
function code(state, node2) {
  const value = node2.value ? node2.value + "\n" : "";
  const lang2 = node2.lang ? node2.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null;
  const properties2 = {};
  if (lang2) {
    properties2.className = ["language-" + lang2];
  }
  let result = {
    type: "element",
    tagName: "code",
    properties: properties2,
    children: [{ type: "text", value }]
  };
  if (node2.meta) {
    result.data = { meta: node2.meta };
  }
  state.patch(node2, result);
  result = state.applyData(node2, result);
  result = { type: "element", tagName: "pre", properties: {}, children: [result] };
  state.patch(node2, result);
  return result;
}
function strikethrough(state, node2) {
  const result = {
    type: "element",
    tagName: "del",
    properties: {},
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function emphasis(state, node2) {
  const result = {
    type: "element",
    tagName: "em",
    properties: {},
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function normalizeUri(value) {
  const result = [];
  let index2 = -1;
  let start = 0;
  let skip = 0;
  while (++index2 < value.length) {
    const code2 = value.charCodeAt(index2);
    let replace2 = "";
    if (code2 === 37 && asciiAlphanumeric(value.charCodeAt(index2 + 1)) && asciiAlphanumeric(value.charCodeAt(index2 + 2))) {
      skip = 2;
    } else if (code2 < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code2))) {
        replace2 = String.fromCharCode(code2);
      }
    } else if (code2 > 55295 && code2 < 57344) {
      const next2 = value.charCodeAt(index2 + 1);
      if (code2 < 56320 && next2 > 56319 && next2 < 57344) {
        replace2 = String.fromCharCode(code2, next2);
        skip = 1;
      } else {
        replace2 = "�";
      }
    } else {
      replace2 = String.fromCharCode(code2);
    }
    if (replace2) {
      result.push(value.slice(start, index2), encodeURIComponent(replace2));
      start = index2 + skip + 1;
      replace2 = "";
    }
    if (skip) {
      index2 += skip;
      skip = 0;
    }
  }
  return result.join("") + value.slice(start);
}
function footnoteReference(state, node2) {
  const id = String(node2.identifier).toUpperCase();
  const safeId = normalizeUri(id.toLowerCase());
  const index2 = state.footnoteOrder.indexOf(id);
  let counter;
  if (index2 === -1) {
    state.footnoteOrder.push(id);
    state.footnoteCounts[id] = 1;
    counter = state.footnoteOrder.length;
  } else {
    state.footnoteCounts[id]++;
    counter = index2 + 1;
  }
  const reuseCounter = state.footnoteCounts[id];
  const link2 = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + state.clobberPrefix + "fn-" + safeId,
      id: state.clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
      dataFootnoteRef: true,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(counter) }]
  };
  state.patch(node2, link2);
  const sup = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [link2]
  };
  state.patch(node2, sup);
  return state.applyData(node2, sup);
}
function footnote(state, node2) {
  const footnoteById = state.footnoteById;
  let no = 1;
  while (no in footnoteById)
    no++;
  const identifier2 = String(no);
  footnoteById[identifier2] = {
    type: "footnoteDefinition",
    identifier: identifier2,
    children: [{ type: "paragraph", children: node2.children }],
    position: node2.position
  };
  return footnoteReference(state, {
    type: "footnoteReference",
    identifier: identifier2,
    position: node2.position
  });
}
function heading(state, node2) {
  const result = {
    type: "element",
    tagName: "h" + node2.depth,
    properties: {},
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function html$2(state, node2) {
  if (state.dangerous) {
    const result = { type: "raw", value: node2.value };
    state.patch(node2, result);
    return state.applyData(node2, result);
  }
  return null;
}
function revert(state, node2) {
  const subtype = node2.referenceType;
  let suffix = "]";
  if (subtype === "collapsed") {
    suffix += "[]";
  } else if (subtype === "full") {
    suffix += "[" + (node2.label || node2.identifier) + "]";
  }
  if (node2.type === "imageReference") {
    return { type: "text", value: "![" + node2.alt + suffix };
  }
  const contents = state.all(node2);
  const head = contents[0];
  if (head && head.type === "text") {
    head.value = "[" + head.value;
  } else {
    contents.unshift({ type: "text", value: "[" });
  }
  const tail = contents[contents.length - 1];
  if (tail && tail.type === "text") {
    tail.value += suffix;
  } else {
    contents.push({ type: "text", value: suffix });
  }
  return contents;
}
function imageReference(state, node2) {
  const def = state.definition(node2.identifier);
  if (!def) {
    return revert(state, node2);
  }
  const properties2 = { src: normalizeUri(def.url || ""), alt: node2.alt };
  if (def.title !== null && def.title !== void 0) {
    properties2.title = def.title;
  }
  const result = { type: "element", tagName: "img", properties: properties2, children: [] };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function image(state, node2) {
  const properties2 = { src: normalizeUri(node2.url) };
  if (node2.alt !== null && node2.alt !== void 0) {
    properties2.alt = node2.alt;
  }
  if (node2.title !== null && node2.title !== void 0) {
    properties2.title = node2.title;
  }
  const result = { type: "element", tagName: "img", properties: properties2, children: [] };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function inlineCode(state, node2) {
  const text2 = { type: "text", value: node2.value.replace(/\r?\n|\r/g, " ") };
  state.patch(node2, text2);
  const result = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [text2]
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function linkReference(state, node2) {
  const def = state.definition(node2.identifier);
  if (!def) {
    return revert(state, node2);
  }
  const properties2 = { href: normalizeUri(def.url || "") };
  if (def.title !== null && def.title !== void 0) {
    properties2.title = def.title;
  }
  const result = {
    type: "element",
    tagName: "a",
    properties: properties2,
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function link(state, node2) {
  const properties2 = { href: normalizeUri(node2.url) };
  if (node2.title !== null && node2.title !== void 0) {
    properties2.title = node2.title;
  }
  const result = {
    type: "element",
    tagName: "a",
    properties: properties2,
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function listItem(state, node2, parent) {
  const results = state.all(node2);
  const loose = parent ? listLoose(parent) : listItemLoose(node2);
  const properties2 = {};
  const children = [];
  if (typeof node2.checked === "boolean") {
    const head = results[0];
    let paragraph2;
    if (head && head.type === "element" && head.tagName === "p") {
      paragraph2 = head;
    } else {
      paragraph2 = { type: "element", tagName: "p", properties: {}, children: [] };
      results.unshift(paragraph2);
    }
    if (paragraph2.children.length > 0) {
      paragraph2.children.unshift({ type: "text", value: " " });
    }
    paragraph2.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: node2.checked, disabled: true },
      children: []
    });
    properties2.className = ["task-list-item"];
  }
  let index2 = -1;
  while (++index2 < results.length) {
    const child = results[index2];
    if (loose || index2 !== 0 || child.type !== "element" || child.tagName !== "p") {
      children.push({ type: "text", value: "\n" });
    }
    if (child.type === "element" && child.tagName === "p" && !loose) {
      children.push(...child.children);
    } else {
      children.push(child);
    }
  }
  const tail = results[results.length - 1];
  if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) {
    children.push({ type: "text", value: "\n" });
  }
  const result = { type: "element", tagName: "li", properties: properties2, children };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function listLoose(node2) {
  let loose = false;
  if (node2.type === "list") {
    loose = node2.spread || false;
    const children = node2.children;
    let index2 = -1;
    while (!loose && ++index2 < children.length) {
      loose = listItemLoose(children[index2]);
    }
  }
  return loose;
}
function listItemLoose(node2) {
  const spread = node2.spread;
  return spread === void 0 || spread === null ? node2.children.length > 1 : spread;
}
function list(state, node2) {
  const properties2 = {};
  const results = state.all(node2);
  let index2 = -1;
  if (typeof node2.start === "number" && node2.start !== 1) {
    properties2.start = node2.start;
  }
  while (++index2 < results.length) {
    const child = results[index2];
    if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
      properties2.className = ["contains-task-list"];
      break;
    }
  }
  const result = {
    type: "element",
    tagName: node2.ordered ? "ol" : "ul",
    properties: properties2,
    children: state.wrap(results, true)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function paragraph(state, node2) {
  const result = {
    type: "element",
    tagName: "p",
    properties: {},
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function root$1(state, node2) {
  const result = { type: "root", children: state.wrap(state.all(node2)) };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function strong(state, node2) {
  const result = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
const pointStart = point("start");
const pointEnd = point("end");
function position(node2) {
  return { start: pointStart(node2), end: pointEnd(node2) };
}
function point(type) {
  return point2;
  function point2(node2) {
    const point3 = node2 && node2.position && node2.position[type] || {};
    return {
      // @ts-expect-error: in practice, null is allowed.
      line: point3.line || null,
      // @ts-expect-error: in practice, null is allowed.
      column: point3.column || null,
      // @ts-expect-error: in practice, null is allowed.
      offset: point3.offset > -1 ? point3.offset : null
    };
  }
}
function table(state, node2) {
  const rows = state.all(node2);
  const firstRow = rows.shift();
  const tableContent = [];
  if (firstRow) {
    const head = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: state.wrap([firstRow], true)
    };
    state.patch(node2.children[0], head);
    tableContent.push(head);
  }
  if (rows.length > 0) {
    const body = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: state.wrap(rows, true)
    };
    const start = pointStart(node2.children[1]);
    const end = pointEnd(node2.children[node2.children.length - 1]);
    if (start.line && end.line)
      body.position = { start, end };
    tableContent.push(body);
  }
  const result = {
    type: "element",
    tagName: "table",
    properties: {},
    children: state.wrap(tableContent, true)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function tableRow(state, node2, parent) {
  const siblings = parent ? parent.children : void 0;
  const rowIndex = siblings ? siblings.indexOf(node2) : 1;
  const tagName = rowIndex === 0 ? "th" : "td";
  const align = parent && parent.type === "table" ? parent.align : void 0;
  const length2 = align ? align.length : node2.children.length;
  let cellIndex = -1;
  const cells = [];
  while (++cellIndex < length2) {
    const cell = node2.children[cellIndex];
    const properties2 = {};
    const alignValue = align ? align[cellIndex] : void 0;
    if (alignValue) {
      properties2.align = alignValue;
    }
    let result2 = { type: "element", tagName, properties: properties2, children: [] };
    if (cell) {
      result2.children = state.all(cell);
      state.patch(cell, result2);
      result2 = state.applyData(node2, result2);
    }
    cells.push(result2);
  }
  const result = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: state.wrap(cells, true)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function tableCell(state, node2) {
  const result = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
const tab = 9;
const space = 32;
function trimLines(value) {
  const source = String(value);
  const search2 = /\r?\n|\r/g;
  let match5 = search2.exec(source);
  let last = 0;
  const lines = [];
  while (match5) {
    lines.push(
      trimLine(source.slice(last, match5.index), last > 0, true),
      match5[0]
    );
    last = match5.index + match5[0].length;
    match5 = search2.exec(source);
  }
  lines.push(trimLine(source.slice(last), last > 0, false));
  return lines.join("");
}
function trimLine(value, start, end) {
  let startIndex = 0;
  let endIndex = value.length;
  if (start) {
    let code2 = value.codePointAt(startIndex);
    while (code2 === tab || code2 === space) {
      startIndex++;
      code2 = value.codePointAt(startIndex);
    }
  }
  if (end) {
    let code2 = value.codePointAt(endIndex - 1);
    while (code2 === tab || code2 === space) {
      endIndex--;
      code2 = value.codePointAt(endIndex - 1);
    }
  }
  return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}
function text(state, node2) {
  const result = { type: "text", value: trimLines(String(node2.value)) };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function thematicBreak(state, node2) {
  const result = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
const handlers = {
  blockquote,
  break: hardBreak,
  code,
  delete: strikethrough,
  emphasis,
  footnoteReference,
  footnote,
  heading,
  html: html$2,
  imageReference,
  image,
  inlineCode,
  linkReference,
  link,
  listItem,
  list,
  paragraph,
  root: root$1,
  strong,
  table,
  tableCell,
  tableRow,
  text,
  thematicBreak,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
};
function ignore() {
  return null;
}
const convert = (
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {AssertAnything}
   */
  function(test) {
    if (test === void 0 || test === null) {
      return ok;
    }
    if (typeof test === "string") {
      return typeFactory(test);
    }
    if (typeof test === "object") {
      return Array.isArray(test) ? anyFactory(test) : propsFactory(test);
    }
    if (typeof test === "function") {
      return castFactory(test);
    }
    throw new Error("Expected function, string, or object as test");
  }
);
function anyFactory(tests) {
  const checks2 = [];
  let index2 = -1;
  while (++index2 < tests.length) {
    checks2[index2] = convert(tests[index2]);
  }
  return castFactory(any);
  function any(...parameters) {
    let index3 = -1;
    while (++index3 < checks2.length) {
      if (checks2[index3].call(this, ...parameters))
        return true;
    }
    return false;
  }
}
function propsFactory(check) {
  return castFactory(all2);
  function all2(node2) {
    let key;
    for (key in check) {
      if (node2[key] !== check[key])
        return false;
    }
    return true;
  }
}
function typeFactory(check) {
  return castFactory(type);
  function type(node2) {
    return node2 && node2.type === check;
  }
}
function castFactory(check) {
  return assertion;
  function assertion(node2, ...parameters) {
    return Boolean(
      node2 && typeof node2 === "object" && "type" in node2 && // @ts-expect-error: fine.
      Boolean(check.call(this, node2, ...parameters))
    );
  }
}
function ok() {
  return true;
}
function color(d2) {
  return d2;
}
const CONTINUE = true;
const EXIT = false;
const SKIP = "skip";
const visitParents = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor<Node>} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
      reverse = visitor;
      visitor = test;
      test = null;
    }
    const is = convert(test);
    const step = reverse ? -1 : 1;
    factory(tree, void 0, [])();
    function factory(node2, index2, parents) {
      const value = node2 && typeof node2 === "object" ? node2 : {};
      if (typeof value.type === "string") {
        const name = (
          // `hast`
          typeof value.tagName === "string" ? value.tagName : (
            // `xast`
            typeof value.name === "string" ? value.name : void 0
          )
        );
        Object.defineProperty(visit2, "name", {
          value: "node (" + color(node2.type + (name ? "<" + name + ">" : "")) + ")"
        });
      }
      return visit2;
      function visit2() {
        let result = [];
        let subresult;
        let offset2;
        let grandparents;
        if (!test || is(node2, index2, parents[parents.length - 1] || null)) {
          result = toResult(visitor(node2, parents));
          if (result[0] === EXIT) {
            return result;
          }
        }
        if (node2.children && result[0] !== SKIP) {
          offset2 = (reverse ? node2.children.length : -1) + step;
          grandparents = parents.concat(node2);
          while (offset2 > -1 && offset2 < node2.children.length) {
            subresult = factory(node2.children[offset2], offset2, grandparents)();
            if (subresult[0] === EXIT) {
              return subresult;
            }
            offset2 = typeof subresult[1] === "number" ? subresult[1] : offset2 + step;
          }
        }
        return result;
      }
    }
  }
);
function toResult(value) {
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === "number") {
    return [CONTINUE, value];
  }
  return [value];
}
const visit = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
      reverse = visitor;
      visitor = test;
      test = null;
    }
    visitParents(tree, test, overload, reverse);
    function overload(node2, parents) {
      const parent = parents[parents.length - 1];
      return visitor(
        node2,
        parent ? parent.children.indexOf(node2) : null,
        parent
      );
    }
  }
);
function generated(node2) {
  return !node2 || !node2.position || !node2.position.start || !node2.position.start.line || !node2.position.start.column || !node2.position.end || !node2.position.end.line || !node2.position.end.column;
}
const own$4 = {}.hasOwnProperty;
function definitions(tree) {
  const cache2 = /* @__PURE__ */ Object.create(null);
  if (!tree || !tree.type) {
    throw new Error("mdast-util-definitions expected node");
  }
  visit(tree, "definition", (definition3) => {
    const id = clean(definition3.identifier);
    if (id && !own$4.call(cache2, id)) {
      cache2[id] = definition3;
    }
  });
  return definition2;
  function definition2(identifier2) {
    const id = clean(identifier2);
    return id && own$4.call(cache2, id) ? cache2[id] : null;
  }
}
function clean(value) {
  return String(value || "").toUpperCase();
}
const own$3 = {}.hasOwnProperty;
function createState(tree, options) {
  const settings = options || {};
  const dangerous = settings.allowDangerousHtml || false;
  const footnoteById = {};
  state.dangerous = dangerous;
  state.clobberPrefix = settings.clobberPrefix === void 0 || settings.clobberPrefix === null ? "user-content-" : settings.clobberPrefix;
  state.footnoteLabel = settings.footnoteLabel || "Footnotes";
  state.footnoteLabelTagName = settings.footnoteLabelTagName || "h2";
  state.footnoteLabelProperties = settings.footnoteLabelProperties || {
    className: ["sr-only"]
  };
  state.footnoteBackLabel = settings.footnoteBackLabel || "Back to content";
  state.unknownHandler = settings.unknownHandler;
  state.passThrough = settings.passThrough;
  state.handlers = __spreadValues(__spreadValues({}, handlers), settings.handlers);
  state.definition = definitions(tree);
  state.footnoteById = footnoteById;
  state.footnoteOrder = [];
  state.footnoteCounts = {};
  state.patch = patch;
  state.applyData = applyData;
  state.one = oneBound;
  state.all = allBound;
  state.wrap = wrap;
  state.augment = augment;
  visit(tree, "footnoteDefinition", (definition2) => {
    const id = String(definition2.identifier).toUpperCase();
    if (!own$3.call(footnoteById, id)) {
      footnoteById[id] = definition2;
    }
  });
  return state;
  function augment(left, right) {
    if (left && "data" in left && left.data) {
      const data = left.data;
      if (data.hName) {
        if (right.type !== "element") {
          right = {
            type: "element",
            tagName: "",
            properties: {},
            children: []
          };
        }
        right.tagName = data.hName;
      }
      if (right.type === "element" && data.hProperties) {
        right.properties = __spreadValues(__spreadValues({}, right.properties), data.hProperties);
      }
      if ("children" in right && right.children && data.hChildren) {
        right.children = data.hChildren;
      }
    }
    if (left) {
      const ctx = "type" in left ? left : { position: left };
      if (!generated(ctx)) {
        right.position = { start: pointStart(ctx), end: pointEnd(ctx) };
      }
    }
    return right;
  }
  function state(node2, tagName, props, children) {
    if (Array.isArray(props)) {
      children = props;
      props = {};
    }
    return augment(node2, {
      type: "element",
      tagName,
      properties: props || {},
      children: children || []
    });
  }
  function oneBound(node2, parent) {
    return one(state, node2, parent);
  }
  function allBound(parent) {
    return all(state, parent);
  }
}
function patch(from2, to2) {
  if (from2.position)
    to2.position = position(from2);
}
function applyData(from2, to2) {
  let result = to2;
  if (from2 && from2.data) {
    const hName = from2.data.hName;
    const hChildren = from2.data.hChildren;
    const hProperties = from2.data.hProperties;
    if (typeof hName === "string") {
      if (result.type === "element") {
        result.tagName = hName;
      } else {
        result = {
          type: "element",
          tagName: hName,
          properties: {},
          children: []
        };
      }
    }
    if (result.type === "element" && hProperties) {
      result.properties = __spreadValues(__spreadValues({}, result.properties), hProperties);
    }
    if ("children" in result && result.children && hChildren !== null && hChildren !== void 0) {
      result.children = hChildren;
    }
  }
  return result;
}
function one(state, node2, parent) {
  const type = node2 && node2.type;
  if (!type) {
    throw new Error("Expected node, got `" + node2 + "`");
  }
  if (own$3.call(state.handlers, type)) {
    return state.handlers[type](state, node2, parent);
  }
  if (state.passThrough && state.passThrough.includes(type)) {
    return "children" in node2 ? __spreadProps(__spreadValues({}, node2), { children: all(state, node2) }) : node2;
  }
  if (state.unknownHandler) {
    return state.unknownHandler(state, node2, parent);
  }
  return defaultUnknownHandler(state, node2);
}
function all(state, parent) {
  const values2 = [];
  if ("children" in parent) {
    const nodes = parent.children;
    let index2 = -1;
    while (++index2 < nodes.length) {
      const result = one(state, nodes[index2], parent);
      if (result) {
        if (index2 && nodes[index2 - 1].type === "break") {
          if (!Array.isArray(result) && result.type === "text") {
            result.value = result.value.replace(/^\s+/, "");
          }
          if (!Array.isArray(result) && result.type === "element") {
            const head = result.children[0];
            if (head && head.type === "text") {
              head.value = head.value.replace(/^\s+/, "");
            }
          }
        }
        if (Array.isArray(result)) {
          values2.push(...result);
        } else {
          values2.push(result);
        }
      }
    }
  }
  return values2;
}
function defaultUnknownHandler(state, node2) {
  const data = node2.data || {};
  const result = "value" in node2 && !(own$3.call(data, "hProperties") || own$3.call(data, "hChildren")) ? { type: "text", value: node2.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: all(state, node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function wrap(nodes, loose) {
  const result = [];
  let index2 = -1;
  if (loose) {
    result.push({ type: "text", value: "\n" });
  }
  while (++index2 < nodes.length) {
    if (index2)
      result.push({ type: "text", value: "\n" });
    result.push(nodes[index2]);
  }
  if (loose && nodes.length > 0) {
    result.push({ type: "text", value: "\n" });
  }
  return result;
}
function footer(state) {
  const listItems = [];
  let index2 = -1;
  while (++index2 < state.footnoteOrder.length) {
    const def = state.footnoteById[state.footnoteOrder[index2]];
    if (!def) {
      continue;
    }
    const content2 = state.all(def);
    const id = String(def.identifier).toUpperCase();
    const safeId = normalizeUri(id.toLowerCase());
    let referenceIndex = 0;
    const backReferences = [];
    while (++referenceIndex <= state.footnoteCounts[id]) {
      const backReference = {
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + state.clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : ""),
          dataFootnoteBackref: true,
          className: ["data-footnote-backref"],
          ariaLabel: state.footnoteBackLabel
        },
        children: [{ type: "text", value: "↩" }]
      };
      if (referenceIndex > 1) {
        backReference.children.push({
          type: "element",
          tagName: "sup",
          children: [{ type: "text", value: String(referenceIndex) }]
        });
      }
      if (backReferences.length > 0) {
        backReferences.push({ type: "text", value: " " });
      }
      backReferences.push(backReference);
    }
    const tail = content2[content2.length - 1];
    if (tail && tail.type === "element" && tail.tagName === "p") {
      const tailTail = tail.children[tail.children.length - 1];
      if (tailTail && tailTail.type === "text") {
        tailTail.value += " ";
      } else {
        tail.children.push({ type: "text", value: " " });
      }
      tail.children.push(...backReferences);
    } else {
      content2.push(...backReferences);
    }
    const listItem2 = {
      type: "element",
      tagName: "li",
      properties: { id: state.clobberPrefix + "fn-" + safeId },
      children: state.wrap(content2, true)
    };
    state.patch(def, listItem2);
    listItems.push(listItem2);
  }
  if (listItems.length === 0) {
    return;
  }
  return {
    type: "element",
    tagName: "section",
    properties: { dataFootnotes: true, className: ["footnotes"] },
    children: [
      {
        type: "element",
        tagName: state.footnoteLabelTagName,
        properties: __spreadProps(__spreadValues({}, JSON.parse(JSON.stringify(state.footnoteLabelProperties))), {
          id: "footnote-label"
        }),
        children: [{ type: "text", value: state.footnoteLabel }]
      },
      { type: "text", value: "\n" },
      {
        type: "element",
        tagName: "ol",
        properties: {},
        children: state.wrap(listItems, true)
      },
      { type: "text", value: "\n" }
    ]
  };
}
function toHast(tree, options) {
  const state = createState(tree, options);
  const node2 = state.one(tree, null);
  const foot = footer(state);
  if (foot) {
    node2.children.push({ type: "text", value: "\n" }, foot);
  }
  return Array.isArray(node2) ? { type: "root", children: node2 } : node2;
}
const remarkRehype = (
  /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */
  function(destination, options) {
    return destination && "run" in destination ? bridge(destination, options) : mutate(destination || options);
  }
);
const remarkRehype$1 = remarkRehype;
function bridge(destination, options) {
  return (node2, file, next2) => {
    destination.run(toHast(node2, options), file, (error) => {
      next2(error);
    });
  };
}
function mutate(options) {
  return (node2) => toHast(node2, options);
}
var propTypes = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error(
      "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
    );
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
class Schema {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(property, normal, space2) {
    this.property = property;
    this.normal = normal;
    if (space2) {
      this.space = space2;
    }
  }
}
Schema.prototype.property = {};
Schema.prototype.normal = {};
Schema.prototype.space = null;
function merge(definitions2, space2) {
  const property = {};
  const normal = {};
  let index2 = -1;
  while (++index2 < definitions2.length) {
    Object.assign(property, definitions2[index2].property);
    Object.assign(normal, definitions2[index2].normal);
  }
  return new Schema(property, normal, space2);
}
function normalize(value) {
  return value.toLowerCase();
}
class Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(property, attribute) {
    this.property = property;
    this.attribute = attribute;
  }
}
Info.prototype.space = null;
Info.prototype.boolean = false;
Info.prototype.booleanish = false;
Info.prototype.overloadedBoolean = false;
Info.prototype.number = false;
Info.prototype.commaSeparated = false;
Info.prototype.spaceSeparated = false;
Info.prototype.commaOrSpaceSeparated = false;
Info.prototype.mustUseProperty = false;
Info.prototype.defined = false;
let powers = 0;
const boolean = increment();
const booleanish = increment();
const overloadedBoolean = increment();
const number = increment();
const spaceSeparated = increment();
const commaSeparated = increment();
const commaOrSpaceSeparated = increment();
function increment() {
  return __pow(2, ++powers);
}
const types = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean,
  booleanish,
  commaOrSpaceSeparated,
  commaSeparated,
  number,
  overloadedBoolean,
  spaceSeparated
}, Symbol.toStringTag, { value: "Module" }));
const checks = Object.keys(types);
class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(property, attribute, mask, space2) {
    let index2 = -1;
    super(property, attribute);
    mark(this, "space", space2);
    if (typeof mask === "number") {
      while (++index2 < checks.length) {
        const check = checks[index2];
        mark(this, checks[index2], (mask & types[check]) === types[check]);
      }
    }
  }
}
DefinedInfo.prototype.defined = true;
function mark(values2, key, value) {
  if (value) {
    values2[key] = value;
  }
}
const own$2 = {}.hasOwnProperty;
function create(definition2) {
  const property = {};
  const normal = {};
  let prop;
  for (prop in definition2.properties) {
    if (own$2.call(definition2.properties, prop)) {
      const value = definition2.properties[prop];
      const info = new DefinedInfo(
        prop,
        definition2.transform(definition2.attributes || {}, prop),
        value,
        definition2.space
      );
      if (definition2.mustUseProperty && definition2.mustUseProperty.includes(prop)) {
        info.mustUseProperty = true;
      }
      property[prop] = info;
      normal[normalize(prop)] = prop;
      normal[normalize(info.attribute)] = prop;
    }
  }
  return new Schema(property, normal, definition2.space);
}
const xlink = create({
  space: "xlink",
  transform(_, prop) {
    return "xlink:" + prop.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
});
const xml = create({
  space: "xml",
  transform(_, prop) {
    return "xml:" + prop.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute;
}
function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase());
}
const xmlns = create({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: caseInsensitiveTransform,
  properties: { xmlns: null, xmlnsXLink: null }
});
const aria = create({
  transform(_, prop) {
    return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  }
});
const html$1 = create({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    capture: boolean,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: boolean,
    // Lists. Use CSS to reduce space between items instead
    declare: boolean,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number,
    // `<img>` and `<object>`
    leftMargin: number,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number,
    // `<body>`
    marginWidth: number,
    // `<body>`
    noResize: boolean,
    // `<frame>`
    noHref: boolean,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  }
});
const svg$1 = create({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: caseSensitiveTransform,
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
});
const valid = /^data[-\w.:]+$/i;
const dash = /-[a-z]/g;
const cap = /[A-Z]/g;
function find(schema, value) {
  const normal = normalize(value);
  let prop = value;
  let Type = Info;
  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]];
  }
  if (normal.length > 4 && normal.slice(0, 4) === "data" && valid.test(value)) {
    if (value.charAt(4) === "-") {
      const rest = value.slice(5).replace(dash, camelcase);
      prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
    } else {
      const rest = value.slice(4);
      if (!dash.test(rest)) {
        let dashes = rest.replace(cap, kebab);
        if (dashes.charAt(0) !== "-") {
          dashes = "-" + dashes;
        }
        value = "data" + dashes;
      }
    }
    Type = DefinedInfo;
  }
  return new Type(prop, value);
}
function kebab($0) {
  return "-" + $0.toLowerCase();
}
function camelcase($0) {
  return $0.charAt(1).toUpperCase();
}
const hastToReact = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
};
const html = merge([xml, xlink, xmlns, aria, html$1], "html");
const svg = merge([xml, xlink, xmlns, aria, svg$1], "svg");
function rehypeFilter(options) {
  if (options.allowedElements && options.disallowedElements) {
    throw new TypeError(
      "Only one of `allowedElements` and `disallowedElements` should be defined"
    );
  }
  if (options.allowedElements || options.disallowedElements || options.allowElement) {
    return (tree) => {
      visit(tree, "element", (node2, index2, parent_) => {
        const parent = (
          /** @type {Element|Root} */
          parent_
        );
        let remove;
        if (options.allowedElements) {
          remove = !options.allowedElements.includes(node2.tagName);
        } else if (options.disallowedElements) {
          remove = options.disallowedElements.includes(node2.tagName);
        }
        if (!remove && options.allowElement && typeof index2 === "number") {
          remove = !options.allowElement(node2, index2, parent);
        }
        if (remove && typeof index2 === "number") {
          if (options.unwrapDisallowed && node2.children) {
            parent.children.splice(index2, 1, ...node2.children);
          } else {
            parent.children.splice(index2, 1);
          }
          return index2;
        }
        return void 0;
      });
    };
  }
}
var reactIs = { exports: {} };
var reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t$1 = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
  if ("object" === typeof a && null !== a) {
    var r2 = a.$$typeof;
    switch (r2) {
      case b:
        switch (a = a.type, a) {
          case d:
          case f:
          case e:
          case m:
          case n:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case h:
              case l:
              case q:
              case p:
              case g:
                return a;
              default:
                return r2;
            }
        }
      case c:
        return r2;
    }
  }
}
reactIs_production_min.ContextConsumer = h;
reactIs_production_min.ContextProvider = g;
reactIs_production_min.Element = b;
reactIs_production_min.ForwardRef = l;
reactIs_production_min.Fragment = d;
reactIs_production_min.Lazy = q;
reactIs_production_min.Memo = p;
reactIs_production_min.Portal = c;
reactIs_production_min.Profiler = f;
reactIs_production_min.StrictMode = e;
reactIs_production_min.Suspense = m;
reactIs_production_min.SuspenseList = n;
reactIs_production_min.isAsyncMode = function() {
  return false;
};
reactIs_production_min.isConcurrentMode = function() {
  return false;
};
reactIs_production_min.isContextConsumer = function(a) {
  return v(a) === h;
};
reactIs_production_min.isContextProvider = function(a) {
  return v(a) === g;
};
reactIs_production_min.isElement = function(a) {
  return "object" === typeof a && null !== a && a.$$typeof === b;
};
reactIs_production_min.isForwardRef = function(a) {
  return v(a) === l;
};
reactIs_production_min.isFragment = function(a) {
  return v(a) === d;
};
reactIs_production_min.isLazy = function(a) {
  return v(a) === q;
};
reactIs_production_min.isMemo = function(a) {
  return v(a) === p;
};
reactIs_production_min.isPortal = function(a) {
  return v(a) === c;
};
reactIs_production_min.isProfiler = function(a) {
  return v(a) === f;
};
reactIs_production_min.isStrictMode = function(a) {
  return v(a) === e;
};
reactIs_production_min.isSuspense = function(a) {
  return v(a) === m;
};
reactIs_production_min.isSuspenseList = function(a) {
  return v(a) === n;
};
reactIs_production_min.isValidElementType = function(a) {
  return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t$1 || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? true : false;
};
reactIs_production_min.typeOf = v;
{
  reactIs.exports = reactIs_production_min;
}
var reactIsExports = reactIs.exports;
const ReactIs = /* @__PURE__ */ getDefaultExportFromCjs(reactIsExports);
function whitespace(thing) {
  const value = (
    // @ts-expect-error looks like a node.
    thing && typeof thing === "object" && thing.type === "text" ? (
      // @ts-expect-error looks like a text.
      thing.value || ""
    ) : thing
  );
  return typeof value === "string" && value.replace(/[ \t\n\f\r]/g, "") === "";
}
function stringify$1(values2) {
  return values2.join(" ").trim();
}
function stringify(values2, options) {
  const settings = options || {};
  const input = values2[values2.length - 1] === "" ? [...values2, ""] : values2;
  return input.join(
    (settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")
  ).trim();
}
var styleToObject = { exports: {} };
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;
var TRIM_REGEX = /^\s+|\s+$/g;
var NEWLINE = "\n";
var FORWARD_SLASH = "/";
var ASTERISK = "*";
var EMPTY_STRING = "";
var TYPE_COMMENT = "comment";
var TYPE_DECLARATION = "declaration";
var inlineStyleParser = function(style2, options) {
  if (typeof style2 !== "string") {
    throw new TypeError("First argument must be a string");
  }
  if (!style2)
    return [];
  options = options || {};
  var lineno = 1;
  var column2 = 1;
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines)
      lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column2 = ~i ? str.length - i : column2 + str.length;
  }
  function position2() {
    var start = { line: lineno, column: column2 };
    return function(node2) {
      node2.position = new Position(start);
      whitespace2();
      return node2;
    };
  }
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column2 };
    this.source = options.source;
  }
  Position.prototype.content = style2;
  function error(msg) {
    var err = new Error(
      options.source + ":" + lineno + ":" + column2 + ": " + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column2;
    err.source = style2;
    if (options.silent)
      ;
    else {
      throw err;
    }
  }
  function match5(re) {
    var m2 = re.exec(style2);
    if (!m2)
      return;
    var str = m2[0];
    updatePosition(str);
    style2 = style2.slice(str.length);
    return m2;
  }
  function whitespace2() {
    match5(WHITESPACE_REGEX);
  }
  function comments(rules) {
    var c2;
    rules = rules || [];
    while (c2 = comment2()) {
      if (c2 !== false) {
        rules.push(c2);
      }
    }
    return rules;
  }
  function comment2() {
    var pos = position2();
    if (FORWARD_SLASH != style2.charAt(0) || ASTERISK != style2.charAt(1))
      return;
    var i = 2;
    while (EMPTY_STRING != style2.charAt(i) && (ASTERISK != style2.charAt(i) || FORWARD_SLASH != style2.charAt(i + 1))) {
      ++i;
    }
    i += 2;
    if (EMPTY_STRING === style2.charAt(i - 1)) {
      return error("End of comment missing");
    }
    var str = style2.slice(2, i - 2);
    column2 += 2;
    updatePosition(str);
    style2 = style2.slice(i);
    column2 += 2;
    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }
  function declaration2() {
    var pos = position2();
    var prop = match5(PROPERTY_REGEX);
    if (!prop)
      return;
    comment2();
    if (!match5(COLON_REGEX))
      return error("property missing ':'");
    var val = match5(VALUE_REGEX);
    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING)) : EMPTY_STRING
    });
    match5(SEMICOLON_REGEX);
    return ret;
  }
  function declarations() {
    var decls = [];
    comments(decls);
    var decl;
    while (decl = declaration2()) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }
    return decls;
  }
  whitespace2();
  return declarations();
};
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}
var parse = inlineStyleParser;
function StyleToObject(style2, iterator) {
  var output = null;
  if (!style2 || typeof style2 !== "string") {
    return output;
  }
  var declaration2;
  var declarations = parse(style2);
  var hasIterator = typeof iterator === "function";
  var property;
  var value;
  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration2 = declarations[i];
    property = declaration2.property;
    value = declaration2.value;
    if (hasIterator) {
      iterator(property, value, declaration2);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }
  return output;
}
styleToObject.exports = StyleToObject;
styleToObject.exports.default = StyleToObject;
var styleToObjectExports = styleToObject.exports;
const StyleToObject$1 = /* @__PURE__ */ getDefaultExportFromCjs(styleToObjectExports);
const own$1 = {}.hasOwnProperty;
const tableElements = /* @__PURE__ */ new Set(["table", "thead", "tbody", "tfoot", "tr"]);
function childrenToReact(context, node2) {
  const children = [];
  let childIndex = -1;
  let child;
  while (++childIndex < node2.children.length) {
    child = node2.children[childIndex];
    if (child.type === "element") {
      children.push(toReact(context, child, childIndex, node2));
    } else if (child.type === "text") {
      if (node2.type !== "element" || !tableElements.has(node2.tagName) || !whitespace(child)) {
        children.push(child.value);
      }
    } else if (child.type === "raw" && !context.options.skipHtml) {
      children.push(child.value);
    }
  }
  return children;
}
function toReact(context, node2, index2, parent) {
  const options = context.options;
  const transform = options.transformLinkUri === void 0 ? uriTransformer : options.transformLinkUri;
  const parentSchema = context.schema;
  const name = node2.tagName;
  const properties2 = {};
  let schema = parentSchema;
  let property;
  if (parentSchema.space === "html" && name === "svg") {
    schema = svg;
    context.schema = schema;
  }
  if (node2.properties) {
    for (property in node2.properties) {
      if (own$1.call(node2.properties, property)) {
        addProperty(properties2, property, node2.properties[property], context);
      }
    }
  }
  if (name === "ol" || name === "ul") {
    context.listDepth++;
  }
  const children = childrenToReact(context, node2);
  if (name === "ol" || name === "ul") {
    context.listDepth--;
  }
  context.schema = parentSchema;
  const position2 = node2.position || {
    start: { line: null, column: null, offset: null },
    end: { line: null, column: null, offset: null }
  };
  const component = options.components && own$1.call(options.components, name) ? options.components[name] : name;
  const basic = typeof component === "string" || component === React__default.Fragment;
  if (!ReactIs.isValidElementType(component)) {
    throw new TypeError(
      `Component for name \`${name}\` not defined or is not renderable`
    );
  }
  properties2.key = index2;
  if (name === "a" && options.linkTarget) {
    properties2.target = typeof options.linkTarget === "function" ? options.linkTarget(
      String(properties2.href || ""),
      node2.children,
      typeof properties2.title === "string" ? properties2.title : null
    ) : options.linkTarget;
  }
  if (name === "a" && transform) {
    properties2.href = transform(
      String(properties2.href || ""),
      node2.children,
      typeof properties2.title === "string" ? properties2.title : null
    );
  }
  if (!basic && name === "code" && parent.type === "element" && parent.tagName !== "pre") {
    properties2.inline = true;
  }
  if (!basic && (name === "h1" || name === "h2" || name === "h3" || name === "h4" || name === "h5" || name === "h6")) {
    properties2.level = Number.parseInt(name.charAt(1), 10);
  }
  if (name === "img" && options.transformImageUri) {
    properties2.src = options.transformImageUri(
      String(properties2.src || ""),
      String(properties2.alt || ""),
      typeof properties2.title === "string" ? properties2.title : null
    );
  }
  if (!basic && name === "li" && parent.type === "element") {
    const input = getInputElement(node2);
    properties2.checked = input && input.properties ? Boolean(input.properties.checked) : null;
    properties2.index = getElementsBeforeCount(parent, node2);
    properties2.ordered = parent.tagName === "ol";
  }
  if (!basic && (name === "ol" || name === "ul")) {
    properties2.ordered = name === "ol";
    properties2.depth = context.listDepth;
  }
  if (name === "td" || name === "th") {
    if (properties2.align) {
      if (!properties2.style)
        properties2.style = {};
      properties2.style.textAlign = properties2.align;
      delete properties2.align;
    }
    if (!basic) {
      properties2.isHeader = name === "th";
    }
  }
  if (!basic && name === "tr" && parent.type === "element") {
    properties2.isHeader = Boolean(parent.tagName === "thead");
  }
  if (options.sourcePos) {
    properties2["data-sourcepos"] = flattenPosition(position2);
  }
  if (!basic && options.rawSourcePos) {
    properties2.sourcePosition = node2.position;
  }
  if (!basic && options.includeElementIndex) {
    properties2.index = getElementsBeforeCount(parent, node2);
    properties2.siblingCount = getElementsBeforeCount(parent);
  }
  if (!basic) {
    properties2.node = node2;
  }
  return children.length > 0 ? React__default.createElement(component, properties2, children) : React__default.createElement(component, properties2);
}
function getInputElement(node2) {
  let index2 = -1;
  while (++index2 < node2.children.length) {
    const child = node2.children[index2];
    if (child.type === "element" && child.tagName === "input") {
      return child;
    }
  }
  return null;
}
function getElementsBeforeCount(parent, node2) {
  let index2 = -1;
  let count = 0;
  while (++index2 < parent.children.length) {
    if (parent.children[index2] === node2)
      break;
    if (parent.children[index2].type === "element")
      count++;
  }
  return count;
}
function addProperty(props, prop, value, ctx) {
  const info = find(ctx.schema, prop);
  let result = value;
  if (result === null || result === void 0 || result !== result) {
    return;
  }
  if (Array.isArray(result)) {
    result = info.commaSeparated ? stringify(result) : stringify$1(result);
  }
  if (info.property === "style" && typeof result === "string") {
    result = parseStyle(result);
  }
  if (info.space && info.property) {
    props[own$1.call(hastToReact, info.property) ? hastToReact[info.property] : info.property] = result;
  } else if (info.attribute) {
    props[info.attribute] = result;
  }
}
function parseStyle(value) {
  const result = {};
  try {
    StyleToObject$1(value, iterator);
  } catch (e2) {
  }
  return result;
  function iterator(name, v2) {
    const k2 = name.slice(0, 4) === "-ms-" ? `ms-${name.slice(4)}` : name;
    result[k2.replace(/-([a-z])/g, styleReplacer)] = v2;
  }
}
function styleReplacer(_, $1) {
  return $1.toUpperCase();
}
function flattenPosition(pos) {
  return [
    pos.start.line,
    ":",
    pos.start.column,
    "-",
    pos.end.line,
    ":",
    pos.end.column
  ].map(String).join("");
}
const own = {}.hasOwnProperty;
const changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
const deprecated = {
  plugins: { to: "remarkPlugins", id: "change-plugins-to-remarkplugins" },
  renderers: { to: "components", id: "change-renderers-to-components" },
  astPlugins: { id: "remove-buggy-html-in-markdown-parser" },
  allowDangerousHtml: { id: "remove-buggy-html-in-markdown-parser" },
  escapeHtml: { id: "remove-buggy-html-in-markdown-parser" },
  source: { to: "children", id: "change-source-to-children" },
  allowNode: {
    to: "allowElement",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  allowedTypes: {
    to: "allowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  disallowedTypes: {
    to: "disallowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  includeNodeIndex: {
    to: "includeElementIndex",
    id: "change-includenodeindex-to-includeelementindex"
  }
};
function ReactMarkdown(options) {
  for (const key in deprecated) {
    if (own.call(deprecated, key) && own.call(options, key)) {
      const deprecation = deprecated[key];
      console.warn(
        `[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : "remove"} \`${key}\` (see <${changelog}#${deprecation.id}> for more info)`
      );
      delete deprecated[key];
    }
  }
  const processor = unified().use(remarkParse).use(options.remarkPlugins || []).use(remarkRehype$1, __spreadProps(__spreadValues({}, options.remarkRehypeOptions), {
    allowDangerousHtml: true
  })).use(options.rehypePlugins || []).use(rehypeFilter, options);
  const file = new VFile();
  if (typeof options.children === "string") {
    file.value = options.children;
  } else if (options.children !== void 0 && options.children !== null) {
    console.warn(
      `[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`
    );
  }
  const hastNode = processor.runSync(processor.parse(file), file);
  if (hastNode.type !== "root") {
    throw new TypeError("Expected a `root` node");
  }
  let result = React__default.createElement(
    React__default.Fragment,
    {},
    childrenToReact({ options, schema: html, listDepth: 0 }, hastNode)
  );
  if (options.className) {
    result = React__default.createElement("div", { className: options.className }, result);
  }
  return result;
}
ReactMarkdown.propTypes = {
  // Core options:
  children: PropTypes.string,
  // Layout options:
  className: PropTypes.string,
  // Filter options:
  allowElement: PropTypes.func,
  allowedElements: PropTypes.arrayOf(PropTypes.string),
  disallowedElements: PropTypes.arrayOf(PropTypes.string),
  unwrapDisallowed: PropTypes.bool,
  // Plugin options:
  remarkPlugins: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.func,
      PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.bool,
          PropTypes.string,
          PropTypes.object,
          PropTypes.func,
          PropTypes.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            PropTypes.any
          )
        ])
      )
    ])
  ),
  rehypePlugins: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.func,
      PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.bool,
          PropTypes.string,
          PropTypes.object,
          PropTypes.func,
          PropTypes.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            PropTypes.any
          )
        ])
      )
    ])
  ),
  // Transform options:
  sourcePos: PropTypes.bool,
  rawSourcePos: PropTypes.bool,
  skipHtml: PropTypes.bool,
  includeElementIndex: PropTypes.bool,
  transformLinkUri: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  linkTarget: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  transformImageUri: PropTypes.func,
  components: PropTypes.object
};
const StyledChip = styled$5(Chip)(({
  bgColor,
  textColor,
  label
}) => ({
  backgroundColor: bgColor,
  color: textColor,
  label
}));
const WalletStatus = ({
  entityId,
  navigateToKycHome,
  navigateToKycVerification,
  overrideIconSize,
  overrideHeaderFontSize,
  overrideSubheaderFontSize,
  onQueryError
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
  const ButtonWrapped = (props) => /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Button, { onClick: props.onClick, variant: "contained", sx: {
    mt: 3,
    px: 3,
    height: "54px !important"
  }, children: /* @__PURE__ */ jsx(Typography, { fontWeight: 500, fontSize: 18, lineHeight: "20px", children: props.children }) }) });
  const BulletedList = ({
    items
  }) => {
    const iconForItem = (item) => [ProductEligibilityQualificationName.SupportedJurisdiction, ProductEligibilityQualificationName.ProofOfResidenceQualification].includes(item.qualificationName) ? /* @__PURE__ */ jsx(SvgBulletGlobe, __spreadValues({ width: "18px", fill: palette.brand[600] }, {})) : /* @__PURE__ */ jsx(SvgBulletPerson, __spreadValues({ width: "18px", fill: palette.brand[600] }, {}));
    return /* @__PURE__ */ jsx(List, { children: items.map((item, index2) => /* @__PURE__ */ jsxs(ListItem, { sx: {
      flexDirection: "column",
      flexGrow: 1,
      mb: 1
    }, children: [
      /* @__PURE__ */ jsxs(Box, { display: "flex", alignContent: "center", alignItems: "center", width: "85%", children: [
        /* @__PURE__ */ jsx(Box, { sx: {
          minWidth: "22px",
          mr: 1
        }, children: iconForItem(item) }),
        /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Typography, { fontSize: 18, fontWeight: 500, sx: {
          minWidth: "100%"
        }, children: item.title }) }),
        /* @__PURE__ */ jsx(Box, { sx: {
          flexGrow: 1
        } }),
        /* @__PURE__ */ jsx(Box, { children: item.chip })
      ] }),
      item.subtitle && /* @__PURE__ */ jsx(Box, { sx: {
        my: 2,
        color: "#444"
      }, display: "flex", alignContent: "center", alignItems: "center", textAlign: "center", children: /* @__PURE__ */ jsx(ReactMarkdown, { components: {
        a: (props) => /* @__PURE__ */ jsx(Link, { href: props.href, children: props.children })
      }, children: item.subtitle }) })
    ] }, index2)) });
  };
  const queryResult = useProductEligibilityQuery({
    variables: {
      entityId
    }
  });
  if (queryResult == null ? void 0 : queryResult.loading) {
    return /* @__PURE__ */ jsx(PageLoadingSpinner, {});
  }
  if (queryResult == null ? void 0 : queryResult.error) {
    onQueryError && onQueryError(queryResult.error);
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  if (!(queryResult == null ? void 0 : queryResult.data)) {
    onQueryError && onQueryError(new Error("No data returned from query"));
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  const latestRegisteredOffering = (_c = (_b = (_a = queryResult == null ? void 0 : queryResult.data) == null ? void 0 : _a.me) == null ? void 0 : _b.entity) == null ? void 0 : _c.latestRegisteredOffering;
  const productEligibility = (_f = (_e = (_d = queryResult == null ? void 0 : queryResult.data) == null ? void 0 : _d.me) == null ? void 0 : _e.entity) == null ? void 0 : _f.productEligibility;
  const currentOnboardingStep = (_j = (_i = (_h = (_g = queryResult == null ? void 0 : queryResult.data) == null ? void 0 : _g.me) == null ? void 0 : _h.entity) == null ? void 0 : _i.kyc) == null ? void 0 : _j.currentStep;
  const idvStepSubmitted = (_n = (_m = (_l = (_k = queryResult == null ? void 0 : queryResult.data) == null ? void 0 : _k.me) == null ? void 0 : _l.entity) == null ? void 0 : _m.kyc) == null ? void 0 : _n.idvStepSubmitted;
  const status = (_p = (_o = productEligibility == null ? void 0 : productEligibility.productStatuses) == null ? void 0 : _o.find((p2) => p2.productName === ProductEligibilityProductName.Wallet)) == null ? void 0 : _p.status;
  const reverification = (_t = (_s = (_r = (_q = queryResult == null ? void 0 : queryResult.data) == null ? void 0 : _q.me) == null ? void 0 : _r.entity) == null ? void 0 : _s.kyc) == null ? void 0 : _t.reverification;
  const headerFontSize = overrideHeaderFontSize || "26px";
  const subheaderFontSize = overrideSubheaderFontSize || "18px";
  const iconSize = overrideIconSize || "150px";
  const latestOfferingRegistrationButton = (latestRegisteredOffering == null ? void 0 : latestRegisteredOffering.name) && (latestRegisteredOffering == null ? void 0 : latestRegisteredOffering.url) && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Link, { href: latestRegisteredOffering == null ? void 0 : latestRegisteredOffering.url, children: /* @__PURE__ */ jsx(ButtonWrapped, { children: /* @__PURE__ */ jsx(Trans, { id: "de7qmv", values: {
    0: latestRegisteredOffering == null ? void 0 : latestRegisteredOffering.name
  } }) }) }) });
  let statusIcon;
  let content2;
  switch (status) {
    case ProductEligibilityProductStatus.Approved: {
      statusIcon = /* @__PURE__ */ jsx(SvgStatusApproved, __spreadValues({}, {}));
      content2 = /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Typography, { sx: {
          mb: 1
        }, fontSize: headerFontSize, children: /* @__PURE__ */ jsx(Trans, { id: "U3c9B9" }) }) }),
        latestOfferingRegistrationButton
      ] });
      break;
    }
    case ProductEligibilityProductStatus.Rejected: {
      const failedItems = ((productEligibility == null ? void 0 : productEligibility.qualifications) || []).filter((q2) => q2.isApplicable && q2.shouldDisplayInStatusPage && q2.qualificationStatus === ProductEligibilityQualificationStatus.Failed).map((q2) => ({
        qualificationName: q2.name || "",
        title: q2.nameForDisplay || "",
        subtitle: q2.notesForStatusPage || "",
        chip: /* @__PURE__ */ jsx(StyledChip, { bgColor: "#FFEAEB", textColor: "#CD3237", label: i18n._(
          /*i18n*/
          {
            id: "ekCRTP"
          }
        ) })
      }));
      const isIdentityFailed = failedItems.find((item) => item.qualificationName === ProductEligibilityQualificationName.IdentityVerified);
      statusIcon = isIdentityFailed ? /* @__PURE__ */ jsx(SvgStatusRejected, __spreadValues({}, {})) : /* @__PURE__ */ jsx(SvgStatusRejectedButIdVerified, __spreadValues({}, {}));
      content2 = /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Typography, { sx: {
          mb: 1
        }, fontSize: headerFontSize, children: isIdentityFailed ? i18n._(
          /*i18n*/
          {
            id: "mAXg7b"
          }
        ) : i18n._(
          /*i18n*/
          {
            id: "pyNU0m"
          }
        ) }),
        /* @__PURE__ */ jsx(Typography, { sx: {
          mb: 5
        }, fontSize: subheaderFontSize, children: isIdentityFailed ? i18n._(
          /*i18n*/
          {
            id: "tesLP4"
          }
        ) : i18n._(
          /*i18n*/
          {
            id: "YEXTw3"
          }
        ) }),
        /* @__PURE__ */ jsx(BulletedList, { items: failedItems || [] }),
        !isIdentityFailed && latestOfferingRegistrationButton
      ] });
      break;
    }
    case ProductEligibilityProductStatus.Pending: {
      statusIcon = /* @__PURE__ */ jsx(SvgStatusPending, __spreadValues({}, {}));
      const pendingItems = ((productEligibility == null ? void 0 : productEligibility.qualifications) || []).filter((q2) => q2.isApplicable && q2.shouldDisplayInStatusPage && q2.qualificationStatus === "PENDING").map((q2) => ({
        title: q2.nameForDisplay || "",
        qualificationName: q2.name || "",
        subtitle: q2.notesForStatusPage || "",
        chip: /* @__PURE__ */ jsx(StyledChip, { bgColor: "#F0F0F0", textColor: "#777", label: i18n._(
          /*i18n*/
          {
            id: "/LCAwL"
          }
        ) }),
        icon: [ProductEligibilityQualificationName.SupportedJurisdiction, ProductEligibilityQualificationName.ProofOfResidenceQualification].includes(q2.name) ? /* @__PURE__ */ jsx(SvgBulletGlobe, __spreadValues({ width: "18px", fill: palette.brand[600] }, {})) : /* @__PURE__ */ jsx(SvgBulletPerson, __spreadValues({ width: "18px", fill: palette.brand[600] }, {}))
      }));
      content2 = /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Typography, { sx: {
          mb: 1
        }, fontSize: headerFontSize, children: "We are reviewing your identity" }),
        /* @__PURE__ */ jsx(Typography, { sx: {
          mb: 5
        }, fontSize: subheaderFontSize, children: /* @__PURE__ */ jsx(Trans, { id: "7fweU2" }) }),
        latestOfferingRegistrationButton,
        /* @__PURE__ */ jsx(BulletedList, { items: pendingItems || [] })
      ] });
      break;
    }
    case ProductEligibilityProductStatus.Incomplete: {
      statusIcon = /* @__PURE__ */ jsx(SvgStatusIncomplete, __spreadValues({}, {}));
      const actionRequiredItems = ((productEligibility == null ? void 0 : productEligibility.qualifications) || []).filter((q2) => q2.isApplicable && q2.shouldDisplayInStatusPage && q2.qualificationStatus === "ACTION_REQUIRED");
      const topRequiredItem = actionRequiredItems[0];
      content2 = /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Typography, { sx: {
          mb: 1
        }, fontSize: headerFontSize, children: "Verify your account" }),
        /* @__PURE__ */ jsx(Typography, { sx: {
          mb: 5
        }, fontSize: subheaderFontSize, children: topRequiredItem.notesForStatusPage || "" }),
        /* @__PURE__ */ jsx(ButtonWrapped, { onClick: () => window.location.href = topRequiredItem.callToActionUrl || "/", children: topRequiredItem.callToActionLabel })
      ] });
      break;
    }
    case ProductEligibilityProductStatus.NotStarted: {
      statusIcon = /* @__PURE__ */ jsx(SvgStatusIncomplete, {});
      content2 = /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Typography, { sx: {
          mb: 1
        }, fontSize: headerFontSize, children: /* @__PURE__ */ jsx(Trans, { id: "ik0mgO" }) }),
        /* @__PURE__ */ jsx(Typography, { sx: {
          mb: 5
        }, fontSize: subheaderFontSize, children: /* @__PURE__ */ jsx(Trans, { id: "FTFhvG" }) }),
        /* @__PURE__ */ jsx(ButtonWrapped, { onClick: navigateToKycHome, children: /* @__PURE__ */ jsx(Trans, { id: "pHxNw3" }) })
      ] });
      break;
    }
    case ProductEligibilityProductStatus.Reverifying: {
      statusIcon = /* @__PURE__ */ jsx(SvgStatusReverifying, {});
      content2 = /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Typography, { sx: {
          mb: 4
        }, fontSize: headerFontSize, children: /* @__PURE__ */ jsx(Trans, { id: "fUYQC7" }) }),
        /* @__PURE__ */ jsxs(List, { sx: {
          mb: 2,
          fontSize: 18,
          fontWeight: 500
        }, children: [
          /* @__PURE__ */ jsx(ListItem, { children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignContent: "center", alignItems: "center", children: [
            /* @__PURE__ */ jsxs(Box, { sx: {
              pr: 4
            }, children: [
              " ",
              /* @__PURE__ */ jsx(SvgReverifyInstitution, {}),
              " "
            ] }),
            /* @__PURE__ */ jsxs(Typography, { children: [
              /* @__PURE__ */ jsx(Trans, { id: "qW7soC" }),
              " ",
              /* @__PURE__ */ jsx(Link, { href: "https://coinlist.co/help/identity-reverification", children: /* @__PURE__ */ jsx(Trans, { id: "zwWKhA" }) })
            ] })
          ] }) }),
          /* @__PURE__ */ jsx(ListItem, { children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignContent: "center", alignItems: "center", children: [
            /* @__PURE__ */ jsxs(Box, { sx: {
              pr: 4
            }, children: [
              " ",
              /* @__PURE__ */ jsx(SvgReverifyLock, {}),
              " "
            ] }),
            /* @__PURE__ */ jsx(Typography, { children: (reverification == null ? void 0 : reverification.isAccountRestricted) ? i18n._(
              /*i18n*/
              {
                id: "2yStfW"
              }
            ) : i18n._(
              /*i18n*/
              {
                id: "tP2U8L",
                values: {
                  0: !!(reverification == null ? void 0 : reverification.readyToRestrictAccountAt) ? t`starting ${hooks.unix(Number(reverification == null ? void 0 : reverification.readyToRestrictAccountAt)).format("MMM D YYYY")}` : t`soon`
                }
              }
            ) })
          ] }) }),
          /* @__PURE__ */ jsx(ListItem, { children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignContent: "center", alignItems: "center", children: [
            /* @__PURE__ */ jsxs(Box, { sx: {
              pr: 4
            }, children: [
              " ",
              /* @__PURE__ */ jsx(SvgReverifyClock, {}),
              " "
            ] }),
            /* @__PURE__ */ jsx(Typography, { children: /* @__PURE__ */ jsx(Trans, { id: "rE+Ay/" }) })
          ] }) })
        ] }),
        /* @__PURE__ */ jsx(ButtonWrapped, { onClick: navigateToKycVerification, children: /* @__PURE__ */ jsx(Trans, { id: "pHxNw3" }) })
      ] });
      break;
    }
    case ProductEligibilityProductStatus.PendingReverificationReview: {
      if (!idvStepSubmitted && currentOnboardingStep == "IDV") {
        statusIcon = /* @__PURE__ */ jsx(SvgStatusReverifying, {});
        content2 = /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Typography, { sx: {
            mb: 4
          }, fontSize: headerFontSize, children: /* @__PURE__ */ jsx(Trans, { id: "fmTD+z" }) }),
          /* @__PURE__ */ jsx(ButtonWrapped, { onClick: navigateToKycVerification, children: /* @__PURE__ */ jsx(Trans, { id: "xGVfLh" }) })
        ] });
      } else {
        statusIcon = /* @__PURE__ */ jsx(SvgStatusPending, {});
        content2 = /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Typography, { sx: {
            mb: 2
          }, fontSize: headerFontSize, children: /* @__PURE__ */ jsx(Trans, { id: "lLmS+R" }) }),
          /* @__PURE__ */ jsx(Typography, { fontSize: subheaderFontSize, children: /* @__PURE__ */ jsx(Trans, { id: "y92q6y", components: {
            0: /* @__PURE__ */ jsx(Link, { href: "https://coinlist.co/help/identity-reverification" })
          } }) })
        ] });
      }
      break;
    }
    case ProductEligibilityProductStatus.UnapprovedAfterZero: {
      statusIcon = /* @__PURE__ */ jsx(SvgStatusRejected, {});
      content2 = /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Typography, { sx: {
          mb: 2
        }, fontSize: headerFontSize, children: /* @__PURE__ */ jsx(Trans, { id: "mAXg7b" }) }),
        /* @__PURE__ */ jsx(Typography, { fontSize: subheaderFontSize, children: /* @__PURE__ */ jsx(Trans, { id: "0ewb+4" }) })
      ] });
      break;
    }
    case ProductEligibilityProductStatus.Offboarded: {
      statusIcon = /* @__PURE__ */ jsx(SvgStatusRejected, {});
      content2 = /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Typography, { sx: {
          mb: 2
        }, fontSize: headerFontSize, children: /* @__PURE__ */ jsx(Trans, { id: "xHn8vf" }) }),
        /* @__PURE__ */ jsx(Typography, { fontSize: subheaderFontSize, children: /* @__PURE__ */ jsx(Trans, { id: "o9z/PM" }) })
      ] });
      break;
    }
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box, { sx: {
      width: iconSize,
      mb: 3
    }, children: statusIcon }),
    /* @__PURE__ */ jsx(Box, { maxWidth: "460px", children: content2 })
  ] });
};
const WalletStatus$1 = WalletStatus;
const AmplitudeContext = createContext({
  track: () => {
    console.warn("AmplitudeContext.track is not implemented");
    return;
  }
});
const useAmplitude = () => {
  const context = useContext(AmplitudeContext);
  if (!context) {
    throw new Error("useAmplitude must be used within an AmplitudeProvider");
  }
  return context;
};
const AmplitudeProvider = ({
  children,
  amplitudeEventHandler
}) => {
  return /* @__PURE__ */ jsx(AmplitudeContext.Provider, { value: {
    track: amplitudeEventHandler
  }, children });
};
const app = {
  name: "CoinList",
  url: "https://coinlist.co"
};
const geography = {
  countries: {
    AF: {
      code: "AF",
      name: "Afghanistan",
      is_comprehensive_ofac_sanctioned: false,
      is_partial_ofac_sanctioned: false,
      if_clc_management_fee_waived: false,
      is_ip_geofenced: false,
      is_staking_limited: false,
      is_wallets_services_blocked: false,
      is_wallets_services_to_be_blocked: true,
      address_select_enabled: true,
      is_trust_allowed: false
    },
    AU: {
      code: "AU",
      name: "Australia",
      is_comprehensive_ofac_sanctioned: false,
      is_partial_ofac_sanctioned: false,
      if_clc_management_fee_waived: false,
      is_ip_geofenced: false,
      is_staking_limited: false,
      is_wallets_services_blocked: false,
      is_wallets_services_to_be_blocked: false,
      address_select_enabled: true,
      is_trust_allowed: false
    },
    FR: {
      code: "FR",
      name: "France",
      is_comprehensive_ofac_sanctioned: false,
      is_partial_ofac_sanctioned: false,
      if_clc_management_fee_waived: false,
      is_ip_geofenced: false,
      is_staking_limited: false,
      is_wallets_services_blocked: false,
      is_wallets_services_to_be_blocked: false,
      address_select_enabled: true,
      is_trust_allowed: false
    },
    UA: {
      code: "UA",
      name: "Ukraine",
      is_comprehensive_ofac_sanctioned: false,
      is_partial_ofac_sanctioned: false,
      if_clc_management_fee_waived: false,
      is_ip_geofenced: false,
      is_staking_limited: false,
      is_wallets_services_blocked: false,
      is_wallets_services_to_be_blocked: false,
      address_select_enabled: true,
      allowed_state_selection: [],
      is_trust_allowed: false
    },
    US: {
      code: "US",
      name: "United States of America",
      is_comprehensive_ofac_sanctioned: false,
      is_partial_ofac_sanctioned: false,
      if_clc_management_fee_waived: false,
      is_ip_geofenced: false,
      is_staking_limited: true,
      is_wallets_services_blocked: false,
      is_wallets_services_to_be_blocked: false,
      address_select_enabled: true,
      is_trust_allowed: true
    },
    UZ: {
      code: "UZ",
      name: "Uzbekistan",
      is_comprehensive_ofac_sanctioned: false,
      is_partial_ofac_sanctioned: false,
      if_clc_management_fee_waived: false,
      is_ip_geofenced: false,
      is_staking_limited: false,
      is_wallets_services_blocked: false,
      is_wallets_services_to_be_blocked: false,
      address_select_enabled: true,
      is_trust_allowed: false
    },
    VE: {
      code: "VE",
      name: "Venezuela (Bolivarian Republic of)",
      is_comprehensive_ofac_sanctioned: true,
      is_partial_ofac_sanctioned: false,
      if_clc_management_fee_waived: false,
      is_ip_geofenced: false,
      is_staking_limited: false,
      is_wallets_services_blocked: false,
      is_wallets_services_to_be_blocked: true,
      address_select_enabled: true,
      is_trust_allowed: false
    },
    VN: {
      code: "VN",
      name: "Viet Nam",
      is_comprehensive_ofac_sanctioned: false,
      is_partial_ofac_sanctioned: false,
      if_clc_management_fee_waived: false,
      is_ip_geofenced: false,
      is_staking_limited: false,
      is_wallets_services_blocked: false,
      is_wallets_services_to_be_blocked: false,
      address_select_enabled: true,
      allowed_state_selection: null,
      is_trust_allowed: false
    },
    VI: {
      code: "VI",
      name: "Virgin Islands (U.S.)",
      is_comprehensive_ofac_sanctioned: false,
      is_partial_ofac_sanctioned: false,
      if_clc_management_fee_waived: false,
      is_ip_geofenced: false,
      is_staking_limited: false,
      is_wallets_services_blocked: true,
      is_wallets_services_to_be_blocked: false,
      address_select_enabled: true,
      is_trust_allowed: false
    },
    YE: {
      code: "YE",
      name: "Yemen",
      is_comprehensive_ofac_sanctioned: false,
      is_partial_ofac_sanctioned: false,
      if_clc_management_fee_waived: false,
      is_ip_geofenced: false,
      is_staking_limited: false,
      is_wallets_services_blocked: false,
      is_wallets_services_to_be_blocked: true,
      address_select_enabled: true,
      is_trust_allowed: false
    },
    ZW: {
      code: "ZW",
      name: "Zimbabwe",
      is_comprehensive_ofac_sanctioned: true,
      is_partial_ofac_sanctioned: false,
      if_clc_management_fee_waived: false,
      is_ip_geofenced: false,
      is_staking_limited: false,
      is_wallets_services_blocked: false,
      is_wallets_services_to_be_blocked: true,
      address_select_enabled: true,
      is_trust_allowed: false
    }
  },
  states: {
    US: {
      AK: {
        code: "AK",
        name: "Alaska",
        is_wallets_blocked_state_wide: true,
        allowed_selection: true
      },
      AL: {
        code: "AL",
        name: "Alabama",
        is_wallets_blocked_state_wide: true,
        allowed_selection: true
      },
      AR: {
        code: "AR",
        name: "Arkansas",
        is_wallets_blocked_state_wide: false,
        allowed_selection: true
      },
      AZ: {
        code: "AZ",
        name: "Arizona",
        is_wallets_blocked_state_wide: true,
        allowed_selection: true
      },
      CA: {
        code: "CA",
        name: "California",
        is_wallets_blocked_state_wide: false,
        allowed_selection: true
      },
      NY: {
        code: "NY",
        name: "New York",
        is_wallets_blocked_state_wide: true,
        allowed_selection: true
      }
    },
    UA: {
      "Cherkas'ka Oblast'": {
        code: "Cherkas'ka Oblast'",
        name: "Cherkas'ka Oblast'",
        is_wallets_blocked_state_wide: false,
        allowed_selection: true
      },
      "Chernihivs'ka Oblast'": {
        code: "Chernihivs'ka Oblast'",
        name: "Chernihivs'ka Oblast'",
        is_wallets_blocked_state_wide: false,
        allowed_selection: true
      }
    }
  }
};
const mockConstants = {
  app,
  geography
};
var index_es5_min = { exports: {} };
/*! countries-list v2.6.1 by Annexare | MIT */
(function(module2, exports) {
  !function(n2, a) {
    module2.exports = a();
  }(commonjsGlobal, function() {
    var n2 = { AF: "Africa", AN: "Antarctica", AS: "Asia", EU: "Europe", NA: "North America", OC: "Oceania", SA: "South America" }, a = { AD: { name: "Andorra", native: "Andorra", phone: "376", continent: "EU", capital: "Andorra la Vella", currency: "EUR", languages: ["ca"], emoji: "🇦🇩", emojiU: "U+1F1E6 U+1F1E9" }, AE: { name: "United Arab Emirates", native: "دولة الإمارات العربية المتحدة", phone: "971", continent: "AS", capital: "Abu Dhabi", currency: "AED", languages: ["ar"], emoji: "🇦🇪", emojiU: "U+1F1E6 U+1F1EA" }, AF: { name: "Afghanistan", native: "افغانستان", phone: "93", continent: "AS", capital: "Kabul", currency: "AFN", languages: ["ps", "uz", "tk"], emoji: "🇦🇫", emojiU: "U+1F1E6 U+1F1EB" }, AG: { name: "Antigua and Barbuda", native: "Antigua and Barbuda", phone: "1268", continent: "NA", capital: "Saint John's", currency: "XCD", languages: ["en"], emoji: "🇦🇬", emojiU: "U+1F1E6 U+1F1EC" }, AI: { name: "Anguilla", native: "Anguilla", phone: "1264", continent: "NA", capital: "The Valley", currency: "XCD", languages: ["en"], emoji: "🇦🇮", emojiU: "U+1F1E6 U+1F1EE" }, AL: { name: "Albania", native: "Shqipëria", phone: "355", continent: "EU", capital: "Tirana", currency: "ALL", languages: ["sq"], emoji: "🇦🇱", emojiU: "U+1F1E6 U+1F1F1" }, AM: { name: "Armenia", native: "Հայաստան", phone: "374", continent: "AS", capital: "Yerevan", currency: "AMD", languages: ["hy", "ru"], emoji: "🇦🇲", emojiU: "U+1F1E6 U+1F1F2" }, AO: { name: "Angola", native: "Angola", phone: "244", continent: "AF", capital: "Luanda", currency: "AOA", languages: ["pt"], emoji: "🇦🇴", emojiU: "U+1F1E6 U+1F1F4" }, AQ: { name: "Antarctica", native: "Antarctica", phone: "672", continent: "AN", capital: "", currency: "", languages: [], emoji: "🇦🇶", emojiU: "U+1F1E6 U+1F1F6" }, AR: { name: "Argentina", native: "Argentina", phone: "54", continent: "SA", capital: "Buenos Aires", currency: "ARS", languages: ["es", "gn"], emoji: "🇦🇷", emojiU: "U+1F1E6 U+1F1F7" }, AS: { name: "American Samoa", native: "American Samoa", phone: "1684", continent: "OC", capital: "Pago Pago", currency: "USD", languages: ["en", "sm"], emoji: "🇦🇸", emojiU: "U+1F1E6 U+1F1F8" }, AT: { name: "Austria", native: "Österreich", phone: "43", continent: "EU", capital: "Vienna", currency: "EUR", languages: ["de"], emoji: "🇦🇹", emojiU: "U+1F1E6 U+1F1F9" }, AU: { name: "Australia", native: "Australia", phone: "61", continent: "OC", capital: "Canberra", currency: "AUD", languages: ["en"], emoji: "🇦🇺", emojiU: "U+1F1E6 U+1F1FA" }, AW: { name: "Aruba", native: "Aruba", phone: "297", continent: "NA", capital: "Oranjestad", currency: "AWG", languages: ["nl", "pa"], emoji: "🇦🇼", emojiU: "U+1F1E6 U+1F1FC" }, AX: { name: "Åland", native: "Åland", phone: "358", continent: "EU", capital: "Mariehamn", currency: "EUR", languages: ["sv"], emoji: "🇦🇽", emojiU: "U+1F1E6 U+1F1FD" }, AZ: { name: "Azerbaijan", native: "Azərbaycan", phone: "994", continent: "AS", capital: "Baku", currency: "AZN", languages: ["az"], emoji: "🇦🇿", emojiU: "U+1F1E6 U+1F1FF" }, BA: { name: "Bosnia and Herzegovina", native: "Bosna i Hercegovina", phone: "387", continent: "EU", capital: "Sarajevo", currency: "BAM", languages: ["bs", "hr", "sr"], emoji: "🇧🇦", emojiU: "U+1F1E7 U+1F1E6" }, BB: { name: "Barbados", native: "Barbados", phone: "1246", continent: "NA", capital: "Bridgetown", currency: "BBD", languages: ["en"], emoji: "🇧🇧", emojiU: "U+1F1E7 U+1F1E7" }, BD: { name: "Bangladesh", native: "Bangladesh", phone: "880", continent: "AS", capital: "Dhaka", currency: "BDT", languages: ["bn"], emoji: "🇧🇩", emojiU: "U+1F1E7 U+1F1E9" }, BE: { name: "Belgium", native: "België", phone: "32", continent: "EU", capital: "Brussels", currency: "EUR", languages: ["nl", "fr", "de"], emoji: "🇧🇪", emojiU: "U+1F1E7 U+1F1EA" }, BF: { name: "Burkina Faso", native: "Burkina Faso", phone: "226", continent: "AF", capital: "Ouagadougou", currency: "XOF", languages: ["fr", "ff"], emoji: "🇧🇫", emojiU: "U+1F1E7 U+1F1EB" }, BG: { name: "Bulgaria", native: "България", phone: "359", continent: "EU", capital: "Sofia", currency: "BGN", languages: ["bg"], emoji: "🇧🇬", emojiU: "U+1F1E7 U+1F1EC" }, BH: { name: "Bahrain", native: "‏البحرين", phone: "973", continent: "AS", capital: "Manama", currency: "BHD", languages: ["ar"], emoji: "🇧🇭", emojiU: "U+1F1E7 U+1F1ED" }, BI: { name: "Burundi", native: "Burundi", phone: "257", continent: "AF", capital: "Bujumbura", currency: "BIF", languages: ["fr", "rn"], emoji: "🇧🇮", emojiU: "U+1F1E7 U+1F1EE" }, BJ: { name: "Benin", native: "Bénin", phone: "229", continent: "AF", capital: "Porto-Novo", currency: "XOF", languages: ["fr"], emoji: "🇧🇯", emojiU: "U+1F1E7 U+1F1EF" }, BL: { name: "Saint Barthélemy", native: "Saint-Barthélemy", phone: "590", continent: "NA", capital: "Gustavia", currency: "EUR", languages: ["fr"], emoji: "🇧🇱", emojiU: "U+1F1E7 U+1F1F1" }, BM: { name: "Bermuda", native: "Bermuda", phone: "1441", continent: "NA", capital: "Hamilton", currency: "BMD", languages: ["en"], emoji: "🇧🇲", emojiU: "U+1F1E7 U+1F1F2" }, BN: { name: "Brunei", native: "Negara Brunei Darussalam", phone: "673", continent: "AS", capital: "Bandar Seri Begawan", currency: "BND", languages: ["ms"], emoji: "🇧🇳", emojiU: "U+1F1E7 U+1F1F3" }, BO: { name: "Bolivia", native: "Bolivia", phone: "591", continent: "SA", capital: "Sucre", currency: "BOB,BOV", languages: ["es", "ay", "qu"], emoji: "🇧🇴", emojiU: "U+1F1E7 U+1F1F4" }, BQ: { name: "Bonaire", native: "Bonaire", phone: "5997", continent: "NA", capital: "Kralendijk", currency: "USD", languages: ["nl"], emoji: "🇧🇶", emojiU: "U+1F1E7 U+1F1F6" }, BR: { name: "Brazil", native: "Brasil", phone: "55", continent: "SA", capital: "Brasília", currency: "BRL", languages: ["pt"], emoji: "🇧🇷", emojiU: "U+1F1E7 U+1F1F7" }, BS: { name: "Bahamas", native: "Bahamas", phone: "1242", continent: "NA", capital: "Nassau", currency: "BSD", languages: ["en"], emoji: "🇧🇸", emojiU: "U+1F1E7 U+1F1F8" }, BT: { name: "Bhutan", native: "ʼbrug-yul", phone: "975", continent: "AS", capital: "Thimphu", currency: "BTN,INR", languages: ["dz"], emoji: "🇧🇹", emojiU: "U+1F1E7 U+1F1F9" }, BV: { name: "Bouvet Island", native: "Bouvetøya", phone: "47", continent: "AN", capital: "", currency: "NOK", languages: ["no", "nb", "nn"], emoji: "🇧🇻", emojiU: "U+1F1E7 U+1F1FB" }, BW: { name: "Botswana", native: "Botswana", phone: "267", continent: "AF", capital: "Gaborone", currency: "BWP", languages: ["en", "tn"], emoji: "🇧🇼", emojiU: "U+1F1E7 U+1F1FC" }, BY: { name: "Belarus", native: "Белару́сь", phone: "375", continent: "EU", capital: "Minsk", currency: "BYN", languages: ["be", "ru"], emoji: "🇧🇾", emojiU: "U+1F1E7 U+1F1FE" }, BZ: { name: "Belize", native: "Belize", phone: "501", continent: "NA", capital: "Belmopan", currency: "BZD", languages: ["en", "es"], emoji: "🇧🇿", emojiU: "U+1F1E7 U+1F1FF" }, CA: { name: "Canada", native: "Canada", phone: "1", continent: "NA", capital: "Ottawa", currency: "CAD", languages: ["en", "fr"], emoji: "🇨🇦", emojiU: "U+1F1E8 U+1F1E6" }, CC: { name: "Cocos [Keeling] Islands", native: "Cocos (Keeling) Islands", phone: "61", continent: "AS", capital: "West Island", currency: "AUD", languages: ["en"], emoji: "🇨🇨", emojiU: "U+1F1E8 U+1F1E8" }, CD: { name: "Democratic Republic of the Congo", native: "République démocratique du Congo", phone: "243", continent: "AF", capital: "Kinshasa", currency: "CDF", languages: ["fr", "ln", "kg", "sw", "lu"], emoji: "🇨🇩", emojiU: "U+1F1E8 U+1F1E9" }, CF: { name: "Central African Republic", native: "Ködörösêse tî Bêafrîka", phone: "236", continent: "AF", capital: "Bangui", currency: "XAF", languages: ["fr", "sg"], emoji: "🇨🇫", emojiU: "U+1F1E8 U+1F1EB" }, CG: { name: "Republic of the Congo", native: "République du Congo", phone: "242", continent: "AF", capital: "Brazzaville", currency: "XAF", languages: ["fr", "ln"], emoji: "🇨🇬", emojiU: "U+1F1E8 U+1F1EC" }, CH: { name: "Switzerland", native: "Schweiz", phone: "41", continent: "EU", capital: "Bern", currency: "CHE,CHF,CHW", languages: ["de", "fr", "it"], emoji: "🇨🇭", emojiU: "U+1F1E8 U+1F1ED" }, CI: { name: "Ivory Coast", native: "Côte d'Ivoire", phone: "225", continent: "AF", capital: "Yamoussoukro", currency: "XOF", languages: ["fr"], emoji: "🇨🇮", emojiU: "U+1F1E8 U+1F1EE" }, CK: { name: "Cook Islands", native: "Cook Islands", phone: "682", continent: "OC", capital: "Avarua", currency: "NZD", languages: ["en"], emoji: "🇨🇰", emojiU: "U+1F1E8 U+1F1F0" }, CL: { name: "Chile", native: "Chile", phone: "56", continent: "SA", capital: "Santiago", currency: "CLF,CLP", languages: ["es"], emoji: "🇨🇱", emojiU: "U+1F1E8 U+1F1F1" }, CM: { name: "Cameroon", native: "Cameroon", phone: "237", continent: "AF", capital: "Yaoundé", currency: "XAF", languages: ["en", "fr"], emoji: "🇨🇲", emojiU: "U+1F1E8 U+1F1F2" }, CN: { name: "China", native: "中国", phone: "86", continent: "AS", capital: "Beijing", currency: "CNY", languages: ["zh"], emoji: "🇨🇳", emojiU: "U+1F1E8 U+1F1F3" }, CO: { name: "Colombia", native: "Colombia", phone: "57", continent: "SA", capital: "Bogotá", currency: "COP", languages: ["es"], emoji: "🇨🇴", emojiU: "U+1F1E8 U+1F1F4" }, CR: { name: "Costa Rica", native: "Costa Rica", phone: "506", continent: "NA", capital: "San José", currency: "CRC", languages: ["es"], emoji: "🇨🇷", emojiU: "U+1F1E8 U+1F1F7" }, CU: { name: "Cuba", native: "Cuba", phone: "53", continent: "NA", capital: "Havana", currency: "CUC,CUP", languages: ["es"], emoji: "🇨🇺", emojiU: "U+1F1E8 U+1F1FA" }, CV: { name: "Cape Verde", native: "Cabo Verde", phone: "238", continent: "AF", capital: "Praia", currency: "CVE", languages: ["pt"], emoji: "🇨🇻", emojiU: "U+1F1E8 U+1F1FB" }, CW: { name: "Curacao", native: "Curaçao", phone: "5999", continent: "NA", capital: "Willemstad", currency: "ANG", languages: ["nl", "pa", "en"], emoji: "🇨🇼", emojiU: "U+1F1E8 U+1F1FC" }, CX: { name: "Christmas Island", native: "Christmas Island", phone: "61", continent: "AS", capital: "Flying Fish Cove", currency: "AUD", languages: ["en"], emoji: "🇨🇽", emojiU: "U+1F1E8 U+1F1FD" }, CY: { name: "Cyprus", native: "Κύπρος", phone: "357", continent: "EU", capital: "Nicosia", currency: "EUR", languages: ["el", "tr", "hy"], emoji: "🇨🇾", emojiU: "U+1F1E8 U+1F1FE" }, CZ: { name: "Czech Republic", native: "Česká republika", phone: "420", continent: "EU", capital: "Prague", currency: "CZK", languages: ["cs", "sk"], emoji: "🇨🇿", emojiU: "U+1F1E8 U+1F1FF" }, DE: { name: "Germany", native: "Deutschland", phone: "49", continent: "EU", capital: "Berlin", currency: "EUR", languages: ["de"], emoji: "🇩🇪", emojiU: "U+1F1E9 U+1F1EA" }, DJ: { name: "Djibouti", native: "Djibouti", phone: "253", continent: "AF", capital: "Djibouti", currency: "DJF", languages: ["fr", "ar"], emoji: "🇩🇯", emojiU: "U+1F1E9 U+1F1EF" }, DK: { name: "Denmark", native: "Danmark", phone: "45", continent: "EU", capital: "Copenhagen", currency: "DKK", languages: ["da"], emoji: "🇩🇰", emojiU: "U+1F1E9 U+1F1F0" }, DM: { name: "Dominica", native: "Dominica", phone: "1767", continent: "NA", capital: "Roseau", currency: "XCD", languages: ["en"], emoji: "🇩🇲", emojiU: "U+1F1E9 U+1F1F2" }, DO: { name: "Dominican Republic", native: "República Dominicana", phone: "1809,1829,1849", continent: "NA", capital: "Santo Domingo", currency: "DOP", languages: ["es"], emoji: "🇩🇴", emojiU: "U+1F1E9 U+1F1F4" }, DZ: { name: "Algeria", native: "الجزائر", phone: "213", continent: "AF", capital: "Algiers", currency: "DZD", languages: ["ar"], emoji: "🇩🇿", emojiU: "U+1F1E9 U+1F1FF" }, EC: { name: "Ecuador", native: "Ecuador", phone: "593", continent: "SA", capital: "Quito", currency: "USD", languages: ["es"], emoji: "🇪🇨", emojiU: "U+1F1EA U+1F1E8" }, EE: { name: "Estonia", native: "Eesti", phone: "372", continent: "EU", capital: "Tallinn", currency: "EUR", languages: ["et"], emoji: "🇪🇪", emojiU: "U+1F1EA U+1F1EA" }, EG: { name: "Egypt", native: "مصر‎", phone: "20", continent: "AF", capital: "Cairo", currency: "EGP", languages: ["ar"], emoji: "🇪🇬", emojiU: "U+1F1EA U+1F1EC" }, EH: { name: "Western Sahara", native: "الصحراء الغربية", phone: "212", continent: "AF", capital: "El Aaiún", currency: "MAD,DZD,MRU", languages: ["es"], emoji: "🇪🇭", emojiU: "U+1F1EA U+1F1ED" }, ER: { name: "Eritrea", native: "ኤርትራ", phone: "291", continent: "AF", capital: "Asmara", currency: "ERN", languages: ["ti", "ar", "en"], emoji: "🇪🇷", emojiU: "U+1F1EA U+1F1F7" }, ES: { name: "Spain", native: "España", phone: "34", continent: "EU", capital: "Madrid", currency: "EUR", languages: ["es", "eu", "ca", "gl", "oc"], emoji: "🇪🇸", emojiU: "U+1F1EA U+1F1F8" }, ET: { name: "Ethiopia", native: "ኢትዮጵያ", phone: "251", continent: "AF", capital: "Addis Ababa", currency: "ETB", languages: ["am"], emoji: "🇪🇹", emojiU: "U+1F1EA U+1F1F9" }, FI: { name: "Finland", native: "Suomi", phone: "358", continent: "EU", capital: "Helsinki", currency: "EUR", languages: ["fi", "sv"], emoji: "🇫🇮", emojiU: "U+1F1EB U+1F1EE" }, FJ: { name: "Fiji", native: "Fiji", phone: "679", continent: "OC", capital: "Suva", currency: "FJD", languages: ["en", "fj", "hi", "ur"], emoji: "🇫🇯", emojiU: "U+1F1EB U+1F1EF" }, FK: { name: "Falkland Islands", native: "Falkland Islands", phone: "500", continent: "SA", capital: "Stanley", currency: "FKP", languages: ["en"], emoji: "🇫🇰", emojiU: "U+1F1EB U+1F1F0" }, FM: { name: "Micronesia", native: "Micronesia", phone: "691", continent: "OC", capital: "Palikir", currency: "USD", languages: ["en"], emoji: "🇫🇲", emojiU: "U+1F1EB U+1F1F2" }, FO: { name: "Faroe Islands", native: "Føroyar", phone: "298", continent: "EU", capital: "Tórshavn", currency: "DKK", languages: ["fo"], emoji: "🇫🇴", emojiU: "U+1F1EB U+1F1F4" }, FR: { name: "France", native: "France", phone: "33", continent: "EU", capital: "Paris", currency: "EUR", languages: ["fr"], emoji: "🇫🇷", emojiU: "U+1F1EB U+1F1F7" }, GA: { name: "Gabon", native: "Gabon", phone: "241", continent: "AF", capital: "Libreville", currency: "XAF", languages: ["fr"], emoji: "🇬🇦", emojiU: "U+1F1EC U+1F1E6" }, GB: { name: "United Kingdom", native: "United Kingdom", phone: "44", continent: "EU", capital: "London", currency: "GBP", languages: ["en"], emoji: "🇬🇧", emojiU: "U+1F1EC U+1F1E7" }, GD: { name: "Grenada", native: "Grenada", phone: "1473", continent: "NA", capital: "St. George's", currency: "XCD", languages: ["en"], emoji: "🇬🇩", emojiU: "U+1F1EC U+1F1E9" }, GE: { name: "Georgia", native: "საქართველო", phone: "995", continent: "AS", capital: "Tbilisi", currency: "GEL", languages: ["ka"], emoji: "🇬🇪", emojiU: "U+1F1EC U+1F1EA" }, GF: { name: "French Guiana", native: "Guyane française", phone: "594", continent: "SA", capital: "Cayenne", currency: "EUR", languages: ["fr"], emoji: "🇬🇫", emojiU: "U+1F1EC U+1F1EB" }, GG: { name: "Guernsey", native: "Guernsey", phone: "44", continent: "EU", capital: "St. Peter Port", currency: "GBP", languages: ["en", "fr"], emoji: "🇬🇬", emojiU: "U+1F1EC U+1F1EC" }, GH: { name: "Ghana", native: "Ghana", phone: "233", continent: "AF", capital: "Accra", currency: "GHS", languages: ["en"], emoji: "🇬🇭", emojiU: "U+1F1EC U+1F1ED" }, GI: { name: "Gibraltar", native: "Gibraltar", phone: "350", continent: "EU", capital: "Gibraltar", currency: "GIP", languages: ["en"], emoji: "🇬🇮", emojiU: "U+1F1EC U+1F1EE" }, GL: { name: "Greenland", native: "Kalaallit Nunaat", phone: "299", continent: "NA", capital: "Nuuk", currency: "DKK", languages: ["kl"], emoji: "🇬🇱", emojiU: "U+1F1EC U+1F1F1" }, GM: { name: "Gambia", native: "Gambia", phone: "220", continent: "AF", capital: "Banjul", currency: "GMD", languages: ["en"], emoji: "🇬🇲", emojiU: "U+1F1EC U+1F1F2" }, GN: { name: "Guinea", native: "Guinée", phone: "224", continent: "AF", capital: "Conakry", currency: "GNF", languages: ["fr", "ff"], emoji: "🇬🇳", emojiU: "U+1F1EC U+1F1F3" }, GP: { name: "Guadeloupe", native: "Guadeloupe", phone: "590", continent: "NA", capital: "Basse-Terre", currency: "EUR", languages: ["fr"], emoji: "🇬🇵", emojiU: "U+1F1EC U+1F1F5" }, GQ: { name: "Equatorial Guinea", native: "Guinea Ecuatorial", phone: "240", continent: "AF", capital: "Malabo", currency: "XAF", languages: ["es", "fr"], emoji: "🇬🇶", emojiU: "U+1F1EC U+1F1F6" }, GR: { name: "Greece", native: "Ελλάδα", phone: "30", continent: "EU", capital: "Athens", currency: "EUR", languages: ["el"], emoji: "🇬🇷", emojiU: "U+1F1EC U+1F1F7" }, GS: { name: "South Georgia and the South Sandwich Islands", native: "South Georgia", phone: "500", continent: "AN", capital: "King Edward Point", currency: "GBP", languages: ["en"], emoji: "🇬🇸", emojiU: "U+1F1EC U+1F1F8" }, GT: { name: "Guatemala", native: "Guatemala", phone: "502", continent: "NA", capital: "Guatemala City", currency: "GTQ", languages: ["es"], emoji: "🇬🇹", emojiU: "U+1F1EC U+1F1F9" }, GU: { name: "Guam", native: "Guam", phone: "1671", continent: "OC", capital: "Hagåtña", currency: "USD", languages: ["en", "ch", "es"], emoji: "🇬🇺", emojiU: "U+1F1EC U+1F1FA" }, GW: { name: "Guinea-Bissau", native: "Guiné-Bissau", phone: "245", continent: "AF", capital: "Bissau", currency: "XOF", languages: ["pt"], emoji: "🇬🇼", emojiU: "U+1F1EC U+1F1FC" }, GY: { name: "Guyana", native: "Guyana", phone: "592", continent: "SA", capital: "Georgetown", currency: "GYD", languages: ["en"], emoji: "🇬🇾", emojiU: "U+1F1EC U+1F1FE" }, HK: { name: "Hong Kong", native: "香港", phone: "852", continent: "AS", capital: "City of Victoria", currency: "HKD", languages: ["zh", "en"], emoji: "🇭🇰", emojiU: "U+1F1ED U+1F1F0" }, HM: { name: "Heard Island and McDonald Islands", native: "Heard Island and McDonald Islands", phone: "61", continent: "AN", capital: "", currency: "AUD", languages: ["en"], emoji: "🇭🇲", emojiU: "U+1F1ED U+1F1F2" }, HN: { name: "Honduras", native: "Honduras", phone: "504", continent: "NA", capital: "Tegucigalpa", currency: "HNL", languages: ["es"], emoji: "🇭🇳", emojiU: "U+1F1ED U+1F1F3" }, HR: { name: "Croatia", native: "Hrvatska", phone: "385", continent: "EU", capital: "Zagreb", currency: "HRK", languages: ["hr"], emoji: "🇭🇷", emojiU: "U+1F1ED U+1F1F7" }, HT: { name: "Haiti", native: "Haïti", phone: "509", continent: "NA", capital: "Port-au-Prince", currency: "HTG,USD", languages: ["fr", "ht"], emoji: "🇭🇹", emojiU: "U+1F1ED U+1F1F9" }, HU: { name: "Hungary", native: "Magyarország", phone: "36", continent: "EU", capital: "Budapest", currency: "HUF", languages: ["hu"], emoji: "🇭🇺", emojiU: "U+1F1ED U+1F1FA" }, ID: { name: "Indonesia", native: "Indonesia", phone: "62", continent: "AS", capital: "Jakarta", currency: "IDR", languages: ["id"], emoji: "🇮🇩", emojiU: "U+1F1EE U+1F1E9" }, IE: { name: "Ireland", native: "Éire", phone: "353", continent: "EU", capital: "Dublin", currency: "EUR", languages: ["ga", "en"], emoji: "🇮🇪", emojiU: "U+1F1EE U+1F1EA" }, IL: { name: "Israel", native: "יִשְׂרָאֵל", phone: "972", continent: "AS", capital: "Jerusalem", currency: "ILS", languages: ["he", "ar"], emoji: "🇮🇱", emojiU: "U+1F1EE U+1F1F1" }, IM: { name: "Isle of Man", native: "Isle of Man", phone: "44", continent: "EU", capital: "Douglas", currency: "GBP", languages: ["en", "gv"], emoji: "🇮🇲", emojiU: "U+1F1EE U+1F1F2" }, IN: { name: "India", native: "भारत", phone: "91", continent: "AS", capital: "New Delhi", currency: "INR", languages: ["hi", "en"], emoji: "🇮🇳", emojiU: "U+1F1EE U+1F1F3" }, IO: { name: "British Indian Ocean Territory", native: "British Indian Ocean Territory", phone: "246", continent: "AS", capital: "Diego Garcia", currency: "USD", languages: ["en"], emoji: "🇮🇴", emojiU: "U+1F1EE U+1F1F4" }, IQ: { name: "Iraq", native: "العراق", phone: "964", continent: "AS", capital: "Baghdad", currency: "IQD", languages: ["ar", "ku"], emoji: "🇮🇶", emojiU: "U+1F1EE U+1F1F6" }, IR: { name: "Iran", native: "ایران", phone: "98", continent: "AS", capital: "Tehran", currency: "IRR", languages: ["fa"], emoji: "🇮🇷", emojiU: "U+1F1EE U+1F1F7" }, IS: { name: "Iceland", native: "Ísland", phone: "354", continent: "EU", capital: "Reykjavik", currency: "ISK", languages: ["is"], emoji: "🇮🇸", emojiU: "U+1F1EE U+1F1F8" }, IT: { name: "Italy", native: "Italia", phone: "39", continent: "EU", capital: "Rome", currency: "EUR", languages: ["it"], emoji: "🇮🇹", emojiU: "U+1F1EE U+1F1F9" }, JE: { name: "Jersey", native: "Jersey", phone: "44", continent: "EU", capital: "Saint Helier", currency: "GBP", languages: ["en", "fr"], emoji: "🇯🇪", emojiU: "U+1F1EF U+1F1EA" }, JM: { name: "Jamaica", native: "Jamaica", phone: "1876", continent: "NA", capital: "Kingston", currency: "JMD", languages: ["en"], emoji: "🇯🇲", emojiU: "U+1F1EF U+1F1F2" }, JO: { name: "Jordan", native: "الأردن", phone: "962", continent: "AS", capital: "Amman", currency: "JOD", languages: ["ar"], emoji: "🇯🇴", emojiU: "U+1F1EF U+1F1F4" }, JP: { name: "Japan", native: "日本", phone: "81", continent: "AS", capital: "Tokyo", currency: "JPY", languages: ["ja"], emoji: "🇯🇵", emojiU: "U+1F1EF U+1F1F5" }, KE: { name: "Kenya", native: "Kenya", phone: "254", continent: "AF", capital: "Nairobi", currency: "KES", languages: ["en", "sw"], emoji: "🇰🇪", emojiU: "U+1F1F0 U+1F1EA" }, KG: { name: "Kyrgyzstan", native: "Кыргызстан", phone: "996", continent: "AS", capital: "Bishkek", currency: "KGS", languages: ["ky", "ru"], emoji: "🇰🇬", emojiU: "U+1F1F0 U+1F1EC" }, KH: { name: "Cambodia", native: "Kâmpŭchéa", phone: "855", continent: "AS", capital: "Phnom Penh", currency: "KHR", languages: ["km"], emoji: "🇰🇭", emojiU: "U+1F1F0 U+1F1ED" }, KI: { name: "Kiribati", native: "Kiribati", phone: "686", continent: "OC", capital: "South Tarawa", currency: "AUD", languages: ["en"], emoji: "🇰🇮", emojiU: "U+1F1F0 U+1F1EE" }, KM: { name: "Comoros", native: "Komori", phone: "269", continent: "AF", capital: "Moroni", currency: "KMF", languages: ["ar", "fr"], emoji: "🇰🇲", emojiU: "U+1F1F0 U+1F1F2" }, KN: { name: "Saint Kitts and Nevis", native: "Saint Kitts and Nevis", phone: "1869", continent: "NA", capital: "Basseterre", currency: "XCD", languages: ["en"], emoji: "🇰🇳", emojiU: "U+1F1F0 U+1F1F3" }, KP: { name: "North Korea", native: "북한", phone: "850", continent: "AS", capital: "Pyongyang", currency: "KPW", languages: ["ko"], emoji: "🇰🇵", emojiU: "U+1F1F0 U+1F1F5" }, KR: { name: "South Korea", native: "대한민국", phone: "82", continent: "AS", capital: "Seoul", currency: "KRW", languages: ["ko"], emoji: "🇰🇷", emojiU: "U+1F1F0 U+1F1F7" }, KW: { name: "Kuwait", native: "الكويت", phone: "965", continent: "AS", capital: "Kuwait City", currency: "KWD", languages: ["ar"], emoji: "🇰🇼", emojiU: "U+1F1F0 U+1F1FC" }, KY: { name: "Cayman Islands", native: "Cayman Islands", phone: "1345", continent: "NA", capital: "George Town", currency: "KYD", languages: ["en"], emoji: "🇰🇾", emojiU: "U+1F1F0 U+1F1FE" }, KZ: { name: "Kazakhstan", native: "Қазақстан", phone: "76,77", continent: "AS", capital: "Astana", currency: "KZT", languages: ["kk", "ru"], emoji: "🇰🇿", emojiU: "U+1F1F0 U+1F1FF" }, LA: { name: "Laos", native: "ສປປລາວ", phone: "856", continent: "AS", capital: "Vientiane", currency: "LAK", languages: ["lo"], emoji: "🇱🇦", emojiU: "U+1F1F1 U+1F1E6" }, LB: { name: "Lebanon", native: "لبنان", phone: "961", continent: "AS", capital: "Beirut", currency: "LBP", languages: ["ar", "fr"], emoji: "🇱🇧", emojiU: "U+1F1F1 U+1F1E7" }, LC: { name: "Saint Lucia", native: "Saint Lucia", phone: "1758", continent: "NA", capital: "Castries", currency: "XCD", languages: ["en"], emoji: "🇱🇨", emojiU: "U+1F1F1 U+1F1E8" }, LI: { name: "Liechtenstein", native: "Liechtenstein", phone: "423", continent: "EU", capital: "Vaduz", currency: "CHF", languages: ["de"], emoji: "🇱🇮", emojiU: "U+1F1F1 U+1F1EE" }, LK: { name: "Sri Lanka", native: "śrī laṃkāva", phone: "94", continent: "AS", capital: "Colombo", currency: "LKR", languages: ["si", "ta"], emoji: "🇱🇰", emojiU: "U+1F1F1 U+1F1F0" }, LR: { name: "Liberia", native: "Liberia", phone: "231", continent: "AF", capital: "Monrovia", currency: "LRD", languages: ["en"], emoji: "🇱🇷", emojiU: "U+1F1F1 U+1F1F7" }, LS: { name: "Lesotho", native: "Lesotho", phone: "266", continent: "AF", capital: "Maseru", currency: "LSL,ZAR", languages: ["en", "st"], emoji: "🇱🇸", emojiU: "U+1F1F1 U+1F1F8" }, LT: { name: "Lithuania", native: "Lietuva", phone: "370", continent: "EU", capital: "Vilnius", currency: "EUR", languages: ["lt"], emoji: "🇱🇹", emojiU: "U+1F1F1 U+1F1F9" }, LU: { name: "Luxembourg", native: "Luxembourg", phone: "352", continent: "EU", capital: "Luxembourg", currency: "EUR", languages: ["fr", "de", "lb"], emoji: "🇱🇺", emojiU: "U+1F1F1 U+1F1FA" }, LV: { name: "Latvia", native: "Latvija", phone: "371", continent: "EU", capital: "Riga", currency: "EUR", languages: ["lv"], emoji: "🇱🇻", emojiU: "U+1F1F1 U+1F1FB" }, LY: { name: "Libya", native: "‏ليبيا", phone: "218", continent: "AF", capital: "Tripoli", currency: "LYD", languages: ["ar"], emoji: "🇱🇾", emojiU: "U+1F1F1 U+1F1FE" }, MA: { name: "Morocco", native: "المغرب", phone: "212", continent: "AF", capital: "Rabat", currency: "MAD", languages: ["ar"], emoji: "🇲🇦", emojiU: "U+1F1F2 U+1F1E6" }, MC: { name: "Monaco", native: "Monaco", phone: "377", continent: "EU", capital: "Monaco", currency: "EUR", languages: ["fr"], emoji: "🇲🇨", emojiU: "U+1F1F2 U+1F1E8" }, MD: { name: "Moldova", native: "Moldova", phone: "373", continent: "EU", capital: "Chișinău", currency: "MDL", languages: ["ro"], emoji: "🇲🇩", emojiU: "U+1F1F2 U+1F1E9" }, ME: { name: "Montenegro", native: "Црна Гора", phone: "382", continent: "EU", capital: "Podgorica", currency: "EUR", languages: ["sr", "bs", "sq", "hr"], emoji: "🇲🇪", emojiU: "U+1F1F2 U+1F1EA" }, MF: { name: "Saint Martin", native: "Saint-Martin", phone: "590", continent: "NA", capital: "Marigot", currency: "EUR", languages: ["en", "fr", "nl"], emoji: "🇲🇫", emojiU: "U+1F1F2 U+1F1EB" }, MG: { name: "Madagascar", native: "Madagasikara", phone: "261", continent: "AF", capital: "Antananarivo", currency: "MGA", languages: ["fr", "mg"], emoji: "🇲🇬", emojiU: "U+1F1F2 U+1F1EC" }, MH: { name: "Marshall Islands", native: "M̧ajeļ", phone: "692", continent: "OC", capital: "Majuro", currency: "USD", languages: ["en", "mh"], emoji: "🇲🇭", emojiU: "U+1F1F2 U+1F1ED" }, MK: { name: "North Macedonia", native: "Северна Македонија", phone: "389", continent: "EU", capital: "Skopje", currency: "MKD", languages: ["mk"], emoji: "🇲🇰", emojiU: "U+1F1F2 U+1F1F0" }, ML: { name: "Mali", native: "Mali", phone: "223", continent: "AF", capital: "Bamako", currency: "XOF", languages: ["fr"], emoji: "🇲🇱", emojiU: "U+1F1F2 U+1F1F1" }, MM: { name: "Myanmar [Burma]", native: "မြန်မာ", phone: "95", continent: "AS", capital: "Naypyidaw", currency: "MMK", languages: ["my"], emoji: "🇲🇲", emojiU: "U+1F1F2 U+1F1F2" }, MN: { name: "Mongolia", native: "Монгол улс", phone: "976", continent: "AS", capital: "Ulan Bator", currency: "MNT", languages: ["mn"], emoji: "🇲🇳", emojiU: "U+1F1F2 U+1F1F3" }, MO: { name: "Macao", native: "澳門", phone: "853", continent: "AS", capital: "", currency: "MOP", languages: ["zh", "pt"], emoji: "🇲🇴", emojiU: "U+1F1F2 U+1F1F4" }, MP: { name: "Northern Mariana Islands", native: "Northern Mariana Islands", phone: "1670", continent: "OC", capital: "Saipan", currency: "USD", languages: ["en", "ch"], emoji: "🇲🇵", emojiU: "U+1F1F2 U+1F1F5" }, MQ: { name: "Martinique", native: "Martinique", phone: "596", continent: "NA", capital: "Fort-de-France", currency: "EUR", languages: ["fr"], emoji: "🇲🇶", emojiU: "U+1F1F2 U+1F1F6" }, MR: { name: "Mauritania", native: "موريتانيا", phone: "222", continent: "AF", capital: "Nouakchott", currency: "MRU", languages: ["ar"], emoji: "🇲🇷", emojiU: "U+1F1F2 U+1F1F7" }, MS: { name: "Montserrat", native: "Montserrat", phone: "1664", continent: "NA", capital: "Plymouth", currency: "XCD", languages: ["en"], emoji: "🇲🇸", emojiU: "U+1F1F2 U+1F1F8" }, MT: { name: "Malta", native: "Malta", phone: "356", continent: "EU", capital: "Valletta", currency: "EUR", languages: ["mt", "en"], emoji: "🇲🇹", emojiU: "U+1F1F2 U+1F1F9" }, MU: { name: "Mauritius", native: "Maurice", phone: "230", continent: "AF", capital: "Port Louis", currency: "MUR", languages: ["en"], emoji: "🇲🇺", emojiU: "U+1F1F2 U+1F1FA" }, MV: { name: "Maldives", native: "Maldives", phone: "960", continent: "AS", capital: "Malé", currency: "MVR", languages: ["dv"], emoji: "🇲🇻", emojiU: "U+1F1F2 U+1F1FB" }, MW: { name: "Malawi", native: "Malawi", phone: "265", continent: "AF", capital: "Lilongwe", currency: "MWK", languages: ["en", "ny"], emoji: "🇲🇼", emojiU: "U+1F1F2 U+1F1FC" }, MX: { name: "Mexico", native: "México", phone: "52", continent: "NA", capital: "Mexico City", currency: "MXN", languages: ["es"], emoji: "🇲🇽", emojiU: "U+1F1F2 U+1F1FD" }, MY: { name: "Malaysia", native: "Malaysia", phone: "60", continent: "AS", capital: "Kuala Lumpur", currency: "MYR", languages: ["ms"], emoji: "🇲🇾", emojiU: "U+1F1F2 U+1F1FE" }, MZ: { name: "Mozambique", native: "Moçambique", phone: "258", continent: "AF", capital: "Maputo", currency: "MZN", languages: ["pt"], emoji: "🇲🇿", emojiU: "U+1F1F2 U+1F1FF" }, NA: { name: "Namibia", native: "Namibia", phone: "264", continent: "AF", capital: "Windhoek", currency: "NAD,ZAR", languages: ["en", "af"], emoji: "🇳🇦", emojiU: "U+1F1F3 U+1F1E6" }, NC: { name: "New Caledonia", native: "Nouvelle-Calédonie", phone: "687", continent: "OC", capital: "Nouméa", currency: "XPF", languages: ["fr"], emoji: "🇳🇨", emojiU: "U+1F1F3 U+1F1E8" }, NE: { name: "Niger", native: "Niger", phone: "227", continent: "AF", capital: "Niamey", currency: "XOF", languages: ["fr"], emoji: "🇳🇪", emojiU: "U+1F1F3 U+1F1EA" }, NF: { name: "Norfolk Island", native: "Norfolk Island", phone: "672", continent: "OC", capital: "Kingston", currency: "AUD", languages: ["en"], emoji: "🇳🇫", emojiU: "U+1F1F3 U+1F1EB" }, NG: { name: "Nigeria", native: "Nigeria", phone: "234", continent: "AF", capital: "Abuja", currency: "NGN", languages: ["en"], emoji: "🇳🇬", emojiU: "U+1F1F3 U+1F1EC" }, NI: { name: "Nicaragua", native: "Nicaragua", phone: "505", continent: "NA", capital: "Managua", currency: "NIO", languages: ["es"], emoji: "🇳🇮", emojiU: "U+1F1F3 U+1F1EE" }, NL: { name: "Netherlands", native: "Nederland", phone: "31", continent: "EU", capital: "Amsterdam", currency: "EUR", languages: ["nl"], emoji: "🇳🇱", emojiU: "U+1F1F3 U+1F1F1" }, NO: { name: "Norway", native: "Norge", phone: "47", continent: "EU", capital: "Oslo", currency: "NOK", languages: ["no", "nb", "nn"], emoji: "🇳🇴", emojiU: "U+1F1F3 U+1F1F4" }, NP: { name: "Nepal", native: "नपल", phone: "977", continent: "AS", capital: "Kathmandu", currency: "NPR", languages: ["ne"], emoji: "🇳🇵", emojiU: "U+1F1F3 U+1F1F5" }, NR: { name: "Nauru", native: "Nauru", phone: "674", continent: "OC", capital: "Yaren", currency: "AUD", languages: ["en", "na"], emoji: "🇳🇷", emojiU: "U+1F1F3 U+1F1F7" }, NU: { name: "Niue", native: "Niuē", phone: "683", continent: "OC", capital: "Alofi", currency: "NZD", languages: ["en"], emoji: "🇳🇺", emojiU: "U+1F1F3 U+1F1FA" }, NZ: { name: "New Zealand", native: "New Zealand", phone: "64", continent: "OC", capital: "Wellington", currency: "NZD", languages: ["en", "mi"], emoji: "🇳🇿", emojiU: "U+1F1F3 U+1F1FF" }, OM: { name: "Oman", native: "عمان", phone: "968", continent: "AS", capital: "Muscat", currency: "OMR", languages: ["ar"], emoji: "🇴🇲", emojiU: "U+1F1F4 U+1F1F2" }, PA: { name: "Panama", native: "Panamá", phone: "507", continent: "NA", capital: "Panama City", currency: "PAB,USD", languages: ["es"], emoji: "🇵🇦", emojiU: "U+1F1F5 U+1F1E6" }, PE: { name: "Peru", native: "Perú", phone: "51", continent: "SA", capital: "Lima", currency: "PEN", languages: ["es"], emoji: "🇵🇪", emojiU: "U+1F1F5 U+1F1EA" }, PF: { name: "French Polynesia", native: "Polynésie française", phone: "689", continent: "OC", capital: "Papeetē", currency: "XPF", languages: ["fr"], emoji: "🇵🇫", emojiU: "U+1F1F5 U+1F1EB" }, PG: { name: "Papua New Guinea", native: "Papua Niugini", phone: "675", continent: "OC", capital: "Port Moresby", currency: "PGK", languages: ["en"], emoji: "🇵🇬", emojiU: "U+1F1F5 U+1F1EC" }, PH: { name: "Philippines", native: "Pilipinas", phone: "63", continent: "AS", capital: "Manila", currency: "PHP", languages: ["en"], emoji: "🇵🇭", emojiU: "U+1F1F5 U+1F1ED" }, PK: { name: "Pakistan", native: "Pakistan", phone: "92", continent: "AS", capital: "Islamabad", currency: "PKR", languages: ["en", "ur"], emoji: "🇵🇰", emojiU: "U+1F1F5 U+1F1F0" }, PL: { name: "Poland", native: "Polska", phone: "48", continent: "EU", capital: "Warsaw", currency: "PLN", languages: ["pl"], emoji: "🇵🇱", emojiU: "U+1F1F5 U+1F1F1" }, PM: { name: "Saint Pierre and Miquelon", native: "Saint-Pierre-et-Miquelon", phone: "508", continent: "NA", capital: "Saint-Pierre", currency: "EUR", languages: ["fr"], emoji: "🇵🇲", emojiU: "U+1F1F5 U+1F1F2" }, PN: { name: "Pitcairn Islands", native: "Pitcairn Islands", phone: "64", continent: "OC", capital: "Adamstown", currency: "NZD", languages: ["en"], emoji: "🇵🇳", emojiU: "U+1F1F5 U+1F1F3" }, PR: { name: "Puerto Rico", native: "Puerto Rico", phone: "1787,1939", continent: "NA", capital: "San Juan", currency: "USD", languages: ["es", "en"], emoji: "🇵🇷", emojiU: "U+1F1F5 U+1F1F7" }, PS: { name: "Palestine", native: "فلسطين", phone: "970", continent: "AS", capital: "Ramallah", currency: "ILS", languages: ["ar"], emoji: "🇵🇸", emojiU: "U+1F1F5 U+1F1F8" }, PT: { name: "Portugal", native: "Portugal", phone: "351", continent: "EU", capital: "Lisbon", currency: "EUR", languages: ["pt"], emoji: "🇵🇹", emojiU: "U+1F1F5 U+1F1F9" }, PW: { name: "Palau", native: "Palau", phone: "680", continent: "OC", capital: "Ngerulmud", currency: "USD", languages: ["en"], emoji: "🇵🇼", emojiU: "U+1F1F5 U+1F1FC" }, PY: { name: "Paraguay", native: "Paraguay", phone: "595", continent: "SA", capital: "Asunción", currency: "PYG", languages: ["es", "gn"], emoji: "🇵🇾", emojiU: "U+1F1F5 U+1F1FE" }, QA: { name: "Qatar", native: "قطر", phone: "974", continent: "AS", capital: "Doha", currency: "QAR", languages: ["ar"], emoji: "🇶🇦", emojiU: "U+1F1F6 U+1F1E6" }, RE: { name: "Réunion", native: "La Réunion", phone: "262", continent: "AF", capital: "Saint-Denis", currency: "EUR", languages: ["fr"], emoji: "🇷🇪", emojiU: "U+1F1F7 U+1F1EA" }, RO: { name: "Romania", native: "România", phone: "40", continent: "EU", capital: "Bucharest", currency: "RON", languages: ["ro"], emoji: "🇷🇴", emojiU: "U+1F1F7 U+1F1F4" }, RS: { name: "Serbia", native: "Србија", phone: "381", continent: "EU", capital: "Belgrade", currency: "RSD", languages: ["sr"], emoji: "🇷🇸", emojiU: "U+1F1F7 U+1F1F8" }, RU: { name: "Russia", native: "Россия", phone: "7", continent: "EU", capital: "Moscow", currency: "RUB", languages: ["ru"], emoji: "🇷🇺", emojiU: "U+1F1F7 U+1F1FA" }, RW: { name: "Rwanda", native: "Rwanda", phone: "250", continent: "AF", capital: "Kigali", currency: "RWF", languages: ["rw", "en", "fr"], emoji: "🇷🇼", emojiU: "U+1F1F7 U+1F1FC" }, SA: { name: "Saudi Arabia", native: "العربية السعودية", phone: "966", continent: "AS", capital: "Riyadh", currency: "SAR", languages: ["ar"], emoji: "🇸🇦", emojiU: "U+1F1F8 U+1F1E6" }, SB: { name: "Solomon Islands", native: "Solomon Islands", phone: "677", continent: "OC", capital: "Honiara", currency: "SBD", languages: ["en"], emoji: "🇸🇧", emojiU: "U+1F1F8 U+1F1E7" }, SC: { name: "Seychelles", native: "Seychelles", phone: "248", continent: "AF", capital: "Victoria", currency: "SCR", languages: ["fr", "en"], emoji: "🇸🇨", emojiU: "U+1F1F8 U+1F1E8" }, SD: { name: "Sudan", native: "السودان", phone: "249", continent: "AF", capital: "Khartoum", currency: "SDG", languages: ["ar", "en"], emoji: "🇸🇩", emojiU: "U+1F1F8 U+1F1E9" }, SE: { name: "Sweden", native: "Sverige", phone: "46", continent: "EU", capital: "Stockholm", currency: "SEK", languages: ["sv"], emoji: "🇸🇪", emojiU: "U+1F1F8 U+1F1EA" }, SG: { name: "Singapore", native: "Singapore", phone: "65", continent: "AS", capital: "Singapore", currency: "SGD", languages: ["en", "ms", "ta", "zh"], emoji: "🇸🇬", emojiU: "U+1F1F8 U+1F1EC" }, SH: { name: "Saint Helena", native: "Saint Helena", phone: "290", continent: "AF", capital: "Jamestown", currency: "SHP", languages: ["en"], emoji: "🇸🇭", emojiU: "U+1F1F8 U+1F1ED" }, SI: { name: "Slovenia", native: "Slovenija", phone: "386", continent: "EU", capital: "Ljubljana", currency: "EUR", languages: ["sl"], emoji: "🇸🇮", emojiU: "U+1F1F8 U+1F1EE" }, SJ: { name: "Svalbard and Jan Mayen", native: "Svalbard og Jan Mayen", phone: "4779", continent: "EU", capital: "Longyearbyen", currency: "NOK", languages: ["no"], emoji: "🇸🇯", emojiU: "U+1F1F8 U+1F1EF" }, SK: { name: "Slovakia", native: "Slovensko", phone: "421", continent: "EU", capital: "Bratislava", currency: "EUR", languages: ["sk"], emoji: "🇸🇰", emojiU: "U+1F1F8 U+1F1F0" }, SL: { name: "Sierra Leone", native: "Sierra Leone", phone: "232", continent: "AF", capital: "Freetown", currency: "SLL", languages: ["en"], emoji: "🇸🇱", emojiU: "U+1F1F8 U+1F1F1" }, SM: { name: "San Marino", native: "San Marino", phone: "378", continent: "EU", capital: "City of San Marino", currency: "EUR", languages: ["it"], emoji: "🇸🇲", emojiU: "U+1F1F8 U+1F1F2" }, SN: { name: "Senegal", native: "Sénégal", phone: "221", continent: "AF", capital: "Dakar", currency: "XOF", languages: ["fr"], emoji: "🇸🇳", emojiU: "U+1F1F8 U+1F1F3" }, SO: { name: "Somalia", native: "Soomaaliya", phone: "252", continent: "AF", capital: "Mogadishu", currency: "SOS", languages: ["so", "ar"], emoji: "🇸🇴", emojiU: "U+1F1F8 U+1F1F4" }, SR: { name: "Suriname", native: "Suriname", phone: "597", continent: "SA", capital: "Paramaribo", currency: "SRD", languages: ["nl"], emoji: "🇸🇷", emojiU: "U+1F1F8 U+1F1F7" }, SS: { name: "South Sudan", native: "South Sudan", phone: "211", continent: "AF", capital: "Juba", currency: "SSP", languages: ["en"], emoji: "🇸🇸", emojiU: "U+1F1F8 U+1F1F8" }, ST: { name: "São Tomé and Príncipe", native: "São Tomé e Príncipe", phone: "239", continent: "AF", capital: "São Tomé", currency: "STN", languages: ["pt"], emoji: "🇸🇹", emojiU: "U+1F1F8 U+1F1F9" }, SV: { name: "El Salvador", native: "El Salvador", phone: "503", continent: "NA", capital: "San Salvador", currency: "SVC,USD", languages: ["es"], emoji: "🇸🇻", emojiU: "U+1F1F8 U+1F1FB" }, SX: { name: "Sint Maarten", native: "Sint Maarten", phone: "1721", continent: "NA", capital: "Philipsburg", currency: "ANG", languages: ["nl", "en"], emoji: "🇸🇽", emojiU: "U+1F1F8 U+1F1FD" }, SY: { name: "Syria", native: "سوريا", phone: "963", continent: "AS", capital: "Damascus", currency: "SYP", languages: ["ar"], emoji: "🇸🇾", emojiU: "U+1F1F8 U+1F1FE" }, SZ: { name: "Swaziland", native: "Swaziland", phone: "268", continent: "AF", capital: "Lobamba", currency: "SZL", languages: ["en", "ss"], emoji: "🇸🇿", emojiU: "U+1F1F8 U+1F1FF" }, TC: { name: "Turks and Caicos Islands", native: "Turks and Caicos Islands", phone: "1649", continent: "NA", capital: "Cockburn Town", currency: "USD", languages: ["en"], emoji: "🇹🇨", emojiU: "U+1F1F9 U+1F1E8" }, TD: { name: "Chad", native: "Tchad", phone: "235", continent: "AF", capital: "N'Djamena", currency: "XAF", languages: ["fr", "ar"], emoji: "🇹🇩", emojiU: "U+1F1F9 U+1F1E9" }, TF: { name: "French Southern Territories", native: "Territoire des Terres australes et antarctiques fr", phone: "262", continent: "AN", capital: "Port-aux-Français", currency: "EUR", languages: ["fr"], emoji: "🇹🇫", emojiU: "U+1F1F9 U+1F1EB" }, TG: { name: "Togo", native: "Togo", phone: "228", continent: "AF", capital: "Lomé", currency: "XOF", languages: ["fr"], emoji: "🇹🇬", emojiU: "U+1F1F9 U+1F1EC" }, TH: { name: "Thailand", native: "ประเทศไทย", phone: "66", continent: "AS", capital: "Bangkok", currency: "THB", languages: ["th"], emoji: "🇹🇭", emojiU: "U+1F1F9 U+1F1ED" }, TJ: { name: "Tajikistan", native: "Тоҷикистон", phone: "992", continent: "AS", capital: "Dushanbe", currency: "TJS", languages: ["tg", "ru"], emoji: "🇹🇯", emojiU: "U+1F1F9 U+1F1EF" }, TK: { name: "Tokelau", native: "Tokelau", phone: "690", continent: "OC", capital: "Fakaofo", currency: "NZD", languages: ["en"], emoji: "🇹🇰", emojiU: "U+1F1F9 U+1F1F0" }, TL: { name: "East Timor", native: "Timor-Leste", phone: "670", continent: "OC", capital: "Dili", currency: "USD", languages: ["pt"], emoji: "🇹🇱", emojiU: "U+1F1F9 U+1F1F1" }, TM: { name: "Turkmenistan", native: "Türkmenistan", phone: "993", continent: "AS", capital: "Ashgabat", currency: "TMT", languages: ["tk", "ru"], emoji: "🇹🇲", emojiU: "U+1F1F9 U+1F1F2" }, TN: { name: "Tunisia", native: "تونس", phone: "216", continent: "AF", capital: "Tunis", currency: "TND", languages: ["ar"], emoji: "🇹🇳", emojiU: "U+1F1F9 U+1F1F3" }, TO: { name: "Tonga", native: "Tonga", phone: "676", continent: "OC", capital: "Nuku'alofa", currency: "TOP", languages: ["en", "to"], emoji: "🇹🇴", emojiU: "U+1F1F9 U+1F1F4" }, TR: { name: "Turkey", native: "Türkiye", phone: "90", continent: "AS", capital: "Ankara", currency: "TRY", languages: ["tr"], emoji: "🇹🇷", emojiU: "U+1F1F9 U+1F1F7" }, TT: { name: "Trinidad and Tobago", native: "Trinidad and Tobago", phone: "1868", continent: "NA", capital: "Port of Spain", currency: "TTD", languages: ["en"], emoji: "🇹🇹", emojiU: "U+1F1F9 U+1F1F9" }, TV: { name: "Tuvalu", native: "Tuvalu", phone: "688", continent: "OC", capital: "Funafuti", currency: "AUD", languages: ["en"], emoji: "🇹🇻", emojiU: "U+1F1F9 U+1F1FB" }, TW: { name: "Taiwan", native: "臺灣", phone: "886", continent: "AS", capital: "Taipei", currency: "TWD", languages: ["zh"], emoji: "🇹🇼", emojiU: "U+1F1F9 U+1F1FC" }, TZ: { name: "Tanzania", native: "Tanzania", phone: "255", continent: "AF", capital: "Dodoma", currency: "TZS", languages: ["sw", "en"], emoji: "🇹🇿", emojiU: "U+1F1F9 U+1F1FF" }, UA: { name: "Ukraine", native: "Україна", phone: "380", continent: "EU", capital: "Kyiv", currency: "UAH", languages: ["uk"], emoji: "🇺🇦", emojiU: "U+1F1FA U+1F1E6" }, UG: { name: "Uganda", native: "Uganda", phone: "256", continent: "AF", capital: "Kampala", currency: "UGX", languages: ["en", "sw"], emoji: "🇺🇬", emojiU: "U+1F1FA U+1F1EC" }, UM: { name: "U.S. Minor Outlying Islands", native: "United States Minor Outlying Islands", phone: "1", continent: "OC", capital: "", currency: "USD", languages: ["en"], emoji: "🇺🇲", emojiU: "U+1F1FA U+1F1F2" }, US: { name: "United States", native: "United States", phone: "1", continent: "NA", capital: "Washington D.C.", currency: "USD,USN,USS", languages: ["en"], emoji: "🇺🇸", emojiU: "U+1F1FA U+1F1F8" }, UY: { name: "Uruguay", native: "Uruguay", phone: "598", continent: "SA", capital: "Montevideo", currency: "UYI,UYU", languages: ["es"], emoji: "🇺🇾", emojiU: "U+1F1FA U+1F1FE" }, UZ: { name: "Uzbekistan", native: "O‘zbekiston", phone: "998", continent: "AS", capital: "Tashkent", currency: "UZS", languages: ["uz", "ru"], emoji: "🇺🇿", emojiU: "U+1F1FA U+1F1FF" }, VA: { name: "Vatican City", native: "Vaticano", phone: "379", continent: "EU", capital: "Vatican City", currency: "EUR", languages: ["it", "la"], emoji: "🇻🇦", emojiU: "U+1F1FB U+1F1E6" }, VC: { name: "Saint Vincent and the Grenadines", native: "Saint Vincent and the Grenadines", phone: "1784", continent: "NA", capital: "Kingstown", currency: "XCD", languages: ["en"], emoji: "🇻🇨", emojiU: "U+1F1FB U+1F1E8" }, VE: { name: "Venezuela", native: "Venezuela", phone: "58", continent: "SA", capital: "Caracas", currency: "VES", languages: ["es"], emoji: "🇻🇪", emojiU: "U+1F1FB U+1F1EA" }, VG: { name: "British Virgin Islands", native: "British Virgin Islands", phone: "1284", continent: "NA", capital: "Road Town", currency: "USD", languages: ["en"], emoji: "🇻🇬", emojiU: "U+1F1FB U+1F1EC" }, VI: { name: "U.S. Virgin Islands", native: "United States Virgin Islands", phone: "1340", continent: "NA", capital: "Charlotte Amalie", currency: "USD", languages: ["en"], emoji: "🇻🇮", emojiU: "U+1F1FB U+1F1EE" }, VN: { name: "Vietnam", native: "Việt Nam", phone: "84", continent: "AS", capital: "Hanoi", currency: "VND", languages: ["vi"], emoji: "🇻🇳", emojiU: "U+1F1FB U+1F1F3" }, VU: { name: "Vanuatu", native: "Vanuatu", phone: "678", continent: "OC", capital: "Port Vila", currency: "VUV", languages: ["bi", "en", "fr"], emoji: "🇻🇺", emojiU: "U+1F1FB U+1F1FA" }, WF: { name: "Wallis and Futuna", native: "Wallis et Futuna", phone: "681", continent: "OC", capital: "Mata-Utu", currency: "XPF", languages: ["fr"], emoji: "🇼🇫", emojiU: "U+1F1FC U+1F1EB" }, WS: { name: "Samoa", native: "Samoa", phone: "685", continent: "OC", capital: "Apia", currency: "WST", languages: ["sm", "en"], emoji: "🇼🇸", emojiU: "U+1F1FC U+1F1F8" }, XK: { name: "Kosovo", native: "Republika e Kosovës", phone: "377,381,383,386", continent: "EU", capital: "Pristina", currency: "EUR", languages: ["sq", "sr"], emoji: "🇽🇰", emojiU: "U+1F1FD U+1F1F0" }, YE: { name: "Yemen", native: "اليَمَن", phone: "967", continent: "AS", capital: "Sana'a", currency: "YER", languages: ["ar"], emoji: "🇾🇪", emojiU: "U+1F1FE U+1F1EA" }, YT: { name: "Mayotte", native: "Mayotte", phone: "262", continent: "AF", capital: "Mamoudzou", currency: "EUR", languages: ["fr"], emoji: "🇾🇹", emojiU: "U+1F1FE U+1F1F9" }, ZA: { name: "South Africa", native: "South Africa", phone: "27", continent: "AF", capital: "Pretoria", currency: "ZAR", languages: ["af", "en", "nr", "st", "ss", "tn", "ts", "ve", "xh", "zu"], emoji: "🇿🇦", emojiU: "U+1F1FF U+1F1E6" }, ZM: { name: "Zambia", native: "Zambia", phone: "260", continent: "AF", capital: "Lusaka", currency: "ZMW", languages: ["en"], emoji: "🇿🇲", emojiU: "U+1F1FF U+1F1F2" }, ZW: { name: "Zimbabwe", native: "Zimbabwe", phone: "263", continent: "AF", capital: "Harare", currency: "USD,ZAR,BWP,GBP,AUD,CNY,INR,JPY", languages: ["en", "sn", "nd"], emoji: "🇿🇼", emojiU: "U+1F1FF U+1F1FC" } }, e2 = { af: { name: "Afrikaans", native: "Afrikaans" }, am: { name: "Amharic", native: "አማርኛ" }, ar: { name: "Arabic", native: "العربية", rtl: 1 }, ay: { name: "Aymara", native: "Aymar" }, az: { name: "Azerbaijani", native: "Azərbaycanca / آذربايجان" }, be: { name: "Belarusian", native: "Беларуская" }, bg: { name: "Bulgarian", native: "Български" }, bi: { name: "Bislama", native: "Bislama" }, bn: { name: "Bengali", native: "বাংলা" }, bs: { name: "Bosnian", native: "Bosanski" }, ca: { name: "Catalan", native: "Català" }, ch: { name: "Chamorro", native: "Chamoru" }, cs: { name: "Czech", native: "Čeština" }, da: { name: "Danish", native: "Dansk" }, de: { name: "German", native: "Deutsch" }, dv: { name: "Divehi", native: "ދިވެހިބަސް", rtl: 1 }, dz: { name: "Dzongkha", native: "ཇོང་ཁ" }, el: { name: "Greek", native: "Ελληνικά" }, en: { name: "English", native: "English" }, es: { name: "Spanish", native: "Español" }, et: { name: "Estonian", native: "Eesti" }, eu: { name: "Basque", native: "Euskara" }, fa: { name: "Persian", native: "فارسی", rtl: 1 }, ff: { name: "Peul", native: "Fulfulde" }, fi: { name: "Finnish", native: "Suomi" }, fj: { name: "Fijian", native: "Na Vosa Vakaviti" }, fo: { name: "Faroese", native: "Føroyskt" }, fr: { name: "French", native: "Français" }, ga: { name: "Irish", native: "Gaeilge" }, gl: { name: "Galician", native: "Galego" }, gn: { name: "Guarani", native: "Avañe'ẽ" }, gv: { name: "Manx", native: "Gaelg" }, he: { name: "Hebrew", native: "עברית", rtl: 1 }, hi: { name: "Hindi", native: "हिन्दी" }, hr: { name: "Croatian", native: "Hrvatski" }, ht: { name: "Haitian", native: "Krèyol ayisyen" }, hu: { name: "Hungarian", native: "Magyar" }, hy: { name: "Armenian", native: "Հայերեն" }, id: { name: "Indonesian", native: "Bahasa Indonesia" }, is: { name: "Icelandic", native: "Íslenska" }, it: { name: "Italian", native: "Italiano" }, ja: { name: "Japanese", native: "日本語" }, ka: { name: "Georgian", native: "ქართული" }, kg: { name: "Kongo", native: "KiKongo" }, kk: { name: "Kazakh", native: "Қазақша" }, kl: { name: "Greenlandic", native: "Kalaallisut" }, km: { name: "Cambodian", native: "ភាសាខ្មែរ" }, ko: { name: "Korean", native: "한국어" }, ku: { name: "Kurdish", native: "Kurdî / كوردی", rtl: 1 }, ky: { name: "Kyrgyz", native: "Кыргызча" }, la: { name: "Latin", native: "Latina" }, lb: { name: "Luxembourgish", native: "Lëtzebuergesch" }, ln: { name: "Lingala", native: "Lingála" }, lo: { name: "Laotian", native: "ລາວ / Pha xa lao" }, lt: { name: "Lithuanian", native: "Lietuvių" }, lu: { name: "Luba-Katanga", native: "Tshiluba" }, lv: { name: "Latvian", native: "Latviešu" }, mg: { name: "Malagasy", native: "Malagasy" }, mh: { name: "Marshallese", native: "Kajin Majel / Ebon" }, mi: { name: "Maori", native: "Māori" }, mk: { name: "Macedonian", native: "Македонски" }, mn: { name: "Mongolian", native: "Монгол" }, ms: { name: "Malay", native: "Bahasa Melayu" }, mt: { name: "Maltese", native: "bil-Malti" }, my: { name: "Burmese", native: "မြန်မာစာ" }, na: { name: "Nauruan", native: "Dorerin Naoero" }, nb: { name: "Norwegian Bokmål", native: "Norsk bokmål" }, nd: { name: "North Ndebele", native: "Sindebele" }, ne: { name: "Nepali", native: "नेपाली" }, nl: { name: "Dutch", native: "Nederlands" }, nn: { name: "Norwegian Nynorsk", native: "Norsk nynorsk" }, no: { name: "Norwegian", native: "Norsk" }, nr: { name: "South Ndebele", native: "isiNdebele" }, ny: { name: "Chichewa", native: "Chi-Chewa" }, oc: { name: "Occitan", native: "Occitan" }, pa: { name: "Panjabi / Punjabi", native: "ਪੰਜਾਬੀ / पंजाबी / پنجابي" }, pl: { name: "Polish", native: "Polski" }, ps: { name: "Pashto", native: "پښتو", rtl: 1 }, pt: { name: "Portuguese", native: "Português" }, qu: { name: "Quechua", native: "Runa Simi" }, rn: { name: "Kirundi", native: "Kirundi" }, ro: { name: "Romanian", native: "Română" }, ru: { name: "Russian", native: "Русский" }, rw: { name: "Rwandi", native: "Kinyarwandi" }, sg: { name: "Sango", native: "Sängö" }, si: { name: "Sinhalese", native: "සිංහල" }, sk: { name: "Slovak", native: "Slovenčina" }, sl: { name: "Slovenian", native: "Slovenščina" }, sm: { name: "Samoan", native: "Gagana Samoa" }, sn: { name: "Shona", native: "chiShona" }, so: { name: "Somalia", native: "Soomaaliga" }, sq: { name: "Albanian", native: "Shqip" }, sr: { name: "Serbian", native: "Српски" }, ss: { name: "Swati", native: "SiSwati" }, st: { name: "Southern Sotho", native: "Sesotho" }, sv: { name: "Swedish", native: "Svenska" }, sw: { name: "Swahili", native: "Kiswahili" }, ta: { name: "Tamil", native: "தமிழ்" }, tg: { name: "Tajik", native: "Тоҷикӣ" }, th: { name: "Thai", native: "ไทย / Phasa Thai" }, ti: { name: "Tigrinya", native: "ትግርኛ" }, tk: { name: "Turkmen", native: "Туркмен / تركمن" }, tn: { name: "Tswana", native: "Setswana" }, to: { name: "Tonga", native: "Lea Faka-Tonga" }, tr: { name: "Turkish", native: "Türkçe" }, ts: { name: "Tsonga", native: "Xitsonga" }, uk: { name: "Ukrainian", native: "Українська" }, ur: { name: "Urdu", native: "اردو", rtl: 1 }, uz: { name: "Uzbek", native: "Ўзбек" }, ve: { name: "Venda", native: "Tshivenḓa" }, vi: { name: "Vietnamese", native: "Tiếng Việt" }, xh: { name: "Xhosa", native: "isiXhosa" }, zh: { name: "Chinese", native: "中文" }, zu: { name: "Zulu", native: "isiZulu" } }, i = { aa: { name: "Afar", native: "Afar" }, ab: { name: "Abkhazian", native: "Аҧсуа" }, af: { name: "Afrikaans", native: "Afrikaans" }, ak: { name: "Akan", native: "Akana" }, am: { name: "Amharic", native: "አማርኛ" }, an: { name: "Aragonese", native: "Aragonés" }, ar: { name: "Arabic", native: "العربية", rtl: 1 }, as: { name: "Assamese", native: "অসমীয়া" }, av: { name: "Avar", native: "Авар" }, ay: { name: "Aymara", native: "Aymar" }, az: { name: "Azerbaijani", native: "Azərbaycanca / آذربايجان" }, ba: { name: "Bashkir", native: "Башҡорт" }, be: { name: "Belarusian", native: "Беларуская" }, bg: { name: "Bulgarian", native: "Български" }, bh: { name: "Bihari", native: "भोजपुरी" }, bi: { name: "Bislama", native: "Bislama" }, bm: { name: "Bambara", native: "Bamanankan" }, bn: { name: "Bengali", native: "বাংলা" }, bo: { name: "Tibetan", native: "བོད་ཡིག / Bod skad" }, br: { name: "Breton", native: "Brezhoneg" }, bs: { name: "Bosnian", native: "Bosanski" }, ca: { name: "Catalan", native: "Català" }, ce: { name: "Chechen", native: "Нохчийн" }, ch: { name: "Chamorro", native: "Chamoru" }, co: { name: "Corsican", native: "Corsu" }, cr: { name: "Cree", native: "Nehiyaw" }, cs: { name: "Czech", native: "Čeština" }, cu: { name: "Old Church Slavonic / Old Bulgarian", native: "словѣньскъ / slověnĭskŭ" }, cv: { name: "Chuvash", native: "Чăваш" }, cy: { name: "Welsh", native: "Cymraeg" }, da: { name: "Danish", native: "Dansk" }, de: { name: "German", native: "Deutsch" }, dv: { name: "Divehi", native: "ދިވެހިބަސް", rtl: 1 }, dz: { name: "Dzongkha", native: "ཇོང་ཁ" }, ee: { name: "Ewe", native: "Ɛʋɛ" }, el: { name: "Greek", native: "Ελληνικά" }, en: { name: "English", native: "English" }, eo: { name: "Esperanto", native: "Esperanto" }, es: { name: "Spanish", native: "Español" }, et: { name: "Estonian", native: "Eesti" }, eu: { name: "Basque", native: "Euskara" }, fa: { name: "Persian", native: "فارسی", rtl: 1 }, ff: { name: "Peul", native: "Fulfulde" }, fi: { name: "Finnish", native: "Suomi" }, fj: { name: "Fijian", native: "Na Vosa Vakaviti" }, fo: { name: "Faroese", native: "Føroyskt" }, fr: { name: "French", native: "Français" }, fy: { name: "West Frisian", native: "Frysk" }, ga: { name: "Irish", native: "Gaeilge" }, gd: { name: "Scottish Gaelic", native: "Gàidhlig" }, gl: { name: "Galician", native: "Galego" }, gn: { name: "Guarani", native: "Avañe'ẽ" }, gu: { name: "Gujarati", native: "ગુજરાતી" }, gv: { name: "Manx", native: "Gaelg" }, ha: { name: "Hausa", native: "هَوُسَ", rtl: 1 }, he: { name: "Hebrew", native: "עברית", rtl: 1 }, hi: { name: "Hindi", native: "हिन्दी" }, ho: { name: "Hiri Motu", native: "Hiri Motu" }, hr: { name: "Croatian", native: "Hrvatski" }, ht: { name: "Haitian", native: "Krèyol ayisyen" }, hu: { name: "Hungarian", native: "Magyar" }, hy: { name: "Armenian", native: "Հայերեն" }, hz: { name: "Herero", native: "Otsiherero" }, ia: { name: "Interlingua", native: "Interlingua" }, id: { name: "Indonesian", native: "Bahasa Indonesia" }, ie: { name: "Interlingue", native: "Interlingue" }, ig: { name: "Igbo", native: "Igbo" }, ii: { name: "Sichuan Yi", native: "ꆇꉙ / 四川彝语" }, ik: { name: "Inupiak", native: "Iñupiak" }, io: { name: "Ido", native: "Ido" }, is: { name: "Icelandic", native: "Íslenska" }, it: { name: "Italian", native: "Italiano" }, iu: { name: "Inuktitut", native: "ᐃᓄᒃᑎᑐᑦ" }, ja: { name: "Japanese", native: "日本語" }, jv: { name: "Javanese", native: "Basa Jawa" }, ka: { name: "Georgian", native: "ქართული" }, kg: { name: "Kongo", native: "KiKongo" }, ki: { name: "Kikuyu", native: "Gĩkũyũ" }, kj: { name: "Kuanyama", native: "Kuanyama" }, kk: { name: "Kazakh", native: "Қазақша" }, kl: { name: "Greenlandic", native: "Kalaallisut" }, km: { name: "Cambodian", native: "ភាសាខ្មែរ" }, kn: { name: "Kannada", native: "ಕನ್ನಡ" }, ko: { name: "Korean", native: "한국어" }, kr: { name: "Kanuri", native: "Kanuri" }, ks: { name: "Kashmiri", native: "कश्मीरी / كشميري", rtl: 1 }, ku: { name: "Kurdish", native: "Kurdî / كوردی", rtl: 1 }, kv: { name: "Komi", native: "Коми" }, kw: { name: "Cornish", native: "Kernewek" }, ky: { name: "Kyrgyz", native: "Кыргызча" }, la: { name: "Latin", native: "Latina" }, lb: { name: "Luxembourgish", native: "Lëtzebuergesch" }, lg: { name: "Ganda", native: "Luganda" }, li: { name: "Limburgian", native: "Limburgs" }, ln: { name: "Lingala", native: "Lingála" }, lo: { name: "Laotian", native: "ລາວ / Pha xa lao" }, lt: { name: "Lithuanian", native: "Lietuvių" }, lu: { name: "Luba-Katanga", native: "Tshiluba" }, lv: { name: "Latvian", native: "Latviešu" }, mg: { name: "Malagasy", native: "Malagasy" }, mh: { name: "Marshallese", native: "Kajin Majel / Ebon" }, mi: { name: "Maori", native: "Māori" }, mk: { name: "Macedonian", native: "Македонски" }, ml: { name: "Malayalam", native: "മലയാളം" }, mn: { name: "Mongolian", native: "Монгол" }, mo: { name: "Moldovan", native: "Moldovenească" }, mr: { name: "Marathi", native: "मराठी" }, ms: { name: "Malay", native: "Bahasa Melayu" }, mt: { name: "Maltese", native: "bil-Malti" }, my: { name: "Burmese", native: "မြန်မာစာ" }, na: { name: "Nauruan", native: "Dorerin Naoero" }, nb: { name: "Norwegian Bokmål", native: "Norsk bokmål" }, nd: { name: "North Ndebele", native: "Sindebele" }, ne: { name: "Nepali", native: "नेपाली" }, ng: { name: "Ndonga", native: "Oshiwambo" }, nl: { name: "Dutch", native: "Nederlands" }, nn: { name: "Norwegian Nynorsk", native: "Norsk nynorsk" }, no: { name: "Norwegian", native: "Norsk" }, nr: { name: "South Ndebele", native: "isiNdebele" }, nv: { name: "Navajo", native: "Diné bizaad" }, ny: { name: "Chichewa", native: "Chi-Chewa" }, oc: { name: "Occitan", native: "Occitan" }, oj: { name: "Ojibwa", native: "ᐊᓂᔑᓈᐯᒧᐎᓐ / Anishinaabemowin" }, om: { name: "Oromo", native: "Oromoo" }, or: { name: "Oriya", native: "ଓଡ଼ିଆ" }, os: { name: "Ossetian / Ossetic", native: "Иронау" }, pa: { name: "Panjabi / Punjabi", native: "ਪੰਜਾਬੀ / पंजाबी / پنجابي" }, pi: { name: "Pali", native: "Pāli / पाऴि" }, pl: { name: "Polish", native: "Polski" }, ps: { name: "Pashto", native: "پښتو", rtl: 1 }, pt: { name: "Portuguese", native: "Português" }, qu: { name: "Quechua", native: "Runa Simi" }, rm: { name: "Raeto Romance", native: "Rumantsch" }, rn: { name: "Kirundi", native: "Kirundi" }, ro: { name: "Romanian", native: "Română" }, ru: { name: "Russian", native: "Русский" }, rw: { name: "Rwandi", native: "Kinyarwandi" }, sa: { name: "Sanskrit", native: "संस्कृतम्" }, sc: { name: "Sardinian", native: "Sardu" }, sd: { name: "Sindhi", native: "सिनधि" }, se: { name: "Northern Sami", native: "Sámegiella" }, sg: { name: "Sango", native: "Sängö" }, sh: { name: "Serbo-Croatian", native: "Srpskohrvatski / Српскохрватски" }, si: { name: "Sinhalese", native: "සිංහල" }, sk: { name: "Slovak", native: "Slovenčina" }, sl: { name: "Slovenian", native: "Slovenščina" }, sm: { name: "Samoan", native: "Gagana Samoa" }, sn: { name: "Shona", native: "chiShona" }, so: { name: "Somalia", native: "Soomaaliga" }, sq: { name: "Albanian", native: "Shqip" }, sr: { name: "Serbian", native: "Српски" }, ss: { name: "Swati", native: "SiSwati" }, st: { name: "Southern Sotho", native: "Sesotho" }, su: { name: "Sundanese", native: "Basa Sunda" }, sv: { name: "Swedish", native: "Svenska" }, sw: { name: "Swahili", native: "Kiswahili" }, ta: { name: "Tamil", native: "தமிழ்" }, te: { name: "Telugu", native: "తెలుగు" }, tg: { name: "Tajik", native: "Тоҷикӣ" }, th: { name: "Thai", native: "ไทย / Phasa Thai" }, ti: { name: "Tigrinya", native: "ትግርኛ" }, tk: { name: "Turkmen", native: "Туркмен / تركمن" }, tl: { name: "Tagalog / Filipino", native: "Tagalog" }, tn: { name: "Tswana", native: "Setswana" }, to: { name: "Tonga", native: "Lea Faka-Tonga" }, tr: { name: "Turkish", native: "Türkçe" }, ts: { name: "Tsonga", native: "Xitsonga" }, tt: { name: "Tatar", native: "Tatarça" }, tw: { name: "Twi", native: "Twi" }, ty: { name: "Tahitian", native: "Reo Mā`ohi" }, ug: { name: "Uyghur", native: "Uyƣurqə / ئۇيغۇرچە" }, uk: { name: "Ukrainian", native: "Українська" }, ur: { name: "Urdu", native: "اردو", rtl: 1 }, uz: { name: "Uzbek", native: "Ўзбек" }, ve: { name: "Venda", native: "Tshivenḓa" }, vi: { name: "Vietnamese", native: "Tiếng Việt" }, vo: { name: "Volapük", native: "Volapük" }, wa: { name: "Walloon", native: "Walon" }, wo: { name: "Wolof", native: "Wollof" }, xh: { name: "Xhosa", native: "isiXhosa" }, yi: { name: "Yiddish", native: "ייִדיש", rtl: 1 }, yo: { name: "Yoruba", native: "Yorùbá" }, za: { name: "Zhuang", native: "Cuengh / Tôô / 壮语" }, zh: { name: "Chinese", native: "中文" }, zu: { name: "Zulu", native: "isiZulu" } };
    const t2 = 2147483647, o = 36, m2 = /^xn--/, r2 = /[^\0-\x7E]/, c2 = /[\x2E\u3002\uFF0E\uFF61]/g, l2 = { overflow: "Overflow: input needs wider integers to process", "not-basic": "Illegal input >= 0x80 (not a basic code point)", "invalid-input": "Invalid input" }, u2 = Math.floor, F = String.fromCharCode;
    function U(n3) {
      throw new RangeError(l2[n3]);
    }
    function s(n3, a2) {
      const e3 = n3.split("@");
      let i2 = "";
      e3.length > 1 && (i2 = e3[0] + "@", n3 = e3[1]);
      const t3 = function(n4, a3) {
        const e4 = [];
        let i3 = n4.length;
        for (; i3--; )
          e4[i3] = a3(n4[i3]);
        return e4;
      }((n3 = n3.replace(c2, ".")).split("."), a2).join(".");
      return i2 + t3;
    }
    function g2(n3) {
      const a2 = [];
      let e3 = 0;
      const i2 = n3.length;
      for (; e3 < i2; ) {
        const t3 = n3.charCodeAt(e3++);
        if (t3 >= 55296 && t3 <= 56319 && e3 < i2) {
          const i3 = n3.charCodeAt(e3++);
          56320 == (64512 & i3) ? a2.push(((1023 & t3) << 10) + (1023 & i3) + 65536) : (a2.push(t3), e3--);
        } else
          a2.push(t3);
      }
      return a2;
    }
    const v2 = function(n3, a2) {
      return n3 + 22 + 75 * (n3 < 26) - ((0 != a2) << 5);
    }, p2 = function(n3, a2, e3) {
      let i2 = 0;
      for (n3 = e3 ? u2(n3 / 700) : n3 >> 1, n3 += u2(n3 / a2); n3 > 455; i2 += o)
        n3 = u2(n3 / 35);
      return u2(i2 + 36 * n3 / (n3 + 38));
    }, h2 = function(n3) {
      const a2 = [], e3 = n3.length;
      let i2 = 0, m3 = 128, r3 = 72, c3 = n3.lastIndexOf("-");
      c3 < 0 && (c3 = 0);
      for (let e4 = 0; e4 < c3; ++e4)
        n3.charCodeAt(e4) >= 128 && U("not-basic"), a2.push(n3.charCodeAt(e4));
      for (let F2 = c3 > 0 ? c3 + 1 : 0; F2 < e3; ) {
        let c4 = i2;
        for (let a3 = 1, m4 = o; ; m4 += o) {
          F2 >= e3 && U("invalid-input");
          const c5 = (l3 = n3.charCodeAt(F2++)) - 48 < 10 ? l3 - 22 : l3 - 65 < 26 ? l3 - 65 : l3 - 97 < 26 ? l3 - 97 : o;
          (c5 >= o || c5 > u2((t2 - i2) / a3)) && U("overflow"), i2 += c5 * a3;
          const s3 = m4 <= r3 ? 1 : m4 >= r3 + 26 ? 26 : m4 - r3;
          if (c5 < s3)
            break;
          const g3 = o - s3;
          a3 > u2(t2 / g3) && U("overflow"), a3 *= g3;
        }
        const s2 = a2.length + 1;
        r3 = p2(i2 - c4, s2, 0 == c4), u2(i2 / s2) > t2 - m3 && U("overflow"), m3 += u2(i2 / s2), i2 %= s2, a2.splice(i2++, 0, m3);
      }
      var l3;
      return String.fromCodePoint(...a2);
    }, j = function(n3) {
      const a2 = [];
      let e3 = (n3 = g2(n3)).length, i2 = 128, m3 = 0, r3 = 72;
      for (const e4 of n3)
        e4 < 128 && a2.push(F(e4));
      let c3 = a2.length, l3 = c3;
      for (c3 && a2.push("-"); l3 < e3; ) {
        let e4 = t2;
        for (const a3 of n3)
          a3 >= i2 && a3 < e4 && (e4 = a3);
        const s2 = l3 + 1;
        e4 - i2 > u2((t2 - m3) / s2) && U("overflow"), m3 += (e4 - i2) * s2, i2 = e4;
        for (const e5 of n3)
          if (e5 < i2 && ++m3 > t2 && U("overflow"), e5 == i2) {
            let n4 = m3;
            for (let e6 = o; ; e6 += o) {
              const i3 = e6 <= r3 ? 1 : e6 >= r3 + 26 ? 26 : e6 - r3;
              if (n4 < i3)
                break;
              const t3 = n4 - i3, m4 = o - i3;
              a2.push(F(v2(i3 + t3 % m4, 0))), n4 = u2(t3 / m4);
            }
            a2.push(F(v2(n4, 0))), r3 = p2(m3, s2, l3 == c3), m3 = 0, ++l3;
          }
        ++m3, ++i2;
      }
      return a2.join("");
    };
    var E = { version: "2.1.0", ucs2: { decode: g2, encode: (n3) => String.fromCodePoint(...n3) }, decode: h2, encode: j, toASCII: function(n3) {
      return s(n3, function(n4) {
        return r2.test(n4) ? "xn--" + j(n4) : n4;
      });
    }, toUnicode: function(n3) {
      return s(n3, function(n4) {
        return m2.test(n4) ? h2(n4.slice(4).toLowerCase()) : n4;
      });
    } };
    const { ucs2: { decode: y, encode: A } } = E, S = 127462 - "A".charCodeAt(0), d2 = /^[A-Z]{2}$/;
    return { continents: n2, countries: a, languages: e2, languagesAll: i, getEmojiFlag: (n3) => d2.test(n3) ? A(n3.split("").map((n4) => S + n4.charCodeAt(0))) : "", getUnicode: (n3) => y(n3).map((n4) => "U+" + Number(n4).toString(16).toUpperCase()).join(" ") };
  });
})(index_es5_min);
var index_es5_minExports = index_es5_min.exports;
const countries = /* @__PURE__ */ getDefaultExportFromCjs(index_es5_minExports);
var lodash$1 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash$1.exports;
(function(module2, exports) {
  (function() {
    var undefined$1;
    var VERSION = "4.17.21";
    var LARGE_ARRAY_SIZE = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT2 = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT = 800, HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN2 = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex2 = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary2 = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal2 = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reApos = RegExp(rsApos, "g");
    var reComboMark = RegExp(rsCombo, "g");
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag2] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var deburredLetters = {
      // Latin-1 Supplement block.
      "À": "A",
      "Á": "A",
      "Â": "A",
      "Ã": "A",
      "Ä": "A",
      "Å": "A",
      "à": "a",
      "á": "a",
      "â": "a",
      "ã": "a",
      "ä": "a",
      "å": "a",
      "Ç": "C",
      "ç": "c",
      "Ð": "D",
      "ð": "d",
      "È": "E",
      "É": "E",
      "Ê": "E",
      "Ë": "E",
      "è": "e",
      "é": "e",
      "ê": "e",
      "ë": "e",
      "Ì": "I",
      "Í": "I",
      "Î": "I",
      "Ï": "I",
      "ì": "i",
      "í": "i",
      "î": "i",
      "ï": "i",
      "Ñ": "N",
      "ñ": "n",
      "Ò": "O",
      "Ó": "O",
      "Ô": "O",
      "Õ": "O",
      "Ö": "O",
      "Ø": "O",
      "ò": "o",
      "ó": "o",
      "ô": "o",
      "õ": "o",
      "ö": "o",
      "ø": "o",
      "Ù": "U",
      "Ú": "U",
      "Û": "U",
      "Ü": "U",
      "ù": "u",
      "ú": "u",
      "û": "u",
      "ü": "u",
      "Ý": "Y",
      "ý": "y",
      "ÿ": "y",
      "Æ": "Ae",
      "æ": "ae",
      "Þ": "Th",
      "þ": "th",
      "ß": "ss",
      // Latin Extended-A block.
      "Ā": "A",
      "Ă": "A",
      "Ą": "A",
      "ā": "a",
      "ă": "a",
      "ą": "a",
      "Ć": "C",
      "Ĉ": "C",
      "Ċ": "C",
      "Č": "C",
      "ć": "c",
      "ĉ": "c",
      "ċ": "c",
      "č": "c",
      "Ď": "D",
      "Đ": "D",
      "ď": "d",
      "đ": "d",
      "Ē": "E",
      "Ĕ": "E",
      "Ė": "E",
      "Ę": "E",
      "Ě": "E",
      "ē": "e",
      "ĕ": "e",
      "ė": "e",
      "ę": "e",
      "ě": "e",
      "Ĝ": "G",
      "Ğ": "G",
      "Ġ": "G",
      "Ģ": "G",
      "ĝ": "g",
      "ğ": "g",
      "ġ": "g",
      "ģ": "g",
      "Ĥ": "H",
      "Ħ": "H",
      "ĥ": "h",
      "ħ": "h",
      "Ĩ": "I",
      "Ī": "I",
      "Ĭ": "I",
      "Į": "I",
      "İ": "I",
      "ĩ": "i",
      "ī": "i",
      "ĭ": "i",
      "į": "i",
      "ı": "i",
      "Ĵ": "J",
      "ĵ": "j",
      "Ķ": "K",
      "ķ": "k",
      "ĸ": "k",
      "Ĺ": "L",
      "Ļ": "L",
      "Ľ": "L",
      "Ŀ": "L",
      "Ł": "L",
      "ĺ": "l",
      "ļ": "l",
      "ľ": "l",
      "ŀ": "l",
      "ł": "l",
      "Ń": "N",
      "Ņ": "N",
      "Ň": "N",
      "Ŋ": "N",
      "ń": "n",
      "ņ": "n",
      "ň": "n",
      "ŋ": "n",
      "Ō": "O",
      "Ŏ": "O",
      "Ő": "O",
      "ō": "o",
      "ŏ": "o",
      "ő": "o",
      "Ŕ": "R",
      "Ŗ": "R",
      "Ř": "R",
      "ŕ": "r",
      "ŗ": "r",
      "ř": "r",
      "Ś": "S",
      "Ŝ": "S",
      "Ş": "S",
      "Š": "S",
      "ś": "s",
      "ŝ": "s",
      "ş": "s",
      "š": "s",
      "Ţ": "T",
      "Ť": "T",
      "Ŧ": "T",
      "ţ": "t",
      "ť": "t",
      "ŧ": "t",
      "Ũ": "U",
      "Ū": "U",
      "Ŭ": "U",
      "Ů": "U",
      "Ű": "U",
      "Ų": "U",
      "ũ": "u",
      "ū": "u",
      "ŭ": "u",
      "ů": "u",
      "ű": "u",
      "ų": "u",
      "Ŵ": "W",
      "ŵ": "w",
      "Ŷ": "Y",
      "ŷ": "y",
      "Ÿ": "Y",
      "Ź": "Z",
      "Ż": "Z",
      "Ž": "Z",
      "ź": "z",
      "ż": "z",
      "ž": "z",
      "Ĳ": "IJ",
      "ĳ": "ij",
      "Œ": "Oe",
      "œ": "oe",
      "ŉ": "'n",
      "ſ": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt2 = parseInt;
    var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal2.process;
    var nodeUtil = function() {
      try {
        var types2 = freeModule && freeModule.require && freeModule.require("util").types;
        if (types2) {
          return types2;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e2) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        var value = array[index2];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }
    function arrayEach(array, iteratee) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        if (iteratee(array[index2], index2, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEachRight(array, iteratee) {
      var length2 = array == null ? 0 : array.length;
      while (length2--) {
        if (iteratee(array[length2], length2, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEvery(array, predicate) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        if (!predicate(array[index2], index2, array)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter(array, predicate) {
      var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index2 < length2) {
        var value = array[index2];
        if (predicate(value, index2, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayIncludes(array, value) {
      var length2 = array == null ? 0 : array.length;
      return !!length2 && baseIndexOf(array, value, 0) > -1;
    }
    function arrayIncludesWith(array, value, comparator) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        if (comparator(value, array[index2])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap(array, iteratee) {
      var index2 = -1, length2 = array == null ? 0 : array.length, result = Array(length2);
      while (++index2 < length2) {
        result[index2] = iteratee(array[index2], index2, array);
      }
      return result;
    }
    function arrayPush(array, values2) {
      var index2 = -1, length2 = values2.length, offset2 = array.length;
      while (++index2 < length2) {
        array[offset2 + index2] = values2[index2];
      }
      return array;
    }
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      if (initAccum && length2) {
        accumulator = array[++index2];
      }
      while (++index2 < length2) {
        accumulator = iteratee(accumulator, array[index2], index2, array);
      }
      return accumulator;
    }
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length2 = array == null ? 0 : array.length;
      if (initAccum && length2) {
        accumulator = array[--length2];
      }
      while (length2--) {
        accumulator = iteratee(accumulator, array[length2], length2, array);
      }
      return accumulator;
    }
    function arraySome(array, predicate) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        if (predicate(array[index2], index2, array)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty("length");
    function asciiToArray(string2) {
      return string2.split("");
    }
    function asciiWords(string2) {
      return string2.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value, key, collection2) {
        if (predicate(value, key, collection2)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length2 = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index2-- : ++index2 < length2) {
        if (predicate(array[index2], index2, array)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index2 = fromIndex - 1, length2 = array.length;
      while (++index2 < length2) {
        if (comparator(array[index2], value)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array, iteratee) {
      var length2 = array == null ? 0 : array.length;
      return length2 ? baseSum(array, iteratee) / length2 : NAN2;
    }
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function basePropertyOf(object) {
      return function(key) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index2, collection2) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array, comparer) {
      var length2 = array.length;
      array.sort(comparer);
      while (length2--) {
        array[length2] = array[length2].value;
      }
      return array;
    }
    function baseSum(array, iteratee) {
      var result, index2 = -1, length2 = array.length;
      while (++index2 < length2) {
        var current = iteratee(array[index2]);
        if (current !== undefined$1) {
          result = result === undefined$1 ? current : result + current;
        }
      }
      return result;
    }
    function baseTimes(n2, iteratee) {
      var index2 = -1, result = Array(n2);
      while (++index2 < n2) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseToPairs(object, props) {
      return arrayMap(props, function(key) {
        return [key, object[key]];
      });
    }
    function baseTrim(string2) {
      return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function baseValues(object, props) {
      return arrayMap(props, function(key) {
        return object[key];
      });
    }
    function cacheHas(cache2, key) {
      return cache2.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index2 = -1, length2 = strSymbols.length;
      while (++index2 < length2 && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index2 = strSymbols.length;
      while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function countHolders(array, placeholder) {
      var length2 = array.length, result = 0;
      while (length2--) {
        if (array[length2] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue2(object, key) {
      return object == null ? undefined$1 : object[key];
    }
    function hasUnicode(string2) {
      return reHasUnicode.test(string2);
    }
    function hasUnicodeWord(string2) {
      return reHasUnicodeWord.test(string2);
    }
    function iteratorToArray(iterator) {
      var data, result = [];
      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }
      return result;
    }
    function mapToArray(map2) {
      var index2 = -1, result = Array(map2.size);
      map2.forEach(function(value, key) {
        result[++index2] = [key, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array, placeholder) {
      var index2 = -1, length2 = array.length, resIndex = 0, result = [];
      while (++index2 < length2) {
        var value = array[index2];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index2] = PLACEHOLDER;
          result[resIndex++] = index2;
        }
      }
      return result;
    }
    function setToArray(set2) {
      var index2 = -1, result = Array(set2.size);
      set2.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    function setToPairs(set2) {
      var index2 = -1, result = Array(set2.size);
      set2.forEach(function(value) {
        result[++index2] = [value, value];
      });
      return result;
    }
    function strictIndexOf(array, value, fromIndex) {
      var index2 = fromIndex - 1, length2 = array.length;
      while (++index2 < length2) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array, value, fromIndex) {
      var index2 = fromIndex + 1;
      while (index2--) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return index2;
    }
    function stringSize(string2) {
      return hasUnicode(string2) ? unicodeSize(string2) : asciiSize(string2);
    }
    function stringToArray(string2) {
      return hasUnicode(string2) ? unicodeToArray(string2) : asciiToArray(string2);
    }
    function trimmedEndIndex(string2) {
      var index2 = string2.length;
      while (index2-- && reWhitespace.test(string2.charAt(index2))) {
      }
      return index2;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string2) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string2)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray(string2) {
      return string2.match(reUnicode) || [];
    }
    function unicodeWords(string2) {
      return string2.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root2 : _.defaults(root2.Object(), context, _.pick(root2, contextProps));
      var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto2 = Object2.prototype;
      var coreJsData = context["__core-js_shared__"];
      var funcToString = funcProto.toString;
      var hasOwnProperty2 = objectProto2.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString = objectProto2.toString;
      var objectCtorString = funcToString.call(Object2);
      var oldDash = root2._;
      var reIsNative = RegExp2(
        "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      );
      var Buffer2 = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined$1, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto2.propertyIsEnumerable, splice2 = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$1;
      var defineProperty2 = function() {
        try {
          var func = getNative(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e2) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root2.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root2.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root2.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax2 = Math2.max, nativeMin2 = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
      var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
      var metaMap = WeakMap2 && new WeakMap2();
      var realNames = {};
      var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
      var symbolProto = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString = symbolProto ? symbolProto.toString : undefined$1;
      function lodash2(value) {
        if (isObjectLike2(value) && !isArray3(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty2.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate = function() {
        function object() {
        }
        return function(proto2) {
          if (!isObject2(proto2)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto2);
          }
          object.prototype = proto2;
          var result2 = new object();
          object.prototype = undefined$1;
          return result2;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash2.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "escape": reEscape,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "evaluate": reEvaluate,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "interpolate": reInterpolate,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        "variable": "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        "imports": {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result2 = new LazyWrapper(this.__wrapped__);
        result2.__actions__ = copyArray(this.__actions__);
        result2.__dir__ = this.__dir__;
        result2.__filtered__ = this.__filtered__;
        result2.__iteratees__ = copyArray(this.__iteratees__);
        result2.__takeCount__ = this.__takeCount__;
        result2.__views__ = copyArray(this.__views__);
        return result2;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result2 = new LazyWrapper(this);
          result2.__dir__ = -1;
          result2.__filtered__ = true;
        } else {
          result2 = this.clone();
          result2.__dir__ *= -1;
        }
        return result2;
      }
      function lazyValue() {
        var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray3(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length2 = end - start, index2 = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin2(length2, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length2 && takeCount == length2) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result2 = [];
        outer:
          while (length2-- && resIndex < takeCount) {
            index2 += dir;
            var iterIndex = -1, value = array[index2];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result2[resIndex++] = value;
          }
        return result2;
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      function hashDelete(key) {
        var result2 = this.has(key) && delete this.__data__[key];
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result2 = data[key];
          return result2 === HASH_UNDEFINED ? undefined$1 : result2;
        }
        return hasOwnProperty2.call(data, key) ? data[key] : undefined$1;
      }
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty2.call(data, key);
      }
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
        return this;
      }
      Hash.prototype.clear = hashClear;
      Hash.prototype["delete"] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      function ListCache(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index2 == lastIndex) {
          data.pop();
        } else {
          splice2.call(data, index2, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        return index2 < 0 ? undefined$1 : data[index2][1];
      }
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      function listCacheSet(key, value) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index2][1] = value;
        }
        return this;
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype["delete"] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      function MapCache(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash(),
          "map": new (Map2 || ListCache)(),
          "string": new Hash()
        };
      }
      function mapCacheDelete(key) {
        var result2 = getMapData(this, key)["delete"](key);
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      function mapCacheSet(key, value) {
        var data = getMapData(this, key), size2 = data.size;
        data.set(key, value);
        this.size += data.size == size2 ? 0 : 1;
        return this;
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype["delete"] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      function SetCache(values3) {
        var index2 = -1, length2 = values3 == null ? 0 : values3.length;
        this.__data__ = new MapCache();
        while (++index2 < length2) {
          this.add(values3[index2]);
        }
      }
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }
      function setCacheHas(value) {
        return this.__data__.has(value);
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      function Stack2(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      function stackDelete(key) {
        var data = this.__data__, result2 = data["delete"](key);
        this.size = data.size;
        return result2;
      }
      function stackGet(key) {
        return this.__data__.get(key);
      }
      function stackHas(key) {
        return this.__data__.has(key);
      }
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      Stack2.prototype.clear = stackClear;
      Stack2.prototype["delete"] = stackDelete;
      Stack2.prototype.get = stackGet;
      Stack2.prototype.has = stackHas;
      Stack2.prototype.set = stackSet;
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray3(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer3(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length2 = result2.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
          (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
          isIndex(key, length2)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function arraySample(array) {
        var length2 = array.length;
        return length2 ? array[baseRandom(0, length2 - 1)] : undefined$1;
      }
      function arraySampleSize(array, n2) {
        return shuffleSelf(copyArray(array), baseClamp(n2, 0, array.length));
      }
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }
      function assignMergeValue(object, key, value) {
        if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty2.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assocIndexOf(array, key) {
        var length2 = array.length;
        while (length2--) {
          if (eq(array[length2][0], key)) {
            return length2;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee2(value), collection2);
        });
        return accumulator;
      }
      function baseAssign(object, source) {
        return object && copyObject(source, keys2(source), object);
      }
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }
      function baseAssignValue(object, key, value) {
        if (key == "__proto__" && defineProperty2) {
          defineProperty2(object, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object[key] = value;
        }
      }
      function baseAt(object, paths) {
        var index2 = -1, length2 = paths.length, result2 = Array2(length2), skip = object == null;
        while (++index2 < length2) {
          result2[index2] = skip ? undefined$1 : get2(object, paths[index2]);
        }
        return result2;
      }
      function baseClamp(number2, lower, upper) {
        if (number2 === number2) {
          if (upper !== undefined$1) {
            number2 = number2 <= upper ? number2 : upper;
          }
          if (lower !== undefined$1) {
            number2 = number2 >= lower ? number2 : lower;
          }
        }
        return number2;
      }
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result2 = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result2 !== undefined$1) {
          return result2;
        }
        if (!isObject2(value)) {
          return value;
        }
        var isArr = isArray3(value);
        if (isArr) {
          result2 = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result2);
          }
        } else {
          var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
          if (isBuffer3(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result2 = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result2 = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack2());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result2);
        if (isSet(value)) {
          value.forEach(function(subValue) {
            result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function(subValue, key2) {
            result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys2;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
        });
        return result2;
      }
      function baseConforms(source) {
        var props = keys2(source);
        return function(object) {
          return baseConformsTo(object, source, props);
        };
      }
      function baseConformsTo(object, source, props) {
        var length2 = props.length;
        if (object == null) {
          return !length2;
        }
        object = Object2(object);
        while (length2--) {
          var key = props[length2], predicate = source[key], value = object[key];
          if (value === undefined$1 && !(key in object) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        return setTimeout2(function() {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array, values3, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, isCommon = true, length2 = array.length, result2 = [], valuesLength = values3.length;
        if (!length2) {
          return result2;
        }
        if (iteratee2) {
          values3 = arrayMap(values3, baseUnary(iteratee2));
        }
        if (comparator) {
          includes2 = arrayIncludesWith;
          isCommon = false;
        } else if (values3.length >= LARGE_ARRAY_SIZE) {
          includes2 = cacheHas;
          isCommon = false;
          values3 = new SetCache(values3);
        }
        outer:
          while (++index2 < length2) {
            var value = array[index2], computed = iteratee2 == null ? value : iteratee2(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values3[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result2.push(value);
            } else if (!includes2(values3, computed, comparator)) {
              result2.push(value);
            }
          }
        return result2;
      }
      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result2 = true;
        baseEach(collection, function(value, index2, collection2) {
          result2 = !!predicate(value, index2, collection2);
          return result2;
        });
        return result2;
      }
      function baseExtremum(array, iteratee2, comparator) {
        var index2 = -1, length2 = array.length;
        while (++index2 < length2) {
          var value = array[index2], current = iteratee2(value);
          if (current != null && (computed === undefined$1 ? current === current && !isSymbol2(current) : comparator(current, computed))) {
            var computed = current, result2 = value;
          }
        }
        return result2;
      }
      function baseFill(array, value, start, end) {
        var length2 = array.length;
        start = toInteger(start);
        if (start < 0) {
          start = -start > length2 ? 0 : length2 + start;
        }
        end = end === undefined$1 || end > length2 ? length2 : toInteger(end);
        if (end < 0) {
          end += length2;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array[start++] = value;
        }
        return array;
      }
      function baseFilter(collection, predicate) {
        var result2 = [];
        baseEach(collection, function(value, index2, collection2) {
          if (predicate(value, index2, collection2)) {
            result2.push(value);
          }
        });
        return result2;
      }
      function baseFlatten(array, depth, predicate, isStrict, result2) {
        var index2 = -1, length2 = array.length;
        predicate || (predicate = isFlattenable);
        result2 || (result2 = []);
        while (++index2 < length2) {
          var value = array[index2];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result2);
            } else {
              arrayPush(result2, value);
            }
          } else if (!isStrict) {
            result2[result2.length] = value;
          }
        }
        return result2;
      }
      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);
      function baseForOwn(object, iteratee2) {
        return object && baseFor(object, iteratee2, keys2);
      }
      function baseForOwnRight(object, iteratee2) {
        return object && baseForRight(object, iteratee2, keys2);
      }
      function baseFunctions(object, props) {
        return arrayFilter(props, function(key) {
          return isFunction2(object[key]);
        });
      }
      function baseGet2(object, path2) {
        path2 = castPath(path2, object);
        var index2 = 0, length2 = path2.length;
        while (object != null && index2 < length2) {
          object = object[toKey(path2[index2++])];
        }
        return index2 && index2 == length2 ? object : undefined$1;
      }
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result2 = keysFunc(object);
        return isArray3(object) ? result2 : arrayPush(result2, symbolsFunc(object));
      }
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString2(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas(object, key) {
        return object != null && hasOwnProperty2.call(object, key);
      }
      function baseHasIn(object, key) {
        return object != null && key in Object2(object);
      }
      function baseInRange(number2, start, end) {
        return number2 >= nativeMin2(start, end) && number2 < nativeMax2(start, end);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length2 = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee2) {
            array = arrayMap(array, baseUnary(iteratee2));
          }
          maxLength = nativeMin2(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length2 >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
        }
        array = arrays[0];
        var index2 = -1, seen = caches[0];
        outer:
          while (++index2 < length2 && result2.length < maxLength) {
            var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache2 = caches[othIndex];
                if (!(cache2 ? cacheHas(cache2, computed) : includes2(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseInverter(object, setter, iteratee2, accumulator) {
        baseForOwn(object, function(value, key, object2) {
          setter(accumulator, iteratee2(value), key, object2);
        });
        return accumulator;
      }
      function baseInvoke(object, path2, args) {
        path2 = castPath(path2, object);
        object = parent(object, path2);
        var func = object == null ? object : object[toKey(last(path2))];
        return func == null ? undefined$1 : apply(func, object, args);
      }
      function baseIsArguments(value) {
        return isObjectLike2(value) && baseGetTag(value) == argsTag;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike2(value) && baseGetTag(value) == arrayBufferTag;
      }
      function baseIsDate(value) {
        return isObjectLike2(value) && baseGetTag(value) == dateTag;
      }
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike2(value) && !isObjectLike2(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray3(object), othIsArr = isArray3(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer3(object)) {
          if (!isBuffer3(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack2());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack2());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack2());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap(value) {
        return isObjectLike2(value) && getTag(value) == mapTag;
      }
      function baseIsMatch(object, source, matchData, customizer) {
        var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
        if (object == null) {
          return !length2;
        }
        object = Object2(object);
        while (index2--) {
          var data = matchData[index2];
          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }
        while (++index2 < length2) {
          data = matchData[index2];
          var key = data[0], objValue = object[key], srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack2();
            if (customizer) {
              var result2 = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result2 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative(value) {
        if (!isObject2(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction2(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike2(value) && baseGetTag(value) == regexpTag;
      }
      function baseIsSet(value) {
        return isObjectLike2(value) && getTag(value) == setTag;
      }
      function baseIsTypedArray(value) {
        return isObjectLike2(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      function baseIteratee(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == "object") {
          return isArray3(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result2 = [];
        for (var key in Object2(object)) {
          if (hasOwnProperty2.call(object, key) && key != "constructor") {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseKeysIn(object) {
        if (!isObject2(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object), result2 = [];
        for (var key in object) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object, key)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap(collection, iteratee2) {
        var index2 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value, key, collection2) {
          result2[++index2] = iteratee2(value, key, collection2);
        });
        return result2;
      }
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }
      function baseMatchesProperty(path2, srcValue) {
        if (isKey2(path2) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path2), srcValue);
        }
        return function(object) {
          var objValue = get2(object, path2);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path2) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function(srcValue, key) {
          stack || (stack = new Stack2());
          if (isObject2(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray3(srcValue), isBuff = !isArr && isBuffer3(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray3(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject3(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject2(objValue) || isFunction2(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      function baseNth(array, n2) {
        var length2 = array.length;
        if (!length2) {
          return;
        }
        n2 += n2 < 0 ? length2 : 0;
        return isIndex(n2, length2) ? array[n2] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function(iteratee2) {
            if (isArray3(iteratee2)) {
              return function(value) {
                return baseGet2(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity];
        }
        var index2 = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result2 = baseMap(collection, function(value, key, collection2) {
          var criteria = arrayMap(iteratees, function(iteratee2) {
            return iteratee2(value);
          });
          return { "criteria": criteria, "index": ++index2, "value": value };
        });
        return baseSortBy(result2, function(object, other) {
          return compareMultiple(object, other, orders);
        });
      }
      function basePick(object, paths) {
        return basePickBy(object, paths, function(value, path2) {
          return hasIn(object, path2);
        });
      }
      function basePickBy(object, paths, predicate) {
        var index2 = -1, length2 = paths.length, result2 = {};
        while (++index2 < length2) {
          var path2 = paths[index2], value = baseGet2(object, path2);
          if (predicate(value, path2)) {
            baseSet(result2, castPath(path2, object), value);
          }
        }
        return result2;
      }
      function basePropertyDeep(path2) {
        return function(object) {
          return baseGet2(object, path2);
        };
      }
      function basePullAll(array, values3, iteratee2, comparator) {
        var indexOf3 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length2 = values3.length, seen = array;
        if (array === values3) {
          values3 = copyArray(values3);
        }
        if (iteratee2) {
          seen = arrayMap(array, baseUnary(iteratee2));
        }
        while (++index2 < length2) {
          var fromIndex = 0, value = values3[index2], computed = iteratee2 ? iteratee2(value) : value;
          while ((fromIndex = indexOf3(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice2.call(seen, fromIndex, 1);
            }
            splice2.call(array, fromIndex, 1);
          }
        }
        return array;
      }
      function basePullAt(array, indexes) {
        var length2 = array ? indexes.length : 0, lastIndex = length2 - 1;
        while (length2--) {
          var index2 = indexes[length2];
          if (length2 == lastIndex || index2 !== previous2) {
            var previous2 = index2;
            if (isIndex(index2)) {
              splice2.call(array, index2, 1);
            } else {
              baseUnset(array, index2);
            }
          }
        }
        return array;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start, end, step, fromRight) {
        var index2 = -1, length2 = nativeMax2(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length2);
        while (length2--) {
          result2[fromRight ? length2 : ++index2] = start;
          start += step;
        }
        return result2;
      }
      function baseRepeat(string2, n2) {
        var result2 = "";
        if (!string2 || n2 < 1 || n2 > MAX_SAFE_INTEGER) {
          return result2;
        }
        do {
          if (n2 % 2) {
            result2 += string2;
          }
          n2 = nativeFloor(n2 / 2);
          if (n2) {
            string2 += string2;
          }
        } while (n2);
        return result2;
      }
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + "");
      }
      function baseSample(collection) {
        return arraySample(values2(collection));
      }
      function baseSampleSize(collection, n2) {
        var array = values2(collection);
        return shuffleSelf(array, baseClamp(n2, 0, array.length));
      }
      function baseSet(object, path2, value, customizer) {
        if (!isObject2(object)) {
          return object;
        }
        path2 = castPath(path2, object);
        var index2 = -1, length2 = path2.length, lastIndex = length2 - 1, nested = object;
        while (nested != null && ++index2 < length2) {
          var key = toKey(path2[index2]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object;
          }
          if (index2 != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject2(objValue) ? objValue : isIndex(path2[index2 + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      var baseSetData = !metaMap ? identity : function(func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString = !defineProperty2 ? identity : function(func, string2) {
        return defineProperty2(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant(string2),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values2(collection));
      }
      function baseSlice(array, start, end) {
        var index2 = -1, length2 = array.length;
        if (start < 0) {
          start = -start > length2 ? 0 : length2 + start;
        }
        end = end > length2 ? length2 : end;
        if (end < 0) {
          end += length2;
        }
        length2 = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result2 = Array2(length2);
        while (++index2 < length2) {
          result2[index2] = array[index2 + start];
        }
        return result2;
      }
      function baseSome(collection, predicate) {
        var result2;
        baseEach(collection, function(value, index2, collection2) {
          result2 = predicate(value, index2, collection2);
          return !result2;
        });
        return !!result2;
      }
      function baseSortedIndex(array, value, retHighest) {
        var low = 0, high = array == null ? low : array.length;
        if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed = array[mid];
            if (computed !== null && !isSymbol2(computed) && (retHighest ? computed <= value : computed < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }
      function baseSortedIndexBy(array, value, iteratee2, retHighest) {
        var low = 0, high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee2(value);
        var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol2(value), valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined$1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol2(computed);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin2(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array, iteratee2) {
        var index2 = -1, length2 = array.length, resIndex = 0, result2 = [];
        while (++index2 < length2) {
          var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
          if (!index2 || !eq(computed, seen)) {
            var seen = computed;
            result2[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result2;
      }
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN2;
        }
        return +value;
      }
      function baseToString(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray3(value)) {
          return arrayMap(value, baseToString) + "";
        }
        if (isSymbol2(value)) {
          return symbolToString ? symbolToString.call(value) : "";
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function baseUniq(array, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, length2 = array.length, isCommon = true, result2 = [], seen = result2;
        if (comparator) {
          isCommon = false;
          includes2 = arrayIncludesWith;
        } else if (length2 >= LARGE_ARRAY_SIZE) {
          var set3 = iteratee2 ? null : createSet(array);
          if (set3) {
            return setToArray(set3);
          }
          isCommon = false;
          includes2 = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee2 ? [] : result2;
        }
        outer:
          while (++index2 < length2) {
            var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed);
              }
              result2.push(value);
            } else if (!includes2(seen, computed, comparator)) {
              if (seen !== result2) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseUnset(object, path2) {
        path2 = castPath(path2, object);
        object = parent(object, path2);
        return object == null || delete object[toKey(last(path2))];
      }
      function baseUpdate(object, path2, updater, customizer) {
        return baseSet(object, path2, updater(baseGet2(object, path2)), customizer);
      }
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length2 = array.length, index2 = fromRight ? length2 : -1;
        while ((fromRight ? index2-- : ++index2 < length2) && predicate(array[index2], index2, array)) {
        }
        return isDrop ? baseSlice(array, fromRight ? 0 : index2, fromRight ? index2 + 1 : length2) : baseSlice(array, fromRight ? index2 + 1 : 0, fromRight ? length2 : index2);
      }
      function baseWrapperValue(value, actions) {
        var result2 = value;
        if (result2 instanceof LazyWrapper) {
          result2 = result2.value();
        }
        return arrayReduce(actions, function(result3, action) {
          return action.func.apply(action.thisArg, arrayPush([result3], action.args));
        }, result2);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length2 = arrays.length;
        if (length2 < 2) {
          return length2 ? baseUniq(arrays[0]) : [];
        }
        var index2 = -1, result2 = Array2(length2);
        while (++index2 < length2) {
          var array = arrays[index2], othIndex = -1;
          while (++othIndex < length2) {
            if (othIndex != index2) {
              result2[index2] = baseDifference(result2[index2] || array, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
      }
      function baseZipObject(props, values3, assignFunc) {
        var index2 = -1, length2 = props.length, valsLength = values3.length, result2 = {};
        while (++index2 < length2) {
          var value = index2 < valsLength ? values3[index2] : undefined$1;
          assignFunc(result2, props[index2], value);
        }
        return result2;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == "function" ? value : identity;
      }
      function castPath(value, object) {
        if (isArray3(value)) {
          return value;
        }
        return isKey2(value, object) ? [value] : stringToPath2(toString2(value));
      }
      var castRest = baseRest;
      function castSlice(array, start, end) {
        var length2 = array.length;
        end = end === undefined$1 ? length2 : end;
        return !start && end >= length2 ? array : baseSlice(array, start, end);
      }
      var clearTimeout2 = ctxClearTimeout || function(id) {
        return root2.clearTimeout(id);
      };
      function cloneBuffer(buffer2, isDeep) {
        if (isDeep) {
          return buffer2.slice();
        }
        var length2 = buffer2.length, result2 = allocUnsafe ? allocUnsafe(length2) : new buffer2.constructor(length2);
        buffer2.copy(result2);
        return result2;
      }
      function cloneArrayBuffer(arrayBuffer) {
        var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
        return result2;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer2 = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer2, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp) {
        var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result2.lastIndex = regexp.lastIndex;
        return result2;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
      }
      function cloneTypedArray(typedArray, isDeep) {
        var buffer2 = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer2, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol2(value);
          var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol2(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object, other, orders) {
        var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length2 = objCriteria.length, ordersLength = orders.length;
        while (++index2 < length2) {
          var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
          if (result2) {
            if (index2 >= ordersLength) {
              return result2;
            }
            var order2 = orders[index2];
            return result2 * (order2 == "desc" ? -1 : 1);
          }
        }
        return object.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result2[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result2[leftIndex++] = args[argsIndex++];
        }
        return result2;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result2[argsIndex] = args[argsIndex];
        }
        var offset2 = argsIndex;
        while (++rightIndex < rightLength) {
          result2[offset2 + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[offset2 + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result2;
      }
      function copyArray(source, array) {
        var index2 = -1, length2 = source.length;
        array || (array = Array2(length2));
        while (++index2 < length2) {
          array[index2] = source[index2];
        }
        return array;
      }
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index2 = -1, length2 = props.length;
        while (++index2 < length2) {
          var key = props[index2];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray3(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index2 = -1, length2 = sources.length, customizer = length2 > 1 ? sources[length2 - 1] : undefined$1, guard = length2 > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length2 < 3 ? undefined$1 : customizer;
            length2 = 1;
          }
          object = Object2(object);
          while (++index2 < length2) {
            var source = sources[index2];
            if (source) {
              assigner(object, source, index2, customizer);
            }
          }
          return object;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object2(collection);
          while (fromRight ? index2-- : ++index2 < length2) {
            if (iteratee2(iterable[index2], index2, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor(fromRight) {
        return function(object, iteratee2, keysFunc) {
          var index2 = -1, iterable = Object2(object), props = keysFunc(object), length2 = props.length;
          while (length2--) {
            var key = props[fromRight ? length2 : ++index2];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var fn = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function(string2) {
          string2 = toString2(string2);
          var strSymbols = hasUnicode(string2) ? stringToArray(string2) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string2.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string2.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder(callback) {
        return function(string2) {
          return arrayReduce(words(deburr(string2).replace(reApos, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
          return isObject2(result2) ? result2 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length2 = arguments.length, args = Array2(length2), index2 = length2, placeholder = getHolder(wrapper);
          while (index2--) {
            args[index2] = arguments[index2];
          }
          var holders = length2 < 3 && args[0] !== placeholder && args[length2 - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length2 -= holders.length;
          if (length2 < arity) {
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              undefined$1,
              args,
              holders,
              undefined$1,
              undefined$1,
              arity - length2
            );
          }
          var fn = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          return apply(fn, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys2(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index2 = findIndexFunc(collection, predicate, fromIndex);
          return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length2 = funcs.length, index2 = length2, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index2--) {
            var func = funcs[index2];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT2);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index2 = wrapper ? index2 : length2;
          while (++index2 < length2) {
            func = funcs[index2];
            var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray3(value)) {
              return wrapper.plant(value).value();
            }
            var index3 = 0, result2 = length2 ? funcs[index3].apply(this, args) : value;
            while (++index3 < length2) {
              result2 = funcs[index3].call(this, result2);
            }
            return result2;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length2 = arguments.length, args = Array2(length2), index2 = length2;
          while (index2--) {
            args[index2] = arguments[index2];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length2 -= holdersCount;
          if (isCurried && length2 < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              thisArg,
              args,
              newHolders,
              argPos,
              ary2,
              arity - length2
            );
          }
          var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
          length2 = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length2 > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length2) {
            args.length = ary2;
          }
          if (this && this !== root2 && this instanceof wrapper) {
            fn = Ctor || createCtor(fn);
          }
          return fn.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object, iteratee2) {
          return baseInverter(object, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result2;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result2 = value;
          }
          if (other !== undefined$1) {
            if (result2 === undefined$1) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result2 = operator(value, other);
          }
          return result2;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length2, chars) {
        chars = chars === undefined$1 ? " " : baseToString(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length2) : chars;
        }
        var result2 = baseRepeat(chars, nativeCeil(length2 / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length2).join("") : result2.slice(0, length2);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function(start, end, step) {
          if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
            end = step = undefined$1;
          }
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber2(value);
            other = toNumber2(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result2 = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result2, newData);
        }
        result2.placeholder = placeholder;
        return setWrapToString(result2, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number2, precision) {
          number2 = toNumber2(number2);
          precision = precision == null ? 0 : nativeMin2(toInteger(precision), 292);
          if (precision && nativeIsFinite(number2)) {
            var pair = (toString2(number2) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString2(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number2);
        };
      }
      var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop : function(values3) {
        return new Set2(values3);
      };
      function createToPairs(keysFunc) {
        return function(object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        var length2 = partials ? partials.length : 0;
        if (!length2) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary2 = ary2 === undefined$1 ? ary2 : nativeMax2(toInteger(ary2), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length2 -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax2(newData[9] - length2, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result2 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result2 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result2 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result2 = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result2, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 || eq(objValue, objectProto2[key]) && !hasOwnProperty2.call(object, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if (isObject2(objValue) && isObject2(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject3(value) ? undefined$1 : value;
      }
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
        stack.set(array, other);
        stack.set(other, array);
        while (++index2 < arrLength) {
          var arrValue = array[index2], othValue = other[index2];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result2 = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function(othValue2, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result2 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result2 = false;
            break;
          }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result2;
      }
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            return object == other + "";
          case mapTag:
            var convert2 = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert2 || (convert2 = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result2 = equalArrays(convert2(object), convert2(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result2;
          case symbolTag2:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index2 = objLength;
        while (index2--) {
          var key = objProps[index2];
          if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result2 = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index2 < objLength) {
          key = objProps[index2];
          var objValue = object[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result2 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result2 && !skipCtor) {
          var objCtor = object.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result2 = false;
          }
        }
        stack["delete"](object);
        stack["delete"](other);
        return result2;
      }
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + "");
      }
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys2, getSymbols);
      }
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      var getData = !metaMap ? noop : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result2 = func.name + "", array = realNames[result2], length2 = hasOwnProperty2.call(realNames, result2) ? array.length : 0;
        while (length2--) {
          var data = array[length2], otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result2;
      }
      function getHolder(func) {
        var object = hasOwnProperty2.call(lodash2, "placeholder") ? lodash2 : func;
        return object.placeholder;
      }
      function getIteratee() {
        var result2 = lodash2.iteratee || iteratee;
        result2 = result2 === iteratee ? baseIteratee : result2;
        return arguments.length ? result2(arguments[0], arguments[1]) : result2;
      }
      function getMapData(map3, key) {
        var data = map3.__data__;
        return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
      }
      function getMatchData(object) {
        var result2 = keys2(object), length2 = result2.length;
        while (length2--) {
          var key = result2[length2], value = object[key];
          result2[length2] = [key, value, isStrictComparable(value)];
        }
        return result2;
      }
      function getNative(object, key) {
        var value = getValue2(object, key);
        return baseIsNative(value) ? value : undefined$1;
      }
      function getRawTag(value) {
        var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e2) {
        }
        var result2 = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result2;
      }
      var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
        if (object == null) {
          return [];
        }
        object = Object2(object);
        return arrayFilter(nativeGetSymbols(object), function(symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
        var result2 = [];
        while (object) {
          arrayPush(result2, getSymbols(object));
          object = getPrototype(object);
        }
        return result2;
      };
      var getTag = baseGetTag;
      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
        getTag = function(value) {
          var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result2;
        };
      }
      function getView(start, end, transforms) {
        var index2 = -1, length2 = transforms.length;
        while (++index2 < length2) {
          var data = transforms[index2], size2 = data.size;
          switch (data.type) {
            case "drop":
              start += size2;
              break;
            case "dropRight":
              end -= size2;
              break;
            case "take":
              end = nativeMin2(end, start + size2);
              break;
            case "takeRight":
              start = nativeMax2(start, end - size2);
              break;
          }
        }
        return { "start": start, "end": end };
      }
      function getWrapDetails(source) {
        var match5 = source.match(reWrapDetails);
        return match5 ? match5[1].split(reSplitDetails) : [];
      }
      function hasPath(object, path2, hasFunc) {
        path2 = castPath(path2, object);
        var index2 = -1, length2 = path2.length, result2 = false;
        while (++index2 < length2) {
          var key = toKey(path2[index2]);
          if (!(result2 = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result2 || ++index2 != length2) {
          return result2;
        }
        length2 = object == null ? 0 : object.length;
        return !!length2 && isLength(length2) && isIndex(key, length2) && (isArray3(object) || isArguments(object));
      }
      function initCloneArray(array) {
        var length2 = array.length, result2 = new array.constructor(length2);
        if (length2 && typeof array[0] == "string" && hasOwnProperty2.call(array, "index")) {
          result2.index = array.index;
          result2.input = array.input;
        }
        return result2;
      }
      function initCloneObject(object) {
        return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag2:
            return cloneSymbol(object);
        }
      }
      function insertWrapDetails(source, details) {
        var length2 = details.length;
        if (!length2) {
          return source;
        }
        var lastIndex = length2 - 1;
        details[lastIndex] = (length2 > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length2 > 2 ? ", " : " ");
        return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable(value) {
        return isArray3(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      function isIndex(value, length2) {
        var type = typeof value;
        length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
        return !!length2 && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
      }
      function isIterateeCall(value, index2, object) {
        if (!isObject2(object)) {
          return false;
        }
        var type = typeof index2;
        if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
          return eq(object[index2], value);
        }
        return false;
      }
      function isKey2(value, object) {
        if (isArray3(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol2(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
      }
      function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      var isMaskable = coreJsData ? isFunction2 : stubFalse;
      function isPrototype(value) {
        var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto2;
        return value === proto2;
      }
      function isStrictComparable(value) {
        return value === value && !isObject2(value);
      }
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object));
        };
      }
      function memoizeCapped(func) {
        var result2 = memoize2(func, function(key) {
          if (cache2.size === MAX_MEMOIZE_SIZE) {
            cache2.clear();
          }
          return key;
        });
        var cache2 = result2.cache;
        return result2;
      }
      function mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) {
          data[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin2(data[8], source[8]);
        }
        if (data[9] == null) {
          data[9] = source[9];
        }
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }
      function nativeKeysIn(object) {
        var result2 = [];
        if (object != null) {
          for (var key in Object2(object)) {
            result2.push(key);
          }
        }
        return result2;
      }
      function objectToString2(value) {
        return nativeObjectToString.call(value);
      }
      function overRest(func, start, transform2) {
        start = nativeMax2(start === undefined$1 ? func.length - 1 : start, 0);
        return function() {
          var args = arguments, index2 = -1, length2 = nativeMax2(args.length - start, 0), array = Array2(length2);
          while (++index2 < length2) {
            array[index2] = args[start + index2];
          }
          index2 = -1;
          var otherArgs = Array2(start + 1);
          while (++index2 < start) {
            otherArgs[index2] = args[index2];
          }
          otherArgs[start] = transform2(array);
          return apply(func, this, otherArgs);
        };
      }
      function parent(object, path2) {
        return path2.length < 2 ? object : baseGet2(object, baseSlice(path2, 0, -1));
      }
      function reorder(array, indexes) {
        var arrLength = array.length, length2 = nativeMin2(indexes.length, arrLength), oldArray = copyArray(array);
        while (length2--) {
          var index2 = indexes[length2];
          array[length2] = isIndex(index2, arrLength) ? oldArray[index2] : undefined$1;
        }
        return array;
      }
      function safeGet(object, key) {
        if (key === "constructor" && typeof object[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object[key];
      }
      var setData = shortOut(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root2.setTimeout(func, wait);
      };
      var setToString = shortOut(baseSetToString);
      function setWrapToString(wrapper, reference, bitmask) {
        var source = reference + "";
        return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array, size2) {
        var index2 = -1, length2 = array.length, lastIndex = length2 - 1;
        size2 = size2 === undefined$1 ? length2 : size2;
        while (++index2 < size2) {
          var rand = baseRandom(index2, lastIndex), value = array[rand];
          array[rand] = array[index2];
          array[index2] = value;
        }
        array.length = size2;
        return array;
      }
      var stringToPath2 = memoizeCapped(function(string2) {
        var result2 = [];
        if (string2.charCodeAt(0) === 46) {
          result2.push("");
        }
        string2.replace(rePropName, function(match5, number2, quote, subString) {
          result2.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match5);
        });
        return result2;
      });
      function toKey(value) {
        if (typeof value == "string" || isSymbol2(value)) {
          return value;
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e2) {
          }
          try {
            return func + "";
          } catch (e2) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result2.__actions__ = copyArray(wrapper.__actions__);
        result2.__index__ = wrapper.__index__;
        result2.__values__ = wrapper.__values__;
        return result2;
      }
      function chunk(array, size2, guard) {
        if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined$1) {
          size2 = 1;
        } else {
          size2 = nativeMax2(toInteger(size2), 0);
        }
        var length2 = array == null ? 0 : array.length;
        if (!length2 || size2 < 1) {
          return [];
        }
        var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length2 / size2));
        while (index2 < length2) {
          result2[resIndex++] = baseSlice(array, index2, index2 += size2);
        }
        return result2;
      }
      function compact2(array) {
        var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result2 = [];
        while (++index2 < length2) {
          var value = array[index2];
          if (value) {
            result2[resIndex++] = value;
          }
        }
        return result2;
      }
      function concat() {
        var length2 = arguments.length;
        if (!length2) {
          return [];
        }
        var args = Array2(length2 - 1), array = arguments[0], index2 = length2;
        while (index2--) {
          args[index2 - 1] = arguments[index2];
        }
        return arrayPush(isArray3(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }
      var difference = baseRest(function(array, values3) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values3, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest(function(array, values3) {
        var iteratee2 = last(values3);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values3, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest(function(array, values3) {
        var comparator = last(values3);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values3, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });
      function drop(array, n2, guard) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger(n2);
        return baseSlice(array, n2 < 0 ? 0 : n2, length2);
      }
      function dropRight(array, n2, guard) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger(n2);
        n2 = length2 - n2;
        return baseSlice(array, 0, n2 < 0 ? 0 : n2);
      }
      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }
      function fill(array, value, start, end) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
          start = 0;
          end = length2;
        }
        return baseFill(array, value, start, end);
      }
      function findIndex(array, predicate, fromIndex) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax2(length2 + index2, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2);
      }
      function findLastIndex(array, predicate, fromIndex) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return -1;
        }
        var index2 = length2 - 1;
        if (fromIndex !== undefined$1) {
          index2 = toInteger(fromIndex);
          index2 = fromIndex < 0 ? nativeMax2(length2 + index2, 0) : nativeMin2(index2, length2 - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2, true);
      }
      function flatten(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? baseFlatten(array, 1) : [];
      }
      function flattenDeep(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? baseFlatten(array, INFINITY) : [];
      }
      function flattenDepth(array, depth) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }
      function fromPairs(pairs) {
        var index2 = -1, length2 = pairs == null ? 0 : pairs.length, result2 = {};
        while (++index2 < length2) {
          var pair = pairs[index2];
          result2[pair[0]] = pair[1];
        }
        return result2;
      }
      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }
      function indexOf2(array, value, fromIndex) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax2(length2 + index2, 0);
        }
        return baseIndexOf(array, value, index2);
      }
      function initial(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? baseSlice(array, 0, -1) : [];
      }
      var intersection = baseRest(function(arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest(function(arrays) {
        var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join2(array, separator) {
        return array == null ? "" : nativeJoin.call(array, separator);
      }
      function last(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? array[length2 - 1] : undefined$1;
      }
      function lastIndexOf(array, value, fromIndex) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return -1;
        }
        var index2 = length2;
        if (fromIndex !== undefined$1) {
          index2 = toInteger(fromIndex);
          index2 = index2 < 0 ? nativeMax2(length2 + index2, 0) : nativeMin2(index2, length2 - 1);
        }
        return value === value ? strictLastIndexOf(array, value, index2) : baseFindIndex(array, baseIsNaN, index2, true);
      }
      function nth(array, n2) {
        return array && array.length ? baseNth(array, toInteger(n2)) : undefined$1;
      }
      var pull = baseRest(pullAll);
      function pullAll(array, values3) {
        return array && array.length && values3 && values3.length ? basePullAll(array, values3) : array;
      }
      function pullAllBy(array, values3, iteratee2) {
        return array && array.length && values3 && values3.length ? basePullAll(array, values3, getIteratee(iteratee2, 2)) : array;
      }
      function pullAllWith(array, values3, comparator) {
        return array && array.length && values3 && values3.length ? basePullAll(array, values3, undefined$1, comparator) : array;
      }
      var pullAt = flatRest(function(array, indexes) {
        var length2 = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
        basePullAt(array, arrayMap(indexes, function(index2) {
          return isIndex(index2, length2) ? +index2 : index2;
        }).sort(compareAscending));
        return result2;
      });
      function remove(array, predicate) {
        var result2 = [];
        if (!(array && array.length)) {
          return result2;
        }
        var index2 = -1, indexes = [], length2 = array.length;
        predicate = getIteratee(predicate, 3);
        while (++index2 < length2) {
          var value = array[index2];
          if (predicate(value, index2, array)) {
            result2.push(value);
            indexes.push(index2);
          }
        }
        basePullAt(array, indexes);
        return result2;
      }
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }
      function slice2(array, start, end) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
          start = 0;
          end = length2;
        } else {
          start = start == null ? 0 : toInteger(start);
          end = end === undefined$1 ? length2 : toInteger(end);
        }
        return baseSlice(array, start, end);
      }
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }
      function sortedIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array, value) {
        var length2 = array == null ? 0 : array.length;
        if (length2) {
          var index2 = baseSortedIndex(array, value);
          if (index2 < length2 && eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }
      function sortedLastIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array, value) {
        var length2 = array == null ? 0 : array.length;
        if (length2) {
          var index2 = baseSortedIndex(array, value, true) - 1;
          if (eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }
      function sortedUniqBy(array, iteratee2) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? baseSlice(array, 1, length2) : [];
      }
      function take(array, n2, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger(n2);
        return baseSlice(array, 0, n2 < 0 ? 0 : n2);
      }
      function takeRight(array, n2, guard) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger(n2);
        n2 = length2 - n2;
        return baseSlice(array, n2 < 0 ? 0 : n2, length2);
      }
      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }
      function uniqBy(array, iteratee2) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
      }
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length2 = 0;
        array = arrayFilter(array, function(group) {
          if (isArrayLikeObject(group)) {
            length2 = nativeMax2(group.length, length2);
            return true;
          }
        });
        return baseTimes(length2, function(index2) {
          return arrayMap(array, baseProperty(index2));
        });
      }
      function unzipWith(array, iteratee2) {
        if (!(array && array.length)) {
          return [];
        }
        var result2 = unzip(array);
        if (iteratee2 == null) {
          return result2;
        }
        return arrayMap(result2, function(group) {
          return apply(iteratee2, undefined$1, group);
        });
      }
      var without = baseRest(function(array, values3) {
        return isArrayLikeObject(array) ? baseDifference(array, values3) : [];
      });
      var xor = baseRest(function(arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });
      var zip = baseRest(unzip);
      function zipObject(props, values3) {
        return baseZipObject(props || [], values3 || [], assignValue);
      }
      function zipObjectDeep(props, values3) {
        return baseZipObject(props || [], values3 || [], baseSet);
      }
      var zipWith = baseRest(function(arrays) {
        var length2 = arrays.length, iteratee2 = length2 > 1 ? arrays[length2 - 1] : undefined$1;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
        return unzipWith(arrays, iteratee2);
      });
      function chain(value) {
        var result2 = lodash2(value);
        result2.__chain__ = true;
        return result2;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function(paths) {
        var length2 = paths.length, start = length2 ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
          return baseAt(object, paths);
        };
        if (length2 > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
          return this.thru(interceptor);
        }
        value = value.slice(start, +start + (length2 ? 1 : 0));
        value.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array) {
          if (length2 && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray2(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
        return { "done": done, "value": value };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result2, parent2 = this;
        while (parent2 instanceof baseLodash) {
          var clone3 = wrapperClone(parent2);
          clone3.__index__ = 0;
          clone3.__values__ = undefined$1;
          if (result2) {
            previous2.__wrapped__ = clone3;
          } else {
            result2 = clone3;
          }
          var previous2 = clone3;
          parent2 = parent2.__wrapped__;
        }
        previous2.__wrapped__ = value;
        return result2;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse],
            "thisArg": undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          ++result2[key];
        } else {
          baseAssignValue(result2, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray3(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter(collection, predicate) {
        var func = isArray3(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find2 = createFind(findIndex);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten(map2(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten(map2(collection, iteratee2), INFINITY);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map2(collection, iteratee2), depth);
      }
      function forEach(collection, iteratee2) {
        var func = isArray3(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray3(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          result2[key].push(value);
        } else {
          baseAssignValue(result2, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values2(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length2 = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax2(length2 + fromIndex, 0);
        }
        return isString2(collection) ? fromIndex <= length2 && collection.indexOf(value, fromIndex) > -1 : !!length2 && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest(function(collection, path2, args) {
        var index2 = -1, isFunc = typeof path2 == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value) {
          result2[++index2] = isFunc ? apply(path2, value, args) : baseInvoke(value, path2, args);
        });
        return result2;
      });
      var keyBy = createAggregator(function(result2, value, key) {
        baseAssignValue(result2, key, value);
      });
      function map2(collection, iteratee2) {
        var func = isArray3(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray3(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray3(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function(result2, value, key) {
        result2[key ? 0 : 1].push(value);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray3(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray3(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray3(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray3(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n2, guard) {
        if (guard ? isIterateeCall(collection, n2, guard) : n2 === undefined$1) {
          n2 = 1;
        } else {
          n2 = toInteger(n2);
        }
        var func = isArray3(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n2);
      }
      function shuffle(collection) {
        var func = isArray3(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString2(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }
      function some2(collection, predicate, guard) {
        var func = isArray3(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length2 = iteratees.length;
        if (length2 > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length2 > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now2 = ctxNow || function() {
        return root2.Date.now();
      };
      function after(n2, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        n2 = toInteger(n2);
        return function() {
          if (--n2 < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n2, guard) {
        n2 = guard ? undefined$1 : n2;
        n2 = func && n2 == null ? func.length : n2;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n2);
      }
      function before(n2, func) {
        var result2;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        n2 = toInteger(n2);
        return function() {
          if (--n2 > 0) {
            result2 = func.apply(this, arguments);
          }
          if (n2 <= 1) {
            func = undefined$1;
          }
          return result2;
        };
      }
      var bind = baseRest(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function(object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curry.placeholder;
        return result2;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curryRight.placeholder;
        return result2;
      }
      function debounce2(func, wait, options) {
        var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        wait = toNumber2(wait) || 0;
        if (isObject2(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax2(toNumber2(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result2 = func.apply(thisArg, args);
          return result2;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time) : result2;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin2(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now2();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result2;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result2 : trailingEdge(now2());
        }
        function debounced() {
          var time = now2(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result2;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest(function(func, wait, args) {
        return baseDelay(func, toNumber2(wait) || 0, args);
      });
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize2(func, resolver2) {
        if (typeof func != "function" || resolver2 != null && typeof resolver2 != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        var memoized = function() {
          var args = arguments, key = resolver2 ? resolver2.apply(this, args) : args[0], cache2 = memoized.cache;
          if (cache2.has(key)) {
            return cache2.get(key);
          }
          var result2 = func.apply(this, args);
          memoized.cache = cache2.set(key, result2) || cache2;
          return result2;
        };
        memoized.cache = new (memoize2.Cache || MapCache)();
        return memoized;
      }
      memoize2.Cache = MapCache;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray3(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function(args) {
          var index2 = -1, length2 = nativeMin2(args.length, funcsLength);
          while (++index2 < length2) {
            args[index2] = transforms[index2].call(this, args[index2]);
          }
          return apply(func, this, args);
        });
      });
      var partial = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        start = start === undefined$1 ? start : toInteger(start);
        return baseRest(func, start);
      }
      function spread(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        start = start == null ? 0 : nativeMax2(toInteger(start), 0);
        return baseRest(function(args) {
          var array = args[start], otherArgs = castSlice(args, 0, start);
          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply(func, this, otherArgs);
        });
      }
      function throttle(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        if (isObject2(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce2(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap2(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray3(value) ? value : [value];
      }
      function clone2(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object, source) {
        return source == null || baseConformsTo(object, source, keys2(source));
      }
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });
      var isArguments = baseIsArguments(function() {
        return arguments;
      }()) ? baseIsArguments : function(value) {
        return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
      };
      var isArray3 = Array2.isArray;
      var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction2(value);
      }
      function isArrayLikeObject(value) {
        return isObjectLike2(value) && isArrayLike(value);
      }
      function isBoolean2(value) {
        return value === true || value === false || isObjectLike2(value) && baseGetTag(value) == boolTag;
      }
      var isBuffer3 = nativeIsBuffer || stubFalse;
      var isDate2 = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
      function isElement(value) {
        return isObjectLike2(value) && value.nodeType === 1 && !isPlainObject3(value);
      }
      function isEmpty2(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray3(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer3(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty2.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result2 = customizer ? customizer(value, other) : undefined$1;
        return result2 === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result2;
      }
      function isError(value) {
        if (!isObjectLike2(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject3(value);
      }
      function isFinite2(value) {
        return typeof value == "number" && nativeIsFinite(value);
      }
      function isFunction2(value) {
        if (!isObject2(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      function isInteger(value) {
        return typeof value == "number" && value == toInteger(value);
      }
      function isLength(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      function isObject2(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      function isObjectLike2(value) {
        return value != null && typeof value == "object";
      }
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      function isMatch(object, source) {
        return object === source || baseIsMatch(object, source, getMatchData(source));
      }
      function isMatchWith(object, source, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch(object, source, getMatchData(source), customizer);
      }
      function isNaN2(value) {
        return isNumber2(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }
      function isNull(value) {
        return value === null;
      }
      function isNil(value) {
        return value == null;
      }
      function isNumber2(value) {
        return typeof value == "number" || isObjectLike2(value) && baseGetTag(value) == numberTag;
      }
      function isPlainObject3(value) {
        if (!isObjectLike2(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto2 = getPrototype(value);
        if (proto2 === null) {
          return true;
        }
        var Ctor = hasOwnProperty2.call(proto2, "constructor") && proto2.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      function isString2(value) {
        return typeof value == "string" || !isArray3(value) && isObjectLike2(value) && baseGetTag(value) == stringTag;
      }
      function isSymbol2(value) {
        return typeof value == "symbol" || isObjectLike2(value) && baseGetTag(value) == symbolTag2;
      }
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      function isUndefined2(value) {
        return value === undefined$1;
      }
      function isWeakMap(value) {
        return isObjectLike2(value) && getTag(value) == weakMapTag;
      }
      function isWeakSet(value) {
        return isObjectLike2(value) && baseGetTag(value) == weakSetTag;
      }
      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });
      function toArray2(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString2(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values2;
        return func(value);
      }
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber2(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign2 = value < 0 ? -1 : 1;
          return sign2 * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      function toInteger(value) {
        var result2 = toFinite(value), remainder = result2 % 1;
        return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber2(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN2;
        }
        if (isObject2(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject2(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary2.test(value);
        return isBinary || reIsOctal2.test(value) ? freeParseInt2(value.slice(2), isBinary ? 2 : 8) : reIsBadHex2.test(value) ? NAN2 : +value;
      }
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
      }
      function toString2(value) {
        return value == null ? "" : baseToString(value);
      }
      var assign2 = createAssigner(function(object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys2(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty2.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner(function(object, source) {
        copyObject(source, keysIn(source), object);
      });
      var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keysIn(source), object, customizer);
      });
      var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keys2(source), object, customizer);
      });
      var at = flatRest(baseAt);
      function create2(prototype, properties2) {
        var result2 = baseCreate(prototype);
        return properties2 == null ? result2 : baseAssign(result2, properties2);
      }
      var defaults2 = baseRest(function(object, sources) {
        object = Object2(object);
        var index2 = -1;
        var length2 = sources.length;
        var guard = length2 > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length2 = 1;
        }
        while (++index2 < length2) {
          var source = sources[index2];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined$1 || eq(value, objectProto2[key]) && !hasOwnProperty2.call(object, key)) {
              object[key] = source[key];
            }
          }
        }
        return object;
      });
      var defaultsDeep = baseRest(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });
      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object, iteratee2) {
        return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forInRight(object, iteratee2) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forOwn(object, iteratee2) {
        return object && baseForOwn(object, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object, iteratee2) {
        return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
      }
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys2(object));
      }
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }
      function get2(object, path2, defaultValue) {
        var result2 = object == null ? undefined$1 : baseGet2(object, path2);
        return result2 === undefined$1 ? defaultValue : result2;
      }
      function has(object, path2) {
        return object != null && hasPath(object, path2, baseHas);
      }
      function hasIn(object, path2) {
        return object != null && hasPath(object, path2, baseHasIn);
      }
      var invert = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        result2[value] = key;
      }, constant(identity));
      var invertBy = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        if (hasOwnProperty2.call(result2, value)) {
          result2[value].push(key);
        } else {
          result2[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);
      function keys2(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      function mapKeys(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, iteratee2(value, key, object2), value);
        });
        return result2;
      }
      function mapValues(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, key, iteratee2(value, key, object2));
        });
        return result2;
      }
      var merge2 = createAssigner(function(object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });
      var omit = flatRest(function(object, paths) {
        var result2 = {};
        if (object == null) {
          return result2;
        }
        var isDeep = false;
        paths = arrayMap(paths, function(path2) {
          path2 = castPath(path2, object);
          isDeep || (isDeep = path2.length > 1);
          return path2;
        });
        copyObject(object, getAllKeysIn(object), result2);
        if (isDeep) {
          result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length2 = paths.length;
        while (length2--) {
          baseUnset(result2, paths[length2]);
        }
        return result2;
      });
      function omitBy(object, predicate) {
        return pickBy2(object, negate(getIteratee(predicate)));
      }
      var pick2 = flatRest(function(object, paths) {
        return object == null ? {} : basePick(object, paths);
      });
      function pickBy2(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function(value, path2) {
          return predicate(value, path2[0]);
        });
      }
      function result(object, path2, defaultValue) {
        path2 = castPath(path2, object);
        var index2 = -1, length2 = path2.length;
        if (!length2) {
          length2 = 1;
          object = undefined$1;
        }
        while (++index2 < length2) {
          var value = object == null ? undefined$1 : object[toKey(path2[index2])];
          if (value === undefined$1) {
            index2 = length2;
            value = defaultValue;
          }
          object = isFunction2(value) ? value.call(object) : value;
        }
        return object;
      }
      function set2(object, path2, value) {
        return object == null ? object : baseSet(object, path2, value);
      }
      function setWith(object, path2, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path2, value, customizer);
      }
      var toPairs = createToPairs(keys2);
      var toPairsIn = createToPairs(keysIn);
      function transform(object, iteratee2, accumulator) {
        var isArr = isArray3(object), isArrLike = isArr || isBuffer3(object) || isTypedArray(object);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject2(object)) {
            accumulator = isFunction2(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function(value, index2, object2) {
          return iteratee2(accumulator, value, index2, object2);
        });
        return accumulator;
      }
      function unset2(object, path2) {
        return object == null ? true : baseUnset(object, path2);
      }
      function update(object, path2, updater) {
        return object == null ? object : baseUpdate(object, path2, castFunction(updater));
      }
      function updateWith(object, path2, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path2, castFunction(updater), customizer);
      }
      function values2(object) {
        return object == null ? [] : baseValues(object, keys2(object));
      }
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }
      function clamp2(number2, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber2(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber2(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber2(number2), lower, upper);
      }
      function inRange(number2, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number2 = toNumber2(number2);
        return baseInRange(number2, start, end);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin2(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function(result2, word, index2) {
        word = word.toLowerCase();
        return result2 + (index2 ? capitalize2(word) : word);
      });
      function capitalize2(string2) {
        return upperFirst(toString2(string2).toLowerCase());
      }
      function deburr(string2) {
        string2 = toString2(string2);
        return string2 && string2.replace(reLatin, deburrLetter).replace(reComboMark, "");
      }
      function endsWith(string2, target, position2) {
        string2 = toString2(string2);
        target = baseToString(target);
        var length2 = string2.length;
        position2 = position2 === undefined$1 ? length2 : baseClamp(toInteger(position2), 0, length2);
        var end = position2;
        position2 -= target.length;
        return position2 >= 0 && string2.slice(position2, end) == target;
      }
      function escape(string2) {
        string2 = toString2(string2);
        return string2 && reHasUnescapedHtml.test(string2) ? string2.replace(reUnescapedHtml, escapeHtmlChar) : string2;
      }
      function escapeRegExp(string2) {
        string2 = toString2(string2);
        return string2 && reHasRegExpChar.test(string2) ? string2.replace(reRegExpChar, "\\$&") : string2;
      }
      var kebabCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst("toLowerCase");
      function pad(string2, length2, chars) {
        string2 = toString2(string2);
        length2 = toInteger(length2);
        var strLength = length2 ? stringSize(string2) : 0;
        if (!length2 || strLength >= length2) {
          return string2;
        }
        var mid = (length2 - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string2 + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string2, length2, chars) {
        string2 = toString2(string2);
        length2 = toInteger(length2);
        var strLength = length2 ? stringSize(string2) : 0;
        return length2 && strLength < length2 ? string2 + createPadding(length2 - strLength, chars) : string2;
      }
      function padStart(string2, length2, chars) {
        string2 = toString2(string2);
        length2 = toInteger(length2);
        var strLength = length2 ? stringSize(string2) : 0;
        return length2 && strLength < length2 ? createPadding(length2 - strLength, chars) + string2 : string2;
      }
      function parseInt2(string2, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString2(string2).replace(reTrimStart, ""), radix || 0);
      }
      function repeat(string2, n2, guard) {
        if (guard ? isIterateeCall(string2, n2, guard) : n2 === undefined$1) {
          n2 = 1;
        } else {
          n2 = toInteger(n2);
        }
        return baseRepeat(toString2(string2), n2);
      }
      function replace2() {
        var args = arguments, string2 = toString2(args[0]);
        return args.length < 3 ? string2 : string2.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "_" : "") + word.toLowerCase();
      });
      function split(string2, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall(string2, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string2 = toString2(string2);
        if (string2 && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string2)) {
            return castSlice(stringToArray(string2), 0, limit);
          }
        }
        return string2.split(separator, limit);
      }
      var startCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + upperFirst(word);
      });
      function startsWith(string2, target, position2) {
        string2 = toString2(string2);
        position2 = position2 == null ? 0 : baseClamp(toInteger(position2), 0, string2.length);
        target = baseToString(target);
        return string2.slice(position2, position2 + target.length) == target;
      }
      function template(string2, options, guard) {
        var settings = lodash2.templateSettings;
        if (guard && isIterateeCall(string2, options, guard)) {
          options = undefined$1;
        }
        string2 = toString2(string2);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys2(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index2 = 0, interpolate2 = options.interpolate || reNoMatch, source = "__p += '";
        var reDelimiters = RegExp2(
          (options.escape || reNoMatch).source + "|" + interpolate2.source + "|" + (interpolate2 === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
          "g"
        );
        var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string2.replace(reDelimiters, function(match5, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset2) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string2.slice(index2, offset2).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index2 = offset2 + match5.length;
          return match5;
        });
        source += "';\n";
        var variable = hasOwnProperty2.call(options, "variable") && options.variable;
        if (!variable) {
          source = "with (obj) {\n" + source + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
        var result2 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
        });
        result2.source = source;
        if (isError(result2)) {
          throw result2;
        }
        return result2;
      }
      function toLower(value) {
        return toString2(value).toLowerCase();
      }
      function toUpper(value) {
        return toString2(value).toUpperCase();
      }
      function trim2(string2, chars, guard) {
        string2 = toString2(string2);
        if (string2 && (guard || chars === undefined$1)) {
          return baseTrim(string2);
        }
        if (!string2 || !(chars = baseToString(chars))) {
          return string2;
        }
        var strSymbols = stringToArray(string2), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start, end).join("");
      }
      function trimEnd(string2, chars, guard) {
        string2 = toString2(string2);
        if (string2 && (guard || chars === undefined$1)) {
          return string2.slice(0, trimmedEndIndex(string2) + 1);
        }
        if (!string2 || !(chars = baseToString(chars))) {
          return string2;
        }
        var strSymbols = stringToArray(string2), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end).join("");
      }
      function trimStart(string2, chars, guard) {
        string2 = toString2(string2);
        if (string2 && (guard || chars === undefined$1)) {
          return string2.replace(reTrimStart, "");
        }
        if (!string2 || !(chars = baseToString(chars))) {
          return string2;
        }
        var strSymbols = stringToArray(string2), start = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start).join("");
      }
      function truncate(string2, options) {
        var length2 = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject2(options)) {
          var separator = "separator" in options ? options.separator : separator;
          length2 = "length" in options ? toInteger(options.length) : length2;
          omission = "omission" in options ? baseToString(options.omission) : omission;
        }
        string2 = toString2(string2);
        var strLength = string2.length;
        if (hasUnicode(string2)) {
          var strSymbols = stringToArray(string2);
          strLength = strSymbols.length;
        }
        if (length2 >= strLength) {
          return string2;
        }
        var end = length2 - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string2.slice(0, end);
        if (separator === undefined$1) {
          return result2 + omission;
        }
        if (strSymbols) {
          end += result2.length - end;
        }
        if (isRegExp(separator)) {
          if (string2.slice(end).search(separator)) {
            var match5, substring = result2;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString2(reFlags.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match5 = separator.exec(substring)) {
              var newEnd = match5.index;
            }
            result2 = result2.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string2.indexOf(baseToString(separator), end) != end) {
          var index2 = result2.lastIndexOf(separator);
          if (index2 > -1) {
            result2 = result2.slice(0, index2);
          }
        }
        return result2 + omission;
      }
      function unescape(string2) {
        string2 = toString2(string2);
        return string2 && reHasEscapedHtml.test(string2) ? string2.replace(reEscapedHtml, unescapeHtmlChar) : string2;
      }
      var upperCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toUpperCase();
      });
      var upperFirst = createCaseFirst("toUpperCase");
      function words(string2, pattern, guard) {
        string2 = toString2(string2);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord(string2) ? unicodeWords(string2) : asciiWords(string2);
        }
        return string2.match(pattern) || [];
      }
      var attempt = baseRest(function(func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e2) {
          return isError(e2) ? e2 : new Error2(e2);
        }
      });
      var bindAll = flatRest(function(object, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey(key);
          baseAssignValue(object, key, bind(object[key], object));
        });
        return object;
      });
      function cond(pairs) {
        var length2 = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length2 ? [] : arrayMap(pairs, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function(args) {
          var index2 = -1;
          while (++index2 < length2) {
            var pair = pairs[index2];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }
      function constant(value) {
        return function() {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow2 = createFlow();
      var flowRight = createFlow(true);
      function identity(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
      }
      function matches(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path2, srcValue) {
        return baseMatchesProperty(path2, baseClone(srcValue, CLONE_DEEP_FLAG));
      }
      var method = baseRest(function(path2, args) {
        return function(object) {
          return baseInvoke(object, path2, args);
        };
      });
      var methodOf = baseRest(function(object, args) {
        return function(path2) {
          return baseInvoke(object, path2, args);
        };
      });
      function mixin(object, source, options) {
        var props = keys2(source), methodNames = baseFunctions(source, props);
        if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys2(source));
        }
        var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction2(object);
        arrayEach(methodNames, function(methodName) {
          var func = source[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain2 || chainAll) {
                var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                actions.push({ "func": func, "args": arguments, "thisArg": object });
                result2.__chain__ = chainAll;
                return result2;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });
        return object;
      }
      function noConflict() {
        if (root2._ === this) {
          root2._ = oldDash;
        }
        return this;
      }
      function noop() {
      }
      function nthArg(n2) {
        n2 = toInteger(n2);
        return baseRest(function(args) {
          return baseNth(args, n2);
        });
      }
      var over = createOver(arrayMap);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome);
      function property(path2) {
        return isKey2(path2) ? baseProperty(toKey(path2)) : basePropertyDeep(path2);
      }
      function propertyOf(object) {
        return function(path2) {
          return object == null ? undefined$1 : baseGet2(object, path2);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray() {
        return [];
      }
      function stubFalse() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n2, iteratee2) {
        n2 = toInteger(n2);
        if (n2 < 1 || n2 > MAX_SAFE_INTEGER) {
          return [];
        }
        var index2 = MAX_ARRAY_LENGTH, length2 = nativeMin2(n2, MAX_ARRAY_LENGTH);
        iteratee2 = getIteratee(iteratee2);
        n2 -= MAX_ARRAY_LENGTH;
        var result2 = baseTimes(length2, iteratee2);
        while (++index2 < n2) {
          iteratee2(index2);
        }
        return result2;
      }
      function toPath(value) {
        if (isArray3(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol2(value) ? [value] : copyArray(stringToPath2(toString2(value)));
      }
      function uniqueId(prefix2) {
        var id = ++idCounter;
        return toString2(prefix2) + id;
      }
      var add2 = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound("floor");
      function max2(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
      }
      function maxBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined$1;
      }
      function mean(array) {
        return baseMean(array, identity);
      }
      function meanBy(array, iteratee2) {
        return baseMean(array, getIteratee(iteratee2, 2));
      }
      function min2(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
      }
      function minBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round2 = createRound("round");
      var subtract2 = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }
      function sumBy(array, iteratee2) {
        return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign2;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at;
      lodash2.before = before;
      lodash2.bind = bind;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain;
      lodash2.chunk = chunk;
      lodash2.compact = compact2;
      lodash2.concat = concat;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant;
      lodash2.countBy = countBy;
      lodash2.create = create2;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce2;
      lodash2.defaults = defaults2;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer;
      lodash2.delay = delay;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip;
      lodash2.flow = flow2;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys2;
      lodash2.keysIn = keysIn;
      lodash2.map = map2;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues;
      lodash2.matches = matches;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize2;
      lodash2.merge = merge2;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit;
      lodash2.omitBy = omitBy;
      lodash2.once = once;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition;
      lodash2.pick = pick2;
      lodash2.pickBy = pickBy2;
      lodash2.property = property;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove;
      lodash2.rest = rest;
      lodash2.reverse = reverse;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set2;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice2;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split;
      lodash2.spread = spread;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle;
      lodash2.thru = thru;
      lodash2.toArray = toArray2;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject;
      lodash2.transform = transform;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset2;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update;
      lodash2.updateWith = updateWith;
      lodash2.values = values2;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words;
      lodash2.wrap = wrap2;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add2;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase;
      lodash2.capitalize = capitalize2;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp2;
      lodash2.clone = clone2;
      lodash2.cloneDeep = cloneDeep;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith;
      lodash2.eq = eq;
      lodash2.escape = escape;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find2;
      lodash2.findIndex = findIndex;
      lodash2.findKey = findKey;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor;
      lodash2.forEach = forEach;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get2;
      lodash2.gt = gt;
      lodash2.gte = gte;
      lodash2.has = has;
      lodash2.hasIn = hasIn;
      lodash2.head = head;
      lodash2.identity = identity;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf2;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments;
      lodash2.isArray = isArray3;
      lodash2.isArrayBuffer = isArrayBuffer;
      lodash2.isArrayLike = isArrayLike;
      lodash2.isArrayLikeObject = isArrayLikeObject;
      lodash2.isBoolean = isBoolean2;
      lodash2.isBuffer = isBuffer3;
      lodash2.isDate = isDate2;
      lodash2.isElement = isElement;
      lodash2.isEmpty = isEmpty2;
      lodash2.isEqual = isEqual;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError;
      lodash2.isFinite = isFinite2;
      lodash2.isFunction = isFunction2;
      lodash2.isInteger = isInteger;
      lodash2.isLength = isLength;
      lodash2.isMap = isMap;
      lodash2.isMatch = isMatch;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN2;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil;
      lodash2.isNull = isNull;
      lodash2.isNumber = isNumber2;
      lodash2.isObject = isObject2;
      lodash2.isObjectLike = isObjectLike2;
      lodash2.isPlainObject = isPlainObject3;
      lodash2.isRegExp = isRegExp;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet;
      lodash2.isString = isString2;
      lodash2.isSymbol = isSymbol2;
      lodash2.isTypedArray = isTypedArray;
      lodash2.isUndefined = isUndefined2;
      lodash2.isWeakMap = isWeakMap;
      lodash2.isWeakSet = isWeakSet;
      lodash2.join = join2;
      lodash2.kebabCase = kebabCase;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt;
      lodash2.lte = lte;
      lodash2.max = max2;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min2;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray;
      lodash2.stubFalse = stubFalse;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop;
      lodash2.now = now2;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat;
      lodash2.replace = replace2;
      lodash2.result = result;
      lodash2.round = round2;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some2;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract2;
      lodash2.sum = sum;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite;
      lodash2.toInteger = toInteger;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber2;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString2;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim2;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst;
      lodash2.each = forEach;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source = {};
        baseForOwn(lodash2, function(func, methodName) {
          if (!hasOwnProperty2.call(lodash2.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), { "chain": false });
      lodash2.VERSION = VERSION;
      arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach(["drop", "take"], function(methodName, index2) {
        LazyWrapper.prototype[methodName] = function(n2) {
          n2 = n2 === undefined$1 ? 1 : nativeMax2(toInteger(n2), 0);
          var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
          if (result2.__filtered__) {
            result2.__takeCount__ = nativeMin2(n2, result2.__takeCount__);
          } else {
            result2.__views__.push({
              "size": nativeMin2(n2, MAX_ARRAY_LENGTH),
              "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
            });
          }
          return result2;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n2) {
          return this.reverse()[methodName](n2).reverse();
        };
      });
      arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
        var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result2 = this.clone();
          result2.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result2.__filtered__ = result2.__filtered__ || isFilter;
          return result2;
        };
      });
      arrayEach(["head", "last"], function(methodName, index2) {
        var takeName = "take" + (index2 ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(["initial", "tail"], function(methodName, index2) {
        var dropName = "drop" + (index2 ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function(path2, args) {
        if (typeof path2 == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path2, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start, end) {
        start = toInteger(start);
        var result2 = this;
        if (result2.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result2);
        }
        if (start < 0) {
          result2 = result2.takeRight(-start);
        } else if (start) {
          result2 = result2.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger(end);
          result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
        }
        return result2;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray3(value);
          var interceptor = function(value2) {
            var result3 = lodashFunc.apply(lodash2, arrayPush([value2], args));
            return isTaker && chainAll ? result3[0] : result3;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result2 = func.apply(value, args);
            result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
            return new LodashWrapper(result2, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result2 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
        };
      });
      arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray3(value) ? value : [], args);
          }
          return this[chainName](function(value2) {
            return func.apply(isArray3(value2) ? value2 : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty2.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _ = runInContext();
    if (freeModule) {
      (freeModule.exports = _)._ = _;
      freeExports._ = _;
    } else {
      root2._ = _;
    }
  }).call(commonjsGlobal);
})(lodash$1, lodash$1.exports);
var lodashExports = lodash$1.exports;
const lodash = /* @__PURE__ */ getDefaultExportFromCjs(lodashExports);
const ConstantsContext = React__default.createContext({});
const ConstantsProvider = (props) => {
  const {
    constantsUrl,
    shouldMockConstants,
    children
  } = props;
  const [constants, setConstants] = useState({});
  const fetchConstants = () => __async(void 0, null, function* () {
    if (shouldMockConstants) {
      setConstants(getMockConstants());
      return;
    }
    try {
      const cachedConstants = JSON.parse(sessionStorage.getItem("constants") || "{}");
      const cachedSessionId = sessionStorage.getItem("sessionId");
      const currentSessionId = getSessionId();
      const cacheExistsForCurrentSession = !!currentSessionId && !!cachedSessionId && cachedSessionId === currentSessionId;
      const cacheContentsAreValid = cachedConstants && !lodash.isEmpty(cachedConstants);
      if (cacheContentsAreValid && cacheExistsForCurrentSession) {
        return setConstants(cachedConstants);
      }
      const apiConstants = yield getApiConstants(constantsUrl);
      setConstants(apiConstants);
      sessionStorage.setItem("constants", JSON.stringify(apiConstants));
      sessionStorage.setItem("sessionId", currentSessionId);
    } catch (error) {
      console.error("Error fetching constants:", error);
    }
  });
  useEffect(() => {
    fetchConstants();
  }, []);
  if (!constants) {
    return /* @__PURE__ */ jsx("div", {});
  }
  return /* @__PURE__ */ jsx(ConstantsContext.Provider, { value: constants, children });
};
const extendConstants = (constants) => {
  var _a;
  const countries2 = ((_a = constants == null ? void 0 : constants.geography) == null ? void 0 : _a.countries) || {};
  for (const countryCode of Object.keys(countries2)) {
    const countryListIndex = countryCode;
    if (!index_es5_minExports.countries[countryListIndex]) {
      continue;
    }
    const countryObj = index_es5_minExports.countries[countryListIndex];
    countries2[countryCode].name_and_flag = `${countryObj.name} ${countryObj.emoji}`;
    countries2[countryCode].flag = countryObj.emoji;
  }
  return constants;
};
const getSessionId = () => {
  return extractCookieValue("_session_id");
};
const getMockConstants = () => {
  return extendConstants(mockConstants);
};
const getApiConstants = (constantsUrl) => __async(void 0, null, function* () {
  const response = yield fetch(constantsUrl);
  const fetchedConstants = yield response.json();
  return extendConstants(fetchedConstants);
});
const extractCookieValue = (cookieName) => {
  const cookie = document.cookie.split("; ").find((row) => row.startsWith(cookieName));
  if (!cookie) {
    return "";
  }
  return cookie.split("=")[1];
};
const useConstants = () => {
  const constants = React__default.useContext(ConstantsContext);
  if (!constants) {
    throw new Error("useConstants must be used within a ConstantsProvider");
  }
  return constants;
};
const messages$1 = JSON.parse(`{"Eh0/Yl":[["lastUploadedFilename"]," uploaded successfully"],"KatURn":["<0>",["0"]," ",["1"],"</0>, with date of birth <1>",["2"],"</1>.<2/>"],"Du6bPw":"Address","o9z/PM":"All account access features are disabled","ZPVRCH":"An error occurred creating an account application. Please try again later.","EOUool":"Basic Details","0/8Ahd":"By registering this account","ny7qwG":"Choose a different file <0/>","jGiQ8S":"Choose a new file <0/>","WzhY3i":"Choose another file <0/>","zZ9ydC":"City / Town","yz7wBu":"Close","60UM2X":"Company or Trust","xGVfLh":"Continue","JNCzPW":"Country","n5BlVb":"Country of Residence","Dh+FIh":"Date of birth","7uHWR+":"Date of Birth","Y1YKad":"Edit Details","e2w3mS":"File size must be less than 4 MB","oeV6qu":"File upload failed. Please try again later.","qW7soC":"Financial regulations require us to collect additional information from you.","qsm2Zu":"Financial regulations require us to collect additional information from you. <0>Learn more</0>","fmTD+z":"Finish reverifying your info to continue using CoinList","kODvZJ":"First Name","7eMo+U":"Go Home","jcBGHt":"I agree not to fund this account from a <0>private banking account</0>","Ip9uRS":"I agree that I am not a <0>politically exposed person</0> (PEP) or immediate family or close associate of a politically exposed person","AU9CLF":"I agree that I am not—nor is anyone in my immediate household—associated with FINRA, a FINRA-member broker-dealer, or the SEC","6DJL5w":"I agree that this account is not a <0>foreign financial institution</0> or <1>foreign shell bank</1>","Su17Hs":"I agree to the <0>Terms of Service</0> and the <1>Privacy Policy</1>","G/R37p":"I agree to the above terms","OQgY7S":"If you are being asked to create/open an account by a third-party for compensation or as part of a job application process, <0>contact us immediately</0>. <1/><2/>CoinList will never ask you to create an account as part of the job application process.","I0Jpz/":"If your legal name has changed since you last verified, please log out and register a new account.","/LCAwL":"In progress","fKfbXe":"In this step, you'll need to:","fByw/g":"Individual","UXBCwc":"Last Name","zwWKhA":"Learn more","6YtxFj":"Name","KLJ99F":"Never share your account. Never use another person's account.","1UzENP":"No","9pnaAI":"Occupation","ucgZ0o":"Organization","3HPUiF":"Our onboarding process usually takes less than 5 minutes for most individuals, but may take longer for companies or trusts.","ZuLy43":"Phone number","xahhAo":"Photo Verification","qNh1HX":"Please make sure the information below is correct. Click \\"Submit\\" to continue.","1/tEGr":"Please select an option","OyqiiM":"Proof of Address","U+PgUp":"Provide a utility bill, bank or credit card statement in your name, issued within the past 3 months.","p09WA4":"Province or Region","8nVerV":"Re-enter your information below to get re-verified and continue using your account.","fUYQC7":"Re-verify your account to continue using CoinList","ekCRTP":"Rejected","7vksfF":"Required document not uploaded.","de7qmv":["Return to ",["0"]," registration"],"ruqhV8":"Review and Submit","C85d5+":"Save and Continue","IUwGEM":"Save Changes","ACIRPN":"Search Street Address ...","GqXJob":"Select your account type","mOjKS5":"Social Security Number","m0b7v3":"Software Engineer","mL3uuM":"SSN","pHxNw3":"Start Identity Verification","dZh9mq":"Start Photo Verification","p4EMme":"State or Territory","THlSym":"Street Address","hQRttt":"Submit","G9MzmU":"Take a selfie","NcRDVh":"Takes less than 2 minutes","2Zp92Z":"The information and documents you provide must match the name","3NWd2t":"There was an error loading your information. Please try again later.","ZrPMDj":"There was an error submitting your information. Please try again later.","rE+Ay/":"This process should take less than 5 minutes to complete.","0BYiWi":"To comply with applicable regulations, you will be asked to submit information including your name, address, selfie, and government-issued ID image.","FTFhvG":"To enable transactions, we need to verify your identity. This process should take less than 5 minutes to complete.","2yStfW":"Until you re-verify, your account is restricted to withdrawals only.","mb9yQ4":["Upload ",["fileNameForDisplay"]," <0/>"],"0fOIhQ":"Upload another file <0/>","ik0mgO":"Verify your account","lLmS+R":"We are reviewing your identity","YEXTw3":"We are unable to grant you access to core services like trading, staking, and lending. You may still be eligible to paticipate in select CoinList offerings.","tesLP4":"We are unable to verify your account at this time.","6NP9nH":"We collect this information to keep your account secure and comply with financial regulations.","wrZTFD":["We only support file types ",["0"]],"7fweU2":"We will email you when we finish reviewing your information.","y92q6y":"We will email you when we finish reviewing your information. <0>Learn more</0>","l75CjT":"Yes","0ewb+4":"You are restricted to withdrawals only. Once your assets are withdrawn from CoinList, your account will be closed.","94POnH":["You cannot change your country of residence from <0>",["initialCountryName"],"</0> to <1>",["selectedCountryName"],"</1> for re-verification. To change your country of residence, please logout and create a new account."],"pyNU0m":"Your account could not be fully verified","mAXg7b":"Your account could not be verified","xHn8vf":"Your account has been closed","U3c9B9":"Your account is verified","tP2U8L":["Your account will be restricted to withdrawals only ",["0"],"."],"K6f0vw":"Your first name, last name, and date of birth must match the information you provided when you first verified your account."}`);
const translationsEN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  messages: messages$1
}, Symbol.toStringTag, { value: "Module" }));
const messages = JSON.parse(`{"Eh0/Yl":[["lastUploadedFilename"]," başarıyla yüklendi"],"KatURn":["[<0>",["0"],"] ",["1"],"</0>, doğum tarihi [ <1>",["2"],"</1>].<2/>"],"Du6bPw":"Adres","o9z/PM":"Tüm hesap erişim özellikleri devre dışı bırakıldı","ZPVRCH":"Hesap oluştururken bir hata oluştu. Lütfen daha sonra tekrar deneyin.","EOUool":"Temel Detaylar","0/8Ahd":"Bu hesabı oluştururken\\n","ny7qwG":"Farklı bir dosya seçin <0/>","jGiQ8S":"Yeni bir dosya seçin <0/>","WzhY3i":"Başka bir dosya seçin <0/>","zZ9ydC":"Şehir","yz7wBu":"Sonlandır\\n","60UM2X":"Şirket veya Tröst","xGVfLh":"Devam et","JNCzPW":"Ülke","n5BlVb":"İkamet Edilen Ülke","Dh+FIh":"Doğum tarihi","7uHWR+":"Doğum Tarihi","Y1YKad":"Detayları Düzenle","e2w3mS":"Dosya boyutu 4 MB'den az olmalıdır","oeV6qu":"Dosya yükleme başarısız oldu. Lütfen daha sonra tekrar deneyin.","qW7soC":"Financial regulations require us to collect additional information from you.","qsm2Zu":"Financial regulations require us to collect additional information from you. <0>Learn more</0>","fmTD+z":"CoinList'i kullanmaya devam etmek için bilgilerinizi tekrar doğrulama sürecini tamamlayın.","kODvZJ":"Ad","7eMo+U":"Anasayfaya Git","jcBGHt":"Bu hesaba <0>özel bir bankacılık hesabından</0> para yatırmamayı kabul ediyorum","Ip9uRS":"Ben, <0>Siyasi Nüfuz Sahibi Kişi</0> (PEP) veya siyasi olarak nüfuz sahibi bir kişinin birinci dereceden akrabası veya yakın arkadaşı olmadığımı kabul ediyorum","AU9CLF":"FINRA, FINRA üyesi bir broker-dealer veya SEC ile ilişkili olmadığımı -veya yakın çevremdeki herhangi birinin olmadığını- kabul ediyorum","6DJL5w":"Bu hesabın <0>yabancı bir finans kurumu</0> veya <1>yabancı bir paravan banka</1> olmadığını kabul ediyorum","Su17Hs":"<0>Hizmet Koşullarını</0> ve <1>Gizlilik Politikasını</1> kabul ediyorum","G/R37p":"Yukarıdaki şartları kabul ediyorum","OQgY7S":"Üçüncü bir tarafça ücret karşılığında veya iş başvurusu sürecinin bir parçası olarak bir hesap oluşturmanız/açmanız isteniyorsa, <0>derhal bizimle iletişime</0> geçin. <1/><2/>CoinList, iş başvurusu sürecinin bir parçası olarak sizden asla bir hesap oluşturmanızı istemeyecektir.","I0Jpz/":"Son kimlik doğrulamanızdan bu yana yasal adınız değiştiyse, lütfen oturumu kapatın ve yeni bir hesap açın.","/LCAwL":"Devam ediyor","fKfbXe":"Bu adımda yapmanız gerekenler:","fByw/g":"Bireysel","UXBCwc":"Soyadı","zwWKhA":"Learn more","6YtxFj":"Ad","KLJ99F":"Hesabınızı asla paylaşmayın. Asla başka bir kişinin hesabını kullanmayın.","1UzENP":"Hayır","9pnaAI":"Meslek","ucgZ0o":"Organizasyon","3HPUiF":"Üyelik oluşturma sürecimiz çoğu birey için genellikle 5 dakikadan az sürer, ancak şirketler veya tröstler için daha uzun sürebilir.","ZuLy43":"Telefon numarası","xahhAo":"Fotoğraf Doğrulama","qNh1HX":"Lütfen aşağıdaki bilgilerin doğru olduğundan emin olun. Devam etmek için \\"Gönder \\"e tıklayın.","1/tEGr":"Lütfen bir seçeneği işaretleyin","OyqiiM":"Adres Kanıtı","U+PgUp":"Son 3 ay içinde adınıza düzenlenmiş bir fatura, banka veya kredi kartı ekstresi sunun.","p09WA4":"İl veya Bölge","8nVerV":"Yeniden kimlik doğrulaması gerçekleştirmek ve hesabınızı kullanmaya devam etmek için bilgilerinizi aşağıya tekrar girin.","fUYQC7":"CoinList'i kullanmaya devam etmek için bilgilerinizi tekrar doğrulama sürecini tamamlayın.","ekCRTP":"Reddedildi","7vksfF":"Gerekli belge yüklenmedi.","de7qmv":[["0"],"] kaydına geri dönün"],"ruqhV8":"İnceleyin ve Gönderin","C85d5+":"Kaydet ve Devam Et","IUwGEM":"Değişiklikleri Kaydet","ACIRPN":"Sokak Adresi Ara ...","GqXJob":"Hesap türünüzü seçin","mOjKS5":"Sosyal Güvenlik Numarası","m0b7v3":"Yazılım Mühendisi","mL3uuM":"SSN","pHxNw3":"Kimlik Doğrulamayı Başlat","dZh9mq":"Fotoğraf Doğrulamayı Başlat","p4EMme":"Eyalet veya Bölge","THlSym":"Sokak Adresi","hQRttt":"Gönder","G9MzmU":"Bir selfie çekin","NcRDVh":"2 dakikadan daha kısa sürer","2Zp92Z":"Sağladığınız bilgi ve belgeler isminizle eşleşmelidir","3NWd2t":"Bilgileriniz yüklenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.","ZrPMDj":"Bilgilerinizi kaydederken bir hata oluştu. Lütfen daha sonra tekrar deneyin.","rE+Ay/":"Bu işlemin tamamlanması 5 dakikadan az sürmelidir.","0BYiWi":"Geçerli yasal düzenlemelere uyum sağlamak kapsamında adınız, adresiniz, özçekiminiz ve resmi kimlik fotoğrafınız gibi bilgileri göndermeniz istenecektir.","FTFhvG":"İşlemlere başlayabilmek için kimliğinizi doğrulamamız gerekir. Bu işlemin tamamlanması 5 dakikadan az sürmelidir.","2yStfW":"Yeniden kimlik doğrulama gerçekleştirene kadar hesabınız yalnızca para çekme işlemleriyle sınırlıdır.","mb9yQ4":["Yükle ",["fileNameForDisplay"]," <0/>"],"0fOIhQ":"Başka bir dosya yükleyin <0/>","ik0mgO":"Hesabınızı doğrulayın","lLmS+R":"Kimliğinizi gözden geçiriyoruz","YEXTw3":"Alım satım, stake etme ve borç verme gibi temel hizmetlere erişiminizi sağlayamıyoruz. Yine de belirli CoinList hizmetlerine katılmaya uygun olabilirsiniz.","tesLP4":"Şu anda hesabınızı doğrulayamıyoruz.","6NP9nH":"Bu bilgileri hesabınızı güvende tutmak ve finansal uyum yasalarına uyum sağlamak için topluyoruz.","wrZTFD":["Yalnızca ",["0"]," dosya türlerini destekliyoruz"],"7fweU2":"Bilgilerinizi incelemeyi bitirdiğimizde size e-posta göndereceğiz.","y92q6y":"Bilgilerinizi incelemeyi bitirdiğimizde size e-posta göndereceğiz. <0>Daha fazla bilgi</0>","l75CjT":"Evet","0ewb+4":"Yalnızca para çekme işlemleriyle sınırlandırıldınız. Varlıklarınız CoinList'ten çekildikten sonra hesabınız kapatılacaktır.","94POnH":["Yeniden kimlik doğrulama için ikamet ettiğiniz ülkeyi <0>",["initialCountryName"],"</0> 'dan <1>[",["selectedCountryName"],"</1> ]'e değiştiremezsiniz. İkamet ettiğiniz ülkeyi değiştirmek için lütfen oturumu kapatın ve yeni bir hesap oluşturun."],"pyNU0m":"Hesabınız tam olarak doğrulanamadı","mAXg7b":"Hesabınız doğrulanamadı","xHn8vf":"Hesabınız kapatıldı","U3c9B9":"Hesabınız doğrulandı","tP2U8L":["Hesabınız yalnızca para çekme işlemleriyle kısıtlanacaktır ",["0"],"."],"K6f0vw":"Adınız, soyadınız ve doğum tarihiniz, hesabınızı ilk doğruladığınızda verdiğiniz bilgilerle eşleşmelidir."}`);
const translationsTR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  messages
}, Symbol.toStringTag, { value: "Module" }));
function dynamicActivate(locale2) {
  return __async(this, null, function* () {
    const {
      messages: messages2
    } = locale2 === "tr" ? translationsTR : translationsEN;
    i18n.load(locale2, messages2);
    i18n.activate(locale2);
  });
}
const TranslationProvider = ({
  locale: locale2 = "en",
  children
}) => {
  useEffect(() => {
    dynamicActivate(locale2);
  }, []);
  return /* @__PURE__ */ jsx(I18nProvider, { i18n, children });
};
const TranslationProvider$1 = TranslationProvider;
function getSvgIconUtilityClass(slot) {
  return generateUtilityClass("MuiSvgIcon", slot);
}
generateUtilityClasses("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const _excluded$1 = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"];
const useUtilityClasses$1 = (ownerState) => {
  const {
    color: color2,
    fontSize,
    classes
  } = ownerState;
  const slots = {
    root: ["root", color2 !== "inherit" && `color${capitalize(color2)}`, `fontSize${capitalize(fontSize)}`]
  };
  return composeClasses(slots, getSvgIconUtilityClass, classes);
};
const SvgIconRoot = styled$1("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== "inherit" && styles[`color${capitalize(ownerState.color)}`], styles[`fontSize${capitalize(ownerState.fontSize)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette$ownerState$c2, _palette2, _palette2$action, _palette3, _palette3$action;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    fill: "currentColor",
    flexShrink: 0,
    transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
      duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
      medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
      large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
    }[ownerState.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null ? void 0 : (_palette$ownerState$c2 = _palette[ownerState.color]) == null ? void 0 : _palette$ownerState$c2.main) != null ? _palette$ownerState$c : {
      action: (_palette2 = (theme.vars || theme).palette) == null ? void 0 : (_palette2$action = _palette2.action) == null ? void 0 : _palette2$action.active,
      disabled: (_palette3 = (theme.vars || theme).palette) == null ? void 0 : (_palette3$action = _palette3.action) == null ? void 0 : _palette3$action.disabled,
      inherit: void 0
    }[ownerState.color]
  };
});
const SvgIcon = /* @__PURE__ */ React.forwardRef(function SvgIcon2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiSvgIcon"
  });
  const {
    children,
    className,
    color: color2 = "inherit",
    component = "svg",
    fontSize = "medium",
    htmlColor,
    inheritViewBox = false,
    titleAccess,
    viewBox = "0 0 24 24"
  } = props, other = _objectWithoutPropertiesLoose$1(props, _excluded$1);
  const ownerState = _extends$2({}, props, {
    color: color2,
    component,
    fontSize,
    instanceFontSize: inProps.fontSize,
    inheritViewBox,
    viewBox
  });
  const more = {};
  if (!inheritViewBox) {
    more.viewBox = viewBox;
  }
  const classes = useUtilityClasses$1(ownerState);
  return /* @__PURE__ */ jsxs(SvgIconRoot, _extends$2({
    as: component,
    className: clsx(classes.root, className),
    focusable: "false",
    color: htmlColor,
    "aria-hidden": titleAccess ? void 0 : true,
    role: titleAccess ? "img" : void 0,
    ref
  }, more, other, {
    ownerState,
    children: [children, titleAccess ? /* @__PURE__ */ jsx("title", {
      children: titleAccess
    }) : null]
  }));
});
SvgIcon.muiName = "SvgIcon";
const SvgIcon$1 = SvgIcon;
function createSvgIcon$1(path2, displayName) {
  function Component(props, ref) {
    return /* @__PURE__ */ jsx(SvgIcon$1, _extends$2({
      "data-testid": `${displayName}Icon`,
      ref
    }, props, {
      children: path2
    }));
  }
  Component.muiName = SvgIcon$1.muiName;
  return /* @__PURE__ */ React.memo(/* @__PURE__ */ React.forwardRef(Component));
}
const unstable_ClassNameGenerator = {
  configure: (generator) => {
    ClassNameGenerator$1.configure(generator);
  }
};
const utils$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize,
  createChainedFunction,
  createSvgIcon: createSvgIcon$1,
  debounce: debounce$1,
  deprecatedPropType,
  isMuiElement,
  ownerDocument,
  ownerWindow,
  requirePropFactory,
  setRef,
  unstable_ClassNameGenerator,
  unstable_useEnhancedEffect: useEnhancedEffect$1,
  unstable_useId: useId,
  unsupportedProp,
  useControlled,
  useEventCallback,
  useForkRef,
  useIsFocusVisible
}, Symbol.toStringTag, { value: "Module" }));
const Context = /* @__PURE__ */ React.createContext(null);
function useUniquePrefix() {
  const [id, setId] = React.useState(null);
  React.useEffect(() => {
    setId(`mui-p-${Math.round(Math.random() * 1e5)}`);
  }, []);
  return id;
}
function TabContext(props) {
  const {
    children,
    value
  } = props;
  const idPrefix = useUniquePrefix();
  const context = React.useMemo(() => {
    return {
      idPrefix,
      value
    };
  }, [idPrefix, value]);
  return /* @__PURE__ */ jsx(Context.Provider, {
    value: context,
    children
  });
}
function useTabContext() {
  return React.useContext(Context);
}
function getPanelId(context, value) {
  const {
    idPrefix
  } = context;
  if (idPrefix === null) {
    return null;
  }
  return `${context.idPrefix}-P-${value}`;
}
function getTabId(context, value) {
  const {
    idPrefix
  } = context;
  if (idPrefix === null) {
    return null;
  }
  return `${context.idPrefix}-T-${value}`;
}
function getTabPanelUtilityClass(slot) {
  return generateUtilityClass("MuiTabPanel", slot);
}
generateUtilityClasses("MuiTabPanel", ["root"]);
const _excluded = ["children", "className", "value"];
const useUtilityClasses = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getTabPanelUtilityClass, classes);
};
const TabPanelRoot = styled$1("div", {
  name: "MuiTabPanel",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => ({
  padding: theme.spacing(3)
}));
const TabPanel = /* @__PURE__ */ React.forwardRef(function TabPanel2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiTabPanel"
  });
  const {
    children,
    className,
    value
  } = props, other = _objectWithoutPropertiesLoose$1(props, _excluded);
  const ownerState = _extends$2({}, props);
  const classes = useUtilityClasses(ownerState);
  const context = useTabContext();
  if (context === null) {
    throw new TypeError("No TabContext provided");
  }
  const id = getPanelId(context, value);
  const tabId = getTabId(context, value);
  return /* @__PURE__ */ jsx(TabPanelRoot, _extends$2({
    "aria-labelledby": tabId,
    className: clsx(classes.root, className),
    hidden: value !== context.value,
    id,
    ref,
    role: "tabpanel",
    ownerState
  }, other, {
    children: value === context.value && children
  }));
});
const TabPanel$1 = TabPanel;
const ErrorDialogue = ({
  isCloseable,
  openState,
  setOpenState,
  message
}) => {
  const closeAction = () => {
    if (!isCloseable) {
      return;
    }
    setOpenState && setOpenState(false);
  };
  return /* @__PURE__ */ jsxs(Dialog, { open: openState !== void 0 ? openState : true, onClose: closeAction, children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: "An Error Occurred" }),
    /* @__PURE__ */ jsx(DialogContent, { children: message }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      isCloseable && /* @__PURE__ */ jsx(Button, { variant: "outlined", onClick: closeAction, children: /* @__PURE__ */ jsx(Trans, { id: "yz7wBu" }) }),
      !isCloseable && /* @__PURE__ */ jsx(Button, { variant: "outlined", onClick: () => window.location.href = "/", children: /* @__PURE__ */ jsx(Trans, { id: "7eMo+U" }) })
    ] })
  ] });
};
var ArrowForward$1 = {};
var interopRequireDefault = { exports: {} };
(function(module2) {
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  module2.exports = _interopRequireDefault2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(interopRequireDefault);
var interopRequireDefaultExports = interopRequireDefault.exports;
var createSvgIcon = {};
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(utils$1);
var hasRequiredCreateSvgIcon;
function requireCreateSvgIcon() {
  if (hasRequiredCreateSvgIcon)
    return createSvgIcon;
  hasRequiredCreateSvgIcon = 1;
  (function(exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "default", {
      enumerable: true,
      get: function() {
        return _utils2.createSvgIcon;
      }
    });
    var _utils2 = require$$0;
  })(createSvgIcon);
  return createSvgIcon;
}
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(jsxRuntime);
var _interopRequireDefault$3 = interopRequireDefaultExports;
Object.defineProperty(ArrowForward$1, "__esModule", {
  value: true
});
var default_1$1 = ArrowForward$1.default = void 0;
var _createSvgIcon$1 = _interopRequireDefault$3(requireCreateSvgIcon());
var _jsxRuntime$1 = require$$2;
var _default$2 = (0, _createSvgIcon$1.default)(/* @__PURE__ */ (0, _jsxRuntime$1.jsx)("path", {
  d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForward");
default_1$1 = ArrowForward$1.default = _default$2;
const sizeToInt = {
  xs: 0,
  sm: 1,
  md: 2,
  lg: 3,
  xl: 4
};
const HideBelow = ({
  screenSize,
  children
}) => {
  const muiDisplayStyle = {
    xs: sizeToInt[screenSize] > sizeToInt["xs"] ? "none" : "block",
    sm: sizeToInt[screenSize] > sizeToInt["sm"] ? "none" : "block",
    md: sizeToInt[screenSize] > sizeToInt["md"] ? "none" : "block",
    lg: sizeToInt[screenSize] > sizeToInt["lg"] ? "none" : "block",
    xl: sizeToInt[screenSize] > sizeToInt["xl"] ? "none" : "block"
  };
  return /* @__PURE__ */ jsx(Box, { sx: {
    display: muiDisplayStyle
  }, children });
};
const HideAbove = ({
  screenSize,
  children
}) => {
  const muiDisplayStyle = {
    xs: sizeToInt[screenSize] <= sizeToInt["xs"] ? "none" : "block",
    sm: sizeToInt[screenSize] <= sizeToInt["sm"] ? "none" : "block",
    md: sizeToInt[screenSize] <= sizeToInt["md"] ? "none" : "block",
    lg: sizeToInt[screenSize] <= sizeToInt["lg"] ? "none" : "block",
    xl: sizeToInt[screenSize] <= sizeToInt["xl"] ? "none" : "block"
  };
  return /* @__PURE__ */ jsx(Box, { sx: {
    display: muiDisplayStyle
  }, children });
};
const MobileStickyBottomBox = ({
  hideAbove,
  children
}) => {
  return /* @__PURE__ */ jsx(HideAbove, { screenSize: hideAbove, children: /* @__PURE__ */ jsx(Box, { sx: {
    paddingTop: 5,
    paddingLeft: {
      base: 4,
      md: 8
    },
    position: "fixed",
    bottom: "15px",
    bgcolor: "transparent",
    zIndex: 8,
    width: "-webkit-fill-available !important",
    height: "65px",
    borderTop: "1px",
    borderTopColor: "brand.300",
    padding: 2,
    alignItems: "center"
  }, children }) });
};
const AddIcon = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add");
const ArrowForward = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForward");
const AttachFile = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
}), "AttachFile");
const Brightness1 = createSvgIcon$1(/* @__PURE__ */ jsx("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}), "Brightness1");
const Check$1 = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
const CheckCircle = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckCircle");
const Close = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
const Delete = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
const Edit = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), "Edit");
const Error$1 = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
}), "Error");
const Help = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
}), "Help");
const InsertDriveFile = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"
}), "InsertDriveFile");
const RadioButtonUnchecked = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");
const Replay = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
}), "Replay");
const Schedule = createSvgIcon$1([/* @__PURE__ */ jsx("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}, "0"), /* @__PURE__ */ jsx("path", {
  d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
}, "1")], "Schedule");
const Search = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
const Warning = createSvgIcon$1(/* @__PURE__ */ jsx("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");
var FileUploadStatus = /* @__PURE__ */ ((FileUploadStatus2) => {
  FileUploadStatus2[FileUploadStatus2["SUCCESS"] = 0] = "SUCCESS";
  FileUploadStatus2[FileUploadStatus2["FAILED"] = 1] = "FAILED";
  FileUploadStatus2[FileUploadStatus2["NOT_STARTED"] = 2] = "NOT_STARTED";
  FileUploadStatus2[FileUploadStatus2["LOADING"] = 3] = "LOADING";
  return FileUploadStatus2;
})(FileUploadStatus || {});
const SUPPORTED_FILE_TYPES = {
  PDF: "application/pdf",
  JPEG: "image/jpeg",
  PNG: "image/png"
};
const MAX_ALLOWED_FILE_SIZE_BYTES = 4 * 1024 * 1024;
const FileUpload = ({
  label,
  docCategory,
  entityId,
  allowMultipleFiles,
  existingFiles,
  addressInfo,
  onStatusChange,
  displayError,
  children
}) => {
  let existingToShow = existingFiles;
  if (!allowMultipleFiles) {
    existingToShow = lodashExports.sortBy(existingFiles, (file) => file.updatedAt).slice(-1);
  }
  const [uploadDocumentMutation] = useUploadDocumentMutation({
    refetchQueries: () => {
      return [{
        query: EntityKycDocumentsDocument,
        variables: {
          entityId
        }
      }];
    }
  });
  const [clientSideFile, setClientSideFile] = useState(void 0);
  const [fileValidationError, setFileValidationError] = useState(void 0);
  const [lastUploadedFilename, setLastUploadedFilename] = useState(void 0);
  const [status, setStatus] = useState(
    (existingToShow == null ? void 0 : existingToShow.length) > 0 ? 0 : 2
    /* NOT_STARTED */
  );
  const updateUploadStatus = (status2) => {
    setStatus(status2);
    onStatusChange && onStatusChange(status2);
  };
  const fileSelectHandler = (event) => __async(void 0, null, function* () {
    var _a;
    const newFile = ((_a = event == null ? void 0 : event.target) == null ? void 0 : _a.files)[0];
    if (newFile.size > MAX_ALLOWED_FILE_SIZE_BYTES) {
      setFileValidationError(i18n._(
        /*i18n*/
        {
          id: "e2w3mS"
        }
      ));
      return;
    }
    if (!Object.values(SUPPORTED_FILE_TYPES).includes(newFile.type)) {
      setFileValidationError(i18n._(
        /*i18n*/
        {
          id: "wrZTFD",
          values: {
            0: Object.keys(SUPPORTED_FILE_TYPES).join(", ")
          }
        }
      ));
      return;
    }
    setFileValidationError(void 0);
    setClientSideFile(newFile);
    updateUploadStatus(
      2
      /* NOT_STARTED */
    );
  });
  const toBase64 = (file) => __async(void 0, null, function* () {
    if (typeof file === "undefined") {
      return void 0;
    }
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  });
  const uploadHandler = () => __async(void 0, null, function* () {
    var _a, _b;
    updateUploadStatus(
      3
      /* LOADING */
    );
    try {
      const request = {
        fileContent: yield toBase64(clientSideFile),
        fileName: (clientSideFile == null ? void 0 : clientSideFile.name) || "",
        docCategory,
        ownerEntityId: entityId,
        country: addressInfo == null ? void 0 : addressInfo.country,
        state: addressInfo == null ? void 0 : addressInfo.state
      };
      const res = yield uploadDocumentMutation({
        variables: request
      });
      if (!((_b = (_a = res.data) == null ? void 0 : _a.uploadDocument) == null ? void 0 : _b.success)) {
        throw new Error("Unsuccesful response");
      }
      setLastUploadedFilename(clientSideFile == null ? void 0 : clientSideFile.name);
      updateUploadStatus(
        0
        /* SUCCESS */
      );
      setClientSideFile(void 0);
    } catch (error) {
      updateUploadStatus(
        1
        /* FAILED */
      );
      return;
    }
  });
  const chooseFileButton = () => {
    const chooseFileId = "contained-button-file-" + docCategory;
    return /* @__PURE__ */ jsxs(Box, { children: [
      /* @__PURE__ */ jsx("input", { accept: Object.values(SUPPORTED_FILE_TYPES).join(","), id: chooseFileId, type: "file", onChange: fileSelectHandler, style: {
        display: "none"
      } }),
      /* @__PURE__ */ jsx(FormLabel, { htmlFor: chooseFileId, children: /* @__PURE__ */ jsx(Button, { size: "small", color: fileValidationError ? "error" : "primary", variant: "outlined", sx: {
        mb: 0
      }, component: "span", fullWidth: true, children: (existingToShow == null ? void 0 : existingToShow.length) == 0 ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Trans, { id: "jGiQ8S", components: {
        0: /* @__PURE__ */ jsx(AttachFile, { sx: {
          ml: 1
        } })
      } }) }) : allowMultipleFiles ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Trans, { id: "0fOIhQ", components: {
        0: /* @__PURE__ */ jsx(AttachFile, { sx: {
          ml: 1
        } })
      } }) }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Trans, { id: "ny7qwG", components: {
        0: /* @__PURE__ */ jsx(Replay, { sx: {
          ml: 1
        } })
      } }) }) }) }),
      displayError && /* @__PURE__ */ jsx(Typography, { color: "error.main", sx: {
        mt: 1
      }, children: /* @__PURE__ */ jsx(Trans, { id: "7vksfF" }) }),
      fileValidationError && /* @__PURE__ */ jsx(Typography, { color: "error.main", sx: {
        mt: 1
      }, children: fileValidationError })
    ] });
  };
  const uploadAndClearButtons = () => {
    let fileNameForDisplay = (clientSideFile || {}).name || "file";
    if ((fileNameForDisplay == null ? void 0 : fileNameForDisplay.length) > 15) {
      fileNameForDisplay = (fileNameForDisplay == null ? void 0 : fileNameForDisplay.substring(0, 15)) + "...";
    }
    if (status === 3) {
      return /* @__PURE__ */ jsx(Box, { sx: {
        display: "flex",
        justifyContent: "center"
      }, children: /* @__PURE__ */ jsx(CircularProgress, { size: 30, color: "primary" }) });
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Button, { size: "small", color: "info", fullWidth: true, sx: {
        mb: 2
      }, variant: "outlined", component: "span", onClick: uploadHandler, children: /* @__PURE__ */ jsx(Trans, { id: "mb9yQ4", values: {
        fileNameForDisplay
      }, components: {
        0: /* @__PURE__ */ jsx(ArrowForward, { sx: {
          ml: 1
        } })
      } }) }),
      /* @__PURE__ */ jsx(Button, { size: "small", color: "error", sx: {
        mb: 2
      }, variant: "outlined", component: "span", fullWidth: true, onClick: () => {
        setClientSideFile(void 0);
        updateUploadStatus(
          2
          /* NOT_STARTED */
        );
      }, children: /* @__PURE__ */ jsx(Trans, { id: "WzhY3i", components: {
        0: /* @__PURE__ */ jsx(Replay, { sx: {
          ml: 1
        } })
      } }) })
    ] });
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box, { sx: {
      mt: 2
    } }),
    /* @__PURE__ */ jsx(FormLabel, { className: "kyc_form", children: label }),
    /* @__PURE__ */ jsx(Box, { children }),
    lastUploadedFilename && status == 0 && /* @__PURE__ */ jsx(Typography, { color: "success.main", sx: {
      my: 1
    }, children: /* @__PURE__ */ jsx(Trans, { id: "Eh0/Yl", values: {
      lastUploadedFilename
    } }) }),
    status == 1 && /* @__PURE__ */ jsx(Typography, { color: "error.main", sx: {
      my: 1
    }, children: /* @__PURE__ */ jsx(Trans, { id: "oeV6qu" }) }),
    (existingToShow == null ? void 0 : existingToShow.length) > 0 && /* @__PURE__ */ jsxs(Box, { sx: {
      border: "1px solid #ccc",
      borderRadius: "10px",
      padding: 2,
      my: 2,
      width: "100%"
    }, children: [
      /* @__PURE__ */ jsx(Typography, { color: "brand.blue", children: allowMultipleFiles ? /* @__PURE__ */ jsx(Fragment, { children: "Uploaded files:" }) : /* @__PURE__ */ jsx(Fragment, { children: "Uploaded file:" }) }),
      /* @__PURE__ */ jsx(List, { children: existingToShow == null ? void 0 : existingToShow.map((file) => /* @__PURE__ */ jsx(ListItem, { children: /* @__PURE__ */ jsxs(Typography, { color: "brand.blue", children: [
        /* @__PURE__ */ jsx(InsertDriveFile, { sx: {
          fontSize: 16,
          mr: 1
        } }),
        file.filename
      ] }) }, file.id)) })
    ] }),
    /* @__PURE__ */ jsx(Box, { sx: {
      mt: 2
    }, children: clientSideFile ? uploadAndClearButtons() : chooseFileButton() })
  ] });
};
const KycFormInputWrapper = (props) => {
  if (props.hidden)
    return null;
  const asterisk = (
    // use browser default font for asterisk
    /* @__PURE__ */ jsx("span", { style: {
      color: "red",
      paddingRight: "4px",
      fontFamily: "initial"
    }, children: "*" })
  );
  return /* @__PURE__ */ jsxs(Box, { className: "kyc_input_form", children: [
    props.upperLabel && /* @__PURE__ */ jsxs(Box, { sx: {
      mb: 1
    }, children: [
      /* @__PURE__ */ jsx(FormLabel, { className: "kyc_form", children: /* @__PURE__ */ jsxs("span", { style: {
        fontSize: (props.headerFontSize || "16px") + " !important"
      }, children: [
        props.renderAsterisk && asterisk,
        props.upperLabel
      ] }) }),
      props.tooltipText && /* @__PURE__ */ jsx(Tooltip, { title: /* @__PURE__ */ jsx(Typography, { sx: {
        fontSize: "12px",
        whiteSpace: "pre-line"
      }, children: props.tooltipText }), placement: "right-start", children: /* @__PURE__ */ jsx(Help, { sx: {
        verticalAlign: "bottom",
        marginLeft: "6px",
        color: palette.brand[700],
        "&:hover": {
          color: palette.brand[500]
        }
      } }) })
    ] }),
    props.inputDescription && /* @__PURE__ */ jsxs(Typography, { sx: {
      color: "#aaa",
      mb: 2
    }, children: [
      props.renderAsterisk && !props.upperLabel && asterisk,
      props.inputDescription
    ] }),
    /* @__PURE__ */ jsxs(FormControl, { fullWidth: true, sx: {
      paddingBottom: props.upperLabel ? "16px" : "12px"
    }, children: [
      props.children,
      /* @__PURE__ */ jsx(FormHelperText, { children: props.error || "" })
    ] })
  ] });
};
function KycPhoneInput(props) {
  var _a, _b, _c;
  const {
    value,
    onChange,
    error,
    defaultCountry
  } = props;
  const muiInputStyles = (_c = (_b = (_a = MuiTheme$1.components) == null ? void 0 : _a.MuiInputBase) == null ? void 0 : _b.defaultProps) == null ? void 0 : _c.sx;
  return /* @__PURE__ */ jsx(PhoneInput, { value, country: defaultCountry || "us", onChange: (value2, countryData, event, formattedValue) => onChange(formattedValue), inputStyle: {
    width: "100%",
    fontFamily: "inherit",
    fontSize: "14px",
    height: "40px",
    // Same height of the MUI input
    borderRadius: muiInputStyles == null ? void 0 : muiInputStyles.borderRadius,
    borderColor: error ? palette.brand.errorRed : muiInputStyles == null ? void 0 : muiInputStyles.borderColor
  }, dropdownStyle: {
    borderRadius: muiInputStyles == null ? void 0 : muiInputStyles.borderRadius,
    fontSize: "10px"
  }, containerStyle: {
    position: "relative",
    width: "100%",
    fontFamily: "inherit"
  }, buttonStyle: {
    paddingLeft: "6px",
    fontSize: "22px",
    backgroundColor: "white",
    borderTopLeftRadius: muiInputStyles.borderRadius,
    borderBottomLeftRadius: muiInputStyles.borderRadius,
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px",
    borderRightWidth: "0px",
    borderColor: error ? palette.brand.errorRed : muiInputStyles == null ? void 0 : muiInputStyles.borderColor
  } });
}
const SidebarItem = ({
  isChecked,
  isHighlighted,
  name
}) => {
  const iconStyle = {
    color: "black",
    mr: "4px",
    width: "16px",
    height: "16px"
  };
  return /* @__PURE__ */ jsx(Box, { width: "fit-content", sx: {
    borderRadius: "20px",
    backgroundColor: isHighlighted ? "#F5F5F5" : "white",
    py: "3px",
    px: "13px",
    my: "8px"
  }, children: /* @__PURE__ */ jsxs(Box, { sx: {
    display: "flex",
    alignItems: "center"
  }, children: [
    isHighlighted && /* @__PURE__ */ jsx(Brightness1, { sx: __spreadValues({}, iconStyle) }),
    isChecked && /* @__PURE__ */ jsx(CheckCircle, { sx: __spreadValues({}, iconStyle) }),
    !isChecked && !isHighlighted && /* @__PURE__ */ jsx(RadioButtonUnchecked, { sx: __spreadValues({}, iconStyle) }),
    /* @__PURE__ */ jsx(Typography, { fontWeight: 700, children: name })
  ] }) });
};
const SidebarIndividual = ({
  tabs,
  currentTabId,
  buttonLabel,
  butonOnClick,
  buttonDisabled,
  isSubmitting
}) => {
  var _a;
  const currentTabIndex = (_a = tabs.find((tab2) => tab2.id === currentTabId)) == null ? void 0 : _a.index;
  return /* @__PURE__ */ jsxs(Box, { sx: {
    minWidth: {
      xs: "320px",
      xl: "384px"
    },
    maxWidth: {
      xs: "320px",
      xl: "384px"
    },
    marginTop: "20px",
    marginRight: 5,
    marginLeft: {
      xs: 2,
      s: 4,
      md: 6,
      lg: 8
    },
    py: "15px",
    top: "5px",
    height: "fit-content",
    position: "sticky",
    border: "1.5px solid #eee",
    borderRadius: "20px"
  }, children: [
    /* @__PURE__ */ jsx(Box, { sx: {
      display: "flex",
      alignItems: "center",
      ml: 2,
      mr: 1,
      mb: 2
    }, children: /* @__PURE__ */ jsx(Typography, { variant: "body1", fontWeight: 500, sx: {
      fontSize: {
        xs: "12px",
        md: "13px"
      },
      color: "gray"
    }, children: /* @__PURE__ */ jsx(Trans, { id: "6NP9nH" }) }) }),
    /* @__PURE__ */ jsxs(Box, { sx: {
      mx: 1
    }, children: [
      tabs.map((tab2) => /* @__PURE__ */ jsx(SidebarItem, { name: tab2.title, isChecked: tab2.index < (currentTabIndex || 1), isHighlighted: currentTabIndex === tab2.index }, tab2.id)),
      /* @__PURE__ */ jsx(Box, { sx: {
        mb: 4
      } }),
      /* @__PURE__ */ jsxs(Button, { id: "sidebar-submit", variant: "contained", onClick: butonOnClick, disabled: !!buttonDisabled, sx: {
        width: "100%",
        boxShadow: "none",
        borderRadius: "8px"
      }, size: "small", endIcon: /* @__PURE__ */ jsx(default_1$1, { color: "inherit" }), children: [
        isSubmitting && /* @__PURE__ */ jsx(CircularProgress, { size: 24, sx: {
          mr: 1
        } }),
        buttonLabel
      ] })
    ] })
  ] });
};
const DATE_ISO_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const capDateIsoToToday = (dateIsoString) => {
  let date2;
  const today2 = /* @__PURE__ */ new Date();
  const todayIsoString = dateToIsoString(today2);
  try {
    date2 = isoStringToDate(dateIsoString);
  } catch (e2) {
    return todayIsoString;
  }
  if (date2 > today2) {
    return todayIsoString;
  }
  return dateIsoString;
};
const dateIsoToDisplay = (dateIsoString) => {
  const date2 = isoStringToDate(dateIsoString);
  return hooks(date2).utc().format("MMM D, YYYY");
};
const isoStringToDate = (dateIsoString) => {
  if (!dateIsoString || !DATE_ISO_REGEX.test(dateIsoString)) {
    throw new Error("Invalid date ISO string");
  }
  return new Date(dateIsoString);
};
const dateToIsoString = (date2) => {
  return hooks(date2).utc().format("YYYY-MM-DD");
};
const today = () => {
  return /* @__PURE__ */ new Date();
};
const oneYearAgo = () => {
  const date2 = today();
  date2.setFullYear(date2.getFullYear() - 1);
  return date2;
};
const validateFormInputsAgainstRuleSet = (ruleSet, formInputs, formMetadata) => {
  const validationErrors = {};
  Object.keys(formInputs).forEach((fieldName) => {
    var _a, _b;
    const first_matched_rule_display = (_b = (_a = ruleSet[fieldName]) == null ? void 0 : _a.find((rule) => rule.condition_check(formInputs, fieldName, formMetadata || {}))) == null ? void 0 : _b.display(formInputs, fieldName, formMetadata || {});
    if (!!first_matched_rule_display) {
      validationErrors[fieldName] = {
        type: "custom",
        message: first_matched_rule_display
      };
    }
  });
  return validationErrors;
};
const validateQuestionnaireFormInputs = (questionnaire, formInputs) => {
  const validationErrors = {};
  const slugsToValidate = ["kyb_main_purpose", "wealth_sources", "funding_sources"];
  const requiredOtherSlugs = ["funding_sources", "wealth_sources"];
  questionnaire.questions.forEach((question) => {
    const choices = question.choices;
    const matchingInput = formInputs[question.slug];
    if (slugsToValidate.includes(question.slug) && matchingInput.length === 0) {
      validationErrors[question.slug] = {
        type: "custom",
        message: "This field is required"
      };
    }
    if (requiredOtherSlugs.includes(question.slug) && matchingInput.length > 0) {
      const isOtherSelected = choices == null ? void 0 : choices.find((choice) => matchingInput.includes(choice.id) && choice.text === "Other");
      const othersFieldInput = formInputs[`${question.slug}_other`];
      if (isOtherSelected) {
        if (!othersFieldInput) {
          validationErrors[`${question.slug}_other`] = {
            type: "custom",
            message: "This field is required"
          };
        } else if (othersFieldInput.length < 10) {
          validationErrors[`${question.slug}_other`] = {
            type: "custom",
            message: "At least 10 characters required"
          };
        }
      }
    }
    if (!question.isOptional && !matchingInput) {
      validationErrors[question.slug] = {
        type: "custom",
        message: "This field is required"
      };
    }
    if (!question.isOptional && question.answerType === "Questionnaires::FreeformAnswer") {
      const minLength = question.displayAs === "TEXT_INPUT_SINGLELINE" ? 5 : 10;
      if (matchingInput.length < minLength) {
        validationErrors[question.slug] = {
          type: "custom",
          message: `At least ${minLength} characters required`
        };
      }
    }
  });
  return validationErrors;
};
const getNonMatchingCharacters = (str, regex) => {
  return [...str].filter((char2) => !regex.test(char2));
};
const REGEX_TRUNARRATIVE_TEXT = /^[‘’“”–=\uab30-\uab6f-\u0000-\u003B\u003F-\u007e\u0080-þĀ-žƀ-ɎḀ-ỾⱠ-\u2c7e꜠-ꟾЀ-ӾԀ-\u052e\u2de0-\u2dfeꙀ-\ua69e\u0600-۾ݐ-ݾ\u08a0-\u08feﭐ-\ufdfeﹰ-\ufefe\ude00-\udefe\u3040-\u309f\u30a0-\u30ff\u4E00-\u9FA0\u3000-〾\u0370-\u03FFи́\r\n]+$/;
const REGEX_DATESTRING = /^\d{4}-\d{2}-\d{2}$/;
const REGEX_US_POSTAL_CODE = /^[0-9]{5}(?:-[0-9]{4})?$/;
const REGEX_US_SSN = /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/;
const _rule = (display, condition_check) => ({
  display,
  condition_check
});
const _rule_not_empty = _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "Can not be empty" }), (payload, key) => payload[key] === void 0 || payload[key] === "");
const _rule_is_valid_datestring = _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "Must be a valid date" }), (payload, key) => {
  return !REGEX_DATESTRING.test(payload[key] || "");
});
const _rule_min_length = (min_length) => _rule(() => /* @__PURE__ */ jsxs(Fragment, { children: [
  "Must have at least ",
  min_length,
  " characters"
] }), (payload, key) => (payload[key] || "").length < min_length);
const _rule_max_length = (max_length) => _rule(() => /* @__PURE__ */ jsxs(Fragment, { children: [
  "Must have at most ",
  max_length,
  " characters"
] }), (payload, key) => (payload[key] || "").length > max_length);
const _rules_between_length = (min_length, max_length) => [_rule_min_length(min_length), _rule_max_length(max_length)];
const _rule_regex_tn_text = _rule(
  // Rule output is a little misleading, as we also support space, /, -, !, ., +, comma, _, (), %, #, @, &, ', ",
  // But best to be concise in our messaging about what is allowed
  (payload, key) => /* @__PURE__ */ jsxs(Fragment, { children: [
    "Characters",
    " ",
    getNonMatchingCharacters(payload[key], REGEX_TRUNARRATIVE_TEXT).join(""),
    " ",
    "are not supported"
  ] }),
  (payload, key) => {
    if (!payload[key]) {
      return false;
    }
    return !REGEX_TRUNARRATIVE_TEXT.test(payload[key]);
  }
);
const AddressFormsRules = {
  streetAddress: [_rule_not_empty, ..._rules_between_length(2, 255), _rule_regex_tn_text],
  city: [_rule_not_empty, ..._rules_between_length(2, 50), _rule_regex_tn_text],
  country: [_rule_not_empty, _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "Selected country is invalid." }), (payload, key, formMetadata) => {
    const country = payload[key];
    return !(country in formMetadata.globalConstants.geography.countries);
  }), _rule(() => /* @__PURE__ */ jsxs(Fragment, { children: [
    "The country you selected is not supported.",
    /* @__PURE__ */ jsx("br", {}),
    "You can review our unsupported jurisdictions and legal disclosures",
    " ",
    /* @__PURE__ */ jsx(Link, { style: {
      color: "red"
    }, href: "https://coinlist.co/legal", children: "here." })
  ] }), (payload, key, formMetadata) => {
    if (!formMetadata.checkWalletEligibility) {
      return false;
    }
    const country = payload[key];
    const countryConfig = formMetadata.globalConstants.geography.countries[country];
    const isWalletInelligible = countryConfig.is_wallets_services_blocked || countryConfig.is_wallets_services_to_be_blocked;
    return isWalletInelligible;
  }), _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "The country you selected is not supported." }), (payload, key, formMetadata) => {
    if (!formMetadata.checkCustomListOfCountries) {
      return false;
    }
    const inputCountry = payload["country"];
    return !formMetadata.checkCustomListOfCountries.includes(inputCountry);
  }), _rule_regex_tn_text],
  postalCode: [_rule_not_empty, ..._rules_between_length(2, 10), _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "US postal codes must be five-digit or nine-digit (12345 and 12345-6789)" }), (payload, key) => payload["country"] === "US" && !REGEX_US_POSTAL_CODE.test(payload[key])), _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "US postal codes must be 5 digits" }), (payload, key) => payload["country"] === "US" && payload[key].length !== 5)],
  region: [_rule_not_empty, _rule_min_length(2), _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "Region or province you selected is invalid." }), (payload, key, formMetadata) => {
    const inputCountry = payload["country"];
    const inputState = payload[key];
    const statesConfig = formMetadata.globalConstants.geography.states;
    if (!(inputCountry in statesConfig) || statesConfig[inputCountry] === 0) {
      return false;
    }
    if (!(inputState in statesConfig[inputCountry])) {
      return true;
    }
    const isValid2 = statesConfig[inputCountry][inputState].allowed_selection;
    return !isValid2;
  }), _rule(() => /* @__PURE__ */ jsxs(Fragment, { children: [
    "The region you selected is not supported.",
    /* @__PURE__ */ jsx("br", {}),
    "You can review our unsupported jurisdictions and legal disclosures",
    " ",
    /* @__PURE__ */ jsx(Link, { style: {
      color: "red"
    }, href: "https://coinlist.co/legal", children: "here." })
  ] }), (payload, key, formMetadata) => {
    if (!formMetadata.checkWalletEligibility) {
      return false;
    }
    const inputCountry = payload["country"];
    const inputState = payload[key];
    const statesConfig = formMetadata.globalConstants.geography.states[inputCountry];
    if (!statesConfig || statesConfig[inputCountry] === 0) {
      return false;
    }
    if (!(inputState in statesConfig)) {
      return false;
    }
    return statesConfig[inputState].is_wallets_blocked_state_wide;
  }), _rule_regex_tn_text]
};
const PersonRules = __spreadValues({
  title: [_rule_not_empty, ..._rules_between_length(2, 255), _rule_regex_tn_text],
  firstName: [_rule_not_empty, ..._rules_between_length(2, 50), _rule_regex_tn_text],
  lastName: [_rule_not_empty, ..._rules_between_length(2, 50), _rule_regex_tn_text],
  middleName: [_rule_regex_tn_text],
  dateOfBirth: [_rule_not_empty, _rule_is_valid_datestring, _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "Can not be a date in the future" }), (payload, key) => new Date(payload[key]) > /* @__PURE__ */ new Date()), _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "You must be at least 18 years old to use this service" }), (payload, key) => {
    const date2 = new Date(payload[key]);
    const today2 = /* @__PURE__ */ new Date();
    const eighteenYearsAgo = new Date(today2.getFullYear() - 18, today2.getMonth(), today2.getDate());
    return date2 > eighteenYearsAgo;
  }), _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "Date must not be older than 100 years ago" }), (payload, key) => {
    const date2 = new Date(payload[key]);
    const today2 = /* @__PURE__ */ new Date();
    const oneHundredYearsAgo = new Date(today2.getFullYear() - 100, today2.getMonth(), today2.getDate());
    return date2 < oneHundredYearsAgo;
  })],
  stateIdentifier: [_rule(() => /* @__PURE__ */ jsx(Fragment, { children: "Required for US residents" }), (payload, key) => payload["country"] === "US" && (payload[key] || "").length === 0), _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "SSN must be of format XXX-XX-XXXX" }), (payload, key) => payload["country"] === "US" && !REGEX_US_SSN.test(payload[key]))],
  occupation: [_rule_not_empty, ..._rules_between_length(2, 255), _rule_regex_tn_text],
  phoneNumber: [
    _rule_not_empty,
    // TODO: ED - worthwhile to explore libs that validates phone numbers depending on different
    // country code extensions. See (npmjs.com/package/google-libphonenumber)
    // For now, we'll just validate length is reasonable.
    _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "Phone number is invalid" }), (payload, key) => (payload[key] || "").length < 10)
  ]
}, AddressFormsRules);
const CompanyDocumentationPanelRules = {
  dbaName: [_rule_not_empty, ..._rules_between_length(2, 255), _rule_regex_tn_text],
  legalName: [_rule_not_empty, ..._rules_between_length(2, 255), _rule_regex_tn_text],
  taxIdNumber: [_rule(() => /* @__PURE__ */ jsx(Fragment, { children: "For US residents only" }), (payload, key) => {
    return payload["countryOfIncorporation"] !== "US" && (payload[key] || "").length > 0;
  }), _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "Tax ID must be of format XX-XXXXXXX or XXXXXXXXX" }), (payload, key) => payload["countryOfIncorporation"] === "US" && !(/^\d{2}-\d{7}$/.test(payload[key]) || /^\d{9}$/.test(payload[key]) || (payload[key] || "").length == 0))],
  regionOfIncorporation: [_rule_not_empty, ..._rules_between_length(2, 255)],
  countryOfIncorporation: [_rule_not_empty, _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "Country is Invalid" }), (payload, key) => Object.keys(index_es5_minExports.countries).find((country) => country === payload[key]) === void 0)],
  incorporatedOn: [_rule_not_empty, _rule_is_valid_datestring, _rule(() => /* @__PURE__ */ jsx(Fragment, { children: "Can not be a date in the future" }), (payload, key) => new Date(payload[key]) > /* @__PURE__ */ new Date())],
  servicesProvided: [_rule_not_empty, ..._rules_between_length(50, 500), _rule_regex_tn_text],
  industry: [_rule_not_empty, _rule_max_length(600), _rule_regex_tn_text]
  // Business Ops Address should be validated with AddressFormsRules
};
const TrustDocumentationPanelRules = {
  legalName: CompanyDocumentationPanelRules.legalName,
  taxIdNumber: CompanyDocumentationPanelRules.taxIdNumber
  // Business Ops Address should be validated with AddressFormsRules
};
const formatSSN = (value) => {
  if (!value)
    return value;
  const ssn = value.replace(/[^\d]/g, "");
  if (ssn.length < 4)
    return ssn;
  if (ssn.length < 6) {
    return `${ssn.slice(0, 3)}-${ssn.slice(3)}`;
  }
  return `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.slice(5, 9)}`;
};
var isCheckBoxInput = (element2) => element2.type === "checkbox";
var isDateObject = (value) => value instanceof Date;
var isNullOrUndefined = (value) => value == null;
const isObjectType = (value) => typeof value === "object";
var isObject$1 = (value) => !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value);
var getEventValue = (event) => isObject$1(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));
var isPlainObject2 = (tempObject) => {
  const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
  return isObject$1(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function cloneObject(data) {
  let copy2;
  const isArray3 = Array.isArray(data);
  if (data instanceof Date) {
    copy2 = new Date(data);
  } else if (data instanceof Set) {
    copy2 = new Set(data);
  } else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray3 || isObject$1(data))) {
    copy2 = isArray3 ? [] : {};
    if (!isArray3 && !isPlainObject2(data)) {
      copy2 = data;
    } else {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          copy2[key] = cloneObject(data[key]);
        }
      }
    }
  } else {
    return data;
  }
  return copy2;
}
var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];
var isUndefined = (val) => val === void 0;
var get = (obj, path2, defaultValue) => {
  if (!path2 || !isObject$1(obj)) {
    return defaultValue;
  }
  const result = compact(path2.split(/[,[\].]+?/)).reduce((result2, key) => isNullOrUndefined(result2) ? result2 : result2[key], obj);
  return isUndefined(result) || result === obj ? isUndefined(obj[path2]) ? defaultValue : obj[path2] : result;
};
var isBoolean = (value) => typeof value === "boolean";
const EVENTS = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
};
const VALIDATION_MODE = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
};
const INPUT_VALIDATION_RULES = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
const HookFormContext = React__default.createContext(null);
const useFormContext = () => React__default.useContext(HookFormContext);
const FormProvider = (props) => {
  const _a = props, { children } = _a, data = __objRest(_a, ["children"]);
  return React__default.createElement(HookFormContext.Provider, { value: data }, children);
};
var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
  const result = {
    defaultValues: control._defaultValues
  };
  for (const key in formState) {
    Object.defineProperty(result, key, {
      get: () => {
        const _key = key;
        if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
          control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
        }
        localProxyFormState && (localProxyFormState[_key] = true);
        return formState[_key];
      }
    });
  }
  return result;
};
var isEmptyObject = (value) => isObject$1(value) && !Object.keys(value).length;
var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
  updateFormState(formStateData);
  const _a = formStateData, { name } = _a, formState = __objRest(_a, ["name"]);
  return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key) => _proxyFormState[key] === (!isRoot || VALIDATION_MODE.all));
};
var convertToArrayPayload = (value) => Array.isArray(value) ? value : [value];
var shouldSubscribeByName = (name, signalName, exact) => exact && signalName ? name === signalName || Array.isArray(name) && name.some((currentName) => currentName && exact && currentName === signalName) : !name || !signalName || name === signalName || convertToArrayPayload(name).some((currentName) => currentName && (currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function useSubscribe(props) {
  const _props = React__default.useRef(props);
  _props.current = props;
  React__default.useEffect(() => {
    const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
      next: _props.current.next
    });
    return () => {
      subscription && subscription.unsubscribe();
    };
  }, [props.disabled]);
}
function useFormState(props) {
  const methods = useFormContext();
  const { control = methods.control, disabled, name, exact } = props || {};
  const [formState, updateFormState] = React__default.useState(control._formState);
  const _mounted = React__default.useRef(true);
  const _localProxyFormState = React__default.useRef({
    isDirty: false,
    isLoading: false,
    dirtyFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  });
  const _name = React__default.useRef(name);
  _name.current = name;
  useSubscribe({
    disabled,
    next: (value) => _mounted.current && shouldSubscribeByName(_name.current, value.name, exact) && shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) && updateFormState(__spreadValues(__spreadValues({}, control._formState), value)),
    subject: control._subjects.state
  });
  React__default.useEffect(() => {
    _mounted.current = true;
    _localProxyFormState.current.isValid && control._updateValid(true);
    return () => {
      _mounted.current = false;
    };
  }, [control]);
  return getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var isString = (value) => typeof value === "string";
var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
  if (isString(names)) {
    isGlobal && _names.watch.add(names);
    return get(formValues, names, defaultValue);
  }
  if (Array.isArray(names)) {
    return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
  }
  isGlobal && (_names.watchAll = true);
  return formValues;
};
function useWatch(props) {
  const methods = useFormContext();
  const { control = methods.control, name, defaultValue, disabled, exact } = props || {};
  const _name = React__default.useRef(name);
  _name.current = name;
  useSubscribe({
    disabled,
    subject: control._subjects.values,
    next: (formState) => {
      if (shouldSubscribeByName(_name.current, formState.name, exact)) {
        updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
      }
    }
  });
  const [value, updateValue] = React__default.useState(control._getWatch(name, defaultValue));
  React__default.useEffect(() => control._removeUnmounted());
  return value;
}
var isKey = (value) => /^\w*$/.test(value);
var stringToPath = (input) => compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
function set(object, path2, value) {
  let index2 = -1;
  const tempPath = isKey(path2) ? [path2] : stringToPath(path2);
  const length2 = tempPath.length;
  const lastIndex = length2 - 1;
  while (++index2 < length2) {
    const key = tempPath[index2];
    let newValue = value;
    if (index2 !== lastIndex) {
      const objValue = object[key];
      newValue = isObject$1(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index2 + 1]) ? [] : {};
    }
    object[key] = newValue;
    object = object[key];
  }
  return object;
}
function useController(props) {
  const methods = useFormContext();
  const { name, disabled, control = methods.control, shouldUnregister } = props;
  const isArrayField = isNameInFieldArray(control._names.array, name);
  const value = useWatch({
    control,
    name,
    defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
    exact: true
  });
  const formState = useFormState({
    control,
    name
  });
  const _registerProps = React__default.useRef(control.register(name, __spreadProps(__spreadValues({}, props.rules), {
    value
  })));
  _registerProps.current = control.register(name, props.rules);
  React__default.useEffect(() => {
    const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
    const updateMounted = (name2, value2) => {
      const field = get(control._fields, name2);
      if (field) {
        field._f.mount = value2;
      }
    };
    updateMounted(name, true);
    if (_shouldUnregisterField) {
      const value2 = cloneObject(get(control._options.defaultValues, name));
      set(control._defaultValues, name, value2);
      if (isUndefined(get(control._formValues, name))) {
        set(control._formValues, name, value2);
      }
    }
    return () => {
      (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
    };
  }, [name, control, isArrayField, shouldUnregister]);
  React__default.useEffect(() => {
    control._updateDisabledField({
      disabled,
      fields: control._fields,
      name
    });
  }, [disabled, name, control]);
  return {
    field: __spreadProps(__spreadValues({
      name,
      value
    }, isBoolean(disabled) ? { disabled } : {}), {
      onChange: React__default.useCallback((event) => _registerProps.current.onChange({
        target: {
          value: getEventValue(event),
          name
        },
        type: EVENTS.CHANGE
      }), [name]),
      onBlur: React__default.useCallback(() => _registerProps.current.onBlur({
        target: {
          value: get(control._formValues, name),
          name
        },
        type: EVENTS.BLUR
      }), [name, control]),
      ref: (elm) => {
        const field = get(control._fields, name);
        if (field && elm) {
          field._f.ref = {
            focus: () => elm.focus(),
            select: () => elm.select(),
            setCustomValidity: (message) => elm.setCustomValidity(message),
            reportValidity: () => elm.reportValidity()
          };
        }
      }
    }),
    formState,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: true,
        get: () => !!get(formState.errors, name)
      },
      isDirty: {
        enumerable: true,
        get: () => !!get(formState.dirtyFields, name)
      },
      isTouched: {
        enumerable: true,
        get: () => !!get(formState.touchedFields, name)
      },
      error: {
        enumerable: true,
        get: () => get(formState.errors, name)
      }
    })
  };
}
const Controller = (props) => props.render(useController(props));
var appendErrors = (name, validateAllFieldCriteria, errors2, type, message) => validateAllFieldCriteria ? __spreadProps(__spreadValues({}, errors2[name]), {
  types: __spreadProps(__spreadValues({}, errors2[name] && errors2[name].types ? errors2[name].types : {}), {
    [type]: message || true
  })
}) : {};
const focusFieldBy = (fields, callback, fieldsNames) => {
  for (const key of fieldsNames || Object.keys(fields)) {
    const field = get(fields, key);
    if (field) {
      const _a = field, { _f } = _a, currentField = __objRest(_a, ["_f"]);
      if (_f && callback(_f.name)) {
        if (_f.ref.focus) {
          _f.ref.focus();
          break;
        } else if (_f.refs && _f.refs[0].focus) {
          _f.refs[0].focus();
          break;
        }
      } else if (isObject$1(currentField)) {
        focusFieldBy(currentField, callback);
      }
    }
  }
};
var getValidationModes = (mode) => ({
  isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
  isOnBlur: mode === VALIDATION_MODE.onBlur,
  isOnChange: mode === VALIDATION_MODE.onChange,
  isOnAll: mode === VALIDATION_MODE.all,
  isOnTouch: mode === VALIDATION_MODE.onTouched
});
var isWatched = (name, _names, isBlurEvent) => !isBlurEvent && (_names.watchAll || _names.watch.has(name) || [..._names.watch].some((watchName) => name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
var updateFieldArrayRootError = (errors2, error, name) => {
  const fieldArrayErrors = compact(get(errors2, name));
  set(fieldArrayErrors, "root", error[name]);
  set(errors2, name, fieldArrayErrors);
  return errors2;
};
var isFileInput = (element2) => element2.type === "file";
var isFunction = (value) => typeof value === "function";
var isHTMLElement = (value) => {
  if (!isWeb) {
    return false;
  }
  const owner = value ? value.ownerDocument : 0;
  return value instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var isMessage = (value) => isString(value);
var isRadioInput = (element2) => element2.type === "radio";
var isRegex = (value) => value instanceof RegExp;
const defaultResult = {
  value: false,
  isValid: false
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      const values2 = options.filter((option) => option && option.checked && !option.disabled).map((option) => option.value);
      return { value: values2, isValid: !!values2.length };
    }
    return options[0].checked && !options[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === "" ? validResult : { value: options[0].value, isValid: true } : validResult
    ) : defaultResult;
  }
  return defaultResult;
};
const defaultReturn = {
  isValid: false,
  value: null
};
var getRadioValue = (options) => Array.isArray(options) ? options.reduce((previous2, option) => option && option.checked && !option.disabled ? {
  isValid: true,
  value: option.value
} : previous2, defaultReturn) : defaultReturn;
function getValidateError(result, ref, type = "validate") {
  if (isMessage(result) || Array.isArray(result) && result.every(isMessage) || isBoolean(result) && !result) {
    return {
      type,
      message: isMessage(result) ? result : "",
      ref
    };
  }
}
var getValueAndMessage = (validationData) => isObject$1(validationData) && !isRegex(validationData) ? validationData : {
  value: validationData,
  message: ""
};
var validateField = (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => __async(void 0, null, function* () {
  const { ref, refs, required, maxLength, minLength, min: min2, max: max2, pattern, validate, name, valueAsNumber, mount, disabled } = field._f;
  const inputValue = get(formValues, name);
  if (!mount || disabled) {
    return {};
  }
  const inputRef = refs ? refs[0] : ref;
  const setCustomValidity = (message) => {
    if (shouldUseNativeValidation && inputRef.reportValidity) {
      inputRef.setCustomValidity(isBoolean(message) ? "" : message || "");
      inputRef.reportValidity();
    }
  };
  const error = {};
  const isRadio = isRadioInput(ref);
  const isCheckBox = isCheckBoxInput(ref);
  const isRadioOrCheckbox2 = isRadio || isCheckBox;
  const isEmpty2 = (valueAsNumber || isFileInput(ref)) && isUndefined(ref.value) && isUndefined(inputValue) || isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
  const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
  const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
    const message = exceedMax ? maxLengthMessage : minLengthMessage;
    error[name] = __spreadValues({
      type: exceedMax ? maxType : minType,
      message,
      ref
    }, appendErrorsCurry(exceedMax ? maxType : minType, message));
  };
  if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox2 && (isEmpty2 || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid)) {
    const { value, message } = isMessage(required) ? { value: !!required, message: required } : getValueAndMessage(required);
    if (value) {
      error[name] = __spreadValues({
        type: INPUT_VALIDATION_RULES.required,
        message,
        ref: inputRef
      }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));
      if (!validateAllFieldCriteria) {
        setCustomValidity(message);
        return error;
      }
    }
  }
  if (!isEmpty2 && (!isNullOrUndefined(min2) || !isNullOrUndefined(max2))) {
    let exceedMax;
    let exceedMin;
    const maxOutput = getValueAndMessage(max2);
    const minOutput = getValueAndMessage(min2);
    if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
      const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
      if (!isNullOrUndefined(maxOutput.value)) {
        exceedMax = valueNumber > maxOutput.value;
      }
      if (!isNullOrUndefined(minOutput.value)) {
        exceedMin = valueNumber < minOutput.value;
      }
    } else {
      const valueDate = ref.valueAsDate || new Date(inputValue);
      const convertTimeToDate = (time) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + time);
      const isTime = ref.type == "time";
      const isWeek = ref.type == "week";
      if (isString(maxOutput.value) && inputValue) {
        exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
      }
      if (isString(minOutput.value) && inputValue) {
        exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
      }
    }
    if (exceedMax || exceedMin) {
      getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error[name].message);
        return error;
      }
    }
  }
  if ((maxLength || minLength) && !isEmpty2 && (isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
    const maxLengthOutput = getValueAndMessage(maxLength);
    const minLengthOutput = getValueAndMessage(minLength);
    const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
    const exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
    if (exceedMax || exceedMin) {
      getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error[name].message);
        return error;
      }
    }
  }
  if (pattern && !isEmpty2 && isString(inputValue)) {
    const { value: patternValue, message } = getValueAndMessage(pattern);
    if (isRegex(patternValue) && !inputValue.match(patternValue)) {
      error[name] = __spreadValues({
        type: INPUT_VALIDATION_RULES.pattern,
        message,
        ref
      }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message));
      if (!validateAllFieldCriteria) {
        setCustomValidity(message);
        return error;
      }
    }
  }
  if (validate) {
    if (isFunction(validate)) {
      const result = yield validate(inputValue, formValues);
      const validateError = getValidateError(result, inputRef);
      if (validateError) {
        error[name] = __spreadValues(__spreadValues({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));
        if (!validateAllFieldCriteria) {
          setCustomValidity(validateError.message);
          return error;
        }
      }
    } else if (isObject$1(validate)) {
      let validationResult = {};
      for (const key in validate) {
        if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
          break;
        }
        const validateError = getValidateError(yield validate[key](inputValue, formValues), inputRef, key);
        if (validateError) {
          validationResult = __spreadValues(__spreadValues({}, validateError), appendErrorsCurry(key, validateError.message));
          setCustomValidity(validateError.message);
          if (validateAllFieldCriteria) {
            error[name] = validationResult;
          }
        }
      }
      if (!isEmptyObject(validationResult)) {
        error[name] = __spreadValues({
          ref: inputRef
        }, validationResult);
        if (!validateAllFieldCriteria) {
          return error;
        }
      }
    }
  }
  setCustomValidity(true);
  return error;
});
function baseGet(object, updatePath) {
  const length2 = updatePath.slice(0, -1).length;
  let index2 = 0;
  while (index2 < length2) {
    object = isUndefined(object) ? index2++ : object[updatePath[index2++]];
  }
  return object;
}
function isEmptyArray(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
      return false;
    }
  }
  return true;
}
function unset(object, path2) {
  const paths = Array.isArray(path2) ? path2 : isKey(path2) ? [path2] : stringToPath(path2);
  const childObject = paths.length === 1 ? object : baseGet(object, paths);
  const index2 = paths.length - 1;
  const key = paths[index2];
  if (childObject) {
    delete childObject[key];
  }
  if (index2 !== 0 && (isObject$1(childObject) && isEmptyObject(childObject) || Array.isArray(childObject) && isEmptyArray(childObject))) {
    unset(object, paths.slice(0, -1));
  }
  return object;
}
function createSubject() {
  let _observers = [];
  const next2 = (value) => {
    for (const observer of _observers) {
      observer.next && observer.next(value);
    }
  };
  const subscribe = (observer) => {
    _observers.push(observer);
    return {
      unsubscribe: () => {
        _observers = _observers.filter((o) => o !== observer);
      }
    };
  };
  const unsubscribe = () => {
    _observers = [];
  };
  return {
    get observers() {
      return _observers;
    },
    next: next2,
    subscribe,
    unsubscribe
  };
}
var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);
function deepEqual(object1, object2) {
  if (isPrimitive(object1) || isPrimitive(object2)) {
    return object1 === object2;
  }
  if (isDateObject(object1) && isDateObject(object2)) {
    return object1.getTime() === object2.getTime();
  }
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    const val1 = object1[key];
    if (!keys2.includes(key)) {
      return false;
    }
    if (key !== "ref") {
      const val2 = object2[key];
      if (isDateObject(val1) && isDateObject(val2) || isObject$1(val1) && isObject$1(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual(val1, val2) : val1 !== val2) {
        return false;
      }
    }
  }
  return true;
}
var isMultipleSelect = (element2) => element2.type === `select-multiple`;
var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);
var live = (ref) => isHTMLElement(ref) && ref.isConnected;
var objectHasFunction = (data) => {
  for (const key in data) {
    if (isFunction(data[key])) {
      return true;
    }
  }
  return false;
};
function markFieldsDirty(data, fields = {}) {
  const isParentNodeArray = Array.isArray(data);
  if (isObject$1(data) || isParentNodeArray) {
    for (const key in data) {
      if (Array.isArray(data[key]) || isObject$1(data[key]) && !objectHasFunction(data[key])) {
        fields[key] = Array.isArray(data[key]) ? [] : {};
        markFieldsDirty(data[key], fields[key]);
      } else if (!isNullOrUndefined(data[key])) {
        fields[key] = true;
      }
    }
  }
  return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
  const isParentNodeArray = Array.isArray(data);
  if (isObject$1(data) || isParentNodeArray) {
    for (const key in data) {
      if (Array.isArray(data[key]) || isObject$1(data[key]) && !objectHasFunction(data[key])) {
        if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) {
          dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? markFieldsDirty(data[key], []) : __spreadValues({}, markFieldsDirty(data[key]));
        } else {
          getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        }
      } else {
        dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
      }
    }
  }
  return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));
var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value) ? value : valueAsNumber ? value === "" ? NaN : value ? +value : value : valueAsDate && isString(value) ? new Date(value) : setValueAs ? setValueAs(value) : value;
function getFieldValue(_f) {
  const ref = _f.ref;
  if (_f.refs ? _f.refs.every((ref2) => ref2.disabled) : ref.disabled) {
    return;
  }
  if (isFileInput(ref)) {
    return ref.files;
  }
  if (isRadioInput(ref)) {
    return getRadioValue(_f.refs).value;
  }
  if (isMultipleSelect(ref)) {
    return [...ref.selectedOptions].map(({ value }) => value);
  }
  if (isCheckBoxInput(ref)) {
    return getCheckboxValue(_f.refs).value;
  }
  return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
  const fields = {};
  for (const name of fieldsNames) {
    const field = get(_fields, name);
    field && set(fields, name, field._f);
  }
  return {
    criteriaMode,
    names: [...fieldsNames],
    fields,
    shouldUseNativeValidation
  };
};
var getRuleValue = (rule) => isUndefined(rule) ? rule : isRegex(rule) ? rule.source : isObject$1(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
var hasValidation = (options) => options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function schemaErrorLookup(errors2, _fields, name) {
  const error = get(errors2, name);
  if (error || isKey(name)) {
    return {
      error,
      name
    };
  }
  const names = name.split(".");
  while (names.length) {
    const fieldName = names.join(".");
    const field = get(_fields, fieldName);
    const foundError = get(errors2, fieldName);
    if (field && !Array.isArray(field) && name !== fieldName) {
      return { name };
    }
    if (foundError && foundError.type) {
      return {
        name: fieldName,
        error: foundError
      };
    }
    names.pop();
  }
  return {
    name
  };
}
var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
  if (mode.isOnAll) {
    return false;
  } else if (!isSubmitted && mode.isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
    return isBlurEvent;
  }
  return true;
};
var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);
const defaultOptions = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: true
};
function createFormControl(props = {}, flushRootRender) {
  let _options = __spreadValues(__spreadValues({}, defaultOptions), props);
  let _formState = {
    submitCount: 0,
    isDirty: false,
    isLoading: isFunction(_options.defaultValues),
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    errors: {}
  };
  let _fields = {};
  let _defaultValues = isObject$1(_options.defaultValues) || isObject$1(_options.values) ? cloneObject(_options.defaultValues || _options.values) || {} : {};
  let _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
  let _state = {
    action: false,
    mount: false,
    watch: false
  };
  let _names = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  };
  let delayErrorCallback;
  let timer = 0;
  const _proxyFormState = {
    isDirty: false,
    dirtyFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  };
  const _subjects = {
    values: createSubject(),
    array: createSubject(),
    state: createSubject()
  };
  const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
  const validationModeBeforeSubmit = getValidationModes(_options.mode);
  const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
  const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
  const debounce2 = (callback) => (wait) => {
    clearTimeout(timer);
    timer = setTimeout(callback, wait);
  };
  const _updateValid = (shouldUpdateValid) => __async(this, null, function* () {
    if (_proxyFormState.isValid || shouldUpdateValid) {
      const isValid2 = _options.resolver ? isEmptyObject((yield _executeSchema()).errors) : yield executeBuiltInValidation(_fields, true);
      if (isValid2 !== _formState.isValid) {
        _subjects.state.next({
          isValid: isValid2
        });
      }
    }
  });
  const _updateIsValidating = (value) => _proxyFormState.isValidating && _subjects.state.next({
    isValidating: value
  });
  const _updateFieldArray = (name, values2 = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
    if (args && method) {
      _state.action = true;
      if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
        const fieldValues = method(get(_fields, name), args.argA, args.argB);
        shouldSetValues && set(_fields, name, fieldValues);
      }
      if (shouldUpdateFieldsAndState && Array.isArray(get(_formState.errors, name))) {
        const errors2 = method(get(_formState.errors, name), args.argA, args.argB);
        shouldSetValues && set(_formState.errors, name, errors2);
        unsetEmptyArray(_formState.errors, name);
      }
      if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray(get(_formState.touchedFields, name))) {
        const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
        shouldSetValues && set(_formState.touchedFields, name, touchedFields);
      }
      if (_proxyFormState.dirtyFields) {
        _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
      }
      _subjects.state.next({
        name,
        isDirty: _getDirty(name, values2),
        dirtyFields: _formState.dirtyFields,
        errors: _formState.errors,
        isValid: _formState.isValid
      });
    } else {
      set(_formValues, name, values2);
    }
  };
  const updateErrors = (name, error) => {
    set(_formState.errors, name, error);
    _subjects.state.next({
      errors: _formState.errors
    });
  };
  const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
    const field = get(_fields, name);
    if (field) {
      const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
      isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
      _state.mount && _updateValid();
    }
  };
  const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
    let shouldUpdateField = false;
    let isPreviousDirty = false;
    const output = {
      name
    };
    if (!isBlurEvent || shouldDirty) {
      if (_proxyFormState.isDirty) {
        isPreviousDirty = _formState.isDirty;
        _formState.isDirty = output.isDirty = _getDirty();
        shouldUpdateField = isPreviousDirty !== output.isDirty;
      }
      const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
      isPreviousDirty = get(_formState.dirtyFields, name);
      isCurrentFieldPristine ? unset(_formState.dirtyFields, name) : set(_formState.dirtyFields, name, true);
      output.dirtyFields = _formState.dirtyFields;
      shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
    }
    if (isBlurEvent) {
      const isPreviousFieldTouched = get(_formState.touchedFields, name);
      if (!isPreviousFieldTouched) {
        set(_formState.touchedFields, name, isBlurEvent);
        output.touchedFields = _formState.touchedFields;
        shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
      }
    }
    shouldUpdateField && shouldRender && _subjects.state.next(output);
    return shouldUpdateField ? output : {};
  };
  const shouldRenderByError = (name, isValid2, error, fieldState) => {
    const previousFieldError = get(_formState.errors, name);
    const shouldUpdateValid = _proxyFormState.isValid && isBoolean(isValid2) && _formState.isValid !== isValid2;
    if (props.delayError && error) {
      delayErrorCallback = debounce2(() => updateErrors(name, error));
      delayErrorCallback(props.delayError);
    } else {
      clearTimeout(timer);
      delayErrorCallback = null;
      error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
    }
    if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
      const updatedFormState = __spreadProps(__spreadValues(__spreadValues({}, fieldState), shouldUpdateValid && isBoolean(isValid2) ? { isValid: isValid2 } : {}), {
        errors: _formState.errors,
        name
      });
      _formState = __spreadValues(__spreadValues({}, _formState), updatedFormState);
      _subjects.state.next(updatedFormState);
    }
    _updateIsValidating(false);
  };
  const _executeSchema = (name) => __async(this, null, function* () {
    return _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
  });
  const executeSchemaAndUpdateState = (names) => __async(this, null, function* () {
    const { errors: errors2 } = yield _executeSchema(names);
    if (names) {
      for (const name of names) {
        const error = get(errors2, name);
        error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
      }
    } else {
      _formState.errors = errors2;
    }
    return errors2;
  });
  const executeBuiltInValidation = (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (fields, shouldOnlyCheckValid, context = {
    valid: true
  }) {
    for (const name in fields) {
      const field = fields[name];
      if (field) {
        const _a = field, { _f } = _a, fieldValue = __objRest(_a, ["_f"]);
        if (_f) {
          const isFieldArrayRoot = _names.array.has(_f.name);
          const fieldError = yield validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
          if (fieldError[_f.name]) {
            context.valid = false;
            if (shouldOnlyCheckValid) {
              break;
            }
          }
          !shouldOnlyCheckValid && (get(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));
        }
        fieldValue && (yield executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
      }
    }
    return context.valid;
  });
  const _removeUnmounted = () => {
    for (const name of _names.unMount) {
      const field = get(_fields, name);
      field && (field._f.refs ? field._f.refs.every((ref) => !live(ref)) : !live(field._f.ref)) && unregister(name);
    }
    _names.unMount = /* @__PURE__ */ new Set();
  };
  const _getDirty = (name, data) => (name && data && set(_formValues, name, data), !deepEqual(getValues(), _defaultValues));
  const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, __spreadValues({}, _state.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString(names) ? { [names]: defaultValue } : defaultValue), isGlobal, defaultValue);
  const _getFieldArray = (name) => compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
  const setFieldValue = (name, value, options = {}) => {
    const field = get(_fields, name);
    let fieldValue = value;
    if (field) {
      const fieldReference = field._f;
      if (fieldReference) {
        !fieldReference.disabled && set(_formValues, name, getFieldValueAs(value, fieldReference));
        fieldValue = isHTMLElement(fieldReference.ref) && isNullOrUndefined(value) ? "" : value;
        if (isMultipleSelect(fieldReference.ref)) {
          [...fieldReference.ref.options].forEach((optionRef) => optionRef.selected = fieldValue.includes(optionRef.value));
        } else if (fieldReference.refs) {
          if (isCheckBoxInput(fieldReference.ref)) {
            fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data) => data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
          } else {
            fieldReference.refs.forEach((radioRef) => radioRef.checked = radioRef.value === fieldValue);
          }
        } else if (isFileInput(fieldReference.ref)) {
          fieldReference.ref.value = "";
        } else {
          fieldReference.ref.value = fieldValue;
          if (!fieldReference.ref.type) {
            _subjects.values.next({
              name,
              values: __spreadValues({}, _formValues)
            });
          }
        }
      }
    }
    (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
    options.shouldValidate && trigger(name);
  };
  const setValues = (name, value, options) => {
    for (const fieldKey in value) {
      const fieldValue = value[fieldKey];
      const fieldName = `${name}.${fieldKey}`;
      const field = get(_fields, fieldName);
      (_names.array.has(name) || !isPrimitive(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
    }
  };
  const setValue = (name, value, options = {}) => {
    const field = get(_fields, name);
    const isFieldArray = _names.array.has(name);
    const cloneValue = cloneObject(value);
    set(_formValues, name, cloneValue);
    if (isFieldArray) {
      _subjects.array.next({
        name,
        values: __spreadValues({}, _formValues)
      });
      if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) {
        _subjects.state.next({
          name,
          dirtyFields: getDirtyFields(_defaultValues, _formValues),
          isDirty: _getDirty(name, cloneValue)
        });
      }
    } else {
      field && !field._f && !isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
    }
    isWatched(name, _names) && _subjects.state.next(__spreadValues({}, _formState));
    _subjects.values.next({
      name,
      values: __spreadValues({}, _formValues)
    });
    !_state.mount && flushRootRender();
  };
  const onChange = (event) => __async(this, null, function* () {
    const target = event.target;
    let name = target.name;
    let isFieldValueUpdated = true;
    const field = get(_fields, name);
    const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
    if (field) {
      let error;
      let isValid2;
      const fieldValue = getCurrentFieldValue();
      const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
      const shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !get(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
      const watched = isWatched(name, _names, isBlurEvent);
      set(_formValues, name, fieldValue);
      if (isBlurEvent) {
        field._f.onBlur && field._f.onBlur(event);
        delayErrorCallback && delayErrorCallback(0);
      } else if (field._f.onChange) {
        field._f.onChange(event);
      }
      const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
      const shouldRender = !isEmptyObject(fieldState) || watched;
      !isBlurEvent && _subjects.values.next({
        name,
        type: event.type,
        values: __spreadValues({}, _formValues)
      });
      if (shouldSkipValidation) {
        _proxyFormState.isValid && _updateValid();
        return shouldRender && _subjects.state.next(__spreadValues({ name }, watched ? {} : fieldState));
      }
      !isBlurEvent && watched && _subjects.state.next(__spreadValues({}, _formState));
      _updateIsValidating(true);
      if (_options.resolver) {
        const { errors: errors2 } = yield _executeSchema([name]);
        const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
        const errorLookupResult = schemaErrorLookup(errors2, _fields, previousErrorLookupResult.name || name);
        error = errorLookupResult.error;
        name = errorLookupResult.name;
        isValid2 = isEmptyObject(errors2);
      } else {
        error = (yield validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
        isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === get(_formValues, name, fieldValue);
        if (isFieldValueUpdated) {
          if (error) {
            isValid2 = false;
          } else if (_proxyFormState.isValid) {
            isValid2 = yield executeBuiltInValidation(_fields, true);
          }
        }
      }
      if (isFieldValueUpdated) {
        field._f.deps && trigger(field._f.deps);
        shouldRenderByError(name, isValid2, error, fieldState);
      }
    }
  });
  const trigger = (_0, ..._1) => __async(this, [_0, ..._1], function* (name, options = {}) {
    let isValid2;
    let validationResult;
    const fieldNames = convertToArrayPayload(name);
    _updateIsValidating(true);
    if (_options.resolver) {
      const errors2 = yield executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
      isValid2 = isEmptyObject(errors2);
      validationResult = name ? !fieldNames.some((name2) => get(errors2, name2)) : isValid2;
    } else if (name) {
      validationResult = (yield Promise.all(fieldNames.map((fieldName) => __async(this, null, function* () {
        const field = get(_fields, fieldName);
        return yield executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
      })))).every(Boolean);
      !(!validationResult && !_formState.isValid) && _updateValid();
    } else {
      validationResult = isValid2 = yield executeBuiltInValidation(_fields);
    }
    _subjects.state.next(__spreadProps(__spreadValues(__spreadValues({}, !isString(name) || _proxyFormState.isValid && isValid2 !== _formState.isValid ? {} : { name }), _options.resolver || !name ? { isValid: isValid2 } : {}), {
      errors: _formState.errors,
      isValidating: false
    }));
    options.shouldFocus && !validationResult && focusFieldBy(_fields, (key) => key && get(_formState.errors, key), name ? fieldNames : _names.mount);
    return validationResult;
  });
  const getValues = (fieldNames) => {
    const values2 = __spreadValues(__spreadValues({}, _defaultValues), _state.mount ? _formValues : {});
    return isUndefined(fieldNames) ? values2 : isString(fieldNames) ? get(values2, fieldNames) : fieldNames.map((name) => get(values2, name));
  };
  const getFieldState = (name, formState) => ({
    invalid: !!get((formState || _formState).errors, name),
    isDirty: !!get((formState || _formState).dirtyFields, name),
    isTouched: !!get((formState || _formState).touchedFields, name),
    error: get((formState || _formState).errors, name)
  });
  const clearErrors = (name) => {
    name && convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
    _subjects.state.next({
      errors: name ? _formState.errors : {}
    });
  };
  const setError = (name, error, options) => {
    const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
    set(_formState.errors, name, __spreadProps(__spreadValues({}, error), {
      ref
    }));
    _subjects.state.next({
      name,
      errors: _formState.errors,
      isValid: false
    });
    options && options.shouldFocus && ref && ref.focus && ref.focus();
  };
  const watch = (name, defaultValue) => isFunction(name) ? _subjects.values.subscribe({
    next: (payload) => name(_getWatch(void 0, defaultValue), payload)
  }) : _getWatch(name, defaultValue, true);
  const unregister = (name, options = {}) => {
    for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
      _names.mount.delete(fieldName);
      _names.array.delete(fieldName);
      if (!options.keepValue) {
        unset(_fields, fieldName);
        unset(_formValues, fieldName);
      }
      !options.keepError && unset(_formState.errors, fieldName);
      !options.keepDirty && unset(_formState.dirtyFields, fieldName);
      !options.keepTouched && unset(_formState.touchedFields, fieldName);
      !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
    }
    _subjects.values.next({
      values: __spreadValues({}, _formValues)
    });
    _subjects.state.next(__spreadValues(__spreadValues({}, _formState), !options.keepDirty ? {} : { isDirty: _getDirty() }));
    !options.keepIsValid && _updateValid();
  };
  const _updateDisabledField = ({ disabled, name, field, fields }) => {
    if (isBoolean(disabled)) {
      const value = disabled ? void 0 : get(_formValues, name, getFieldValue(field ? field._f : get(fields, name)._f));
      set(_formValues, name, value);
      updateTouchAndDirty(name, value, false, false, true);
    }
  };
  const register = (name, options = {}) => {
    let field = get(_fields, name);
    const disabledIsDefined = isBoolean(options.disabled);
    set(_fields, name, __spreadProps(__spreadValues({}, field || {}), {
      _f: __spreadValues(__spreadProps(__spreadValues({}, field && field._f ? field._f : { ref: { name } }), {
        name,
        mount: true
      }), options)
    }));
    _names.mount.add(name);
    if (field) {
      _updateDisabledField({
        field,
        disabled: options.disabled,
        name
      });
    } else {
      updateValidAndValue(name, true, options.value);
    }
    return __spreadProps(__spreadValues(__spreadValues({}, disabledIsDefined ? { disabled: options.disabled } : {}), _options.progressive ? {
      required: !!options.required,
      min: getRuleValue(options.min),
      max: getRuleValue(options.max),
      minLength: getRuleValue(options.minLength),
      maxLength: getRuleValue(options.maxLength),
      pattern: getRuleValue(options.pattern)
    } : {}), {
      name,
      onChange,
      onBlur: onChange,
      ref: (ref) => {
        if (ref) {
          register(name, options);
          field = get(_fields, name);
          const fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
          const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
          const refs = field._f.refs || [];
          if (radioOrCheckbox ? refs.find((option) => option === fieldRef) : fieldRef === field._f.ref) {
            return;
          }
          set(_fields, name, {
            _f: __spreadValues(__spreadValues({}, field._f), radioOrCheckbox ? {
              refs: [
                ...refs.filter(live),
                fieldRef,
                ...Array.isArray(get(_defaultValues, name)) ? [{}] : []
              ],
              ref: { type: fieldRef.type, name }
            } : { ref: fieldRef })
          });
          updateValidAndValue(name, false, void 0, fieldRef);
        } else {
          field = get(_fields, name, {});
          if (field._f) {
            field._f.mount = false;
          }
          (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
        }
      }
    });
  };
  const _focusError = () => _options.shouldFocusError && focusFieldBy(_fields, (key) => key && get(_formState.errors, key), _names.mount);
  const handleSubmit = (onValid, onInvalid) => (e2) => __async(this, null, function* () {
    if (e2) {
      e2.preventDefault && e2.preventDefault();
      e2.persist && e2.persist();
    }
    let fieldValues = cloneObject(_formValues);
    _subjects.state.next({
      isSubmitting: true
    });
    if (_options.resolver) {
      const { errors: errors2, values: values2 } = yield _executeSchema();
      _formState.errors = errors2;
      fieldValues = values2;
    } else {
      yield executeBuiltInValidation(_fields);
    }
    unset(_formState.errors, "root");
    if (isEmptyObject(_formState.errors)) {
      _subjects.state.next({
        errors: {}
      });
      yield onValid(fieldValues, e2);
    } else {
      if (onInvalid) {
        yield onInvalid(__spreadValues({}, _formState.errors), e2);
      }
      _focusError();
      setTimeout(_focusError);
    }
    _subjects.state.next({
      isSubmitted: true,
      isSubmitting: false,
      isSubmitSuccessful: isEmptyObject(_formState.errors),
      submitCount: _formState.submitCount + 1,
      errors: _formState.errors
    });
  });
  const resetField = (name, options = {}) => {
    if (get(_fields, name)) {
      if (isUndefined(options.defaultValue)) {
        setValue(name, get(_defaultValues, name));
      } else {
        setValue(name, options.defaultValue);
        set(_defaultValues, name, options.defaultValue);
      }
      if (!options.keepTouched) {
        unset(_formState.touchedFields, name);
      }
      if (!options.keepDirty) {
        unset(_formState.dirtyFields, name);
        _formState.isDirty = options.defaultValue ? _getDirty(name, get(_defaultValues, name)) : _getDirty();
      }
      if (!options.keepError) {
        unset(_formState.errors, name);
        _proxyFormState.isValid && _updateValid();
      }
      _subjects.state.next(__spreadValues({}, _formState));
    }
  };
  const _reset = (formValues, keepStateOptions = {}) => {
    const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
    const cloneUpdatedValues = cloneObject(updatedValues);
    const values2 = formValues && !isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
    if (!keepStateOptions.keepDefaultValues) {
      _defaultValues = updatedValues;
    }
    if (!keepStateOptions.keepValues) {
      if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) {
        for (const fieldName of _names.mount) {
          get(_formState.dirtyFields, fieldName) ? set(values2, fieldName, get(_formValues, fieldName)) : setValue(fieldName, get(values2, fieldName));
        }
      } else {
        if (isWeb && isUndefined(formValues)) {
          for (const name of _names.mount) {
            const field = get(_fields, name);
            if (field && field._f) {
              const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
              if (isHTMLElement(fieldReference)) {
                const form = fieldReference.closest("form");
                if (form) {
                  form.reset();
                  break;
                }
              }
            }
          }
        }
        _fields = {};
      }
      _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneObject(values2);
      _subjects.array.next({
        values: __spreadValues({}, values2)
      });
      _subjects.values.next({
        values: __spreadValues({}, values2)
      });
    }
    _names = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: false,
      focus: ""
    };
    !_state.mount && flushRootRender();
    _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
    _state.watch = !!props.shouldUnregister;
    _subjects.state.next({
      submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
      isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
      isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
      dirtyFields: keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : {},
      touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
      errors: keepStateOptions.keepErrors ? _formState.errors : {},
      isSubmitting: false,
      isSubmitSuccessful: false
    });
  };
  const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
  const setFocus = (name, options = {}) => {
    const field = get(_fields, name);
    const fieldReference = field && field._f;
    if (fieldReference) {
      const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
      if (fieldRef.focus) {
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
      }
    }
  };
  const _updateFormState = (updatedFormState) => {
    _formState = __spreadValues(__spreadValues({}, _formState), updatedFormState);
  };
  const _resetDefaultValues = () => isFunction(_options.defaultValues) && _options.defaultValues().then((values2) => {
    reset(values2, _options.resetOptions);
    _subjects.state.next({
      isLoading: false
    });
  });
  return {
    control: {
      register,
      unregister,
      getFieldState,
      handleSubmit,
      setError,
      _executeSchema,
      _getWatch,
      _getDirty,
      _updateValid,
      _removeUnmounted,
      _updateFieldArray,
      _updateDisabledField,
      _getFieldArray,
      _reset,
      _resetDefaultValues,
      _updateFormState,
      _subjects,
      _proxyFormState,
      get _fields() {
        return _fields;
      },
      get _formValues() {
        return _formValues;
      },
      get _state() {
        return _state;
      },
      set _state(value) {
        _state = value;
      },
      get _defaultValues() {
        return _defaultValues;
      },
      get _names() {
        return _names;
      },
      set _names(value) {
        _names = value;
      },
      get _formState() {
        return _formState;
      },
      set _formState(value) {
        _formState = value;
      },
      get _options() {
        return _options;
      },
      set _options(value) {
        _options = __spreadValues(__spreadValues({}, _options), value);
      }
    },
    trigger,
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    resetField,
    clearErrors,
    unregister,
    setError,
    setFocus,
    getFieldState
  };
}
function useForm(props = {}) {
  const _formControl = React__default.useRef();
  const _values = React__default.useRef();
  const [formState, updateFormState] = React__default.useState({
    isDirty: false,
    isValidating: false,
    isLoading: isFunction(props.defaultValues),
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: {},
    defaultValues: isFunction(props.defaultValues) ? void 0 : props.defaultValues
  });
  if (!_formControl.current) {
    _formControl.current = __spreadProps(__spreadValues({}, createFormControl(props, () => updateFormState((formState2) => __spreadValues({}, formState2)))), {
      formState
    });
  }
  const control = _formControl.current.control;
  control._options = props;
  useSubscribe({
    subject: control._subjects.state,
    next: (value) => {
      if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
        updateFormState(__spreadValues({}, control._formState));
      }
    }
  });
  React__default.useEffect(() => {
    if (props.values && !deepEqual(props.values, _values.current)) {
      control._reset(props.values, control._options.resetOptions);
      _values.current = props.values;
    } else {
      control._resetDefaultValues();
    }
  }, [props.values, control]);
  React__default.useEffect(() => {
    if (!control._state.mount) {
      control._updateValid();
      control._state.mount = true;
    }
    if (control._state.watch) {
      control._state.watch = false;
      control._subjects.state.next(__spreadValues({}, control._formState));
    }
    control._removeUnmounted();
  });
  _formControl.current.formState = getProxyFormState(formState, control);
  return _formControl.current;
}
const StatesDropdown = ({
  register,
  registerId,
  options,
  errors: errors2,
  selectedValue
}) => {
  var _a;
  return /* @__PURE__ */ jsxs(KycFormInputWrapper, { error: (_a = errors2.region) == null ? void 0 : _a.message, children: [
    /* @__PURE__ */ jsx(InputLabel, { size: "small", id: "state-select", children: /* @__PURE__ */ jsx(Trans, { id: "p4EMme" }) }),
    /* @__PURE__ */ jsx(Select, __spreadProps(__spreadValues({ displayEmpty: true, fullWidth: true, id: "state-select", label: i18n._(
      /*i18n*/
      {
        id: "p4EMme"
      }
    ), variant: "outlined", size: "small", error: !!errors2.region, value: selectedValue }, register(registerId)), { children: options.map((opt) => opt.allowed_selection && /* @__PURE__ */ jsx(MenuItem, { value: opt.code, selected: opt.code == "", children: opt.name }, opt.code)) }))
  ] });
};
const StatesDropdown$1 = StatesDropdown;
var dist = {};
var PlacesAutocomplete$1 = {};
var FUNC_ERROR_TEXT = "Expected a function";
var NAN = 0 / 0;
var symbolTag = "[object Symbol]";
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
var objectProto = Object.prototype;
var objectToString = objectProto.toString;
var nativeMax = Math.max, nativeMin = Math.min;
var now = function() {
  return root.Date.now();
};
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
    return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
function isObject(value) {
  var type = typeof value;
  return !!value && (type == "object" || type == "function");
}
function isObjectLike(value) {
  return !!value && typeof value == "object";
}
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, "");
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var lodash_debounce = debounce;
var helpers = {};
Object.defineProperty(helpers, "__esModule", {
  value: true
});
helpers.compose = function compose2() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    fns.forEach(function(fn) {
      return fn && fn.apply(void 0, args);
    });
  };
};
helpers.pick = function pick(obj) {
  for (var _len3 = arguments.length, props = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    props[_key3 - 1] = arguments[_key3];
  }
  return props.reduce(function(newObj, prop) {
    if (obj && obj.hasOwnProperty(prop)) {
      newObj[prop] = obj[prop];
    }
    return newObj;
  }, {});
};
Object.defineProperty(PlacesAutocomplete$1, "__esModule", {
  value: true
});
var _extends$1 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = React__default;
var _react2 = _interopRequireDefault$2(_react);
var _propTypes = propTypesExports;
var _propTypes2 = _interopRequireDefault$2(_propTypes);
var _lodash = lodash_debounce;
var _lodash2 = _interopRequireDefault$2(_lodash);
var _helpers = helpers;
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var formattedSuggestion = function formattedSuggestion2(structured_formatting) {
  return {
    mainText: structured_formatting.main_text,
    secondaryText: structured_formatting.secondary_text
  };
};
var PlacesAutocomplete = function(_React$Component) {
  _inherits(PlacesAutocomplete2, _React$Component);
  function PlacesAutocomplete2(props) {
    _classCallCheck(this, PlacesAutocomplete2);
    var _this = _possibleConstructorReturn(this, (PlacesAutocomplete2.__proto__ || Object.getPrototypeOf(PlacesAutocomplete2)).call(this, props));
    _this.init = function() {
      if (!window.google) {
        throw new Error("[react-places-autocomplete]: Google Maps JavaScript API library must be loaded. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library");
      }
      if (!window.google.maps.places) {
        throw new Error("[react-places-autocomplete]: Google Maps Places library must be loaded. Please add `libraries=places` to the src URL. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library");
      }
      _this.autocompleteService = new window.google.maps.places.AutocompleteService();
      _this.autocompleteOK = window.google.maps.places.PlacesServiceStatus.OK;
      _this.setState(function(state) {
        if (state.ready) {
          return null;
        } else {
          return { ready: true };
        }
      });
    };
    _this.autocompleteCallback = function(predictions, status) {
      _this.setState({ loading: false });
      if (status !== _this.autocompleteOK) {
        _this.props.onError(status, _this.clearSuggestions);
        return;
      }
      var highlightFirstSuggestion = _this.props.highlightFirstSuggestion;
      _this.setState({
        suggestions: predictions.map(function(p2, idx) {
          return {
            id: p2.id,
            description: p2.description,
            placeId: p2.place_id,
            active: highlightFirstSuggestion && idx === 0 ? true : false,
            index: idx,
            formattedSuggestion: formattedSuggestion(p2.structured_formatting),
            matchedSubstrings: p2.matched_substrings,
            terms: p2.terms,
            types: p2.types
          };
        })
      });
    };
    _this.fetchPredictions = function() {
      var value = _this.props.value;
      if (value.length) {
        _this.setState({ loading: true });
        _this.autocompleteService.getPlacePredictions(_extends$1({}, _this.props.searchOptions, {
          input: value
        }), _this.autocompleteCallback);
      }
    };
    _this.clearSuggestions = function() {
      _this.setState({ suggestions: [] });
    };
    _this.clearActive = function() {
      _this.setState({
        suggestions: _this.state.suggestions.map(function(suggestion) {
          return _extends$1({}, suggestion, {
            active: false
          });
        })
      });
    };
    _this.handleSelect = function(address, placeId, suggestion) {
      _this.clearSuggestions();
      if (_this.props.onSelect) {
        _this.props.onSelect(address, placeId, suggestion);
      } else {
        _this.props.onChange(address);
      }
    };
    _this.getActiveSuggestion = function() {
      return _this.state.suggestions.find(function(suggestion) {
        return suggestion.active;
      });
    };
    _this.selectActiveAtIndex = function(index2) {
      var activeName = _this.state.suggestions.find(function(suggestion) {
        return suggestion.index === index2;
      }).description;
      _this.setActiveAtIndex(index2);
      _this.props.onChange(activeName);
    };
    _this.selectUserInputValue = function() {
      _this.clearActive();
      _this.props.onChange(_this.state.userInputValue);
    };
    _this.handleEnterKey = function() {
      var activeSuggestion = _this.getActiveSuggestion();
      if (activeSuggestion === void 0) {
        _this.handleSelect(_this.props.value, null, null);
      } else {
        _this.handleSelect(activeSuggestion.description, activeSuggestion.placeId, activeSuggestion);
      }
    };
    _this.handleDownKey = function() {
      if (_this.state.suggestions.length === 0) {
        return;
      }
      var activeSuggestion = _this.getActiveSuggestion();
      if (activeSuggestion === void 0) {
        _this.selectActiveAtIndex(0);
      } else if (activeSuggestion.index === _this.state.suggestions.length - 1) {
        _this.selectUserInputValue();
      } else {
        _this.selectActiveAtIndex(activeSuggestion.index + 1);
      }
    };
    _this.handleUpKey = function() {
      if (_this.state.suggestions.length === 0) {
        return;
      }
      var activeSuggestion = _this.getActiveSuggestion();
      if (activeSuggestion === void 0) {
        _this.selectActiveAtIndex(_this.state.suggestions.length - 1);
      } else if (activeSuggestion.index === 0) {
        _this.selectUserInputValue();
      } else {
        _this.selectActiveAtIndex(activeSuggestion.index - 1);
      }
    };
    _this.handleInputKeyDown = function(event) {
      switch (event.key) {
        case "Enter":
          event.preventDefault();
          _this.handleEnterKey();
          break;
        case "ArrowDown":
          event.preventDefault();
          _this.handleDownKey();
          break;
        case "ArrowUp":
          event.preventDefault();
          _this.handleUpKey();
          break;
        case "Escape":
          _this.clearSuggestions();
          break;
      }
    };
    _this.setActiveAtIndex = function(index2) {
      _this.setState({
        suggestions: _this.state.suggestions.map(function(suggestion, idx) {
          if (idx === index2) {
            return _extends$1({}, suggestion, { active: true });
          } else {
            return _extends$1({}, suggestion, { active: false });
          }
        })
      });
    };
    _this.handleInputChange = function(event) {
      var value = event.target.value;
      _this.props.onChange(value);
      _this.setState({ userInputValue: value });
      if (!value) {
        _this.clearSuggestions();
        return;
      }
      if (_this.props.shouldFetchSuggestions) {
        _this.debouncedFetchPredictions();
      }
    };
    _this.handleInputOnBlur = function() {
      if (!_this.mousedownOnSuggestion) {
        _this.clearSuggestions();
      }
    };
    _this.getActiveSuggestionId = function() {
      var activeSuggestion = _this.getActiveSuggestion();
      return activeSuggestion ? "PlacesAutocomplete__suggestion-" + activeSuggestion.placeId : void 0;
    };
    _this.getIsExpanded = function() {
      return _this.state.suggestions.length > 0;
    };
    _this.getInputProps = function() {
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (options.hasOwnProperty("value")) {
        throw new Error("[react-places-autocomplete]: getInputProps does not accept `value`. Use `value` prop instead");
      }
      if (options.hasOwnProperty("onChange")) {
        throw new Error("[react-places-autocomplete]: getInputProps does not accept `onChange`. Use `onChange` prop instead");
      }
      var defaultInputProps = {
        type: "text",
        autoComplete: "off",
        role: "combobox",
        "aria-autocomplete": "list",
        "aria-expanded": _this.getIsExpanded(),
        "aria-activedescendant": _this.getActiveSuggestionId(),
        disabled: !_this.state.ready
      };
      return _extends$1({}, defaultInputProps, options, {
        onKeyDown: (0, _helpers.compose)(_this.handleInputKeyDown, options.onKeyDown),
        onBlur: (0, _helpers.compose)(_this.handleInputOnBlur, options.onBlur),
        value: _this.props.value,
        onChange: function onChange(event) {
          _this.handleInputChange(event);
        }
      });
    };
    _this.getSuggestionItemProps = function(suggestion) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var handleSuggestionMouseEnter = _this.handleSuggestionMouseEnter.bind(_this, suggestion.index);
      var handleSuggestionClick = _this.handleSuggestionClick.bind(_this, suggestion);
      return _extends$1({}, options, {
        key: suggestion.id,
        id: _this.getActiveSuggestionId(),
        role: "option",
        onMouseEnter: (0, _helpers.compose)(handleSuggestionMouseEnter, options.onMouseEnter),
        onMouseLeave: (0, _helpers.compose)(_this.handleSuggestionMouseLeave, options.onMouseLeave),
        onMouseDown: (0, _helpers.compose)(_this.handleSuggestionMouseDown, options.onMouseDown),
        onMouseUp: (0, _helpers.compose)(_this.handleSuggestionMouseUp, options.onMouseUp),
        onTouchStart: (0, _helpers.compose)(_this.handleSuggestionTouchStart, options.onTouchStart),
        onTouchEnd: (0, _helpers.compose)(_this.handleSuggestionMouseUp, options.onTouchEnd),
        onClick: (0, _helpers.compose)(handleSuggestionClick, options.onClick)
      });
    };
    _this.handleSuggestionMouseEnter = function(index2) {
      _this.setActiveAtIndex(index2);
    };
    _this.handleSuggestionMouseLeave = function() {
      _this.mousedownOnSuggestion = false;
      _this.clearActive();
    };
    _this.handleSuggestionMouseDown = function(event) {
      event.preventDefault();
      _this.mousedownOnSuggestion = true;
    };
    _this.handleSuggestionTouchStart = function() {
      _this.mousedownOnSuggestion = true;
    };
    _this.handleSuggestionMouseUp = function() {
      _this.mousedownOnSuggestion = false;
    };
    _this.handleSuggestionClick = function(suggestion, event) {
      if (event && event.preventDefault) {
        event.preventDefault();
      }
      var description = suggestion.description, placeId = suggestion.placeId;
      _this.handleSelect(description, placeId, suggestion);
      setTimeout(function() {
        _this.mousedownOnSuggestion = false;
      });
    };
    _this.state = {
      loading: false,
      suggestions: [],
      userInputValue: props.value,
      ready: !props.googleCallbackName
    };
    _this.debouncedFetchPredictions = (0, _lodash2.default)(_this.fetchPredictions, props.debounce);
    return _this;
  }
  _createClass(PlacesAutocomplete2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var googleCallbackName = this.props.googleCallbackName;
      if (googleCallbackName) {
        var isPlacesLoaded = window.google && window.google.maps && window.google.maps.places;
        if (!isPlacesLoaded) {
          window[googleCallbackName] = this.init;
        } else {
          this.init();
        }
      } else {
        this.init();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var googleCallbackName = this.props.googleCallbackName;
      if (googleCallbackName && window[googleCallbackName]) {
        delete window[googleCallbackName];
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        getInputProps: this.getInputProps,
        getSuggestionItemProps: this.getSuggestionItemProps,
        loading: this.state.loading,
        suggestions: this.state.suggestions
      });
    }
  }]);
  return PlacesAutocomplete2;
}(_react2.default.Component);
PlacesAutocomplete.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.func.isRequired,
  onError: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  searchOptions: _propTypes2.default.shape({
    bounds: _propTypes2.default.object,
    componentRestrictions: _propTypes2.default.object,
    location: _propTypes2.default.object,
    offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    types: _propTypes2.default.array
  }),
  debounce: _propTypes2.default.number,
  highlightFirstSuggestion: _propTypes2.default.bool,
  shouldFetchSuggestions: _propTypes2.default.bool,
  googleCallbackName: _propTypes2.default.string
};
PlacesAutocomplete.defaultProps = {
  /* eslint-disable no-unused-vars, no-console */
  onError: function onError(status, _clearSuggestions) {
    return console.error("[react-places-autocomplete]: error happened when fetching data from Google Maps API.\nPlease check the docs here (https://developers.google.com/maps/documentation/javascript/places#place_details_responses)\nStatus: ", status);
  },
  /* eslint-enable no-unused-vars, no-console */
  searchOptions: {},
  debounce: 200,
  highlightFirstSuggestion: false,
  shouldFetchSuggestions: true
};
PlacesAutocomplete$1.default = PlacesAutocomplete;
var utils = {};
Object.defineProperty(utils, "__esModule", {
  value: true
});
utils.geocodeByAddress = function geocodeByAddress(address) {
  var geocoder = new window.google.maps.Geocoder();
  var OK = window.google.maps.GeocoderStatus.OK;
  return new Promise(function(resolve, reject) {
    geocoder.geocode({ address }, function(results, status) {
      if (status !== OK) {
        reject(status);
      }
      resolve(results);
    });
  });
};
utils.getLatLng = function getLatLng(result) {
  return new Promise(function(resolve, reject) {
    try {
      var latLng = {
        lat: result.geometry.location.lat(),
        lng: result.geometry.location.lng()
      };
      resolve(latLng);
    } catch (e2) {
      reject(e2);
    }
  });
};
utils.geocodeByPlaceId = function geocodeByPlaceId(placeId) {
  var geocoder = new window.google.maps.Geocoder();
  var OK = window.google.maps.GeocoderStatus.OK;
  return new Promise(function(resolve, reject) {
    geocoder.geocode({ placeId }, function(results, status) {
      if (status !== OK) {
        reject(status);
      }
      resolve(results);
    });
  });
};
Object.defineProperty(dist, "__esModule", {
  value: true
});
dist.getLatLng = dist.geocodeByPlaceId = geocodeByAddress2 = dist.geocodeByAddress = void 0;
var _PlacesAutocomplete = PlacesAutocomplete$1;
var _PlacesAutocomplete2 = _interopRequireDefault$1(_PlacesAutocomplete);
var _utils = utils;
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var geocodeByAddress2 = dist.geocodeByAddress = _utils.geocodeByAddress;
dist.geocodeByPlaceId = _utils.geocodeByPlaceId;
dist.getLatLng = _utils.getLatLng;
var _default$1 = dist.default = _PlacesAutocomplete2.default;
const PlacesSuggestionsSelector = (props) => {
  const {
    loading,
    suggestions,
    getSuggestionItemProps
  } = props;
  const shouldDisplay = suggestions.length > 0 && !loading;
  if (!shouldDisplay) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  return /* @__PURE__ */ jsxs(Box, { className: "autocomplete-dropdown-container", sx: {
    borderRadius: "12px",
    border: "2px solid gainsboro",
    background: "white",
    p: "8px 12px",
    marginBottom: "10px"
  }, children: [
    loading && /* @__PURE__ */ jsx("div", { children: "Loading..." }),
    suggestions.map((suggestion, index2) => {
      const className = suggestion.active ? "suggestion-item--active" : "suggestion-item";
      const style2 = {
        backgroundColor: suggestion.active ? "#fafafa" : "white",
        cursor: "pointer",
        marginBottom: index2 === suggestions.length - 1 ? "0" : "8px"
      };
      return /* @__PURE__ */ createElement(
        "div",
        __spreadProps(__spreadValues({}, getSuggestionItemProps(suggestion, {
          className,
          style: style2
        })), {
          key: suggestion.placeId
        }),
        /* @__PURE__ */ jsx("span", { children: suggestion.description })
      );
    })
  ] });
};
const AddressForms = ({
  register,
  formState,
  setValue,
  trigger,
  watch,
  addressMustMatchIdv,
  hideFields
}) => {
  var _a, _b, _c, _d, _e, _f;
  const {
    errors: errors2
  } = formState;
  const [showIdvDisclaimer, setShowIdvDisclaimer] = useState(false);
  const geographyConstants = useConstants().geography;
  const countries2 = Object.values((geographyConstants == null ? void 0 : geographyConstants.countries) || {}).filter((country) => (country == null ? void 0 : country.address_select_enabled) === true);
  const states = Object.values(((_a = geographyConstants == null ? void 0 : geographyConstants.states) == null ? void 0 : _a[watch("country") || "US"]) || {});
  const watchedCountryName = (_b = countries2.find((country) => country.code === watch("country"))) == null ? void 0 : _b.name;
  const handleSelect = (address) => __async(void 0, null, function* () {
    geocodeByAddress2(address).then((results) => {
      let autocompletedStreet = "";
      let autocompletedStreetNumber = "";
      let autocompletedCity = "";
      let autocompletedRegion = "";
      let autocompletedCountry = "";
      let autocompletedZipcode = "";
      const components2 = results[0].address_components;
      components2.forEach((component) => {
        const componentType = component.types[0];
        switch (componentType) {
          case "street_number": {
            autocompletedStreetNumber = component.short_name;
            break;
          }
          case "route": {
            autocompletedStreet = component.short_name;
            break;
          }
          case "locality": {
            autocompletedCity = component.long_name;
            break;
          }
          case "administrative_area_level_1": {
            autocompletedRegion = component.short_name;
            break;
          }
          case "postal_code": {
            autocompletedZipcode = component.short_name;
            break;
          }
          case "country": {
            autocompletedCountry = component.short_name;
            break;
          }
        }
      });
      setValue("streetAddress", `${autocompletedStreetNumber} ${autocompletedStreet}`);
      setValue("city", autocompletedCity);
      setValue("region", autocompletedRegion);
      setValue("country", autocompletedCountry);
      setValue("postalCode", autocompletedZipcode);
      if (formState.isSubmitted) {
        trigger("streetAddress");
        trigger("city");
        trigger("region");
        trigger("country");
        trigger("postalCode");
      }
    }).catch((error) => {
      console.error("Error", error);
    });
  });
  const streetAddessInput = /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, children: /* @__PURE__ */ jsx(
    _default$1,
    {
      onChange: (value) => {
        if (addressMustMatchIdv) {
          setShowIdvDisclaimer(true);
        }
        register("streetAddress").onChange({
          target: {
            name: "streetAddress",
            value
          }
        });
      },
      value: watch("streetAddress"),
      onSelect: handleSelect,
      children: ({
        getInputProps,
        suggestions,
        getSuggestionItemProps,
        loading
      }) => {
        var _a2;
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(KycFormInputWrapper, { error: (_a2 = errors2.streetAddress) == null ? void 0 : _a2.message, children: /* @__PURE__ */ jsx(TextField, __spreadValues({ fullWidth: true, label: i18n._(
            /*i18n*/
            {
              id: "THlSym"
            }
          ), variant: "outlined", size: "small", error: !!errors2.streetAddress }, getInputProps({
            placeholder: i18n._(
              /*i18n*/
              {
                id: "ACIRPN"
              }
            ),
            className: "location-search-input"
          }))) }),
          /* @__PURE__ */ jsx(Box, { style: {
            zIndex: 1e3
          }, children: /* @__PURE__ */ jsx(PlacesSuggestionsSelector, { loading, suggestions, getSuggestionItemProps }) })
        ] });
      }
    }
  ) });
  const cityInput = /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { error: (_c = errors2.city) == null ? void 0 : _c.message, children: /* @__PURE__ */ jsx(TextField, __spreadValues({ id: "city-input", fullWidth: true, type: "text", label: i18n._(
    /*i18n*/
    {
      id: "zZ9ydC"
    }
  ), placeholder: "San Francisco", variant: "outlined", size: "small", value: watch("city"), error: !!errors2.city }, register("city"))) }) });
  const postalCodeInput = /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { error: (_d = errors2.postalCode) == null ? void 0 : _d.message, children: /* @__PURE__ */ jsx(TextField, __spreadValues({ id: "postal-code-input", fullWidth: true, label: watch("country") == "US" ? "Zip Code" : "Postal Code", type: "text", placeholder: "94117", variant: "outlined", size: "small", value: watch("postalCode"), error: !!errors2.postalCode }, register("postalCode"))) }) });
  const countryInput = /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, children: /* @__PURE__ */ jsxs(KycFormInputWrapper, { error: (_e = errors2.country) == null ? void 0 : _e.message, children: [
    /* @__PURE__ */ jsx(InputLabel, { size: "small", id: "country-select", children: "Country" }),
    /* @__PURE__ */ jsx(
      Select,
      {
        id: "country-select",
        displayEmpty: true,
        error: !!errors2.country,
        size: "small",
        label: i18n._(
          /*i18n*/
          {
            id: "JNCzPW"
          }
        ),
        onChange: (e2) => {
          setValue("region", "");
          setValue("country", e2.target.value);
          if (formState.isSubmitted) {
            trigger("region");
            trigger("country");
          }
        },
        value: watch("country") || "",
        children: countries2.map(({
          name_and_flag,
          name,
          code: code2
        }) => /* @__PURE__ */ jsx(MenuItem, { value: code2, children: name_and_flag || name }, code2))
      }
    )
  ] }) });
  const regionInput = /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, children: ["US", "UA", ""].includes(watch("country") || "") ? /* @__PURE__ */ jsx(StatesDropdown$1, { options: Object.values(states), register, registerId: "region", errors: errors2, selectedValue: watch("region") || "" }) : /* @__PURE__ */ jsx(KycFormInputWrapper, { error: (_f = errors2.region) == null ? void 0 : _f.message, children: /* @__PURE__ */ jsx(TextField, __spreadValues({ fullWidth: true, type: "text", label: i18n._(
    /*i18n*/
    {
      id: "p09WA4"
    }
  ), variant: "outlined", size: "small", error: !!errors2.region }, register("region"))) }) });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box, { sx: {
      mb: 2
    }, children: /* @__PURE__ */ jsx(FormLabel, { className: "kyc_form", children: "Address" }) }),
    /* @__PURE__ */ jsxs(Grid, { container: true, spacing: 1.5, children: [
      (hideFields == null ? void 0 : hideFields.includes("streetAddress")) ? null : streetAddessInput,
      (hideFields == null ? void 0 : hideFields.includes("city")) ? null : cityInput,
      (hideFields == null ? void 0 : hideFields.includes("postalCode")) ? null : postalCodeInput,
      (hideFields == null ? void 0 : hideFields.includes("country")) ? null : countryInput,
      (hideFields == null ? void 0 : hideFields.includes("region")) ? null : regionInput,
      showIdvDisclaimer && /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, children: /* @__PURE__ */ jsxs(Alert, { severity: "info", sx: {
        width: "100%"
      }, children: [
        "You will need a government issued photo ID from",
        " ",
        watchedCountryName,
        " to complete onboarding."
      ] }) })
    ] })
  ] });
};
const AddressForms$1 = AddressForms;
const BasicDetailsTabPanel = ({
  entityId,
  sidebarTabs,
  basicDetails,
  proofOfAddressDocs,
  onEditBasicDetailsFinished,
  isReverificationFlow,
  isRegisteringForOffering
}) => {
  var _a, _b, _c, _d, _e, _f;
  const amplitude = useAmplitude();
  const globalConstants = useConstants();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const isMobile = useMediaQuery(useTheme$3().breakpoints.down("md"));
  const initialFirstName = useRef(basicDetails == null ? void 0 : basicDetails.firstName).current;
  const initialLastName = useRef(basicDetails == null ? void 0 : basicDetails.lastName).current;
  const initialDob = useRef(basicDetails == null ? void 0 : basicDetails.dob).current;
  const initialCountry = useRef(basicDetails == null ? void 0 : basicDetails.country).current;
  const [hasProofOfAddress, setHasProofOfAddress] = useState(proofOfAddressDocs && (proofOfAddressDocs == null ? void 0 : proofOfAddressDocs.length) > 0);
  const [displayProofOfAddressError, setDisplayProofOfAddressError] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    trigger,
    formState,
    getValues
  } = useForm({
    defaultValues: {
      firstName: (basicDetails == null ? void 0 : basicDetails.firstName) || "",
      lastName: (basicDetails == null ? void 0 : basicDetails.lastName) || "",
      dateOfBirth: (basicDetails == null ? void 0 : basicDetails.dob) || "",
      occupation: (basicDetails == null ? void 0 : basicDetails.occupation) || "",
      phoneNumber: (basicDetails == null ? void 0 : basicDetails.phoneNumber) || "",
      stateIdentifier: (basicDetails == null ? void 0 : basicDetails.stateIdentifier) ? formatSSN((basicDetails == null ? void 0 : basicDetails.stateIdentifier) || "") : "",
      streetAddress: (basicDetails == null ? void 0 : basicDetails.streetAddress) || "",
      city: (basicDetails == null ? void 0 : basicDetails.city) || "",
      region: (basicDetails == null ? void 0 : basicDetails.state) || "CA",
      country: (basicDetails == null ? void 0 : basicDetails.country) || "US",
      postalCode: (basicDetails == null ? void 0 : basicDetails.zipcode) || "",
      fileUpload: false
    },
    resolver: (data) => {
      const validationErrors = validateFormInputsAgainstRuleSet(PersonRules, lodashExports.pick(data, Object.keys(PersonRules)), {
        globalConstants,
        // Offerings don't require wallet elligible country constraints
        checkWalletEligibility: !isRegisteringForOffering
      });
      return {
        values: data,
        errors: validationErrors
      };
    }
  });
  const isPWWOrg = getValues("country") && globalConstants.geography.countries[getValues("country")] && globalConstants.geography.countries[getValues("country")].country_org === "PWW";
  const {
    errors: errors2
  } = formState;
  const formErrorsExist = Object.values(errors2).some(Boolean);
  const watchedCountry = watch("country");
  const [upsertKycBasicDetails] = useUpsertKycBasicDetailsMutation({
    // Refetch the basic details after submitting, because the review and submit tab
    // will be using these values
    refetchQueries: () => {
      return [{
        query: PersonKycBasicDetailsDocument,
        variables: {
          entityId
        }
      }];
    }
  });
  const checkReverificationConstraints = (data) => {
    var _a2, _b2, _c2, _d2;
    const countries2 = globalConstants.geography.countries;
    const selectedCountry = data.country;
    const initialCountryName = (_a2 = countries2[initialCountry || ""]) == null ? void 0 : _a2.name_and_flag;
    const selectedCountryName = (_b2 = countries2[selectedCountry]) == null ? void 0 : _b2.name_and_flag;
    const initialCountryOrg = (_c2 = countries2[initialCountry || ""]) == null ? void 0 : _c2.org;
    const selectedCountryOrg = (_d2 = countries2[selectedCountry]) == null ? void 0 : _d2.org;
    if (initialCountryOrg != selectedCountryOrg) {
      setErrorMessage(/* @__PURE__ */ jsx(Typography, { children: /* @__PURE__ */ jsx(Trans, { id: "94POnH", values: {
        initialCountryName,
        selectedCountryName
      }, components: {
        0: /* @__PURE__ */ jsx("b", {}),
        1: /* @__PURE__ */ jsx("b", {})
      } }) }));
      setErrorDialogOpen(true);
      setIsSubmitting(false);
      return false;
    }
    if (initialFirstName != data.firstName || initialLastName != data.lastName || initialDob != data.dateOfBirth) {
      setErrorMessage(/* @__PURE__ */ jsx(Typography, { children: /* @__PURE__ */ jsx(Trans, { id: "K6f0vw" }) }));
      setErrorDialogOpen(true);
      setIsSubmitting(false);
      return false;
    }
    return true;
  };
  const onSubmit = (data) => __async(void 0, null, function* () {
    var _a2, _b2;
    if (isPWWOrg && !hasProofOfAddress) {
      setDisplayProofOfAddressError(true);
      return;
    }
    setIsSubmitting(true);
    const request = data;
    data.entityId = entityId;
    data.zipcode = data.postalCode;
    if (isReverificationFlow && !checkReverificationConstraints(data)) {
      return;
    }
    try {
      const res = yield upsertKycBasicDetails({
        variables: request
      });
      if (!((_b2 = (_a2 = res.data) == null ? void 0 : _a2.upsertBasicDetails) == null ? void 0 : _b2.success)) {
        throw new Error("Unsuccesful response");
      }
      amplitude.track("kyc-details-continued");
      onEditBasicDetailsFinished();
    } catch (error) {
      setErrorMessage(i18n._(
        /*i18n*/
        {
          id: "ZrPMDj"
        }
      ));
      setErrorDialogOpen(true);
      setIsSubmitting(false);
      amplitude.track("kyc-details-error");
    }
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: true, openState: errorDialogOpen, setOpenState: setErrorDialogOpen, message: errorMessage }),
    /* @__PURE__ */ jsxs(Box, { sx: {
      width: "100%",
      display: "flex"
    }, justifyContent: isMobile ? "center" : "start", children: [
      /* @__PURE__ */ jsxs(Container, { sx: {
        mt: 2,
        ml: 2,
        mr: 2,
        mb: 6
      }, children: [
        isReverificationFlow && /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsxs(Typography, { children: [
            /* @__PURE__ */ jsx(Trans, { id: "8nVerV" }),
            /* @__PURE__ */ jsx("br", {}),
            /* @__PURE__ */ jsx("br", {}),
            /* @__PURE__ */ jsx(Trans, { id: "2Zp92Z" }),
            /* @__PURE__ */ jsx(Trans, { id: "KatURn", values: {
              0: basicDetails == null ? void 0 : basicDetails.firstName,
              1: basicDetails == null ? void 0 : basicDetails.lastName,
              2: basicDetails == null ? void 0 : basicDetails.dob
            }, components: {
              0: /* @__PURE__ */ jsx("b", {}),
              1: /* @__PURE__ */ jsx("b", {}),
              2: /* @__PURE__ */ jsx("br", {})
            } })
          ] }),
          /* @__PURE__ */ jsx(Alert, { severity: "warning", sx: {
            width: "100%",
            mt: 3,
            mb: 3
          }, children: /* @__PURE__ */ jsx(Trans, { id: "I0Jpz/" }) }),
          /* @__PURE__ */ jsx(Divider, { sx: {
            mb: 3
          } })
        ] }),
        /* @__PURE__ */ jsxs("form", { children: [
          /* @__PURE__ */ jsxs(Grid, { container: true, columnSpacing: 3, children: [
            /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: i18n._(
              /*i18n*/
              {
                id: "kODvZJ"
              }
            ), hidden: isReverificationFlow, error: (_a = errors2.firstName) == null ? void 0 : _a.message, children: /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ fullWidth: true, placeholder: "Satoshi", variant: "outlined", size: "small" }, register("firstName")), { disabled: isReverificationFlow, error: !!errors2.firstName })) }) }),
            /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: i18n._(
              /*i18n*/
              {
                id: "UXBCwc"
              }
            ), hidden: isReverificationFlow, error: (_b = errors2.lastName) == null ? void 0 : _b.message, children: /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ fullWidth: true, placeholder: "Nakamoto", variant: "outlined", size: "small", disabled: isReverificationFlow }, register("lastName")), { error: !!errors2.lastName })) }) })
          ] }),
          /* @__PURE__ */ jsxs(Grid, { container: true, columnSpacing: 3, children: [
            /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: i18n._(
              /*i18n*/
              {
                id: "ZuLy43"
              }
            ), error: (_c = errors2.phoneNumber) == null ? void 0 : _c.message, children: /* @__PURE__ */ jsx(Controller, { name: "phoneNumber", control, render: ({
              field
            }) => /* @__PURE__ */ jsx(KycPhoneInput, { value: field.value, onChange: (newValue) => {
              field.onChange(newValue);
            }, defaultCountry: watchedCountry.toLowerCase(), error: !!errors2.phoneNumber }) }) }) }),
            /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: i18n._(
              /*i18n*/
              {
                id: "7uHWR+"
              }
            ), hidden: isReverificationFlow, error: (_d = errors2.dateOfBirth) == null ? void 0 : _d.message, children: /* @__PURE__ */ jsx(Controller, { name: "dateOfBirth", control, render: ({
              field
            }) => /* @__PURE__ */ jsx(TextField, { fullWidth: true, type: "date", variant: "outlined", size: "small", error: !!errors2.dateOfBirth, disabled: isReverificationFlow, onChange: (e2) => {
              field.onChange(capDateIsoToToday(e2.target.value));
            }, value: capDateIsoToToday(field.value) }) }) }) })
          ] }),
          /* @__PURE__ */ jsx(Box, { sx: {
            mt: 2,
            mb: 2
          }, children: /* @__PURE__ */ jsx(AddressForms$1, { register, setValue, trigger, formState, watch, addressMustMatchIdv: true }) }),
          /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: i18n._(
            /*i18n*/
            {
              id: "9pnaAI"
            }
          ), error: (_e = errors2.occupation) == null ? void 0 : _e.message, children: /* @__PURE__ */ jsx(TextField, __spreadValues({ fullWidth: true, placeholder: i18n._(
            /*i18n*/
            {
              id: "m0b7v3"
            }
          ), variant: "outlined", size: "small", error: !!errors2.occupation }, register("occupation"))) }),
          /* @__PURE__ */ jsx(Box, { sx: {
            display: watchedCountry == "US" ? "block" : "none",
            mb: 2
          }, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: i18n._(
            /*i18n*/
            {
              id: "mOjKS5"
            }
          ), error: (_f = errors2.stateIdentifier) == null ? void 0 : _f.message, hidden: isReverificationFlow, children: /* @__PURE__ */ jsx(Controller, { name: "stateIdentifier", control, render: ({
            field
          }) => /* @__PURE__ */ jsx(TextField, { fullWidth: true, className: "fs-exclude", placeholder: "123-45-6789", variant: "outlined", size: "small", error: !!errors2.stateIdentifier, disabled: isReverificationFlow, onChange: (e2) => {
            field.onChange(formatSSN(e2.target.value));
          }, value: formatSSN(field.value) }) }) }) }),
          isPWWOrg && /* @__PURE__ */ jsx(FileUpload, { label: i18n._(
            /*i18n*/
            {
              id: "OyqiiM"
            }
          ), entityId, docCategory: DocumentPurpose.ProofOfResidence, existingFiles: proofOfAddressDocs, allowMultipleFiles: false, addressInfo: {
            country: getValues("country"),
            state: getValues("region")
          }, onStatusChange: (status) => {
            if (status === FileUploadStatus.SUCCESS) {
              setHasProofOfAddress(true);
              setDisplayProofOfAddressError(false);
            }
          }, displayError: displayProofOfAddressError, children: /* @__PURE__ */ jsx(Typography, { mb: "3", color: "textSecondary", children: /* @__PURE__ */ jsx(Trans, { id: "U+PgUp" }) }) })
        ] })
      ] }),
      !isMobile && /* @__PURE__ */ jsx(SidebarIndividual, { tabs: sidebarTabs, currentTabId: "basic-details", buttonLabel: i18n._(
        /*i18n*/
        {
          id: "xGVfLh"
        }
      ), butonOnClick: handleSubmit(onSubmit), buttonDisabled: isSubmitting || formErrorsExist, isSubmitting })
    ] }),
    /* @__PURE__ */ jsx(MobileStickyBottomBox, { hideAbove: "md", children: /* @__PURE__ */ jsx(Box, { sx: {
      display: "flex",
      justifyContent: "start"
    }, children: /* @__PURE__ */ jsx(Container, { maxWidth: "xs", children: /* @__PURE__ */ jsxs(Button, { fullWidth: true, variant: "contained", size: "large", onClick: handleSubmit(onSubmit), disabled: isSubmitting || formErrorsExist, endIcon: /* @__PURE__ */ jsx(default_1$1, { color: "inherit" }), sx: {
      maxWidth: "container.xs"
    }, children: [
      isSubmitting && /* @__PURE__ */ jsx(CircularProgress, { size: 24, sx: {
        mr: 1
      } }),
      /* @__PURE__ */ jsx(Trans, { id: "xGVfLh" })
    ] }) }) }) })
  ] });
};
const BasicDetailsTabPanel$1 = BasicDetailsTabPanel;
const IdvDisclaimer = (props) => {
  var _a, _b, _c, _d;
  const countries2 = ((_b = (_a = useConstants()) == null ? void 0 : _a.geography) == null ? void 0 : _b.countries) || {};
  const countryName = (_c = countries2[props.country || ""]) == null ? void 0 : _c.name;
  const countryFlag = (_d = countries2[props.country || ""]) == null ? void 0 : _d.flag;
  let docText = "Submit a government-issued photo ID";
  if (countryName) {
    docText = docText + ` from ${countryName}`;
  }
  if (props.entityName) {
    docText = docText + ` with the name ${props.entityName}`;
  }
  return /* @__PURE__ */ jsx(Box, { display: "flex", children: /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsxs(Stack, { spacing: 1, sx: {
      mt: 2
    }, children: [
      /* @__PURE__ */ jsx(Typography, { fontSize: "12px", fontWeight: 800, children: /* @__PURE__ */ jsx(Trans, { id: "fKfbXe" }) }),
      /* @__PURE__ */ jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, children: [
        /* @__PURE__ */ jsx(Typography, { children: "📷" }),
        /* @__PURE__ */ jsx(Typography, { sx: {
          ml: 2
        }, variant: "body1", children: /* @__PURE__ */ jsx(Trans, { id: "G9MzmU" }) })
      ] }),
      /* @__PURE__ */ jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, children: [
        /* @__PURE__ */ jsx(Typography, { children: countryFlag || "💳" }),
        /* @__PURE__ */ jsx(Typography, { sx: {
          ml: 2
        }, variant: "body1", children: docText })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, sx: {
      mt: 2,
      mb: 3
    }, children: [
      /* @__PURE__ */ jsx(Schedule, { sx: {
        width: "0.6em",
        color: "brand.700"
      } }),
      /* @__PURE__ */ jsx(Typography, { variant: "subtitle1", fontWeight: 300, children: /* @__PURE__ */ jsx(Trans, { id: "NcRDVh" }) })
    ] })
  ] }) });
};
const IdvTabPanel$1 = ({
  sidebarTabs,
  basicDetails,
  idvSession
}) => {
  const isMobile = useMediaQuery(useTheme$3().breakpoints.down("md"));
  const entityName = (basicDetails == null ? void 0 : basicDetails.firstName) && (basicDetails == null ? void 0 : basicDetails.lastName) ? `${basicDetails == null ? void 0 : basicDetails.firstName} ${basicDetails == null ? void 0 : basicDetails.lastName}` : void 0;
  const buttonOnClick = () => {
    if (!idvSession) {
      return;
    }
    window.location.href = idvSession.url;
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Box, { sx: {
      width: "100%"
    }, justifyContent: isMobile ? "center" : "start", display: "flex", children: [
      /* @__PURE__ */ jsx(Container, { maxWidth: "sm", sx: {
        ml: 6,
        mr: 6,
        mt: 3
      }, children: /* @__PURE__ */ jsx(Box, { justifyContent: isMobile ? "center" : "start", display: "flex", children: /* @__PURE__ */ jsx(IdvDisclaimer, { entityName, country: (basicDetails == null ? void 0 : basicDetails.country) || "" }) }) }),
      !isMobile && /* @__PURE__ */ jsx(SidebarIndividual, { tabs: sidebarTabs, currentTabId: "idv", buttonLabel: i18n._(
        /*i18n*/
        {
          id: "dZh9mq"
        }
      ), butonOnClick: buttonOnClick, buttonDisabled: false, isSubmitting: false })
    ] }),
    isMobile && /* @__PURE__ */ jsxs(Container, { maxWidth: "xs", children: [
      /* @__PURE__ */ jsx(Button, { variant: "contained", size: "large", fullWidth: true, endIcon: /* @__PURE__ */ jsx(ArrowForward, {}), onClick: buttonOnClick, sx: {
        mx: 4
      }, children: /* @__PURE__ */ jsx(Trans, { id: "dZh9mq" }) }),
      /* @__PURE__ */ jsx(Button, { variant: "contained", size: "large", fullWidth: true, endIcon: /* @__PURE__ */ jsx(ArrowForward, {}), onClick: buttonOnClick, sx: {
        mx: 4
      }, children: /* @__PURE__ */ jsx(Trans, { id: "dZh9mq" }) })
    ] })
  ] });
};
const IdvTabPanel$2 = IdvTabPanel$1;
const SUBMISSION_ERROR = i18n._(
  /*i18n*/
  {
    id: "ZrPMDj"
  }
);
const ReviewAndSubmitTabPanel$1 = ({
  entityId,
  sidebarTabs,
  basicDetails,
  startEditBasicDetails
}) => {
  const amplitude = useAmplitude();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [finalizeKycBasicDetails] = useFinalizeKycBasicDetailsMutation({
    // Refetch the current step after submitting, because it will have changed to 'IDV'
    refetchQueries: () => {
      return [{
        query: CurrentOnboardingStepDocument,
        variables: {
          entityId
        }
      }];
    }
  });
  const isMobile = useMediaQuery(useTheme$3().breakpoints.down("md"));
  const onSubmit = () => __async(void 0, null, function* () {
    var _a, _b;
    setIsSubmitting(true);
    try {
      const request = {
        entityId
      };
      const response = yield finalizeKycBasicDetails({
        variables: request
      });
      if (!((_b = (_a = response == null ? void 0 : response.data) == null ? void 0 : _a.finalizeBasicDetails) == null ? void 0 : _b.success)) {
        setErrorMessage(SUBMISSION_ERROR);
        setErrorDialogOpen(true);
        setIsSubmitting(false);
      }
      amplitude.track("kyc-review-submitted");
    } catch (error) {
      setErrorMessage(error.message);
      setErrorDialogOpen(true);
      setIsSubmitting(false);
    }
  });
  const ReviewEl = ({
    children,
    label
  }) => {
    return /* @__PURE__ */ jsxs(Box, { sx: {
      marginBottom: 1
    }, children: [
      /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Typography, { color: "brand.700", fontWeight: 700, children: label }) }),
      /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Typography, { fontSize: "22px", fontWeight: 300, children }) })
    ] });
  };
  const countryObj = countries.countries[(basicDetails == null ? void 0 : basicDetails.country) || "US"];
  const countryName = countryObj.name;
  const countryFlag = countryObj.emoji;
  const countryNameAndFlag = `${countryName} ${countryFlag}`;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: true, openState: errorDialogOpen, setOpenState: setErrorDialogOpen, message: errorMessage }),
    /* @__PURE__ */ jsxs(Box, { sx: {
      width: "100%",
      display: "flex"
    }, justifyContent: isMobile ? "center" : "start", children: [
      /* @__PURE__ */ jsxs(Container, { maxWidth: "md", sx: {
        mx: 2,
        mt: 1,
        mb: 3
      }, children: [
        /* @__PURE__ */ jsx(Typography, { justifyContent: "start", variant: "body1", sx: {
          m: 2
        }, children: /* @__PURE__ */ jsx(Trans, { id: "qNh1HX" }) }),
        /* @__PURE__ */ jsxs(Box, { sx: {
          m: 2
        }, children: [
          /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Grid, { container: true, children: [
            /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(ReviewEl, { label: i18n._(
              /*i18n*/
              {
                id: "6YtxFj"
              }
            ), children: `${basicDetails == null ? void 0 : basicDetails.firstName} ${basicDetails == null ? void 0 : basicDetails.lastName}` }) }),
            /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(ReviewEl, { label: i18n._(
              /*i18n*/
              {
                id: "n5BlVb"
              }
            ), children: countryNameAndFlag }) }),
            /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: hooks(basicDetails == null ? void 0 : basicDetails.dob, "YYYY-MM-DD", true).isValid() && /* @__PURE__ */ jsx(ReviewEl, { label: i18n._(
              /*i18n*/
              {
                id: "Dh+FIh"
              }
            ), children: dateIsoToDisplay((basicDetails == null ? void 0 : basicDetails.dob) || "") }) }),
            /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(ReviewEl, { label: i18n._(
              /*i18n*/
              {
                id: "ZuLy43"
              }
            ), children: basicDetails == null ? void 0 : basicDetails.phoneNumber }) }),
            (basicDetails == null ? void 0 : basicDetails.country) == "US" && /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, className: "fs-exclude", children: /* @__PURE__ */ jsx(ReviewEl, { label: i18n._(
              /*i18n*/
              {
                id: "mL3uuM"
              }
            ), children: formatSSN((basicDetails == null ? void 0 : basicDetails.stateIdentifier) || "") }) }),
            /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(ReviewEl, { label: i18n._(
              /*i18n*/
              {
                id: "9pnaAI"
              }
            ), children: basicDetails == null ? void 0 : basicDetails.occupation }) }),
            /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 12, children: /* @__PURE__ */ jsxs(ReviewEl, { label: i18n._(
              /*i18n*/
              {
                id: "Du6bPw"
              }
            ), children: [
              basicDetails == null ? void 0 : basicDetails.streetAddress,
              /* @__PURE__ */ jsx("br", {}),
              (basicDetails == null ? void 0 : basicDetails.city) && `${basicDetails == null ? void 0 : basicDetails.city},`,
              " ",
              basicDetails == null ? void 0 : basicDetails.state,
              " ",
              basicDetails == null ? void 0 : basicDetails.zipcode
            ] }) })
          ] }) }),
          /* @__PURE__ */ jsx(Box, { sx: {
            mt: 5,
            display: "flex",
            justifyContent: "left"
          }, children: /* @__PURE__ */ jsx(Button, { variant: "outlined", sx: {
            minWidth: {
              xs: "100%",
              sm: "100%",
              md: "400px"
            }
          }, onClick: () => {
            amplitude.track("kyc-details-edit");
            startEditBasicDetails();
          }, children: /* @__PURE__ */ jsx(Trans, { id: "Y1YKad" }) }) })
        ] })
      ] }),
      /* @__PURE__ */ jsx(HideBelow, { screenSize: "md", children: /* @__PURE__ */ jsx(SidebarIndividual, { tabs: sidebarTabs, currentTabId: "review-and-submit", buttonLabel: i18n._(
        /*i18n*/
        {
          id: "hQRttt"
        }
      ), butonOnClick: onSubmit, buttonDisabled: isSubmitting, isSubmitting }) })
    ] }),
    /* @__PURE__ */ jsx(MobileStickyBottomBox, { hideAbove: "md", children: /* @__PURE__ */ jsx(Button, { onClick: onSubmit, disabled: isSubmitting, startIcon: isSubmitting && /* @__PURE__ */ jsx(CircularProgress, { size: 24 }), endIcon: /* @__PURE__ */ jsx(ArrowForward, {}), variant: "contained", fullWidth: true, children: "Submit" }) })
  ] });
};
const ReviewAndSubmitTabPanel$2 = ReviewAndSubmitTabPanel$1;
const KycAppIndividual = ({
  entityId,
  isReverificationFlow,
  navigateToStatusPage
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
  const entityIdVars = {
    variables: {
      entityId
    }
  };
  const basicDetailsQuery = usePersonKycBasicDetailsQuery(__spreadValues({}, entityIdVars));
  const idvSessionQuery = useVeriffIdvSessionQuery(__spreadValues({}, entityIdVars));
  const currentStepQuery = useCurrentOnboardingStepQuery(__spreadValues({}, entityIdVars));
  const basicDetails = (_d = (_c = (_b = (_a = basicDetailsQuery == null ? void 0 : basicDetailsQuery.data) == null ? void 0 : _a.me) == null ? void 0 : _b.entity) == null ? void 0 : _c.kyc) == null ? void 0 : _d.basicDetails;
  const isRegisteringForOffering = Boolean((_h = (_g = (_f = (_e = basicDetailsQuery == null ? void 0 : basicDetailsQuery.data) == null ? void 0 : _e.me) == null ? void 0 : _f.entity) == null ? void 0 : _g.latestRegisteredOffering) == null ? void 0 : _h.name);
  const proofOfAddressDocs = (_l = (_k = (_j = (_i = basicDetailsQuery == null ? void 0 : basicDetailsQuery.data) == null ? void 0 : _i.me) == null ? void 0 : _j.entity) == null ? void 0 : _k.kyc) == null ? void 0 : _l.documents;
  const idvSession = (_p = (_o = (_n = (_m = idvSessionQuery == null ? void 0 : idvSessionQuery.data) == null ? void 0 : _m.me) == null ? void 0 : _n.entity) == null ? void 0 : _o.kyc) == null ? void 0 : _p.idv;
  const currentStep = (_t = (_s = (_r = (_q = currentStepQuery == null ? void 0 : currentStepQuery.data) == null ? void 0 : _q.me) == null ? void 0 : _r.entity) == null ? void 0 : _s.kyc) == null ? void 0 : _t.currentStep;
  const basicDetailsIsFilledOut = !!basicDetails && !!basicDetails.streetAddress;
  const [isEditingBasicDetails, setIsEditingBasicDetails] = useState(isReverificationFlow);
  const shouldDisplayBasicDetails = !basicDetailsIsFilledOut || isEditingBasicDetails;
  const isLoading = [basicDetailsQuery, idvSessionQuery, currentStepQuery].some((query) => query == null ? void 0 : query.loading);
  if (isLoading) {
    return /* @__PURE__ */ jsx(PageLoadingSpinner, {});
  }
  const hasError = [basicDetailsQuery, idvSessionQuery, currentStepQuery].some((query) => (query == null ? void 0 : query.error) || !(query == null ? void 0 : query.data));
  if (hasError) {
    return /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: false, message: i18n._(
      /*i18n*/
      {
        id: "3NWd2t"
      }
    ) });
  }
  if (currentStep === KycOnboardingStep.Status) {
    navigateToStatusPage();
    return /* @__PURE__ */ jsx(PageLoadingSpinner, {});
  }
  let currentTab;
  if (currentStep == KycOnboardingStep.Idv) {
    currentTab = "idv";
  } else if (shouldDisplayBasicDetails) {
    currentTab = "basic-details";
  } else {
    currentTab = "review-and-submit";
  }
  const tabs = [{
    index: 1,
    id: "basic-details",
    title: i18n._(
      /*i18n*/
      {
        id: "EOUool"
      }
    )
  }, {
    index: 2,
    id: "review-and-submit",
    title: i18n._(
      /*i18n*/
      {
        id: "ruqhV8"
      }
    )
  }, {
    index: 3,
    id: "idv",
    title: i18n._(
      /*i18n*/
      {
        id: "xahhAo"
      }
    )
  }];
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(TabContext, { value: currentTab, children: [
    /* @__PURE__ */ jsx(TabPanel$1, { value: "basic-details", children: /* @__PURE__ */ jsx(BasicDetailsTabPanel$1, { isRegisteringForOffering, proofOfAddressDocs, sidebarTabs: tabs, entityId, basicDetails, onEditBasicDetailsFinished: () => setIsEditingBasicDetails(false), isReverificationFlow }) }),
    /* @__PURE__ */ jsx(TabPanel$1, { value: "review-and-submit", children: /* @__PURE__ */ jsx(ReviewAndSubmitTabPanel$2, { sidebarTabs: tabs, entityId, basicDetails, startEditBasicDetails: () => setIsEditingBasicDetails(true) }) }),
    /* @__PURE__ */ jsx(TabPanel$1, { value: "idv", children: idvSession && /* @__PURE__ */ jsx(IdvTabPanel$2, { sidebarTabs: tabs, entityId, basicDetails, idvSession }) })
  ] }) });
};
const KycAppIndividual$1 = KycAppIndividual;
const SvgProgressComplete = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "#64D268", viewBox: "0 0 48 48" }, props), /* @__PURE__ */ React.createElement("path", { d: "M23.345 45.548c3.062 0 5.94-.586 8.636-1.758a22.874 22.874 0 0 0 7.163-4.856 22.947 22.947 0 0 0 4.855-7.141c1.172-2.71 1.758-5.596 1.758-8.657 0-3.062-.586-5.94-1.758-8.635a22.874 22.874 0 0 0-4.855-7.164 22.875 22.875 0 0 0-7.163-4.856C29.27 1.31 26.384.724 23.322.724c-3.061 0-5.947.586-8.657 1.757a22.946 22.946 0 0 0-7.141 4.856 23.06 23.06 0 0 0-4.834 7.164C1.519 17.195.933 20.074.933 23.136c0 3.061.586 5.947 1.758 8.657a22.946 22.946 0 0 0 4.856 7.141 22.946 22.946 0 0 0 7.141 4.856c2.71 1.172 5.596 1.758 8.657 1.758Zm-2.46-11.69c-.382 0-.726-.08-1.033-.241-.308-.161-.608-.432-.901-.813l-5.516-6.768a3.577 3.577 0 0 1-.395-.681 2.232 2.232 0 0 1-.132-.747c0-.498.169-.923.506-1.274.337-.367.754-.55 1.252-.55.322 0 .608.066.857.198.264.132.535.38.813.747l4.46 5.757 9.383-15.073c.41-.674.937-1.011 1.582-1.011.469 0 .893.154 1.274.461.381.293.571.696.571 1.209 0 .249-.058.498-.175.747a7.91 7.91 0 0 1-.374.703L22.73 32.804a2.45 2.45 0 0 1-.813.79 2.044 2.044 0 0 1-1.033.264Z" }));
const SvgProgressEditing = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "#FFB84D", viewBox: "0 0 48 48" }, props), /* @__PURE__ */ React.createElement("path", { d: "M46.768 23.136c0-3.135-.6-6.08-1.802-8.833a23.449 23.449 0 0 0-4.965-7.317 22.882 22.882 0 0 0-7.295-4.944C29.937.841 26.986.24 23.85.24c-3.135 0-6.087.6-8.855 1.802a23.14 23.14 0 0 0-7.317 4.944 23.45 23.45 0 0 0-4.966 7.317C1.526 17.057.933 20 .933 23.136c0 3.15.593 6.108 1.78 8.877a23.185 23.185 0 0 0 4.966 7.295 23.141 23.141 0 0 0 7.317 4.944c2.768 1.2 5.72 1.801 8.855 1.801 3.134 0 6.086-.6 8.855-1.801A22.883 22.883 0 0 0 40 39.307a23.522 23.522 0 0 0 4.966-7.295c1.201-2.769 1.802-5.728 1.802-8.877Zm-5.032 0H5.965c0-2.476.461-4.79 1.384-6.944a17.674 17.674 0 0 1 3.845-5.69 17.997 17.997 0 0 1 5.691-3.846c2.168-.937 4.49-1.406 6.966-1.406 2.475 0 4.79.461 6.943 1.384a17.929 17.929 0 0 1 5.713 3.845 17.674 17.674 0 0 1 3.845 5.691c.923 2.168 1.384 4.49 1.384 6.966Z" }));
const SvgProgressIncomplete = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" }, props), /* @__PURE__ */ React.createElement("path", { stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" }));
const StyledTab = styled$3(Tab)(() => ({
  width: "95%",
  height: "50px",
  borderRadius: "16px !important",
  border: `1px solid #ccc !important`,
  margin: 4,
  alignItems: "flex-start",
  fontWeight: "500 !important",
  color: "black !important",
  "&:hover, &.Mui-focusVisible": {
    border: `1px solid black !important`
  },
  "&.Mui-selected": {
    backgroundColor: "#ddd",
    border: `2px solid black !important`,
    borderColor: "#ccc",
    height: "40px",
    boxShadow: "none"
  },
  "&.Mui-disabled": {
    color: `#ccc !important`,
    border: `1px dashed #ccc !important`
  }
}));
const SidebarOrganization = ({
  currentTabIndex,
  buttonClickHandler,
  setTabIndex,
  tabs,
  sidebarDescription
}) => {
  const selectedTabId = tabs[currentTabIndex].id;
  const getTabLabel = (tab2) => {
    let icon;
    switch (tab2.progressState) {
      case ProgressState.COMPLETE:
        icon = /* @__PURE__ */ jsx(Box, { sx: {
          width: "20px"
        }, children: /* @__PURE__ */ jsx(SvgProgressComplete, {}) });
        break;
      case ProgressState.EDITING:
        icon = /* @__PURE__ */ jsx(Box, { sx: {
          width: "20px"
        }, children: /* @__PURE__ */ jsx(SvgProgressEditing, {}) });
        break;
      default:
        icon = /* @__PURE__ */ jsx(Box, { sx: {
          width: "20px"
        }, children: /* @__PURE__ */ jsx(SvgProgressIncomplete, {}) });
        break;
    }
    return /* @__PURE__ */ jsxs(Box, { sx: {
      display: "flex",
      marginTop: "3px"
    }, children: [
      icon,
      /* @__PURE__ */ jsx("p", { style: {
        marginLeft: "12px",
        fontSize: "14px",
        paddingTop: "3px"
      }, children: tab2.title })
    ] });
  };
  const showContinueButton = currentTabIndex < tabs.length - 1 && tabs[currentTabIndex + 1].isClickable;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Box, { sx: {
    top: "80px",
    border: `2px solid ${MuiTheme$1.palette.grey[300]}`,
    borderRadius: "24px",
    padding: 5
  }, children: [
    /* @__PURE__ */ jsx(Typography, { color: "black", children: sidebarDescription }),
    /* @__PURE__ */ jsx(Box, { sx: {
      borderBottom: "none",
      mt: 2
    }, children: /* @__PURE__ */ jsx(Tabs, { value: selectedTabId, orientation: "vertical", TabIndicatorProps: {
      style: {
        backgroundColor: "transparent"
      }
    }, sx: {
      "& .MuiTabs-flexContainer": {
        alignItems: "center",
        justifyContent: "center"
      }
    }, children: tabs.map((tab2) => /* @__PURE__ */ jsx(StyledTab, { label: getTabLabel(tab2), onClick: () => setTabIndex(tab2.index), value: tab2.id, disabled: !tab2.isClickable }, tab2.index)) }) }),
    showContinueButton && /* @__PURE__ */ jsx(Button, { fullWidth: true, variant: "contained", sx: {
      mt: 2,
      height: "48px",
      borderRadius: "20px"
    }, onClick: buttonClickHandler, endIcon: /* @__PURE__ */ jsx(default_1$1, {}), children: "Continue" })
  ] }) });
};
const Question = ({
  questionnaireSlug,
  question
}) => {
  var _a;
  const {
    slug: questionSlug,
    answerType,
    displayAs,
    text: text2,
    choices,
    isOptional,
    tooltipText
  } = question;
  const orderedChoices = [...choices || []].sort((a, b2) => a.order - b2.order);
  const {
    control,
    register,
    formState,
    watch
  } = useFormContext();
  const formKey = `${questionnaireSlug}.${questionSlug}`;
  const errors2 = (_a = formState.errors) == null ? void 0 : _a[questionnaireSlug];
  const questionError = errors2 == null ? void 0 : errors2[questionSlug];
  const renderQuestion = () => {
    switch (displayAs) {
      case "CHECKBOX":
        return renderCheckboxQuestion();
      case "RADIO":
        return renderRadioQuestion();
      case "SELECT":
        return renderSelectQuestion();
      case "TEXT_INPUT_SINGLELINE":
        return renderTextInputQuestion();
      case "TEXT_INPUT_MULTILINE":
        return renderTextAreaQuestion();
      default:
        return null;
    }
  };
  const renderCheckboxQuestion = () => {
    return /* @__PURE__ */ jsx(FormGroup, { sx: __spreadValues({}, questionError ? {
      border: `1px solid ${palette.brand.errorRed}`,
      borderRadius: "10px"
    } : {}), children: orderedChoices == null ? void 0 : orderedChoices.map((choice) => {
      var _a2;
      return /* @__PURE__ */ jsx(FormControlLabel, { control: /* @__PURE__ */ jsx(Checkbox, __spreadProps(__spreadValues({}, register(formKey)), { value: choice.id, checked: (_a2 = watch(formKey)) == null ? void 0 : _a2.includes(choice.id) })), label: choice.text }, choice.id);
    }) });
  };
  const renderRadioQuestion = () => {
    return /* @__PURE__ */ jsx(Controller, { name: formKey, control, rules: {
      required: {
        value: !isOptional,
        message: i18n._(
          /*i18n*/
          {
            id: "1/tEGr"
          }
        )
      }
    }, render: ({
      field
    }) => /* @__PURE__ */ jsx(FormGroup, { children: /* @__PURE__ */ jsx(RadioGroup, __spreadProps(__spreadValues({}, field), { children: answerType === "Questionnaires::BooleanAnswer" ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(FormControlLabel, { control: /* @__PURE__ */ jsx(Radio, {}), value: "true", label: i18n._(
        /*i18n*/
        {
          id: "l75CjT"
        }
      ) }),
      /* @__PURE__ */ jsx(FormControlLabel, { control: /* @__PURE__ */ jsx(Radio, {}), value: "false", label: i18n._(
        /*i18n*/
        {
          id: "1UzENP"
        }
      ) })
    ] }) : orderedChoices == null ? void 0 : orderedChoices.map((choice, index2) => /* @__PURE__ */ jsx(FormControlLabel, { control: /* @__PURE__ */ jsx(Radio, {}), label: choice.text, value: choice.id }, index2)) })) }) });
  };
  const renderSelectQuestion = () => {
    return /* @__PURE__ */ jsx(Controller, { name: formKey, control, render: ({
      field
    }) => /* @__PURE__ */ jsxs(Select, __spreadProps(__spreadValues({ fullWidth: true, label: "", displayEmpty: true, variant: "outlined", size: "small", error: !!questionError }, field), { children: [
      /* @__PURE__ */ jsx(MenuItem, { value: "", disabled: true, children: "Select an option" }),
      orderedChoices == null ? void 0 : orderedChoices.map((choice, index2) => /* @__PURE__ */ jsx(MenuItem, { value: choice.id, selected: watch(formKey) === choice.id, children: choice.text }, index2))
    ] })) });
  };
  const renderTextInputQuestion = () => {
    return /* @__PURE__ */ jsx(TextField, __spreadValues({ fullWidth: true, id: formKey, size: "small", error: !!questionError }, register(formKey)));
  };
  const renderTextAreaQuestion = () => {
    return /* @__PURE__ */ jsx(TextField, __spreadValues({ id: formKey, fullWidth: true, multiline: true, rows: 4, error: !!questionError }, register(formKey)));
  };
  return /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: text2, inputDescription: "", renderAsterisk: !isOptional, tooltipText: tooltipText || void 0, error: questionError == null ? void 0 : questionError.message, headerFontSize: "15px", children: /* @__PURE__ */ jsx(Box, { sx: {
    mt: "6px",
    maxWidth: "500px",
    fontSize: "15px",
    "& .MuiFormControlLabel-root": {
      fontSize: "15px",
      maxHeight: "34px"
    }
  }, children: renderQuestion() }) });
};
const Questionnaire = ({
  questionnaire
}) => {
  const orderedQuestions = [...questionnaire == null ? void 0 : questionnaire.questions].sort((a, b2) => {
    return a.order - b2.order;
  });
  return /* @__PURE__ */ jsx("div", { children: orderedQuestions == null ? void 0 : orderedQuestions.map((question) => {
    return /* @__PURE__ */ jsx(Box, { sx: {
      mb: 2
    }, children: /* @__PURE__ */ jsx(Question, { questionnaireSlug: questionnaire.slug, question }) }, question.slug);
  }) });
};
const QUESTION_ANSWER_TYPE = {
  FREEFORM: "Questionnaires::FreeformAnswer",
  MULTIPLE_CHOICE: "Questionnaires::MultipleChoiceAnswer",
  BOOLEAN: "Questionnaires::BooleanAnswer"
};
const questionnaireFormValuesToGql = (values2) => {
  return Object.entries(values2).flatMap(([questionSlug, answer]) => (Array.isArray(answer) ? answer : [answer]).map((singleAnswer) => ({
    questionSlug,
    answer: singleAnswer
  }))) || [];
};
const getQuestionnaireInitValues = (questionnaire, existingSubmission) => {
  const initValues = {};
  questionnaire.questions.map((question) => {
    var _a;
    const existingAnswers = (_a = existingSubmission == null ? void 0 : existingSubmission.find((submission) => submission.questionSlug === question.slug)) == null ? void 0 : _a.answers;
    switch (question.answerType) {
      case QUESTION_ANSWER_TYPE.FREEFORM:
        initValues[question.slug] = (existingAnswers == null ? void 0 : existingAnswers[0]) || "";
        break;
      case QUESTION_ANSWER_TYPE.MULTIPLE_CHOICE:
        if (question.shouldAllowMultipleAnswers) {
          initValues[question.slug] = existingAnswers || [];
        } else {
          initValues[question.slug] = (existingAnswers == null ? void 0 : existingAnswers[0]) || "";
        }
        break;
      case QUESTION_ANSWER_TYPE.BOOLEAN:
        initValues[question.slug] = (existingAnswers == null ? void 0 : existingAnswers[0]) || "false";
        break;
    }
  });
  return initValues;
};
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var DisabledContext = /* @__PURE__ */ createContext(false);
var Disable = function Disable2(_ref) {
  var _ref$as = _ref.as, as2 = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, disabled = _ref.disabled, disabledProps = _ref.disabledProps, disabledStyles = _ref.disabledStyles, _ref$disabledOpacity = _ref.disabledOpacity, disabledOpacity = _ref$disabledOpacity === void 0 ? 0.3 : _ref$disabledOpacity, rest = _objectWithoutPropertiesLoose(_ref, ["as", "children", "disabled", "disabledProps", "disabledStyles", "disabledOpacity"]);
  var isParentDisabled = useContext(DisabledContext);
  var shouldDisable = isParentDisabled ? false : disabled;
  var disableEvent = useCallback(function(e2) {
    e2.persist();
    if (shouldDisable) {
      e2.preventDefault();
      e2.stopPropagation();
    }
  }, [shouldDisable]);
  return createElement(DisabledContext.Provider, {
    value: disabled
  }, createElement(as2, _extends({
    style: _extends({
      transition: "all 100ms linear"
    }, shouldDisable && _extends({
      opacity: disabledOpacity,
      pointerEvents: "none",
      userSelect: "none"
    }, disabledStyles)),
    onClick: disableEvent,
    onKeyDown: disableEvent
  }, shouldDisable && _extends({
    tabIndex: -1,
    "aria-hidden": "true"
  }, disabledProps), {}, rest), children));
};
const KybTabPanelButtons = ({
  setAllowEdits,
  submitHandler,
  progressState,
  isSubmitting,
  disabled
}) => {
  return progressState === ProgressState.COMPLETE ? /* @__PURE__ */ jsx(Button, { variant: "outlined", size: "large", onClick: setAllowEdits, sx: {
    width: "100%",
    my: 4
  }, children: "Edit Submission" }) : /* @__PURE__ */ jsxs(Button, { variant: "contained", size: "large", onClick: submitHandler, disabled: isSubmitting || disabled, sx: {
    width: "100%",
    my: 4
  }, endIcon: /* @__PURE__ */ jsx(ArrowForward, { color: "inherit" }), children: [
    isSubmitting && /* @__PURE__ */ jsx(CircularProgress, { size: 24, sx: {
      mr: 1
    } }),
    progressState === ProgressState.EDITING ? i18n._(
      /*i18n*/
      {
        id: "IUwGEM"
      }
    ) : i18n._(
      /*i18n*/
      {
        id: "C85d5+"
      }
    )
  ] });
};
const KybTabPanelButtons$1 = KybTabPanelButtons;
const KybTabPanelHeader = ({
  title,
  subtitle,
  setAllowEdits,
  progressState
}) => {
  let progressIcon;
  let progressDisplay;
  switch (progressState) {
    case ProgressState.COMPLETE:
      progressIcon = /* @__PURE__ */ jsx(Box, { sx: {
        width: "40px"
      }, children: /* @__PURE__ */ jsx(SvgProgressComplete, {}) });
      progressDisplay = /* @__PURE__ */ jsx(Button, { variant: "outlined", size: "medium", onClick: setAllowEdits, sx: {
        mb: "3px",
        ml: 2
      }, children: "Edit Submission" });
      break;
    case ProgressState.EDITING:
      progressIcon = /* @__PURE__ */ jsx(Box, { sx: {
        width: "40px"
      }, children: /* @__PURE__ */ jsx(SvgProgressEditing, {}) });
      progressDisplay = /* @__PURE__ */ jsx(Typography, { sx: {
        fontSize: {
          xs: "16px",
          sm: "20px",
          md: "40px"
        },
        fontWeight: "bold",
        ml: 2,
        color: "#aaa"
      }, children: "(Editing)" });
      break;
    default:
      progressIcon = void 0;
      progressDisplay = void 0;
      break;
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Box, { sx: {
      display: "flex",
      alignItems: "center",
      mb: 3
    }, children: [
      /* @__PURE__ */ jsx(Typography, { sx: {
        fontSize: "40px",
        fontWeight: "bold"
      }, children: title }),
      progressIcon && /* @__PURE__ */ jsx(Box, { display: "inline-block", sx: {
        ml: 1
      }, children: progressIcon }),
      progressDisplay
    ] }),
    subtitle && /* @__PURE__ */ jsx(Typography, { sx: {
      mb: 3,
      color: "#aaa"
    }, children: subtitle })
  ] });
};
const KybTabPanelHeader$1 = KybTabPanelHeader;
const AccountUsageTabPanel = ({
  entityId,
  progressState,
  setAllowEdits,
  moveToNextTab,
  existingData,
  questionnaire
}) => {
  var _a, _b, _c;
  const amplitude = useAmplitude();
  const kycData = (_c = (_b = (_a = existingData == null ? void 0 : existingData.data) == null ? void 0 : _a.me) == null ? void 0 : _b.entity) == null ? void 0 : _c.kyc;
  const questionnaireSubmission = (kycData == null ? void 0 : kycData.accountUsageSurvey) || [];
  const {
    formCache,
    setFormCache
  } = useContext(FormCacheContext);
  const methods = useForm({
    defaultValues: (formCache == null ? void 0 : formCache.accountUsage) || {
      [questionnaire.slug]: getQuestionnaireInitValues(questionnaire, questionnaireSubmission)
    },
    resolver: (data) => {
      const validationErrors = {};
      const questionnaireErrors = validateQuestionnaireFormInputs(questionnaire, data[questionnaire.slug]);
      if (Object.keys(questionnaireErrors).length > 0) {
        validationErrors[questionnaire.slug] = questionnaireErrors;
      }
      return {
        values: data,
        errors: validationErrors
      };
    }
  });
  useEffect(() => {
    methods.watch((values2) => setFormCache(__spreadProps(__spreadValues({}, formCache), {
      accountUsage: values2
    })));
  });
  const formErrorsExist = Object.values(methods.formState.errors).some(Boolean);
  const [upsertAccountUsageSurvey] = useUpsertAccountUsageSurveyMutation({
    refetchQueries: () => {
      return [{
        query: AccountUsageSubmissionDocument,
        variables: {
          entityId
        }
      }];
    }
  });
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const onSubmit = (data) => __async(void 0, null, function* () {
    var _a2, _b2;
    setIsSubmitting(true);
    try {
      const request = {
        entity: entityId,
        submission: questionnaireFormValuesToGql(data[questionnaire.slug])
      };
      const res = yield upsertAccountUsageSurvey({
        variables: request
      });
      if (!((_b2 = (_a2 = res.data) == null ? void 0 : _a2.upsertAccountUsageSurvey) == null ? void 0 : _b2.success)) {
        throw new Error("Unsuccesful response");
      }
      amplitude.track("kyb-usage-saved");
      moveToNextTab();
    } catch (error) {
      setErrorMessage(error.message);
      setErrorDialogOpen(true);
      amplitude.track("kyb-usage-error");
    } finally {
      setIsSubmitting(false);
    }
  });
  return /* @__PURE__ */ jsxs(FormProvider, __spreadProps(__spreadValues({}, methods), { children: [
    /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: true, openState: errorDialogOpen, setOpenState: setErrorDialogOpen, message: errorMessage }),
    /* @__PURE__ */ jsx(KybTabPanelHeader$1, { title: "Account Usage", setAllowEdits, progressState }),
    /* @__PURE__ */ jsx(Disable, { disabled: progressState == ProgressState.COMPLETE, disabledOpacity: 0.6, children: /* @__PURE__ */ jsx(Questionnaire, { questionnaire }) }),
    /* @__PURE__ */ jsx(KybTabPanelButtons$1, { setAllowEdits, submitHandler: methods.handleSubmit(onSubmit), progressState, isSubmitting, disabled: formErrorsExist })
  ] }));
};
const AuthorizedSignatoryTabPanel = ({
  existingData,
  evidenceToActDocs,
  proofOfResidenceDocs,
  entityKind,
  entityId,
  moveToNextTab,
  progressState,
  setAllowEdits
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const amplitude = useAmplitude();
  const kyc = (_c = (_b = (_a = existingData == null ? void 0 : existingData.data) == null ? void 0 : _a.me) == null ? void 0 : _b.entity) == null ? void 0 : _c.kyc;
  const authorizedSignatory = kyc == null ? void 0 : kyc.authorizedSignatory;
  const [authorizedSignatoryExists, setAuthorizedSignatoryExists] = useState((kyc == null ? void 0 : kyc.authorizedSignatory) ? true : false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const {
    formCache,
    setFormCache
  } = useContext(FormCacheContext);
  const refetchQueries = [{
    query: AuthorizedSignatoryDocument,
    variables: {
      entityId
    }
  }];
  const [createAuthorizedSignatory] = useCreateAuthorizedSignatoryMutation({
    refetchQueries: () => refetchQueries
  });
  const [editAuthorizedSignatory] = useEditAuthorizedSignatoryMutation({
    refetchQueries: () => refetchQueries
  });
  const globalConstants = useConstants();
  const methods = useForm({
    defaultValues: (formCache == null ? void 0 : formCache.signatory) || {
      title: (authorizedSignatory == null ? void 0 : authorizedSignatory.title) || "",
      firstName: (authorizedSignatory == null ? void 0 : authorizedSignatory.firstName) || "",
      lastName: (authorizedSignatory == null ? void 0 : authorizedSignatory.lastName) || "",
      middleName: (authorizedSignatory == null ? void 0 : authorizedSignatory.middleName) || "",
      stateIdentifier: formatSSN((authorizedSignatory == null ? void 0 : authorizedSignatory.stateIdentifier) || ""),
      phoneNumber: (authorizedSignatory == null ? void 0 : authorizedSignatory.phoneNumber) || "",
      dateOfBirth: (authorizedSignatory == null ? void 0 : authorizedSignatory.dob) || "",
      streetAddress: (authorizedSignatory == null ? void 0 : authorizedSignatory.streetAddress) || "",
      city: (authorizedSignatory == null ? void 0 : authorizedSignatory.city) || "",
      country: (authorizedSignatory == null ? void 0 : authorizedSignatory.country) || "US",
      postalCode: (authorizedSignatory == null ? void 0 : authorizedSignatory.zipcode) || "",
      region: (authorizedSignatory == null ? void 0 : authorizedSignatory.region) || ""
    },
    resolver: (data) => {
      const validationErrors = validateFormInputsAgainstRuleSet(PersonRules, lodashExports.pick(data, Object.keys(PersonRules)), {
        globalConstants,
        checkWalletEligibility: false
      });
      return {
        values: data,
        errors: validationErrors
      };
    }
  });
  useEffect(() => {
    methods.watch((values2) => setFormCache(__spreadProps(__spreadValues({}, formCache), {
      signatory: values2
    })));
  });
  const {
    errors: errors2
  } = methods.formState;
  const formErrorsExist = Object.values(errors2).some(Boolean);
  const watchedCountry = methods.watch("country");
  const evidenceToActDocsComplete = (evidenceToActDocs == null ? void 0 : evidenceToActDocs.length) > 0;
  const proofOfResidenceDocsComplete = (proofOfResidenceDocs == null ? void 0 : proofOfResidenceDocs.length) > 0;
  const docsCompleted = {
    [EntityOrganizationKind.Company]: evidenceToActDocsComplete && proofOfResidenceDocsComplete,
    [EntityOrganizationKind.Trust]: true
  };
  const onSubmit = (data) => __async(void 0, null, function* () {
    var _a2, _b2, _c2, _d2;
    if (!docsCompleted[entityKind]) {
      return;
    }
    setIsSubmitting(true);
    const request = __spreadProps(__spreadValues({}, data), {
      ownerId: entityId
    });
    try {
      if (authorizedSignatoryExists) {
        const res = yield editAuthorizedSignatory({
          variables: request
        });
        if (!((_b2 = (_a2 = res.data) == null ? void 0 : _a2.editAuthorizedSignatory) == null ? void 0 : _b2.success)) {
          throw new Error("Unsuccesful response");
        }
      } else {
        const res = yield createAuthorizedSignatory({
          variables: request
        });
        if (!((_d2 = (_c2 = res.data) == null ? void 0 : _c2.createAuthorizedSignatory) == null ? void 0 : _d2.success)) {
          throw new Error("Unsuccesful response");
        }
        setAuthorizedSignatoryExists(true);
      }
      amplitude.track("kyb-signatory-saved");
      moveToNextTab();
    } catch (e2) {
      setErrorMessage("An error occurred submitting your information. Please try again later.");
      setErrorDialogOpen(true);
      amplitude.track("kyb-signatory-error");
    } finally {
      setIsSubmitting(false);
    }
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: true, openState: errorDialogOpen, setOpenState: setErrorDialogOpen, message: errorMessage }),
    /* @__PURE__ */ jsx(KybTabPanelHeader$1, { title: "Authorized Signatory", subtitle: "An authorized signatory is a person who has been given legal power to\n        sign contracts, instruments, agreements or legally binding documents on\n        behalf of a legal entity.", setAllowEdits, progressState }),
    /* @__PURE__ */ jsxs(Disable, { disabled: progressState == ProgressState.COMPLETE, disabledOpacity: 0.6, children: [
      /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Title", error: (_d = errors2.title) == null ? void 0 : _d.message, children: /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ fullWidth: true, placeholder: "CEO", variant: "outlined", size: "small" }, methods.register("title")), { error: !!errors2.title })) }),
      /* @__PURE__ */ jsxs(Grid, { container: true, spacing: 2, children: [
        /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 4, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "First Name", error: (_e = errors2.firstName) == null ? void 0 : _e.message, children: /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ fullWidth: true, placeholder: "Satoshi", variant: "outlined", size: "small" }, methods.register("firstName")), { error: !!errors2.firstName })) }) }),
        /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 4, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Middle Name", error: (_f = errors2.middleName) == null ? void 0 : _f.message, children: /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ fullWidth: true, placeholder: "", variant: "outlined", size: "small" }, methods.register("middleName")), { error: !!errors2.middleName })) }) }),
        /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 4, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Last Name", error: (_g = errors2.lastName) == null ? void 0 : _g.message, children: /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ fullWidth: true, placeholder: "Nakamoto", variant: "outlined", size: "small" }, methods.register("lastName")), { error: !!errors2.lastName })) }) })
      ] }),
      /* @__PURE__ */ jsxs(Grid, { container: true, spacing: 2, sx: {
        mb: 3
      }, children: [
        /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Date of Birth", error: (_h = errors2.dateOfBirth) == null ? void 0 : _h.message, children: /* @__PURE__ */ jsx(Controller, { name: "dateOfBirth", control: methods.control, render: ({
          field
        }) => /* @__PURE__ */ jsx(TextField, { fullWidth: true, type: "date", variant: "outlined", size: "small", error: !!errors2.dateOfBirth, onChange: (e2) => {
          field.onChange(capDateIsoToToday(e2.target.value));
        }, value: capDateIsoToToday(field.value) }) }) }) }),
        /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, sx: {
          mb: 3
        }, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Phone number", error: (_i = errors2.phoneNumber) == null ? void 0 : _i.message, children: /* @__PURE__ */ jsx(Controller, { name: "phoneNumber", control: methods.control, render: ({
          field
        }) => /* @__PURE__ */ jsx(KycPhoneInput, { value: field.value, onChange: (newValue) => {
          field.onChange(newValue);
        }, defaultCountry: watchedCountry.toLowerCase(), error: !!errors2.phoneNumber }) }) }) })
      ] }),
      /* @__PURE__ */ jsx(Box, { sx: {
        mb: 3
      }, children: /* @__PURE__ */ jsx(AddressForms$1, { register: methods.register, setValue: methods.setValue, trigger: methods.trigger, formState: methods.formState, watch: methods.watch, addressMustMatchIdv: true }) }),
      /* @__PURE__ */ jsx(Box, { sx: {
        mb: 3
      }, display: watchedCountry === "US" ? "" : "none", children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Social Security Number", error: (_j = errors2.stateIdentifier) == null ? void 0 : _j.message, children: /* @__PURE__ */ jsx(Controller, { name: "stateIdentifier", control: methods.control, render: ({
        field
      }) => /* @__PURE__ */ jsx(TextField, { fullWidth: true, className: "fs-exclude", placeholder: "123-45-6789", variant: "outlined", size: "small", error: !!errors2.stateIdentifier, onChange: (e2) => {
        field.onChange(formatSSN(e2.target.value));
      }, value: formatSSN(field.value) }) }) }) }),
      /* @__PURE__ */ jsx(Box, { sx: {
        mb: 5
      } }),
      entityKind === EntityOrganizationKind.Company && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "h3", sx: {
          mb: 5,
          mt: 3,
          fontSize: "30px",
          fontWeight: "bold"
        }, children: "Signatory Documents" }),
        /* @__PURE__ */ jsx(FileUpload, { label: "Evidence to Act on Behalf of Company", entityId, docCategory: DocumentPurpose.CompaniesEvidenceToAct, existingFiles: evidenceToActDocs, allowMultipleFiles: false, onStatusChange: (status) => {
          if (status === FileUploadStatus.SUCCESS) {
            amplitude.track("kyb-signatory-evidence");
          }
        }, displayError: methods.formState.isSubmitted && !evidenceToActDocsComplete, children: /* @__PURE__ */ jsx(Typography, { mb: "3", color: "textSecondary", children: "Evidence can take the form of written consent of the company board of directors, or a secretary's certificate, or may be included in the company operating agreement." }) }),
        /* @__PURE__ */ jsx(Box, { sx: {
          mt: 3
        } }),
        /* @__PURE__ */ jsx(FileUpload, { label: "Proof of Residence", entityId, docCategory: DocumentPurpose.SignatoryProofOfResidence, existingFiles: proofOfResidenceDocs, allowMultipleFiles: true, onStatusChange: (status) => {
          if (status === FileUploadStatus.SUCCESS) {
            amplitude.track("kyb-signatory-bills");
          }
        }, displayError: methods.formState.isSubmitted && !proofOfResidenceDocsComplete, children: /* @__PURE__ */ jsx(Typography, { mb: "3", color: "textSecondary", children: "Utility bills in your name, home owner's insurance bill, pay stubs from the last 90 days, or your most recent tax filing." }) }),
        /* @__PURE__ */ jsx(Box, { sx: {
          mb: 5
        } })
      ] })
    ] }),
    /* @__PURE__ */ jsx(KybTabPanelButtons$1, { setAllowEdits, submitHandler: methods.handleSubmit(onSubmit), progressState, isSubmitting, disabled: formErrorsExist || methods.formState.isSubmitted && !docsCompleted[entityKind] })
  ] });
};
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset2 = 0) {
  return (byteToHex[arr[offset2 + 0]] + byteToHex[arr[offset2 + 1]] + byteToHex[arr[offset2 + 2]] + byteToHex[arr[offset2 + 3]] + "-" + byteToHex[arr[offset2 + 4]] + byteToHex[arr[offset2 + 5]] + "-" + byteToHex[arr[offset2 + 6]] + byteToHex[arr[offset2 + 7]] + "-" + byteToHex[arr[offset2 + 8]] + byteToHex[arr[offset2 + 9]] + "-" + byteToHex[arr[offset2 + 10]] + byteToHex[arr[offset2 + 11]] + byteToHex[arr[offset2 + 12]] + byteToHex[arr[offset2 + 13]] + byteToHex[arr[offset2 + 14]] + byteToHex[arr[offset2 + 15]]).toLowerCase();
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = {
  randomUUID
};
function v4(options, buf, offset2) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }
  options = options || {};
  const rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset2 = offset2 || 0;
    for (let i = 0; i < 16; ++i) {
      buf[offset2 + i] = rnds[i];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}
const BeneficiaryCreateOrEdit = ({
  beneficiaryId,
  showSummary,
  setShowSummary,
  organizationEntityId,
  clearNewBeneficiary
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const globalConstants = useConstants();
  const amplitude = useAmplitude();
  const beneficiaryDetailsResult = useBeneficiaryDetailsQuery({
    variables: {
      entityId: organizationEntityId,
      beneficiaryId: beneficiaryId || ""
    },
    skip: !beneficiaryId
  });
  const beneficiary = (_d = (_c = (_b = (_a = beneficiaryDetailsResult == null ? void 0 : beneficiaryDetailsResult.data) == null ? void 0 : _a.me) == null ? void 0 : _b.entity) == null ? void 0 : _c.kyc) == null ? void 0 : _d.beneficiary;
  const beneficiaryLoading = beneficiaryDetailsResult.loading;
  const methods = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      middleName: "",
      stateIdentifier: "",
      phoneNumber: "",
      dateOfBirth: "",
      streetAddress: "",
      city: "",
      country: "US",
      postalCode: "",
      region: ""
    },
    resolver: (data) => {
      const validationErrors = validateFormInputsAgainstRuleSet(PersonRules, lodashExports.pick(data, Object.keys(PersonRules)), {
        globalConstants,
        checkWalletEligibility: false
      });
      return {
        values: data,
        errors: validationErrors
      };
    }
  });
  useEffect(() => {
    methods.reset({
      firstName: (beneficiary == null ? void 0 : beneficiary.firstName) || "",
      lastName: (beneficiary == null ? void 0 : beneficiary.lastName) || "",
      middleName: (beneficiary == null ? void 0 : beneficiary.middleName) || "",
      stateIdentifier: formatSSN((beneficiary == null ? void 0 : beneficiary.stateIdentifier) || ""),
      phoneNumber: (beneficiary == null ? void 0 : beneficiary.phoneNumber) || "",
      dateOfBirth: (beneficiary == null ? void 0 : beneficiary.dob) || "",
      streetAddress: (beneficiary == null ? void 0 : beneficiary.streetAddress) || "",
      city: (beneficiary == null ? void 0 : beneficiary.city) || "",
      country: (beneficiary == null ? void 0 : beneficiary.country) || "US",
      postalCode: (beneficiary == null ? void 0 : beneficiary.zipcode) || "",
      region: (beneficiary == null ? void 0 : beneficiary.region) || ""
    });
  }, [beneficiaryDetailsResult]);
  const {
    errors: errors2
  } = methods.formState;
  const watchedCountry = methods.watch("country");
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formErrorsExist = Object.values(errors2).some(Boolean);
  const switchBackToSummary = (id) => {
    const newState = new Set(showSummary);
    newState.add(id);
    setShowSummary(newState);
  };
  const mutationCallbackConfig = {
    refetchQueries: () => {
      return [{
        query: BeneficiariesDocument,
        variables: {
          entityId: organizationEntityId
        }
      }];
    },
    awaitRefetchQueries: true
  };
  const [upsertEditBeneficiary] = useEditBeneficiaryMutation(mutationCallbackConfig);
  const [createBeneficiary] = useCreateBeneficiaryMutation(mutationCallbackConfig);
  if (beneficiaryLoading) {
    return /* @__PURE__ */ jsx(Card, { sx: {
      p: 2,
      mt: 2,
      mb: 2,
      border: "1px solid black"
    }, children: /* @__PURE__ */ jsx(Box, { sx: {
      display: "flex",
      justifyContent: "center"
    }, children: /* @__PURE__ */ jsx(CircularProgress, { size: 60 }) }) });
  }
  const submitBeneficiary = (organizationEntityId2, beneficiaryId2, data) => __async(void 0, null, function* () {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2;
    setIsSubmitting(true);
    let responseOk = false;
    let responseBeneficiaryId = void 0;
    try {
      if (beneficiaryId2) {
        const req = __spreadProps(__spreadValues({}, data), {
          ownerId: organizationEntityId2,
          beneficiaryId: beneficiaryId2
        });
        const res = yield upsertEditBeneficiary({
          variables: req
        });
        responseOk = ((_b2 = (_a2 = res == null ? void 0 : res.data) == null ? void 0 : _a2.editBeneficiary) == null ? void 0 : _b2.success) || false;
        responseBeneficiaryId = (_e2 = (_d2 = (_c2 = res == null ? void 0 : res.data) == null ? void 0 : _c2.editBeneficiary) == null ? void 0 : _d2.result) == null ? void 0 : _e2.relatedPersonId;
      } else {
        const req = __spreadProps(__spreadValues({}, data), {
          ownerId: organizationEntityId2
        });
        const res = yield createBeneficiary({
          variables: req
        });
        responseOk = ((_g2 = (_f2 = res == null ? void 0 : res.data) == null ? void 0 : _f2.createBeneficiary) == null ? void 0 : _g2.success) || false;
        responseBeneficiaryId = (_j2 = (_i2 = (_h2 = res == null ? void 0 : res.data) == null ? void 0 : _h2.createBeneficiary) == null ? void 0 : _i2.result) == null ? void 0 : _j2.relatedPersonId;
        clearNewBeneficiary();
      }
      if (!responseOk || !responseBeneficiaryId) {
        throw new Error("No new beneficiary result from mutation");
      }
      switchBackToSummary(responseBeneficiaryId);
    } catch (e2) {
      setErrorMessage("There was an error submitting the information for this beneficiary. Please try again later.");
      amplitude.track("kyb-beneficiary-error");
      setErrorDialogOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  });
  return /* @__PURE__ */ jsxs(Card, { sx: {
    p: 2,
    mt: 2,
    mb: 2,
    border: "1px solid black"
  }, children: [
    /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: true, openState: errorDialogOpen, setOpenState: setErrorDialogOpen, message: errorMessage }),
    /* @__PURE__ */ jsx(Typography, { variant: "h6", sx: {
      mb: 3
    }, children: "Editing Beneficiary" }),
    /* @__PURE__ */ jsxs(Grid, { container: true, spacing: 1, children: [
      /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 4, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "First Name", error: (_e = errors2.firstName) == null ? void 0 : _e.message, children: /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ fullWidth: true, placeholder: "Vitalik", variant: "outlined", size: "small" }, methods.register("firstName")), { error: !!errors2.firstName })) }) }),
      /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 4, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Middle Name", error: (_f = errors2.middleName) == null ? void 0 : _f.message, children: /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ fullWidth: true, placeholder: "", variant: "outlined", size: "small" }, methods.register("middleName")), { error: !!errors2.middleName })) }) }),
      /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 4, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Last Name", error: (_g = errors2.lastName) == null ? void 0 : _g.message, children: /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ fullWidth: true, placeholder: "Buterin", variant: "outlined", size: "small" }, methods.register("lastName")), { error: !!errors2.lastName })) }) })
    ] }),
    /* @__PURE__ */ jsxs(Grid, { container: true, spacing: 1, children: [
      /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Date of Birth", error: (_h = errors2.dateOfBirth) == null ? void 0 : _h.message, children: /* @__PURE__ */ jsx(Controller, { name: "dateOfBirth", control: methods.control, render: ({
        field
      }) => /* @__PURE__ */ jsx(TextField, { fullWidth: true, type: "date", variant: "outlined", size: "small", error: !!errors2.dateOfBirth, onChange: (e2) => {
        field.onChange(capDateIsoToToday(e2.target.value));
      }, value: capDateIsoToToday(field.value) }) }) }) }),
      /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Phone number", error: (_i = errors2.phoneNumber) == null ? void 0 : _i.message, children: /* @__PURE__ */ jsx(Controller, { name: "phoneNumber", control: methods.control, render: ({
        field
      }) => /* @__PURE__ */ jsx(KycPhoneInput, { value: field.value, onChange: (newValue) => {
        field.onChange(newValue);
      }, defaultCountry: watchedCountry.toLowerCase(), error: !!errors2.phoneNumber }) }) }) })
    ] }),
    /* @__PURE__ */ jsx(Box, { sx: {
      mt: 1
    }, children: /* @__PURE__ */ jsx(AddressForms$1, { register: methods.register, setValue: methods.setValue, trigger: methods.trigger, formState: methods.formState, watch: methods.watch }) }),
    /* @__PURE__ */ jsx(Box, { sx: {
      width: "50%",
      display: watchedCountry === "US" ? "block" : "none"
    }, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Social Security Number", error: (_j = errors2.stateIdentifier) == null ? void 0 : _j.message, children: /* @__PURE__ */ jsx(Controller, { name: "stateIdentifier", control: methods.control, render: ({
      field
    }) => /* @__PURE__ */ jsx(TextField, { fullWidth: true, className: "fs-exclude", placeholder: "123-45-6789", variant: "outlined", size: "small", error: !!errors2.stateIdentifier, onChange: (e2) => {
      field.onChange(formatSSN(e2.target.value));
    }, value: formatSSN(field.value) }) }) }) }),
    /* @__PURE__ */ jsxs(Box, { sx: {
      my: 2
    }, display: "flex", justifyContent: "left", children: [
      /* @__PURE__ */ jsx(Button, { onClick: methods.handleSubmit((data) => submitBeneficiary(organizationEntityId, beneficiary == null ? void 0 : beneficiary.relatedPersonId, data)), startIcon: isSubmitting && /* @__PURE__ */ jsx(CircularProgress, { size: 24 }), disabled: isSubmitting || formErrorsExist, variant: "contained", sx: {
        mb: 0,
        mr: 2
      }, children: "Save" }),
      /* @__PURE__ */ jsx(Button, { onClick: () => {
        if (!(beneficiary == null ? void 0 : beneficiary.relatedPersonId)) {
          clearNewBeneficiary();
        } else {
          switchBackToSummary(beneficiary == null ? void 0 : beneficiary.relatedPersonId);
        }
      }, variant: "outlined", sx: {
        mb: 0
      }, children: "Cancel" })
    ] })
  ] });
};
const BeneficiaryCreateOrEdit$1 = BeneficiaryCreateOrEdit;
const SvgIndividual = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "10 9 37.02 39.21" }, props), /* @__PURE__ */ React.createElement("path", { fill: "#333", d: "M14.62 48.209h27.757c3.094 0 4.64-1.053 4.64-3.158 0-1.404-.43-2.886-1.289-4.448-.845-1.575-2.07-3.057-3.673-4.447-1.605-1.39-3.545-2.513-5.823-3.373-2.277-.873-4.848-1.31-7.712-1.31-2.88 0-5.457.437-7.735 1.31-2.277.86-4.218 1.984-5.822 3.373-1.604 1.39-2.836 2.872-3.695 4.447C10.422 42.165 10 43.647 10 45.051c0 2.105 1.54 3.158 4.62 3.158Zm-.645-2.492c-.502 0-.853-.072-1.053-.215-.186-.129-.28-.372-.28-.73 0-1.003.351-2.127 1.053-3.374.702-1.246 1.726-2.427 3.073-3.545 1.36-1.131 3.022-2.062 4.984-2.793 1.977-.73 4.232-1.095 6.768-1.095 2.52 0 4.762.365 6.724 1.095 1.977.731 3.638 1.662 4.984 2.793 1.361 1.118 2.392 2.3 3.094 3.545.702 1.246 1.053 2.37 1.053 3.373 0 .359-.1.602-.3.731-.187.143-.524.215-1.01.215h-29.09ZM28.54 28.55c1.662 0 3.172-.444 4.533-1.332 1.375-.903 2.464-2.099 3.266-3.588.816-1.49 1.224-3.151 1.224-4.985 0-1.79-.408-3.408-1.224-4.855-.802-1.46-1.89-2.621-3.266-3.48C31.714 9.436 30.203 9 28.541 9c-1.661 0-3.18.444-4.555 1.332-1.36.874-2.449 2.041-3.265 3.502-.817 1.46-1.218 3.072-1.203 4.834 0 1.819.4 3.48 1.203 4.984.816 1.49 1.905 2.679 3.265 3.567 1.361.888 2.88 1.332 4.555 1.332Zm0-2.514a5.717 5.717 0 0 1-3.223-.967c-.96-.659-1.726-1.54-2.299-2.642-.572-1.117-.859-2.37-.859-3.76 0-1.318.287-2.514.86-3.588.572-1.088 1.339-1.955 2.298-2.6a5.716 5.716 0 0 1 3.223-.966c1.174 0 2.242.315 3.201.945.96.63 1.726 1.49 2.299 2.578.573 1.074.86 2.277.86 3.61 0 1.375-.287 2.62-.86 3.738-.559 1.117-1.325 2.005-2.299 2.664a5.53 5.53 0 0 1-3.201.988Z" }));
const DELETE_ERROR = "There was an error deleting this beneficiary. Please try again later.";
const BeneficiarySummary = ({
  beneficiary,
  organizationEntityId,
  showSummary,
  setShowSummary
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [upsertDeleteBeneficiary] = useDeleteBeneficiaryMutation({
    refetchQueries: () => {
      return [{
        query: BeneficiariesDocument,
        variables: {
          entityId: organizationEntityId
        }
      }];
    }
  });
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const deleteBeneficiary = (beneficiaryId) => __async(void 0, null, function* () {
    var _a, _b;
    setIsDeleting(true);
    try {
      const request = {
        beneficiaryId,
        entityId: organizationEntityId
      };
      const res = yield upsertDeleteBeneficiary({
        variables: request
      });
      if (!((_b = (_a = res.data) == null ? void 0 : _a.deleteBeneficiary) == null ? void 0 : _b.success)) {
        throw new Error("Failed to delete beneficiary");
      }
    } catch (e2) {
      setErrorMessage(DELETE_ERROR);
      setErrorDialogOpen(true);
    } finally {
      setIsDeleting(false);
    }
  });
  const switchToEdit = (id) => {
    const newState = new Set(showSummary);
    newState.delete(id);
    setShowSummary(newState);
  };
  return /* @__PURE__ */ jsxs(Box, { borderBottom: "1px solid", borderColor: "darkgrey", padding: "10px", children: [
    /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: true, openState: errorDialogOpen, setOpenState: setErrorDialogOpen, message: errorMessage }),
    /* @__PURE__ */ jsxs(Box, { sx: {
      display: "flex"
    }, children: [
      /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Box, { sx: {
        display: "flex",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ jsx(Box, { marginRight: "10px", children: /* @__PURE__ */ jsx(SvgIndividual, {}) }),
        (beneficiary == null ? void 0 : beneficiary.firstName) && (beneficiary == null ? void 0 : beneficiary.lastName) ? /* @__PURE__ */ jsx(Typography, { children: `${beneficiary == null ? void 0 : beneficiary.firstName} ${(beneficiary == null ? void 0 : beneficiary.middleName) || ""} ${beneficiary == null ? void 0 : beneficiary.lastName}` }) : /* @__PURE__ */ jsx(Typography, { color: "error.main", fontWeight: 800, children: "Missing Info" })
      ] }) }),
      /* @__PURE__ */ jsx(Box, { flexGrow: 1 }),
      /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 1, children: [
        /* @__PURE__ */ jsxs(Button, { size: "small", color: "primary", variant: "outlined", onClick: () => switchToEdit(beneficiary == null ? void 0 : beneficiary.relatedPersonId), children: [
          /* @__PURE__ */ jsx(Edit, {}),
          "Edit"
        ] }),
        /* @__PURE__ */ jsx(Button, { size: "small", color: "primary", variant: "outlined", onClick: () => deleteBeneficiary(beneficiary == null ? void 0 : beneficiary.relatedPersonId), children: isDeleting ? /* @__PURE__ */ jsx(CircularProgress, {}) : /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Delete, {}),
          "Delete"
        ] }) })
      ] }) })
    ] })
  ] });
};
const BeneficiarySummary$1 = BeneficiarySummary;
const BENEFICIARIES_CONFIRMED_LOCAL_STORAGE_KEY = (entityId) => `beneficiariesListConfirmed-${entityId}`;
const BeneficiariesTabPanel = ({
  existingData,
  progressState,
  setAllowEdits,
  entityId,
  entityKind,
  moveToNextTab,
  idvDocs,
  ownershipDocs
}) => {
  var _a, _b, _c;
  const amplitude = useAmplitude();
  const kyc = (_c = (_b = (_a = existingData == null ? void 0 : existingData.data) == null ? void 0 : _a.me) == null ? void 0 : _b.entity) == null ? void 0 : _c.kyc;
  const beneficiariesBackend = (kyc == null ? void 0 : kyc.beneficiaries) || [];
  const [isAddingNewBeneficiary, setIsAddingNewBeneficiary] = useState(false);
  const [isListConfirmed, setIsListConfirmed] = useState((localStorage.getItem(BENEFICIARIES_CONFIRMED_LOCAL_STORAGE_KEY(entityId)) || "") === "true");
  useEffect(() => {
    localStorage.setItem(BENEFICIARIES_CONFIRMED_LOCAL_STORAGE_KEY(entityId), isListConfirmed.toString());
  }, [isListConfirmed]);
  const [showSummary, setShowSummary] = useState(new Set(beneficiariesBackend == null ? void 0 : beneficiariesBackend.map((beneficiary) => beneficiary == null ? void 0 : beneficiary.relatedPersonId)));
  const docsComplete = {
    [EntityOrganizationKind.Company]: (idvDocs == null ? void 0 : idvDocs.length) > 0 && (ownershipDocs == null ? void 0 : ownershipDocs.length) > 0 || (beneficiariesBackend == null ? void 0 : beneficiariesBackend.length) === 0,
    [EntityOrganizationKind.Trust]: (idvDocs == null ? void 0 : idvDocs.length) > 0 || (beneficiariesBackend == null ? void 0 : beneficiariesBackend.length) === 0
  };
  const beneficiaryLimitExceeded = (beneficiariesBackend == null ? void 0 : beneficiariesBackend.length) >= 4;
  const onSubmit = () => {
    amplitude.track("kyb-beneficiary-saved");
    moveToNextTab();
  };
  const ConfirmBeneficiaryCheckbox = ({
    hidden
  }) => {
    return /* @__PURE__ */ jsx(Box, { hidden, children: /* @__PURE__ */ jsx(FormControlLabel, { sx: {
      mt: 3,
      ml: 1
    }, control: /* @__PURE__ */ jsx(Checkbox, { checked: isListConfirmed, onChange: () => setIsListConfirmed(!isListConfirmed) }), label: /* @__PURE__ */ jsx(Typography, { sx: {
      pl: 2
    }, fontSize: 18, children: (beneficiariesBackend == null ? void 0 : beneficiariesBackend.length) > 0 ? "I confirm the list of beneficial owners is complete and all documents are uploaded" : "I do not have any beneficial owners to report" }) }) });
  };
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsx(KybTabPanelHeader$1, { title: "Beneficiaries", setAllowEdits, subtitle: "Enter the information of any person that directly or indirectly owns or\n          controls greater than or equal to 25% or more of the ownership or controlling interest in\n          this legal entity.", progressState }),
    /* @__PURE__ */ jsxs(Disable, { disabled: progressState == ProgressState.COMPLETE, disabledOpacity: 0.6, children: [
      (beneficiariesBackend || []).map((beneficiary) => (showSummary || []).has((beneficiary == null ? void 0 : beneficiary.relatedPersonId) || "") ? !!beneficiary && /* @__PURE__ */ jsx(BeneficiarySummary$1, { organizationEntityId: entityId, beneficiary, showSummary, setShowSummary }, v4()) : !!beneficiary && /* @__PURE__ */ jsx(BeneficiaryCreateOrEdit$1, { organizationEntityId: entityId, beneficiaryId: beneficiary == null ? void 0 : beneficiary.relatedPersonId, showSummary, setShowSummary, clearNewBeneficiary: () => setIsAddingNewBeneficiary(false) }, v4())),
      isAddingNewBeneficiary && /* @__PURE__ */ jsx(BeneficiaryCreateOrEdit$1, { organizationEntityId: entityId, beneficiaryId: null, showSummary, setShowSummary, clearNewBeneficiary: () => setIsAddingNewBeneficiary(false) }, v4()),
      /* @__PURE__ */ jsx(Button, { startIcon: /* @__PURE__ */ jsx(AddIcon, {}), color: "primary", variant: "contained", hidden: !!isAddingNewBeneficiary || beneficiaryLimitExceeded, disabled: isListConfirmed, sx: {
        my: 2
      }, onClick: () => {
        setIsAddingNewBeneficiary(true);
      }, children: (beneficiariesBackend == null ? void 0 : beneficiariesBackend.length) === 0 && !isAddingNewBeneficiary ? "Add a Beneficiary" : "Add Another Beneficiary" }),
      (beneficiariesBackend == null ? void 0 : beneficiariesBackend.length) > 0 && /* @__PURE__ */ jsxs(Box, { sx: {
        mt: 4
      }, children: [
        /* @__PURE__ */ jsx(Typography, { variant: "h3", sx: {
          mb: 5,
          fontSize: "30px",
          fontWeight: "bold"
        }, children: "Beneficiary Documents" }),
        /* @__PURE__ */ jsx(FileUpload, { label: "Passport Copies", entityId, docCategory: DocumentPurpose.CompaniesMajorShareholderIdVerification, existingFiles: idvDocs, allowMultipleFiles: true, onStatusChange: (status) => {
          if (status === FileUploadStatus.SUCCESS) {
            amplitude.track("kyb-beneficiary-passport");
          }
        }, children: /* @__PURE__ */ jsx(Typography, { mb: "3", color: "textSecondary", children: "For each beneficiary in the prior section, upload a copy of an unexpired passport or other vendor supported government issued document evidencing the individual's nationality or residence bearing a photograph." }) }),
        /* @__PURE__ */ jsx(Box, { sx: {
          mt: 4
        } }),
        entityKind === EntityOrganizationKind.Company && /* @__PURE__ */ jsx(FileUpload, { label: "Proof of Beneficiary Ownership", entityId, docCategory: DocumentPurpose.CompaniesMajorShareholderOwnershipVerification, existingFiles: ownershipDocs, allowMultipleFiles: false, onStatusChange: (status) => {
          if (status === FileUploadStatus.SUCCESS) {
            amplitude.track("kyb-beneficiary-proof");
          }
        }, children: /* @__PURE__ */ jsx(Typography, { mb: "3", color: "textSecondary", children: "Upload a document in English language listing the beneficial owners and the ownership percentage of each. This can be an official document, a company agreement, or schedule listing investors, or we can accept a letter from a CPA, CFO, or attorney." }) })
      ] }),
      /* @__PURE__ */ jsx(Box, { sx: {
        mt: 5,
        mb: 1
      }, children: /* @__PURE__ */ jsx("hr", {}) }),
      /* @__PURE__ */ jsx(ConfirmBeneficiaryCheckbox, { hidden: !docsComplete[entityKind] })
    ] }),
    /* @__PURE__ */ jsx(KybTabPanelButtons$1, { setAllowEdits: () => {
      setAllowEdits();
      setIsListConfirmed(false);
    }, submitHandler: onSubmit, progressState, isSubmitting: false, disabled: !(isListConfirmed && docsComplete[entityKind]) })
  ] });
};
const formatTaxIDNumber = (value) => {
  if (!value)
    return value;
  const taxId = value.replace(/[^\d]/g, "");
  return `${taxId.slice(0, 9)}`;
};
const CompanyDocumentationTabPanel = ({
  entityId,
  isRegisteringForOffering,
  progressState,
  setAllowEdits,
  moveToNextTab,
  existingData,
  questionnaire,
  proofOfAddressDocs,
  evidenceOfRegistrationDocs,
  evidenceOfGoodStandingDocs
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u;
  const amplitude = useAmplitude();
  const globalConstants = useConstants();
  const kycSubmission = (_c = (_b = (_a = existingData == null ? void 0 : existingData.data) == null ? void 0 : _a.me) == null ? void 0 : _b.entity) == null ? void 0 : _c.kyc;
  const {
    formCache,
    setFormCache
  } = useContext(FormCacheContext);
  const methods = useForm({
    defaultValues: (formCache == null ? void 0 : formCache.companyDocumentation) || {
      legalName: (kycSubmission == null ? void 0 : kycSubmission.legalName) || "",
      dbaName: (kycSubmission == null ? void 0 : kycSubmission.dbaName) || "",
      regionOfIncorporation: ((_d = kycSubmission == null ? void 0 : kycSubmission.incorporationInfo) == null ? void 0 : _d.regionOfIncorporation) || "",
      countryOfIncorporation: ((_e = kycSubmission == null ? void 0 : kycSubmission.incorporationInfo) == null ? void 0 : _e.countryOfIncorporation) || "US",
      taxIdNumber: ((_f = kycSubmission == null ? void 0 : kycSubmission.incorporationInfo) == null ? void 0 : _f.taxIdNumber) || "",
      incorporationType: ((_g = kycSubmission == null ? void 0 : kycSubmission.incorporationInfo) == null ? void 0 : _g.incorporationType) || "",
      incorporatedOn: ((_h = kycSubmission == null ? void 0 : kycSubmission.incorporationInfo) == null ? void 0 : _h.incorporatedOn) || dateToIsoString(today()),
      streetAddress: ((_i = kycSubmission == null ? void 0 : kycSubmission.businessOpsAddress) == null ? void 0 : _i.streetAddress) || "",
      city: ((_j = kycSubmission == null ? void 0 : kycSubmission.businessOpsAddress) == null ? void 0 : _j.city) || "",
      country: ((_k = kycSubmission == null ? void 0 : kycSubmission.businessOpsAddress) == null ? void 0 : _k.country) || "US",
      postalCode: ((_l = kycSubmission == null ? void 0 : kycSubmission.businessOpsAddress) == null ? void 0 : _l.postalCode) || "",
      region: ((_m = kycSubmission == null ? void 0 : kycSubmission.businessOpsAddress) == null ? void 0 : _m.region) || "",
      [questionnaire.slug]: getQuestionnaireInitValues(questionnaire, (kycSubmission == null ? void 0 : kycSubmission.companyProfileSurvey) || [])
    },
    resolver: (data) => {
      const validationErrors = __spreadValues(__spreadValues({}, validateFormInputsAgainstRuleSet(AddressFormsRules, lodashExports.pick(data, Object.keys(AddressFormsRules)), {
        globalConstants,
        // We check wallet elligibility for the region / country the business is in
        // Exception is offerings
        checkWalletEligibility: !isRegisteringForOffering
      })), validateFormInputsAgainstRuleSet(CompanyDocumentationPanelRules, data));
      const questionnaireErrors = validateQuestionnaireFormInputs(questionnaire, data[questionnaire.slug]);
      if (Object.keys(questionnaireErrors).length > 0) {
        validationErrors[questionnaire.slug] = questionnaireErrors;
      }
      return {
        values: data,
        errors: validationErrors
      };
    }
  });
  useEffect(() => {
    methods.watch((values2) => setFormCache(__spreadProps(__spreadValues({}, formCache), {
      companyDocumentation: values2
    })));
  });
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    formState
  } = methods;
  const {
    errors: errors2
  } = formState;
  const watchedCountryOfIncorporation = watch("countryOfIncorporation");
  const watchedCountryOfOperations = watch("country");
  const watchedIncorporationDate = watch("incorporatedOn");
  const geographyConstants = globalConstants == null ? void 0 : globalConstants.geography;
  const countries2 = Object.values((geographyConstants == null ? void 0 : geographyConstants.countries) || {}).filter((country) => (country == null ? void 0 : country.address_select_enabled) === true);
  const states = Object.values(((_n = geographyConstants == null ? void 0 : geographyConstants.states) == null ? void 0 : _n[watchedCountryOfIncorporation || "US"]) || {});
  const proofOfAddressDocsComplete = proofOfAddressDocs.length > 0;
  const evidenceOfRegistrationDocsComplete = evidenceOfRegistrationDocs.length > 0;
  const evidenceOfGoodStandingDocsComplete = evidenceOfGoodStandingDocs.length > 0 || watchedCountryOfOperations != "US" || watchedCountryOfOperations === "US" && isoStringToDate(watchedIncorporationDate) > oneYearAgo();
  const docsCompleted = proofOfAddressDocsComplete && evidenceOfRegistrationDocsComplete && evidenceOfGoodStandingDocsComplete;
  const formErrorsExist = Object.values(errors2).some(Boolean);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [upsertKybDocumentation] = useSubmitKybDocumentationCompanyMutation({
    refetchQueries: () => {
      return [{
        query: OrganizationKycInfoDocument,
        variables: {
          entityId
        }
      }];
    }
  });
  const onSubmit = (data) => __async(void 0, null, function* () {
    var _a2, _b2;
    if (!docsCompleted) {
      return;
    }
    setIsSubmitting(true);
    try {
      const request = {
        entity: entityId,
        legalName: data.legalName,
        dbaName: data.dbaName,
        companyProfileSurvey: questionnaireFormValuesToGql(data[questionnaire.slug]),
        businessOpsAddress: {
          country: data.country,
          region: data.region,
          city: data.city,
          postalCode: data.postalCode,
          streetAddress: data.streetAddress
        },
        incorporationInfo: {
          regionOfIncorporation: data.regionOfIncorporation,
          countryOfIncorporation: data.countryOfIncorporation,
          taxIdNumber: data.taxIdNumber,
          incorporatedOn: data.incorporatedOn,
          incorporationType: data.incorporationType
        }
      };
      const res = yield upsertKybDocumentation({
        variables: request
      });
      if (!((_b2 = (_a2 = res.data) == null ? void 0 : _a2.upsertBusinessInfo) == null ? void 0 : _b2.success)) {
        throw new Error("Unsuccesful response");
      }
      amplitude.track("kyb-documentation-saved");
      moveToNextTab();
    } catch (e2) {
      setErrorMessage("An error occurred submitting your information. Please try again later.");
      amplitude.track("kyb-documentation-error");
    } finally {
      setIsSubmitting(false);
    }
  });
  return /* @__PURE__ */ jsxs(FormProvider, __spreadProps(__spreadValues({}, methods), { children: [
    /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: true, openState: errorDialogOpen, setOpenState: setErrorDialogOpen, message: errorMessage }),
    /* @__PURE__ */ jsx(KybTabPanelHeader$1, { title: "Documentation", subtitle: "We collect this information to keep your account secure and comply with\n      financial regulations.", setAllowEdits, progressState }),
    /* @__PURE__ */ jsxs(Disable, { disabled: progressState == ProgressState.COMPLETE, disabledOpacity: 0.6, children: [
      /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Legal name of entity", error: (_o = errors2.legalName) == null ? void 0 : _o.message, inputDescription: "Provide the full legal name as listed on your formation document and bank account.", children: /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ id: "legalName", placeholder: "Helen's Food Service, Inc.", variant: "outlined", fullWidth: true }, register("legalName")), { error: !!errors2.legalName })) }),
      /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "DBA Name / Trade Name", error: (_p = errors2.dbaName) == null ? void 0 : _p.message, inputDescription: "If your business documents are registered under a different name,\n          please also provide that information. The name provided must match exactly to your\n          documents for us to accept them.", children: /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ id: "dbaName", placeholder: "Helen's Food", variant: "outlined", fullWidth: true }, register("dbaName")), { error: !!errors2.dbaName })) }),
      /* @__PURE__ */ jsx(Typography, { variant: "h3", sx: {
        fontSize: "30px",
        fontWeight: "bold",
        mb: 5,
        mt: 3
      }, children: "Place of Business Operations" }),
      /* @__PURE__ */ jsx(AddressForms$1, { register, setValue, trigger, formState, watch }),
      /* @__PURE__ */ jsx(Typography, { variant: "h3", sx: {
        mb: 5,
        mt: 3,
        fontSize: "30px",
        fontWeight: "bold"
      }, children: "Incorporation Information" }),
      /* @__PURE__ */ jsxs(KycFormInputWrapper, { upperLabel: "Incorporation Type", error: (_q = errors2.incorporationType) == null ? void 0 : _q.message, inputDescription: "Provide the type of incorporation for your business.", children: [
        /* @__PURE__ */ jsx(InputLabel, { size: "small", id: "incorporation-type-select", children: "Incorporation Type" }),
        /* @__PURE__ */ jsx(Controller, { name: "incorporationType", control: methods.control, render: ({
          field
        }) => /* @__PURE__ */ jsx(Select, { id: "incorporation-type-select", displayEmpty: true, error: !!errors2.country, size: "small", label: "Incorporation Type", onChange: (e2) => {
          field.onChange(e2.target.value);
        }, value: watch("incorporationType") || "", children: Object.values(KycIncorporationTypes).map((incType) => /* @__PURE__ */ jsx(MenuItem, { value: incType, selected: incType === watch("incorporationType"), children: KycIncorporationTypesDescriptions[incType] }, incType)) }) })
      ] }),
      /* @__PURE__ */ jsxs(KycFormInputWrapper, { upperLabel: "Place of Incorporation", error: (_r = errors2.countryOfIncorporation) == null ? void 0 : _r.message, inputDescription: "Provide the country and region where your business was incorporated.", children: [
        /* @__PURE__ */ jsx(InputLabel, { size: "small", id: "incorporation-country-select", children: "Country" }),
        /* @__PURE__ */ jsx(Controller, { name: "countryOfIncorporation", control: methods.control, render: ({
          field
        }) => /* @__PURE__ */ jsx(Select, { displayEmpty: true, error: !!errors2.country, size: "small", label: "Country", onChange: (e2) => {
          field.onChange(e2.target.value);
          methods.resetField("regionOfIncorporation", {
            defaultValue: ""
          });
        }, value: watchedCountryOfIncorporation || "", children: countries2.map(({
          name_and_flag,
          name,
          code: code2
        }) => /* @__PURE__ */ jsx(MenuItem, { value: code2, children: name_and_flag || name }, code2)) }) })
      ] }),
      watchedCountryOfIncorporation == "US" ? /* @__PURE__ */ jsx(StatesDropdown$1, { options: states, register, registerId: "regionOfIncorporation", errors: errors2, selectedValue: watch("regionOfIncorporation") || "" }) : /* @__PURE__ */ jsx(KycFormInputWrapper, { error: (_s = errors2.region) == null ? void 0 : _s.message, children: /* @__PURE__ */ jsx(TextField, __spreadValues({ fullWidth: true, type: "text", label: "Province or Region", variant: "outlined", size: "small", error: !!errors2.regionOfIncorporation }, register("regionOfIncorporation"))) }),
      /* @__PURE__ */ jsx(Box, { sx: {
        mb: 1
      } }),
      /* @__PURE__ */ jsx(Box, { sx: {
        display: watchedCountryOfIncorporation === "US" ? "block" : "none",
        mt: 1
      }, children: /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Tax ID Number (US Only)", error: (_t = errors2.taxIdNumber) == null ? void 0 : _t.message, inputDescription: "Provide the tax ID number for your business.", children: /* @__PURE__ */ jsx(Controller, { name: "stateIdentifier", control: methods.control, render: ({
        field
      }) => /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ fullWidth: true, placeholder: "12-3456789", variant: "outlined", size: "small" }, register("taxIdNumber")), { error: !!errors2.taxIdNumber, onChange: (e2) => {
        field.onChange(formatTaxIDNumber(e2.target.value));
      }, value: formatTaxIDNumber(field.value) })) }) }) }),
      /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Date of Incorporation", error: (_u = errors2.incorporatedOn) == null ? void 0 : _u.message, inputDescription: "Provide the date your business was incorporated.", children: /* @__PURE__ */ jsx(Controller, { name: "incorporatedOn", control: methods.control, render: ({
        field
      }) => /* @__PURE__ */ jsx(TextField, { fullWidth: true, type: "date", variant: "outlined", size: "small", error: !!errors2.incorporatedOn, onChange: (e2) => {
        field.onChange(capDateIsoToToday(e2.target.value));
      }, value: capDateIsoToToday(field.value) }) }) }),
      /* @__PURE__ */ jsx(Typography, { variant: "h3", sx: {
        mb: 5,
        mt: 3,
        fontSize: "30px",
        fontWeight: "bold"
      }, children: "Company Profile" }),
      /* @__PURE__ */ jsx(Questionnaire, { questionnaire }),
      /* @__PURE__ */ jsx(Typography, { variant: "h3", sx: {
        mb: 5,
        mt: 3,
        fontSize: "30px",
        fontWeight: "bold"
      }, children: "Company Documents" }),
      /* @__PURE__ */ jsx(FileUpload, { label: "Proof of Address", entityId, docCategory: DocumentPurpose.CompaniesProofOfAddress, existingFiles: proofOfAddressDocs, allowMultipleFiles: true, displayError: formState.isSubmitted && !proofOfAddressDocsComplete, children: /* @__PURE__ */ jsxs(Typography, { mb: "3", color: "textSecondary", children: [
        "Provide a document showing the address and name of the company dated within the last 3 months. It can be in the form of either:",
        /* @__PURE__ */ jsxs("ul", { style: {
          marginLeft: "20px"
        }, children: [
          /* @__PURE__ */ jsx("li", { children: "A recent utility bill showing where your operations take place" }),
          /* @__PURE__ */ jsx("li", { children: "A lease agreement showing the address and name of your company" })
        ] })
      ] }) }),
      /* @__PURE__ */ jsx(Box, { sx: {
        mt: 4
      } }),
      /* @__PURE__ */ jsx(FileUpload, { label: "Evidence of Registration", entityId, docCategory: DocumentPurpose.CompaniesRegistrationVerification, existingFiles: evidenceOfRegistrationDocs, allowMultipleFiles: false, displayError: formState.isSubmitted && !evidenceOfRegistrationDocsComplete, children: /* @__PURE__ */ jsxs(Typography, { mb: "3", color: "textSecondary", children: [
        "Provide a certificate of your company's registration in one of the following forms",
        /* @__PURE__ */ jsxs("ul", { style: {
          marginLeft: "20px"
        }, children: [
          /* @__PURE__ */ jsx("li", { children: "Articles of incorporation" }),
          /* @__PURE__ */ jsx("li", { children: "Articles of organization" }),
          /* @__PURE__ */ jsx("li", { children: "Certificate of formation" }),
          /* @__PURE__ */ jsx("li", { children: "Certificate of incorporation" })
        ] })
      ] }) }),
      /* @__PURE__ */ jsx(Box, { sx: {
        mt: 4
      } }),
      watchedCountryOfOperations == "US" && isoStringToDate(watchedIncorporationDate) < oneYearAgo() && /* @__PURE__ */ jsx(FileUpload, { label: "Evidence of Good Standing", entityId, docCategory: DocumentPurpose.CompaniesGoodStandingVerification, existingFiles: evidenceOfGoodStandingDocs, allowMultipleFiles: false, displayError: formState.isSubmitted && !evidenceOfGoodStandingDocsComplete, children: "A certificate of good standing (also known as a certificate of existence). Required for U.S. customers incorporated more than 1 year ago." })
    ] }),
    /* @__PURE__ */ jsx(KybTabPanelButtons$1, { setAllowEdits, submitHandler: handleSubmit(onSubmit), progressState, isSubmitting, disabled: formErrorsExist || formState.isSubmitted && !docsCompleted })
  ] }));
};
const ReviewAndSubmitTabPanel = ({
  organizationEntityId,
  reviewableTabs,
  currentTabIndex,
  setTabIndex
}) => {
  const amplitude = useAmplitude();
  const [isConfirmingSubmit, setIsConfirmingSubmit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [upsertFinalize] = useFinalizeKybMutation({
    refetchQueries: () => [
      // IDV verification link is within the signatory, so refetch upon finalize
      {
        query: AuthorizedSignatoryDocument,
        variables: {
          entityId: organizationEntityId
        }
      },
      // At this, point we'll be ready to present the IDV step
      {
        query: CurrentOnboardingStepDocument,
        variables: {
          entityId: organizationEntityId
        }
      }
    ]
  });
  const onSubmit = () => __async(void 0, null, function* () {
    var _a, _b;
    setIsSubmitting(true);
    try {
      const res = yield upsertFinalize({
        variables: {
          entityId: organizationEntityId
        }
      });
      if (!((_b = (_a = res.data) == null ? void 0 : _a.finalizeKyb) == null ? void 0 : _b.success)) {
        throw new Error("Unsuccesful response");
      }
      amplitude.track("kyb-review-submitted");
      setTabIndex(currentTabIndex + 1);
    } catch (e2) {
      setIsConfirmingSubmit(false);
      setErrorDialogOpen(true);
      setErrorMessage("An error occurred submitting your information. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  });
  const finishedTabs = reviewableTabs.filter((tab2) => tab2.progressState !== ProgressState.INCOMPLETE);
  const unfinishedTabs = reviewableTabs.filter((tab2) => tab2.progressState === ProgressState.INCOMPLETE);
  return /* @__PURE__ */ jsxs(Box, { sx: {
    width: "inherit"
  }, children: [
    /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: true, openState: errorDialogOpen, setOpenState: setErrorDialogOpen, message: errorMessage }),
    /* @__PURE__ */ jsxs(Dialog, { open: isConfirmingSubmit, onClose: () => setIsConfirmingSubmit(false), children: [
      /* @__PURE__ */ jsx(DialogTitle, { children: "Are you sure you want to submit?" }),
      /* @__PURE__ */ jsx(DialogContent, { children: /* @__PURE__ */ jsx(Typography, { children: "Once you submit, you will not be able to edit the application." }) }),
      /* @__PURE__ */ jsxs(DialogActions, { children: [
        /* @__PURE__ */ jsx(Button, { variant: "outlined", onClick: () => setIsConfirmingSubmit(false), children: "Close" }),
        /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: onSubmit, endIcon: isSubmitting ? /* @__PURE__ */ jsx(CircularProgress, { sx: {
          ml: 2
        } }) : /* @__PURE__ */ jsx(default_1$1, {}), disabled: isSubmitting, children: "Submit" })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Typography, { sx: {
      mb: 3,
      fontSize: "40px",
      fontWeight: "bold"
    }, children: "Review & Submit" }),
    /* @__PURE__ */ jsxs(Card, { sx: {
      padding: 5,
      borderRadius: "1rem",
      border: `1px solid #ccc !important`,
      minWidth: {
        lg: "500px",
        sm: "400px"
      }
    }, children: [
      /* @__PURE__ */ jsx(Typography, { sx: {
        mb: 3
      }, children: "Make sure you review all the below sections before submitting. Once submitted, you will not be able to edit the application." }),
      unfinishedTabs.length > 0 && /* @__PURE__ */ jsx(Typography, { sx: {
        mb: 3
      }, fontWeight: "bold", color: "#444", children: "Not completed" }),
      /* @__PURE__ */ jsx(Box, { children: unfinishedTabs.map((tab2) => /* @__PURE__ */ jsx(Card, { sx: {
        display: "flex",
        mt: 3,
        p: 2,
        boxShadow: "none",
        border: "1px solid #bbb",
        borderRadius: "20px"
      }, children: /* @__PURE__ */ jsx(CardContent, { sx: {
        flexGrow: 1
      }, children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
        /* @__PURE__ */ jsx(Box, { sx: {
          width: "40px"
        }, children: /* @__PURE__ */ jsx(SvgProgressIncomplete, {}) }),
        /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsx(Typography, { fontWeight: "bold", children: tab2.title }),
          /* @__PURE__ */ jsx(Typography, { children: "Missing information." })
        ] }),
        /* @__PURE__ */ jsx(Button, { onClick: () => {
          amplitude.track("kyb-review-edit");
          setTabIndex(tab2.index);
        }, variant: "outlined", sx: {
          mb: 0
        }, children: "Edit" })
      ] }) }) }, v4())) }),
      /* @__PURE__ */ jsxs(Box, { children: [
        finishedTabs.length > 0 && /* @__PURE__ */ jsx(Typography, { sx: {
          my: 3
        }, fontWeight: "bold", color: "#444", children: "Completed" }),
        finishedTabs.map((tab2) => /* @__PURE__ */ jsx(Card, { sx: {
          display: "flex",
          mt: 3,
          p: 2,
          boxShadow: "none",
          border: "1px solid #bbb",
          borderRadius: "20px"
        }, children: /* @__PURE__ */ jsx(CardContent, { sx: {
          flexGrow: 1
        }, children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
          /* @__PURE__ */ jsx(Box, { sx: {
            width: "40px"
          }, children: /* @__PURE__ */ jsx(SvgProgressComplete, {}) }),
          /* @__PURE__ */ jsxs(Box, { children: [
            /* @__PURE__ */ jsx(Typography, { fontWeight: "bold", children: tab2.title }),
            /* @__PURE__ */ jsx(Typography, { children: "All questions completed." })
          ] }),
          /* @__PURE__ */ jsx(Button, { onClick: () => setTabIndex(tab2.index), variant: "outlined", sx: {
            mb: 0
          }, children: "Edit" })
        ] }) }) }, v4())),
        /* @__PURE__ */ jsx(Button, { fullWidth: true, sx: {
          mt: 4
        }, variant: "contained", endIcon: /* @__PURE__ */ jsx(default_1$1, {}), onClick: () => setIsConfirmingSubmit(true), disabled: unfinishedTabs.length > 0, children: "Finalize Information" })
      ] })
    ] })
  ] });
};
const TrustDocumentationTabPanel = ({
  entityId,
  progressState,
  setAllowEdits,
  moveToNextTab,
  existingData,
  trustAgreementDocs
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const amplitude = useAmplitude();
  const globalConstants = useConstants();
  const countries2 = ((_a = globalConstants == null ? void 0 : globalConstants.geography) == null ? void 0 : _a.countries) || {};
  const supportedCountryCodes = Object.values(countries2).filter((country) => country.is_trust_allowed).map((country) => country.code);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const kycSubmission = (_d = (_c = (_b = existingData == null ? void 0 : existingData.data) == null ? void 0 : _b.me) == null ? void 0 : _c.entity) == null ? void 0 : _d.kyc;
  const {
    formCache,
    setFormCache
  } = useContext(FormCacheContext);
  const methods = useForm({
    defaultValues: (formCache == null ? void 0 : formCache.companyDocumentation) || {
      legalName: (kycSubmission == null ? void 0 : kycSubmission.legalName) || "",
      taxIdNumber: ((_e = kycSubmission == null ? void 0 : kycSubmission.incorporationInfo) == null ? void 0 : _e.taxIdNumber) || "",
      streetAddress: ((_f = kycSubmission == null ? void 0 : kycSubmission.businessOpsAddress) == null ? void 0 : _f.streetAddress) || "",
      city: ((_g = kycSubmission == null ? void 0 : kycSubmission.businessOpsAddress) == null ? void 0 : _g.city) || "",
      country: ((_h = kycSubmission == null ? void 0 : kycSubmission.businessOpsAddress) == null ? void 0 : _h.country) || "US",
      postalCode: ((_i = kycSubmission == null ? void 0 : kycSubmission.businessOpsAddress) == null ? void 0 : _i.postalCode) || "",
      region: ((_j = kycSubmission == null ? void 0 : kycSubmission.businessOpsAddress) == null ? void 0 : _j.region) || ""
    },
    resolver: (data) => {
      const validationErrors = __spreadValues(__spreadValues({}, validateFormInputsAgainstRuleSet(AddressFormsRules, lodashExports.pick(data, ["country", "region"]), {
        globalConstants,
        checkCustomListOfCountries: supportedCountryCodes
      })), validateFormInputsAgainstRuleSet(TrustDocumentationPanelRules, data));
      return {
        values: data,
        errors: validationErrors
      };
    }
  });
  useEffect(() => {
    methods.watch((values2) => setFormCache(__spreadProps(__spreadValues({}, formCache), {
      trustDocumentation: values2
    })));
  });
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    formState
  } = methods;
  const {
    errors: errors2
  } = formState;
  const trustAgreementDocCompleted = trustAgreementDocs.length > 0;
  const docsCompleted = trustAgreementDocCompleted;
  const formErrorsExist = Object.values(errors2).some(Boolean);
  const [upsertKybDocumentation] = useSubmitKybDocumentationTrustMutation({
    refetchQueries: () => {
      return [{
        query: OrganizationKycInfoDocument,
        variables: {
          entityId
        }
      }];
    }
  });
  const onSubmit = (data) => __async(void 0, null, function* () {
    var _a2, _b2;
    if (!docsCompleted) {
      return;
    }
    setIsSubmitting(true);
    try {
      const request = {
        entity: entityId,
        legalName: data.legalName,
        businessOpsAddress: {
          country: data.country,
          region: data.region,
          city: data.city,
          postalCode: data.postalCode,
          streetAddress: data.streetAddress
        },
        incorporationInfo: {
          taxIdNumber: data.taxIdNumber
        }
      };
      const res = yield upsertKybDocumentation({
        variables: request
      });
      if (!((_b2 = (_a2 = res.data) == null ? void 0 : _a2.upsertBusinessInfo) == null ? void 0 : _b2.success)) {
        throw new Error("Unsuccesful response");
      }
      amplitude.track("kyb-documentation-saved");
      moveToNextTab();
    } catch (e2) {
      amplitude.track("kyb-documentation-error");
      setErrorMessage("An error occurred submitting your information. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  });
  return /* @__PURE__ */ jsxs(FormProvider, __spreadProps(__spreadValues({}, methods), { children: [
    /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: true, openState: errorDialogOpen, setOpenState: setErrorDialogOpen, message: errorMessage }),
    /* @__PURE__ */ jsx(KybTabPanelHeader$1, { title: "Documentation", subtitle: "We collect this information to keep your account secure and comply with\n        financial regulations.", setAllowEdits, progressState }),
    /* @__PURE__ */ jsxs(Disable, { disabled: progressState == ProgressState.COMPLETE, disabledOpacity: 0.6, children: [
      /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Legal name of entity", error: (_k = errors2.legalName) == null ? void 0 : _k.message, inputDescription: "Provide the full legal name as listed on your formation document and bank account.", children: /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ id: "legalName", placeholder: "Helen's Food Service, Inc.", variant: "outlined", fullWidth: true }, register("legalName")), { error: !!errors2.legalName })) }),
      /* @__PURE__ */ jsx(Typography, { variant: "h3", sx: {
        fontSize: "30px",
        fontWeight: "bold",
        mb: 3,
        mt: 3
      }, children: "Principal Place of Administration" }),
      /* @__PURE__ */ jsx(Typography, { sx: {
        color: "#aaa",
        mb: 2
      }, children: "This is the primary location where the trustee conducts the business of the trust. This address must be the same jursidiction for which the trust is subject to local tax laws." }),
      /* @__PURE__ */ jsx(AddressForms$1, { register, setValue, trigger, formState, watch, hideFields: ["streetAddress", "city", "postalCode"] }),
      /* @__PURE__ */ jsxs(Box, { sx: {
        display: watch("country") === "US" ? "block" : "none",
        mt: 1
      }, children: [
        /* @__PURE__ */ jsx(Typography, { variant: "h3", sx: {
          mb: 2,
          mt: 3,
          fontSize: "30px",
          fontWeight: "bold"
        }, children: "Incorporation Information" }),
        /* @__PURE__ */ jsx(KycFormInputWrapper, { upperLabel: "Tax ID Number (US Only)", error: (_l = errors2.taxIdNumber) == null ? void 0 : _l.message, inputDescription: "Provide the tax ID number for your business.", children: /* @__PURE__ */ jsx(Controller, { name: "stateIdentifier", control: methods.control, render: ({
          field
        }) => /* @__PURE__ */ jsx(TextField, __spreadProps(__spreadValues({ fullWidth: true, id: "taxIdNumber", placeholder: "12-3456789", variant: "outlined", size: "small" }, register("taxIdNumber")), { error: !!errors2.taxIdNumber, onChange: (e2) => {
          field.onChange(formatTaxIDNumber(e2.target.value));
        }, value: formatTaxIDNumber(field.value) })) }) })
      ] }),
      /* @__PURE__ */ jsx(Typography, { variant: "h3", sx: {
        mb: 5,
        mt: 3,
        fontSize: "30px",
        fontWeight: "bold"
      }, children: "Trust Documents" }),
      /* @__PURE__ */ jsx(FileUpload, { label: "Trust Agreement", entityId, docCategory: DocumentPurpose.TrustsAgreementVerification, existingFiles: trustAgreementDocs, allowMultipleFiles: true, displayError: formState.isSubmitted && !trustAgreementDocCompleted, children: /* @__PURE__ */ jsx(Typography, { mb: "3", color: "textSecondary", children: "Upload the trust agreement in English. If the original trust agreement is not in English, please provide a certified translation." }) })
    ] }),
    /* @__PURE__ */ jsx(KybTabPanelButtons$1, { setAllowEdits, submitHandler: handleSubmit(onSubmit), progressState, isSubmitting, disabled: formErrorsExist || formState.isSubmitted && !docsCompleted })
  ] }));
};
const IdvTabPanel = ({
  idvUrl
}) => {
  const amplitude = useAmplitude();
  const title = /* @__PURE__ */ jsx(Typography, { sx: {
    mb: 3,
    fontSize: "40px",
    fontWeight: "bold"
  }, children: "Photo Verification" });
  if (!idvUrl) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      title,
      /* @__PURE__ */ jsxs(Typography, { sx: {
        mb: 3,
        fontSize: "22px"
      }, children: [
        /* @__PURE__ */ jsx(Error$1, { sx: {
          verticalAlign: "middle",
          marginRight: "5px"
        } }),
        "We are having trouble initiating a photo verification session for you. Try again later. If the problem persists, please contact support."
      ] })
    ] });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    title,
    /* @__PURE__ */ jsx(IdvDisclaimer, {}),
    /* @__PURE__ */ jsx(Button, { variant: "contained", sx: {
      mt: 1
    }, onClick: () => {
      amplitude.track("kyb-idv-started");
      window.location.href = idvUrl;
    }, children: "Start Photo Verification" })
  ] });
};
const STEP_PRE_IDV = KycOnboardingStep.PreIdv;
const STEP_IDV = KycOnboardingStep.Idv;
const STEP_STATUS = KycOnboardingStep.Status;
const findDocuments = (documents, purpose) => {
  return (documents == null ? void 0 : documents.filter((doc) => doc.category === purpose)) || [];
};
const isCurrentDocsMissingPurposes = (documents, requiredPurposes) => {
  return requiredPurposes && requiredPurposes.some((purpose) => findDocuments(documents, purpose).length === 0);
};
const isAuthorizedSignatoryComplete = (authorizedSignatoryQuery, documents, entityKind, currentStep) => {
  var _a, _b, _c;
  if (currentStep != STEP_PRE_IDV) {
    return true;
  }
  const missingDocsCriteria = {
    [EntityOrganizationKind.Company]: [DocumentPurpose.CompaniesEvidenceToAct, DocumentPurpose.SignatoryProofOfResidence],
    [EntityOrganizationKind.Trust]: []
  };
  if (isCurrentDocsMissingPurposes(documents, missingDocsCriteria[entityKind])) {
    return false;
  }
  const kyc = (_c = (_b = (_a = authorizedSignatoryQuery == null ? void 0 : authorizedSignatoryQuery.data) == null ? void 0 : _a.me) == null ? void 0 : _b.entity) == null ? void 0 : _c.kyc;
  const authorizedSignatory = kyc == null ? void 0 : kyc.authorizedSignatory;
  return authorizedSignatory ? true : false;
};
const isBeneficiariesComplete = (entityId, benificiariesQuery, documents, entityKind, currentStep) => {
  var _a, _b, _c, _d;
  if (currentStep != STEP_PRE_IDV) {
    return true;
  }
  const userConfirmedList = localStorage.getItem(BENEFICIARIES_CONFIRMED_LOCAL_STORAGE_KEY(entityId)) === "true";
  const kyc = (_c = (_b = (_a = benificiariesQuery == null ? void 0 : benificiariesQuery.data) == null ? void 0 : _a.me) == null ? void 0 : _b.entity) == null ? void 0 : _c.kyc;
  if (((_d = kyc == null ? void 0 : kyc.beneficiaries) == null ? void 0 : _d.length) === 0) {
    return userConfirmedList;
  }
  const missingDocsCriteria = {
    [EntityOrganizationKind.Company]: [DocumentPurpose.CompaniesMajorShareholderIdVerification, DocumentPurpose.CompaniesMajorShareholderOwnershipVerification],
    [EntityOrganizationKind.Trust]: [DocumentPurpose.CompaniesMajorShareholderOwnershipVerification]
  };
  const requiredDocTypes = missingDocsCriteria[entityKind];
  return !isCurrentDocsMissingPurposes(documents, requiredDocTypes) && userConfirmedList;
};
const isDocumentationComplete = (orgInfoQuery, documents, currentStep) => {
  var _a, _b, _c;
  if (currentStep != STEP_PRE_IDV) {
    return true;
  }
  const orgInfo = (_c = (_b = (_a = orgInfoQuery == null ? void 0 : orgInfoQuery.data) == null ? void 0 : _a.me) == null ? void 0 : _b.entity) == null ? void 0 : _c.kyc;
  const missincDocsCriteria = {
    [EntityOrganizationKind.Company]: [DocumentPurpose.CompaniesProofOfAddress, DocumentPurpose.CompaniesRegistrationVerification],
    [EntityOrganizationKind.Trust]: []
  };
  const docsMissing = isCurrentDocsMissingPurposes(documents, missincDocsCriteria[orgInfo == null ? void 0 : orgInfo.kind]);
  return !!(orgInfo == null ? void 0 : orgInfo.legalName) && !!(orgInfo == null ? void 0 : orgInfo.incorporationInfo) && !docsMissing;
};
const isAccountUsageComplete = (accountUsage, currentStep) => {
  var _a, _b, _c;
  if (currentStep != STEP_PRE_IDV) {
    return true;
  }
  const kyc = (_c = (_b = (_a = accountUsage == null ? void 0 : accountUsage.data) == null ? void 0 : _a.me) == null ? void 0 : _b.entity) == null ? void 0 : _c.kyc;
  const submission = kyc == null ? void 0 : kyc.accountUsageSurvey;
  return !!submission;
};
var ProgressState = /* @__PURE__ */ ((ProgressState2) => {
  ProgressState2["EDITING"] = "edit";
  ProgressState2["INCOMPLETE"] = "incomplete";
  ProgressState2["COMPLETE"] = "complete";
  return ProgressState2;
})(ProgressState || {});
const FormCacheContext = createContext({});
const KycAppOrganization = ({
  entityId,
  navigateToStatusPage
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
  const entityIdVars = {
    variables: {
      entityId
    }
  };
  const orgInfoData = useOrganizationKycInfoQuery(__spreadValues({}, entityIdVars));
  const accountUsageData = useAccountUsageSubmissionQuery(__spreadValues({}, entityIdVars));
  const questionnaires = useOrganizationKycQuestionnairesQuery();
  const documentsData = useEntityKycDocumentsQuery(__spreadValues({}, entityIdVars));
  const authorizedSignatoryData = useAuthorizedSignatoryQuery(__spreadValues({}, entityIdVars));
  const beneficiariesData = useBeneficiariesQuery(__spreadValues({}, entityIdVars));
  const currentStepData = useCurrentOnboardingStepQuery(__spreadValues({}, entityIdVars));
  const currentStep = (_d = (_c = (_b = (_a = currentStepData == null ? void 0 : currentStepData.data) == null ? void 0 : _a.me) == null ? void 0 : _b.entity) == null ? void 0 : _c.kyc) == null ? void 0 : _d.currentStep;
  const isRegisteringForOffering = Boolean((_h = (_g = (_f = (_e = orgInfoData == null ? void 0 : orgInfoData.data) == null ? void 0 : _e.me) == null ? void 0 : _f.entity) == null ? void 0 : _g.latestRegisteredOffering) == null ? void 0 : _h.name);
  const signatory = (_l = (_k = (_j = (_i = authorizedSignatoryData == null ? void 0 : authorizedSignatoryData.data) == null ? void 0 : _i.me) == null ? void 0 : _j.entity) == null ? void 0 : _k.kyc) == null ? void 0 : _l.authorizedSignatory;
  const documents = ((_p = (_o = (_n = (_m = documentsData == null ? void 0 : documentsData.data) == null ? void 0 : _m.me) == null ? void 0 : _n.entity) == null ? void 0 : _o.kyc) == null ? void 0 : _p.documents) || [];
  const entityKind = ((_t = (_s = (_r = (_q = orgInfoData == null ? void 0 : orgInfoData.data) == null ? void 0 : _q.me) == null ? void 0 : _r.entity) == null ? void 0 : _s.kyc) == null ? void 0 : _t.kind) || EntityOrganizationKind.Company;
  const [editStates, setEditStates] = useState({
    documentation: false,
    accountUsage: false,
    authorizedSignatory: false,
    beneficiaries: false
  });
  const completionStates = {
    documentation: isDocumentationComplete(orgInfoData, documents, currentStep),
    accountUsage: isAccountUsageComplete(accountUsageData, currentStep),
    authorizedSignatory: isAuthorizedSignatoryComplete(authorizedSignatoryData, documents, entityKind, currentStep),
    beneficiaries: isBeneficiariesComplete(entityId, beneficiariesData, documents, entityKind, currentStep),
    reviewAndSubmit: currentStep != STEP_PRE_IDV,
    idv: currentStep == STEP_STATUS
  };
  const [formCache, setFormCache] = useState({});
  function getProgressState(section) {
    var _a2;
    const isComplete = completionStates[section];
    const isEditing = (_a2 = editStates[section]) != null ? _a2 : false;
    if (isComplete) {
      return isEditing ? "edit" : "complete";
    } else {
      return "incomplete";
    }
  }
  const tabsCompany = [{
    index: 0,
    id: "documentation",
    title: "🗂️ Documentation",
    progressState: getProgressState("documentation"),
    showOnReviewAndSubmit: true,
    isClickable: currentStep == STEP_PRE_IDV
  }, {
    index: 1,
    id: "account-usage",
    title: "📝 Account Usage",
    progressState: getProgressState("accountUsage"),
    showOnReviewAndSubmit: true,
    isClickable: currentStep == STEP_PRE_IDV
  }, {
    index: 2,
    id: "authorized-signatory",
    title: "👤 Authorized Signatory",
    progressState: getProgressState("authorizedSignatory"),
    showOnReviewAndSubmit: true,
    isClickable: currentStep == STEP_PRE_IDV
  }, {
    index: 3,
    id: "beneficiaries",
    title: "👥 Beneficiaries",
    progressState: getProgressState("beneficiaries"),
    showOnReviewAndSubmit: true,
    isClickable: currentStep == STEP_PRE_IDV
  }, {
    index: 4,
    id: "review-and-submit",
    title: "🔎 Review and Submit",
    progressState: getProgressState("reviewAndSubmit"),
    showOnReviewAndSubmit: false,
    isClickable: currentStep == STEP_PRE_IDV
  }, {
    index: 5,
    id: "idv",
    title: "📸 Photo Verification",
    progressState: getProgressState("idv"),
    showOnReviewAndSubmit: false,
    isClickable: currentStep == STEP_IDV
  }];
  const tabsTrust = [{
    index: 0,
    id: "documentation",
    title: "🗂️ Documentation",
    progressState: getProgressState("documentation"),
    showOnReviewAndSubmit: true,
    isClickable: currentStep == STEP_PRE_IDV
  }, {
    index: 1,
    id: "authorized-signatory",
    title: "👤 Authorized Signatory",
    progressState: getProgressState("authorizedSignatory"),
    showOnReviewAndSubmit: true,
    isClickable: currentStep == STEP_PRE_IDV
  }, {
    index: 2,
    id: "beneficiaries",
    title: "👥 Beneficiaries",
    progressState: getProgressState("beneficiaries"),
    showOnReviewAndSubmit: true,
    isClickable: currentStep == STEP_PRE_IDV
  }, {
    index: 3,
    id: "review-and-submit",
    title: "🔎 Review and Submit",
    progressState: getProgressState("reviewAndSubmit"),
    showOnReviewAndSubmit: false,
    isClickable: currentStep == STEP_PRE_IDV
  }, {
    index: 4,
    id: "idv",
    title: "📸 Photo Verification",
    progressState: getProgressState("idv"),
    showOnReviewAndSubmit: false,
    isClickable: currentStep == STEP_IDV
  }];
  const tabs = entityKind == EntityOrganizationKind.Company ? tabsCompany : tabsTrust;
  const [tabIndex, setTabIndex] = useState(0);
  useEffect(() => {
    setEditStates({
      documentation: false,
      accountUsage: false,
      authorizedSignatory: false,
      beneficiaries: false
    });
  }, [tabIndex]);
  const [shouldResetInitialTab, setShouldResetInitialTab] = useState(true);
  const isMobile = useMediaQuery(useTheme$3().breakpoints.down("md"));
  const isLoading = [questionnaires, orgInfoData, accountUsageData, authorizedSignatoryData, beneficiariesData, currentStepData].some((query) => query == null ? void 0 : query.loading);
  if (isLoading) {
    return /* @__PURE__ */ jsx(PageLoadingSpinner, {});
  }
  const hasError = [questionnaires, orgInfoData, accountUsageData, authorizedSignatoryData, beneficiariesData, currentStepData].some((query) => (query == null ? void 0 : query.error) || !(query == null ? void 0 : query.data));
  if (hasError) {
    return /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: false, message: "There was an error loading your information. Please try again later." });
  }
  if (shouldResetInitialTab) {
    const firstClickableNonCompleted = tabs.find(
      (tab2) => (tab2 == null ? void 0 : tab2.isClickable) && tab2.progressState !== "complete"
      /* COMPLETE */
    );
    setTabIndex((firstClickableNonCompleted == null ? void 0 : firstClickableNonCompleted.index) || 0);
    setShouldResetInitialTab(false);
  }
  const moveToNextTab = (index2) => {
    if (index2 < tabs.length - 1) {
      setTabIndex(index2 + 1);
    }
  };
  const sidebar = /* @__PURE__ */ jsx(SidebarOrganization, { currentTabIndex: tabIndex, setTabIndex, buttonClickHandler: () => moveToNextTab(tabIndex), tabs, sidebarDescription: "We collect this information to keep your account secure and comply with financial regulations" });
  if (currentStep === KycOnboardingStep.Status) {
    navigateToStatusPage();
    return /* @__PURE__ */ jsx(PageLoadingSpinner, {});
  }
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(TabContext, { value: tabs[tabIndex].id, children: [
    isMobile && /* @__PURE__ */ jsx(Box, { sx: {
      m: "30px auto",
      maxWidth: "500px"
    }, children: sidebar }),
    /* @__PURE__ */ jsxs(Box, { sx: {
      width: "100%",
      display: "flex",
      justifyContent: "center"
    }, children: [
      /* @__PURE__ */ jsx(Box, { sx: {
        minWidth: "300px",
        maxWidth: "700px"
      }, children: /* @__PURE__ */ jsxs(FormCacheContext.Provider, { value: {
        formCache,
        setFormCache
      }, children: [
        /* @__PURE__ */ jsxs(TabPanel$1, { value: "documentation", children: [
          entityKind == EntityOrganizationKind.Trust && /* @__PURE__ */ jsx(TrustDocumentationTabPanel, { entityId, progressState: getProgressState("documentation"), setAllowEdits: () => setEditStates(__spreadProps(__spreadValues({}, editStates), {
            documentation: true
          })), trustAgreementDocs: findDocuments(documents, DocumentPurpose.TrustsAgreementVerification), existingData: orgInfoData, moveToNextTab: () => moveToNextTab(tabIndex) }),
          entityKind == EntityOrganizationKind.Company && ((_u = questionnaires == null ? void 0 : questionnaires.data) == null ? void 0 : _u.profileCompany) && /* @__PURE__ */ jsx(CompanyDocumentationTabPanel, { entityId, isRegisteringForOffering, progressState: getProgressState("documentation"), setAllowEdits: () => setEditStates(__spreadProps(__spreadValues({}, editStates), {
            documentation: true
          })), questionnaire: (_v = questionnaires == null ? void 0 : questionnaires.data) == null ? void 0 : _v.profileCompany, proofOfAddressDocs: findDocuments(documents, DocumentPurpose.CompaniesProofOfAddress), evidenceOfRegistrationDocs: findDocuments(documents, DocumentPurpose.CompaniesRegistrationVerification), evidenceOfGoodStandingDocs: findDocuments(documents, DocumentPurpose.CompaniesGoodStandingVerification), existingData: orgInfoData, moveToNextTab: () => moveToNextTab(tabIndex) })
        ] }),
        /* @__PURE__ */ jsx(TabPanel$1, { value: "account-usage", children: ((_w = questionnaires == null ? void 0 : questionnaires.data) == null ? void 0 : _w.accountUsageCompany) && /* @__PURE__ */ jsx(AccountUsageTabPanel, { entityId, progressState: getProgressState("accountUsage"), setAllowEdits: () => setEditStates(__spreadProps(__spreadValues({}, editStates), {
          accountUsage: true
        })), questionnaire: (_x = questionnaires == null ? void 0 : questionnaires.data) == null ? void 0 : _x.accountUsageCompany, existingData: accountUsageData, moveToNextTab: () => moveToNextTab(tabIndex) }) }),
        /* @__PURE__ */ jsx(TabPanel$1, { value: "authorized-signatory", children: /* @__PURE__ */ jsx(AuthorizedSignatoryTabPanel, { entityId, entityKind, progressState: getProgressState("authorizedSignatory"), setAllowEdits: () => setEditStates(__spreadProps(__spreadValues({}, editStates), {
          authorizedSignatory: true
        })), existingData: authorizedSignatoryData, moveToNextTab: () => moveToNextTab(tabIndex), evidenceToActDocs: findDocuments(documents, DocumentPurpose.CompaniesEvidenceToAct), proofOfResidenceDocs: findDocuments(documents, DocumentPurpose.SignatoryProofOfResidence) }) }),
        /* @__PURE__ */ jsx(TabPanel$1, { value: "beneficiaries", children: /* @__PURE__ */ jsx(BeneficiariesTabPanel, { entityId, entityKind, progressState: getProgressState("beneficiaries"), setAllowEdits: () => setEditStates(__spreadProps(__spreadValues({}, editStates), {
          beneficiaries: true
        })), existingData: beneficiariesData, moveToNextTab: () => moveToNextTab(tabIndex), idvDocs: findDocuments(documents, DocumentPurpose.CompaniesMajorShareholderIdVerification), ownershipDocs: findDocuments(documents, DocumentPurpose.CompaniesMajorShareholderOwnershipVerification) }) }),
        /* @__PURE__ */ jsx(TabPanel$1, { value: "review-and-submit", children: /* @__PURE__ */ jsx(ReviewAndSubmitTabPanel, { organizationEntityId: entityId, setTabIndex, currentTabIndex: tabIndex, reviewableTabs: tabs.filter((tab2) => tab2.showOnReviewAndSubmit) || [] }) }),
        /* @__PURE__ */ jsx(TabPanel$1, { value: "idv", children: /* @__PURE__ */ jsx(IdvTabPanel, { idvUrl: (_y = signatory == null ? void 0 : signatory.idv) == null ? void 0 : _y.url }) })
      ] }) }),
      !isMobile && /* @__PURE__ */ jsx(Box, { sx: {
        position: "sticky",
        minWidth: {
          xs: "320px",
          xl: "384px"
        },
        maxWidth: {
          xs: "320px",
          xl: "384px"
        },
        mt: 2,
        mr: 5,
        ml: {
          md: 6,
          lg: 8
        }
      }, children: sidebar })
    ] })
  ] }) });
};
const KycAppOrganization$1 = KycAppOrganization;
const DATA_LOAD_ERROR = i18n._(
  /*i18n*/
  {
    id: "3NWd2t"
  }
);
const KycAppStatus = ({
  entityId,
  navigateToKycHome,
  navigateToKycVerification
}) => {
  const [queryError, setQueryError] = React__default.useState(null);
  if (queryError) {
    return /* @__PURE__ */ jsx(ErrorDialogue, { message: DATA_LOAD_ERROR, isCloseable: false });
  }
  return /* @__PURE__ */ jsx(Box, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center", sx: {
    height: "70%"
  }, my: 4, mx: 3, children: /* @__PURE__ */ jsx(WalletStatus$1, { entityId, navigateToKycHome, navigateToKycVerification, onQueryError: setQueryError }) });
};
const KycAppStatus$1 = KycAppStatus;
const NewEntitySelectorButton = ({
  onClick,
  isSubmitting,
  children,
  variant
}) => {
  return /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Button, { variant: variant || "contained", onClick, disabled: isSubmitting, startIcon: isSubmitting && /* @__PURE__ */ jsx(CircularProgress, { size: 24 }), sx: {
    height: 56,
    width: "100%",
    fontSize: "1em"
  }, children: /* @__PURE__ */ jsx(Box, { sx: {
    display: "flex",
    alignItems: "center"
  }, children }) }) });
};
const URL_PEP = "http://www.fatf-gafi.org/publications/fatfrecommendations/documents/peps-r12-r22.html";
const URL_COINLIST_PREFIX = "https://coinlist.co";
const KycTermsOfAgreement = (props) => {
  const WrappedLink = (props2) => /* @__PURE__ */ jsx(Link, { target: "_blank", href: props2.href, color: "primary", children: props2.children });
  const WrappedListItem = (props2) => /* @__PURE__ */ jsxs(ListItem, { sx: {
    display: "inline-flex",
    alignItems: "flex-start"
  }, children: [
    /* @__PURE__ */ jsx(Check$1, { fontSize: "small", sx: {
      color: "grey",
      marginTop: "2px",
      marginRight: "8px"
    } }),
    /* @__PURE__ */ jsx(Typography, { variant: "body1", fontWeight: "light", children: props2.children })
  ] });
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsxs(Card, { sx: {
      p: 5,
      bgcolor: "whitesmoke"
    }, children: [
      /* @__PURE__ */ jsxs(Typography, { variant: "body1", fontWeight: "bold", mb: "2", sx: {
        display: "flex",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ jsx(Warning, { fontSize: "small", sx: {
          color: "orange",
          mr: 1
        } }),
        /* @__PURE__ */ jsx(Trans, { id: "KLJ99F" })
      ] }),
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsx(Typography, { variant: "body1", fontWeight: "light", mb: "2", children: /* @__PURE__ */ jsx(Trans, { id: "OQgY7S", components: {
        0: /* @__PURE__ */ jsx(WrappedLink, { href: "https://support.coinlist.co/support/tickets/new" }),
        1: /* @__PURE__ */ jsx("br", {}),
        2: /* @__PURE__ */ jsx("br", {})
      } }) }),
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsxs(Typography, { variant: "body1", fontWeight: "bold", mb: "2", sx: {
        whiteSpace: "pre-line",
        display: "flex",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ jsx(Search, { fontSize: "small", sx: {
          color: "blue",
          mr: 1
        } }),
        /* @__PURE__ */ jsx(Trans, { id: "0/8Ahd" })
      ] }),
      /* @__PURE__ */ jsxs(List, { sx: {
        fontSize: "14px",
        fontWeight: "light",
        mb: "2"
      }, children: [
        /* @__PURE__ */ jsx(WrappedListItem, { children: /* @__PURE__ */ jsx(Trans, { id: "Su17Hs", components: {
          0: /* @__PURE__ */ jsx(WrappedLink, { href: `${URL_COINLIST_PREFIX}/terms` }),
          1: /* @__PURE__ */ jsx(WrappedLink, { href: `${URL_COINLIST_PREFIX}/privacy` })
        } }) }),
        /* @__PURE__ */ jsx(WrappedListItem, { children: /* @__PURE__ */ jsx(Trans, { id: "6DJL5w", components: {
          0: /* @__PURE__ */ jsx(WrappedLink, { href: `${URL_COINLIST_PREFIX}/help/what-is-a-foreign-financial-institution` }),
          1: /* @__PURE__ */ jsx(WrappedLink, { href: `${URL_COINLIST_PREFIX}/help/what-is-a-foreign-shell-bank` })
        } }) }),
        /* @__PURE__ */ jsx(WrappedListItem, { children: /* @__PURE__ */ jsx(Trans, { id: "jcBGHt", components: {
          0: /* @__PURE__ */ jsx(WrappedLink, { href: `${URL_COINLIST_PREFIX}/help/what-is-a-private-banking-account` })
        } }) }),
        /* @__PURE__ */ jsx(WrappedListItem, { children: /* @__PURE__ */ jsx(Trans, { id: "Ip9uRS", components: {
          0: /* @__PURE__ */ jsx(WrappedLink, { href: URL_PEP })
        } }) }),
        /* @__PURE__ */ jsx(WrappedListItem, { children: /* @__PURE__ */ jsx(Trans, { id: "AU9CLF" }) })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Box, { sx: {
      marginBottom: 2
    } }),
    /* @__PURE__ */ jsxs(NewEntitySelectorButton, { isSubmitting: props.isSubmitting, onClick: props.onAccept, children: [
      /* @__PURE__ */ jsx(Check$1, {}),
      " ",
      /* @__PURE__ */ jsx(Box, { sx: {
        mx: 1
      } }),
      /* @__PURE__ */ jsx(Trans, { id: "G/R37p" })
    ] }),
    /* @__PURE__ */ jsx(Box, { sx: {
      marginBottom: 2
    } }),
    /* @__PURE__ */ jsxs(NewEntitySelectorButton, { isSubmitting: props.isSubmitting, onClick: props.onDecline, variant: "outlined", children: [
      /* @__PURE__ */ jsx(Close, {}),
      " ",
      /* @__PURE__ */ jsx(Box, { sx: {
        mr: 1
      } }),
      " Decline"
    ] })
  ] });
};
var Check = {};
var _interopRequireDefault = interopRequireDefaultExports;
Object.defineProperty(Check, "__esModule", {
  value: true
});
var default_1 = Check.default = void 0;
var _createSvgIcon = _interopRequireDefault(requireCreateSvgIcon());
var _jsxRuntime = require$$2;
var _default = (0, _createSvgIcon.default)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
default_1 = Check.default = _default;
const NewEntitySelector = (props) => {
  const selectOption = (opts) => /* @__PURE__ */ jsxs(Card, { sx: {
    display: "flex",
    flexDirection: {
      sm: "row"
    },
    height: 90,
    borderRadius: 5,
    backgroundColor: opts.isSelected ? "whitesmoke" : "white",
    cursor: "pointer",
    boxShadow: 1,
    "&:hover": {
      boxShadow: 3
    }
  }, onClick: () => opts.selectFn(), children: [
    opts.icon && /* @__PURE__ */ jsx(CardMedia, { component: "svg", sx: {
      objectFit: "contain",
      maxWidth: 40,
      maxHeight: 40,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: 3,
      marginRight: 2
    }, children: /* @__PURE__ */ jsx(opts.icon, {}) }),
    /* @__PURE__ */ jsx(CardContent, { sx: {
      flex: "1 0 auto",
      display: "flex",
      alignItems: "center"
    }, children: /* @__PURE__ */ jsxs(Grid, { container: true, direction: "column", alignItems: "flex-start", spacing: 1, children: [
      /* @__PURE__ */ jsx(Typography, { variant: "body1", fontWeight: 600, children: opts.option }),
      /* @__PURE__ */ jsx(Typography, { variant: "caption", fontWeight: 300, children: opts.sublabel })
    ] }) }),
    /* @__PURE__ */ jsx(CardContent, { sx: {
      display: "flex",
      alignItems: "center"
    }, children: opts.isSelected && /* @__PURE__ */ jsx(default_1, { color: "primary" }) })
  ] });
  return /* @__PURE__ */ jsxs(Card, { variant: "outlined", sx: {
    borderRadius: 5,
    px: 2,
    py: 2
  }, children: [
    props.title && /* @__PURE__ */ jsx(Box, { sx: {
      display: "flex",
      justifyContent: "center"
    }, children: /* @__PURE__ */ jsx(Typography, { variant: "body1", fontWeight: "bold", sx: {
      pb: 2
    }, children: /* @__PURE__ */ jsx(Trans, { id: "GqXJob" }) }) }),
    /* @__PURE__ */ jsx(Grid, { container: true, direction: "column", spacing: 2, children: props.selectOptions.map((option) => {
      return /* @__PURE__ */ jsx(Grid, { item: true, children: selectOption(option) }, option.option);
    }) })
  ] });
};
const SvgOrganization = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -2.78 46 46" }, props), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M45 40.438H1a1 1 0 0 1 0-2h44a1 1 0 0 1 0 2Zm-30-10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2h1v-13H7a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2h-1v13Zm-3-13h-2v13h2Zm15 13a1 1 0 0 1 0 2h-8a1 1 0 0 1 0-2h1v-13h-1a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2h-1v13Zm-3-13h-2v13h2Zm19 18a1 1 0 0 1-1 1H4a1 1 0 0 1 0-2h38a1 1 0 0 1 1 1Zm-4-5a1 1 0 0 1 0 2h-8a1 1 0 0 1 0-2h1v-13h-1a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2h-1v13Zm-3-13h-2v13h2Zm-34-6L23 0l21 11.438v2H2Zm37.541 0L23 2.886 6.4 11.438Z", "data-name": "04.Bank" }));
const KycSelectorEntityType = ({
  redirectToPersonApplication,
  redirectToOrgCreation
}) => {
  const amplitude = useAmplitude();
  const userQueryResult = useUserNameAndEntityCountQuery();
  const [isPersonSelected, setIsPersonSelected] = useState(true);
  const [createPersonEntity] = useCreatePersonEntityMutation();
  const [showTermsAgreement, setShowTermsAgreement] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = React__default.useState(false);
  const [errorMessage, setErrorMessage] = React__default.useState("");
  const [isSubmitting, setIsSubmitting] = React__default.useState(false);
  if (userQueryResult == null ? void 0 : userQueryResult.loading) {
    return /* @__PURE__ */ jsx(PageLoadingSpinner, {});
  }
  if ((userQueryResult == null ? void 0 : userQueryResult.error) || !(userQueryResult == null ? void 0 : userQueryResult.data)) {
    return /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: false, message: i18n._(
      /*i18n*/
      {
        id: "3NWd2t"
      }
    ) });
  }
  const onSubmit = () => __async(void 0, null, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    setIsSubmitting(true);
    if (!isPersonSelected) {
      return redirectToOrgCreation();
    }
    try {
      const request = {
        firstName: (_b = (_a = userQueryResult == null ? void 0 : userQueryResult.data) == null ? void 0 : _a.me) == null ? void 0 : _b.firstName,
        lastName: (_d = (_c = userQueryResult == null ? void 0 : userQueryResult.data) == null ? void 0 : _c.me) == null ? void 0 : _d.lastName,
        offeringSlug: new URLSearchParams(window.location.search).get("offering") || ""
      };
      const response = yield createPersonEntity({
        variables: request
      });
      if ((_f = (_e = response.data) == null ? void 0 : _e.createPersonEntity) == null ? void 0 : _f.success) {
        const entityId = ((_i = (_h = (_g = response.data) == null ? void 0 : _g.createPersonEntity) == null ? void 0 : _h.result) == null ? void 0 : _i.id) || "";
        if (!entityId) {
          throw new Error("No entity id returned from createOrganizationEntity");
        }
        redirectToPersonApplication(entityId);
      } else {
        throw Error("createPersonEntity failed");
      }
    } catch (e2) {
      setErrorMessage(i18n._(
        /*i18n*/
        {
          id: "ZPVRCH"
        }
      ));
      setErrorDialogOpen(true);
      setIsSubmitting(false);
    }
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: true, openState: errorDialogOpen, setOpenState: setErrorDialogOpen, message: errorMessage }),
    /* @__PURE__ */ jsx(Fade, { in: true, timeout: 500, children: /* @__PURE__ */ jsxs(Container, { maxWidth: "sm", sx: {
      px: 2,
      mt: 4
    }, children: [
      /* @__PURE__ */ jsxs(Collapse, { in: !showTermsAgreement, children: [
        /* @__PURE__ */ jsx(Box, { mb: 4, children: /* @__PURE__ */ jsxs(Typography, { variant: "body1", fontWeight: "light", children: [
          /* @__PURE__ */ jsx(Trans, { id: "0BYiWi" }),
          /* @__PURE__ */ jsx("br", {}),
          " ",
          /* @__PURE__ */ jsx("br", {}),
          /* @__PURE__ */ jsx(Trans, { id: "3HPUiF" })
        ] }) }),
        /* @__PURE__ */ jsx(NewEntitySelector, { title: i18n._(
          /*i18n*/
          {
            id: "GqXJob"
          }
        ), selectOptions: [{
          option: i18n._(
            /*i18n*/
            {
              id: "fByw/g"
            }
          ),
          sublabel: "",
          icon: SvgIndividual,
          isSelected: isPersonSelected,
          selectFn: () => {
            setIsPersonSelected(true);
            amplitude.track("kycb-accounttype-switched");
          }
        }, {
          option: i18n._(
            /*i18n*/
            {
              id: "ucgZ0o"
            }
          ),
          sublabel: i18n._(
            /*i18n*/
            {
              id: "60UM2X"
            }
          ),
          icon: SvgOrganization,
          isSelected: !isPersonSelected,
          selectFn: () => {
            setIsPersonSelected(false);
            amplitude.track("kycb-accounttype-switched");
          }
        }] }),
        /* @__PURE__ */ jsx(Box, { mb: 4 }),
        /* @__PURE__ */ jsxs(NewEntitySelectorButton, { isSubmitting, onClick: () => {
          amplitude.track("kycb-accounttype-continued");
          isPersonSelected ? setShowTermsAgreement(true) : onSubmit();
        }, children: [
          "Continue ",
          /* @__PURE__ */ jsx(ArrowForward, {})
        ] })
      ] }),
      /* @__PURE__ */ jsx(Collapse, { in: isPersonSelected && showTermsAgreement, children: /* @__PURE__ */ jsx(Box, { my: 5, children: /* @__PURE__ */ jsx(KycTermsOfAgreement, { onAccept: () => {
        amplitude.track("kyc-terms-agreed");
        onSubmit();
      }, onDecline: () => setShowTermsAgreement(false), isSubmitting }) }) })
    ] }) })
  ] });
};
const KycSelectorEntityType$1 = KycSelectorEntityType;
const SvgCompany = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50" }, props), /* @__PURE__ */ React.createElement("path", { d: "M8 2v4H4v42h42V14H30V6h-4V2Zm2 2h14v4h4v38h-9v-7h-4v7H6V8h4Zm0 6v2h2v-2Zm4 0v2h2v-2Zm4 0v2h2v-2Zm4 0v2h2v-2Zm-12 5v4h2v-4Zm4 0v4h2v-4Zm4 0v4h2v-4Zm4 0v4h2v-4Zm8 1h14v30H30Zm2 2v2h2v-2Zm4 0v2h2v-2Zm4 0v2h2v-2Zm-30 3v4h2v-4Zm4 0v4h2v-4Zm4 0v4h2v-4Zm4 0v4h2v-4Zm10 1v2h2v-2Zm4 0v2h2v-2Zm4 0v2h2v-2Zm-8 4v2h2v-2Zm4 0v2h2v-2Zm4 0v2h2v-2Zm-30 1v4h2v-4Zm4 0v4h2v-4Zm4 0v4h2v-4Zm4 0v4h2v-4Zm10 3v2h2v-2Zm4 0v2h2v-2Zm4 0v2h2v-2Zm-30 3v4h2v-4Zm4 0v4h2v-4Zm4 0v4h2v-4Zm4 0v4h2v-4Zm10 1v2h2v-2Zm4 0v2h2v-2Zm4 0v2h2v-2Zm-8 4v2h2v-2Zm4 0v2h2v-2Zm4 0v2h2v-2Zm-30 1v5h2v-5Zm12 0v5h2v-5Zm10 3v2h2v-2Zm4 0v2h2v-2Zm4 0v2h2v-2Z" }));
const SvgTrust = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", viewBox: "1 1.19 12 11.61" }, props), /* @__PURE__ */ React.createElement("path", { d: "M10.135 10.265h.351v.373h-.351zm-.659-1.356-.175.305.834.481v.403h.351v-.606zm-3.224 1.356h.351v.373h-.351zm-.659-1.356-.175.305.834.481v.403h.351v-.606zm4.542-5.37h.351v.373h-.351zm-.659-1.355-.175.304.834.482v.402h.351v-.605zM6.252 3.539h.351v.373h-.351zm-.659-1.355-.175.304.834.482v.402h.351v-.605zm6.483 4.718h.352v.373h-.352zm-.658-1.356-.176.305.834.481v.403h.352v-.606zm-.36-.89V2.415L8.942 1.193 7 2.313l-1.941-1.12L2.94 2.415v2.241L1 5.777v2.445l1.941 1.12v2.243l2.118 1.222L7 11.687l1.941 1.12 2.118-1.222V9.343L13 8.222V5.777l-1.941-1.12ZM7.177 2.618l1.765-1.02 1.766 1.02v2.038l-1.766 1.02-1.765-1.02V2.618zm-3.883 0 1.766-1.02 1.765 1.02v2.038L5.06 5.676l-1.766-1.02V2.618zM1.352 8.019V5.98l1.765-1.019 1.766 1.02v2.038l-1.766 1.02-1.765-1.02Zm5.472 3.363-1.765 1.02-1.766-1.02V9.343l1.766-1.019 1.765 1.02v2.038zM5.234 8.02V5.98L7 4.961l1.766 1.02v2.038L7 9.039l-1.766-1.02Zm3.707 4.382-1.765-1.019V9.343L8.94 8.324l1.766 1.02v2.038l-1.766 1.02zm3.707-4.382-1.765 1.02-1.766-1.02V5.98l1.766-1.019 1.765 1.02v2.038zM8.193 6.902h.352v.373h-.352zm-.658-1.356-.176.305.834.481v.403h.352v-.606zM4.31 6.902h.351v.373h-.351zm-.659-1.356-.176.305.835.481v.403h.351v-.606z" }));
const KycSelectorOrganizationType = ({
  redirectToOrgApplication
}) => {
  var _a;
  const amplitude = useAmplitude();
  const [tabSelected, setTab] = useState(
    "Company"
    /* Company */
  );
  const [name, setName] = useState("");
  const [nameErr, setNameErr] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showTermsAgreement, setShowTermsAgreement] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [createOrganizationEntity] = useEntityCreateOrganizationMutation();
  const globalConstants = useConstants();
  const countries2 = ((_a = globalConstants == null ? void 0 : globalConstants.geography) == null ? void 0 : _a.countries) || {};
  const supportedCountryNames = Object.values(countries2).filter((country) => country.is_trust_allowed).map((country) => country.name);
  const onContinue = () => {
    if (name.length === 0) {
      return setNameErr("Please enter a name");
    }
    amplitude.track("kyb-orgtype-continued");
    setNameErr("");
    setShowTermsAgreement(true);
  };
  const onTermsAccept = () => __async(void 0, null, function* () {
    var _a2, _b, _c;
    setIsSubmitting(true);
    try {
      const request = {
        name,
        kind: tabSelected === "Company" ? EntityOrganizationKind.Company : EntityOrganizationKind.Trust,
        offeringSlug: new URLSearchParams(window.location.search).get("offering") || ""
      };
      const response = yield createOrganizationEntity({
        variables: request
      });
      const entityId = ((_c = (_b = (_a2 = response.data) == null ? void 0 : _a2.entityCreateOrganization) == null ? void 0 : _b.result) == null ? void 0 : _c.id) || "";
      if (!entityId) {
        throw new Error("No entity id returned from createOrganizationEntity");
      }
      redirectToOrgApplication(entityId);
    } catch (error) {
      setErrorMessage("An error occurred creating an account application. Please try again later.");
      setErrorDialogOpen(true);
      setIsSubmitting(false);
    }
  });
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsx(ErrorDialogue, { isCloseable: true, openState: errorDialogOpen, setOpenState: setErrorDialogOpen, message: errorMessage }),
    /* @__PURE__ */ jsxs(Container, { maxWidth: "sm", children: [
      /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Typography, { align: "center", sx: {
        my: 4
      }, fontSize: "34px", fontWeight: "bold", children: "Organization Type" }) }),
      /* @__PURE__ */ jsxs(Collapse, { in: !showTermsAgreement, children: [
        /* @__PURE__ */ jsx(NewEntitySelector, { selectOptions: [{
          option: "Company",
          sublabel: "A legal entity, such as a corporation or limited liability company",
          icon: SvgCompany,
          // icon: null,
          isSelected: tabSelected === "Company",
          selectFn: () => {
            setTab(
              "Company"
              /* Company */
            );
            amplitude.track("kyb-orgtype-switched");
          }
        }, {
          option: "Trust",
          sublabel: "A legally binding agreement between a trustor and trustee",
          icon: SvgTrust,
          isSelected: tabSelected === "Trust",
          selectFn: () => {
            setTab(
              "Trust"
              /* Trust */
            );
            amplitude.track("kyb-orgtype-switched");
          }
        }] }),
        /* @__PURE__ */ jsx(Box, { sx: {
          mt: 2
        } }),
        /* @__PURE__ */ jsx(Collapse, { in: tabSelected === "Trust", children: /* @__PURE__ */ jsx(Box, { sx: {
          width: "100%"
        }, children: /* @__PURE__ */ jsx(Alert, { severity: "warning", color: "warning", sx: {
          p: 1,
          borderRadius: "8px",
          alignItems: "center",
          border: "1px solid 100"
        }, children: /* @__PURE__ */ jsxs(Typography, { variant: "body1", fontWeight: "light", mb: "0", children: [
          "At this time, we only support trusts for residents of",
          supportedCountryNames.map((country, index2) => {
            if (index2 === 0) {
              return ` ${country}`;
            } else if (index2 === supportedCountryNames.length - 1) {
              return ` and ${country}.`;
            } else {
              return `, ${country}`;
            }
          })
        ] }) }) }) }),
        /* @__PURE__ */ jsxs(Box, { sx: {
          mt: 2,
          width: "100%"
        }, children: [
          /* @__PURE__ */ jsx(FormLabel, { children: "Full legal name" }),
          /* @__PURE__ */ jsx(TextField, { fullWidth: true, type: "text", placeholder: "Ethereum Foundation", onChange: (e2) => setName(e2.target.value), InputLabelProps: {
            shrink: true
          }, error: !!nameErr }),
          /* @__PURE__ */ jsx(FormHelperText, { error: !!nameErr, children: nameErr })
        ] }),
        /* @__PURE__ */ jsx(Button, { variant: "contained", size: "large", onClick: onContinue, sx: {
          width: "100%",
          mt: 2
        }, endIcon: /* @__PURE__ */ jsx(ArrowForward, { color: "inherit" }), children: "Continue" })
      ] }),
      /* @__PURE__ */ jsx(Collapse, { in: showTermsAgreement, children: /* @__PURE__ */ jsx(KycTermsOfAgreement, { onAccept: () => {
        amplitude.track("kyb-terms-agreed");
        onTermsAccept();
      }, onDecline: () => setShowTermsAgreement(false), isSubmitting }) })
    ] })
  ] });
};
const KycSelectorOrganizationType$1 = KycSelectorOrganizationType;
export {
  AmplitudeProvider,
  ConstantsProvider,
  KycAppIndividual$1 as KycAppIndividual,
  KycAppOrganization$1 as KycAppOrganization,
  KycAppStatus$1 as KycAppStatus,
  KycSelectorEntityType$1 as KycSelectorEntityType,
  KycSelectorOrganizationType$1 as KycSelectorOrganizationType,
  MuiTheme$1 as MuiTheme,
  TranslationProvider$1 as TranslationProvider,
  WalletStatus$1 as WalletStatus
};
//# sourceMappingURL=index.es.js.map
